import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date scalar type */
  Date: { input: any; output: any; }
  /** JSONObject custom scalar type */
  JSONObject: { input: any; output: any; }
};

export type AccessItemInput = {
  launchId?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};

export type AccountItemInput = {
  login: Scalars['String']['input'];
};

export type AchievementEntity = {
  __typename?: 'AchievementEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  levels: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requires: AchievementRequireLevel;
  slug: Scalars['String']['output'];
  statuses: AchievementStatusLevel;
  trophies: AchievementTrophyLevel;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AchievementRequireLevel = {
  __typename?: 'AchievementRequireLevel';
  bronze: Scalars['Int']['output'];
  gold?: Maybe<Scalars['Int']['output']>;
  silver?: Maybe<Scalars['Int']['output']>;
};

export type AchievementStatusLevel = {
  __typename?: 'AchievementStatusLevel';
  bronze: Scalars['String']['output'];
  gold?: Maybe<Scalars['String']['output']>;
  silver?: Maybe<Scalars['String']['output']>;
};

export type AchievementTrophyLevel = {
  __typename?: 'AchievementTrophyLevel';
  bronze: TrophyAchievement;
  gold?: Maybe<TrophyAchievement>;
  silver?: Maybe<TrophyAchievement>;
};

export type AcquiringEntity = {
  __typename?: 'AcquiringEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  provider: PaymentProviderEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export type AcquiringManage = {
  __typename?: 'AcquiringManage';
  active: Scalars['Boolean']['output'];
  config: Scalars['JSONObject']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  provider: PaymentProviderEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserEntity>;
  uuid: Scalars['String']['output'];
};

export type AddOperationWalletInput = {
  amount: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Int']['input'];
};

export type AnalyticsFilterInvoiceInput = {
  finishAt?: InputMaybe<Scalars['Date']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum AppColorScheme {
  BrightLight = 'BrightLight',
  SpaceGray = 'SpaceGray'
}

export type AppRouteLink = {
  __typename?: 'AppRouteLink';
  params: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type AppSchemeData = {
  __typename?: 'AppSchemeData';
  BrightLight?: Maybe<Scalars['JSONObject']['output']>;
  SpaceGray?: Maybe<Scalars['JSONObject']['output']>;
};

export type AppSchemeInput = {
  BrightLight?: InputMaybe<Scalars['JSONObject']['input']>;
  SpaceGray?: InputMaybe<Scalars['JSONObject']['input']>;
};

export enum AppServeDomain {
  Biz = 'Biz',
  Global = 'Global',
  Kz = 'Kz',
  Ru = 'Ru',
  Uz = 'Uz'
}

export type ArticleEntity = {
  __typename?: 'ArticleEntity';
  blocks: Array<ContentElementEntity>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domains: Array<AppServeDomain>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum AuthException {
  Blocked = 'Blocked',
  Forbidden = 'Forbidden',
  InvalidLoginVerificationCode = 'InvalidLoginVerificationCode',
  InvalidNewOtp = 'InvalidNewOtp',
  InvalidOtp = 'InvalidOtp',
  InvalidPassword = 'InvalidPassword',
  LoginVerificationRequired = 'LoginVerificationRequired',
  NotFound = 'NotFound',
  OtpRequired = 'OtpRequired',
  Unauthorized = 'Unauthorized'
}

export type BankInfoCompanyOutput = {
  __typename?: 'BankInfoCompanyOutput';
  address?: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  correspondentAccount?: Maybe<Scalars['String']['output']>;
  inn: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  kpp: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BaseSortInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type CalculateCartTotalInvoice = {
  __typename?: 'CalculateCartTotalInvoice';
  appliedDiscounts: Array<DiscountEntity>;
  discountAmount: Scalars['Float']['output'];
  items: Array<InvoiceTotalCartItem>;
  totalAmount: Scalars['Float']['output'];
  unAppliedDiscounts: Array<UnAppliedDiscountItem>;
};

export type CalculateCartTotalInvoiceInput = {
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<CreateCartProductInput>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CartEntity = {
  __typename?: 'CartEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isShared: Scalars['Boolean']['output'];
  products: Array<CartProduct>;
  promoCodes: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  uuid: Scalars['String']['output'];
};

export type CartProduct = {
  __typename?: 'CartProduct';
  addedAt: Scalars['Date']['output'];
  priceId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
};

export enum ChatActionPermission {
  Admin = 'Admin',
  Member = 'Member'
}

export type ChatEntity = {
  __typename?: 'ChatEntity';
  countMembers: Scalars['Int']['output'];
  countUnread?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  creator: UserEntity;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasUserSideAdmin: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inviteUuid?: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  lastAction?: Maybe<Scalars['Date']['output']>;
  lastMessage?: Maybe<ChatMessageEntity>;
  membersAreVisible: Scalars['Boolean']['output'];
  myMember?: Maybe<ChatMemberEntity>;
  name?: Maybe<Scalars['String']['output']>;
  personalCompanionMember?: Maybe<ChatMemberEntity>;
  /** Fix cache reset for deep personalCompanionUser object on apollo client */
  personalCompanionUserId?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<ProductEntity>;
  productParticipant?: Maybe<ProductParticipantEntity>;
  sendMessagePermission: ChatActionPermission;
  ticket?: Maybe<SupportTicketEntity>;
  type: ChatType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ChatException {
  InvalidChatId = 'InvalidChatId',
  MemberIsBlocked = 'MemberIsBlocked',
  NotAvailableEditMessage = 'NotAvailableEditMessage',
  NotChatMember = 'NotChatMember',
  NotValidPersonalChatCreateInput = 'NotValidPersonalChatCreateInput',
  TooManyMembers = 'TooManyMembers'
}

export type ChatListEvent = {
  __typename?: 'ChatListEvent';
  action: ChatListEventAction;
  chat: ChatEntity;
  messages?: Maybe<Array<ChatMessageEntity>>;
  myMember: ChatMemberEntity;
  updatedMembers?: Maybe<Array<ChatMemberEntity>>;
};

export enum ChatListEventAction {
  ChatUpdate = 'ChatUpdate',
  NewLastAction = 'NewLastAction',
  NewLastMessage = 'NewLastMessage',
  NewMessage = 'NewMessage'
}

export type ChatMemberEntity = {
  __typename?: 'ChatMemberEntity';
  archived: Scalars['Boolean']['output'];
  blocked: Scalars['Boolean']['output'];
  blockedUntil?: Maybe<Scalars['Date']['output']>;
  chat: ChatEntity;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  muted: Scalars['Boolean']['output'];
  personalCompanionUser?: Maybe<UserEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type ChatMessageEntity = {
  __typename?: 'ChatMessageEntity';
  chat: ChatEntity;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  editedAt?: Maybe<Scalars['Date']['output']>;
  forwardUser?: Maybe<UserEntity>;
  id: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isMine: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  medias: Array<ChatMessageMediaEntity>;
  replyMessage?: Maybe<ChatMessageEntity>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  status: ChatMessageStatus;
  text?: Maybe<Scalars['String']['output']>;
  type: ChatMessageType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  userTabUuid?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageEvent = {
  __typename?: 'ChatMessageEvent';
  action: ChatMessageEventAction;
  chat: ChatEntity;
  messages: Array<ChatMessageEntity>;
};

export enum ChatMessageEventAction {
  DeleteMessages = 'DeleteMessages',
  EditMessage = 'EditMessage',
  NewMessage = 'NewMessage',
  ReadMessages = 'ReadMessages'
}

export type ChatMessageMediaEntity = {
  __typename?: 'ChatMessageMediaEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  storage?: Maybe<StorageFileEntity>;
  type: MessageMediaType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widget?: Maybe<ChatMessageWidget>;
};

export enum ChatMessageStatus {
  Scheduled = 'Scheduled',
  Sending = 'Sending',
  Sent = 'Sent'
}

export enum ChatMessageType {
  System = 'System',
  User = 'User'
}

export type ChatMessageWidget = {
  __typename?: 'ChatMessageWidget';
  contentElement?: Maybe<ContentElementEntity>;
  courseLessonPracticeAttempt?: Maybe<CourseLessonPracticeAttemptEntity>;
  data: ChatMessageWidgetData;
  type: MessageMediaWidgetType;
};

export type ChatMessageWidgetData = {
  __typename?: 'ChatMessageWidgetData';
  contentElementUuid?: Maybe<Scalars['String']['output']>;
  courseLessonPracticeAttemptUuid?: Maybe<Scalars['String']['output']>;
};

export enum ChatPermanentConst {
  Saved = 'Saved'
}

export enum ChatType {
  Channel = 'Channel',
  Personal = 'Personal',
  Practice = 'Practice',
  PrivateGroup = 'PrivateGroup',
  ProductAccess = 'ProductAccess',
  ProductReview = 'ProductReview',
  PublicGroup = 'PublicGroup',
  Qa = 'Qa',
  Support = 'Support'
}

export type ChatTypingEvent = {
  __typename?: 'ChatTypingEvent';
  anotherCount: Scalars['Int']['output'];
  chatId: Scalars['Int']['output'];
  profiles: Array<ProfileEntity>;
};

export type CheckAliasCourseOutput = {
  __typename?: 'CheckAliasCourseOutput';
  cause?: Maybe<CourseException>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckDomainSchoolOutput = {
  __typename?: 'CheckDomainSchoolOutput';
  cause?: Maybe<SchoolException>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckDomainUserOutput = {
  __typename?: 'CheckDomainUserOutput';
  cause?: Maybe<UserException>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckLaunchProductInput = {
  saleFinishAt: Scalars['Date']['input'];
  saleStartAt: Scalars['Date']['input'];
};

export enum CheckoutException {
  CheckoutNotCreated = 'CheckoutNotCreated'
}

export type CloneTournamentInput = {
  bet: Scalars['Int']['input'];
  /** In minutes */
  duration?: InputMaybe<Scalars['Int']['input']>;
  liveBroadcastUrl?: InputMaybe<Scalars['String']['input']>;
  membersLimit: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  startMode: TournamentStartMode;
  type: TournamentType;
};

export type ConnectCallbackTelegramInput = {
  auth_date: Scalars['Float']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  id: Scalars['Float']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ContentCategoryEntity = {
  __typename?: 'ContentCategoryEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  space: ContentCategorySpace;
  subjects: Array<SubjectEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visible: Scalars['Boolean']['output'];
};

export enum ContentCategorySpace {
  Course = 'Course',
  Feed = 'Feed',
  Promotion = 'Promotion'
}

export type ContentElementEntity = {
  __typename?: 'ContentElementEntity';
  article?: Maybe<ArticleEntity>;
  content: Scalars['JSONObject']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  finishAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lesson?: Maybe<CourseLessonEntity>;
  myInteraction?: Maybe<ContentElementInteractionEntity>;
  order: Scalars['Int']['output'];
  space: ContentElementSpace;
  startAt?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<TaskEntity>;
  title?: Maybe<Scalars['String']['output']>;
  type: ContentElementType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export type ContentElementInteractionEntity = {
  __typename?: 'ContentElementInteractionEntity';
  contentElement: ContentElementEntity;
  createdAt: Scalars['Date']['output'];
  data: Scalars['JSONObject']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ContentElementSpace {
  Article = 'Article',
  CourseLesson = 'CourseLesson',
  Promotion = 'Promotion',
  Task = 'Task'
}

export enum ContentElementType {
  ActionContextBanner = 'ActionContextBanner',
  AdContextBanner = 'AdContextBanner',
  Audio = 'Audio',
  ChatBotContent = 'ChatBotContent',
  Checklist = 'Checklist',
  EditorJsBlock = 'EditorJsBlock',
  NotionPage = 'NotionPage',
  Survey = 'Survey',
  Text = 'Text',
  Video = 'Video'
}

export type CountAnalyticsItemOutput = {
  __typename?: 'CountAnalyticsItemOutput';
  count: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export type CountAnalyticsOutput = {
  __typename?: 'CountAnalyticsOutput';
  data: Array<CountAnalyticsItemOutput>;
};

export enum CountByTypeMode {
  Catalog = 'Catalog',
  Enrolled = 'Enrolled',
  Managed = 'Managed'
}

export type CourseAuthorEntity = {
  __typename?: 'CourseAuthorEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type CourseCategoryEntity = {
  __typename?: 'CourseCategoryEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  subjectCategory: SubjectCategoryEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseCountByType = {
  __typename?: 'CourseCountByType';
  MasterClass?: Maybe<Scalars['Int']['output']>;
  PersonalLesson?: Maybe<Scalars['Int']['output']>;
  TextCourse?: Maybe<Scalars['Int']['output']>;
  VideoCourse?: Maybe<Scalars['Int']['output']>;
  Webinar?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CourseEntity = {
  __typename?: 'CourseEntity';
  alias?: Maybe<Scalars['String']['output']>;
  authors: Array<CourseAuthorEntity>;
  categories: Array<CourseCategoryEntity>;
  contentCategory?: Maybe<ContentCategoryEntity>;
  countLessons: CourseLessonCount;
  countModules: CourseLessonCount;
  createdAt: Scalars['Date']['output'];
  currentLesson?: Maybe<CourseLessonEntity>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image: CourseImage;
  isParticipant?: Maybe<Scalars['Boolean']['output']>;
  lessons: Array<CourseLessonPreview>;
  minDurationInDays: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  preferenceSettings: CoursePreference;
  product: ProductEntity;
  progressType: CourseProgressType;
  promoVideo?: Maybe<Scalars['String']['output']>;
  seoTags: Array<Scalars['String']['output']>;
  subject: EducationSubject;
  tags: Array<Scalars['String']['output']>;
  type: CourseType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum CourseException {
  AliasAlreadyBusy = 'AliasAlreadyBusy',
  InvalidAlias = 'InvalidAlias',
  LessonPracticeAttemptNotFound = 'LessonPracticeAttemptNotFound',
  NotCourseParticipant = 'NotCourseParticipant',
  NotFound = 'NotFound',
  NotPublished = 'NotPublished',
  StartNextLessonNotAllowed = 'StartNextLessonNotAllowed',
  StartNextLessonNotParticipant = 'StartNextLessonNotParticipant'
}

export type CourseImage = {
  __typename?: 'CourseImage';
  main?: Maybe<Scalars['String']['output']>;
  wrapper?: Maybe<Scalars['String']['output']>;
};

export enum CourseLessonAccessType {
  Demo = 'Demo',
  Participant = 'Participant'
}

export type CourseLessonBlocksInfo = {
  __typename?: 'CourseLessonBlocksInfo';
  hasVideo: Scalars['Boolean']['output'];
  totalVideoDuration?: Maybe<Scalars['Float']['output']>;
};

export type CourseLessonCount = {
  __typename?: 'CourseLessonCount';
  Draft?: Maybe<Scalars['Int']['output']>;
  OnCheck?: Maybe<Scalars['Int']['output']>;
  Published?: Maybe<Scalars['Int']['output']>;
  ReadyToPublish?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CourseLessonEntity = {
  __typename?: 'CourseLessonEntity';
  accessType: CourseLessonAccessType;
  blocks: Array<ContentElementEntity>;
  blocksInfo: CourseLessonBlocksInfo;
  canStartNextLesson: Scalars['Boolean']['output'];
  course: CourseEntity;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDemo: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isPublishedOrScheduled: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  medias: Array<CourseLessonMediaEntity>;
  /** Difference with myProgressStatus - saved in DB */
  myProgress?: Maybe<CourseProgressEntity>;
  /** Difference with myProgress - depends on course and lesson settings */
  myProgressStatus?: Maybe<CourseProgressLessonStatus>;
  name: Scalars['String']['output'];
  next?: Maybe<CourseLessonEntity>;
  order: Scalars['Int']['output'];
  parent?: Maybe<CourseLessonEntity>;
  practice?: Maybe<CourseLessonPracticeEntity>;
  previewImage?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<CourseLessonEntity>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedOrder?: Maybe<CourseLessonOrder>;
  scheduledPublishAt?: Maybe<Scalars['Date']['output']>;
  status: CourseLessonStatus;
  type: CourseLessonType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  viewsCount: Scalars['Int']['output'];
  withContent: Scalars['Boolean']['output'];
  withPractice: Scalars['Boolean']['output'];
  wrapper?: Maybe<StorageSizedImage>;
};

export type CourseLessonFeedback = {
  __typename?: 'CourseLessonFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  isSent: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
};

export type CourseLessonMediaEntity = {
  __typename?: 'CourseLessonMediaEntity';
  allowedToDownload: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  storage: StorageFileEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseLessonMetaEntity = {
  __typename?: 'CourseLessonMetaEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  feedback: CourseLessonFeedback;
  id: Scalars['Int']['output'];
  isLiked: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseLessonOrder = {
  __typename?: 'CourseLessonOrder';
  order: Scalars['Int']['output'];
  parentOrder?: Maybe<Scalars['Int']['output']>;
};

export type CourseLessonPracticeAttemptEntity = {
  __typename?: 'CourseLessonPracticeAttemptEntity';
  answers: Array<TaskAnswerEntity>;
  attemptIndex?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  curator?: Maybe<SellerManagerEntity>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  maxPointsAmount: Scalars['Int']['output'];
  message?: Maybe<ChatMessageEntity>;
  pointsAmount: Scalars['Int']['output'];
  practice: CourseLessonPracticeEntity;
  progress?: Maybe<CourseProgressEntity>;
  sentToReviewAt?: Maybe<Scalars['Date']['output']>;
  solvedCount: Scalars['Int']['output'];
  status: CourseLessonPracticeAttemptStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  uuid: Scalars['String']['output'];
};

export enum CourseLessonPracticeAttemptStatus {
  AutoVerified = 'AutoVerified',
  Created = 'Created',
  OnCorrection = 'OnCorrection',
  OnReview = 'OnReview',
  Verified = 'Verified'
}

export type CourseLessonPracticeEntity = {
  __typename?: 'CourseLessonPracticeEntity';
  activeAttempt?: Maybe<CourseLessonPracticeAttemptEntity>;
  attempts: Array<CourseLessonPracticeAttemptEntity>;
  createdAt: Scalars['Date']['output'];
  deadlineInDays?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastFinishedAttempt?: Maybe<CourseLessonPracticeAttemptEntity>;
  lesson: CourseLessonEntity;
  tasks: Array<CourseLessonPracticeTaskEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseLessonPracticeTaskEntity = {
  __typename?: 'CourseLessonPracticeTaskEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  task: TaskEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CourseLessonPreview = {
  __typename?: 'CourseLessonPreview';
  accessType: CourseLessonAccessType;
  blocks: Array<ContentElementEntity>;
  blocksInfo: CourseLessonBlocksInfo;
  canStartNextLesson: Scalars['Boolean']['output'];
  course: CourseEntity;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDemo: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isPublishedOrScheduled: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  medias: Array<CourseLessonMediaEntity>;
  /** Difference with myProgressStatus - saved in DB */
  myProgress?: Maybe<CourseProgressEntity>;
  myProgressStatus?: Maybe<CourseProgressLessonStatus>;
  name: Scalars['String']['output'];
  next?: Maybe<CourseLessonEntity>;
  order: Scalars['Int']['output'];
  parent?: Maybe<CourseLessonEntity>;
  practice?: Maybe<CourseLessonPracticeEntity>;
  previewImage?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<CourseLessonEntity>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedOrder?: Maybe<CourseLessonOrder>;
  scheduledPublishAt?: Maybe<Scalars['Date']['output']>;
  status: CourseLessonStatus;
  type: CourseLessonType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  viewsCount: Scalars['Int']['output'];
  withContent: Scalars['Boolean']['output'];
  withPractice: Scalars['Boolean']['output'];
  wrapper?: Maybe<StorageSizedImage>;
};

export enum CourseLessonStatus {
  Draft = 'Draft',
  OnCheck = 'OnCheck',
  Published = 'Published',
  ReadyToPublish = 'ReadyToPublish'
}

export enum CourseLessonType {
  Regular = 'Regular',
  Webinar = 'Webinar'
}

export enum CourseParticipationType {
  Active = 'Active',
  All = 'All',
  Completed = 'Completed',
  NotParticipant = 'NotParticipant'
}

export type CoursePreference = {
  __typename?: 'CoursePreference';
  cardColor?: Maybe<AppSchemeData>;
  cardCustomLink?: Maybe<Scalars['String']['output']>;
};

export type CoursePreferenceInput = {
  cardColor?: InputMaybe<AppSchemeInput>;
  cardCustomLink?: InputMaybe<Scalars['String']['input']>;
};

export type CourseProgressEntity = {
  __typename?: 'CourseProgressEntity';
  chat?: Maybe<ChatEntity>;
  course: CourseEntity;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lesson: CourseLessonEntity;
  practiceDeadlineAt?: Maybe<Scalars['Date']['output']>;
  scheduleFinishAt?: Maybe<Scalars['Date']['output']>;
  scheduleStartAt?: Maybe<Scalars['Date']['output']>;
  scheduleStatus?: Maybe<CourseProgressScheduleStatus>;
  status: CourseProgressLessonStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum CourseProgressLessonStatus {
  AvailableAsDemo = 'AvailableAsDemo',
  Completed = 'Completed',
  FeatureAvailable = 'FeatureAvailable',
  FeatureDisabled = 'FeatureDisabled',
  LaunchEducationFinished = 'LaunchEducationFinished',
  LaunchEducationNotStated = 'LaunchEducationNotStated',
  LessonStartScheduled = 'LessonStartScheduled',
  NotInitialized = 'NotInitialized',
  NotParticipant = 'NotParticipant',
  NotStarted = 'NotStarted',
  OnCorrection = 'OnCorrection',
  OnPractice = 'OnPractice',
  OnReview = 'OnReview',
  OnTheory = 'OnTheory'
}

export enum CourseProgressScheduleStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  InProgress = 'InProgress',
  OnTimeChoose = 'OnTimeChoose',
  WaitingStart = 'WaitingStart'
}

export enum CourseProgressType {
  AfterCheck = 'AfterCheck',
  Free = 'Free',
  OnComplete = 'OnComplete'
}

export type CoursePublicationAuthorsCheck = {
  __typename?: 'CoursePublicationAuthorsCheck';
  authors?: Maybe<Array<CoursePublicationCheckItem>>;
  valid: CoursePublicationCheckItem;
};

export type CoursePublicationBrandingCheck = {
  __typename?: 'CoursePublicationBrandingCheck';
  image: CoursePublicationCheckItem;
  valid: Scalars['Boolean']['output'];
};

export type CoursePublicationCheck = {
  __typename?: 'CoursePublicationCheck';
  authors: CoursePublicationAuthorsCheck;
  available: Scalars['Boolean']['output'];
  branding: CoursePublicationBrandingCheck;
  content: CoursePublicationContentCheck;
  date: CoursePublicationDateCheck;
  details: CoursePublicationDetailsCheck;
  faqs: CoursePublicationFaqCheck;
  pricing?: Maybe<CoursePublicationPricingCheck>;
};

export type CoursePublicationCheckItem = {
  __typename?: 'CoursePublicationCheckItem';
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<CoursePublicationCheckItemEntity>;
  entityId?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum CoursePublicationCheckItemEntity {
  Faq = 'Faq',
  Lesson = 'Lesson',
  Price = 'Price',
  User = 'User'
}

export type CoursePublicationContentCheck = {
  __typename?: 'CoursePublicationContentCheck';
  lessons?: Maybe<Array<CoursePublicationCheckItem>>;
  valid: CoursePublicationCheckItem;
};

export type CoursePublicationDateCheck = {
  __typename?: 'CoursePublicationDateCheck';
  educationDates: CoursePublicationCheckItem;
  saleDates: CoursePublicationCheckItem;
  valid: Scalars['Boolean']['output'];
};

export type CoursePublicationDetailsCheck = {
  __typename?: 'CoursePublicationDetailsCheck';
  categories: CoursePublicationCheckItem;
  description: CoursePublicationCheckItem;
  name: CoursePublicationCheckItem;
  tags: CoursePublicationCheckItem;
  valid: Scalars['Boolean']['output'];
};

export type CoursePublicationFaqCheck = {
  __typename?: 'CoursePublicationFaqCheck';
  faqs?: Maybe<Array<CoursePublicationCheckItem>>;
  valid: CoursePublicationCheckItem;
};

export type CoursePublicationPricingCheck = {
  __typename?: 'CoursePublicationPricingCheck';
  prices?: Maybe<Array<CoursePublicationCheckItem>>;
  valid: CoursePublicationCheckItem;
};

export enum CourseType {
  MasterClass = 'MasterClass',
  PersonalLesson = 'PersonalLesson',
  TextCourse = 'TextCourse',
  VideoCourse = 'VideoCourse',
  Webinar = 'Webinar'
}

export type CreateAccessManyProductInput = {
  accesses: Array<AccessItemInput>;
};

export type CreateAcquiringInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['Int']['input'];
};

export type CreateArticleInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBySharedCartInvoiceInput = {
  acquiringId: Scalars['Int']['input'];
  currency: ProductCurrency;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type CreateCartInput = {
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<CreateCartProductInput>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCartProductInput = {
  addedAt: Scalars['Date']['input'];
  priceId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type CreateCategoryContentInput = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  space: ContentCategorySpace;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCategorySubjectInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  subject: EducationSubject;
  visibility?: InputMaybe<SubjectCategoryVisibility>;
};

export type CreateChatInput = {
  adminUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconStorageId?: InputMaybe<Scalars['Int']['input']>;
  memberUserIds: Array<Scalars['Int']['input']>;
  message?: InputMaybe<SendMessageChatInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: ChatType;
};

export type CreateCourseImageInput = {
  main?: InputMaybe<Scalars['String']['input']>;
  wrapper?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCourseInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  authors: Array<Scalars['Int']['input']>;
  contentCategoryId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  image?: InputMaybe<CreateCourseImageInput>;
  name: Scalars['String']['input'];
  preferenceSettings?: InputMaybe<CoursePreferenceInput>;
  product?: InputMaybe<CreateProductInput>;
  progressType?: InputMaybe<CourseProgressType>;
  promoVideo?: InputMaybe<Scalars['String']['input']>;
  seoTags?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<EducationSubject>;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tags: Array<Scalars['String']['input']>;
  type: CourseType;
};

export type CreateDiscountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  code: Scalars['String']['input'];
  currency?: InputMaybe<ProductCurrency>;
  maxApplies?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: DiscountType;
  value: Scalars['Float']['input'];
};

export type CreateElementContentInput = {
  content: Scalars['JSONObject']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateEndpointWebhookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  events: Array<WebhookEvent>;
  note?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateFaqProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answer: Scalars['JSONObject']['input'];
  isOpenedInUi?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
};

export type CreateFeedbackProductInput = {
  rate: Scalars['Float']['input'];
  text: Scalars['String']['input'];
};

export type CreateGroupInput = {
  accessLimitation?: InputMaybe<GroupAccessLimitationInput>;
  communication?: InputMaybe<GroupCommunicationInput>;
  contentLimitation?: InputMaybe<GroupContentLimitationInput>;
  curatorUserId?: InputMaybe<Scalars['Int']['input']>;
  launchId?: InputMaybe<Scalars['Int']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  memberUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  scheduleLimitation?: InputMaybe<GroupScheduleLimitationInput>;
};

export type CreateInvoiceInput = {
  acquiringId: Scalars['Int']['input'];
  currency: ProductCurrency;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<CreateCartProductInput>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateLaunchProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  infinityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLessonCourseInput = {
  accessType?: InputMaybe<CourseLessonAccessType>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentLessonId?: InputMaybe<Scalars['Int']['input']>;
  previewImage?: InputMaybe<Scalars['String']['input']>;
  scheduledPublishAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CourseLessonStatus>;
  storageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<CourseLessonType>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
  withPractice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateLessonFeedbackMetaCourseInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLessonMetaCourseInput = {
  feedback?: InputMaybe<CreateLessonFeedbackMetaCourseInput>;
  isLiked?: InputMaybe<Scalars['Boolean']['input']>;
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLessonPracticeCourseInput = {
  deadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  taskUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  permissions: Array<Permission>;
  userId: Scalars['Float']['input'];
};

export type CreateManyUserInput = {
  accounts: Array<AccountItemInput>;
};

export type CreateManyUserOutput = {
  __typename?: 'CreateManyUserOutput';
  created: Array<UserEntity>;
  exist: Array<UserEntity>;
};

export type CreateOperationPayoutInput = {
  amount: Scalars['Float']['input'];
  requisiteId: Scalars['Int']['input'];
};

export type CreateOrganizationDocumentSellerInput = {
  config?: InputMaybe<OrganizationDocumentConfigSellerInput>;
  location: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: SellerOrganizationDocumentType;
};

export type CreatePriceProductInput = {
  accessDays?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  amount: Scalars['Float']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon: Scalars['String']['input'];
  infinityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  launchPeriodMode?: InputMaybe<ProductPriceLaunchPeriodMode>;
  previousAmount?: InputMaybe<Scalars['Float']['input']>;
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateProductInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<ProductCurrency>;
  domains?: InputMaybe<Array<AppServeDomain>>;
  saleFinishAt?: InputMaybe<Scalars['Date']['input']>;
  saleStartAt?: InputMaybe<Scalars['Date']['input']>;
  type: ProductType;
};

export type CreateProductManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  permissions: Array<Permission>;
  productId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type CreateRefundInvoiceInput = {
  invoiceId: Scalars['Int']['input'];
  invoiceProductIds: Array<Scalars['Int']['input']>;
};

export type CreateRequisitePayoutInput = {
  bankAccountNumber: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  correspondentAccount: Scalars['String']['input'];
};

export type CreateSchoolInput = {
  baseCurrency?: InputMaybe<ProductCurrency>;
  baseDomain: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateStoriesInput = {
  duration: Scalars['Float']['input'];
  previewImage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StoriesStatus>;
  title: Scalars['String']['input'];
  type: StoriesType;
  url: Scalars['String']['input'];
};

export type CreateSubjectInput = {
  contentCategoryId: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTaskInput = {
  answerType: TaskAnswerType;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<TaskComplexity>;
  contentTypes?: InputMaybe<Array<TaskContentType>>;
  maxPoint?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['JSONObject']['input']>;
  subject?: InputMaybe<EducationSubject>;
  subjectCategoryId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<TaskVisibility>;
};

export type CreateTicketSupportInput = {
  message?: InputMaybe<SendMessageChatInput>;
};

export type CreateTournamentInput = {
  bet: Scalars['Int']['input'];
  /** In minutes */
  duration?: InputMaybe<Scalars['Int']['input']>;
  liveBroadcastUrl?: InputMaybe<Scalars['String']['input']>;
  membersLimit: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  startMode: TournamentStartMode;
  subject: EducationSubject;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  taskCount: Scalars['Int']['input'];
  taskUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: TournamentType;
};

export enum CryptoException {
  InvalidLength = 'InvalidLength'
}

export type CursorInput = {
  after?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['Float']['input']>;
};

export type CursorOutput = {
  __typename?: 'CursorOutput';
  after?: Maybe<Scalars['Float']['output']>;
  before?: Maybe<Scalars['Float']['output']>;
  hasNext: Scalars['Boolean']['output'];
  hasPrev: Scalars['Boolean']['output'];
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export enum DbConfigKey {
  AndroidAppVersion = 'AndroidAppVersion',
  AndroidIsOnSale = 'AndroidIsOnSale',
  CommonPlatformConfig = 'CommonPlatformConfig',
  CurrencyExchangeRates = 'CurrencyExchangeRates',
  IosAppVersion = 'IosAppVersion',
  IosIsOnSale = 'IosIsOnSale',
  MarketplaceConfig = 'MarketplaceConfig',
  SchoolDomainBlockList = 'SchoolDomainBlockList',
  SchoolProducts = 'SchoolProducts',
  SellerDefaultPayoutCommission = 'SellerDefaultPayoutCommission',
  SellerPayoutMinAmount = 'SellerPayoutMinAmount',
  SiteCommonHtml = 'SiteCommonHtml',
  UserLoginTgBotToken = 'UserLoginTgBotToken',
  WebAppVersion = 'WebAppVersion'
}

export type DiscountEntity = {
  __typename?: 'DiscountEntity';
  active: Scalars['Boolean']['output'];
  activeFrom?: Maybe<Scalars['Date']['output']>;
  activeTo?: Maybe<Scalars['Date']['output']>;
  code: Scalars['String']['output'];
  countApplies: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  currency?: Maybe<ProductCurrency>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isActiveByCountApplies: Scalars['Boolean']['output'];
  isActiveByDate: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  maxApplies?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  products: Array<ProductEntity>;
  type: DiscountType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value: Scalars['Float']['output'];
};

export enum DiscountException {
  CodeAlreadyExist = 'CodeAlreadyExist',
  NotFoundByCode = 'NotFoundByCode',
  NotSellerOwnerOfProvidedProducts = 'NotSellerOwnerOfProvidedProducts'
}

export enum DiscountType {
  Amount = 'Amount',
  Percent = 'Percent'
}

export enum DiscountUnAppliedReason {
  ApplyLimitExceeded = 'ApplyLimitExceeded',
  NotActive = 'NotActive',
  NotApplicableToProduct = 'NotApplicableToProduct'
}

export type DtoInput = {
  AuthException: AuthException;
  ChatException: ChatException;
  ChatPermanentConst: ChatPermanentConst;
  CheckoutException: CheckoutException;
  CryptoException: CryptoException;
  DiscountException: DiscountException;
  InvoiceException: InvoiceException;
  MailException: MailException;
  NotificationException: NotificationException;
  PaymentException: PaymentException;
  PayoutException: PayoutException;
  ProductException: ProductException;
  ProfileException: ProfileException;
  PromotionException: PromotionException;
  RateException: RateException;
  SmsException: SmsException;
  TournamentException: TournamentException;
  UserException: UserException;
  UserLang: Language;
  VkAuthMode: VkAuthMode;
  WalletException: WalletException;
  WebhookException: WebhookException;
};

export type DynamicTemplateMailInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Language>;
  subject: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  to: Scalars['String']['input'];
  toMany: Array<Scalars['String']['input']>;
};

export type EditMessageChatInput = {
  medias?: InputMaybe<Array<SendMessageMediaChatInput>>;
  replyMessageId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTabUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum EducationSubject {
  BusinessBrand = 'BusinessBrand',
  BusinessEntrepreneur = 'BusinessEntrepreneur',
  BusinessLegal = 'BusinessLegal',
  BusinessManagement = 'BusinessManagement',
  BusinessMedia = 'BusinessMedia',
  BusinessOther = 'BusinessOther',
  BusinessSales = 'BusinessSales',
  Design3DAnimation = 'Design3DAnimation',
  DesignGraphic = 'DesignGraphic',
  DesignOther = 'DesignOther',
  DesignUx = 'DesignUx',
  DesignWeb = 'DesignWeb',
  DevelopmentApp = 'DevelopmentApp',
  DevelopmentArchitecture = 'DevelopmentArchitecture',
  DevelopmentDb = 'DevelopmentDb',
  DevelopmentOther = 'DevelopmentOther',
  DevelopmentTheory = 'DevelopmentTheory',
  DevelopmentWeb = 'DevelopmentWeb',
  EgeBiology = 'EgeBiology',
  EgeChemistry = 'EgeChemistry',
  EgeEnglish = 'EgeEnglish',
  EgeFrench = 'EgeFrench',
  EgeGeography = 'EgeGeography',
  EgeGerman = 'EgeGerman',
  EgeHistory = 'EgeHistory',
  EgeInformatics = 'EgeInformatics',
  EgeLiterature = 'EgeLiterature',
  EgeMath = 'EgeMath',
  EgeMathBasic = 'EgeMathBasic',
  EgeOther = 'EgeOther',
  EgePhysics = 'EgePhysics',
  EgeRussian = 'EgeRussian',
  EgeSocial = 'EgeSocial',
  EgeSpanish = 'EgeSpanish',
  FinanceAccounting = 'FinanceAccounting',
  FinanceCrypto = 'FinanceCrypto',
  FinanceOther = 'FinanceOther',
  FinanceStocks = 'FinanceStocks',
  HealthBeauty = 'HealthBeauty',
  HealthHealthyEating = 'HealthHealthyEating',
  HealthOther = 'HealthOther',
  LanguageChinese = 'LanguageChinese',
  LanguageEnglish = 'LanguageEnglish',
  LanguageFrench = 'LanguageFrench',
  LanguageGerman = 'LanguageGerman',
  LanguageJapanese = 'LanguageJapanese',
  LanguageOther = 'LanguageOther',
  LanguageSpanish = 'LanguageSpanish',
  LanguageTurkish = 'LanguageTurkish',
  MarketingContent = 'MarketingContent',
  MarketingInternet = 'MarketingInternet',
  MarketingOther = 'MarketingOther',
  MarketingSeo = 'MarketingSeo',
  MarketingSmm = 'MarketingSmm',
  MarketingTrade = 'MarketingTrade',
  MusicBasics = 'MusicBasics',
  MusicInstruments = 'MusicInstruments',
  MusicOther = 'MusicOther',
  MusicProduction = 'MusicProduction',
  MusicSkillUp = 'MusicSkillUp',
  MusicSoftware = 'MusicSoftware',
  MusicVocals = 'MusicVocals',
  OgeBiology = 'OgeBiology',
  OgeChemistry = 'OgeChemistry',
  OgeGeography = 'OgeGeography',
  OgeHistory = 'OgeHistory',
  OgeInformatics = 'OgeInformatics',
  OgeLiterature = 'OgeLiterature',
  OgeMath = 'OgeMath',
  OgeOther = 'OgeOther',
  OgePhysics = 'OgePhysics',
  OgeRussian = 'OgeRussian',
  OgeSocial = 'OgeSocial',
  OtherOther = 'OtherOther',
  PersonalBrand = 'PersonalBrand',
  PersonalCareer = 'PersonalCareer',
  PersonalLeadership = 'PersonalLeadership',
  PersonalMotivation = 'PersonalMotivation',
  PersonalOther = 'PersonalOther',
  PersonalRelationships = 'PersonalRelationships',
  Photo = 'Photo',
  PhotoBasics = 'PhotoBasics',
  PhotoColorCorrection = 'PhotoColorCorrection',
  PhotoDigital = 'PhotoDigital',
  PhotoOther = 'PhotoOther',
  PhotoPortrait = 'PhotoPortrait',
  PreschoolMentalArithmetic = 'PreschoolMentalArithmetic',
  PreschoolOther = 'PreschoolOther',
  PreschoolPreparation = 'PreschoolPreparation',
  PreschoolSpeedReading = 'PreschoolSpeedReading',
  SportBodyBuilding = 'SportBodyBuilding',
  SportFitness = 'SportFitness',
  SportOther = 'SportOther',
  SportWeightLoss = 'SportWeightLoss',
  VideoBasics = 'VideoBasics',
  VideoEditing = 'VideoEditing',
  VideoOther = 'VideoOther'
}

export type EgeSubjectExamWaves = {
  __typename?: 'EgeSubjectExamWaves';
  early: Array<Scalars['String']['output']>;
  main: Array<Scalars['String']['output']>;
  reserve?: Maybe<Array<Scalars['String']['output']>>;
};

export type EgeSubjectInfo = {
  __typename?: 'EgeSubjectInfo';
  dates?: Maybe<EgeSubjectExamWaves>;
  duration?: Maybe<Scalars['Int']['output']>;
  egeFirstPartTaskCount?: Maybe<Scalars['Int']['output']>;
  egeSecondPartTaskCount?: Maybe<Scalars['Int']['output']>;
  passingScore?: Maybe<Scalars['Int']['output']>;
  universityPassingScore?: Maybe<Scalars['Int']['output']>;
};

export type ExchangeRateOutput = {
  __typename?: 'ExchangeRateOutput';
  Eur: Scalars['Float']['output'];
  Kzt: Scalars['Float']['output'];
  Rub: Scalars['Float']['output'];
  Usd: Scalars['Float']['output'];
  Uzs: Scalars['Float']['output'];
};

export type FilterAccessProductInput = {
  accessIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  launchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  product?: InputMaybe<FilterProductInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterAchievementInput = {
  trophyTypes?: InputMaybe<Array<TrophyAchievementType>>;
};

export type FilterAcquiringInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  productPriceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  provider?: InputMaybe<FilterProviderPaymentInput>;
};

export type FilterArticleInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilterBalanceOperationSellerInput = {
  createdAtDateRange?: InputMaybe<DateRangeInput>;
  payoutOperation?: InputMaybe<FilterOperationPayoutInput>;
  statuses?: InputMaybe<Array<SellerBalanceStatus>>;
  types?: InputMaybe<Array<SellerBalanceType>>;
};

export type FilterCategoryContentInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  spaces?: InputMaybe<Array<ContentCategorySpace>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCategorySelectionSubjectInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  subjects?: InputMaybe<Array<EducationSubject>>;
};

export type FilterCategorySubjectInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  minTaskCount?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Array<EducationSubject>>;
  task?: InputMaybe<FilterTaskInput>;
};

export type FilterChatInput = {
  chatIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ChatType>>;
};

export type FilterCourseInput = {
  administrate?: InputMaybe<Scalars['Boolean']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  contentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  manage?: InputMaybe<Scalars['Boolean']['input']>;
  participation?: InputMaybe<CourseParticipationType>;
  product?: InputMaybe<FilterProductInput>;
  progressTypes?: InputMaybe<Array<CourseProgressType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjects?: InputMaybe<Array<EducationSubject>>;
  types?: InputMaybe<Array<CourseType>>;
};

export type FilterDiscountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  applyLimitExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterEndpointWebhookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Array<WebhookEvent>>;
};

export type FilterFaqProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterFaqSupportInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<SupportFaqSectionType>;
};

export type FilterFeedbackProductInput = {
  feedbackIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<ProductFeedbackStatus>>;
};

export type FilterFriendshipInput = {
  hasPersonalChat?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FriendshipStatus>;
};

export type FilterGroupInput = {
  courseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  launchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilterInvoiceInput = {
  invoiceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterLaunchProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ProductLaunchStatus>>;
};

export type FilterLessonCourseInput = {
  courseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<CourseLessonStatus>>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
  withPractice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterLessonPracticeAttemptCourseInput = {
  courseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  curatorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  launchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lessonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  practiceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CourseLessonPracticeAttemptStatus>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Combined by seller and product manager permissions */
  combinedPermissions?: InputMaybe<Array<Permission>>;
  permissions?: InputMaybe<Array<Permission>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<SellerManagerType>>;
};

export type FilterMemberChatInput = {
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterMemberGroupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterMemberSubjectInput = {
  subjects: Array<EducationSubject>;
};

export type FilterMemberTournamentInput = {
  isPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  tournamentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterMessageChatInput = {
  messageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<ChatMessageStatus>>;
  storageFileTypes?: InputMaybe<Array<StorageFileType>>;
};

export type FilterNotificationInput = {
  statuses?: InputMaybe<Array<NotificationStatus>>;
  types?: InputMaybe<Array<NotificationType>>;
};

export type FilterOperationPayoutInput = {
  payoutOperationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<PayoutOperationStatus>>;
  tinkoffPaymentRegistry?: InputMaybe<FilterPaymentRegistryTinkoffInput>;
};

export type FilterOrganizationDocumentSellerInput = {
  types?: InputMaybe<Array<SellerOrganizationDocumentType>>;
};

export type FilterPageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterPaymentInput = {
  acquiringIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<PaymentStatus>>;
};

export type FilterPaymentRegistryTinkoffInput = {
  correlationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<TinkoffPaymentRegistryStatus>>;
  types?: InputMaybe<Array<TinkoffPaymentRegistryType>>;
};

export type FilterPriceProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeDateRange?: InputMaybe<DateRangeInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  launchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  types?: InputMaybe<Array<ProductPriceType>>;
};

export type FilterProductInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  currencies?: InputMaybe<Array<ProductCurrency>>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  launch?: InputMaybe<FilterLaunchProductInput>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sellerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  showInCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<ProductStatus>>;
};

export type FilterProductManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterProfileInput = {
  hasAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<FilterUserInput>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterProgressCourseInput = {
  hasPracticeDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<FilterLessonCourseInput>;
  lessonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<CourseProgressLessonStatus>>;
};

export type FilterProviderPaymentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currencies?: InputMaybe<Array<ProductCurrency>>;
  domains?: InputMaybe<Array<AppServeDomain>>;
  types?: InputMaybe<Array<PaymentProviderType>>;
};

export type FilterRequestSellerInput = {
  statuses?: InputMaybe<Array<SellerBecomeRequestStatus>>;
};

export type FilterRequisitePayoutInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterSellerInput = {
  balance?: InputMaybe<NumberRangeInput>;
  payoutBalance?: InputMaybe<NumberRangeInput>;
  requisite?: InputMaybe<FilterRequisitePayoutInput>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterSessionInput = {
  alive?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAtDateRange?: InputMaybe<DateRangeInput>;
  launchers?: InputMaybe<Array<SessionLauncher>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterStoriesInput = {
  manage?: InputMaybe<Scalars['Boolean']['input']>;
  sellerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<StoriesStatus>>;
  subjects?: InputMaybe<Array<EducationSubject>>;
};

export type FilterSubjectInput = {
  contentCategory?: InputMaybe<FilterCategoryContentInput>;
  contentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilterTaskInput = {
  administrate?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypes?: InputMaybe<Array<TaskAnswerType>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  complexities?: InputMaybe<Array<TaskComplexity>>;
  contentTypes?: InputMaybe<Array<TaskContentType>>;
  manage?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjects?: InputMaybe<Array<EducationSubject>>;
  taskUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  visibilities?: InputMaybe<Array<TaskVisibility>>;
};

export type FilterTournamentInput = {
  bet?: InputMaybe<Scalars['Float']['input']>;
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  creatorUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  memberUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  onlyMySelectedSubjects?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  startModes?: InputMaybe<Array<TournamentStartMode>>;
  states?: InputMaybe<Array<TournamentState>>;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjects?: InputMaybe<Array<EducationSubject>>;
  types?: InputMaybe<Array<TournamentType>>;
};

export type FilterUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  profile?: InputMaybe<FilterProfileInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterWalletInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountType?: InputMaybe<WalletAmountType>;
  identifier?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<WalletOperationType>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ForwardMessageChatInput = {
  forwardMessageIds: Array<Scalars['Int']['input']>;
  medias?: InputMaybe<Array<SendMessageMediaChatInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTabUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FriendshipEntity = {
  __typename?: 'FriendshipEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  from: UserEntity;
  id: Scalars['Int']['output'];
  status: FriendshipStatus;
  to: UserEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum FriendshipStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  Rejected = 'Rejected',
  Requested = 'Requested'
}

export type GetSelfUserOutput = {
  __typename?: 'GetSelfUserOutput';
  profile: ProfileEntity;
  user: UserEntity;
};

export type GroupAccessLimitation = {
  __typename?: 'GroupAccessLimitation';
  active: Scalars['Boolean']['output'];
  commonDateStartAt?: Maybe<Scalars['Date']['output']>;
  durationInMinutes?: Maybe<Scalars['Float']['output']>;
  startPointType?: Maybe<GroupAccessStartPointType>;
};

export type GroupAccessLimitationInput = {
  active: Scalars['Boolean']['input'];
  commonDateStartAt?: InputMaybe<Scalars['Date']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  startPointType?: InputMaybe<GroupAccessStartPointType>;
};

export enum GroupAccessStartPointType {
  CommonDate = 'CommonDate',
  Participant = 'Participant'
}

export type GroupCommunication = {
  __typename?: 'GroupCommunication';
  channelIsActive: Scalars['Boolean']['output'];
  dialogueWithEmployeesBlocked: Scalars['Boolean']['output'];
  groupChatIsActive: Scalars['Boolean']['output'];
};

export type GroupCommunicationInput = {
  channelIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  dialogueWithEmployeesBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  groupChatIsActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupContentLimitation = {
  __typename?: 'GroupContentLimitation';
  disableSendHomework: Scalars['Boolean']['output'];
  hideEarlyAccessLessons: Scalars['Boolean']['output'];
  lessons?: Maybe<Scalars['JSONObject']['output']>;
};

export type GroupContentLimitationInput = {
  disableSendHomework?: InputMaybe<Scalars['Boolean']['input']>;
  hideEarlyAccessLessons?: InputMaybe<Scalars['Boolean']['input']>;
  lessons?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type GroupContentLimitationLessonItemInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

export type GroupEntity = {
  __typename?: 'GroupEntity';
  accessLimitation: GroupAccessLimitation;
  channel?: Maybe<ChatEntity>;
  communication: GroupCommunication;
  contentLimitation: GroupContentLimitation;
  countMembers: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  curator?: Maybe<SellerManagerEntity>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  groupChat?: Maybe<ChatEntity>;
  id: Scalars['Int']['output'];
  launch?: Maybe<ProductLaunchEntity>;
  maxMembers?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  product?: Maybe<ProductEntity>;
  scheduleLimitation: GroupScheduleLimitation;
  space: GroupSpace;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export type GroupMemberEntity = {
  __typename?: 'GroupMemberEntity';
  active: Scalars['Boolean']['output'];
  blockedUntil?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  group: GroupEntity;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type GroupScheduleLimitation = {
  __typename?: 'GroupScheduleLimitation';
  active: Scalars['Boolean']['output'];
  byWeekdays?: Maybe<GroupScheduleLimitationWeekdays>;
  onceForInterval?: Maybe<GroupScheduleLimitationInterval>;
  openUnit?: Maybe<GroupScheduleOpenUnit>;
  type?: Maybe<GroupScheduleType>;
};

export type GroupScheduleLimitationInput = {
  active: Scalars['Boolean']['input'];
  byWeekdays?: InputMaybe<GroupScheduleLimitationWeekdaysInput>;
  onceForInterval?: InputMaybe<GroupScheduleLimitationIntervalInput>;
  openUnit: GroupScheduleOpenUnit;
  type: GroupScheduleType;
};

export type GroupScheduleLimitationInterval = {
  __typename?: 'GroupScheduleLimitationInterval';
  durationInMinutes: Scalars['Float']['output'];
  startFrom: Scalars['Date']['output'];
};

export type GroupScheduleLimitationIntervalInput = {
  durationInMinutes: Scalars['Float']['input'];
  startFrom: Scalars['Date']['input'];
};

export type GroupScheduleLimitationWeekdays = {
  __typename?: 'GroupScheduleLimitationWeekdays';
  selected: Array<Scalars['Int']['output']>;
  startFrom: Scalars['Date']['output'];
};

export type GroupScheduleLimitationWeekdaysInput = {
  selected: Array<Scalars['Int']['input']>;
  startFrom: Scalars['Date']['input'];
};

export enum GroupScheduleOpenUnit {
  Lesson = 'Lesson',
  Module = 'Module'
}

export enum GroupScheduleType {
  ByWeekdays = 'ByWeekdays',
  OnceForInterval = 'OnceForInterval'
}

export enum GroupSpace {
  Education = 'Education'
}

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  actualPayment?: Maybe<PaymentEntity>;
  createdAt: Scalars['Date']['output'];
  currency: ProductCurrency;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  discountAmount: Scalars['Float']['output'];
  expireAt?: Maybe<Scalars['Date']['output']>;
  humanId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isFullyRefunded: Scalars['Boolean']['output'];
  payments: Array<PaymentEntity>;
  products?: Maybe<Array<InvoiceProductEntity>>;
  refunds: Array<InvoiceRefundEntity>;
  totalAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  uuid: Scalars['String']['output'];
};

export enum InvoiceException {
  ExistNotCompletedRefunds = 'ExistNotCompletedRefunds',
  InvoiceFullyRefunded = 'InvoiceFullyRefunded',
  NotFoundById = 'NotFoundById',
  NotFoundByUuid = 'NotFoundByUuid',
  PaymentNotCompleted = 'PaymentNotCompleted',
  RefundCheckoutError = 'RefundCheckoutError',
  RefundInNotEditableStatus = 'RefundInNotEditableStatus',
  RefundProductsNotMatchInvoice = 'RefundProductsNotMatchInvoice'
}

export type InvoiceProductEntity = {
  __typename?: 'InvoiceProductEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  discountAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  invoice: InvoiceEntity;
  originalPrice: Scalars['Float']['output'];
  price: ProductPriceEntity;
  product: ProductEntity;
  totalPrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type InvoiceProductPayoutEntity = {
  __typename?: 'InvoiceProductPayoutEntity';
  commission?: Maybe<PayoutCommissionEntity>;
  commissionAmount: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoiceProduct?: Maybe<InvoiceProductEntity>;
  operations: Array<SellerBalanceOperationEntity>;
  payoutScheduledAt?: Maybe<Scalars['Date']['output']>;
  profitAmount: Scalars['Float']['output'];
  status: InvoiceProductPayoutStatus;
  transactionAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum InvoiceProductPayoutStatus {
  Created = 'Created',
  Refunded = 'Refunded',
  Released = 'Released',
  Waiting = 'Waiting'
}

export type InvoiceRefundEntity = {
  __typename?: 'InvoiceRefundEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoice: InvoiceEntity;
  products: Array<InvoiceRefundProductEntity>;
  refundedAt?: Maybe<Scalars['Date']['output']>;
  status: InvoiceRefundStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export type InvoiceRefundProductEntity = {
  __typename?: 'InvoiceRefundProductEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum InvoiceRefundStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Created = 'Created'
}

export type InvoiceTotalCartItem = {
  __typename?: 'InvoiceTotalCartItem';
  appliedDiscount?: Maybe<DiscountEntity>;
  discountAmount: Scalars['Float']['output'];
  originalPrice: Scalars['Float']['output'];
  price: ProductPriceEntity;
  product: ProductEntity;
  totalPrice: Scalars['Float']['output'];
  unAppliedDiscounts: Array<UnAppliedDiscountItem>;
};

export type JsonObjectInput = {
  meta?: InputMaybe<Scalars['JSONObject']['input']>;
  value: Scalars['JSONObject']['input'];
};

export enum Language {
  Ru = 'Ru',
  Uz = 'Uz'
}

export type ListAccessProductOutput = {
  __typename?: 'ListAccessProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductAccessEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListAchievementOutput = {
  __typename?: 'ListAchievementOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<AchievementEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListAcquiringManageOutput = {
  __typename?: 'ListAcquiringManageOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<AcquiringManage>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListAcquiringOutput = {
  __typename?: 'ListAcquiringOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<AcquiringEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListArticleOutput = {
  __typename?: 'ListArticleOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ArticleEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListBalanceOperationSellerOutput = {
  __typename?: 'ListBalanceOperationSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerBalanceOperationEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListCategoryContentOutput = {
  __typename?: 'ListCategoryContentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ContentCategoryEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListCategorySelectionSubjectOutput = {
  __typename?: 'ListCategorySelectionSubjectOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SubjectCategorySelectionEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListCategorySubjectOutput = {
  __typename?: 'ListCategorySubjectOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SubjectCategoryEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListChatOutput = {
  __typename?: 'ListChatOutput';
  count: Scalars['Int']['output'];
  cursor: CursorOutput;
  items?: Maybe<Array<ChatEntity>>;
};

export type ListCourseOutput = {
  __typename?: 'ListCourseOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<CourseEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListDirectionInfo = {
  __typename?: 'ListDirectionInfo';
  page: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
};

export type ListDiscountOutput = {
  __typename?: 'ListDiscountOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<DiscountEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListEndpointWebhookOutput = {
  __typename?: 'ListEndpointWebhookOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<WebhookEndpointEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListFaqProductOutput = {
  __typename?: 'ListFaqProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductFaqEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListFaqSupportOutput = {
  __typename?: 'ListFaqSupportOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SupportFaqEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListFeedbackProductOutput = {
  __typename?: 'ListFeedbackProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductFeedbackEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListGroupOutput = {
  __typename?: 'ListGroupOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<GroupEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ListInvitationTournamentOutput = {
  __typename?: 'ListInvitationTournamentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TournamentInvitationEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListInvoiceOutput = {
  __typename?: 'ListInvoiceOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<InvoiceEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListLaunchProductOutput = {
  __typename?: 'ListLaunchProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductLaunchEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListLessonCourseOutput = {
  __typename?: 'ListLessonCourseOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<CourseLessonEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListLessonPracticeAttemptCourseOutput = {
  __typename?: 'ListLessonPracticeAttemptCourseOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<CourseLessonPracticeAttemptEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListManagerSellerOutput = {
  __typename?: 'ListManagerSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerManagerEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListMemberChatOutput = {
  __typename?: 'ListMemberChatOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ChatMemberEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListMemberGroupOutput = {
  __typename?: 'ListMemberGroupOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<GroupMemberEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListMemberSubjectOutput = {
  __typename?: 'ListMemberSubjectOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<UserEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListMemberTournamentOutput = {
  __typename?: 'ListMemberTournamentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TournamentMemberEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListMessageChatOutput = {
  __typename?: 'ListMessageChatOutput';
  count: Scalars['Int']['output'];
  cursor: CursorOutput;
  items?: Maybe<Array<ChatMessageEntity>>;
};

export type ListMessageTournamentOutput = {
  __typename?: 'ListMessageTournamentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TournamentMessageEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListNotificationOutput = {
  __typename?: 'ListNotificationOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<NotificationEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListOperationPayoutOutput = {
  __typename?: 'ListOperationPayoutOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<PayoutOperationEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListOrganizationDocumentsSellerOutput = {
  __typename?: 'ListOrganizationDocumentsSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerOrganizationDocumentEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListPageOutput = {
  __typename?: 'ListPageOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<PageEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListPaymentOutput = {
  __typename?: 'ListPaymentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<PaymentEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListPriceProductOutput = {
  __typename?: 'ListPriceProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductPriceEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListProductManagerSellerOutput = {
  __typename?: 'ListProductManagerSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerProductManagerEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListProductOutput = {
  __typename?: 'ListProductOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProductEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListProfileOutput = {
  __typename?: 'ListProfileOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<ProfileEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListProgressCourseOutput = {
  __typename?: 'ListProgressCourseOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<CourseProgressEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListProviderPaymentOutput = {
  __typename?: 'ListProviderPaymentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<PaymentProviderEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListRequestSellerOutput = {
  __typename?: 'ListRequestSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerBecomeRequestEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListResultTournamentOutput = {
  __typename?: 'ListResultTournamentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TournamentResultEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListSellerOutput = {
  __typename?: 'ListSellerOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SellerEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListSessionOutput = {
  __typename?: 'ListSessionOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SessionEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListStoriesOutput = {
  __typename?: 'ListStoriesOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<StoriesEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListSubjectOutput = {
  __typename?: 'ListSubjectOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<SubjectEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListTaskOutput = {
  __typename?: 'ListTaskOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TaskEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListTournamentOutput = {
  __typename?: 'ListTournamentOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<TournamentEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListUserFriendshipOutput = {
  __typename?: 'ListUserFriendshipOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<UserEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListUserOutput = {
  __typename?: 'ListUserOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<UserEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type ListWalletOperationOutput = {
  __typename?: 'ListWalletOperationOutput';
  count: Scalars['Int']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  items: Array<WalletOperationEntity>;
  next: ListDirectionInfo;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  prev: ListDirectionInfo;
};

export type LoginAuthOutput = {
  __typename?: 'LoginAuthOutput';
  session: SessionEntity;
  user: UserEntity;
};

export type LogoutAuthOutput = {
  __typename?: 'LogoutAuthOutput';
  logout: Scalars['Boolean']['output'];
};

export enum MailException {
  NotFound = 'NotFound'
}

export type MailRead = {
  __typename?: 'MailRead';
  ip: Scalars['String']['output'];
  timestamp: Scalars['Date']['output'];
};

export type MailTemplateMeta = {
  __typename?: 'MailTemplateMeta';
  subject?: Maybe<Scalars['String']['output']>;
};

export type MakeTransferWalletInput = {
  amount: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Int']['input'];
};

export type MergerDbConfigOutput = {
  __typename?: 'MergerDbConfigOutput';
  AndroidAppVersion?: Maybe<Scalars['String']['output']>;
  AndroidIsOnSale?: Maybe<Scalars['Boolean']['output']>;
  CommonPlatformConfig?: Maybe<Scalars['JSONObject']['output']>;
  CurrencyExchangeRates?: Maybe<Scalars['JSONObject']['output']>;
  IosAppVersion?: Maybe<Scalars['String']['output']>;
  IosIsOnSale?: Maybe<Scalars['Boolean']['output']>;
  MarketplaceConfig?: Maybe<Scalars['JSONObject']['output']>;
  SchoolDomainBlockList?: Maybe<Scalars['JSONObject']['output']>;
  SchoolProducts?: Maybe<Scalars['JSONObject']['output']>;
  SellerDefaultPayoutCommission?: Maybe<Scalars['JSONObject']['output']>;
  SellerPayoutMinAmount?: Maybe<Scalars['Float']['output']>;
  SiteCommonHtml?: Maybe<Scalars['JSONObject']['output']>;
  UserLoginTgBotToken?: Maybe<Scalars['String']['output']>;
  WebAppVersion?: Maybe<Scalars['String']['output']>;
};

export enum MessageMediaType {
  File = 'File',
  PhotoVideo = 'PhotoVideo',
  Widget = 'Widget'
}

export enum MessageMediaWidgetType {
  Actions = 'Actions',
  ContentElement = 'ContentElement',
  CourseLessonPracticeAttempt = 'CourseLessonPracticeAttempt'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Auth: USER */
  articleBlockManageCreate: ContentElementEntity;
  /** Auth: USER */
  articleBlockManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  articleBlockManageRecover: ContentElementEntity;
  /** Auth: USER */
  articleBlockManageUpdate: ContentElementEntity;
  /** Auth: USER */
  articleBlockManageUpdateOrder: Array<ContentElementEntity>;
  /** Auth: USER */
  articleCreate: ArticleEntity;
  /** Auth: USER */
  articleUpdate: ArticleEntity;
  /** Auth: USER */
  cartUpsert: CartEntity;
  /** Auth: USER

Rate: Count: 20 • Interval: 86400 • Ignore: no • Freeze: yes • Canonical (GET + POST):  uid */
  chatCreate: ChatEntity;
  /** Auth: USER */
  chatMemberDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  chatMemberInviteMany: Array<ChatMemberEntity>;
  /** Auth: USER */
  chatMemberToggleBlockByAdmin: ChatMemberEntity;
  /** Auth: USER */
  chatMemberToggleBlockPersonal: ChatMemberEntity;
  /** Auth: USER */
  chatMemberUpdate: ChatMemberEntity;
  /** Auth: USER */
  chatMessageDeleteMany: Array<Scalars['Int']['output']>;
  /** Auth: USER */
  chatMessageEdit: ChatMessageEntity;
  /** Auth: USER

Rate: Count: 60 • Interval: 60 • Ignore: no • Freeze: yes • Canonical (GET + POST):  uid */
  chatMessageForward: SentForwardMessageChat;
  /** Auth: USER */
  chatMessageReadAllInChat: Scalars['Int']['output'];
  /** Auth: USER */
  chatMessageReadMany: Array<ChatMessageEntity>;
  /** Auth: USER

Rate: Count: 60 • Interval: 60 • Ignore: no • Freeze: yes • Canonical (GET + POST):  uid */
  chatMessageSend: ChatMessageEntity;
  /** Auth: USER */
  chatTypingSetStatus: ChatTypingEvent;
  /** Auth: USER */
  chatUpdate: ChatEntity;
  /** Auth: USER */
  contentElementInteractionUpsert: ContentElementInteractionEntity;
  /** Auth: USER */
  courseLessonBlockManageCreate: ContentElementEntity;
  /** Auth: USER */
  courseLessonBlockManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  courseLessonBlockManageRecover: ContentElementEntity;
  /** Auth: USER */
  courseLessonBlockManageUpdate: ContentElementEntity;
  /** Auth: USER */
  courseLessonBlockManageUpdateOrder: Array<ContentElementEntity>;
  /** Auth: USER */
  courseLessonManageClone: CourseLessonEntity;
  /** Auth: USER */
  courseLessonManageCreate: CourseLessonEntity;
  /** Auth: USER */
  courseLessonManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  courseLessonManageUpdate?: Maybe<CourseLessonEntity>;
  /** Auth: USER */
  courseLessonManageUpdateOrder: Array<CourseLessonEntity>;
  /** Auth: USER */
  courseLessonMediaManageUpdate: CourseLessonMediaEntity;
  /** Auth: USER */
  courseLessonMetaUpsert: CourseLessonMetaEntity;
  /** Auth: USER */
  courseLessonPracticeAttemptFinishAttempt: CourseLessonPracticeAttemptEntity;
  /** Auth: USER */
  courseLessonPracticeAttemptManageUpdate: CourseLessonPracticeAttemptEntity;
  /** Auth: USER */
  courseLessonPracticeAttemptSaveTaskAnswer: CourseLessonPracticeAttemptEntity;
  /** Auth: USER */
  courseLessonPracticeManageCreate: CourseLessonPracticeEntity;
  /** Auth: USER */
  courseLessonPracticeManageUpdate: CourseLessonPracticeEntity;
  /** Auth: USER */
  courseLessonPracticeTaskManageCreate: CourseLessonPracticeTaskEntity;
  /** Auth: USER */
  courseLessonPracticeTaskManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  courseLessonPracticeTaskManageRecover: CourseLessonPracticeTaskEntity;
  /** Auth: USER */
  courseLessonPracticeTaskManageUpdateOrder: Array<CourseLessonPracticeTaskEntity>;
  /** Auth: USER */
  courseManageClone: CourseEntity;
  /** Auth: USER */
  courseManageCreate: CourseEntity;
  /** Auth: USER

Exceptions: InvalidAlias, AliasAlreadyBusy */
  courseManageUpdate: CourseEntity;
  /** Auth: USER

Exceptions: StartNextLessonNotParticipant, StartNextLessonNotAllowed */
  courseProgressStartNextManual?: Maybe<CourseProgressEntity>;
  /** Auth: USER */
  courseProgressUpdateByParticipant?: Maybe<CourseProgressEntity>;
  /** Auth: USER */
  courseProgressUpsertChat?: Maybe<ChatEntity>;
  /** Auth: USER, UserIsAdmin, AdminCoursePublish

Exceptions: CodeAlreadyExist, NotSellerOwnerOfProvidedProducts */
  discountManageCreate: DiscountEntity;
  /** Auth: USER, UserIsAdmin, AdminCoursePublish

Exceptions: CodeAlreadyExist, NotSellerOwnerOfProvidedProducts */
  discountManageUpdate: DiscountEntity;
  /** Auth: USER */
  educationPreferenceSetExamsReminderState: Array<EducationSubject>;
  /** Auth: USER */
  educationPreferenceSetUserSubjects: Array<SubjectEntity>;
  /** Auth: USER */
  friendshipSetFriendshipStatus: FriendshipEntity;
  /** Auth: USER */
  groupManageCreate: GroupEntity;
  /** Auth: USER */
  groupManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  groupManageUpdate: GroupEntity;
  /** Auth: USER */
  groupMemberCreateMany: Array<GroupMemberEntity>;
  /** Auth: USER */
  groupMemberDeleteMany: Scalars['Int']['output'];
  /** Auth: USER

Rate: Count: 1 • Interval: 1 • Ignore: no • Freeze: no • Canonical (GET + POST):  uid */
  invoiceCreateByCart: InvoiceEntity;
  /** Rate: Count: 255 • Interval: 86400 • Ignore: no • Freeze: no • Canonical (GET + POST):  ip */
  invoiceCreateByCartUnauth: InvoiceEntity;
  /** Exceptions: NotFoundByUuid */
  invoiceCreateBySharedCart: InvoiceEntity;
  /** Exceptions: NotFoundByUuid */
  invoiceRecreatePayment: InvoiceEntity;
  /** Auth: USER, UserIsAdmin */
  invoiceRefundCreate: InvoiceRefundEntity;
  /** Auth: USER, UserIsAdmin */
  invoiceRefundUpdate: InvoiceRefundEntity;
  /** Auth: USER, UserIsAdmin */
  mailSendDynamicMail: Scalars['Int']['output'];
  /** Auth: USER */
  notificationReadAllNotifications: Scalars['Int']['output'];
  /** Auth: USER */
  notificationReadNotification: NotificationEntity;
  /** Auth: USER, UserIsAdmin */
  notificationSendToManyFcm: Scalars['Int']['output'];
  /** Auth: USER

Exceptions: BalanceNotEnoughToPayout */
  payoutOperationCreate: PayoutOperationEntity;
  /** Auth: USER, UserIsAdmin */
  payoutOperationExecuteCreateByScheduleCron: Array<InvoiceProductPayoutEntity>;
  /** Auth: USER

Exceptions: SellerIsNotVerifiedToSetRequisite */
  payoutRequisiteCreate: PayoutRequisiteEntity;
  /** Auth: USER

Rate: Count: 1 • Interval: 1 • Ignore: no • Freeze: no

Exceptions: ProductIsNotFree */
  productAccessProlongAccessForFree: ProductAccessEntity;
  /** Auth: USER */
  productFaqCreate: ProductFaqEntity;
  /** Auth: USER */
  productFaqUpdate: ProductFaqEntity;
  /** Auth: USER */
  productFaqUpdateOrder: Array<ProductFaqEntity>;
  /** Auth: USER */
  productFeedbackUpsert: ProductFeedbackEntity;
  /** Auth: USER */
  productLaunchCreate: ProductLaunchEntity;
  /** Auth: USER */
  productLaunchUpdate: ProductLaunchEntity;
  /** Auth: USER */
  productManageCreate: ProductEntity;
  /** Auth: USER */
  productManageUpdate: ProductEntity;
  /** Auth: USER */
  productManageUpsertReviewTicket: SupportTicketEntity;
  /** Auth: USER */
  productParticipantUpdate: ProductParticipantEntity;
  /** Auth: USER */
  productPriceCreate: ProductPriceEntity;
  /** Auth: USER */
  productPriceUpdate: ProductPriceEntity;
  /** Auth: USER */
  productPriceUpdateOrder: Array<ProductPriceEntity>;
  /** Auth: USER */
  productPublicationManualPublishLaunch: ProductLaunchEntity;
  /** Auth: USER, UserIsAdmin, AdminCoursePublish */
  productPublicationReviewLaunch: ProductLaunchEntity;
  /** Auth: USER */
  profileUpdate: ProfileEntity;
  /** Auth: USER */
  profileUpdatePhoto: ProfileEntity;
  /** Auth: USER */
  profileUpdateTitleManually: ProfileEntity;
  /** Auth: USER

Exceptions: NotFound, SelfDenied, Timeout, AlreadyInvited */
  promotionApplyInvitationBonus: PromotionInviteEntity;
  /** Auth: USER */
  schoolAcquiringCreate: AcquiringManage;
  /** Auth: USER */
  schoolAcquiringDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  schoolAcquiringUpdate: AcquiringManage;
  /** Auth: USER */
  schoolAcquiringUpdateOrder: Array<AcquiringManage>;
  /** Auth: USER */
  schoolContentCategoryCreate: ContentCategoryEntity;
  /** Auth: USER */
  schoolContentCategoryUpdate: ContentCategoryEntity;
  /** Auth: USER

Exceptions: DomainIsBusy, DomainIsInvalid, DomainIsInBlockList */
  schoolManageCreateWithSeller: SchoolEntity;
  /** Auth: USER */
  schoolManageSetStateByKey: Scalars['Boolean']['output'];
  /** Auth: USER

Exceptions: DomainIsBusy, DomainIsInvalid, DomainIsInBlockList */
  schoolManageUpdate: SchoolEntity;
  /** Auth: USER */
  schoolOrganizationUpdate: SellerOrganizationEntity;
  /** Auth: USER */
  schoolSubjectCreate: SubjectEntity;
  /** Auth: USER */
  schoolSubjectUpdate: SubjectEntity;
  /** Auth: USER */
  schoolUserManageCreateMany: CreateManyUserOutput;
  /** Auth: USER */
  schoolUserManageProductAccessesCreateMany: Array<ProductAccessEntity>;
  /** Auth: USER */
  schoolUserManageSessionKillAll: Array<SessionEntity>;
  /** Auth: USER */
  schoolUserManageSessionKillById: SessionEntity;
  /** Auth: USER */
  schoolUserManageUpdate: UserEntity;
  /** Auth: USER, UserIsAdmin */
  sellerBalanceExecuteSellerPayoutBalanceUpScheduledCron: Array<InvoiceProductPayoutEntity>;
  /** Auth: USER, AdminSellerVerify

Exceptions: RequestIncompleteAutoVerification */
  sellerBecomeRequestReview: SellerBecomeRequestEntity;
  /** Auth: USER */
  sellerBecomeRequestUpsert: SellerBecomeRequestEntity;
  /** Auth: USER */
  sellerBecomeRequestUpsertShortForm: SellerBecomeRequestEntity;
  /** Auth: USER */
  sellerManagerCreate: SellerManagerEntity;
  /** Auth: USER

Exceptions: NotAllowedToModifySellerOwner */
  sellerManagerDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  sellerManagerUpdate: SellerManagerEntity;
  /** Auth: USER */
  sellerOrganizationDocumentCreate: SellerOrganizationDocumentEntity;
  /** Auth: USER */
  sellerOrganizationDocumentUpdate: SellerOrganizationDocumentEntity;
  /** Auth: USER */
  sellerOrganizationUpdate: SellerOrganizationEntity;
  /** Auth: USER */
  sellerProductManagerCreate: SellerProductManagerEntity;
  /** Auth: USER */
  sellerProductManagerUpdate: SellerProductManagerEntity;
  /** Auth: USER */
  sessionKillAnotherSessions: Scalars['Int']['output'];
  /** Auth: USER */
  sessionKillSessionById: SessionEntity;
  /** Auth: USER */
  sessionUpdateMeta: Scalars['Int']['output'];
  /** Auth: USER */
  storiesManageCreate: StoriesEntity;
  /** Auth: USER */
  storiesManageUpdate: StoriesEntity;
  /** Auth: USER */
  storiesUpsertView: StoriesViewEntity;
  /** Auth: USER, TaskManage */
  subjectCategoryManageCreate: SubjectCategoryEntity;
  /** Auth: USER, TaskManage */
  subjectCategoryManageUpdate: SubjectCategoryEntity;
  /** Auth: USER

Rate: Count: 10 • Interval: 86400 • Ignore: no • Freeze: no • Canonical (GET + POST):  uid */
  supportTicketCreateByUser: SupportTicketEntity;
  /** Auth: USER */
  taskBlockManageCreate: ContentElementEntity;
  /** Auth: USER */
  taskBlockManageDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  taskBlockManageRecover: ContentElementEntity;
  /** Auth: USER */
  taskBlockManageUpdate: ContentElementEntity;
  /** Auth: USER */
  taskBlockManageUpdateOrder: Array<ContentElementEntity>;
  /** Auth: USER, UserIsAdmin */
  taskExecuteOrderAllTasksCron?: Maybe<Scalars['Boolean']['output']>;
  /** Auth: USER, TaskManage */
  taskManageCreate: TaskEntity;
  /** Auth: USER, TaskManage, CourseManage */
  taskManageUpdate: TaskEntity;
  /** Auth: USER */
  tournamentBlitzFindRival: TournamentBlitzLobbyEntity;
  /** Auth: USER */
  tournamentBlitzSetStatusUserQueue: Scalars['Int']['output'];
  /** Auth: USER

Exceptions: NoMoney, NotAllowedCreateOfficial */
  tournamentClone: TournamentEntity;
  /** Auth: USER

Exceptions: NoMoney, NotAllowedCreateOfficial */
  tournamentCreate: TournamentEntity;
  /** Auth: USER

Exceptions: NoMoney, AlreadyAppointed, AlreadyStarted, MaxMembersExceeded, InvalidInviteKey */
  tournamentLobbyAppoint: TournamentEntity;
  /** Auth: USER */
  tournamentLobbyMakeMemberPlayer?: Maybe<TournamentMemberEntity>;
  /** Auth: USER */
  tournamentLobbyManuallyStartTournament: Scalars['Boolean']['output'];
  /** Auth: USER */
  tournamentLobbySendInvitation: TournamentInvitationEntity;
  /** Auth: USER */
  tournamentLobbySendMessage: TournamentMessageEntity;
  /** Auth: USER */
  tournamentProcessSaveTaskAnswer: TournamentResultEntity;
  /** Auth: USER */
  tournamentPromotionPublish: Scalars['Boolean']['output'];
  /** Auth: USER

Rate: Count: 1 • Interval: 1 • Ignore: no • Freeze: no */
  tournamentResultFinishMyTournament: TournamentResultEntity;
  /** Auth: USER

Exceptions: TgIdAlreadyConnected */
  userConnectTelegram: UserEntity;
  /** Auth: USER, UserIsAdmin

Exceptions: NotFound */
  userManageUpdate: UserEntity;
  /** Auth: USER */
  userRequestDeletion: Scalars['Boolean']['output'];
  /** Auth: USER

Exceptions: DomainIsInvalid */
  userSettingsSetDomain: UserEntity;
  /** Auth: USER */
  userStateSetByKey: Scalars['Boolean']['output'];
  /** Auth: USER, UserIsAdmin */
  walletManageAddOperation: WalletOperationEntity;
  /** Auth: USER

Rate: Count: 1 • Interval: 2 • Ignore: no • Freeze: no • Canonical (GET + POST):  uid

Exceptions: NoMoney, TransferFailed */
  walletOperationMakeTransfer: WalletOperationEntity;
  /** Auth: USER */
  webhookEndpointCreate: WebhookEndpointEntity;
  /** Auth: USER */
  webhookEndpointDelete: Scalars['Boolean']['output'];
  /** Auth: USER */
  webhookEndpointUpdate: WebhookEndpointEntity;
};


export type MutationArticleBlockManageCreateArgs = {
  articleId: Scalars['Int']['input'];
  contentElement: CreateElementContentInput;
};


export type MutationArticleBlockManageDeleteArgs = {
  articleId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
};


export type MutationArticleBlockManageRecoverArgs = {
  articleId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
};


export type MutationArticleBlockManageUpdateArgs = {
  articleId: Scalars['Int']['input'];
  contentElement: UpdateElementContentInput;
  contentElementId: Scalars['Int']['input'];
};


export type MutationArticleBlockManageUpdateOrderArgs = {
  articleId: Scalars['Int']['input'];
  blockOrder: UpdateBlockOrderArticleInput;
};


export type MutationArticleCreateArgs = {
  article: CreateArticleInput;
};


export type MutationArticleUpdateArgs = {
  article: UpdateArticleInput;
  articleId: Scalars['Int']['input'];
};


export type MutationCartUpsertArgs = {
  cart: CreateCartInput;
  merge?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationChatCreateArgs = {
  chat: CreateChatInput;
};


export type MutationChatMemberDeleteArgs = {
  chatId: Scalars['Int']['input'];
};


export type MutationChatMemberInviteManyArgs = {
  chatId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationChatMemberToggleBlockByAdminArgs = {
  blocked: Scalars['Boolean']['input'];
  blockedUntil?: InputMaybe<Scalars['Date']['input']>;
  chatId: Scalars['Int']['input'];
  memberUserId: Scalars['Int']['input'];
};


export type MutationChatMemberToggleBlockPersonalArgs = {
  blocked: Scalars['Boolean']['input'];
  chatId: Scalars['Int']['input'];
  companionUserId: Scalars['Int']['input'];
};


export type MutationChatMemberUpdateArgs = {
  chatId: Scalars['Int']['input'];
  member: UpdateMemberChatInput;
};


export type MutationChatMessageDeleteManyArgs = {
  chatId: Scalars['Int']['input'];
  messageIds: Array<Scalars['Int']['input']>;
};


export type MutationChatMessageEditArgs = {
  chatId: Scalars['Int']['input'];
  message: EditMessageChatInput;
  messageId: Scalars['Int']['input'];
};


export type MutationChatMessageForwardArgs = {
  chatId: Scalars['Int']['input'];
  message: ForwardMessageChatInput;
  targetChatId: Scalars['Int']['input'];
};


export type MutationChatMessageReadAllInChatArgs = {
  chatId: Scalars['Int']['input'];
};


export type MutationChatMessageReadManyArgs = {
  chatId: Scalars['Int']['input'];
  messageIds: Array<Scalars['Int']['input']>;
};


export type MutationChatMessageSendArgs = {
  chatId: Scalars['Int']['input'];
  message: SendMessageChatInput;
};


export type MutationChatTypingSetStatusArgs = {
  chatId: Scalars['Int']['input'];
  isTyping: Scalars['Boolean']['input'];
};


export type MutationChatUpdateArgs = {
  chat: UpdateChatInput;
  chatId: Scalars['Int']['input'];
};


export type MutationContentElementInteractionUpsertArgs = {
  contentElementUuid: Scalars['String']['input'];
  interaction: UpsertInteractionElementContentInput;
};


export type MutationCourseLessonBlockManageCreateArgs = {
  contentElement: CreateElementContentInput;
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonBlockManageDeleteArgs = {
  contentElementId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonBlockManageRecoverArgs = {
  contentElementId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonBlockManageUpdateArgs = {
  contentElement: UpdateElementContentInput;
  contentElementId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonBlockManageUpdateOrderArgs = {
  blockOrder: UpdateLessonBlockOrderCourseInput;
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonManageCloneArgs = {
  lessonId: Scalars['Int']['input'];
  sourceCourseId: Scalars['Int']['input'];
  targetCourseId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCourseLessonManageCreateArgs = {
  courseId: Scalars['Int']['input'];
  lesson: CreateLessonCourseInput;
};


export type MutationCourseLessonManageDeleteArgs = {
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonManageUpdateArgs = {
  lesson: UpdateLessonCourseInput;
  lessonId: Scalars['Int']['input'];
};


export type MutationCourseLessonManageUpdateOrderArgs = {
  courseId: Scalars['Int']['input'];
  lessonIds: Array<Scalars['Int']['input']>;
};


export type MutationCourseLessonMediaManageUpdateArgs = {
  media: UpdateLessonMediaCourseInput;
  mediaId: Scalars['Int']['input'];
};


export type MutationCourseLessonMetaUpsertArgs = {
  lessonId: Scalars['Int']['input'];
  meta: CreateLessonMetaCourseInput;
};


export type MutationCourseLessonPracticeAttemptFinishAttemptArgs = {
  courseId: Scalars['Int']['input'];
  practiceId: Scalars['Int']['input'];
};


export type MutationCourseLessonPracticeAttemptManageUpdateArgs = {
  attempt: UpdateLessonPracticeAttemptCourseInput;
  attemptId: Scalars['Int']['input'];
};


export type MutationCourseLessonPracticeAttemptSaveTaskAnswerArgs = {
  answer: SaveAnswerTaskInput;
  courseId: Scalars['Int']['input'];
  practiceId: Scalars['Int']['input'];
};


export type MutationCourseLessonPracticeManageCreateArgs = {
  lessonId: Scalars['Int']['input'];
  practice: CreateLessonPracticeCourseInput;
};


export type MutationCourseLessonPracticeManageUpdateArgs = {
  lessonPracticeId: Scalars['Int']['input'];
  practice: UpdateLessonPracticeCourseInput;
};


export type MutationCourseLessonPracticeTaskManageCreateArgs = {
  lessonPracticeId: Scalars['Int']['input'];
  task: CreateTaskInput;
};


export type MutationCourseLessonPracticeTaskManageDeleteArgs = {
  practiceTaskId: Scalars['Int']['input'];
};


export type MutationCourseLessonPracticeTaskManageRecoverArgs = {
  practiceTaskId: Scalars['Int']['input'];
};


export type MutationCourseLessonPracticeTaskManageUpdateOrderArgs = {
  lessonId: Scalars['Int']['input'];
  lessonPracticeId: Scalars['Int']['input'];
  taskOrder: UpdateLessonPracticeTaskOrderCourseInput;
};


export type MutationCourseManageCloneArgs = {
  courseId: Scalars['Int']['input'];
};


export type MutationCourseManageCreateArgs = {
  course: CreateCourseInput;
};


export type MutationCourseManageUpdateArgs = {
  course: UpdateCourseInput;
  courseId: Scalars['Int']['input'];
};


export type MutationCourseProgressStartNextManualArgs = {
  courseId: Scalars['Int']['input'];
  currentLessonId: Scalars['Int']['input'];
};


export type MutationCourseProgressUpdateByParticipantArgs = {
  lessonId: Scalars['Int']['input'];
  progress: UpdateParticipantProgressCourseInput;
};


export type MutationCourseProgressUpsertChatArgs = {
  lessonId: Scalars['Int']['input'];
};


export type MutationDiscountManageCreateArgs = {
  discount: CreateDiscountInput;
};


export type MutationDiscountManageUpdateArgs = {
  discount: UpdateDiscountInput;
  discountId: Scalars['Int']['input'];
};


export type MutationEducationPreferenceSetExamsReminderStateArgs = {
  subject: EducationSubject;
};


export type MutationEducationPreferenceSetUserSubjectsArgs = {
  subjects: Array<EducationSubject>;
};


export type MutationFriendshipSetFriendshipStatusArgs = {
  relUserId: Scalars['Int']['input'];
  status: FriendshipStatus;
};


export type MutationGroupManageCreateArgs = {
  group: CreateGroupInput;
};


export type MutationGroupManageDeleteArgs = {
  groupId: Scalars['Int']['input'];
};


export type MutationGroupManageUpdateArgs = {
  group: UpdateGroupInput;
  groupId: Scalars['Int']['input'];
};


export type MutationGroupMemberCreateManyArgs = {
  groupId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationGroupMemberDeleteManyArgs = {
  groupId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationInvoiceCreateByCartArgs = {
  cart: CreateInvoiceInput;
};


export type MutationInvoiceCreateByCartUnauthArgs = {
  cart: CreateInvoiceInput;
  payer: PayerCreateInvoiceInput;
};


export type MutationInvoiceCreateBySharedCartArgs = {
  sharedCart: CreateBySharedCartInvoiceInput;
};


export type MutationInvoiceRecreatePaymentArgs = {
  acquiringId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationInvoiceRefundCreateArgs = {
  refund: CreateRefundInvoiceInput;
};


export type MutationInvoiceRefundUpdateArgs = {
  refund: UpdateRefundInvoiceInput;
  refundId: Scalars['Int']['input'];
};


export type MutationMailSendDynamicMailArgs = {
  mail: DynamicTemplateMailInput;
};


export type MutationNotificationReadNotificationArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationNotificationSendToManyFcmArgs = {
  notification: SendManyNotificationInput;
};


export type MutationPayoutOperationCreateArgs = {
  operation: CreateOperationPayoutInput;
};


export type MutationPayoutRequisiteCreateArgs = {
  requisite: CreateRequisitePayoutInput;
};


export type MutationProductAccessProlongAccessForFreeArgs = {
  launchId: Scalars['Int']['input'];
};


export type MutationProductFaqCreateArgs = {
  faq: CreateFaqProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductFaqUpdateArgs = {
  faq: UpdateFaqProductInput;
  faqId: Scalars['Int']['input'];
};


export type MutationProductFaqUpdateOrderArgs = {
  faqIds: Array<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationProductFeedbackUpsertArgs = {
  feedback: CreateFeedbackProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductLaunchCreateArgs = {
  launch: CreateLaunchProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductLaunchUpdateArgs = {
  launch: UpdateLaunchProductInput;
  launchId: Scalars['Int']['input'];
};


export type MutationProductManageCreateArgs = {
  product: CreateProductInput;
};


export type MutationProductManageUpdateArgs = {
  product: UpdateProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductManageUpsertReviewTicketArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationProductParticipantUpdateArgs = {
  participant: UpdateParticipantProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductPriceCreateArgs = {
  launchId?: InputMaybe<Scalars['Int']['input']>;
  price: CreatePriceProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationProductPriceUpdateArgs = {
  price: UpdatePriceProductInput;
  priceId: Scalars['Int']['input'];
};


export type MutationProductPriceUpdateOrderArgs = {
  priceIds: Array<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationProductPublicationManualPublishLaunchArgs = {
  launchId: Scalars['Int']['input'];
  publication: PublishLaunchProductInput;
};


export type MutationProductPublicationReviewLaunchArgs = {
  launchId: Scalars['Int']['input'];
  review: ReviewLaunchProductInput;
};


export type MutationProfileUpdateArgs = {
  profile: UpdateProfileInput;
};


export type MutationProfileUpdatePhotoArgs = {
  photo: UpdateAvatarProfileInput;
};


export type MutationProfileUpdateTitleManuallyArgs = {
  title: UpdateTitleProfileInput;
};


export type MutationPromotionApplyInvitationBonusArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationSchoolAcquiringCreateArgs = {
  acquiring: CreateAcquiringInput;
};


export type MutationSchoolAcquiringDeleteArgs = {
  acquiringId: Scalars['Int']['input'];
};


export type MutationSchoolAcquiringUpdateArgs = {
  acquiring: UpdateAcquiringInput;
  acquiringId: Scalars['Int']['input'];
};


export type MutationSchoolAcquiringUpdateOrderArgs = {
  acquiringIds: Array<Scalars['Int']['input']>;
};


export type MutationSchoolContentCategoryCreateArgs = {
  category: CreateCategoryContentInput;
};


export type MutationSchoolContentCategoryUpdateArgs = {
  category: UpdateCategoryContentInput;
  categoryId: Scalars['Int']['input'];
};


export type MutationSchoolManageCreateWithSellerArgs = {
  school: CreateSchoolInput;
};


export type MutationSchoolManageSetStateByKeyArgs = {
  input: JsonObjectInput;
  key: SchoolStateKey;
  schoolId: Scalars['Int']['input'];
};


export type MutationSchoolManageUpdateArgs = {
  school: UpdateSchoolInput;
  schoolId: Scalars['Int']['input'];
};


export type MutationSchoolOrganizationUpdateArgs = {
  organization: UpdateOrganizationSchoolInput;
  sellerOrganizationId: Scalars['Int']['input'];
};


export type MutationSchoolSubjectCreateArgs = {
  subject: CreateSubjectInput;
};


export type MutationSchoolSubjectUpdateArgs = {
  subject: UpdateSubjectInput;
  subjectId: Scalars['Int']['input'];
};


export type MutationSchoolUserManageCreateManyArgs = {
  enrollments?: InputMaybe<CreateAccessManyProductInput>;
  users: CreateManyUserInput;
};


export type MutationSchoolUserManageProductAccessesCreateManyArgs = {
  enrollments: CreateAccessManyProductInput;
  userId: Scalars['Int']['input'];
};


export type MutationSchoolUserManageSessionKillAllArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSchoolUserManageSessionKillByIdArgs = {
  sessionId: Scalars['Int']['input'];
};


export type MutationSchoolUserManageUpdateArgs = {
  userId: Scalars['Int']['input'];
  userPartial: UpdateUserInput;
};


export type MutationSellerBecomeRequestReviewArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['Int']['input'];
  status: SellerBecomeRequestStatus;
};


export type MutationSellerBecomeRequestUpsertArgs = {
  request: SellerBecomeRequestInput;
  requestId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSellerBecomeRequestUpsertShortFormArgs = {
  request: ShortFormSellerBecomeRequestInput;
};


export type MutationSellerManagerCreateArgs = {
  manager: CreateManagerSellerInput;
};


export type MutationSellerManagerDeleteArgs = {
  managerId: Scalars['Int']['input'];
};


export type MutationSellerManagerUpdateArgs = {
  manager: UpdateManagerSellerInput;
  managerId: Scalars['Int']['input'];
};


export type MutationSellerOrganizationDocumentCreateArgs = {
  document: CreateOrganizationDocumentSellerInput;
};


export type MutationSellerOrganizationDocumentUpdateArgs = {
  document: UpdateOrganizationDocumentSellerInput;
  documentId: Scalars['Int']['input'];
};


export type MutationSellerOrganizationUpdateArgs = {
  organization: UpdateOrganizationSellerInput;
  sellerOrganizationId: Scalars['Int']['input'];
};


export type MutationSellerProductManagerCreateArgs = {
  productManager: CreateProductManagerSellerInput;
};


export type MutationSellerProductManagerUpdateArgs = {
  productManager: UpdateProductManagerSellerInput;
  productManagerId: Scalars['Int']['input'];
};


export type MutationSessionKillSessionByIdArgs = {
  sessionId: Scalars['Int']['input'];
};


export type MutationSessionUpdateMetaArgs = {
  sessionMeta: UpdateMetaSessionInput;
};


export type MutationStoriesManageCreateArgs = {
  stories: CreateStoriesInput;
};


export type MutationStoriesManageUpdateArgs = {
  stories: UpdateStoriesInput;
  storiesId: Scalars['Int']['input'];
};


export type MutationStoriesUpsertViewArgs = {
  storiesId: Scalars['Int']['input'];
};


export type MutationSubjectCategoryManageCreateArgs = {
  category: CreateCategorySubjectInput;
};


export type MutationSubjectCategoryManageUpdateArgs = {
  category: UpdateCategorySubjectInput;
  categoryId: Scalars['Int']['input'];
};


export type MutationSupportTicketCreateByUserArgs = {
  ticket: CreateTicketSupportInput;
};


export type MutationTaskBlockManageCreateArgs = {
  contentElement: CreateElementContentInput;
  taskId: Scalars['Int']['input'];
};


export type MutationTaskBlockManageDeleteArgs = {
  contentElementId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationTaskBlockManageRecoverArgs = {
  contentElementId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationTaskBlockManageUpdateArgs = {
  contentElement: UpdateElementContentInput;
  contentElementId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationTaskBlockManageUpdateOrderArgs = {
  blockOrder: UpdateBlockOrderTaskInput;
  taskId: Scalars['Int']['input'];
};


export type MutationTaskManageCreateArgs = {
  task: CreateTaskInput;
};


export type MutationTaskManageUpdateArgs = {
  task: UpdateTaskInput;
  taskId: Scalars['Int']['input'];
};


export type MutationTournamentBlitzFindRivalArgs = {
  subject: EducationSubject;
};


export type MutationTournamentBlitzSetStatusUserQueueArgs = {
  blitzLobbyId?: InputMaybe<Scalars['Int']['input']>;
  status: TournamentBlitzLobbyStatus;
};


export type MutationTournamentCloneArgs = {
  tournament: CloneTournamentInput;
  tournamentParentId: Scalars['Int']['input'];
};


export type MutationTournamentCreateArgs = {
  tournament: CreateTournamentInput;
};


export type MutationTournamentLobbyAppointArgs = {
  inviteKey: Scalars['String']['input'];
  tournamentId: Scalars['Int']['input'];
};


export type MutationTournamentLobbyMakeMemberPlayerArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationTournamentLobbyManuallyStartTournamentArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationTournamentLobbySendInvitationArgs = {
  invitation: SendInvitationTournamentInput;
};


export type MutationTournamentLobbySendMessageArgs = {
  messagePayload: SendMessageTournamentInput;
};


export type MutationTournamentProcessSaveTaskAnswerArgs = {
  answer: SaveAnswerTaskInput;
  currentTaskIndex?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['Int']['input'];
};


export type MutationTournamentPromotionPublishArgs = {
  contentType: TournamentPromotionContentType;
  promotionType: PromotionPublicationType;
  tournamentId: Scalars['Int']['input'];
};


export type MutationTournamentResultFinishMyTournamentArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationUserConnectTelegramArgs = {
  callbackConnectInput: ConnectCallbackTelegramInput;
};


export type MutationUserManageUpdateArgs = {
  userId: Scalars['Int']['input'];
  userPartial: UpdateUserInput;
};


export type MutationUserRequestDeletionArgs = {
  form: RequestUserDeletionInput;
};


export type MutationUserSettingsSetDomainArgs = {
  domain: Scalars['String']['input'];
};


export type MutationUserStateSetByKeyArgs = {
  input: JsonObjectInput;
  key: UserStateKey;
};


export type MutationWalletManageAddOperationArgs = {
  operation: AddOperationWalletInput;
};


export type MutationWalletOperationMakeTransferArgs = {
  transfer: MakeTransferWalletInput;
};


export type MutationWebhookEndpointCreateArgs = {
  endpoint: CreateEndpointWebhookInput;
};


export type MutationWebhookEndpointDeleteArgs = {
  endpointId: Scalars['Int']['input'];
};


export type MutationWebhookEndpointUpdateArgs = {
  endpoint: UpdateEndpointWebhookInput;
  endpointId: Scalars['Int']['input'];
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  arguments?: Maybe<Scalars['JSONObject']['output']>;
  link?: Maybe<AppRouteLink>;
  method?: Maybe<NotificationActionMethod>;
  title: Scalars['String']['output'];
};

export enum NotificationActionMethod {
  FriendshipConfirm = 'FriendshipConfirm',
  PaymentReleasedOpen = 'PaymentReleasedOpen',
  SellerBecomeRequestOpen = 'SellerBecomeRequestOpen',
  TournamentOpen = 'TournamentOpen'
}

export type NotificationActor = {
  __typename?: 'NotificationActor';
  identifier: Scalars['Int']['output'];
  type: NotificationActorType;
};

export enum NotificationActorType {
  Admin = 'Admin',
  Default = 'Default',
  Tournament = 'Tournament',
  User = 'User'
}

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  actions: Array<NotificationAction>;
  actor: NotificationActor;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  icons: NotificationIcons;
  id: Scalars['Int']['output'];
  isGhost?: Maybe<Scalars['Boolean']['output']>;
  status: NotificationStatus;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum NotificationException {
  NotFound = 'NotFound'
}

export type NotificationIcon = {
  __typename?: 'NotificationIcon';
  type: NotificationIconType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationIconType {
  Default = 'Default',
  User = 'User'
}

export type NotificationIcons = {
  __typename?: 'NotificationIcons';
  extra?: Maybe<Array<NotificationIcon>>;
  main: NotificationIcon;
};

export enum NotificationStatus {
  Read = 'Read',
  Unread = 'Unread'
}

export enum NotificationType {
  CourseNewLesson = 'CourseNewLesson',
  PaymentReleased = 'PaymentReleased',
  SessionNewLogin = 'SessionNewLogin',
  TournamentInvitation = 'TournamentInvitation',
  UserFriendRequestConfirm = 'UserFriendRequestConfirm',
  UserIncomeFriendRequest = 'UserIncomeFriendRequest',
  UserSellerBecomeRequestNewStatus = 'UserSellerBecomeRequestNewStatus',
  UserVkFriendInExodeNow = 'UserVkFriendInExodeNow',
  WalletNewOperation = 'WalletNewOperation'
}

export enum NotificationUserSegment {
  Online = 'Online'
}

export type NumberRangeInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationDocumentConfigSellerInput = {
  showInFooter?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<SellerOrganizationSelfUploadedDocumentType>;
  uploadMode?: InputMaybe<SellerOrganizationDocumentUploadMode>;
};

export type OrganizationInfoCompanyOutput = {
  __typename?: 'OrganizationInfoCompanyOutput';
  address?: Maybe<Scalars['String']['output']>;
  inn: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  kpp: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ogrn: Scalars['String']['output'];
};

export enum PageCategoryType {
  Custom = 'Custom',
  System = 'System'
}

export type PageEntity = {
  __typename?: 'PageEntity';
  active: Scalars['Boolean']['output'];
  auth?: Maybe<Scalars['JSONObject']['output']>;
  canonicalParams: Array<Scalars['String']['output']>;
  categoryType: PageCategoryType;
  content: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domains: Array<AppServeDomain>;
  editable: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  middleware?: Maybe<Scalars['String']['output']>;
  mobileTab?: Maybe<PageMobileTab>;
  path: Scalars['String']['output'];
  request?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unauth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  viewType: PageViewType;
};

export enum PageMobileTab {
  Catalog = 'Catalog',
  Chat = 'Chat',
  Education = 'Education',
  Menu = 'Menu'
}

export enum PageViewType {
  Iframe = 'Iframe',
  Page = 'Page',
  Tab = 'Tab'
}

export type PasswordEntity = {
  __typename?: 'PasswordEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PayerCreateInvoiceInput = {
  login: Scalars['String']['input'];
};

export type PayerDetailsPayment = {
  __typename?: 'PayerDetailsPayment';
  cardNumber?: Maybe<Scalars['String']['output']>;
};

export type PaymeAcquiringUzItem = {
  __typename?: 'PaymeAcquiringUzItem';
  createTransactionTime?: Maybe<Scalars['Int']['output']>;
  fiscal?: Maybe<Scalars['JSONObject']['output']>;
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  acquiring?: Maybe<AcquiringEntity>;
  checkoutPaymentId?: Maybe<Scalars['String']['output']>;
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  expireAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoice: InvoiceEntity;
  isCanceled: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isCreated: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  /** Is initial subscription payment */
  isRecurrent: Scalars['Boolean']['output'];
  isWaitingPay: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  payerDetails: PayerDetailsPayment;
  products: Array<InvoiceProductEntity>;
  rebillId?: Maybe<Scalars['String']['output']>;
  recurrentParentId?: Maybe<Scalars['Float']['output']>;
  /** Released to user */
  released: Scalars['Boolean']['output'];
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PaymentException {
  AcquiringNotFoundOrNotActive = 'AcquiringNotFoundOrNotActive',
  NotFound = 'NotFound',
  NotFoundByCheckoutPaymentId = 'NotFoundByCheckoutPaymentId'
}

export type PaymentProviderEntity = {
  __typename?: 'PaymentProviderEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  currencies: Array<ProductCurrency>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domains: Array<AppServeDomain>;
  dynamicForm: Scalars['JSONObject']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  preference: ProviderPreferencePayment;
  ttlDuration: Scalars['Float']['output'];
  type: PaymentProviderType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PaymentProviderType {
  ClickAcquiringUz = 'ClickAcquiringUz',
  PaymeAcquiringUz = 'PaymeAcquiringUz',
  TinkoffAcquiringRu = 'TinkoffAcquiringRu',
  UzumAcquiringUz = 'UzumAcquiringUz'
}

export enum PaymentStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Created = 'Created',
  Processing = 'Processing',
  WaitingPay = 'WaitingPay'
}

export type PayoutCommissionEntity = {
  __typename?: 'PayoutCommissionEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  next?: Maybe<PayoutCommissionEntity>;
  payoutDelay: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
  startAt: Scalars['Date']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PayoutException {
  BalanceIsLessMinToPayout = 'BalanceIsLessMinToPayout',
  BalanceNotEnoughToPayout = 'BalanceNotEnoughToPayout',
  ErrorInBankProcessing = 'ErrorInBankProcessing',
  SellerIsNotVerifiedToPayout = 'SellerIsNotVerifiedToPayout',
  SellerIsNotVerifiedToSetRequisite = 'SellerIsNotVerifiedToSetRequisite',
  SellerRequisiteIsNotActiveToPayout = 'SellerRequisiteIsNotActiveToPayout'
}

export type PayoutOperationEntity = {
  __typename?: 'PayoutOperationEntity';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  currency: ProductCurrency;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  exception?: Maybe<PayoutException>;
  id: Scalars['Int']['output'];
  initiationType: PayoutOperationInitiationType;
  operations: Array<SellerBalanceOperationEntity>;
  seller: SellerEntity;
  status: PayoutOperationStatus;
  transactionAmount: Scalars['Float']['output'];
  transferAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserEntity>;
};

export enum PayoutOperationInitiationType {
  Automation = 'Automation',
  Manually = 'Manually'
}

export enum PayoutOperationStatus {
  Calculating = 'Calculating',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Created = 'Created',
  OnBankProcessing = 'OnBankProcessing',
  Verifying = 'Verifying',
  WaitBankProcessing = 'WaitBankProcessing'
}

export type PayoutRequisiteEntity = {
  __typename?: 'PayoutRequisiteEntity';
  active: Scalars['Boolean']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  correspondentAccount: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserEntity>;
};

export enum Permission {
  AdminCompanyItDeveloper = 'AdminCompanyItDeveloper',
  AdminCompanyTeamMember = 'AdminCompanyTeamMember',
  AdminCoursePublish = 'AdminCoursePublish',
  AdminSellerVerify = 'AdminSellerVerify',
  CompanyItDeveloper = 'CompanyItDeveloper',
  CompanyTeamMember = 'CompanyTeamMember',
  CourseCommentsManage = 'CourseCommentsManage',
  CourseCurator = 'CourseCurator',
  CourseManage = 'CourseManage',
  CourseReportingView = 'CourseReportingView',
  CourseStudentManage = 'CourseStudentManage',
  CourseView = 'CourseView',
  ProductManage = 'ProductManage',
  SchoolCustomizeSite = 'SchoolCustomizeSite',
  SchoolManagePages = 'SchoolManagePages',
  SchoolManageSettings = 'SchoolManageSettings',
  SchoolManageUsers = 'SchoolManageUsers',
  SellerFinances = 'SellerFinances',
  SellerManage = 'SellerManage',
  SellerManageManagers = 'SellerManageManagers',
  SellerRefunds = 'SellerRefunds',
  SellerSales = 'SellerSales',
  TaskManage = 'TaskManage',
  TaskView = 'TaskView',
  TournamentAll = 'TournamentAll',
  TournamentCreateOfficial = 'TournamentCreateOfficial',
  UserHavePartnerAccount = 'UserHavePartnerAccount',
  UserIsAdmin = 'UserIsAdmin',
  UserIsAdministrationAccount = 'UserIsAdministrationAccount',
  UserIsApiClient = 'UserIsApiClient',
  UserIsBot = 'UserIsBot',
  UserIsSupportAgent = 'UserIsSupportAgent',
  UserView = 'UserView'
}

export type ProducerEntity = {
  __typename?: 'ProducerEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProductAccessEntity = {
  __typename?: 'ProductAccessEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  expireAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  launch?: Maybe<ProductLaunchEntity>;
  participant?: Maybe<ProductParticipantEntity>;
  price?: Maybe<ProductPriceEntity>;
  product: ProductEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum ProductApprove {
  Certified = 'Certified',
  Recommended = 'Recommended'
}

export enum ProductCurrency {
  Eur = 'Eur',
  Exes = 'Exes',
  Free = 'Free',
  Kzt = 'Kzt',
  Rub = 'Rub',
  Usd = 'Usd',
  Uzs = 'Uzs'
}

export type ProductEntity = {
  __typename?: 'ProductEntity';
  approves: Array<ProductApprove>;
  archived: Scalars['Boolean']['output'];
  course?: Maybe<CourseEntity>;
  createdAt: Scalars['Date']['output'];
  currency: ProductCurrency;
  currentEducationLaunches?: Maybe<Array<ProductLaunchEntity>>;
  currentSaleLaunch?: Maybe<ProductLaunchEntity>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domains: Array<AppServeDomain>;
  feedbackRating?: Maybe<Scalars['Float']['output']>;
  groupsCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFree: Scalars['Boolean']['output'];
  isOnSale: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  launches: Array<ProductLaunchEntity>;
  meta: ProductMeta;
  minimalPrice?: Maybe<ProductPriceEntity>;
  myAccess?: Maybe<ProductAccessEntity>;
  participantsCount: Scalars['Int']['output'];
  prices: Array<ProductPriceEntity>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  saleFinishAt?: Maybe<Scalars['Date']['output']>;
  saleStartAt?: Maybe<Scalars['Date']['output']>;
  seller: SellerEntity;
  showInCatalog: Scalars['Boolean']['output'];
  status: ProductStatus;
  type: ProductType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProductException {
  FeedbackCanNotSend = 'FeedbackCanNotSend',
  LaunchNotAvailableToPublish = 'LaunchNotAvailableToPublish',
  LaunchSaleDatesIsCrossed = 'LaunchSaleDatesIsCrossed',
  NotFound = 'NotFound',
  PriceNameIsNotUniq = 'PriceNameIsNotUniq',
  PriceNotInLaunchSaleInterval = 'PriceNotInLaunchSaleInterval',
  ProductIsNotFree = 'ProductIsNotFree'
}

export type ProductFaqEntity = {
  __typename?: 'ProductFaqEntity';
  active: Scalars['Boolean']['output'];
  answer: Scalars['JSONObject']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isOpenedInUi: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProductFeedbackEntity = {
  __typename?: 'ProductFeedbackEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  status: ProductFeedbackStatus;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum ProductFeedbackStatus {
  OnCheck = 'OnCheck',
  Published = 'Published'
}

export enum ProductLaunchByDateStatus {
  Active = 'Active',
  Declined = 'Declined',
  Draft = 'Draft',
  Future = 'Future',
  Inactive = 'Inactive',
  NoActualPrices = 'NoActualPrices',
  OnCheck = 'OnCheck',
  Past = 'Past',
  ReadyToPublish = 'ReadyToPublish'
}

export type ProductLaunchEntity = {
  __typename?: 'ProductLaunchEntity';
  active: Scalars['Boolean']['output'];
  countAccesses: Scalars['Int']['output'];
  countPrices: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  educationFinishAt?: Maybe<Scalars['Date']['output']>;
  educationStartAt?: Maybe<Scalars['Date']['output']>;
  educationStatus: ProductLaunchByDateStatus;
  id: Scalars['Int']['output'];
  infinityAccess: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  product: ProductEntity;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  saleFinishAt?: Maybe<Scalars['Date']['output']>;
  saleStartAt?: Maybe<Scalars['Date']['output']>;
  saleStatus: ProductLaunchByDateStatus;
  status: ProductLaunchStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProductLaunchStatus {
  Declined = 'Declined',
  Draft = 'Draft',
  OnCheck = 'OnCheck',
  Published = 'Published',
  Unpublished = 'Unpublished'
}

export type ProductMeta = {
  __typename?: 'ProductMeta';
  payment?: Maybe<ProductPaymentMeta>;
  stats?: Maybe<ProductStatsMeta>;
};

export type ProductParticipantEntity = {
  __typename?: 'ProductParticipantEntity';
  courseProgresses: Array<CourseProgressEntity>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  product: ProductEntity;
  status: ProductParticipantStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ProductParticipantStatus {
  Completed = 'Completed',
  InUse = 'InUse'
}

export type ProductPaymentMeta = {
  __typename?: 'ProductPaymentMeta';
  receiptConfig?: Maybe<Scalars['JSONObject']['output']>;
};

export type ProductPriceEntity = {
  __typename?: 'ProductPriceEntity';
  accessDays?: Maybe<Scalars['Int']['output']>;
  active: Scalars['Boolean']['output'];
  activeFrom?: Maybe<Scalars['Date']['output']>;
  activeTo?: Maybe<Scalars['Date']['output']>;
  actualAccessDays?: Maybe<Scalars['Int']['output']>;
  actualFrom?: Maybe<Scalars['Date']['output']>;
  actualIsDependsOnLaunch: Scalars['Boolean']['output'];
  actualTo?: Maybe<Scalars['Date']['output']>;
  amount: Scalars['Float']['output'];
  amountExchangeRates?: Maybe<ProductPriceExchangeRate>;
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Access via direct link */
  hidden: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infinityAccess: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isActiveByDate: Scalars['Boolean']['output'];
  launch?: Maybe<ProductLaunchEntity>;
  launchPeriodMode: ProductPriceLaunchPeriodMode;
  meta: ProductPriceMeta;
  order: Scalars['Int']['output'];
  previousAmount?: Maybe<Scalars['Float']['output']>;
  product: ProductEntity;
  subscriptionPeriod?: Maybe<ProductPriceSubscriptionPeriod>;
  tags: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ProductPriceType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ProductPriceExchangeRate = {
  __typename?: 'ProductPriceExchangeRate';
  amount?: Maybe<ExchangeRateOutput>;
  previousAmount?: Maybe<ExchangeRateOutput>;
};

export enum ProductPriceLaunchPeriodMode {
  AccordingToLaunch = 'AccordingToLaunch',
  SelfDefinition = 'SelfDefinition'
}

export type ProductPriceMeta = {
  __typename?: 'ProductPriceMeta';
  override?: Maybe<ProductPriceOverrideMeta>;
  schoolSaasFeatures?: Maybe<SchoolFeatures>;
};

export type ProductPriceOverrideMeta = {
  __typename?: 'ProductPriceOverrideMeta';
  description?: Maybe<Scalars['JSONObject']['output']>;
  slug?: Maybe<Scalars['JSONObject']['output']>;
  tags?: Maybe<Array<Scalars['JSONObject']['output']>>;
  title?: Maybe<Scalars['JSONObject']['output']>;
};

export enum ProductPriceSubscriptionPeriod {
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export enum ProductPriceType {
  Demo = 'Demo',
  Single = 'Single',
  Subscription = 'Subscription',
  Upgrade = 'Upgrade'
}

export type ProductStatsMeta = {
  __typename?: 'ProductStatsMeta';
  prevParticipantCount?: Maybe<Scalars['Float']['output']>;
  ratingOverride?: Maybe<Scalars['Float']['output']>;
};

export enum ProductStatus {
  Declined = 'Declined',
  Draft = 'Draft',
  OnCheck = 'OnCheck',
  Published = 'Published',
  ReadyToPublish = 'ReadyToPublish'
}

export enum ProductType {
  Course = 'Course',
  Digital = 'Digital',
  School = 'School'
}

export type ProfileAvatar = {
  __typename?: 'ProfileAvatar';
  id: Scalars['Float']['output'];
  maximum?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export type ProfileAvatarInput = {
  maximum: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  small: Scalars['String']['input'];
};

export type ProfileContact = {
  __typename?: 'ProfileContact';
  email?: Maybe<Scalars['String']['output']>;
  messengerUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProfileContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  messengerUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileEntity = {
  __typename?: 'ProfileEntity';
  avatar: ProfileAvatar;
  bdate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Optional public contact info */
  contact: ProfileContact;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  emojiTitle?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  fullNameShort: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  official: Scalars['Boolean']['output'];
  originalNames: ProfileOriginalNames;
  role: ProfileRole;
  school: ProfileSchool;
  sex: UserSexType;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleState: ProfileTitleState;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum ProfileException {
  NotFound = 'NotFound'
}

export type ProfileOriginalNames = {
  __typename?: 'ProfileOriginalNames';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum ProfileRole {
  Parent = 'Parent',
  Student = 'Student',
  Tutor = 'Tutor'
}

export type ProfileSchool = {
  __typename?: 'ProfileSchool';
  city?: Maybe<Scalars['Float']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  speciality?: Maybe<Scalars['String']['output']>;
};

export type ProfileTitleState = {
  __typename?: 'ProfileTitleState';
  achievementEmojiTitle?: Maybe<Scalars['String']['output']>;
  achievementTitle?: Maybe<Scalars['String']['output']>;
  locationEmojiTitle?: Maybe<Scalars['String']['output']>;
  locationTitle?: Maybe<Scalars['String']['output']>;
  manualEmojiTitle?: Maybe<Scalars['String']['output']>;
  manualExpiredAt?: Maybe<Scalars['Date']['output']>;
  manualNextEmojiTitle?: Maybe<Scalars['String']['output']>;
  manualNextTitle?: Maybe<Scalars['String']['output']>;
  manualTitle?: Maybe<Scalars['String']['output']>;
};

export enum PromotionException {
  AlreadyInvited = 'AlreadyInvited',
  NotFound = 'NotFound',
  SelfDenied = 'SelfDenied',
  Timeout = 'Timeout'
}

export type PromotionInviteEntity = {
  __typename?: 'PromotionInviteEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  inviter: UserEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PromotionPublicationType {
  VkStories = 'VkStories',
  VkWallPost = 'VkWallPost'
}

export type ProviderCommissionByOrganizationType = {
  __typename?: 'ProviderCommissionByOrganizationType';
  organization?: Maybe<ProviderCommissionPayoutItem>;
  selfEmployed?: Maybe<ProviderCommissionPayoutItem>;
};

export type ProviderCommissionPaymentItem = {
  __typename?: 'ProviderCommissionPaymentItem';
  minAmount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
};

export type ProviderCommissionPayoutItem = {
  __typename?: 'ProviderCommissionPayoutItem';
  fixedCost?: Maybe<Scalars['Float']['output']>;
  minAmount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
};

export type ProviderPreferencePayment = {
  __typename?: 'ProviderPreferencePayment';
  bgColor?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type PublishLaunchProductInput = {
  status: ProductLaunchStatus;
};

export type Query = {
  __typename?: 'Query';
  achievementFindMany: ListAchievementOutput;
  acquiringFindManyActive: ListAcquiringOutput;
  articleFindMany: ListArticleOutput;
  articleFindOne: ArticleEntity;
  /** Auth: USER */
  cartFindOne?: Maybe<CartEntity>;
  cartFindOneSharedByUuid: CartEntity;
  /** Auth: USER */
  chatFindMany: ListChatOutput;
  /** Auth: USER */
  chatFindOne: ChatEntity;
  /** Auth: USER */
  chatFindOnePersonal?: Maybe<ChatEntity>;
  /** Auth: USER */
  chatGetUnreadCount: Scalars['Int']['output'];
  /** Auth: USER */
  chatMemberFindMany: ListMemberChatOutput;
  /** Auth: USER */
  chatMemberFindOne: ChatMemberEntity;
  /** Auth: USER */
  chatMessageFindMany: ListMessageChatOutput;
  /** Auth: USER */
  chatMessageFindOne: ChatMessageEntity;
  companyGetApiVersion: Scalars['String']['output'];
  companyGetBankInfoByBic?: Maybe<BankInfoCompanyOutput>;
  companyGetOrganizationInfoByInn?: Maybe<OrganizationInfoCompanyOutput>;
  configGetManyByKeys?: Maybe<MergerDbConfigOutput>;
  configGetOneByKey?: Maybe<Scalars['JSONObject']['output']>;
  configGetServerTime: Scalars['Date']['output'];
  contentCategoryFindMany: ListCategoryContentOutput;
  /** Auth: USER */
  courseCheckLaunchPublication: CoursePublicationCheck;
  courseCountByType: CourseCountByType;
  courseFindMany: ListCourseOutput;
  /** Exceptions: NotFound, NotPublished */
  courseFindOne: CourseEntity;
  /** Auth: USER */
  courseLessonFindMany: ListLessonCourseOutput;
  /** Auth: USER

Exceptions: NotPublished */
  courseLessonFindOne: CourseLessonEntity;
  courseLessonFindOneDemo: CourseLessonEntity;
  courseLessonFindOnePreview: CourseLessonPreview;
  courseLessonGetProgressStatus: CourseProgressLessonStatus;
  /** Auth: USER */
  courseLessonMetaFindOne?: Maybe<CourseLessonMetaEntity>;
  /** Auth: USER */
  courseLessonPracticeAttemptFindMany: ListLessonPracticeAttemptCourseOutput;
  courseLessonPracticeAttemptFindOneByUuid: CourseLessonPracticeAttemptEntity;
  /** Auth: USER */
  courseLessonPracticeFindOne?: Maybe<CourseLessonPracticeEntity>;
  /** Auth: USER

Exceptions: InvalidAlias, AliasAlreadyBusy */
  courseManageCheckCourseAlias: CheckAliasCourseOutput;
  /** Auth: USER */
  courseProgressFindManyCurrent: ListProgressCourseOutput;
  /** Rate: Count: 100 • Interval: 86400 • Ignore: no • Freeze: no

Exceptions: NotFoundByCode */
  discountCheckCode: DiscountEntity;
  /** Auth: USER, UserIsAdmin, AdminCoursePublish */
  discountManageFindMany: ListDiscountOutput;
  /** Auth: USER, UserIsAdmin, AdminCoursePublish */
  discountManageFindOne: DiscountEntity;
  /** Auth: USER */
  educationPreferenceGetExamsReminderState: Array<EducationSubject>;
  educationPreferenceGetUserSubjects: Array<SubjectEntity>;
  /** Auth: USER */
  friendshipFindMany: ListUserFriendshipOutput;
  /** Auth: USER */
  friendshipFindManyCommon: ListUserFriendshipOutput;
  /** Auth: USER */
  friendshipFindManyPossible: ListUserFriendshipOutput;
  /** Auth: USER */
  friendshipGetFriendshipStatus?: Maybe<FriendshipEntity>;
  /** Auth: USER */
  groupFindMany: ListGroupOutput;
  /** Auth: USER */
  groupFindOne: GroupEntity;
  /** Auth: USER */
  groupMemberFindMany: ListMemberGroupOutput;
  /** Auth: USER, SellerSales */
  invoiceAnalyticsCountByInterval: CountAnalyticsOutput;
  /** Auth: USER, SellerSales */
  invoiceAnalyticsSumByInterval: SumAnalyticsOutput;
  invoiceCalculateCartTotal: CalculateCartTotalInvoice;
  invoiceFindOneByUuid: InvoiceEntity;
  /** Auth: USER, SellerSales */
  invoiceManageFindMany: ListInvoiceOutput;
  /** Auth: USER, SellerSales */
  invoiceManageFindOne: InvoiceEntity;
  /** Auth: USER */
  notificationCountByStatus: Scalars['Int']['output'];
  /** Auth: USER */
  notificationFindMany: ListNotificationOutput;
  /** Auth: USER */
  notificationFindOne: NotificationEntity;
  pageFindMany: ListPageOutput;
  /** Auth: USER */
  passwordFindOneLast?: Maybe<PasswordEntity>;
  /** Auth: USER, SellerSales */
  paymentManageFindMany: ListPaymentOutput;
  paymentProviderFindMany: ListProviderPaymentOutput;
  paymentProviderFindOneActiveByType: PaymentProviderEntity;
  /** Auth: USER */
  payoutCommissionFindOneCurrent?: Maybe<PayoutCommissionEntity>;
  /** Auth: USER */
  payoutOperationCalculateBeforePayout: TransferDetailsOnPayoutOutput;
  /** Auth: USER */
  payoutOperationCountByFilter: Scalars['Int']['output'];
  /** Auth: USER */
  payoutOperationFindMany: ListOperationPayoutOutput;
  /** Auth: USER */
  payoutOperationFindOne: PayoutOperationEntity;
  /** Auth: USER */
  payoutOperationSumAmountByFilter: Scalars['Float']['output'];
  /** Auth: USER */
  payoutRequisiteFindOneActive?: Maybe<PayoutRequisiteEntity>;
  privateArg?: Maybe<Scalars['String']['output']>;
  privateGetSelfUserOutput: GetSelfUserOutput;
  privateLoginAuthOutput: LoginAuthOutput;
  privateLogoutAuthOutput: LogoutAuthOutput;
  privateRecoverPasswordOutput: RecoverPasswordOutput;
  privateServiceLoginAuthOutput: ServiceLoginAuthOutput;
  privateSignupAuthOutput: SignupAuthOutput;
  privateUserOnlineSocketOutput: UserOnlineSocketOutput;
  /** Auth: USER */
  productAccessFindMany: ListAccessProductOutput;
  /** Auth: USER */
  productAccessFindOne: ProductAccessEntity;
  productFaqFindMany: ListFaqProductOutput;
  /** Auth: USER */
  productFaqFindOne: ProductFaqEntity;
  /** Auth: USER */
  productFeedbackCanSend: Scalars['Boolean']['output'];
  productFeedbackFindMany: ListFeedbackProductOutput;
  /** Auth: USER */
  productFeedbackFindOne: ProductFeedbackEntity;
  /** Auth: USER */
  productFeedbackFindOneByUserAndProduct?: Maybe<ProductFeedbackEntity>;
  /** Auth: USER */
  productFindMany: ListProductOutput;
  /** Auth: USER */
  productLaunchFindMany: ListLaunchProductOutput;
  /** Auth: USER */
  productLaunchFindOne: ProductLaunchEntity;
  /** Auth: USER */
  productLaunchFindOneCrossed?: Maybe<ProductLaunchEntity>;
  /** Auth: USER */
  productPriceFindMany: ListPriceProductOutput;
  /** Auth: USER */
  productPriceFindOne: ProductPriceEntity;
  profileFindMany: ListProfileOutput;
  /** Exceptions: NotFound */
  profileFindOne: ProfileEntity;
  /** Auth: USER */
  promotionCountInvited: Scalars['Int']['output'];
  /** Auth: USER */
  schoolAcquiringFindMany: ListAcquiringManageOutput;
  /** Auth: USER */
  schoolAcquiringFindOne: AcquiringManage;
  schoolFindOne: SchoolEntity;
  schoolFindOneByDomain?: Maybe<SchoolEntity>;
  /** Auth: USER

Exceptions: InvalidAlias, AliasAlreadyBusy */
  schoolManageCheckDomain: CheckDomainSchoolOutput;
  /** Auth: USER */
  schoolManageFindManyMine: Array<SchoolEntity>;
  /** Auth: USER */
  schoolManageGetStateByKey?: Maybe<Scalars['JSONObject']['output']>;
  schoolPriceFindManyActive: Array<ProductPriceEntity>;
  /** Auth: USER */
  schoolUserFindMany: ListUserOutput;
  /** Auth: USER */
  schoolUserFindOne: UserEntity;
  /** Auth: USER */
  schoolUserPasswordFindOneLastPlain?: Maybe<Scalars['String']['output']>;
  /** Auth: USER */
  schoolUserSessionFindMany: ListSessionOutput;
  /** Auth: USER */
  sellerBalanceCurrent: SellerCurrentBalanceOutput;
  /** Auth: USER */
  sellerBalanceOperationFindMany: ListBalanceOperationSellerOutput;
  /** Auth: USER */
  sellerBalanceOperationFindOne: SellerBalanceOperationEntity;
  /** Auth: USER, UserIsAdmin, AdminSellerVerify */
  sellerBecomeRequestFindMany: ListRequestSellerOutput;
  /** Auth: USER */
  sellerBecomeRequestFindOne: SellerBecomeRequestEntity;
  /** Auth: USER */
  sellerBecomeRequestFindOneByCurrentUser?: Maybe<SellerBecomeRequestEntity>;
  /** Auth: USER */
  sellerCurrentUserSeller?: Maybe<SellerEntity>;
  /** Auth: USER, UserIsAdmin */
  sellerFindMany: ListSellerOutput;
  /** Auth: USER */
  sellerFindManyByUser: ListSellerOutput;
  /** Auth: USER */
  sellerManagerFindMany: ListManagerSellerOutput;
  /** Auth: USER */
  sellerManagerFindOne: SellerManagerEntity;
  /** Auth: USER */
  sellerManagerFindOneByUser?: Maybe<SellerManagerEntity>;
  /** Auth: USER */
  sellerOrganizationDocumentFindMany: ListOrganizationDocumentsSellerOutput;
  /** Auth: USER */
  sellerOrganizationDocumentFindOne: SellerOrganizationDocumentEntity;
  /** Auth: USER */
  sellerProductManagerFindMany: ListProductManagerSellerOutput;
  /** Auth: USER */
  sellerProductManagerFindOne: SellerProductManagerEntity;
  /** Auth: USER */
  sellerProductManagerFindOneByUserAndProduct?: Maybe<SellerProductManagerEntity>;
  /** Auth: USER */
  sessionGetActiveSessions: Array<SessionEntity>;
  smsProviderGetAvailableCountryCodes: Array<Scalars['String']['output']>;
  storiesFindMany: ListStoriesOutput;
  storiesFindOne: StoriesEntity;
  /** Auth: USER */
  subjectCategoryFindMany: ListCategorySubjectOutput;
  subjectCategorySelectionFindMany: ListCategorySelectionSubjectOutput;
  subjectCountOfMembers: Scalars['Int']['output'];
  subjectFindMany: ListSubjectOutput;
  subjectFindManyMembers: ListMemberSubjectOutput;
  subjectFindOne: SubjectEntity;
  supportFaqFindMany: ListFaqSupportOutput;
  supportFaqFindManyDistinctByCategory: Array<SupportFaqEntity>;
  /** Auth: USER */
  taskAnswerFindOne?: Maybe<TaskAnswerEntity>;
  taskAnswerFindOneByUuid?: Maybe<TaskAnswerEntity>;
  taskFindMany: ListTaskOutput;
  taskFindOne?: Maybe<TaskEntity>;
  /** Auth: USER */
  taskGetSubjectCategoryStatistic: Array<TaskSubjectStatistic>;
  tournamentCountByFilter: Scalars['Int']['output'];
  tournamentFindMany: ListTournamentOutput;
  tournamentFindOne: TournamentEntity;
  /** Auth: USER */
  tournamentLobbyFindManyInvitations: ListInvitationTournamentOutput;
  tournamentLobbyFindManyMembers: ListMemberTournamentOutput;
  tournamentLobbyFindManyMessages: ListMessageTournamentOutput;
  /** Auth: USER */
  tournamentResultFindMany: ListResultTournamentOutput;
  /** Auth: USER */
  tournamentResultFindOne?: Maybe<TournamentResultEntity>;
  userCountUsersOnline: Scalars['Int']['output'];
  /** Auth: USER, UserIsAdmin */
  userFindMany: ListUserOutput;
  /** Auth: USER */
  userGetMyInfo: UserEntity;
  /** Auth: USER */
  userSettingsCheckDomain: CheckDomainUserOutput;
  /** Auth: USER */
  userStateGetByKey?: Maybe<Scalars['JSONObject']['output']>;
  /** Auth: USER */
  walletGetBalance: Scalars['Float']['output'];
  /** Auth: USER */
  walletGetMonthlyExpense: Scalars['Float']['output'];
  /** Auth: USER */
  walletGetMonthlyIncome: Scalars['Float']['output'];
  /** Auth: USER, UserIsAdmin */
  walletManageFindManyOperations: ListWalletOperationOutput;
  /** Auth: USER */
  walletOperationFindMany: ListWalletOperationOutput;
  /** Auth: USER */
  walletOperationFindOne: WalletOperationEntity;
  /** Auth: USER */
  webhookEndpointFindMany: ListEndpointWebhookOutput;
  /** Auth: USER */
  webhookEndpointFindOne: WebhookEndpointEntity;
};


export type QueryAchievementFindManyArgs = {
  filter: FilterAchievementInput;
  list: ListInput;
};


export type QueryAcquiringFindManyActiveArgs = {
  filter: FilterAcquiringInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryArticleFindManyArgs = {
  filter: FilterArticleInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryArticleFindOneArgs = {
  articleId: Scalars['Int']['input'];
};


export type QueryCartFindOneSharedByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryChatFindManyArgs = {
  cursor?: InputMaybe<CursorInput>;
  filter: FilterChatInput;
  list: ListInput;
  sort?: InputMaybe<SortChatInput>;
};


export type QueryChatFindOneArgs = {
  chatId: Scalars['Int']['input'];
};


export type QueryChatFindOnePersonalArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryChatGetUnreadCountArgs = {
  types?: InputMaybe<Array<ChatType>>;
};


export type QueryChatMemberFindManyArgs = {
  chatId: Scalars['Int']['input'];
  filter: FilterMemberChatInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryChatMemberFindOneArgs = {
  chatId: Scalars['Int']['input'];
  chatMemberId: Scalars['Int']['input'];
};


export type QueryChatMessageFindManyArgs = {
  chatId: Scalars['Int']['input'];
  cursor?: InputMaybe<CursorInput>;
  filter: FilterMessageChatInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryChatMessageFindOneArgs = {
  chatId: Scalars['Int']['input'];
  messageId: Scalars['Int']['input'];
};


export type QueryCompanyGetBankInfoByBicArgs = {
  bic: Scalars['String']['input'];
};


export type QueryCompanyGetOrganizationInfoByInnArgs = {
  inn: Scalars['String']['input'];
};


export type QueryConfigGetManyByKeysArgs = {
  keys: Array<DbConfigKey>;
  version: Scalars['String']['input'];
};


export type QueryConfigGetOneByKeyArgs = {
  key: DbConfigKey;
  version: Scalars['String']['input'];
};


export type QueryContentCategoryFindManyArgs = {
  filter: FilterCategoryContentInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryCourseCheckLaunchPublicationArgs = {
  courseId: Scalars['Int']['input'];
  launchId: Scalars['Int']['input'];
};


export type QueryCourseCountByTypeArgs = {
  filter: FilterCourseInput;
  mode: CountByTypeMode;
};


export type QueryCourseFindManyArgs = {
  filter: FilterCourseInput;
  list: ListInput;
  sort?: InputMaybe<SortCourseInput>;
};


export type QueryCourseFindOneArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCourseLessonFindManyArgs = {
  courseId: Scalars['Int']['input'];
  filter: FilterLessonCourseInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryCourseLessonFindOneArgs = {
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseLessonFindOneDemoArgs = {
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseLessonFindOnePreviewArgs = {
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseLessonGetProgressStatusArgs = {
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseLessonMetaFindOneArgs = {
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseLessonPracticeAttemptFindManyArgs = {
  filter: FilterLessonPracticeAttemptCourseInput;
  list: ListInput;
  sort?: InputMaybe<SortLessonPracticeAttemptCourseInput>;
};


export type QueryCourseLessonPracticeAttemptFindOneByUuidArgs = {
  attemptUuid: Scalars['String']['input'];
};


export type QueryCourseLessonPracticeFindOneArgs = {
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};


export type QueryCourseManageCheckCourseAliasArgs = {
  alias: Scalars['String']['input'];
  courseId: Scalars['Int']['input'];
};


export type QueryCourseProgressFindManyCurrentArgs = {
  filter: FilterProgressCourseInput;
  list: ListInput;
  sort?: InputMaybe<SortProgressCourseInput>;
};


export type QueryDiscountCheckCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryDiscountManageFindManyArgs = {
  filter: FilterDiscountInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryDiscountManageFindOneArgs = {
  discountId: Scalars['Int']['input'];
};


export type QueryEducationPreferenceGetUserSubjectsArgs = {
  relUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFriendshipFindManyArgs = {
  filter: FilterFriendshipInput;
  list: ListInput;
  relUserId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryFriendshipFindManyCommonArgs = {
  list: ListInput;
  relUserId: Scalars['Int']['input'];
};


export type QueryFriendshipFindManyPossibleArgs = {
  list: ListInput;
};


export type QueryFriendshipGetFriendshipStatusArgs = {
  relUserId: Scalars['Int']['input'];
};


export type QueryGroupFindManyArgs = {
  filter: FilterGroupInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryGroupFindOneArgs = {
  groupId: Scalars['Int']['input'];
};


export type QueryGroupMemberFindManyArgs = {
  filter: FilterMemberGroupInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryInvoiceAnalyticsCountByIntervalArgs = {
  filter: AnalyticsFilterInvoiceInput;
};


export type QueryInvoiceAnalyticsSumByIntervalArgs = {
  filter: AnalyticsFilterInvoiceInput;
};


export type QueryInvoiceCalculateCartTotalArgs = {
  cart: CalculateCartTotalInvoiceInput;
};


export type QueryInvoiceFindOneByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryInvoiceManageFindManyArgs = {
  filter: FilterInvoiceInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryInvoiceManageFindOneArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryNotificationCountByStatusArgs = {
  notificationStatus: NotificationStatus;
};


export type QueryNotificationFindManyArgs = {
  filter: FilterNotificationInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryNotificationFindOneArgs = {
  notificationId: Scalars['Int']['input'];
};


export type QueryPageFindManyArgs = {
  filter: FilterPageInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryPaymentManageFindManyArgs = {
  filter: FilterPaymentInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryPaymentProviderFindManyArgs = {
  filter: FilterProviderPaymentInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryPaymentProviderFindOneActiveByTypeArgs = {
  paymentProviderType: PaymentProviderType;
};


export type QueryPayoutOperationCalculateBeforePayoutArgs = {
  operation: CreateOperationPayoutInput;
};


export type QueryPayoutOperationCountByFilterArgs = {
  filter: FilterOperationPayoutInput;
};


export type QueryPayoutOperationFindManyArgs = {
  filter: FilterOperationPayoutInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryPayoutOperationFindOneArgs = {
  payoutId: Scalars['Int']['input'];
};


export type QueryPayoutOperationSumAmountByFilterArgs = {
  filter: FilterOperationPayoutInput;
};


export type QueryPrivateArgArgs = {
  ConnectCallbackTelegramInput: ConnectCallbackTelegramInput;
  DtoInput: DtoInput;
  GroupContentLimitationLessonItemInput: GroupContentLimitationLessonItemInput;
  SetOtpAuthInput: SetOtpAuthInput;
  UpdatePasswordInput: UpdatePasswordInput;
  UploadFilesStorageInput: UploadFilesStorageInput;
  VkIdLoginAuthInput: VkIdLoginAuthInput;
};


export type QueryProductAccessFindManyArgs = {
  filter: FilterAccessProductInput;
  list: ListInput;
  sort?: InputMaybe<SortAccessProductInput>;
};


export type QueryProductAccessFindOneArgs = {
  accessId: Scalars['Int']['input'];
};


export type QueryProductFaqFindManyArgs = {
  filter: FilterFaqProductInput;
  list: ListInput;
  sort?: InputMaybe<SortFaqProductInput>;
};


export type QueryProductFaqFindOneArgs = {
  faqId: Scalars['Int']['input'];
};


export type QueryProductFeedbackCanSendArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductFeedbackFindManyArgs = {
  filter: FilterFeedbackProductInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryProductFeedbackFindOneArgs = {
  feedbackId: Scalars['Int']['input'];
};


export type QueryProductFeedbackFindOneByUserAndProductArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductFindManyArgs = {
  filter: FilterProductInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryProductLaunchFindManyArgs = {
  filter: FilterLaunchProductInput;
  list: ListInput;
  sort?: InputMaybe<SortLaunchProductInput>;
};


export type QueryProductLaunchFindOneArgs = {
  launchId: Scalars['Int']['input'];
};


export type QueryProductLaunchFindOneCrossedArgs = {
  launch: CheckLaunchProductInput;
  launchId: Scalars['Int']['input'];
};


export type QueryProductPriceFindManyArgs = {
  filter: FilterPriceProductInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryProductPriceFindOneArgs = {
  priceId: Scalars['Int']['input'];
};


export type QueryProfileFindManyArgs = {
  filter: FilterProfileInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryProfileFindOneArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromotionCountInvitedArgs = {
  relUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchoolAcquiringFindManyArgs = {
  filter: FilterAcquiringInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySchoolAcquiringFindOneArgs = {
  acquiringId: Scalars['Int']['input'];
};


export type QuerySchoolFindOneArgs = {
  schoolId: Scalars['Int']['input'];
};


export type QuerySchoolFindOneByDomainArgs = {
  domain: Scalars['String']['input'];
  withPrevDomain?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySchoolManageCheckDomainArgs = {
  domain: Scalars['String']['input'];
  domainType: SchoolDomainType;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchoolManageGetStateByKeyArgs = {
  key: SchoolStateKey;
  schoolId: Scalars['Int']['input'];
};


export type QuerySchoolPriceFindManyActiveArgs = {
  currency: ProductCurrency;
};


export type QuerySchoolUserFindManyArgs = {
  filter: FilterUserInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySchoolUserFindOneArgs = {
  userId: Scalars['Int']['input'];
};


export type QuerySchoolUserPasswordFindOneLastPlainArgs = {
  userId: Scalars['Int']['input'];
};


export type QuerySchoolUserSessionFindManyArgs = {
  filter: FilterSessionInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerBalanceOperationFindManyArgs = {
  filter: FilterBalanceOperationSellerInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerBalanceOperationFindOneArgs = {
  operationId: Scalars['Int']['input'];
};


export type QuerySellerBecomeRequestFindManyArgs = {
  filter: FilterRequestSellerInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerBecomeRequestFindOneArgs = {
  requestId: Scalars['Int']['input'];
};


export type QuerySellerFindManyArgs = {
  filter: FilterSellerInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerFindManyByUserArgs = {
  list: ListInput;
};


export type QuerySellerManagerFindManyArgs = {
  filter: FilterManagerSellerInput;
  list: ListInput;
  sort?: InputMaybe<SortManagerSellerInput>;
};


export type QuerySellerManagerFindOneArgs = {
  managerId: Scalars['Int']['input'];
};


export type QuerySellerManagerFindOneByUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QuerySellerOrganizationDocumentFindManyArgs = {
  filter: FilterOrganizationDocumentSellerInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerOrganizationDocumentFindOneArgs = {
  documentId: Scalars['Int']['input'];
};


export type QuerySellerProductManagerFindManyArgs = {
  filter: FilterProductManagerSellerInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySellerProductManagerFindOneArgs = {
  productManagerId: Scalars['Int']['input'];
};


export type QuerySellerProductManagerFindOneByUserAndProductArgs = {
  productId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryStoriesFindManyArgs = {
  filter: FilterStoriesInput;
  list: ListInput;
  sort?: InputMaybe<SortStoriesInput>;
};


export type QueryStoriesFindOneArgs = {
  storiesId: Scalars['Int']['input'];
};


export type QuerySubjectCategoryFindManyArgs = {
  filter: FilterCategorySubjectInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySubjectCategorySelectionFindManyArgs = {
  filter: FilterCategorySelectionSubjectInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySubjectCountOfMembersArgs = {
  subject: EducationSubject;
};


export type QuerySubjectFindManyArgs = {
  filter: FilterSubjectInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySubjectFindManyMembersArgs = {
  filter: FilterMemberSubjectInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QuerySubjectFindOneArgs = {
  subject: EducationSubject;
};


export type QuerySupportFaqFindManyArgs = {
  filter: FilterFaqSupportInput;
  list: ListInput;
  sort?: InputMaybe<SortFaqSupportInput>;
};


export type QuerySupportFaqFindManyDistinctByCategoryArgs = {
  filter: FilterFaqSupportInput;
};


export type QueryTaskAnswerFindOneArgs = {
  taskAnswerId: Scalars['Int']['input'];
};


export type QueryTaskAnswerFindOneByUuidArgs = {
  taskAnswerUuid: Scalars['String']['input'];
};


export type QueryTaskFindManyArgs = {
  filter: FilterTaskInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryTaskFindOneArgs = {
  taskUuid: Scalars['String']['input'];
};


export type QueryTaskGetSubjectCategoryStatisticArgs = {
  subject: EducationSubject;
};


export type QueryTournamentCountByFilterArgs = {
  filter: FilterTournamentInput;
};


export type QueryTournamentFindManyArgs = {
  filter: FilterTournamentInput;
  list: ListInput;
  sort?: InputMaybe<SortTournamentInput>;
};


export type QueryTournamentFindOneArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentLobbyFindManyInvitationsArgs = {
  list: ListInput;
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentLobbyFindManyMembersArgs = {
  filter: FilterMemberTournamentInput;
  list: ListInput;
  sort?: InputMaybe<SortMemberTournamentInput>;
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentLobbyFindManyMessagesArgs = {
  list: ListInput;
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentResultFindManyArgs = {
  list: ListInput;
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentResultFindOneArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryUserFindManyArgs = {
  filter: FilterUserInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryUserSettingsCheckDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryUserStateGetByKeyArgs = {
  key: UserStateKey;
};


export type QueryWalletGetBalanceArgs = {
  relUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWalletManageFindManyOperationsArgs = {
  filter: FilterWalletInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryWalletOperationFindManyArgs = {
  filter: FilterWalletInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryWalletOperationFindOneArgs = {
  operationId: Scalars['Int']['input'];
};


export type QueryWebhookEndpointFindManyArgs = {
  filter: FilterEndpointWebhookInput;
  list: ListInput;
  sort?: InputMaybe<BaseSortInput>;
};


export type QueryWebhookEndpointFindOneArgs = {
  endpointId: Scalars['Int']['input'];
};

export enum RateException {
  Rate = 'Rate'
}

export type RecoverPasswordOutput = {
  __typename?: 'RecoverPasswordOutput';
  login: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
};

export type RequestUserDeletionInput = {
  reason: Scalars['String']['input'];
};

export type ReviewLaunchProductInput = {
  approves: Array<ProductApprove>;
  message?: InputMaybe<Scalars['String']['input']>;
  status: ProductLaunchStatus;
};

export type SaveAnswerTaskInput = {
  detailed?: InputMaybe<TaskUserDetailedAnswerInput>;
  quiz?: InputMaybe<Scalars['JSONObject']['input']>;
  taskUuid: Scalars['String']['input'];
};

export enum SchoolAccessType {
  Private = 'Private',
  Public = 'Public'
}

export type SchoolAddress = {
  __typename?: 'SchoolAddress';
  address: Scalars['String']['output'];
  locationLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SchoolAddressItemInput = {
  address: Scalars['String']['input'];
  locationLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum SchoolBlockMode {
  Color = 'Color',
  Image = 'Image',
  Text = 'Text'
}

export type SchoolBlockSettings = {
  __typename?: 'SchoolBlockSettings';
  catalog?: Maybe<SchoolCatalogBlock>;
  footer?: Maybe<Array<SchoolFooterBlock>>;
  headerMenu?: Maybe<Array<SchoolHeaderMenuBlock>>;
  leftMenu?: Maybe<Array<SchoolLeftMenuBlock>>;
  logo?: Maybe<SchoolLogoBlock>;
  meta?: Maybe<SchoolMetaBlock>;
  mobileMenu?: Maybe<Array<SchoolMobileMenuBlock>>;
};

export type SchoolBlockSettingsInput = {
  catalog?: InputMaybe<SchoolCatalogBlockInput>;
  footer?: InputMaybe<Array<SchoolFooterBlockInput>>;
  headerMenu?: InputMaybe<Array<SchoolHeaderMenuBlockInput>>;
  leftMenu?: InputMaybe<Array<SchoolLeftMenuBlockInput>>;
  logo?: InputMaybe<SchoolLogoBlockInput>;
  meta?: InputMaybe<SchoolMetaBlockInput>;
  mobileMenu?: InputMaybe<Array<SchoolMobileMenuBlockInput>>;
};

export type SchoolCatalogBlock = {
  __typename?: 'SchoolCatalogBlock';
  color?: Maybe<Scalars['String']['output']>;
  mode: SchoolBlockMode;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SchoolCatalogBlockInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  mode: SchoolBlockMode;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolConfig = {
  __typename?: 'SchoolConfig';
  /** Force redirect from base domain to custom */
  forceRedirectToCustomDomain: Scalars['Boolean']['output'];
};

export type SchoolConfigInput = {
  forceRedirectToCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchoolContact = {
  __typename?: 'SchoolContact';
  email?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<SchoolContactRole>;
};

export type SchoolContactItemInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<SchoolContactRole>;
};

export enum SchoolContactRole {
  Director = 'Director',
  Manager = 'Manager',
  Support = 'Support'
}

export type SchoolCustomCode = {
  __typename?: 'SchoolCustomCode';
  css?: Maybe<Scalars['String']['output']>;
  js?: Maybe<Scalars['String']['output']>;
};

export type SchoolCustomCodeInput = {
  css?: InputMaybe<Scalars['String']['input']>;
  js?: InputMaybe<Scalars['String']['input']>;
};

export enum SchoolDomainType {
  Base = 'Base',
  Custom = 'Custom'
}

export type SchoolEntity = {
  __typename?: 'SchoolEntity';
  access: ProductAccessEntity;
  accessType: SchoolAccessType;
  active: Scalars['Boolean']['output'];
  addresses: Array<SchoolAddress>;
  baseDomain: Scalars['String']['output'];
  blockSettings: SchoolBlockSettings;
  config: SchoolConfig;
  contacts: Array<SchoolContact>;
  createdAt: Scalars['Date']['output'];
  customCode: SchoolCustomCode;
  customDomain?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  domainType: SchoolDomainType;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platformConfig: Scalars['JSONObject']['output'];
  preferenceSettings: SchoolPreferenceSettings;
  seller: SellerEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SchoolException {
  DemoPriceNotFound = 'DemoPriceNotFound',
  DomainIsBusy = 'DomainIsBusy',
  DomainIsInBlockList = 'DomainIsInBlockList',
  DomainIsInvalid = 'DomainIsInvalid',
  NotActiveOrBlocked = 'NotActiveOrBlocked'
}

export type SchoolFeatures = {
  __typename?: 'SchoolFeatures';
  activeProducts: Scalars['Float']['output'];
  articlesAndBlog: Scalars['Boolean']['output'];
  autoFunnels: Scalars['Boolean']['output'];
  autoTests: Scalars['Boolean']['output'];
  calendar: Scalars['Boolean']['output'];
  course: Scalars['Boolean']['output'];
  customCode: Scalars['Boolean']['output'];
  customDesign: Scalars['Boolean']['output'];
  customDomain: Scalars['Boolean']['output'];
  educationAnalytics: Scalars['Boolean']['output'];
  financialAnalytics: Scalars['Boolean']['output'];
  homework: Scalars['Boolean']['output'];
  integrations: Scalars['Boolean']['output'];
  marketingTools: Scalars['Boolean']['output'];
  maxManagers: Scalars['Float']['output'];
  maxUsers: Scalars['Float']['output'];
  messenger: Scalars['Boolean']['output'];
  paymentProcessing: Scalars['Boolean']['output'];
  personalLesson: Scalars['Boolean']['output'];
  personalManager: Scalars['Boolean']['output'];
  storageSize: Scalars['Float']['output'];
  storiesAndReels: Scalars['Boolean']['output'];
  support: Scalars['Boolean']['output'];
  webinar: Scalars['Boolean']['output'];
};

export type SchoolFooterBlock = {
  __typename?: 'SchoolFooterBlock';
  items: Array<SchoolFooterBlockItem>;
  title: Scalars['String']['output'];
};

export type SchoolFooterBlockInput = {
  items: Array<SchoolFooterBlockItemInput>;
  title: Scalars['String']['input'];
};

export type SchoolFooterBlockItem = {
  __typename?: 'SchoolFooterBlockItem';
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SchoolFooterBlockItemInput = {
  link: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SchoolHeaderBlockItem = {
  __typename?: 'SchoolHeaderBlockItem';
  icon?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SchoolHeaderBlockItemInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SchoolHeaderMenuBlock = {
  __typename?: 'SchoolHeaderMenuBlock';
  items?: Maybe<Array<SchoolHeaderBlockItem>>;
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SchoolHeaderMenuBlockInput = {
  items?: InputMaybe<Array<SchoolHeaderBlockItemInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SchoolLeftMenuBlock = {
  __typename?: 'SchoolLeftMenuBlock';
  icon: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchoolLeftMenuBlockInput = {
  icon: Scalars['String']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SchoolLogoBlock = {
  __typename?: 'SchoolLogoBlock';
  mode: SchoolBlockMode;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SchoolLogoBlockInput = {
  mode: SchoolBlockMode;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolMetaBlock = {
  __typename?: 'SchoolMetaBlock';
  footerCaption?: Maybe<Scalars['String']['output']>;
};

export type SchoolMetaBlockInput = {
  footerCaption?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolMobileMenuBlock = {
  __typename?: 'SchoolMobileMenuBlock';
  icon: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchoolMobileMenuBlockInput = {
  icon: Scalars['String']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SchoolPreferenceSettings = {
  __typename?: 'SchoolPreferenceSettings';
  colorVariables?: Maybe<AppSchemeData>;
  scheme?: Maybe<SchoolSchemePreference>;
};

export type SchoolPreferenceSettingsInput = {
  colorVariables?: InputMaybe<AppSchemeInput>;
  scheme?: InputMaybe<SchoolSchemePreferenceInput>;
};

export type SchoolSchemePreference = {
  __typename?: 'SchoolSchemePreference';
  available?: Maybe<AppColorScheme>;
  default?: Maybe<AppColorScheme>;
};

export type SchoolSchemePreferenceInput = {
  available?: InputMaybe<AppColorScheme>;
  default?: InputMaybe<AppColorScheme>;
};

export enum SchoolStateKey {
  MaxLoginSessionsCount = 'MaxLoginSessionsCount',
  UserLoginTgBotToken = 'UserLoginTgBotToken'
}

export type SelfEmployedNameOrganizationInterface = {
  __typename?: 'SelfEmployedNameOrganizationInterface';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SellerBalanceOperationEntity = {
  __typename?: 'SellerBalanceOperationEntity';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  currency?: Maybe<ProductCurrency>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoiceProductPayouts: Array<InvoiceProductPayoutEntity>;
  payoutOperations: Array<PayoutOperationEntity>;
  source: SellerBalanceSource;
  status: SellerBalanceStatus;
  type: SellerBalanceType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export enum SellerBalanceSource {
  BalanceDownPayout = 'BalanceDownPayout',
  BalanceDownRefund = 'BalanceDownRefund',
  BalanceUpPayment = 'BalanceUpPayment',
  BalanceUpScheduled = 'BalanceUpScheduled'
}

export enum SellerBalanceStatus {
  Authorized = 'Authorized',
  Canceled = 'Canceled'
}

export enum SellerBalanceType {
  Balance = 'Balance',
  PayoutBalance = 'PayoutBalance'
}

export type SellerBecomeRequestAgreementDocs = {
  __typename?: 'SellerBecomeRequestAgreementDocs';
  signed?: Maybe<Scalars['String']['output']>;
  toSign?: Maybe<Scalars['String']['output']>;
};

export type SellerBecomeRequestDoc = {
  __typename?: 'SellerBecomeRequestDoc';
  type: SellerBecomeRequestDocType;
  uploadedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export type SellerBecomeRequestDocInput = {
  type: SellerBecomeRequestDocType;
  uploadedAt?: InputMaybe<Scalars['Date']['input']>;
  url: Scalars['String']['input'];
};

export enum SellerBecomeRequestDocType {
  AgreementSigned = 'AgreementSigned',
  AgreementToSign = 'AgreementToSign',
  PassportMain = 'PassportMain',
  PassportRegistration = 'PassportRegistration'
}

export type SellerBecomeRequestEntity = {
  __typename?: 'SellerBecomeRequestEntity';
  address?: Maybe<Scalars['String']['output']>;
  agreementDocs: SellerBecomeRequestAgreementDocs;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  contactInfo?: Maybe<Scalars['String']['output']>;
  correspondentAccount?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  declinedComment?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  docs: Array<SellerBecomeRequestDoc>;
  firstName?: Maybe<Scalars['String']['output']>;
  icAdmin?: Maybe<UserEntity>;
  id: Scalars['Int']['output'];
  inn?: Maybe<Scalars['String']['output']>;
  isOrganization: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ogrn?: Maybe<Scalars['String']['output']>;
  organizationForm: SellerOrganizationForm;
  organizationName?: Maybe<Scalars['String']['output']>;
  passport?: Maybe<SellerBecomeRequestPassport>;
  registerVerification: SellerRegisterVerification;
  sellerOrganization?: Maybe<SellerOrganizationEntity>;
  status: SellerBecomeRequestStatus;
  surname?: Maybe<Scalars['String']['output']>;
  type: SellerType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  verifiedBy?: Maybe<UserEntity>;
};

export type SellerBecomeRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  docs?: InputMaybe<Array<SellerBecomeRequestDocInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inn: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationForm: SellerOrganizationForm;
  passport?: InputMaybe<SellerBecomeRequestPassportInput>;
  surname?: InputMaybe<Scalars['String']['input']>;
  type: SellerType;
};

export type SellerBecomeRequestPassport = {
  __typename?: 'SellerBecomeRequestPassport';
  dateOfIssue: Scalars['String']['output'];
  issuedBy: Scalars['String']['output'];
  issuedByCode: Scalars['String']['output'];
  number: Scalars['String']['output'];
  pages: Array<SellerBecomeRequestPassportPage>;
  registration: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

export type SellerBecomeRequestPassportInput = {
  dateOfIssue: Scalars['String']['input'];
  issuedBy: Scalars['String']['input'];
  issuedByCode: Scalars['String']['input'];
  number: Scalars['String']['input'];
  pages: Array<SellerBecomeRequestPassportPageInput>;
  registration: Scalars['String']['input'];
  series: Scalars['String']['input'];
};

export type SellerBecomeRequestPassportPage = {
  __typename?: 'SellerBecomeRequestPassportPage';
  page: SellerBecomeRequestDocType;
  uploadedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export type SellerBecomeRequestPassportPageInput = {
  page: SellerBecomeRequestDocType;
  uploadedAt?: InputMaybe<Scalars['Date']['input']>;
  url: Scalars['String']['input'];
};

export enum SellerBecomeRequestStatus {
  AgreementChecking = 'AgreementChecking',
  AgreementDataDeclined = 'AgreementDataDeclined',
  FormDataChecking = 'FormDataChecking',
  FormDataDeclined = 'FormDataDeclined',
  Initialized = 'Initialized',
  OnAgreementSigning = 'OnAgreementSigning',
  Verified = 'Verified'
}

export type SellerCurrentBalanceOutput = {
  __typename?: 'SellerCurrentBalanceOutput';
  balance: Scalars['Float']['output'];
  payoutBalance: Scalars['Float']['output'];
};

export type SellerEntity = {
  __typename?: 'SellerEntity';
  active: Scalars['Boolean']['output'];
  baseCurrency: ProductCurrency;
  createdAt: Scalars['Date']['output'];
  currentManager: SellerManagerEntity;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isSchool: Scalars['Boolean']['output'];
  organization: SellerOrganizationEntity;
  producer?: Maybe<ProducerEntity>;
  school?: Maybe<SchoolEntity>;
  tutor?: Maybe<TutorEntity>;
  type: SellerType;
  university?: Maybe<UniversityEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  verified: Scalars['Boolean']['output'];
};

export type SellerManagerEntity = {
  __typename?: 'SellerManagerEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isSellerOwner: Scalars['Boolean']['output'];
  lastCalledAt: Scalars['Date']['output'];
  permissions: Array<Permission>;
  productManagers: Array<SellerProductManagerEntity>;
  seller: SellerEntity;
  type: SellerManagerType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum SellerManagerType {
  Product = 'Product',
  Seller = 'Seller'
}

export type SellerOrganizationDocumentConfig = {
  __typename?: 'SellerOrganizationDocumentConfig';
  showInFooter?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<SellerOrganizationSelfUploadedDocumentType>;
  uploadMode?: Maybe<SellerOrganizationDocumentUploadMode>;
};

export type SellerOrganizationDocumentEntity = {
  __typename?: 'SellerOrganizationDocumentEntity';
  config: SellerOrganizationDocumentConfig;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  location: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageFileEntity>;
  type: SellerOrganizationDocumentType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SellerOrganizationDocumentType {
  AgreementSigned = 'AgreementSigned',
  AgreementToSign = 'AgreementToSign',
  PassportMain = 'PassportMain',
  PassportRegistration = 'PassportRegistration',
  SelfUploaded = 'SelfUploaded'
}

export enum SellerOrganizationDocumentUploadMode {
  File = 'File',
  Link = 'Link'
}

export type SellerOrganizationEntity = {
  __typename?: 'SellerOrganizationEntity';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  form: SellerOrganizationForm;
  id: Scalars['Int']['output'];
  inn?: Maybe<Scalars['String']['output']>;
  isOrganization: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ogrn?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  request?: Maybe<SellerBecomeRequestEntity>;
  selfEmployedName?: Maybe<SelfEmployedNameOrganizationInterface>;
  seller: SellerEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SellerOrganizationForm {
  Ano = 'Ano',
  Ao = 'Ao',
  Fgbnu = 'Fgbnu',
  GosEdOrg = 'GosEdOrg',
  Ip = 'Ip',
  Mbuk = 'Mbuk',
  Nao = 'Nao',
  Nko = 'Nko',
  Oao = 'Oao',
  Ooo = 'Ooo',
  Pao = 'Pao',
  Pk = 'Pk',
  SelfEmployed = 'SelfEmployed',
  SelfHostedSchool = 'SelfHostedSchool',
  Up = 'Up',
  Zao = 'Zao'
}

export enum SellerOrganizationSelfUploadedDocumentType {
  DataConsentNews = 'DataConsentNews',
  DataPolicy = 'DataPolicy',
  MedicalDisclaimer = 'MedicalDisclaimer',
  Other = 'Other',
  PublicOffer = 'PublicOffer'
}

export type SellerProductManagerEntity = {
  __typename?: 'SellerProductManagerEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  manager: SellerManagerEntity;
  permissions: Array<Permission>;
  product: ProductEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SellerRegisterVerification = {
  __typename?: 'SellerRegisterVerification';
  bank: Scalars['Boolean']['output'];
  organization: Scalars['Boolean']['output'];
  selfEmployed?: Maybe<Scalars['Boolean']['output']>;
};

export enum SellerType {
  Producer = 'Producer',
  School = 'School',
  Tutor = 'Tutor',
  University = 'University'
}

export type SendInvitationTournamentInput = {
  toUserId: Scalars['Int']['input'];
  tournamentId: Scalars['Int']['input'];
};

export type SendManyNotificationInput = {
  toUserIds: Array<Scalars['Int']['input']>;
  userSegment: NotificationUserSegment;
};

export type SendMessageChatInput = {
  medias?: InputMaybe<Array<SendMessageMediaChatInput>>;
  replyMessageId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTabUuid?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageMediaChatInput = {
  storageFileId?: InputMaybe<Scalars['Int']['input']>;
  type: MessageMediaType;
  widget?: InputMaybe<SendMessageMediaWidgetChatInput>;
};

export type SendMessageMediaWidgetChatInput = {
  data: Scalars['JSONObject']['input'];
  type: MessageMediaWidgetType;
};

export type SendMessageTournamentInput = {
  message: TournamentMessageInput;
  tournamentId: Scalars['Int']['input'];
};

export type SentForwardMessageChat = {
  __typename?: 'SentForwardMessageChat';
  forwarded: Array<ChatMessageEntity>;
  sent?: Maybe<ChatMessageEntity>;
};

export type ServiceLoginAuthOutput = {
  __typename?: 'ServiceLoginAuthOutput';
  cause?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type SessionEntity = {
  __typename?: 'SessionEntity';
  alive: Scalars['Boolean']['output'];
  appLocation?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  expireAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isOnline: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  lastActivityAt: Scalars['Date']['output'];
  launcher: SessionLauncher;
  location: SessionLocation;
  timezone?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum SessionLauncher {
  Android = 'Android',
  Ios = 'Ios',
  LinuxApp = 'LinuxApp',
  MacApp = 'MacApp',
  Vk = 'Vk',
  Web = 'Web',
  WindowsApp = 'WindowsApp'
}

export type SessionLocation = {
  __typename?: 'SessionLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  variants?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type SetOtpAuthInput = {
  active: Scalars['Boolean']['input'];
  otp: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type ShortFormSellerBecomeRequestInput = {
  contactInfo: Scalars['String']['input'];
  inn?: InputMaybe<Scalars['String']['input']>;
  organizationForm: SellerOrganizationForm;
  organizationName: Scalars['String']['input'];
  type: SellerType;
};

export type SignupAuthOutput = {
  __typename?: 'SignupAuthOutput';
  exist: Scalars['Boolean']['output'];
  session?: Maybe<SessionEntity>;
  user?: Maybe<UserEntity>;
};

export enum SmsException {
  InvalidPhoneNumber = 'InvalidPhoneNumber',
  NotFound = 'NotFound'
}

export type SortAccessProductInput = {
  createdAt?: InputMaybe<SortDirection>;
  expireAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortChatInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastAction?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortCourseInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  productAccess?: InputMaybe<SortAccessProductInput>;
  publishedAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortFaqProductInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortFaqSupportInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortLaunchProductInput = {
  createdAt?: InputMaybe<SortDirection>;
  educationFinishAt?: InputMaybe<SortDirection>;
  educationStartAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  saleFinishAt?: InputMaybe<SortDirection>;
  saleStartAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortLessonPracticeAttemptCourseInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  sentToReviewAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortManagerSellerInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastCalledAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortMemberTournamentInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isPlayer?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortProgressCourseInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  practiceDeadlineAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortStoriesInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  publishedAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SortTournamentInput = {
  bet?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  finishAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  membersLimit?: InputMaybe<SortDirection>;
  startAt?: InputMaybe<SortDirection>;
  state?: InputMaybe<Array<TournamentState>>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum StorageBucketName {
  DefaultHot = 'DefaultHot'
}

export enum StorageBucketType {
  Cold = 'Cold',
  Hot = 'Hot'
}

export type StorageFileEntity = {
  __typename?: 'StorageFileEntity';
  bucketName: StorageBucketName;
  bucketType: StorageBucketType;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fileType: StorageFileType;
  id: Scalars['Int']['output'];
  imageSizes: StorageSizedImage;
  key?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  meta: StorageFileMeta;
  space: StorageSpace;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type StorageFileMeta = {
  __typename?: 'StorageFileMeta';
  dimensions?: Maybe<StorageMetaDimensions>;
  duration?: Maybe<Scalars['Float']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
};

export enum StorageFileType {
  Audio = 'Audio',
  File = 'File',
  Image = 'Image',
  Video = 'Video'
}

export enum StorageImageSize {
  Medium = 'Medium',
  Small = 'Small'
}

export type StorageMetaDimensions = {
  __typename?: 'StorageMetaDimensions';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type StorageMetaDimensionsInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type StorageMetaInput = {
  dimensions?: InputMaybe<StorageMetaDimensionsInput>;
  duration?: InputMaybe<Scalars['Float']['input']>;
};

export type StorageSizedImage = {
  __typename?: 'StorageSizedImage';
  maximum: Scalars['String']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export enum StorageSpace {
  Article = 'Article',
  Course = 'Course',
  School = 'School',
  Seller = 'Seller',
  Task = 'Task',
  User = 'User'
}

export type StoriesEntity = {
  __typename?: 'StoriesEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Float']['output'];
  hasView: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  previewImage?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  seller?: Maybe<SellerEntity>;
  status: StoriesStatus;
  title: Scalars['String']['output'];
  type: StoriesType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
  user: UserEntity;
  wrapper?: Maybe<Scalars['String']['output']>;
};

export enum StoriesStatus {
  Declined = 'Declined',
  Draft = 'Draft',
  OnCheck = 'OnCheck',
  Published = 'Published'
}

export enum StoriesType {
  Image = 'Image',
  Video = 'Video'
}

export type StoriesViewEntity = {
  __typename?: 'StoriesViewEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  stories: StoriesEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubjectCategoryEntity = {
  __typename?: 'SubjectCategoryEntity';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visibility: SubjectCategoryVisibility;
};

export type SubjectCategorySelectionEntity = {
  __typename?: 'SubjectCategorySelectionEntity';
  archived: Scalars['Boolean']['output'];
  categories: Array<SubjectCategoryEntity>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SubjectCategoryVisibility {
  All = 'All',
  Organization = 'Organization',
  Personal = 'Personal'
}

export type SubjectEntity = {
  __typename?: 'SubjectEntity';
  activeForTournament: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  contentCategory?: Maybe<ContentCategoryEntity>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  egeSubjectInfo: EgeSubjectInfo;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** Managed by administration */
  subject: EducationSubject;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Auth: USER */
  cartListenNewState: CartEntity;
  /** Auth: USER */
  chatListenNewListEvent: ChatListEvent;
  /** Auth: USER */
  chatListenNewMessage: ChatMessageEvent;
  /** Auth: USER */
  chatListenNewTotalUnreadCount: Scalars['Int']['output'];
  /** Auth: USER */
  chatListenNewTypingState: ChatTypingEvent;
  /** Auth: USER */
  contentElementListenMyInteractionUpdate: ContentElementInteractionEntity;
  contentElementListenUpdate: ContentElementEntity;
  /** Auth: USER */
  notificationListenNewNotificationItemOrUpdate: NotificationEntity;
  /** Auth: USER */
  notificationListenNewUnreadNotificationCount: Scalars['Int']['output'];
  profileListenNewState: ProfileEntity;
  schoolListenUpdate: SchoolEntity;
  /** Auth: USER */
  sessionListenExit: Scalars['Boolean']['output'];
  sessionListenNewState: SessionEntity;
  /** Auth: USER */
  tournamentListenNewLobbyMessage: TournamentMessageEntity;
  /** Auth: USER */
  tournamentListenNewMember: TournamentMemberEntity;
  /** Auth: USER */
  tournamentListenNewMemberProgress: TournamentResultEntity;
  /** Auth: USER */
  tournamentListenNewPlayer: TournamentMemberEntity;
  /** Auth: USER */
  tournamentListenTournamentBlitzLobbyState: TournamentBlitzLobbyEntity;
  tournamentListenTournamentState: TournamentEntity;
  userListenCountUserOnline: Scalars['Int']['output'];
  /** Auth: USER */
  walletListenNewUserBalance: Scalars['Float']['output'];
};


export type SubscriptionChatListenNewMessageArgs = {
  chatId: Scalars['Int']['input'];
};


export type SubscriptionChatListenNewTotalUnreadCountArgs = {
  type?: InputMaybe<ChatType>;
};


export type SubscriptionChatListenNewTypingStateArgs = {
  chatId: Scalars['Int']['input'];
};


export type SubscriptionContentElementListenMyInteractionUpdateArgs = {
  contentElementUuid: Scalars['String']['input'];
};


export type SubscriptionContentElementListenUpdateArgs = {
  contentElementUuid: Scalars['String']['input'];
};


export type SubscriptionProfileListenNewStateArgs = {
  profileId: Scalars['Int']['input'];
};


export type SubscriptionSchoolListenUpdateArgs = {
  schoolId: Scalars['Int']['input'];
};


export type SubscriptionSessionListenNewStateArgs = {
  sessionUuid: Scalars['String']['input'];
};


export type SubscriptionTournamentListenNewLobbyMessageArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type SubscriptionTournamentListenNewMemberArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type SubscriptionTournamentListenNewMemberProgressArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type SubscriptionTournamentListenNewPlayerArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type SubscriptionTournamentListenTournamentBlitzLobbyStateArgs = {
  blitzLobbyId: Scalars['Int']['input'];
};


export type SubscriptionTournamentListenTournamentStateArgs = {
  tournamentId: Scalars['Int']['input'];
};

export type SumAnalyticsItemOutput = {
  __typename?: 'SumAnalyticsItemOutput';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export type SumAnalyticsOutput = {
  __typename?: 'SumAnalyticsOutput';
  data: Array<SumAnalyticsItemOutput>;
};

export type SupportFaqEntity = {
  __typename?: 'SupportFaqEntity';
  article: ArticleEntity;
  category: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  section: SupportFaqSectionType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vkIcon: Scalars['String']['output'];
};

export enum SupportFaqSectionType {
  Common = 'Common',
  Seller = 'Seller',
  Student = 'Student'
}

export type SupportStaffEntity = {
  __typename?: 'SupportStaffEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lastCalledAt: Scalars['Date']['output'];
  status: SupportStaffStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SupportStaffStatus {
  Busy = 'Busy',
  Free = 'Free',
  Inactive = 'Inactive'
}

export type SupportTicketEntity = {
  __typename?: 'SupportTicketEntity';
  chat?: Maybe<ChatEntity>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  staff?: Maybe<SupportStaffEntity>;
  status: SupportTicketStatus;
  type: SupportTicketStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum SupportTicketStatus {
  Closed = 'Closed',
  Created = 'Created',
  Resolved = 'Resolved',
  WaitingStaff = 'WaitingStaff',
  WaitingUser = 'WaitingUser'
}

export type TaskAnswerEntity = {
  __typename?: 'TaskAnswerEntity';
  answer: TaskUserAnswer;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  maxPoint: Scalars['Float']['output'];
  moduleName: TaskAnswerModuleName;
  point: Scalars['Float']['output'];
  status: TaskAnswerStatus;
  task: TaskEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['String']['output'];
};

export enum TaskAnswerModuleName {
  CourseLessonPracticeAttempt = 'CourseLessonPracticeAttempt',
  TournamentResult = 'TournamentResult'
}

export enum TaskAnswerStatus {
  OnReview = 'OnReview',
  Verified = 'Verified',
  WaitingCheck = 'WaitingCheck'
}

export enum TaskAnswerType {
  Arrange = 'Arrange',
  Boolean = 'Boolean',
  Detailed = 'Detailed',
  FillSpaces = 'FillSpaces',
  Mapping = 'Mapping',
  Multiple = 'Multiple',
  MultipleWithAttachment = 'MultipleWithAttachment',
  Short = 'Short',
  Single = 'Single',
  SingleWithAttachment = 'SingleWithAttachment'
}

export type TaskAnsweredDetailedAttachmentItem = {
  __typename?: 'TaskAnsweredDetailedAttachmentItem';
  location: Scalars['String']['output'];
  type: StorageFileType;
};

export type TaskAnsweredDetailedItem = {
  __typename?: 'TaskAnsweredDetailedItem';
  attachments?: Maybe<Array<TaskAnsweredDetailedAttachmentItem>>;
  content?: Maybe<Scalars['JSONObject']['output']>;
};

export enum TaskComplexity {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  VeryHigh = 'VeryHigh',
  VeryLow = 'VeryLow'
}

export enum TaskContentType {
  Course = 'Course',
  Tournament = 'Tournament'
}

export type TaskEntity = {
  __typename?: 'TaskEntity';
  answerType: TaskAnswerType;
  archived: Scalars['Boolean']['output'];
  blocks: Array<ContentElementEntity>;
  complexity: TaskComplexity;
  contentTypes: Array<TaskContentType>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  groupOrder: TaskGroupOrder;
  id: Scalars['Int']['output'];
  maxPoint: Scalars['Int']['output'];
  question: Scalars['JSONObject']['output'];
  subject?: Maybe<EducationSubject>;
  subjectCategory?: Maybe<SubjectCategoryEntity>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  uuid: Scalars['String']['output'];
  visibility: TaskVisibility;
};

export type TaskGroupOrder = {
  __typename?: 'TaskGroupOrder';
  Course?: Maybe<Scalars['Int']['output']>;
  Tournament?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Int']['output']>;
};

export type TaskSubjectStatistic = {
  __typename?: 'TaskSubjectStatistic';
  correctSolvedCount: Scalars['Int']['output'];
  subjectCategoryId: Scalars['Int']['output'];
  subjectCategoryName: Scalars['String']['output'];
  totalSolvedCount: Scalars['Int']['output'];
  totalTaskCount: Scalars['Int']['output'];
};

export type TaskUserAnswer = {
  __typename?: 'TaskUserAnswer';
  detailed?: Maybe<TaskUserDetailedAnswer>;
  quiz?: Maybe<Scalars['JSONObject']['output']>;
};

export type TaskUserDetailedAnswer = {
  __typename?: 'TaskUserDetailedAnswer';
  attachments?: Maybe<Array<TaskUserDetailedAnswerAttachmentItem>>;
  content?: Maybe<Scalars['JSONObject']['output']>;
};

export type TaskUserDetailedAnswerAttachmentItem = {
  __typename?: 'TaskUserDetailedAnswerAttachmentItem';
  location: Scalars['String']['output'];
  type: StorageFileType;
};

export type TaskUserDetailedAnswerAttachmentItemInput = {
  location: Scalars['String']['input'];
  type: StorageFileType;
};

export type TaskUserDetailedAnswerInput = {
  attachments?: InputMaybe<Array<TaskUserDetailedAnswerAttachmentItemInput>>;
  content?: InputMaybe<Scalars['JSONObject']['input']>;
};

export enum TaskVisibility {
  All = 'All',
  Organization = 'Organization',
  Personal = 'Personal'
}

export type TemplateMeta = {
  __typename?: 'TemplateMeta';
  mail?: Maybe<MailTemplateMeta>;
};

export enum TinkoffPaymentRegistryStatus {
  CanceledByPayoutError = 'CanceledByPayoutError',
  Completed = 'Completed',
  Created = 'Created',
  Initialized = 'Initialized',
  OnCreating = 'OnCreating',
  OnPayment = 'OnPayment',
  OnReceiptGenerating = 'OnReceiptGenerating',
  OnSubmitting = 'OnSubmitting',
  Paid = 'Paid',
  ReceiptGeneratingError = 'ReceiptGeneratingError',
  Submitted = 'Submitted'
}

export enum TinkoffPaymentRegistryType {
  Organization = 'Organization',
  SelfEmployed = 'SelfEmployed'
}

export type TournamentBlitzLobbyEntity = {
  __typename?: 'TournamentBlitzLobbyEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  status: TournamentBlitzLobbyStatus;
  subject: EducationSubject;
  tournament?: Maybe<TournamentEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum TournamentBlitzLobbyStatus {
  Cancel = 'Cancel',
  OnHold = 'OnHold',
  Released = 'Released',
  Waiting = 'Waiting'
}

export type TournamentCategoryEntity = {
  __typename?: 'TournamentCategoryEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  subjectCategory: SubjectCategoryEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TournamentEntity = {
  __typename?: 'TournamentEntity';
  accessByInviteKey: Scalars['Boolean']['output'];
  autoCancelAt?: Maybe<Scalars['Date']['output']>;
  bet: Scalars['Int']['output'];
  categories: Array<TournamentCategoryEntity>;
  countMembers: Scalars['Int']['output'];
  countWinners?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishAt?: Maybe<Scalars['Date']['output']>;
  fund?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isGoingOn: Scalars['Boolean']['output'];
  isMember?: Maybe<Scalars['Boolean']['output']>;
  lastMembers: Array<UserEntity>;
  liveBroadcastUrl?: Maybe<Scalars['String']['output']>;
  membersLimit?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['Date']['output']>;
  startMode: TournamentStartMode;
  state: TournamentState;
  subject: EducationSubject;
  taskCount: Scalars['Int']['output'];
  tasks: Array<TournamentTaskEntity>;
  type: TournamentType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
  /** Using as invite key */
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum TournamentException {
  AlreadyAppointed = 'AlreadyAppointed',
  AlreadyStarted = 'AlreadyStarted',
  InvalidInviteKey = 'InvalidInviteKey',
  MaxMembersExceeded = 'MaxMembersExceeded',
  MemberNotPlayer = 'MemberNotPlayer',
  NoMoney = 'NoMoney',
  NotAllowedCreateOfficial = 'NotAllowedCreateOfficial'
}

export type TournamentInvitationEntity = {
  __typename?: 'TournamentInvitationEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  to: UserEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TournamentMemberEntity = {
  __typename?: 'TournamentMemberEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isPlayer: Scalars['Boolean']['output'];
  tournament: TournamentEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type TournamentMessageEntity = {
  __typename?: 'TournamentMessageEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  message: TournamentMessagePayload;
  tournament: TournamentEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type TournamentMessageInput = {
  text: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type TournamentMessagePayload = {
  __typename?: 'TournamentMessagePayload';
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum TournamentPromotionContentType {
  InviteShare = 'InviteShare',
  ResultShare = 'ResultShare',
  WinnerShare = 'WinnerShare'
}

export type TournamentResultEntity = {
  __typename?: 'TournamentResultEntity';
  answers: Array<TaskAnswerEntity>;
  createdAt: Scalars['Date']['output'];
  currentTaskIndex: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  maxPointsAmount: Scalars['Int']['output'];
  myAnswers: Array<TaskAnswerEntity>;
  place?: Maybe<Scalars['Int']['output']>;
  pointsAmount: Scalars['Int']['output'];
  prize?: Maybe<Scalars['Int']['output']>;
  solvedCount: Scalars['Int']['output'];
  tournament: TournamentEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export enum TournamentStartMode {
  Event = 'Event',
  Scheduled = 'Scheduled'
}

export enum TournamentState {
  Cancel = 'Cancel',
  Process = 'Process',
  Result = 'Result',
  StartLobby = 'StartLobby',
  Waiting = 'Waiting'
}

export type TournamentTaskEntity = {
  __typename?: 'TournamentTaskEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  task: TaskEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TournamentType {
  Blitz = 'Blitz',
  Official = 'Official',
  Private = 'Private',
  Public = 'Public'
}

export type TransferDetailsOnPayoutOutput = {
  __typename?: 'TransferDetailsOnPayoutOutput';
  isInternal: Scalars['Boolean']['output'];
  minAmount?: Maybe<Scalars['Float']['output']>;
  transactionAmount: Scalars['Float']['output'];
  transferAmount: Scalars['Float']['output'];
};

export type TrophyAchievement = {
  __typename?: 'TrophyAchievement';
  amount?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['Int']['output']>;
  type: TrophyAchievementType;
};

export enum TrophyAchievementType {
  Course = 'Course',
  Ex = 'Ex'
}

export type TutorEntity = {
  __typename?: 'TutorEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  seller: SellerEntity;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: UserEntity;
};

export type UnAppliedDiscountItem = {
  __typename?: 'UnAppliedDiscountItem';
  discount: DiscountEntity;
  reason: DiscountUnAppliedReason;
};

export type UniversityEntity = {
  __typename?: 'UniversityEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UpdateAcquiringInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateArticleInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAvatarProfileInput = {
  avatar: ProfileAvatarInput;
};

export type UpdateBlockOrderArticleInput = {
  items: Array<UpdateOrderContentElementItemInput>;
};

export type UpdateBlockOrderTaskInput = {
  items: Array<UpdateOrderContentElementItemInput>;
};

export type UpdateCategoryContentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<ContentCategorySpace>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCategorySubjectInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<EducationSubject>;
  visibility?: InputMaybe<SubjectCategoryVisibility>;
};

export type UpdateChatInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconStorageId?: InputMaybe<Scalars['Int']['input']>;
  inviteUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChatType>;
};

export type UpdateCourseInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  authors?: InputMaybe<Array<Scalars['Int']['input']>>;
  contentCategoryId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CreateCourseImageInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferenceSettings?: InputMaybe<CoursePreferenceInput>;
  product?: InputMaybe<CreateProductInput>;
  progressType?: InputMaybe<CourseProgressType>;
  promoVideo?: InputMaybe<Scalars['String']['input']>;
  seoTags?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<EducationSubject>;
  subjectCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CourseType>;
};

export type UpdateDiscountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<ProductCurrency>;
  maxApplies?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<DiscountType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateElementContentInput = {
  content?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEndpointWebhookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Array<WebhookEvent>>;
  note?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFaqProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answer?: InputMaybe<Scalars['JSONObject']['input']>;
  isOpenedInUi?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  accessLimitation?: InputMaybe<GroupAccessLimitationInput>;
  communication?: InputMaybe<GroupCommunicationInput>;
  contentLimitation?: InputMaybe<GroupContentLimitationInput>;
  curatorUserId?: InputMaybe<Scalars['Int']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleLimitation?: InputMaybe<GroupScheduleLimitationInput>;
};

export type UpdateLaunchProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  educationFinishAt?: InputMaybe<Scalars['Date']['input']>;
  educationStartAt?: InputMaybe<Scalars['Date']['input']>;
  infinityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saleFinishAt?: InputMaybe<Scalars['Date']['input']>;
  saleStartAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ProductLaunchStatus>;
};

export type UpdateLessonBlockOrderCourseInput = {
  items: Array<UpdateOrderContentElementItemInput>;
};

export type UpdateLessonCourseInput = {
  accessType?: InputMaybe<CourseLessonAccessType>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentLessonId?: InputMaybe<Scalars['Int']['input']>;
  previewImage?: InputMaybe<Scalars['String']['input']>;
  scheduledPublishAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CourseLessonStatus>;
  storageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<CourseLessonType>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
  withPractice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLessonMediaCourseInput = {
  allowedToDownload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLessonPracticeAttemptCourseInput = {
  curatorId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CourseLessonPracticeAttemptStatus>;
};

export type UpdateLessonPracticeCourseInput = {
  deadlineInDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  taskUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLessonPracticeOrderItemInput = {
  order: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateLessonPracticeTaskOrderCourseInput = {
  items: Array<UpdateLessonPracticeOrderItemInput>;
};

export type UpdateManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMemberChatInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMetaSessionInput = {
  appLocation?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  launcher?: InputMaybe<SessionLauncher>;
  timezone?: InputMaybe<Scalars['Float']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderContentElementItemInput = {
  id: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
};

export type UpdateOrganizationDocumentSellerInput = {
  config?: InputMaybe<OrganizationDocumentConfigSellerInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SellerOrganizationDocumentType>;
};

export type UpdateOrganizationSchoolInput = {
  inn?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationSellerInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantProductInput = {
  completeFinalLesson?: InputMaybe<Scalars['Boolean']['input']>;
  status: ProductParticipantStatus;
};

export type UpdateParticipantProgressCourseInput = {
  status?: InputMaybe<CourseProgressLessonStatus>;
};

export type UpdatePasswordInput = {
  logout: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
};

export type UpdatePriceProductInput = {
  accessDays?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeFrom?: InputMaybe<Scalars['Date']['input']>;
  activeTo?: InputMaybe<Scalars['Date']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  infinityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  launchPeriodMode?: InputMaybe<ProductPriceLaunchPeriodMode>;
  previousAmount?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  domains?: InputMaybe<Array<AppServeDomain>>;
  saleFinishAt?: InputMaybe<Scalars['Date']['input']>;
  saleStartAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateProductManagerSellerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  productId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProfileInput = {
  bdate?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ProfileContactInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role?: InputMaybe<ProfileRole>;
  sex?: InputMaybe<UserSexType>;
};

export type UpdateRefundInvoiceInput = {
  invoiceProductIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<InvoiceRefundStatus>;
};

export type UpdateSchoolInput = {
  accessType?: InputMaybe<SchoolAccessType>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<Array<SchoolAddressItemInput>>;
  baseCurrency?: InputMaybe<ProductCurrency>;
  baseDomain?: InputMaybe<Scalars['String']['input']>;
  blockSettings?: InputMaybe<SchoolBlockSettingsInput>;
  config?: InputMaybe<SchoolConfigInput>;
  contacts?: InputMaybe<Array<SchoolContactItemInput>>;
  customCode?: InputMaybe<SchoolCustomCodeInput>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainType?: InputMaybe<SchoolDomainType>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferenceSettings?: InputMaybe<SchoolPreferenceSettingsInput>;
};

export type UpdateStoriesInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  previewImage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StoriesStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoriesType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubjectInput = {
  contentCategoryId?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaskInput = {
  answerType?: InputMaybe<TaskAnswerType>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<TaskComplexity>;
  contentTypes?: InputMaybe<Array<TaskContentType>>;
  maxPoint?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['JSONObject']['input']>;
  subject?: InputMaybe<EducationSubject>;
  subjectCategoryId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<TaskVisibility>;
};

export type UpdateTitleProfileInput = {
  manualEmojiTitle?: InputMaybe<Scalars['String']['input']>;
  manualExpiredAt?: InputMaybe<Scalars['Date']['input']>;
  manualNextEmojiTitle?: InputMaybe<Scalars['String']['input']>;
  manualNextTitle?: InputMaybe<Scalars['String']['input']>;
  manualTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadFilesStorageInput = {
  bucketName?: InputMaybe<StorageBucketName>;
  bucketType?: InputMaybe<StorageBucketType>;
  files: Array<Scalars['String']['input']>;
  imageSizes?: InputMaybe<Array<StorageImageSize>>;
  meta?: InputMaybe<Array<StorageMetaInput>>;
  space: StorageSpace;
};

export type UpsertInteractionElementContentInput = {
  data: Scalars['JSONObject']['input'];
};

export type UserEntity = {
  __typename?: 'UserEntity';
  activated: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  alive: Scalars['Boolean']['output'];
  appleId?: Maybe<Scalars['String']['output']>;
  banned: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<UserEntity>;
  createdOnDomain: AppServeDomain;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  friendshipStatus?: Maybe<FriendshipStatus>;
  id: Scalars['Int']['output'];
  isOriginDomain: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  lastOnlineAt: Scalars['Date']['output'];
  login: Scalars['String']['output'];
  meta?: Maybe<UserMetaEntity>;
  originDomain: Scalars['String']['output'];
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']['output']>;
  productAccessesCount?: Maybe<Scalars['Int']['output']>;
  profile: ProfileEntity;
  tgId?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['Float']['output']>;
  tutor?: Maybe<TutorEntity>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  vkId?: Maybe<Scalars['Float']['output']>;
};

export enum UserException {
  DomainIsBusy = 'DomainIsBusy',
  DomainIsInvalid = 'DomainIsInvalid',
  GetVkProfileFail = 'GetVkProfileFail',
  NotFound = 'NotFound',
  TgIdAlreadyConnected = 'TgIdAlreadyConnected'
}

export type UserMetaEntity = {
  __typename?: 'UserMetaEntity';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hasOtp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserOnlineSocketOutput = {
  __typename?: 'UserOnlineSocketOutput';
  online: Scalars['Boolean']['output'];
  user: UserEntity;
};

export enum UserSexType {
  Men = 'Men',
  Ufo = 'Ufo',
  Women = 'Women'
}

export enum UserStateKey {
  ChatBotApiEndpoint = 'ChatBotApiEndpoint',
  ContentCategoryIds = 'ContentCategoryIds',
  EducationSubjects = 'EducationSubjects',
  ExamsReminder = 'ExamsReminder',
  OnBoardingProgress = 'OnBoardingProgress',
  PersonalInfoFilled = 'PersonalInfoFilled',
  TgAuthInfo = 'TgAuthInfo',
  VkEmail = 'VkEmail',
  VkFriends = 'VkFriends',
  VkInfo = 'VkInfo',
  VkPhone = 'VkPhone',
  VkToken = 'VkToken'
}

export enum VkAuthMode {
  Vk = 'Vk',
  VkId = 'VkId',
  VkMiniApp = 'VkMiniApp'
}

export type VkIdLoginAuthInput = {
  mode?: InputMaybe<VkIdLoginMode>;
  payload?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum VkIdLoginMode {
  MiniApp = 'MiniApp',
  VkId = 'VkId'
}

export enum WalletAmountType {
  Expense = 'Expense',
  Income = 'Income'
}

export enum WalletException {
  NoMoney = 'NoMoney',
  TransferFailed = 'TransferFailed'
}

export type WalletOperationEntity = {
  __typename?: 'WalletOperationEntity';
  amount: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fromUser?: Maybe<UserEntity>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['Int']['output']>;
  isRefund: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<UserEntity>;
  toUser?: Maybe<UserEntity>;
  tournament?: Maybe<TournamentEntity>;
  type: WalletOperationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserEntity>;
};

export enum WalletOperationType {
  Administration = 'Administration',
  Blitz = 'Blitz',
  Course = 'Course',
  Gift = 'Gift',
  Referral = 'Referral',
  Tournament = 'Tournament',
  User = 'User'
}

export type WebhookEndpointEntity = {
  __typename?: 'WebhookEndpointEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  events: Array<WebhookEvent>;
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
  timeout: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export enum WebhookEvent {
  CourseCompleted = 'CourseCompleted',
  CourseLessonPracticeAutoVerifySent = 'CourseLessonPracticeAutoVerifySent',
  CourseLessonPracticeDetailedSent = 'CourseLessonPracticeDetailedSent',
  CourseProgressChanged = 'CourseProgressChanged',
  PaymentCompleted = 'PaymentCompleted',
  ProductAccessSubscriptionEnding1Day = 'ProductAccessSubscriptionEnding1Day',
  ProductAccessSubscriptionEnding7Days = 'ProductAccessSubscriptionEnding7Days',
  ProductEnrolledViaLms = 'ProductEnrolledViaLms',
  ProductEnrolledViaPayment = 'ProductEnrolledViaPayment',
  ProductRefundCompleted = 'ProductRefundCompleted',
  SchoolCreated = 'SchoolCreated',
  SchoolManagersOnlineDailyReportCron = 'SchoolManagersOnlineDailyReportCron',
  SchoolUsersOnlineDailyReportCron = 'SchoolUsersOnlineDailyReportCron',
  UserCreatedViaLms = 'UserCreatedViaLms',
  UserJoinedByReferral = 'UserJoinedByReferral',
  UserLoggedOut = 'UserLoggedOut',
  UserSignedIn = 'UserSignedIn',
  UserSignedUp = 'UserSignedUp'
}

export enum WebhookException {
  LimitOfCreatedEndpointsExcited = 'LimitOfCreatedEndpointsExcited',
  NotFound = 'NotFound'
}

export type TournamentFindOneFragmentFragment = { __typename?: 'TournamentEntity', id: number, uuid?: string | null, subject: EducationSubject, startAt?: any | null, bet: number, type: TournamentType, countMembers: number, isMember?: boolean | null, state: TournamentState, accessByInviteKey: boolean, categories: Array<{ __typename?: 'TournamentCategoryEntity', subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, lastMembers: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> };

export type TournamentFindOneQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentFindOneQuery = { __typename?: 'Query', tournamentFindOne: { __typename?: 'TournamentEntity', startMode: TournamentStartMode, id: number, uuid?: string | null, subject: EducationSubject, startAt?: any | null, bet: number, type: TournamentType, countMembers: number, isMember?: boolean | null, state: TournamentState, accessByInviteKey: boolean, categories: Array<{ __typename?: 'TournamentCategoryEntity', subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, lastMembers: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type TournamentLobbyAppointMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  inviteKey: Scalars['String']['input'];
}>;


export type TournamentLobbyAppointMutation = { __typename?: 'Mutation', tournamentLobbyAppoint: { __typename?: 'TournamentEntity', id: number, uuid?: string | null, isMember?: boolean | null, countMembers: number } };

export type ChatPersonalCompanionMemberFragmentFragment = { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type ChatMyMemberFragmentFragment = { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null };

export type ChatFragmentFragment = { __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null };

export type MessageFragmentFragment = { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> };

export type MessageWidgetFragmentFragment = { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } };

export type ChatFindOneTopBarQueryVariables = Exact<{
  chatId: Scalars['Int']['input'];
}>;


export type ChatFindOneTopBarQuery = { __typename?: 'Query', chatFindOne: { __typename?: 'ChatEntity', id: number, type: ChatType, name?: string | null, countUnread?: number | null, countMembers: number, isAdmin: boolean, sendMessagePermission: ChatActionPermission, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null } };

export type ChatMemberFindManyQueryVariables = Exact<{
  chatId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterMemberChatInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ChatMemberFindManyQuery = { __typename?: 'Query', chatMemberFindMany: { __typename?: 'ListMemberChatOutput', count: number, pages: number, items: Array<{ __typename?: 'ChatMemberEntity', user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type ChatFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterChatInput;
  sort?: InputMaybe<SortChatInput>;
  cursor?: InputMaybe<CursorInput>;
}>;


export type ChatFindManyQuery = { __typename?: 'Query', chatFindMany: { __typename?: 'ListChatOutput', count: number, cursor: { __typename?: 'CursorOutput', after?: number | null, before?: number | null, hasNext: boolean, hasPrev: boolean }, items?: Array<{ __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null }> | null } };

export type ChatAndProfileSearchFindManyQueryVariables = Exact<{
  chatList: ListInput;
  chatFilter: FilterChatInput;
  chatSort?: InputMaybe<SortChatInput>;
  profileList: ListInput;
  profileFilter: FilterProfileInput;
  profileSort?: InputMaybe<BaseSortInput>;
  profileSkip: Scalars['Boolean']['input'];
}>;


export type ChatAndProfileSearchFindManyQuery = { __typename?: 'Query', chatFindMany: { __typename?: 'ListChatOutput', count: number, cursor: { __typename?: 'CursorOutput', after?: number | null, before?: number | null, hasNext: boolean, hasPrev: boolean }, items?: Array<{ __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null }> | null }, profileFindMany?: { __typename?: 'ListProfileOutput', items: Array<{ __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, updatedAt?: any | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } }> } };

export type ChatMessageFindOneQueryVariables = Exact<{
  chatId: Scalars['Int']['input'];
  messageId: Scalars['Int']['input'];
}>;


export type ChatMessageFindOneQuery = { __typename?: 'Query', chatMessageFindOne: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } };

export type ChatMessageFindManyQueryVariables = Exact<{
  chatId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterMessageChatInput;
  sort?: InputMaybe<BaseSortInput>;
  cursor?: InputMaybe<CursorInput>;
}>;


export type ChatMessageFindManyQuery = { __typename?: 'Query', chatMessageFindMany: { __typename?: 'ListMessageChatOutput', items?: Array<{ __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> }> | null, cursor: { __typename?: 'CursorOutput', hasPrev: boolean, hasNext: boolean, before?: number | null, after?: number | null } } };

export type ChatAttachmentsFindManyQueryVariables = Exact<{
  chatId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterMessageChatInput;
  sort?: InputMaybe<BaseSortInput>;
  cursor?: InputMaybe<CursorInput>;
}>;


export type ChatAttachmentsFindManyQuery = { __typename?: 'Query', chatMessageFindMany: { __typename?: 'ListMessageChatOutput', items?: Array<{ __typename?: 'ChatMessageEntity', id: number, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, uuid?: string | null, key?: string | null, createdAt: any, updatedAt?: any | null, location?: string | null, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null }> }> | null, cursor: { __typename?: 'CursorOutput', hasPrev: boolean, hasNext: boolean, before?: number | null, after?: number | null } } };

export type FindManyFriendsHasNotPersonalChatQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFriendshipInput;
  sort?: InputMaybe<BaseSortInput>;
  relUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindManyFriendsHasNotPersonalChatQuery = { __typename?: 'Query', friendshipFindMany: { __typename?: 'ListUserFriendshipOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, lastOnlineAt: any, updatedAt?: any | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type ChatProfileFindOneQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ChatProfileFindOneQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, fullName: string, country?: string | null, city?: string | null, official: boolean, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, maximum?: string | null }, user: { __typename?: 'UserEntity', id: number, email?: string | null, verified: boolean, lastOnlineAt: any, domain?: string | null, tutor?: { __typename?: 'TutorEntity', id: number, seller: { __typename?: 'SellerEntity', id: number } } | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type ChatGetUnreadCountQueryVariables = Exact<{
  types?: InputMaybe<Array<ChatType> | ChatType>;
}>;


export type ChatGetUnreadCountQuery = { __typename?: 'Query', chatGetUnreadCount: number };

export type ChatFindOnePersonalQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ChatFindOnePersonalQuery = { __typename?: 'Query', chatFindOnePersonal?: { __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null } | null };

export type ChatCreateMutationVariables = Exact<{
  chat: CreateChatInput;
}>;


export type ChatCreateMutation = { __typename?: 'Mutation', chatCreate: { __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null } };

export type ChatMessageSendMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  message: SendMessageChatInput;
}>;


export type ChatMessageSendMutation = { __typename?: 'Mutation', chatMessageSend: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } };

export type ChatMessageEditMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  messageId: Scalars['Int']['input'];
  message: EditMessageChatInput;
}>;


export type ChatMessageEditMutation = { __typename?: 'Mutation', chatMessageEdit: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } };

export type ChatMessageReadManyMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  messageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ChatMessageReadManyMutation = { __typename?: 'Mutation', chatMessageReadMany: Array<{ __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> }> };

export type ChatTypingSetStatusMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  isTyping: Scalars['Boolean']['input'];
}>;


export type ChatTypingSetStatusMutation = { __typename?: 'Mutation', chatTypingSetStatus: { __typename?: 'ChatTypingEvent', profiles: Array<{ __typename?: 'ProfileEntity', id: number, fullNameShort: string }> } };

export type ChatMessageDeleteManyMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  messageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ChatMessageDeleteManyMutation = { __typename?: 'Mutation', chatMessageDeleteMany: Array<number> };

export type ChatMemberUpdateMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  member: UpdateMemberChatInput;
}>;


export type ChatMemberUpdateMutation = { __typename?: 'Mutation', chatMemberUpdate: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, deletedAt?: any | null, blockedUntil?: any | null, chat: { __typename?: 'ChatEntity', id: number, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null } } };

export type ChatMemberDeleteMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
}>;


export type ChatMemberDeleteMutation = { __typename?: 'Mutation', chatMemberDelete: boolean };

export type ChatMemberToggleBlockPersonalMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  companionUserId: Scalars['Int']['input'];
  blocked: Scalars['Boolean']['input'];
}>;


export type ChatMemberToggleBlockPersonalMutation = { __typename?: 'Mutation', chatMemberToggleBlockPersonal: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, blockedUntil?: any | null, chat: { __typename?: 'ChatEntity', id: number, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null } } };

export type ChatMessageForwardMutationVariables = Exact<{
  chatId: Scalars['Int']['input'];
  targetChatId: Scalars['Int']['input'];
  message: ForwardMessageChatInput;
}>;


export type ChatMessageForwardMutation = { __typename?: 'Mutation', chatMessageForward: { __typename?: 'SentForwardMessageChat', sent?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwarded: Array<{ __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> }> } };

export type ChatListenNewMessageSubscriptionVariables = Exact<{
  chatId: Scalars['Int']['input'];
}>;


export type ChatListenNewMessageSubscription = { __typename?: 'Subscription', chatListenNewMessage: { __typename?: 'ChatMessageEvent', action: ChatMessageEventAction, messages: Array<{ __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> }> } };

export type ChatListenNewListEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChatListenNewListEventSubscription = { __typename?: 'Subscription', chatListenNewListEvent: { __typename?: 'ChatListEvent', action: ChatListEventAction, chat: { __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null }, myMember: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } } };

export type ChatListenNewCountTotalUnreadSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChatListenNewCountTotalUnreadSubscription = { __typename?: 'Subscription', chatListenNewTotalUnreadCount: number };

export type ChatListenNewTypingStateSubscriptionVariables = Exact<{
  chatId: Scalars['Int']['input'];
}>;


export type ChatListenNewTypingStateSubscription = { __typename?: 'Subscription', chatListenNewTypingState: { __typename?: 'ChatTypingEvent', chatId: number, anotherCount: number, profiles: Array<{ __typename?: 'ProfileEntity', id: number, firstName?: string | null }> } };

export type ChatListenNewTotalUnreadCountSubscriptionVariables = Exact<{
  type?: InputMaybe<ChatType>;
}>;


export type ChatListenNewTotalUnreadCountSubscription = { __typename?: 'Subscription', chatListenNewTotalUnreadCount: number };

export type SupportTicketCreateByUserMutationVariables = Exact<{
  ticket: CreateTicketSupportInput;
}>;


export type SupportTicketCreateByUserMutation = { __typename?: 'Mutation', supportTicketCreateByUser: { __typename?: 'SupportTicketEntity', chat?: { __typename?: 'ChatEntity', id: number } | null } };

export type CourseLessonPracticeAttemptWidgetQueryVariables = Exact<{
  attemptUuid: Scalars['String']['input'];
}>;


export type CourseLessonPracticeAttemptWidgetQuery = { __typename?: 'Query', courseLessonPracticeAttemptFindOneByUuid: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, uuid: string, status: CourseLessonPracticeAttemptStatus, finished: boolean, solvedCount: number, pointsAmount: number, attemptIndex?: number | null, sentToReviewAt?: any | null, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string } } } };

export type GetDbConfigByKeyQueryVariables = Exact<{
  key: DbConfigKey;
  version: Scalars['String']['input'];
}>;


export type GetDbConfigByKeyQuery = { __typename?: 'Query', configGetOneByKey?: any | null };

export type ConfigGetServerTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigGetServerTimeQuery = { __typename?: 'Query', configGetServerTime: any };

export type UpdateSessionMetaMutationVariables = Exact<{
  sessionMeta: UpdateMetaSessionInput;
}>;


export type UpdateSessionMetaMutation = { __typename?: 'Mutation', sessionUpdateMeta: number };

export type ContentElementFragmentFragment = { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null };

export type ContentElementMyInteractionFragmentFragment = { __typename?: 'ContentElementInteractionEntity', id: number, data: any };

export type ContentElementInteractMutationVariables = Exact<{
  contentElementUuid: Scalars['String']['input'];
  interaction: UpsertInteractionElementContentInput;
}>;


export type ContentElementInteractMutation = { __typename?: 'Mutation', contentElementInteractionUpsert: { __typename?: 'ContentElementInteractionEntity', id: number, data: any, contentElement: { __typename?: 'ContentElementEntity', id: number } } };

export type GetAvailableCountryCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCountryCodesQuery = { __typename?: 'Query', smsProviderGetAvailableCountryCodes: Array<string> };

export type CompanyGetApiVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyGetApiVersionQuery = { __typename?: 'Query', companyGetApiVersion: string };

export type SupportFaqFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFaqSupportInput;
  sort?: InputMaybe<SortFaqSupportInput>;
}>;


export type SupportFaqFindManyQuery = { __typename?: 'Query', supportFaqFindMany: { __typename?: 'ListFaqSupportOutput', count: number, pages: number, items: Array<{ __typename?: 'SupportFaqEntity', id: number, article: { __typename?: 'ArticleEntity', id: number, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> } }> } };

export type SupportFaqFindManyDistinctByCategoryQueryVariables = Exact<{
  filter: FilterFaqSupportInput;
}>;


export type SupportFaqFindManyDistinctByCategoryQuery = { __typename?: 'Query', supportFaqFindManyDistinctByCategory: Array<{ __typename?: 'SupportFaqEntity', id: number, vkIcon: string, category: string }> };

export type RequestDeletionMutationVariables = Exact<{
  form: RequestUserDeletionInput;
}>;


export type RequestDeletionMutation = { __typename?: 'Mutation', userRequestDeletion: boolean };

export type ContentCategoryFragmentFragment = { __typename?: 'ContentCategoryEntity', id: number, space: ContentCategorySpace, slug?: string | null, order: number, name?: string | null, visible: boolean, subjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> };

export type ContentCategoryFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCategoryContentInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ContentCategoryFindManyQuery = { __typename?: 'Query', contentCategoryFindMany: { __typename?: 'ListCategoryContentOutput', count: number, page: number, pages: number, items: Array<{ __typename?: 'ContentCategoryEntity', id: number, space: ContentCategorySpace, slug?: string | null, order: number, name?: string | null, visible: boolean, subjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> }> } };

export type FeedbackFragmentFragment = { __typename?: 'ProductFeedbackEntity', id: number, text: string, rate: number, status: ProductFeedbackStatus, createdAt: any, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type CourseFindOneQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
}>;


export type CourseFindOneQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', isParticipant?: boolean | null, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', id: number, isFree: boolean, isOnSale: boolean, currency: ProductCurrency, feedbackRating?: number | null, approves: Array<ProductApprove>, participantsCount: number, status: ProductStatus, archived: boolean, createdAt: any, publishedAt?: any | null, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, seller: { __typename?: 'SellerEntity', id: number, verified: boolean, organization: { __typename?: 'SellerOrganizationEntity', id: number, inn?: string | null, name: string, logo?: string | null, form: SellerOrganizationForm, createdAt: any, updatedAt?: any | null } }, prices: Array<{ __typename?: 'ProductPriceEntity', id: number, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, actualFrom?: any | null, actualTo?: any | null, previousAmount?: number | null, amount: number, accessDays?: number | null, actualAccessDays?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null }>, myAccess?: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, name: string, order: number, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, practice?: { __typename?: 'CourseLessonPracticeEntity', attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }> } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null } | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, description: string, previewImage?: string | null, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null }>, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type ProductFindManyFeedbacksQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFeedbackProductInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ProductFindManyFeedbacksQuery = { __typename?: 'Query', productFeedbackFindMany: { __typename?: 'ListFeedbackProductOutput', count: number, items: Array<{ __typename?: 'ProductFeedbackEntity', id: number, text: string, rate: number, status: ProductFeedbackStatus, createdAt: any, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type ProductFeedbackFindOneByUserAndProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type ProductFeedbackFindOneByUserAndProductQuery = { __typename?: 'Query', productFeedbackCanSend: boolean, productFeedbackFindOneByUserAndProduct?: { __typename?: 'ProductFeedbackEntity', id: number, text: string, rate: number, status: ProductFeedbackStatus, createdAt: any, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null };

export type ProductFeedbackUpsertMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  feedback: CreateFeedbackProductInput;
}>;


export type ProductFeedbackUpsertMutation = { __typename?: 'Mutation', productFeedbackUpsert: { __typename?: 'ProductFeedbackEntity', id: number, text: string, rate: number, status: ProductFeedbackStatus, createdAt: any, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type ProductAccessProlongAccessForFreeMutationVariables = Exact<{
  launchId: Scalars['Int']['input'];
}>;


export type ProductAccessProlongAccessForFreeMutation = { __typename?: 'Mutation', productAccessProlongAccessForFree: { __typename?: 'ProductAccessEntity', id: number, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, currentLesson?: { __typename?: 'CourseLessonEntity', id: number } | null } | null } } };

export type LessonStudyFragmentFragment = { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, previewImage?: string | null, myProgressStatus?: CourseProgressLessonStatus | null, publishedAt?: any | null, scheduledPublishAt?: any | null, isDemo: boolean, accessType: CourseLessonAccessType, viewsCount: number, isFinal: boolean, order: number, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, updatedAt?: any | null, deletedAt?: any | null, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, myProgressStatus?: CourseProgressLessonStatus | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } | null } | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, location?: string | null, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } }> };

export type CourseLessonsFragmentFragment = { __typename?: 'CourseEntity', lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, scheduledPublishAt?: any | null, description: string, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null }> };

export type CourseInformationInLessonFragmentFragment = { __typename?: 'CourseEntity', id: number, name: string, type: CourseType, progressType: CourseProgressType, isParticipant?: boolean | null, product: { __typename?: 'ProductEntity', id: number, isFree: boolean, seller: { __typename?: 'SellerEntity', id: number }, myAccess?: { __typename?: 'ProductAccessEntity', id: number, participant?: { __typename?: 'ProductParticipantEntity', id: number, status: ProductParticipantStatus } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } };

export type CourseLessonParentFragmentFragment = { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null };

export type CourseLessonFindManyQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterLessonCourseInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type CourseLessonFindManyQuery = { __typename?: 'Query', courseLessonFindMany: { __typename?: 'ListLessonCourseOutput', count: number, items: Array<{ __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isPublished: boolean, isDemo: boolean, accessType: CourseLessonAccessType, description: string, myProgressStatus?: CourseProgressLessonStatus | null, scheduledPublishAt?: any | null, previewImage?: string | null, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null, next?: { __typename?: 'CourseLessonEntity', id: number } | null }> }, courseFindOne: { __typename?: 'CourseEntity', currentLesson?: { __typename?: 'CourseLessonEntity', id: number, order: number } | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null } }> } };

export type CourseFindOneLessonsQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type CourseFindOneLessonsQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', id: number, progressType: CourseProgressType, isParticipant?: boolean | null, product: { __typename?: 'ProductEntity', id: number, isFree: boolean, myAccess?: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, launch?: { __typename?: 'ProductLaunchEntity', id: number, educationStartAt?: any | null, educationFinishAt?: any | null } | null } | null }, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null } | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, scheduledPublishAt?: any | null, description: string, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type CourseLessonFindOneQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonFindOneQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', id: number, name: string, type: CourseType, progressType: CourseProgressType, isParticipant?: boolean | null, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, myProgressStatus?: CourseProgressLessonStatus | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null, product: { __typename?: 'ProductEntity', id: number, isFree: boolean, seller: { __typename?: 'SellerEntity', id: number }, myAccess?: { __typename?: 'ProductAccessEntity', id: number, participant?: { __typename?: 'ProductParticipantEntity', id: number, status: ProductParticipantStatus } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, scheduledPublishAt?: any | null, description: string, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }, courseLessonFindOne: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, previewImage?: string | null, myProgressStatus?: CourseProgressLessonStatus | null, publishedAt?: any | null, scheduledPublishAt?: any | null, isDemo: boolean, accessType: CourseLessonAccessType, viewsCount: number, isFinal: boolean, order: number, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, updatedAt?: any | null, deletedAt?: any | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, myProgressStatus?: CourseProgressLessonStatus | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } | null } | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, location?: string | null, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } }> } };

export type CourseLessonFindOneDemoQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonFindOneDemoQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', id: number, name: string, type: CourseType, progressType: CourseProgressType, isParticipant?: boolean | null, product: { __typename?: 'ProductEntity', id: number, isFree: boolean, seller: { __typename?: 'SellerEntity', id: number }, myAccess?: { __typename?: 'ProductAccessEntity', id: number, participant?: { __typename?: 'ProductParticipantEntity', id: number, status: ProductParticipantStatus } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, scheduledPublishAt?: any | null, description: string, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }, courseLessonFindOneDemo: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, previewImage?: string | null, myProgressStatus?: CourseProgressLessonStatus | null, publishedAt?: any | null, scheduledPublishAt?: any | null, isDemo: boolean, accessType: CourseLessonAccessType, viewsCount: number, isFinal: boolean, order: number, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, updatedAt?: any | null, deletedAt?: any | null, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, myProgressStatus?: CourseProgressLessonStatus | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } | null } | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, location?: string | null, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } }> } };

export type CourseLessonGetProgressStatusQueryVariables = Exact<{
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonGetProgressStatusQuery = { __typename?: 'Query', courseLessonGetProgressStatus: CourseProgressLessonStatus };

export type CourseLessonMetaUpsertMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  meta: CreateLessonMetaCourseInput;
}>;


export type CourseLessonMetaUpsertMutation = { __typename?: 'Mutation', courseLessonMetaUpsert: { __typename?: 'CourseLessonMetaEntity', id: number, isLiked: boolean, feedback: { __typename?: 'CourseLessonFeedback', rate?: number | null, isSent: boolean, comment?: string | null } } };

export type CourseLessonMetaFindOneQueryVariables = Exact<{
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonMetaFindOneQuery = { __typename?: 'Query', courseLessonMetaFindOne?: { __typename?: 'CourseLessonMetaEntity', id: number, isLiked: boolean, feedback: { __typename?: 'CourseLessonFeedback', rate?: number | null, isSent: boolean, comment?: string | null } } | null };

export type CourseLessonUpsertChatMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonUpsertChatMutation = { __typename?: 'Mutation', courseProgressUpsertChat?: { __typename?: 'ChatEntity', id: number, updatedAt?: any | null, type: ChatType, name?: string | null, description?: string | null, icon?: string | null, isAdmin: boolean, countUnread?: number | null, countMembers: number, lastAction?: any | null, sendMessagePermission: ChatActionPermission, personalCompanionUserId?: number | null, lastMessage?: { __typename?: 'ChatMessageEntity', id: number, createdAt: any, updatedAt?: any | null, type: ChatMessageType, text?: string | null, status: ChatMessageStatus, editedAt?: any | null, isMine: boolean, userTabUuid?: string | null, isRead: boolean, isEditable: boolean, replyMessage?: { __typename?: 'ChatMessageEntity', id: number, text?: string | null, createdAt: any, editedAt?: any | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, forwardUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, medias: Array<{ __typename?: 'ChatMessageMediaEntity', id: number, storage?: { __typename?: 'StorageFileEntity', id: number, location?: string | null, createdAt: any, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', small?: string | null, medium?: string | null, maximum: string }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } | null, widget?: { __typename?: 'ChatMessageWidget', type: MessageMediaWidgetType, data: { __typename?: 'ChatMessageWidgetData', contentElementUuid?: string | null, courseLessonPracticeAttemptUuid?: string | null } } | null }> } | null, myMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, deletedAt?: any | null } | null, personalCompanionMember?: { __typename?: 'ChatMemberEntity', id: number, muted: boolean, blocked: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null } | null };

export type CourseProgressStartNextManualMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  currentLessonId: Scalars['Int']['input'];
}>;


export type CourseProgressStartNextManualMutation = { __typename?: 'Mutation', courseProgressStartNextManual?: { __typename?: 'CourseProgressEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, next?: { __typename?: 'CourseLessonEntity', id: number } | null, previous?: { __typename?: 'CourseLessonEntity', id: number } | null } } | null };

export type CourseProgressUpdateByParticipantMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  progress: UpdateParticipantProgressCourseInput;
}>;


export type CourseProgressUpdateByParticipantMutation = { __typename?: 'Mutation', courseProgressUpdateByParticipant?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null };

export type ProductParticipantUpdateMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  participant: UpdateParticipantProductInput;
}>;


export type ProductParticipantUpdateMutation = { __typename?: 'Mutation', productParticipantUpdate: { __typename?: 'ProductParticipantEntity', id: number, status: ProductParticipantStatus } };

export type CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  practiceId: Scalars['Int']['input'];
  answer: SaveAnswerTaskInput;
}>;


export type CourseLessonPracticeAttemptSaveTaskAnswerMutation = { __typename?: 'Mutation', courseLessonPracticeAttemptSaveTaskAnswer: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } };

export type CourseLessonPracticeAttemptFinishAttemptMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  practiceId: Scalars['Int']['input'];
}>;


export type CourseLessonPracticeAttemptFinishAttemptMutation = { __typename?: 'Mutation', courseLessonPracticeAttemptFinishAttempt: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } };

export type AbsoluteCourseFragmentFragment = { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> };

export type CourseFragmentFragment = { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } };

export type CoursePreferenceSettingsFragmentFragment = { __typename?: 'CourseEntity', preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } };

export type CourseAuthorsFragmentFragment = { __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type CourseLessonBlocksInfoFragmentFragment = { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null };

export type CartUpsertMutationVariables = Exact<{
  cart: CreateCartInput;
  merge?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CartUpsertMutation = { __typename?: 'Mutation', cartUpsert: { __typename?: 'CartEntity', id: number, uuid: string, promoCodes: Array<string>, products: Array<{ __typename?: 'CartProduct', priceId: number, productId: number }> } };

export type ProductPriceExchangeFragmentFragment = { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null };

export type ProductParticipantFragmentFragment = { __typename?: 'ProductParticipantEntity', id: number, status: ProductParticipantStatus };

export type CoursesFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCourseInput;
  sort?: InputMaybe<SortCourseInput>;
}>;


export type CoursesFindManyQuery = { __typename?: 'Query', courseFindMany: { __typename?: 'ListCourseOutput', count: number, pages: number, items: Array<{ __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }> } };

export type EgeSubjectFragmentFragment = { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', duration?: number | null, passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } };

export type EgeSubjectAuthQueryVariables = Exact<{
  subject: EducationSubject;
}>;


export type EgeSubjectAuthQuery = { __typename?: 'Query', educationPreferenceGetExamsReminderState: Array<EducationSubject>, subjectFindOne: { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', duration?: number | null, passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } }, educationPreferenceGetUserSubjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject }>, taskGetSubjectCategoryStatistic: Array<{ __typename?: 'TaskSubjectStatistic', subjectCategoryId: number, subjectCategoryName: string, totalSolvedCount: number, correctSolvedCount: number, totalTaskCount: number }> };

export type EgeSubjectUnauthQueryVariables = Exact<{
  subject: EducationSubject;
}>;


export type EgeSubjectUnauthQuery = { __typename?: 'Query', subjectFindOne: { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', duration?: number | null, passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } } };

export type EgeSubjectDatesQueryVariables = Exact<{
  subject: EducationSubject;
}>;


export type EgeSubjectDatesQuery = { __typename?: 'Query', subjectFindOne: { __typename?: 'SubjectEntity', id: number, activeForTournament: boolean, subject: EducationSubject, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } } };

export type EgeSubjectExamineesQueryVariables = Exact<{
  subject: EducationSubject;
}>;


export type EgeSubjectExamineesQuery = { __typename?: 'Query', subjectFindManyMembers: { __typename?: 'ListMemberSubjectOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type EgeSetReminderStateMutationVariables = Exact<{
  subject: EducationSubject;
}>;


export type EgeSetReminderStateMutation = { __typename?: 'Mutation', educationPreferenceSetExamsReminderState: Array<EducationSubject> };

export type EgeTimeoutFragmentFragment = { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } };

export type EgeTimeoutAuthQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type EgeTimeoutAuthQuery = { __typename?: 'Query', educationPreferenceGetExamsReminderState: Array<EducationSubject>, subjectFindMany: { __typename?: 'ListSubjectOutput', items: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } }> } };

export type EgeTimeoutUnauthQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type EgeTimeoutUnauthQuery = { __typename?: 'Query', subjectFindMany: { __typename?: 'ListSubjectOutput', items: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null } }> } };

export type ArticleFragmentFragment = { __typename?: 'ArticleEntity', id: number, slug?: string | null, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> };

export type ArticleFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterArticleInput;
  sort: BaseSortInput;
}>;


export type ArticleFindManyQuery = { __typename?: 'Query', articleFindMany: { __typename?: 'ListArticleOutput', count: number, pages: number, items: Array<{ __typename?: 'ArticleEntity', id: number, slug?: string | null, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> }> } };

export type ArticleFindOneQueryVariables = Exact<{
  articleId: Scalars['Int']['input'];
}>;


export type ArticleFindOneQuery = { __typename?: 'Query', articleFindOne: { __typename?: 'ArticleEntity', id: number, slug?: string | null, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> } };

export type ArticleCreateMutationVariables = Exact<{
  article: CreateArticleInput;
}>;


export type ArticleCreateMutation = { __typename?: 'Mutation', articleCreate: { __typename?: 'ArticleEntity', id: number, slug?: string | null, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> } };

export type ArticleUpdateMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  article: UpdateArticleInput;
}>;


export type ArticleUpdateMutation = { __typename?: 'Mutation', articleUpdate: { __typename?: 'ArticleEntity', id: number, slug?: string | null, title?: string | null, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> } };

export type ArticleBlockManageCreateMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  contentElement: CreateElementContentInput;
}>;


export type ArticleBlockManageCreateMutation = { __typename?: 'Mutation', articleBlockManageCreate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type ArticleBlockManageUpdateMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
  contentElement: UpdateElementContentInput;
}>;


export type ArticleBlockManageUpdateMutation = { __typename?: 'Mutation', articleBlockManageUpdate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type ArticleBlockManageDeleteMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type ArticleBlockManageDeleteMutation = { __typename?: 'Mutation', articleBlockManageDelete: boolean };

export type ArticleBlockManageRecoverMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type ArticleBlockManageRecoverMutation = { __typename?: 'Mutation', articleBlockManageRecover: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type ArticleBlockManageUpdateOrderMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  blockOrder: UpdateBlockOrderArticleInput;
}>;


export type ArticleBlockManageUpdateOrderMutation = { __typename?: 'Mutation', articleBlockManageUpdateOrder: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> };

export type GetPartnerRequestsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterRequestSellerInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type GetPartnerRequestsQuery = { __typename?: 'Query', sellerBecomeRequestFindMany: { __typename?: 'ListRequestSellerOutput', pages: number, count: number, items: Array<{ __typename?: 'SellerBecomeRequestEntity', id: number, type: SellerType, status: SellerBecomeRequestStatus, organizationName?: string | null, organizationForm: SellerOrganizationForm, sellerOrganization?: { __typename?: 'SellerOrganizationEntity', id: number, logo?: string | null, name: string, form: SellerOrganizationForm } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type SellerReviewBecomeRequestMutationVariables = Exact<{
  requestId: Scalars['Int']['input'];
  status: SellerBecomeRequestStatus;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type SellerReviewBecomeRequestMutation = { __typename?: 'Mutation', sellerBecomeRequestReview: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus } };

export type GetUserDataQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserDataQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, verified: boolean, banned: boolean, permissions: Array<Permission>, vkId?: number | null, active: boolean, email?: string | null } } };

export type GetUserProfileQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type UserManageUpdateMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  userPartial: UpdateUserInput;
}>;


export type UserManageUpdateMutation = { __typename?: 'Mutation', userManageUpdate: { __typename?: 'UserEntity', id: number, banned: boolean, permissions: Array<Permission>, verified: boolean } };

export type UserFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterUserInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type UserFindManyQuery = { __typename?: 'Query', userFindMany: { __typename?: 'ListUserOutput', count: number, pages: number, items: Array<{ __typename?: 'UserEntity', id: number, verified: boolean, banned: boolean, active: boolean, vkId?: number | null, email?: string | null, permissions: Array<Permission>, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', sex: UserSexType, id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type LessonListItemFragmentFragment = { __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null };

export type CourseFindManyLessonsQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterLessonCourseInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type CourseFindManyLessonsQuery = { __typename?: 'Query', courseLessonFindMany: { __typename?: 'ListLessonCourseOutput', pages: number, items: Array<{ __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }> } };

export type CourseUpdateLessonOrderMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CourseUpdateLessonOrderMutation = { __typename?: 'Mutation', courseLessonManageUpdateOrder: Array<{ __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }> };

export type ProductFaqFragmentFragment = { __typename?: 'ProductFaqEntity', id: number, question: string, answer: any, active: boolean, isOpenedInUi: boolean };

export type ProductFaqFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFaqProductInput;
  sort?: InputMaybe<SortFaqProductInput>;
}>;


export type ProductFaqFindManyQuery = { __typename?: 'Query', productFaqFindMany: { __typename?: 'ListFaqProductOutput', count: number, items: Array<{ __typename?: 'ProductFaqEntity', id: number, question: string, answer: any, active: boolean, isOpenedInUi: boolean }> } };

export type ProductFaqFindOneQueryVariables = Exact<{
  faqId: Scalars['Int']['input'];
}>;


export type ProductFaqFindOneQuery = { __typename?: 'Query', productFaqFindOne: { __typename?: 'ProductFaqEntity', id: number, question: string, answer: any, active: boolean, isOpenedInUi: boolean } };

export type ProductFaqCreateMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  faq: CreateFaqProductInput;
}>;


export type ProductFaqCreateMutation = { __typename?: 'Mutation', productFaqCreate: { __typename?: 'ProductFaqEntity', id: number, question: string, answer: any, active: boolean, isOpenedInUi: boolean } };

export type ProductFaqUpdateMutationVariables = Exact<{
  faqId: Scalars['Int']['input'];
  faq: UpdateFaqProductInput;
}>;


export type ProductFaqUpdateMutation = { __typename?: 'Mutation', productFaqUpdate: { __typename?: 'ProductFaqEntity', id: number, question: string, answer: any, active: boolean, isOpenedInUi: boolean } };

export type ProductFaqUpdateOrderMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  faqIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProductFaqUpdateOrderMutation = { __typename?: 'Mutation', productFaqUpdateOrder: Array<{ __typename?: 'ProductFaqEntity', id: number }> };

export type CourseManageFragmentFragment = { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } };

export type CourseFindOneManageQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type CourseFindOneManageQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type CourseManageCheckCourseAliasQueryVariables = Exact<{
  alias: Scalars['String']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type CourseManageCheckCourseAliasQuery = { __typename?: 'Query', courseManageCheckCourseAlias: { __typename?: 'CheckAliasCourseOutput', success: boolean, cause?: CourseException | null, message?: string | null } };

export type CourseManageCreateMutationVariables = Exact<{
  course: CreateCourseInput;
}>;


export type CourseManageCreateMutation = { __typename?: 'Mutation', courseManageCreate: { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type CourseManageUpdateMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  course: UpdateCourseInput;
}>;


export type CourseManageUpdateMutation = { __typename?: 'Mutation', courseManageUpdate: { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type CourseManageCloneMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type CourseManageCloneMutation = { __typename?: 'Mutation', courseManageClone: { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } };

export type ProductUpdateMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  product: UpdateProductInput;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productManageUpdate: { __typename?: 'ProductEntity', id: number, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, saleStartAt?: any | null, saleFinishAt?: any | null, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number } | null, prices: Array<{ __typename?: 'ProductPriceEntity', id: number, amount: number, previousAmount?: number | null }> } };

export type CourseDatesUpdateMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  course: UpdateCourseInput;
  productId: Scalars['Int']['input'];
  product: UpdateProductInput;
}>;


export type CourseDatesUpdateMutation = { __typename?: 'Mutation', courseManageUpdate: { __typename?: 'CourseEntity', id: number }, productManageUpdate: { __typename?: 'ProductEntity', id: number, saleStartAt?: any | null, saleFinishAt?: any | null } };

export type ProductPriceFragmentFragment = { __typename?: 'ProductPriceEntity', id: number, amount: number, actualFrom?: any | null, actualTo?: any | null, activeFrom?: any | null, activeTo?: any | null, accessDays?: number | null, actualAccessDays?: number | null, previousAmount?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, active: boolean, isActive: boolean, isActiveByDate: boolean, infinityAccess: boolean, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency, isOnSale: boolean } };

export type ProductPriceFindOneQueryVariables = Exact<{
  priceId: Scalars['Int']['input'];
}>;


export type ProductPriceFindOneQuery = { __typename?: 'Query', productPriceFindOne: { __typename?: 'ProductPriceEntity', id: number, amount: number, actualFrom?: any | null, actualTo?: any | null, activeFrom?: any | null, activeTo?: any | null, accessDays?: number | null, actualAccessDays?: number | null, previousAmount?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, active: boolean, isActive: boolean, isActiveByDate: boolean, infinityAccess: boolean, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency, isOnSale: boolean } } };

export type ProductFindManyPricesQueryVariables = Exact<{
  list: ListInput;
  filter: FilterPriceProductInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ProductFindManyPricesQuery = { __typename?: 'Query', productPriceFindMany: { __typename?: 'ListPriceProductOutput', pages: number, count: number, items: Array<{ __typename?: 'ProductPriceEntity', id: number, amount: number, actualFrom?: any | null, actualTo?: any | null, activeFrom?: any | null, activeTo?: any | null, accessDays?: number | null, actualAccessDays?: number | null, previousAmount?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, active: boolean, isActive: boolean, isActiveByDate: boolean, infinityAccess: boolean, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency, isOnSale: boolean } }> } };

export type ProductCreatePriceMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  price: CreatePriceProductInput;
  launchId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductCreatePriceMutation = { __typename?: 'Mutation', productPriceCreate: { __typename?: 'ProductPriceEntity', id: number, amount: number, actualFrom?: any | null, actualTo?: any | null, activeFrom?: any | null, activeTo?: any | null, accessDays?: number | null, actualAccessDays?: number | null, previousAmount?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, active: boolean, isActive: boolean, isActiveByDate: boolean, infinityAccess: boolean, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency, isOnSale: boolean } } };

export type ProductUpdatePriceMutationVariables = Exact<{
  priceId: Scalars['Int']['input'];
  price: UpdatePriceProductInput;
}>;


export type ProductUpdatePriceMutation = { __typename?: 'Mutation', productPriceUpdate: { __typename?: 'ProductPriceEntity', id: number, amount: number, actualFrom?: any | null, actualTo?: any | null, activeFrom?: any | null, activeTo?: any | null, accessDays?: number | null, actualAccessDays?: number | null, previousAmount?: number | null, launchPeriodMode: ProductPriceLaunchPeriodMode, title?: string | null, description?: string | null, icon?: string | null, tags: Array<string>, active: boolean, isActive: boolean, isActiveByDate: boolean, infinityAccess: boolean, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency, isOnSale: boolean } } };

export type LaunchFragmentFragment = { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } };

export type ProductLaunchFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterLaunchProductInput;
  sort?: InputMaybe<SortLaunchProductInput>;
}>;


export type ProductLaunchFindManyQuery = { __typename?: 'Query', productLaunchFindMany: { __typename?: 'ListLaunchProductOutput', count: number, page: number, pages: number, items: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }> } };

export type ProductLaunchFindOneQueryVariables = Exact<{
  launchId: Scalars['Int']['input'];
}>;


export type ProductLaunchFindOneQuery = { __typename?: 'Query', productLaunchFindOne: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } };

export type ProductLaunchFindOneCrossedQueryVariables = Exact<{
  launchId: Scalars['Int']['input'];
  launch: CheckLaunchProductInput;
}>;


export type ProductLaunchFindOneCrossedQuery = { __typename?: 'Query', productLaunchFindOneCrossed?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null };

export type ProductLaunchCreateMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  launch: CreateLaunchProductInput;
}>;


export type ProductLaunchCreateMutation = { __typename?: 'Mutation', productLaunchCreate: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } };

export type ProductLaunchUpdateMutationVariables = Exact<{
  launchId: Scalars['Int']['input'];
  launch: UpdateLaunchProductInput;
}>;


export type ProductLaunchUpdateMutation = { __typename?: 'Mutation', productLaunchUpdate: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } };

export type ProductPublicationManualPublishLaunchMutationVariables = Exact<{
  launchId: Scalars['Int']['input'];
  publication: PublishLaunchProductInput;
}>;


export type ProductPublicationManualPublishLaunchMutation = { __typename?: 'Mutation', productPublicationManualPublishLaunch: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } };

export type LessonManageFragmentFragment = { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, withContent: boolean, withPractice: boolean, previewImage?: string | null, order: number, isDemo: boolean, accessType: CourseLessonAccessType, scheduledPublishAt?: any | null, publishedAt?: any | null, status: CourseLessonStatus, isPublished: boolean, isPublishedOrScheduled: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, uuid?: string | null, key?: string | null, location?: string | null, space: StorageSpace, bucketName: StorageBucketName, bucketType: StorageBucketType, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', medium?: string | null }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } }>, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, course: { __typename?: 'CourseEntity', id: number, subject: EducationSubject } };

export type LessonPracticeAttemptFragmentFragment = { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } };

export type LessonPracticeFragmentFragment = { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, deadlineInDays?: number | null, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null }, attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }>, activeAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, lastFinishedAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> };

export type GetLessonQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
}>;


export type GetLessonQuery = { __typename?: 'Query', courseLessonFindOne: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, withContent: boolean, withPractice: boolean, previewImage?: string | null, order: number, isDemo: boolean, accessType: CourseLessonAccessType, scheduledPublishAt?: any | null, publishedAt?: any | null, status: CourseLessonStatus, isPublished: boolean, isPublishedOrScheduled: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, uuid?: string | null, key?: string | null, location?: string | null, space: StorageSpace, bucketName: StorageBucketName, bucketType: StorageBucketType, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', medium?: string | null }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } }>, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, course: { __typename?: 'CourseEntity', id: number, subject: EducationSubject } } };

export type CourseLessonPracticeFindOneQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonPracticeFindOneQuery = { __typename?: 'Query', courseLessonPracticeFindOne?: { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, deadlineInDays?: number | null, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null }, attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }>, activeAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, lastFinishedAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> } | null };

export type CourseLessonPracticeManageFindOneQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonPracticeManageFindOneQuery = { __typename?: 'Query', courseLessonPracticeFindOne?: { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, deadlineInDays?: number | null, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null }, attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }>, activeAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, lastFinishedAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> } | null };

export type CourseLessonManageCreateMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  lesson: CreateLessonCourseInput;
}>;


export type CourseLessonManageCreateMutation = { __typename?: 'Mutation', courseLessonManageCreate: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, withContent: boolean, withPractice: boolean, previewImage?: string | null, order: number, isDemo: boolean, accessType: CourseLessonAccessType, scheduledPublishAt?: any | null, publishedAt?: any | null, status: CourseLessonStatus, isPublished: boolean, isPublishedOrScheduled: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, uuid?: string | null, key?: string | null, location?: string | null, space: StorageSpace, bucketName: StorageBucketName, bucketType: StorageBucketType, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', medium?: string | null }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } }>, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, course: { __typename?: 'CourseEntity', id: number, subject: EducationSubject } } };

export type CourseLessonManageCloneMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  sourceCourseId: Scalars['Int']['input'];
  targetCourseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CourseLessonManageCloneMutation = { __typename?: 'Mutation', courseLessonManageClone: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, withContent: boolean, withPractice: boolean, previewImage?: string | null, order: number, isDemo: boolean, accessType: CourseLessonAccessType, scheduledPublishAt?: any | null, publishedAt?: any | null, status: CourseLessonStatus, isPublished: boolean, isPublishedOrScheduled: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, uuid?: string | null, key?: string | null, location?: string | null, space: StorageSpace, bucketName: StorageBucketName, bucketType: StorageBucketType, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', medium?: string | null }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } }>, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, course: { __typename?: 'CourseEntity', id: number, subject: EducationSubject } } };

export type CourseLessonManageUpdateMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  lesson: UpdateLessonCourseInput;
}>;


export type CourseLessonManageUpdateMutation = { __typename?: 'Mutation', courseLessonManageUpdate?: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, withContent: boolean, withPractice: boolean, previewImage?: string | null, order: number, isDemo: boolean, accessType: CourseLessonAccessType, scheduledPublishAt?: any | null, publishedAt?: any | null, status: CourseLessonStatus, isPublished: boolean, isPublishedOrScheduled: boolean, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, medias: Array<{ __typename?: 'CourseLessonMediaEntity', id: number, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, storage: { __typename?: 'StorageFileEntity', id: number, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, uuid?: string | null, key?: string | null, location?: string | null, space: StorageSpace, bucketName: StorageBucketName, bucketType: StorageBucketType, fileType: StorageFileType, imageSizes: { __typename?: 'StorageSizedImage', medium?: string | null }, meta: { __typename?: 'StorageFileMeta', size: number, originalName?: string | null, duration?: number | null, mimeType?: string | null, dimensions?: { __typename?: 'StorageMetaDimensions', width: number, height: number } | null } } }>, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, course: { __typename?: 'CourseEntity', id: number, subject: EducationSubject } } | null };

export type CourseLessonManageDeleteMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
}>;


export type CourseLessonManageDeleteMutation = { __typename?: 'Mutation', courseLessonManageDelete: boolean };

export type CourseLessonPracticeManageCreateMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  practice: CreateLessonPracticeCourseInput;
}>;


export type CourseLessonPracticeManageCreateMutation = { __typename?: 'Mutation', courseLessonPracticeManageCreate: { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, deadlineInDays?: number | null, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null }, attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }>, activeAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, lastFinishedAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> } };

export type CourseLessonPracticeManageUpdateMutationVariables = Exact<{
  lessonPracticeId: Scalars['Int']['input'];
  practice: UpdateLessonPracticeCourseInput;
}>;


export type CourseLessonPracticeManageUpdateMutation = { __typename?: 'Mutation', courseLessonPracticeManageUpdate: { __typename?: 'CourseLessonPracticeEntity', id: number, description: string, deadlineInDays?: number | null, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null }, attempts: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } }>, activeAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, lastFinishedAttempt?: { __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, sentToReviewAt?: any | null, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, course: { __typename?: 'CourseEntity', id: number, name: string }, myProgress?: { __typename?: 'CourseProgressEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean, next?: { __typename?: 'CourseLessonEntity', id: number, myProgressStatus?: CourseProgressLessonStatus | null, canStartNextLesson: boolean } | null } | null }, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null, tasks: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> } };

export type CourseLessonPracticeManageUpdateTaskOrderMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  lessonPracticeId: Scalars['Int']['input'];
  taskOrder: UpdateLessonPracticeTaskOrderCourseInput;
}>;


export type CourseLessonPracticeManageUpdateTaskOrderMutation = { __typename?: 'Mutation', courseLessonPracticeTaskManageUpdateOrder: Array<{ __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number }> };

export type CourseLessonBlockManageCreateMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  contentElement: CreateElementContentInput;
}>;


export type CourseLessonBlockManageCreateMutation = { __typename?: 'Mutation', courseLessonBlockManageCreate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type CourseLessonBlockManageUpdateMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
  contentElement: UpdateElementContentInput;
}>;


export type CourseLessonBlockManageUpdateMutation = { __typename?: 'Mutation', courseLessonBlockManageUpdate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, lesson?: { __typename?: 'CourseLessonEntity', id: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null } } | null, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type CourseLessonBlockManageDeleteMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type CourseLessonBlockManageDeleteMutation = { __typename?: 'Mutation', courseLessonBlockManageDelete: boolean };

export type CourseLessonBlockManageRecoverMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type CourseLessonBlockManageRecoverMutation = { __typename?: 'Mutation', courseLessonBlockManageRecover: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type CourseLessonBlockManageUpdateOrderMutationVariables = Exact<{
  lessonId: Scalars['Int']['input'];
  blockOrder: UpdateLessonBlockOrderCourseInput;
}>;


export type CourseLessonBlockManageUpdateOrderMutation = { __typename?: 'Mutation', courseLessonBlockManageUpdateOrder: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> };

export type ContentElementListenUpdateSubscriptionVariables = Exact<{
  contentElementUuid: Scalars['String']['input'];
}>;


export type ContentElementListenUpdateSubscription = { __typename?: 'Subscription', contentElementListenUpdate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type CourseLessonPracticeTaskManageCreateMutationVariables = Exact<{
  lessonPracticeId: Scalars['Int']['input'];
  task: CreateTaskInput;
}>;


export type CourseLessonPracticeTaskManageCreateMutation = { __typename?: 'Mutation', courseLessonPracticeTaskManageCreate: { __typename?: 'CourseLessonPracticeTaskEntity', id: number, order: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } };

export type CourseLessonPracticeTaskManageDeleteMutationVariables = Exact<{
  practiceTaskId: Scalars['Int']['input'];
}>;


export type CourseLessonPracticeTaskManageDeleteMutation = { __typename?: 'Mutation', courseLessonPracticeTaskManageDelete: boolean };

export type CourseFindManyManageQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCourseInput;
  sort?: InputMaybe<SortCourseInput>;
}>;


export type CourseFindManyManageQuery = { __typename?: 'Query', courseFindMany: { __typename?: 'ListCourseOutput', count: number, pages: number, items: Array<{ __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }> } };

export type GetCoursesManageQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCourseInput;
  sort?: InputMaybe<SortCourseInput>;
}>;


export type GetCoursesManageQuery = { __typename?: 'Query', courseFindMany: { __typename?: 'ListCourseOutput', pages: number, items: Array<{ __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }> } };

export type CourseCountByTypeQueryVariables = Exact<{
  mode: CountByTypeMode;
  filter: FilterCourseInput;
}>;


export type CourseCountByTypeQuery = { __typename?: 'Query', courseCountByType: { __typename?: 'CourseCountByType', totalCount?: number | null, VideoCourse?: number | null, TextCourse?: number | null, MasterClass?: number | null, Webinar?: number | null, PersonalLesson?: number | null } };

export type CoursePublicationCheckItemFragmentFragment = { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null };

export type CourseCheckLaunchPublicationQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  launchId: Scalars['Int']['input'];
}>;


export type CourseCheckLaunchPublicationQuery = { __typename?: 'Query', courseCheckLaunchPublication: { __typename?: 'CoursePublicationCheck', available: boolean, details: { __typename?: 'CoursePublicationDetailsCheck', valid: boolean, name: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, description: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, tags: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, categories: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null } }, branding: { __typename?: 'CoursePublicationBrandingCheck', valid: boolean, image: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null } }, authors: { __typename?: 'CoursePublicationAuthorsCheck', valid: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, authors?: Array<{ __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }> | null }, content: { __typename?: 'CoursePublicationContentCheck', valid: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, lessons?: Array<{ __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }> | null }, pricing?: { __typename?: 'CoursePublicationPricingCheck', valid: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, prices?: Array<{ __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }> | null } | null, date: { __typename?: 'CoursePublicationDateCheck', valid: boolean, saleDates: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null }, educationDates: { __typename?: 'CoursePublicationCheckItem', name: string, valid: boolean, description?: string | null, entityId?: number | null, entity?: CoursePublicationCheckItemEntity | null, errors?: Array<string> | null, icon?: string | null } } }, courseFindOne: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }, productLaunchFindOne: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } };

export type ProductManageUpsertReviewTicketMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type ProductManageUpsertReviewTicketMutation = { __typename?: 'Mutation', productManageUpsertReviewTicket: { __typename?: 'SupportTicketEntity', id: number, chat?: { __typename?: 'ChatEntity', id: number } | null } };

export type ProductPublicationReviewLaunchMutationVariables = Exact<{
  launchId: Scalars['Int']['input'];
  review: ReviewLaunchProductInput;
}>;


export type ProductPublicationReviewLaunchMutation = { __typename?: 'Mutation', productPublicationReviewLaunch: { __typename?: 'ProductLaunchEntity', id: number, status: ProductLaunchStatus } };

export type GroupFragmentFragment = { __typename?: 'GroupEntity', id: number, uuid: string, space: GroupSpace, name: string, maxMembers?: number | null, countMembers: number, channel?: { __typename?: 'ChatEntity', id: number } | null, groupChat?: { __typename?: 'ChatEntity', id: number } | null, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, communication: { __typename?: 'GroupCommunication', channelIsActive: boolean, groupChatIsActive: boolean, dialogueWithEmployeesBlocked: boolean }, accessLimitation: { __typename?: 'GroupAccessLimitation', active: boolean, startPointType?: GroupAccessStartPointType | null, durationInMinutes?: number | null, commonDateStartAt?: any | null }, scheduleLimitation: { __typename?: 'GroupScheduleLimitation', active: boolean, type?: GroupScheduleType | null, openUnit?: GroupScheduleOpenUnit | null, byWeekdays?: { __typename?: 'GroupScheduleLimitationWeekdays', selected: Array<number>, startFrom: any } | null, onceForInterval?: { __typename?: 'GroupScheduleLimitationInterval', durationInMinutes: number, startFrom: any } | null }, contentLimitation: { __typename?: 'GroupContentLimitation', disableSendHomework: boolean, hideEarlyAccessLessons: boolean, lessons?: any | null } };

export type GroupMemberFragmentFragment = { __typename?: 'GroupMemberEntity', id: number, active: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, firstName?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } }, group: { __typename?: 'GroupEntity', id: number, launch?: { __typename?: 'ProductLaunchEntity', id: number, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null } };

export type GroupFindOneQueryVariables = Exact<{
  groupId: Scalars['Int']['input'];
}>;


export type GroupFindOneQuery = { __typename?: 'Query', groupFindOne: { __typename?: 'GroupEntity', id: number, uuid: string, space: GroupSpace, name: string, maxMembers?: number | null, countMembers: number, product?: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, type: CourseType, image: { __typename?: 'CourseImage', main?: string | null } } | null } | null, channel?: { __typename?: 'ChatEntity', id: number } | null, groupChat?: { __typename?: 'ChatEntity', id: number } | null, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, communication: { __typename?: 'GroupCommunication', channelIsActive: boolean, groupChatIsActive: boolean, dialogueWithEmployeesBlocked: boolean }, accessLimitation: { __typename?: 'GroupAccessLimitation', active: boolean, startPointType?: GroupAccessStartPointType | null, durationInMinutes?: number | null, commonDateStartAt?: any | null }, scheduleLimitation: { __typename?: 'GroupScheduleLimitation', active: boolean, type?: GroupScheduleType | null, openUnit?: GroupScheduleOpenUnit | null, byWeekdays?: { __typename?: 'GroupScheduleLimitationWeekdays', selected: Array<number>, startFrom: any } | null, onceForInterval?: { __typename?: 'GroupScheduleLimitationInterval', durationInMinutes: number, startFrom: any } | null }, contentLimitation: { __typename?: 'GroupContentLimitation', disableSendHomework: boolean, hideEarlyAccessLessons: boolean, lessons?: any | null } } };

export type GroupFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterGroupInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type GroupFindManyQuery = { __typename?: 'Query', groupFindMany: { __typename?: 'ListGroupOutput', page: number, count: number, pages: number, items: Array<{ __typename?: 'GroupEntity', id: number, uuid: string, space: GroupSpace, name: string, maxMembers?: number | null, countMembers: number, channel?: { __typename?: 'ChatEntity', id: number } | null, groupChat?: { __typename?: 'ChatEntity', id: number } | null, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, communication: { __typename?: 'GroupCommunication', channelIsActive: boolean, groupChatIsActive: boolean, dialogueWithEmployeesBlocked: boolean }, accessLimitation: { __typename?: 'GroupAccessLimitation', active: boolean, startPointType?: GroupAccessStartPointType | null, durationInMinutes?: number | null, commonDateStartAt?: any | null }, scheduleLimitation: { __typename?: 'GroupScheduleLimitation', active: boolean, type?: GroupScheduleType | null, openUnit?: GroupScheduleOpenUnit | null, byWeekdays?: { __typename?: 'GroupScheduleLimitationWeekdays', selected: Array<number>, startFrom: any } | null, onceForInterval?: { __typename?: 'GroupScheduleLimitationInterval', durationInMinutes: number, startFrom: any } | null }, contentLimitation: { __typename?: 'GroupContentLimitation', disableSendHomework: boolean, hideEarlyAccessLessons: boolean, lessons?: any | null } }> } };

export type GroupManageCreateMutationVariables = Exact<{
  group: CreateGroupInput;
}>;


export type GroupManageCreateMutation = { __typename?: 'Mutation', groupManageCreate: { __typename?: 'GroupEntity', id: number, uuid: string, space: GroupSpace, name: string, maxMembers?: number | null, countMembers: number, channel?: { __typename?: 'ChatEntity', id: number } | null, groupChat?: { __typename?: 'ChatEntity', id: number } | null, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, communication: { __typename?: 'GroupCommunication', channelIsActive: boolean, groupChatIsActive: boolean, dialogueWithEmployeesBlocked: boolean }, accessLimitation: { __typename?: 'GroupAccessLimitation', active: boolean, startPointType?: GroupAccessStartPointType | null, durationInMinutes?: number | null, commonDateStartAt?: any | null }, scheduleLimitation: { __typename?: 'GroupScheduleLimitation', active: boolean, type?: GroupScheduleType | null, openUnit?: GroupScheduleOpenUnit | null, byWeekdays?: { __typename?: 'GroupScheduleLimitationWeekdays', selected: Array<number>, startFrom: any } | null, onceForInterval?: { __typename?: 'GroupScheduleLimitationInterval', durationInMinutes: number, startFrom: any } | null }, contentLimitation: { __typename?: 'GroupContentLimitation', disableSendHomework: boolean, hideEarlyAccessLessons: boolean, lessons?: any | null } } };

export type GroupManageUpdateMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
  group: UpdateGroupInput;
}>;


export type GroupManageUpdateMutation = { __typename?: 'Mutation', groupManageUpdate: { __typename?: 'GroupEntity', id: number, uuid: string, space: GroupSpace, name: string, maxMembers?: number | null, countMembers: number, channel?: { __typename?: 'ChatEntity', id: number } | null, groupChat?: { __typename?: 'ChatEntity', id: number } | null, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, communication: { __typename?: 'GroupCommunication', channelIsActive: boolean, groupChatIsActive: boolean, dialogueWithEmployeesBlocked: boolean }, accessLimitation: { __typename?: 'GroupAccessLimitation', active: boolean, startPointType?: GroupAccessStartPointType | null, durationInMinutes?: number | null, commonDateStartAt?: any | null }, scheduleLimitation: { __typename?: 'GroupScheduleLimitation', active: boolean, type?: GroupScheduleType | null, openUnit?: GroupScheduleOpenUnit | null, byWeekdays?: { __typename?: 'GroupScheduleLimitationWeekdays', selected: Array<number>, startFrom: any } | null, onceForInterval?: { __typename?: 'GroupScheduleLimitationInterval', durationInMinutes: number, startFrom: any } | null }, contentLimitation: { __typename?: 'GroupContentLimitation', disableSendHomework: boolean, hideEarlyAccessLessons: boolean, lessons?: any | null } } };

export type GroupMemberFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterMemberGroupInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type GroupMemberFindManyQuery = { __typename?: 'Query', groupMemberFindMany: { __typename?: 'ListMemberGroupOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'GroupMemberEntity', id: number, active: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, firstName?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } }, group: { __typename?: 'GroupEntity', id: number, launch?: { __typename?: 'ProductLaunchEntity', id: number, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null } }> } };

export type GroupMemberCreateManyMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GroupMemberCreateManyMutation = { __typename?: 'Mutation', groupMemberCreateMany: Array<{ __typename?: 'GroupMemberEntity', id: number, active: boolean, blockedUntil?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, firstName?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } }, group: { __typename?: 'GroupEntity', id: number, launch?: { __typename?: 'ProductLaunchEntity', id: number, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null } }> };

export type GroupMemberDeleteManyMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GroupMemberDeleteManyMutation = { __typename?: 'Mutation', groupMemberDeleteMany: number };

export type InvoiceFragmentFragment = { __typename?: 'InvoiceEntity', id: number, uuid: string, humanId: string, currency: ProductCurrency, createdAt: any, discountAmount: number, totalAmount: number, expireAt?: any | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type InvoiceManageFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterInvoiceInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type InvoiceManageFindManyQuery = { __typename?: 'Query', invoiceManageFindMany: { __typename?: 'ListInvoiceOutput', count: number, pages: number, items: Array<{ __typename?: 'InvoiceEntity', id: number, uuid: string, humanId: string, currency: ProductCurrency, createdAt: any, discountAmount: number, totalAmount: number, expireAt?: any | null, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, isCanceled: boolean, paidAt?: any | null } | null, products?: Array<{ __typename?: 'InvoiceProductEntity', id: number, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }> | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type InvoiceManageFindOneByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceManageFindOneByUuidQuery = { __typename?: 'Query', invoiceManageFindOne: { __typename?: 'InvoiceEntity', id: number, uuid: string, humanId: string, currency: ProductCurrency, createdAt: any, discountAmount: number, totalAmount: number, expireAt?: any | null, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, isCanceled: boolean, paidAt?: any | null, checkoutUrl?: string | null } | null, products?: Array<{ __typename?: 'InvoiceProductEntity', id: number, totalPrice: number, discountAmount: number, price: { __typename?: 'ProductPriceEntity', id: number, title?: string | null }, product: { __typename?: 'ProductEntity', id: number, type: ProductType, currency: ProductCurrency, course?: { __typename?: 'CourseEntity', minDurationInDays: number, id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, product: { __typename?: 'ProductEntity', groupsCount: number, id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, launches: Array<{ __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } }>, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, countModules: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, countLessons: { __typename?: 'CourseLessonCount', Published?: number | null, Draft?: number | null, ReadyToPublish?: number | null, totalCount?: number | null }, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null } }> | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type PaymentFragmentFragment = { __typename?: 'PaymentEntity', id: number, createdAt: any, expireAt?: any | null, paidAt?: any | null, status: PaymentStatus, isCompleted: boolean, isCanceled: boolean, isRecurrent: boolean, checkoutPaymentId?: string | null, acquiring?: { __typename?: 'AcquiringEntity', provider: { __typename?: 'PaymentProviderEntity', id: number, type: PaymentProviderType, icon?: string | null } } | null, payerDetails: { __typename?: 'PayerDetailsPayment', cardNumber?: string | null }, invoice: { __typename?: 'InvoiceEntity', id: number, uuid: string, currency: ProductCurrency, totalAmount: number } };

export type PaymentManageFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterPaymentInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type PaymentManageFindManyQuery = { __typename?: 'Query', paymentManageFindMany: { __typename?: 'ListPaymentOutput', count: number, pages: number, items: Array<{ __typename?: 'PaymentEntity', id: number, createdAt: any, expireAt?: any | null, paidAt?: any | null, status: PaymentStatus, isCompleted: boolean, isCanceled: boolean, isRecurrent: boolean, checkoutPaymentId?: string | null, acquiring?: { __typename?: 'AcquiringEntity', provider: { __typename?: 'PaymentProviderEntity', id: number, type: PaymentProviderType, icon?: string | null } } | null, payerDetails: { __typename?: 'PayerDetailsPayment', cardNumber?: string | null }, invoice: { __typename?: 'InvoiceEntity', id: number, uuid: string, currency: ProductCurrency, totalAmount: number } }> } };

export type PayoutRequisiteFragmentFragment = { __typename?: 'PayoutRequisiteEntity', id: number, bic: string, bankName: string, correspondentAccount: string, bankAccountNumber: string, updatedAt?: any | null, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string } } | null };

export type PayoutOperationFragmentFragment = { __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null };

export type PayoutFindOneDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoutFindOneDetailQuery = { __typename?: 'Query', payoutRequisiteFindOneActive?: { __typename?: 'PayoutRequisiteEntity', id: number, bic: string, bankName: string, correspondentAccount: string, bankAccountNumber: string, updatedAt?: any | null, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string } } | null } | null, sellerCurrentUserSeller?: { __typename?: 'SellerEntity', id: number, verified: boolean } | null };

export type PayoutRequisiteFindOneActiveQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoutRequisiteFindOneActiveQuery = { __typename?: 'Query', payoutRequisiteFindOneActive?: { __typename?: 'PayoutRequisiteEntity', id: number, bic: string, bankName: string, correspondentAccount: string, bankAccountNumber: string, updatedAt?: any | null, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string } } | null } | null, sellerBalanceCurrent: { __typename?: 'SellerCurrentBalanceOutput', balance: number, payoutBalance: number } };

export type PayoutRequisiteCreateMutationVariables = Exact<{
  requisite: CreateRequisitePayoutInput;
}>;


export type PayoutRequisiteCreateMutation = { __typename?: 'Mutation', payoutRequisiteCreate: { __typename?: 'PayoutRequisiteEntity', id: number, bic: string, bankName: string, correspondentAccount: string, bankAccountNumber: string, updatedAt?: any | null, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string } } | null } };

export type PayoutOperationFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterOperationPayoutInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type PayoutOperationFindManyQuery = { __typename?: 'Query', payoutOperationFindMany: { __typename?: 'ListOperationPayoutOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, operations: Array<{ __typename?: 'SellerBalanceOperationEntity', id: number }>, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null }> } };

export type PayoutOperationSumAmountByFilterQueryVariables = Exact<{
  countFilter: FilterOperationPayoutInput;
  sumFilter: FilterOperationPayoutInput;
}>;


export type PayoutOperationSumAmountByFilterQuery = { __typename?: 'Query', payoutOperationCountByFilter: number, payoutOperationSumAmountByFilter: number, sellerBalanceCurrent: { __typename?: 'SellerCurrentBalanceOutput', balance: number, payoutBalance: number } };

export type PayoutOperationCalculateBeforePayoutQueryVariables = Exact<{
  operation: CreateOperationPayoutInput;
}>;


export type PayoutOperationCalculateBeforePayoutQuery = { __typename?: 'Query', payoutOperationCalculateBeforePayout: { __typename?: 'TransferDetailsOnPayoutOutput', minAmount?: number | null, isInternal: boolean, transferAmount: number, transactionAmount: number } };

export type PayoutOperationCreateMutationVariables = Exact<{
  operation: CreateOperationPayoutInput;
}>;


export type PayoutOperationCreateMutation = { __typename?: 'Mutation', payoutOperationCreate: { __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null } };

export type DiscountFragmentFragment = { __typename?: 'DiscountEntity', id: number, code: string, type: DiscountType, value: number, active: boolean, maxApplies?: number | null, isScheduled: boolean, countApplies: number, activeFrom?: any | null, activeTo?: any | null, note?: string | null, isActive: boolean, isActiveByDate: boolean, isActiveByCountApplies: boolean };

export type DiscountManageFindOneQueryVariables = Exact<{
  discountId: Scalars['Int']['input'];
}>;


export type DiscountManageFindOneQuery = { __typename?: 'Query', discountManageFindOne: { __typename?: 'DiscountEntity', id: number, code: string, type: DiscountType, value: number, active: boolean, maxApplies?: number | null, isScheduled: boolean, countApplies: number, activeFrom?: any | null, activeTo?: any | null, note?: string | null, isActive: boolean, isActiveByDate: boolean, isActiveByCountApplies: boolean } };

export type DiscountManageFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterDiscountInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type DiscountManageFindManyQuery = { __typename?: 'Query', discountManageFindMany: { __typename?: 'ListDiscountOutput', count: number, pages: number, items: Array<{ __typename?: 'DiscountEntity', id: number, code: string, type: DiscountType, value: number, active: boolean, maxApplies?: number | null, isScheduled: boolean, countApplies: number, activeFrom?: any | null, activeTo?: any | null, note?: string | null, isActive: boolean, isActiveByDate: boolean, isActiveByCountApplies: boolean }> } };

export type DiscountManageCreateMutationVariables = Exact<{
  discount: CreateDiscountInput;
}>;


export type DiscountManageCreateMutation = { __typename?: 'Mutation', discountManageCreate: { __typename?: 'DiscountEntity', id: number, code: string, type: DiscountType, value: number, active: boolean, maxApplies?: number | null, isScheduled: boolean, countApplies: number, activeFrom?: any | null, activeTo?: any | null, note?: string | null, isActive: boolean, isActiveByDate: boolean, isActiveByCountApplies: boolean } };

export type DiscountManageUpdateMutationVariables = Exact<{
  discountId: Scalars['Int']['input'];
  discount: UpdateDiscountInput;
}>;


export type DiscountManageUpdateMutation = { __typename?: 'Mutation', discountManageUpdate: { __typename?: 'DiscountEntity', id: number, code: string, type: DiscountType, value: number, active: boolean, maxApplies?: number | null, isScheduled: boolean, countApplies: number, activeFrom?: any | null, activeTo?: any | null, note?: string | null, isActive: boolean, isActiveByDate: boolean, isActiveByCountApplies: boolean } };

export type PaymentProviderFragmentFragment = { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } };

export type SchoolAcquiringFragmentFragment = { __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null };

export type PaymentProviderFindOneActiveByTypeQueryVariables = Exact<{
  paymentProviderType: PaymentProviderType;
}>;


export type PaymentProviderFindOneActiveByTypeQuery = { __typename?: 'Query', paymentProviderFindOneActiveByType: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } } };

export type PaymentProviderFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterProviderPaymentInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type PaymentProviderFindManyQuery = { __typename?: 'Query', paymentProviderFindMany: { __typename?: 'ListProviderPaymentOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }> } };

export type SchoolAcquiringCreateMutationVariables = Exact<{
  acquiring: CreateAcquiringInput;
}>;


export type SchoolAcquiringCreateMutation = { __typename?: 'Mutation', schoolAcquiringCreate: { __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null } };

export type SchoolAcquiringUpdateMutationVariables = Exact<{
  acquiringId: Scalars['Int']['input'];
  acquiring: UpdateAcquiringInput;
}>;


export type SchoolAcquiringUpdateMutation = { __typename?: 'Mutation', schoolAcquiringUpdate: { __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null } };

export type SchoolAcquiringFindOneQueryVariables = Exact<{
  acquiringId: Scalars['Int']['input'];
}>;


export type SchoolAcquiringFindOneQuery = { __typename?: 'Query', schoolAcquiringFindOne: { __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null } };

export type SchoolAcquiringFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterAcquiringInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SchoolAcquiringFindManyQuery = { __typename?: 'Query', schoolAcquiringFindMany: { __typename?: 'ListAcquiringManageOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null }> } };

export type SchoolAcquiringUpdateOrderMutationVariables = Exact<{
  acquiringIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SchoolAcquiringUpdateOrderMutation = { __typename?: 'Mutation', schoolAcquiringUpdateOrder: Array<{ __typename?: 'AcquiringManage', id: number, uuid: string, active: boolean, config: any, name?: string | null, description?: string | null, note?: string | null, updatedAt?: any | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } }, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null } } } | null }> };

export type SchoolContentCategoryCreateMutationVariables = Exact<{
  category: CreateCategoryContentInput;
}>;


export type SchoolContentCategoryCreateMutation = { __typename?: 'Mutation', schoolContentCategoryCreate: { __typename?: 'ContentCategoryEntity', id: number, space: ContentCategorySpace, slug?: string | null, order: number, name?: string | null, visible: boolean, subjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> } };

export type SchoolContentCategoryUpdateMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  category: UpdateCategoryContentInput;
}>;


export type SchoolContentCategoryUpdateMutation = { __typename?: 'Mutation', schoolContentCategoryUpdate: { __typename?: 'ContentCategoryEntity', id: number, space: ContentCategorySpace, slug?: string | null, order: number, name?: string | null, visible: boolean, subjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> } };

export type SchoolSubjectCreateMutationVariables = Exact<{
  subject: CreateSubjectInput;
}>;


export type SchoolSubjectCreateMutation = { __typename?: 'Mutation', schoolSubjectCreate: { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null } };

export type SchoolSubjectUpdateMutationVariables = Exact<{
  subjectId: Scalars['Int']['input'];
  subject: UpdateSubjectInput;
}>;


export type SchoolSubjectUpdateMutation = { __typename?: 'Mutation', schoolSubjectUpdate: { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null } };

export type SellerOrganizationDocumentFragmentFragment = { __typename?: 'SellerOrganizationDocumentEntity', id: number, type: SellerOrganizationDocumentType, name?: string | null, location: string, config: { __typename?: 'SellerOrganizationDocumentConfig', type?: SellerOrganizationSelfUploadedDocumentType | null, uploadMode?: SellerOrganizationDocumentUploadMode | null, showInFooter?: boolean | null }, storage?: { __typename?: 'StorageFileEntity', id: number, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } | null };

export type SellerOrganizationDocumentFindOneQueryVariables = Exact<{
  documentId: Scalars['Int']['input'];
}>;


export type SellerOrganizationDocumentFindOneQuery = { __typename?: 'Query', sellerOrganizationDocumentFindOne: { __typename?: 'SellerOrganizationDocumentEntity', id: number, type: SellerOrganizationDocumentType, name?: string | null, location: string, config: { __typename?: 'SellerOrganizationDocumentConfig', type?: SellerOrganizationSelfUploadedDocumentType | null, uploadMode?: SellerOrganizationDocumentUploadMode | null, showInFooter?: boolean | null }, storage?: { __typename?: 'StorageFileEntity', id: number, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } | null } };

export type SellerOrganizationDocumentFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterOrganizationDocumentSellerInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SellerOrganizationDocumentFindManyQuery = { __typename?: 'Query', sellerOrganizationDocumentFindMany: { __typename?: 'ListOrganizationDocumentsSellerOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'SellerOrganizationDocumentEntity', id: number, type: SellerOrganizationDocumentType, name?: string | null, location: string, config: { __typename?: 'SellerOrganizationDocumentConfig', type?: SellerOrganizationSelfUploadedDocumentType | null, uploadMode?: SellerOrganizationDocumentUploadMode | null, showInFooter?: boolean | null }, storage?: { __typename?: 'StorageFileEntity', id: number, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } | null }> } };

export type SellerOrganizationDocumentCreateMutationVariables = Exact<{
  document: CreateOrganizationDocumentSellerInput;
}>;


export type SellerOrganizationDocumentCreateMutation = { __typename?: 'Mutation', sellerOrganizationDocumentCreate: { __typename?: 'SellerOrganizationDocumentEntity', id: number, type: SellerOrganizationDocumentType, name?: string | null, location: string, config: { __typename?: 'SellerOrganizationDocumentConfig', type?: SellerOrganizationSelfUploadedDocumentType | null, uploadMode?: SellerOrganizationDocumentUploadMode | null, showInFooter?: boolean | null }, storage?: { __typename?: 'StorageFileEntity', id: number, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } | null } };

export type SellerOrganizationDocumentUpdateMutationVariables = Exact<{
  documentId: Scalars['Int']['input'];
  document: UpdateOrganizationDocumentSellerInput;
}>;


export type SellerOrganizationDocumentUpdateMutation = { __typename?: 'Mutation', sellerOrganizationDocumentUpdate: { __typename?: 'SellerOrganizationDocumentEntity', id: number, type: SellerOrganizationDocumentType, name?: string | null, location: string, config: { __typename?: 'SellerOrganizationDocumentConfig', type?: SellerOrganizationSelfUploadedDocumentType | null, uploadMode?: SellerOrganizationDocumentUploadMode | null, showInFooter?: boolean | null }, storage?: { __typename?: 'StorageFileEntity', id: number, meta: { __typename?: 'StorageFileMeta', size: number, mimeType?: string | null, originalName?: string | null } } | null } };

export type SchoolOrganizationUpdateMutationVariables = Exact<{
  sellerOrganizationId: Scalars['Int']['input'];
  organization: UpdateOrganizationSchoolInput;
}>;


export type SchoolOrganizationUpdateMutation = { __typename?: 'Mutation', schoolOrganizationUpdate: { __typename?: 'SellerOrganizationEntity', id: number, inn?: string | null, name: string, logo?: string | null, form: SellerOrganizationForm, createdAt: any, updatedAt?: any | null } };

export type SchoolManageFindManyMineQueryVariables = Exact<{ [key: string]: never; }>;


export type SchoolManageFindManyMineQuery = { __typename?: 'Query', schoolManageFindManyMine: Array<{ __typename?: 'SchoolEntity', id: number, name: string, description?: string | null, iconUrl?: string | null, domainType: SchoolDomainType, customDomain?: string | null, baseDomain: string, access: { __typename?: 'ProductAccessEntity', id: number, expireAt?: any | null, isActive: boolean } }> };

export type SchoolManageFragmentFragment = { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, customCode: { __typename?: 'SchoolCustomCode', js?: string | null, css?: string | null }, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } };

export type SchoolManageCheckDomainQueryVariables = Exact<{
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  domain: Scalars['String']['input'];
  domainType: SchoolDomainType;
}>;


export type SchoolManageCheckDomainQuery = { __typename?: 'Query', schoolManageCheckDomain: { __typename?: 'CheckDomainSchoolOutput', success: boolean, cause?: SchoolException | null, message?: string | null } };

export type SchoolManageUpdateMutationVariables = Exact<{
  schoolId: Scalars['Int']['input'];
  school: UpdateSchoolInput;
}>;


export type SchoolManageUpdateMutation = { __typename?: 'Mutation', schoolManageUpdate: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, customCode: { __typename?: 'SchoolCustomCode', js?: string | null, css?: string | null }, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type SchoolPriceFragmentFragment = { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } };

export type SchoolPriceFindManyActiveQueryVariables = Exact<{
  currency: ProductCurrency;
}>;


export type SchoolPriceFindManyActiveQuery = { __typename?: 'Query', schoolPriceFindManyActive: Array<{ __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } }> };

export type SchoolUserFindManyFragmentFragment = { __typename?: 'UserEntity', id: number, phone?: string | null, email?: string | null, banned: boolean, activated: boolean, lastOnlineAt: any, productAccessesCount?: number | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number }, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type SchoolUserFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterUserInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SchoolUserFindManyQuery = { __typename?: 'Query', schoolUserFindMany: { __typename?: 'ListUserOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'UserEntity', id: number, phone?: string | null, email?: string | null, banned: boolean, activated: boolean, lastOnlineAt: any, productAccessesCount?: number | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number }, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type SchoolUserManageCreateManyMutationVariables = Exact<{
  users: CreateManyUserInput;
  enrollments?: InputMaybe<CreateAccessManyProductInput>;
}>;


export type SchoolUserManageCreateManyMutation = { __typename?: 'Mutation', schoolUserManageCreateMany: { __typename?: 'CreateManyUserOutput', created: Array<{ __typename?: 'UserEntity', id: number, phone?: string | null, email?: string | null, banned: boolean, activated: boolean, lastOnlineAt: any, productAccessesCount?: number | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number }, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }>, exist: Array<{ __typename?: 'UserEntity', id: number, phone?: string | null, email?: string | null, banned: boolean, activated: boolean, lastOnlineAt: any, productAccessesCount?: number | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number }, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type SchoolUserFindOneQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SchoolUserFindOneQuery = { __typename?: 'Query', schoolUserFindOne: { __typename?: 'UserEntity', id: number, tgId?: number | null, email?: string | null, phone?: string | null, domain?: string | null, banned: boolean, language?: Language | null, timezone?: number | null, createdAt: any, lastOnlineAt: any, createdBy?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string } } | null, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, bdate?: string | null, firstName?: string | null, lastName?: string | null, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type SchoolUserSessionFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSessionInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SchoolUserSessionFindManyQuery = { __typename?: 'Query', schoolUserSessionFindMany: { __typename?: 'ListSessionOutput', items: Array<{ __typename?: 'SessionEntity', id: number, ip?: string | null, alive: boolean, createdAt: any, isOnline: boolean, launcher: SessionLauncher, lastActivityAt: any, location: { __typename?: 'SessionLocation', city?: string | null, country?: string | null, countryCode?: string | null } }> } };

export type SchoolUserPasswordFindOneLastPlainQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SchoolUserPasswordFindOneLastPlainQuery = { __typename?: 'Query', schoolUserPasswordFindOneLastPlain?: string | null };

export type SchoolUserManageSessionKillAllMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SchoolUserManageSessionKillAllMutation = { __typename?: 'Mutation', schoolUserManageSessionKillAll: Array<{ __typename?: 'SessionEntity', id: number, alive: boolean, isOnline: boolean }> };

export type SchoolUserManageSessionKillByIdMutationVariables = Exact<{
  sessionId: Scalars['Int']['input'];
}>;


export type SchoolUserManageSessionKillByIdMutation = { __typename?: 'Mutation', schoolUserManageSessionKillById: { __typename?: 'SessionEntity', id: number, alive: boolean, isOnline: boolean } };

export type SchoolUserManageUpdateMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  userPartial: UpdateUserInput;
}>;


export type SchoolUserManageUpdateMutation = { __typename?: 'Mutation', schoolUserManageUpdate: { __typename?: 'UserEntity', id: number, banned: boolean, lastOnlineAt: any } };

export type SchoolUserAccessCreateManyMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  enrollments: CreateAccessManyProductInput;
}>;


export type SchoolUserAccessCreateManyMutation = { __typename?: 'Mutation', schoolUserManageProductAccessesCreateMany: Array<{ __typename?: 'ProductAccessEntity', id: number, active: boolean, createdAt: any, isActive: boolean, expireAt?: any | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, educationStartAt?: any | null, educationFinishAt?: any | null } | null, price?: { __typename?: 'ProductPriceEntity', id: number, title?: string | null } | null, product: { __typename?: 'ProductEntity', id: number, type: ProductType, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, previewImage?: string | null, name: string, description: string, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null }, participant?: { __typename?: 'ProductParticipantEntity', id: number, courseProgresses: Array<{ __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, updatedAt?: any | null, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } }> } | null }> };

export type WebhookEndpointFragmentFragment = { __typename?: 'WebhookEndpointEntity', id: number, url: string, note?: string | null, active: boolean, events: Array<WebhookEvent> };

export type WebhookEndpointFindOneQueryVariables = Exact<{
  endpointId: Scalars['Int']['input'];
}>;


export type WebhookEndpointFindOneQuery = { __typename?: 'Query', webhookEndpointFindOne: { __typename?: 'WebhookEndpointEntity', id: number, url: string, note?: string | null, active: boolean, events: Array<WebhookEvent> } };

export type WebhookEndpointFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterEndpointWebhookInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type WebhookEndpointFindManyQuery = { __typename?: 'Query', webhookEndpointFindMany: { __typename?: 'ListEndpointWebhookOutput', page: number, pages: number, count: number, items: Array<{ __typename?: 'WebhookEndpointEntity', id: number, url: string, note?: string | null, active: boolean, events: Array<WebhookEvent> }> } };

export type WebhookEndpointCreateMutationVariables = Exact<{
  endpoint: CreateEndpointWebhookInput;
}>;


export type WebhookEndpointCreateMutation = { __typename?: 'Mutation', webhookEndpointCreate: { __typename?: 'WebhookEndpointEntity', id: number, url: string, note?: string | null, active: boolean, events: Array<WebhookEvent> } };

export type WebhookEndpointUpdateMutationVariables = Exact<{
  endpointId: Scalars['Int']['input'];
  endpoint: UpdateEndpointWebhookInput;
}>;


export type WebhookEndpointUpdateMutation = { __typename?: 'Mutation', webhookEndpointUpdate: { __typename?: 'WebhookEndpointEntity', id: number, url: string, note?: string | null, active: boolean, events: Array<WebhookEvent> } };

export type WebhookEndpointDeleteMutationVariables = Exact<{
  endpointId: Scalars['Int']['input'];
}>;


export type WebhookEndpointDeleteMutation = { __typename?: 'Mutation', webhookEndpointDelete: boolean };

export type SchoolManageGetStateByKeyQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
  key: SchoolStateKey;
}>;


export type SchoolManageGetStateByKeyQuery = { __typename?: 'Query', schoolManageGetStateByKey?: any | null };

export type SchoolManageSetStateByKeyMutationVariables = Exact<{
  schoolId: Scalars['Int']['input'];
  key: SchoolStateKey;
  input: JsonObjectInput;
}>;


export type SchoolManageSetStateByKeyMutation = { __typename?: 'Mutation', schoolManageSetStateByKey: boolean };

export type SchoolManageListenUpdateSubscriptionVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type SchoolManageListenUpdateSubscription = { __typename?: 'Subscription', schoolListenUpdate: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, customCode: { __typename?: 'SchoolCustomCode', js?: string | null, css?: string | null }, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type SellerBalanceOperationFragmentFragment = { __typename?: 'SellerBalanceOperationEntity', id: number, uuid: string, type: SellerBalanceType, amount: number, currency?: ProductCurrency | null, source: SellerBalanceSource, createdAt: any, payoutOperations: Array<{ __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null }>, invoiceProductPayouts: Array<{ __typename?: 'InvoiceProductPayoutEntity', id: number, status: InvoiceProductPayoutStatus, profitAmount: number, commissionAmount: number, transactionAmount: number, payoutScheduledAt?: any | null, commission?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any } | null, invoiceProduct?: { __typename?: 'InvoiceProductEntity', id: number, invoice: { __typename?: 'InvoiceEntity', id: number, currency: ProductCurrency }, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null }> };

export type SellerBalanceOperationFindOneQueryVariables = Exact<{
  operationId: Scalars['Int']['input'];
}>;


export type SellerBalanceOperationFindOneQuery = { __typename?: 'Query', sellerBalanceOperationFindOne: { __typename?: 'SellerBalanceOperationEntity', id: number, uuid: string, type: SellerBalanceType, amount: number, currency?: ProductCurrency | null, source: SellerBalanceSource, createdAt: any, payoutOperations: Array<{ __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null }>, invoiceProductPayouts: Array<{ __typename?: 'InvoiceProductPayoutEntity', id: number, status: InvoiceProductPayoutStatus, profitAmount: number, commissionAmount: number, transactionAmount: number, payoutScheduledAt?: any | null, commission?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any } | null, invoiceProduct?: { __typename?: 'InvoiceProductEntity', id: number, invoice: { __typename?: 'InvoiceEntity', id: number, currency: ProductCurrency }, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null }> } };

export type SellerBalanceOperationFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterBalanceOperationSellerInput;
  sort: BaseSortInput;
}>;


export type SellerBalanceOperationFindManyQuery = { __typename?: 'Query', sellerBalanceOperationFindMany: { __typename?: 'ListBalanceOperationSellerOutput', pages: number, count: number, items: Array<{ __typename?: 'SellerBalanceOperationEntity', id: number, uuid: string, type: SellerBalanceType, amount: number, currency?: ProductCurrency | null, source: SellerBalanceSource, createdAt: any, payoutOperations: Array<{ __typename?: 'PayoutOperationEntity', id: number, status: PayoutOperationStatus, amount: number, currency: ProductCurrency, createdAt: any, exception?: PayoutException | null, initiationType: PayoutOperationInitiationType, transferAmount: number, transactionAmount: number, user?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null }>, invoiceProductPayouts: Array<{ __typename?: 'InvoiceProductPayoutEntity', id: number, status: InvoiceProductPayoutStatus, profitAmount: number, commissionAmount: number, transactionAmount: number, payoutScheduledAt?: any | null, commission?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any } | null, invoiceProduct?: { __typename?: 'InvoiceProductEntity', id: number, invoice: { __typename?: 'InvoiceEntity', id: number, currency: ProductCurrency }, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null }> }> } };

export type SellerBecomeRequestFragmentFragment = { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus, type: SellerType, inn?: string | null, bic?: string | null, ogrn?: string | null, name: string, organizationName?: string | null, contactInfo?: string | null, declinedComment?: string | null, updatedAt?: any | null, address?: string | null, isOrganization: boolean, bankName?: string | null, bankAccountNumber?: string | null, correspondentAccount?: string | null, organizationForm: SellerOrganizationForm, firstName?: string | null, lastName?: string | null, surname?: string | null, agreementDocs: { __typename?: 'SellerBecomeRequestAgreementDocs', toSign?: string | null, signed?: string | null }, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, sellerOrganization?: { __typename?: 'SellerOrganizationEntity', id: number, logo?: string | null, name: string, form: SellerOrganizationForm } | null, passport?: { __typename?: 'SellerBecomeRequestPassport', series: string, number: string, issuedBy: string, issuedByCode: string, dateOfIssue: string, registration: string, pages: Array<{ __typename?: 'SellerBecomeRequestPassportPage', url: string, page: SellerBecomeRequestDocType, uploadedAt?: any | null }> } | null, docs: Array<{ __typename?: 'SellerBecomeRequestDoc', url: string, type: SellerBecomeRequestDocType, uploadedAt?: any | null }>, registerVerification: { __typename?: 'SellerRegisterVerification', selfEmployed?: boolean | null, organization: boolean, bank: boolean }, icAdmin?: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null };

export type SellerBecomeRequestFindOneQueryVariables = Exact<{
  requestId: Scalars['Int']['input'];
}>;


export type SellerBecomeRequestFindOneQuery = { __typename?: 'Query', sellerBecomeRequestFindOne: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus, type: SellerType, inn?: string | null, bic?: string | null, ogrn?: string | null, name: string, organizationName?: string | null, contactInfo?: string | null, declinedComment?: string | null, updatedAt?: any | null, address?: string | null, isOrganization: boolean, bankName?: string | null, bankAccountNumber?: string | null, correspondentAccount?: string | null, organizationForm: SellerOrganizationForm, firstName?: string | null, lastName?: string | null, surname?: string | null, agreementDocs: { __typename?: 'SellerBecomeRequestAgreementDocs', toSign?: string | null, signed?: string | null }, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, sellerOrganization?: { __typename?: 'SellerOrganizationEntity', id: number, logo?: string | null, name: string, form: SellerOrganizationForm } | null, passport?: { __typename?: 'SellerBecomeRequestPassport', series: string, number: string, issuedBy: string, issuedByCode: string, dateOfIssue: string, registration: string, pages: Array<{ __typename?: 'SellerBecomeRequestPassportPage', url: string, page: SellerBecomeRequestDocType, uploadedAt?: any | null }> } | null, docs: Array<{ __typename?: 'SellerBecomeRequestDoc', url: string, type: SellerBecomeRequestDocType, uploadedAt?: any | null }>, registerVerification: { __typename?: 'SellerRegisterVerification', selfEmployed?: boolean | null, organization: boolean, bank: boolean }, icAdmin?: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null } };

export type SellerBecomeRequestFindOneByCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SellerBecomeRequestFindOneByCurrentUserQuery = { __typename?: 'Query', sellerBecomeRequestFindOneByCurrentUser?: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus } | null };

export type RequestBecomeSellerMutationVariables = Exact<{
  request: SellerBecomeRequestInput;
  requestId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RequestBecomeSellerMutation = { __typename?: 'Mutation', sellerBecomeRequestUpsert: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus, type: SellerType, inn?: string | null, bic?: string | null, ogrn?: string | null, name: string, organizationName?: string | null, contactInfo?: string | null, declinedComment?: string | null, updatedAt?: any | null, address?: string | null, isOrganization: boolean, bankName?: string | null, bankAccountNumber?: string | null, correspondentAccount?: string | null, organizationForm: SellerOrganizationForm, firstName?: string | null, lastName?: string | null, surname?: string | null, agreementDocs: { __typename?: 'SellerBecomeRequestAgreementDocs', toSign?: string | null, signed?: string | null }, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, sellerOrganization?: { __typename?: 'SellerOrganizationEntity', id: number, logo?: string | null, name: string, form: SellerOrganizationForm } | null, passport?: { __typename?: 'SellerBecomeRequestPassport', series: string, number: string, issuedBy: string, issuedByCode: string, dateOfIssue: string, registration: string, pages: Array<{ __typename?: 'SellerBecomeRequestPassportPage', url: string, page: SellerBecomeRequestDocType, uploadedAt?: any | null }> } | null, docs: Array<{ __typename?: 'SellerBecomeRequestDoc', url: string, type: SellerBecomeRequestDocType, uploadedAt?: any | null }>, registerVerification: { __typename?: 'SellerRegisterVerification', selfEmployed?: boolean | null, organization: boolean, bank: boolean }, icAdmin?: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, domain?: string | null, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null } };

export type SellerBecomeRequestUpsertShortFormMutationVariables = Exact<{
  request: ShortFormSellerBecomeRequestInput;
}>;


export type SellerBecomeRequestUpsertShortFormMutation = { __typename?: 'Mutation', sellerBecomeRequestUpsertShortForm: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus, sellerOrganization?: { __typename?: 'SellerOrganizationEntity', id: number, seller: { __typename?: 'SellerEntity', id: number, type: SellerType, baseCurrency: ProductCurrency, currentManager: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, isSellerOwner: boolean }, organization: { __typename?: 'SellerOrganizationEntity', id: number, name: string, form: SellerOrganizationForm, logo?: string | null }, tutor?: { __typename?: 'TutorEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null } } | null } };

export type SellerManagerFindOneQueryVariables = Exact<{
  managerId: Scalars['Int']['input'];
}>;


export type SellerManagerFindOneQuery = { __typename?: 'Query', sellerManagerFindOne: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SellerProductManagerFindOneQueryVariables = Exact<{
  productManagerId: Scalars['Int']['input'];
}>;


export type SellerProductManagerFindOneQuery = { __typename?: 'Query', sellerProductManagerFindOne: { __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } };

export type SellerManagerUpdateMutationVariables = Exact<{
  managerId: Scalars['Int']['input'];
  manager: UpdateManagerSellerInput;
}>;


export type SellerManagerUpdateMutation = { __typename?: 'Mutation', sellerManagerUpdate: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SellerManagerDeleteMutationVariables = Exact<{
  managerId: Scalars['Int']['input'];
}>;


export type SellerManagerDeleteMutation = { __typename?: 'Mutation', sellerManagerDelete: boolean };

export type SellerManagerFragmentFragment = { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type SellerProductManagerFragmentFragment = { __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SellerFindManyManagersQueryVariables = Exact<{
  list: ListInput;
  filter: FilterManagerSellerInput;
  sort?: InputMaybe<SortManagerSellerInput>;
}>;


export type SellerFindManyManagersQuery = { __typename?: 'Query', sellerManagerFindMany: { __typename?: 'ListManagerSellerOutput', pages: number, count: number, items: Array<{ __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type SellerProductManagerFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterProductManagerSellerInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SellerProductManagerFindManyQuery = { __typename?: 'Query', sellerProductManagerFindMany: { __typename?: 'ListProductManagerSellerOutput', pages: number, count: number, items: Array<{ __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> } };

export type SellerProductManagerFindOneByUserAndProductQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
}>;


export type SellerProductManagerFindOneByUserAndProductQuery = { __typename?: 'Query', sellerProductManagerFindOneByUserAndProduct?: { __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } | null };

export type SellerManagerFindOneByUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SellerManagerFindOneByUserQuery = { __typename?: 'Query', sellerManagerFindOneByUser?: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null };

export type SellerManagerCreateMutationVariables = Exact<{
  manager: CreateManagerSellerInput;
}>;


export type SellerManagerCreateMutation = { __typename?: 'Mutation', sellerManagerCreate: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, isSellerOwner: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SellerProductManagerCreateMutationVariables = Exact<{
  productManager: CreateProductManagerSellerInput;
}>;


export type SellerProductManagerCreateMutation = { __typename?: 'Mutation', sellerProductManagerCreate: { __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } };

export type SellerProductManagerUpdateMutationVariables = Exact<{
  productManagerId: Scalars['Int']['input'];
  productManager: UpdateProductManagerSellerInput;
}>;


export type SellerProductManagerUpdateMutation = { __typename?: 'Mutation', sellerProductManagerUpdate: { __typename?: 'SellerProductManagerEntity', id: number, permissions: Array<Permission>, active: boolean, updatedAt?: any | null, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null }, manager: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, small?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } };

export type SellerOrganizationFragmentFragment = { __typename?: 'SellerOrganizationEntity', id: number, inn?: string | null, name: string, logo?: string | null, form: SellerOrganizationForm, createdAt: any, updatedAt?: any | null };

export type SellerCurrentBalanceFragmentFragment = { __typename?: 'SellerCurrentBalanceOutput', balance: number, payoutBalance: number };

export type PayoutCommissionFragmentFragment = { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any, next?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any } | null };

export type SellerInfoFindOneQueryVariables = Exact<{ [key: string]: never; }>;


export type SellerInfoFindOneQuery = { __typename?: 'Query', sellerCurrentUserSeller?: { __typename?: 'SellerEntity', id: number, verified: boolean, organization: { __typename?: 'SellerOrganizationEntity', id: number, inn?: string | null, name: string, logo?: string | null, form: SellerOrganizationForm, createdAt: any, updatedAt?: any | null, request?: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus } | null } } | null, payoutCommissionFindOneCurrent?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any, next?: { __typename?: 'PayoutCommissionEntity', id: number, percent: number, startAt: any } | null } | null };

export type SellerCurrentBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type SellerCurrentBalanceQuery = { __typename?: 'Query', sellerBalanceCurrent: { __typename?: 'SellerCurrentBalanceOutput', balance: number, payoutBalance: number } };

export type SellerOrganizationUpdateMutationVariables = Exact<{
  sellerOrganizationId: Scalars['Int']['input'];
  organization: UpdateOrganizationSellerInput;
}>;


export type SellerOrganizationUpdateMutation = { __typename?: 'Mutation', sellerOrganizationUpdate: { __typename?: 'SellerOrganizationEntity', id: number, inn?: string | null, name: string, logo?: string | null, form: SellerOrganizationForm, createdAt: any, updatedAt?: any | null, request?: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus } | null } };

export type SellerOrganizationFindManyDocumentsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterOrganizationDocumentSellerInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SellerOrganizationFindManyDocumentsQuery = { __typename?: 'Query', sellerOrganizationDocumentFindMany: { __typename?: 'ListOrganizationDocumentsSellerOutput', items: Array<{ __typename?: 'SellerOrganizationDocumentEntity', id: number, location: string, updatedAt?: any | null, type: SellerOrganizationDocumentType }> } };

export type SellerFragmentFragment = { __typename?: 'SellerEntity', id: number, type: SellerType, baseCurrency: ProductCurrency, currentManager: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, isSellerOwner: boolean }, organization: { __typename?: 'SellerOrganizationEntity', id: number, name: string, form: SellerOrganizationForm, logo?: string | null }, tutor?: { __typename?: 'TutorEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null };

export type CompanyGetOrganizationInfoByInnQueryVariables = Exact<{
  inn: Scalars['String']['input'];
}>;


export type CompanyGetOrganizationInfoByInnQuery = { __typename?: 'Query', companyGetOrganizationInfoByInn?: { __typename?: 'OrganizationInfoCompanyOutput', inn: string, name: string, isActive: boolean } | null };

export type CompanyGetBankInfoByBicQueryVariables = Exact<{
  bic: Scalars['String']['input'];
}>;


export type CompanyGetBankInfoByBicQuery = { __typename?: 'Query', companyGetBankInfoByBic?: { __typename?: 'BankInfoCompanyOutput', bic: string, name: string, isActive: boolean } | null };

export type GetUserSellersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSellersQuery = { __typename?: 'Query', sellerFindManyByUser: { __typename?: 'ListSellerOutput', items: Array<{ __typename?: 'SellerEntity', id: number, type: SellerType, baseCurrency: ProductCurrency, currentManager: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, isSellerOwner: boolean }, organization: { __typename?: 'SellerOrganizationEntity', id: number, name: string, form: SellerOrganizationForm, logo?: string | null }, tutor?: { __typename?: 'TutorEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null }> } };

export type SellerCurrentUserSellerQueryVariables = Exact<{ [key: string]: never; }>;


export type SellerCurrentUserSellerQuery = { __typename?: 'Query', sellerCurrentUserSeller?: { __typename?: 'SellerEntity', verified: boolean, id: number, type: SellerType, baseCurrency: ProductCurrency, organization: { __typename?: 'SellerOrganizationEntity', id: number, name: string, form: SellerOrganizationForm, logo?: string | null, inn?: string | null, createdAt: any, updatedAt?: any | null, request?: { __typename?: 'SellerBecomeRequestEntity', id: number, status: SellerBecomeRequestStatus } | null }, currentManager: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, isSellerOwner: boolean }, tutor?: { __typename?: 'TutorEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null } | null };

export type StoriesFindOneQueryVariables = Exact<{
  storiesId: Scalars['Int']['input'];
}>;


export type StoriesFindOneQuery = { __typename?: 'Query', storiesFindOne: { __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type StoriesCreateMutationVariables = Exact<{
  stories: CreateStoriesInput;
}>;


export type StoriesCreateMutation = { __typename?: 'Mutation', storiesManageCreate: { __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type StoriesUpdateOneMutationVariables = Exact<{
  storiesId: Scalars['Int']['input'];
  stories: UpdateStoriesInput;
}>;


export type StoriesUpdateOneMutation = { __typename?: 'Mutation', storiesManageUpdate: { __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type ProductAccessFragmentFragment = { __typename?: 'ProductAccessEntity', id: number, active: boolean, createdAt: any, isActive: boolean, expireAt?: any | null, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, educationStartAt?: any | null, educationFinishAt?: any | null } | null, price?: { __typename?: 'ProductPriceEntity', id: number, title?: string | null } | null, product: { __typename?: 'ProductEntity', id: number, type: ProductType, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, previewImage?: string | null, name: string, description: string, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null }, participant?: { __typename?: 'ProductParticipantEntity', id: number, courseProgresses: Array<{ __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, updatedAt?: any | null, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } }> } | null };

export type ProductAccessFindOneQueryVariables = Exact<{
  accessId: Scalars['Int']['input'];
}>;


export type ProductAccessFindOneQuery = { __typename?: 'Query', productAccessFindOne: { __typename?: 'ProductAccessEntity', id: number, active: boolean, createdAt: any, isActive: boolean, expireAt?: any | null, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, educationStartAt?: any | null, educationFinishAt?: any | null } | null, price?: { __typename?: 'ProductPriceEntity', id: number, title?: string | null } | null, product: { __typename?: 'ProductEntity', id: number, type: ProductType, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, previewImage?: string | null, name: string, description: string, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null }, participant?: { __typename?: 'ProductParticipantEntity', id: number, courseProgresses: Array<{ __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, updatedAt?: any | null, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } }> } | null } };

export type ProductAccessFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterAccessProductInput;
  sort?: InputMaybe<SortAccessProductInput>;
}>;


export type ProductAccessFindManyQuery = { __typename?: 'Query', productAccessFindMany: { __typename?: 'ListAccessProductOutput', pages: number, count: number, items: Array<{ __typename?: 'ProductAccessEntity', id: number, active: boolean, createdAt: any, isActive: boolean, expireAt?: any | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, launch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, educationStartAt?: any | null, educationFinishAt?: any | null } | null, price?: { __typename?: 'ProductPriceEntity', id: number, title?: string | null } | null, product: { __typename?: 'ProductEntity', id: number, type: ProductType, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, previewImage?: string | null, name: string, description: string, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null }, participant?: { __typename?: 'ProductParticipantEntity', id: number, courseProgresses: Array<{ __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, updatedAt?: any | null, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, description: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null } }> } | null }> } };

export type FindOneProductIdByCourseQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type FindOneProductIdByCourseQuery = { __typename?: 'Query', courseFindOne: { __typename?: 'CourseEntity', id: number, type: CourseType, name: string, product: { __typename?: 'ProductEntity', id: number } } };

export type CourseLessonPracticeAttemptFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterLessonPracticeAttemptCourseInput;
  sort?: InputMaybe<SortLessonPracticeAttemptCourseInput>;
}>;


export type CourseLessonPracticeAttemptFindManyQuery = { __typename?: 'Query', courseLessonPracticeAttemptFindMany: { __typename?: 'ListLessonPracticeAttemptCourseOutput', count: number, page: number, pages: number, isFirst: boolean, isLast: boolean, items: Array<{ __typename?: 'CourseLessonPracticeAttemptEntity', id: number, status: CourseLessonPracticeAttemptStatus, attemptIndex?: number | null, finished: boolean, solvedCount: number, pointsAmount: number, sentToReviewAt?: any | null, maxPointsAmount: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, practice: { __typename?: 'CourseLessonPracticeEntity', id: number, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, course: { __typename?: 'CourseEntity', id: number, name: string } } }, curator?: { __typename?: 'SellerManagerEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullNameShort: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } } | null, message?: { __typename?: 'ChatMessageEntity', id: number, chat: { __typename?: 'ChatEntity', id: number } } | null }> } };

export type TaskFindOneQueryVariables = Exact<{
  taskUuid: Scalars['String']['input'];
  list: ListInput;
  filter: FilterTaskInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type TaskFindOneQuery = { __typename?: 'Query', taskFindOne?: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null, taskFindMany: { __typename?: 'ListTaskOutput', items: Array<{ __typename?: 'TaskEntity', uuid: string }> } };

export type TaskManageUpdateMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  task: UpdateTaskInput;
}>;


export type TaskManageUpdateMutation = { __typename?: 'Mutation', taskManageUpdate: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TaskManageCreateMutationVariables = Exact<{
  task: CreateTaskInput;
}>;


export type TaskManageCreateMutation = { __typename?: 'Mutation', taskManageCreate: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SubjectCategoryManageCreateMutationVariables = Exact<{
  category: CreateCategorySubjectInput;
}>;


export type SubjectCategoryManageCreateMutation = { __typename?: 'Mutation', subjectCategoryManageCreate: { __typename?: 'SubjectCategoryEntity', id: number, name: string } };

export type SubjectCategoryFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCategorySubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SubjectCategoryFindManyQuery = { __typename?: 'Query', subjectCategoryFindMany: { __typename?: 'ListCategorySubjectOutput', items: Array<{ __typename?: 'SubjectCategoryEntity', id: number, name: string, visibility: SubjectCategoryVisibility }> } };

export type TaskBlockManageCreateMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  contentElement: CreateElementContentInput;
}>;


export type TaskBlockManageCreateMutation = { __typename?: 'Mutation', taskBlockManageCreate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type TaskBlockManageUpdateMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
  contentElement: UpdateElementContentInput;
}>;


export type TaskBlockManageUpdateMutation = { __typename?: 'Mutation', taskBlockManageUpdate: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type TaskBlockManageDeleteMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type TaskBlockManageDeleteMutation = { __typename?: 'Mutation', taskBlockManageDelete: boolean };

export type TaskBlockManageRecoverMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  contentElementId: Scalars['Int']['input'];
}>;


export type TaskBlockManageRecoverMutation = { __typename?: 'Mutation', taskBlockManageRecover: { __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null } };

export type TaskBlockManageUpdateOrderMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  blockOrder: UpdateBlockOrderTaskInput;
}>;


export type TaskBlockManageUpdateOrderMutation = { __typename?: 'Mutation', taskBlockManageUpdateOrder: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }> };

export type TaskFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterTaskInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type TaskFindManyQuery = { __typename?: 'Query', taskFindMany: { __typename?: 'ListTaskOutput', pages: number, items: Array<{ __typename?: 'TaskEntity', id: number, uuid: string, title: string, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, subject?: EducationSubject | null, question: any, complexity: TaskComplexity, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null }> } };

export type TaskCommonFragmentFragment = { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type InvoiceFindOneByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceFindOneByUuidQuery = { __typename?: 'Query', invoiceFindOneByUuid: { __typename?: 'InvoiceEntity', id: number, uuid: string, createdAt: any, humanId: string, currency: ProductCurrency, totalAmount: number, discountAmount: number, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, paidAt?: any | null, isCompleted: boolean } | null, user: { __typename?: 'UserEntity', id: number, login: string }, products?: Array<{ __typename?: 'InvoiceProductEntity', id: number, price: { __typename?: 'ProductPriceEntity', id: number }, product: { __typename?: 'ProductEntity', id: number, type: ProductType, currency: ProductCurrency, prices: Array<{ __typename?: 'ProductPriceEntity', id: number, accessDays?: number | null, previousAmount?: number | null, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null }>, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null } }> | null } };

export type InvoiceRecreatePaymentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  acquiringId: Scalars['Int']['input'];
}>;


export type InvoiceRecreatePaymentMutation = { __typename?: 'Mutation', invoiceRecreatePayment: { __typename?: 'InvoiceEntity', id: number, uuid: string, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, checkoutUrl?: string | null } | null } };

export type AcquiringFindManyActiveQueryVariables = Exact<{
  filter: FilterAcquiringInput;
}>;


export type AcquiringFindManyActiveQuery = { __typename?: 'Query', acquiringFindManyActive: { __typename?: 'ListAcquiringOutput', items: Array<{ __typename?: 'AcquiringEntity', id: number, active: boolean, name?: string | null, description?: string | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } } }> } };

export type InvoiceCreateByCartFragmentFragment = { __typename?: 'InvoiceEntity', id: number, uuid: string, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, checkoutUrl?: string | null } | null };

export type AcquiringFragmentFragment = { __typename?: 'AcquiringEntity', id: number, active: boolean, name?: string | null, description?: string | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } } };

export type ProductFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterProductInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ProductFindManyQuery = { __typename?: 'Query', productFindMany: { __typename?: 'ListProductOutput', pages: number, count: number, items: Array<{ __typename?: 'ProductEntity', id: number, currency: ProductCurrency, prices: Array<{ __typename?: 'ProductPriceEntity', id: number, accessDays?: number | null, previousAmount?: number | null, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null }>, course?: { __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } } | null }> } };

export type InvoiceCalculateCartTotalQueryVariables = Exact<{
  cart: CalculateCartTotalInvoiceInput;
  acquiringFilter: FilterAcquiringInput;
}>;


export type InvoiceCalculateCartTotalQuery = { __typename?: 'Query', acquiringFindManyActive: { __typename?: 'ListAcquiringOutput', items: Array<{ __typename?: 'AcquiringEntity', id: number, active: boolean, name?: string | null, description?: string | null, provider: { __typename?: 'PaymentProviderEntity', id: number, name?: string | null, type: PaymentProviderType, icon?: string | null, active: boolean, domains: Array<AppServeDomain>, currencies: Array<ProductCurrency>, ttlDuration: number, dynamicForm: any, preference: { __typename?: 'ProviderPreferencePayment', icon?: string | null, bgColor?: string | null, textColor?: string | null } } }> }, invoiceCalculateCartTotal: { __typename?: 'CalculateCartTotalInvoice', totalAmount: number, discountAmount: number, unAppliedDiscounts: Array<{ __typename?: 'UnAppliedDiscountItem', reason: DiscountUnAppliedReason, discount: { __typename?: 'DiscountEntity', id: number, code: string } }>, items: Array<{ __typename?: 'InvoiceTotalCartItem', totalPrice: number, discountAmount: number, originalPrice: number, product: { __typename?: 'ProductEntity', id: number, type: ProductType, currency: ProductCurrency, course?: { __typename?: 'CourseEntity', id: number, name: string, subject: EducationSubject, image: { __typename?: 'CourseImage', main?: string | null } } | null }, price: { __typename?: 'ProductPriceEntity', id: number, title?: string | null, amount: number, accessDays?: number | null, previousAmount?: number | null, actualAccessDays?: number | null, subscriptionPeriod?: ProductPriceSubscriptionPeriod | null, type: ProductPriceType, active: boolean, description?: string | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } }> } };

export type CartFindOneSharedByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CartFindOneSharedByUuidQuery = { __typename?: 'Query', cartFindOneSharedByUuid: { __typename?: 'CartEntity', id: number, uuid: string, promoCodes: Array<string>, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, products: Array<{ __typename?: 'CartProduct', productId: number, priceId: number, addedAt: any }> } };

export type DiscountCheckCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DiscountCheckCodeQuery = { __typename?: 'Query', discountCheckCode: { __typename?: 'DiscountEntity', id: number, value: number, type: DiscountType, code: string } };

export type InvoiceCreateByCartMutationVariables = Exact<{
  cart: CreateInvoiceInput;
}>;


export type InvoiceCreateByCartMutation = { __typename?: 'Mutation', invoiceCreateByCart: { __typename?: 'InvoiceEntity', id: number, uuid: string, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, checkoutUrl?: string | null } | null } };

export type InvoiceCreateByCartUnauthMutationVariables = Exact<{
  cart: CreateInvoiceInput;
  payer: PayerCreateInvoiceInput;
}>;


export type InvoiceCreateByCartUnauthMutation = { __typename?: 'Mutation', invoiceCreateByCartUnauth: { __typename?: 'InvoiceEntity', id: number, uuid: string, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, checkoutUrl?: string | null } | null } };

export type InvoiceCreateBySharedCartMutationVariables = Exact<{
  sharedCart: CreateBySharedCartInvoiceInput;
}>;


export type InvoiceCreateBySharedCartMutation = { __typename?: 'Mutation', invoiceCreateBySharedCart: { __typename?: 'InvoiceEntity', id: number, uuid: string, actualPayment?: { __typename?: 'PaymentEntity', id: number, status: PaymentStatus, isCompleted: boolean, checkoutUrl?: string | null } | null } };

export type ListFriendsByStatusQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFriendshipInput;
  sort?: InputMaybe<BaseSortInput>;
  relUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFriendsByStatusQuery = { __typename?: 'Query', friendshipFindMany: { __typename?: 'ListUserFriendshipOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, sex: UserSexType, firstName?: string | null, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type PossibleFriendsListQueryVariables = Exact<{
  list: ListInput;
}>;


export type PossibleFriendsListQuery = { __typename?: 'Query', friendshipFindManyPossible: { __typename?: 'ListUserFriendshipOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, lastOnlineAt: any, friendshipStatus?: FriendshipStatus | null, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type NotificationFragmentFragment = { __typename?: 'NotificationEntity', id: number, type: NotificationType, status: NotificationStatus, title?: string | null, text?: string | null, isGhost?: boolean | null, icons: { __typename?: 'NotificationIcons', main: { __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }, extra?: Array<{ __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }> | null }, actor: { __typename?: 'NotificationActor', type: NotificationActorType, identifier: number }, actions: Array<{ __typename?: 'NotificationAction', title: string, method?: NotificationActionMethod | null, arguments?: any | null, link?: { __typename?: 'AppRouteLink', path: string, params: string } | null }> };

export type NotificationsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterNotificationInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notificationFindMany: { __typename?: 'ListNotificationOutput', count: number, items: Array<{ __typename?: 'NotificationEntity', createdAt: any, id: number, type: NotificationType, status: NotificationStatus, title?: string | null, text?: string | null, isGhost?: boolean | null, icons: { __typename?: 'NotificationIcons', main: { __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }, extra?: Array<{ __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }> | null }, actor: { __typename?: 'NotificationActor', type: NotificationActorType, identifier: number }, actions: Array<{ __typename?: 'NotificationAction', title: string, method?: NotificationActionMethod | null, arguments?: any | null, link?: { __typename?: 'AppRouteLink', path: string, params: string } | null }> }> } };

export type NotificationCountByStatusQueryVariables = Exact<{
  notificationStatus: NotificationStatus;
}>;


export type NotificationCountByStatusQuery = { __typename?: 'Query', notificationCountByStatus: number };

export type ReadNotificationMutationVariables = Exact<{
  notificationId: Scalars['Int']['input'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', notificationReadNotification: { __typename?: 'NotificationEntity', id: number, status: NotificationStatus } };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { __typename?: 'Mutation', notificationReadAllNotifications: number };

export type NotificationListenNewUnreadCountSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationListenNewUnreadCountSubscription = { __typename?: 'Subscription', notificationListenNewUnreadNotificationCount: number };

export type NotificationListenNewUnreadSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationListenNewUnreadSubscription = { __typename?: 'Subscription', notificationListenNewNotificationItemOrUpdate: { __typename?: 'NotificationEntity', id: number, type: NotificationType, status: NotificationStatus, title?: string | null, text?: string | null, isGhost?: boolean | null, icons: { __typename?: 'NotificationIcons', main: { __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }, extra?: Array<{ __typename?: 'NotificationIcon', type: NotificationIconType, url?: string | null }> | null }, actor: { __typename?: 'NotificationActor', type: NotificationActorType, identifier: number }, actions: Array<{ __typename?: 'NotificationAction', title: string, method?: NotificationActionMethod | null, arguments?: any | null, link?: { __typename?: 'AppRouteLink', path: string, params: string } | null }> } };

export type ProfileTitleFragmentFragment = { __typename?: 'ProfileEntity', id: number, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } };

export type ProfileFindOneFragmentFragment = { __typename?: 'ProfileEntity', id: number, fullName: string, country?: string | null, city?: string | null, official: boolean, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, maximum?: string | null }, user: { __typename?: 'UserEntity', id: number, email?: string | null, verified: boolean, lastOnlineAt: any, domain?: string | null, tutor?: { __typename?: 'TutorEntity', id: number, seller: { __typename?: 'SellerEntity', id: number } } | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } };

export type ProfileFindOneQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ProfileFindOneQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, fullName: string, country?: string | null, city?: string | null, official: boolean, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, maximum?: string | null }, user: { __typename?: 'UserEntity', id: number, email?: string | null, verified: boolean, lastOnlineAt: any, domain?: string | null, tutor?: { __typename?: 'TutorEntity', id: number, seller: { __typename?: 'SellerEntity', id: number } } | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type AchievementFindManyFragmentFragment = { __typename?: 'ListAchievementOutput', items: Array<{ __typename?: 'AchievementEntity', id: number, image: string, name: string, description: string, levels: number }> };

export type ProfileInfoAuthQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ProfileInfoAuthQuery = { __typename?: 'Query', promotionCountInvited: number, walletGetBalance: number, profileFindOne: { __typename?: 'ProfileEntity', id: number, fullName: string, country?: string | null, city?: string | null, official: boolean, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, maximum?: string | null }, user: { __typename?: 'UserEntity', id: number, email?: string | null, verified: boolean, lastOnlineAt: any, domain?: string | null, tutor?: { __typename?: 'TutorEntity', id: number, seller: { __typename?: 'SellerEntity', id: number } } | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } }, friendshipGetFriendshipStatus?: { __typename?: 'FriendshipEntity', id: number, status: FriendshipStatus, from: { __typename?: 'UserEntity', id: number }, to: { __typename?: 'UserEntity', id: number } } | null, educationPreferenceGetUserSubjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }>, friendshipFindMany: { __typename?: 'ListUserFriendshipOutput', count: number }, friendshipFindManyCommon: { __typename?: 'ListUserFriendshipOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type ProfileInfoUnauthQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ProfileInfoUnauthQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', sex: UserSexType, id: number, fullName: string, country?: string | null, city?: string | null, official: boolean, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, maximum?: string | null }, user: { __typename?: 'UserEntity', id: number, email?: string | null, verified: boolean, lastOnlineAt: any, domain?: string | null, tutor?: { __typename?: 'TutorEntity', id: number, seller: { __typename?: 'SellerEntity', id: number } } | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } }, educationPreferenceGetUserSubjects: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> };

export type SetFriendshipStatusMutationVariables = Exact<{
  relUserId: Scalars['Int']['input'];
  status: FriendshipStatus;
}>;


export type SetFriendshipStatusMutation = { __typename?: 'Mutation', friendshipSetFriendshipStatus: { __typename?: 'FriendshipEntity', id: number, status: FriendshipStatus, from: { __typename?: 'UserEntity', id: number }, to: { __typename?: 'UserEntity', id: number } } };

export type ProfileListenTitleSubscriptionVariables = Exact<{
  profileId: Scalars['Int']['input'];
}>;


export type ProfileListenTitleSubscription = { __typename?: 'Subscription', profileListenNewState: { __typename?: 'ProfileEntity', id: number, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type GetUserIdByAliasQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserIdByAliasQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, user: { __typename?: 'UserEntity', id: number } } };

export type ProfileGetTitleQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProfileGetTitleQuery = { __typename?: 'Query', profileFindOne: { __typename?: 'ProfileEntity', id: number, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type ProfileUpdateTitleManuallyMutationVariables = Exact<{
  title: UpdateTitleProfileInput;
}>;


export type ProfileUpdateTitleManuallyMutation = { __typename?: 'Mutation', profileUpdateTitleManually: { __typename?: 'ProfileEntity', id: number, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type SubjectFragmentFragment = { __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null };

export type EgeSubjectDetailsFragmentFragment = { __typename?: 'SubjectEntity', order: number, id: number, subject: EducationSubject, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null };

export type ListProfileSubjectsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type ListProfileSubjectsQuery = { __typename?: 'Query', subjectFindMany: { __typename?: 'ListSubjectOutput', items: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> }, educationPreferenceGetUserSubjects: Array<{ __typename?: 'SubjectEntity', order: number, id: number, subject: EducationSubject, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> };

export type EgeUpdateUserSubjectsMutationVariables = Exact<{
  subjects: Array<EducationSubject> | EducationSubject;
}>;


export type EgeUpdateUserSubjectsMutation = { __typename?: 'Mutation', educationPreferenceSetUserSubjects: Array<{ __typename?: 'SubjectEntity', order: number, id: number, subject: EducationSubject, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', passingScore?: number | null, universityPassingScore?: number | null, dates?: { __typename?: 'EgeSubjectExamWaves', early: Array<string>, main: Array<string>, reserve?: Array<string> | null } | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> };

export type SubjectFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SubjectFindManyQuery = { __typename?: 'Query', subjectFindMany: { __typename?: 'ListSubjectOutput', count: number, page: number, pages: number, items: Array<{ __typename?: 'SubjectEntity', id: number, subject: EducationSubject, order: number, name: string, icon?: string | null, visible: boolean, activeForTournament: boolean, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number } | null }> } };

export type WalletOperationUserFragmentFragment = { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } };

export type WalletOperationsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterWalletInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type WalletOperationsQuery = { __typename?: 'Query', walletOperationFindMany: { __typename?: 'ListWalletOperationOutput', count: number, pages: number, items: Array<{ __typename?: 'WalletOperationEntity', isRefund: boolean, id: number, createdAt: any, identifier?: number | null, type: WalletOperationType, amount: number, name?: string | null, comment?: string | null, tournament?: { __typename?: 'TournamentEntity', id: number, type: TournamentType, state: TournamentState, subject: EducationSubject, bet: number, finishAt?: any | null } | null, toUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null, fromUser?: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null } } } | null }> } };

export type WalletCardQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletCardQuery = { __typename?: 'Query', walletGetBalance: number, walletGetMonthlyIncome: number, walletGetMonthlyExpense: number };

export type WalletGetBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletGetBalanceQuery = { __typename?: 'Query', walletGetBalance: number };

export type UserBalanceListenUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserBalanceListenUpdateSubscription = { __typename?: 'Subscription', walletListenNewUserBalance: number };

export type WalletMakeTransferMutationVariables = Exact<{
  transfer: MakeTransferWalletInput;
}>;


export type WalletMakeTransferMutation = { __typename?: 'Mutation', walletOperationMakeTransfer: { __typename?: 'WalletOperationEntity', id: number, createdAt: any, type: WalletOperationType, amount: number, identifier?: number | null } };

export type FriendsReceiverListQueryVariables = Exact<{
  list: ListInput;
  filter: FilterFriendshipInput;
  sort?: InputMaybe<BaseSortInput>;
  relUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FriendsReceiverListQuery = { __typename?: 'Query', friendshipFindMany: { __typename?: 'ListUserFriendshipOutput', count: number, items: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type SendConfirmationQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SendConfirmationQuery = { __typename?: 'Query', walletGetBalance: number, walletGetMonthlyIncome: number, walletGetMonthlyExpense: number, profileFindOne: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type WalletFindOneOperationQueryVariables = Exact<{
  operationId: Scalars['Int']['input'];
}>;


export type WalletFindOneOperationQuery = { __typename?: 'Query', walletOperationFindOne: { __typename?: 'WalletOperationEntity', id: number, amount: number, comment?: string | null, createdAt: any, toUser?: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } | null } };

export type SearchProfileQueryVariables = Exact<{
  list: ListInput;
  filter: FilterProfileInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SearchProfileQuery = { __typename?: 'Query', profileFindMany: { __typename?: 'ListProfileOutput', count: number, items: Array<{ __typename?: 'ProfileEntity', id: number, sex: UserSexType, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } }> } };

export type ApplyInvitationBonusMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ApplyInvitationBonusMutation = { __typename?: 'Mutation', promotionApplyInvitationBonus: { __typename?: 'PromotionInviteEntity', id: number, createdAt: any, inviter: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type SchoolManageCreateWithSellerMutationVariables = Exact<{
  school: CreateSchoolInput;
}>;


export type SchoolManageCreateWithSellerMutation = { __typename?: 'Mutation', schoolManageCreateWithSeller: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, seller: { __typename?: 'SellerEntity', id: number, type: SellerType, baseCurrency: ProductCurrency, currentManager: { __typename?: 'SellerManagerEntity', id: number, permissions: Array<Permission>, isSellerOwner: boolean }, organization: { __typename?: 'SellerOrganizationEntity', id: number, name: string, form: SellerOrganizationForm, logo?: string | null }, tutor?: { __typename?: 'TutorEntity', id: number, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } | null }, customCode: { __typename?: 'SchoolCustomCode', js?: string | null, css?: string | null }, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type SchoolFragmentFragment = { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } };

export type SchoolFindOneQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type SchoolFindOneQuery = { __typename?: 'Query', schoolFindOne: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type SchoolFindOneManageQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type SchoolFindOneManageQuery = { __typename?: 'Query', schoolFindOne: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, customCode: { __typename?: 'SchoolCustomCode', js?: string | null, css?: string | null }, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type SchoolListenUpdateSubscriptionVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type SchoolListenUpdateSubscription = { __typename?: 'Subscription', schoolListenUpdate: { __typename?: 'SchoolEntity', id: number, name: string, active: boolean, domain: string, iconUrl?: string | null, isPublic: boolean, accessType: SchoolAccessType, domainType: SchoolDomainType, baseDomain: string, description?: string | null, customDomain?: string | null, platformConfig: any, access: { __typename?: 'ProductAccessEntity', id: number, isActive: boolean, expireAt?: any | null, createdAt: any, price?: { __typename?: 'ProductPriceEntity', id: number, type: ProductPriceType, title?: string | null, amount: number, active: boolean, accessDays?: number | null, description?: string | null, previousAmount?: number | null, product: { __typename?: 'ProductEntity', id: number, currency: ProductCurrency }, meta: { __typename?: 'ProductPriceMeta', override?: { __typename?: 'ProductPriceOverrideMeta', slug?: any | null, tags?: Array<any> | null, title?: any | null, description?: any | null } | null } } | null }, config: { __typename?: 'SchoolConfig', forceRedirectToCustomDomain: boolean }, addresses: Array<{ __typename?: 'SchoolAddress', name: string, address: string, locationLink?: string | null }>, contacts: Array<{ __typename?: 'SchoolContact', name: string, phone?: string | null, email?: string | null, link?: string | null, role?: SchoolContactRole | null }>, blockSettings: { __typename?: 'SchoolBlockSettings', logo?: { __typename?: 'SchoolLogoBlock', mode: SchoolBlockMode, url?: string | null, text?: string | null } | null, meta?: { __typename?: 'SchoolMetaBlock', footerCaption?: string | null } | null, catalog?: { __typename?: 'SchoolCatalogBlock', mode: SchoolBlockMode, url?: string | null, color?: string | null, title?: string | null, subtitle?: string | null } | null, leftMenu?: Array<{ __typename?: 'SchoolLeftMenuBlock', name: string, icon: string, link: string }> | null, footer?: Array<{ __typename?: 'SchoolFooterBlock', title: string, items: Array<{ __typename?: 'SchoolFooterBlockItem', text: string, link: string }> }> | null }, preferenceSettings: { __typename?: 'SchoolPreferenceSettings', colorVariables?: { __typename?: 'AppSchemeData', SpaceGray?: any | null, BrightLight?: any | null } | null } } };

export type TaskResultFragmentFragment = { __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TaskAnswerFindOneByUuidQueryVariables = Exact<{
  taskAnswerUuid: Scalars['String']['input'];
}>;


export type TaskAnswerFindOneByUuidQuery = { __typename?: 'Query', taskAnswerFindOneByUuid?: { __typename?: 'TaskAnswerEntity', id: number, point: number, maxPoint: number, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, maxPoint: number } } | null };

export type RivalEntityFragmentFragment = { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } };

export type StartLookingForBlitzRivalMutationVariables = Exact<{
  subject: EducationSubject;
}>;


export type StartLookingForBlitzRivalMutation = { __typename?: 'Mutation', tournamentBlitzFindRival: { __typename?: 'TournamentBlitzLobbyEntity', id: number, status: TournamentBlitzLobbyStatus, subject: EducationSubject, tournament?: { __typename?: 'TournamentEntity', id: number } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TournamentSetStatusUserBlitzQueueMutationVariables = Exact<{
  status: TournamentBlitzLobbyStatus;
  blitzLobbyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TournamentSetStatusUserBlitzQueueMutation = { __typename?: 'Mutation', tournamentBlitzSetStatusUserQueue: number };

export type TournamentListenBlitzRivalSubscriptionVariables = Exact<{
  blitzLobbyId: Scalars['Int']['input'];
}>;


export type TournamentListenBlitzRivalSubscription = { __typename?: 'Subscription', tournamentListenTournamentBlitzLobbyState: { __typename?: 'TournamentBlitzLobbyEntity', id: number, status: TournamentBlitzLobbyStatus, tournament?: { __typename?: 'TournamentEntity', id: number, lastMembers: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } | null } };

export type TournamentCreateMutationVariables = Exact<{
  tournament: CreateTournamentInput;
}>;


export type TournamentCreateMutation = { __typename?: 'Mutation', tournamentCreate: { __typename?: 'TournamentEntity', id: number, createdAt: any, updatedAt?: any | null, type: TournamentType, subject: EducationSubject, state: TournamentState, bet: number, startMode: TournamentStartMode, startAt?: any | null } };

export type GetSubjectTaskAmountQueryVariables = Exact<{
  subject: EducationSubject;
}>;


export type GetSubjectTaskAmountQuery = { __typename?: 'Query', subjectFindOne: { __typename?: 'SubjectEntity', id: number, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', egeFirstPartTaskCount?: number | null } } };

export type GetTaskAmountQueryVariables = Exact<{
  list: ListInput;
  filter: FilterSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type GetTaskAmountQuery = { __typename?: 'Query', subjectFindMany: { __typename?: 'ListSubjectOutput', items: Array<{ __typename?: 'SubjectEntity', id: number, egeSubjectInfo: { __typename?: 'EgeSubjectInfo', egeFirstPartTaskCount?: number | null } }> } };

export type SubjectCategorySelectionFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCategorySelectionSubjectInput;
  sort?: InputMaybe<BaseSortInput>;
}>;


export type SubjectCategorySelectionFindManyQuery = { __typename?: 'Query', subjectCategorySelectionFindMany: { __typename?: 'ListCategorySelectionSubjectOutput', items: Array<{ __typename?: 'SubjectCategorySelectionEntity', id: number, name: string, categories: Array<{ __typename?: 'SubjectCategoryEntity', id: number }> }> } };

export type UserTournamentsCountQueryVariables = Exact<{
  filter: FilterTournamentInput;
}>;


export type UserTournamentsCountQuery = { __typename?: 'Query', tournamentCountByFilter: number };

export type TournamentGetStatusQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentGetStatusQuery = { __typename?: 'Query', tournamentFindOne: { __typename?: 'TournamentEntity', id: number, state: TournamentState, type: TournamentType, isMember?: boolean | null } };

export type TournamentFindOneLobbyQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentFindOneLobbyQuery = { __typename?: 'Query', tournamentFindOne: { __typename?: 'TournamentEntity', startMode: TournamentStartMode, type: TournamentType, finishAt?: any | null, autoCancelAt?: any | null, liveBroadcastUrl?: string | null, id: number, uuid?: string | null, subject: EducationSubject, startAt?: any | null, bet: number, countMembers: number, isMember?: boolean | null, state: TournamentState, accessByInviteKey: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, categories: Array<{ __typename?: 'TournamentCategoryEntity', subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, lastMembers: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> } };

export type TournamentMembersQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
  filter: FilterMemberTournamentInput;
  sort?: InputMaybe<SortMemberTournamentInput>;
}>;


export type TournamentMembersQuery = { __typename?: 'Query', tournamentLobbyFindManyMembers: { __typename?: 'ListMemberTournamentOutput', count: number, items: Array<{ __typename?: 'TournamentMemberEntity', id: number, isPlayer: boolean, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type TournamentMessagesQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type TournamentMessagesQuery = { __typename?: 'Query', tournamentLobbyFindManyMessages: { __typename?: 'ListMessageTournamentOutput', count: number, items: Array<{ __typename?: 'TournamentMessageEntity', id: number, message: { __typename?: 'TournamentMessagePayload', uuid: string, text: string }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type TournamentInvitationsQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type TournamentInvitationsQuery = { __typename?: 'Query', tournamentLobbyFindManyInvitations: { __typename?: 'ListInvitationTournamentOutput', items: Array<{ __typename?: 'TournamentInvitationEntity', to: { __typename?: 'UserEntity', id: number } }> } };

export type UserFinishedTournamentQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type UserFinishedTournamentQuery = { __typename?: 'Query', tournamentResultFindOne?: { __typename?: 'TournamentResultEntity', id: number, finished: boolean, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null, accessByInviteKey: boolean } } | null };

export type SetIsPlayerMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type SetIsPlayerMutation = { __typename?: 'Mutation', tournamentLobbyMakeMemberPlayer?: { __typename?: 'TournamentMemberEntity', id: number, isPlayer: boolean, user: { __typename?: 'UserEntity', id: number } } | null };

export type StartTournamentMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type StartTournamentMutation = { __typename?: 'Mutation', tournamentLobbyManuallyStartTournament: boolean };

export type SendInvitationMutationVariables = Exact<{
  invitation: SendInvitationTournamentInput;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', tournamentLobbySendInvitation: { __typename?: 'TournamentInvitationEntity', to: { __typename?: 'UserEntity', id: number } } };

export type SendTournamentMessageMutationVariables = Exact<{
  messagePayload: SendMessageTournamentInput;
}>;


export type SendTournamentMessageMutation = { __typename?: 'Mutation', tournamentLobbySendMessage: { __typename?: 'TournamentMessageEntity', id: number, createdAt: any, message: { __typename?: 'TournamentMessagePayload', uuid: string, text: string }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TournamentListenMessagesSubscriptionVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentListenMessagesSubscription = { __typename?: 'Subscription', tournamentListenNewLobbyMessage: { __typename?: 'TournamentMessageEntity', id: number, message: { __typename?: 'TournamentMessagePayload', uuid: string, text: string }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TournamentListenStateSubscriptionVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentListenStateSubscription = { __typename?: 'Subscription', tournamentListenTournamentState: { __typename?: 'TournamentEntity', id: number, state: TournamentState, countMembers: number } };

export type TournamentListenNewMembersSubscriptionVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentListenNewMembersSubscription = { __typename?: 'Subscription', tournamentListenNewMember: { __typename?: 'TournamentMemberEntity', id: number, isPlayer: boolean, tournament: { __typename?: 'TournamentEntity', countMembers: number }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type TournamentTasksQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentTasksQuery = { __typename?: 'Query', tournamentFindOne: { __typename?: 'TournamentEntity', id: number, type: TournamentType, state: TournamentState, isMember?: boolean | null, subject: EducationSubject, countMembers: number, liveBroadcastUrl?: string | null, finishAt?: any | null, tasks: Array<{ __typename?: 'TournamentTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }> }, tournamentResultFindOne?: { __typename?: 'TournamentResultEntity', id: number, finished: boolean, currentTaskIndex: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string } }> } | null };

export type GetTournamentStateQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type GetTournamentStateQuery = { __typename?: 'Query', tournamentFindOne: { __typename?: 'TournamentEntity', id: number, uuid?: string | null, type: TournamentType, state: TournamentState, isMember?: boolean | null } };

export type TournamentMembersProgressQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type TournamentMembersProgressQuery = { __typename?: 'Query', tournamentResultFindMany: { __typename?: 'ListResultTournamentOutput', count: number, items: Array<{ __typename?: 'TournamentResultEntity', id: number, solvedCount: number, finished: boolean, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }, tournament: { __typename?: 'TournamentEntity', id: number, tasks: Array<{ __typename?: 'TournamentTaskEntity', id: number }> } }> } };

export type SendTaskAnswerMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  answer: SaveAnswerTaskInput;
  currentTaskIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SendTaskAnswerMutation = { __typename?: 'Mutation', tournamentProcessSaveTaskAnswer: { __typename?: 'TournamentResultEntity', id: number, finished: boolean, currentTaskIndex: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string } }> } };

export type FinishTournamentMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type FinishTournamentMutation = { __typename?: 'Mutation', tournamentResultFinishMyTournament: { __typename?: 'TournamentResultEntity', id: number, finished: boolean, currentTaskIndex: number } };

export type TournamentListenMembersProgressSubscriptionVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentListenMembersProgressSubscription = { __typename?: 'Subscription', tournamentListenNewMemberProgress: { __typename?: 'TournamentResultEntity', id: number, solvedCount: number, user: { __typename?: 'UserEntity', lastOnlineAt: any } } };

export type TaskAnswersResultFragmentFragment = { __typename?: 'TournamentResultEntity', id: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null, subject: EducationSubject, liveBroadcastUrl?: string | null, tasks: Array<{ __typename?: 'TournamentTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } };

export type TournamentResultParticipantsFragmentFragment = { __typename?: 'TournamentResultEntity', id: number, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, firstName?: string | null, lastName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type TournamentResultQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type TournamentResultQuery = { __typename?: 'Query', tournamentResultFindMany: { __typename?: 'ListResultTournamentOutput', pages: number, items: Array<{ __typename?: 'TournamentResultEntity', id: number, prize?: number | null, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, firstName?: string | null, lastName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> }, tournamentFindOne: { __typename?: 'TournamentEntity', id: number, countMembers: number, countWinners?: number | null, fund?: number | null, bet: number } };

export type TournamentParticipantsQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type TournamentParticipantsQuery = { __typename?: 'Query', tournamentResultFindMany: { __typename?: 'ListResultTournamentOutput', pages: number, items: Array<{ __typename?: 'TournamentResultEntity', id: number, place?: number | null, pointsAmount: number, solvedCount: number, prize?: number | null, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, fullNameShort: string, fullName: string, firstName?: string | null, lastName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type MyTournamentResultQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type MyTournamentResultQuery = { __typename?: 'Query', tournamentResultFindOne?: { __typename?: 'TournamentResultEntity', id: number, pointsAmount: number, maxPointsAmount: number, answers: Array<{ __typename?: 'TaskAnswerEntity', id: number, uuid: string, point: number, status: TaskAnswerStatus, maxPoint: number, createdAt: any, moduleName: TaskAnswerModuleName, answer: { __typename?: 'TaskUserAnswer', quiz?: any | null, detailed?: { __typename?: 'TaskUserDetailedAnswer', content?: any | null, attachments?: Array<{ __typename?: 'TaskUserDetailedAnswerAttachmentItem', type: StorageFileType, location: string }> | null } | null }, task: { __typename?: 'TaskEntity', id: number, uuid: string, title: string, subject?: EducationSubject | null, answerType: TaskAnswerType, contentTypes: Array<TaskContentType>, complexity: TaskComplexity, archived: boolean, maxPoint: number, question: any, blocks: Array<{ __typename?: 'ContentElementEntity', id: number, type: ContentElementType, uuid: string, title?: string | null, order: number, content: any, myInteraction?: { __typename?: 'ContentElementInteractionEntity', id: number, data: any } | null }>, subjectCategory?: { __typename?: 'SubjectCategoryEntity', id: number, name: string } | null, user: { __typename?: 'UserEntity', id: number, domain?: string | null, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, country?: string | null, city?: string | null, role: ProfileRole, status?: string | null, fullName: string, fullNameShort: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null, maximum?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } }>, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null, subject: EducationSubject, liveBroadcastUrl?: string | null, tasks: Array<{ __typename?: 'TournamentTaskEntity', id: number, task: { __typename?: 'TaskEntity', id: number, uuid: string, question: any } }> } } | null };

export type GetPlacesQueryVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  list: ListInput;
}>;


export type GetPlacesQuery = { __typename?: 'Query', tournamentResultFindMany: { __typename?: 'ListResultTournamentOutput', items: Array<{ __typename?: 'TournamentResultEntity', id: number, tournament: { __typename?: 'TournamentEntity', id: number, uuid?: string | null }, user: { __typename?: 'UserEntity', id: number } }> } };

export type VkPublishTournamentResultMutationVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
  promotionType: PromotionPublicationType;
  contentType: TournamentPromotionContentType;
}>;


export type VkPublishTournamentResultMutation = { __typename?: 'Mutation', tournamentPromotionPublish: boolean };

export type ReadyAndUpcomingTournamentsFragmentFragment = { __typename?: 'TournamentEntity', id: number, state: TournamentState, type: TournamentType, subject: EducationSubject, startAt?: any | null, isMember?: boolean | null };

export type ReadyAndUpcomingTournamentsQueryVariables = Exact<{
  listReady: ListInput;
  filterReady: FilterTournamentInput;
  sortReady?: InputMaybe<SortTournamentInput>;
  listUpcoming: ListInput;
  filterUpcoming: FilterTournamentInput;
  sortUpcoming?: InputMaybe<SortTournamentInput>;
}>;


export type ReadyAndUpcomingTournamentsQuery = { __typename?: 'Query', tournamentFindManyReady: { __typename?: 'ListTournamentOutput', items: Array<{ __typename?: 'TournamentEntity', id: number, state: TournamentState, type: TournamentType, subject: EducationSubject, startAt?: any | null, isMember?: boolean | null }> }, tournamentFindManyUpcoming: { __typename?: 'ListTournamentOutput', items: Array<{ __typename?: 'TournamentEntity', id: number, state: TournamentState, type: TournamentType, subject: EducationSubject, startAt?: any | null, isMember?: boolean | null }> } };

export type ScheduledTournamentsQueryVariables = Exact<{
  list: ListInput;
  filter: FilterTournamentInput;
  sort?: InputMaybe<SortTournamentInput>;
}>;


export type ScheduledTournamentsQuery = { __typename?: 'Query', tournamentFindMany: { __typename?: 'ListTournamentOutput', pages: number, count: number, items: Array<{ __typename?: 'TournamentEntity', id: number, subject: EducationSubject, type: TournamentType, bet: number, isMember?: boolean | null, state: TournamentState, countMembers: number, startAt?: any | null, startMode: TournamentStartMode, categories: Array<{ __typename?: 'TournamentCategoryEntity', subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, lastMembers: Array<{ __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } }> }> } };

export type UsersOnlineQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersOnlineQuery = { __typename?: 'Query', userCountUsersOnline: number };

export type UserOnlineCountSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserOnlineCountSubscription = { __typename?: 'Subscription', userListenCountUserOnline: number };

export type TournamentListenNewMemberSubscriptionVariables = Exact<{
  tournamentId: Scalars['Int']['input'];
}>;


export type TournamentListenNewMemberSubscription = { __typename?: 'Subscription', tournamentListenNewMember: { __typename?: 'TournamentMemberEntity', tournament: { __typename?: 'TournamentEntity', countMembers: number }, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } };

export type ProfileUpdateFragmentFragment = { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, sex: UserSexType, bdate?: string | null, role: ProfileRole, user: { __typename?: 'UserEntity', domain?: string | null }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, contact: { __typename?: 'ProfileContact', phone?: string | null, email?: string | null, messengerUrl?: string | null } };

export type MyUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUserSettingsQuery = { __typename?: 'Query', userGetMyInfo: { __typename?: 'UserEntity', id: number, tgId?: number | null, email?: string | null, phone?: string | null, domain?: string | null, createdOnDomain: AppServeDomain, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, sex: UserSexType, bdate?: string | null, role: ProfileRole, title?: string | null, emojiTitle?: string | null, originalNames: { __typename?: 'ProfileOriginalNames', firstName?: string | null, lastName?: string | null }, user: { __typename?: 'UserEntity', domain?: string | null }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, contact: { __typename?: 'ProfileContact', phone?: string | null, email?: string | null, messengerUrl?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } }, meta?: { __typename?: 'UserMetaEntity', hasOtp?: boolean | null } | null }, sessionGetActiveSessions: Array<{ __typename?: 'SessionEntity', id: number, ip?: string | null, alive: boolean, isCurrent?: boolean | null, launcher: SessionLauncher, createdAt: any, lastActivityAt: any, location: { __typename?: 'SessionLocation', city?: string | null, country?: string | null, countryCode?: string | null } }>, passwordFindOneLast?: { __typename?: 'PasswordEntity', id: number, updatedAt?: any | null } | null };

export type CheckUserDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type CheckUserDomainQuery = { __typename?: 'Query', userSettingsCheckDomain: { __typename?: 'CheckDomainUserOutput', success: boolean, cause?: UserException | null, message?: string | null } };

export type ProfileUpdateMutationVariables = Exact<{
  profile: UpdateProfileInput;
}>;


export type ProfileUpdateMutation = { __typename?: 'Mutation', profileUpdate: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, sex: UserSexType, bdate?: string | null, role: ProfileRole, user: { __typename?: 'UserEntity', domain?: string | null }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, contact: { __typename?: 'ProfileContact', phone?: string | null, email?: string | null, messengerUrl?: string | null } } };

export type ProfileUpdatePhotoMutationVariables = Exact<{
  photo: UpdateAvatarProfileInput;
}>;


export type ProfileUpdatePhotoMutation = { __typename?: 'Mutation', profileUpdatePhoto: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, lastName?: string | null, fullName: string, fullNameShort: string, sex: UserSexType, bdate?: string | null, role: ProfileRole, user: { __typename?: 'UserEntity', domain?: string | null }, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, contact: { __typename?: 'ProfileContact', phone?: string | null, email?: string | null, messengerUrl?: string | null } } };

export type SetUserDomainMutationVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type SetUserDomainMutation = { __typename?: 'Mutation', userSettingsSetDomain: { __typename?: 'UserEntity', domain?: string | null } };

export type KillSessionsMutationVariables = Exact<{ [key: string]: never; }>;


export type KillSessionsMutation = { __typename?: 'Mutation', sessionKillAnotherSessions: number };

export type KillSessionByIdMutationVariables = Exact<{
  sessionId: Scalars['Int']['input'];
}>;


export type KillSessionByIdMutation = { __typename?: 'Mutation', sessionKillSessionById: { __typename?: 'SessionEntity', id: number, alive: boolean } };

export type SessionListenKillSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SessionListenKillSubscription = { __typename?: 'Subscription', sessionListenExit: boolean };

export type GetUserStateQueryVariables = Exact<{
  key: UserStateKey;
}>;


export type GetUserStateQuery = { __typename?: 'Query', userStateGetByKey?: any | null };

export type UpdateUserStateMutationVariables = Exact<{
  key: UserStateKey;
  input: JsonObjectInput;
}>;


export type UpdateUserStateMutation = { __typename?: 'Mutation', userStateSetByKey: boolean };

export type UserConnectTelegramMutationVariables = Exact<{
  callbackConnectInput: ConnectCallbackTelegramInput;
}>;


export type UserConnectTelegramMutation = { __typename?: 'Mutation', userConnectTelegram: { __typename?: 'UserEntity', id: number, tgId?: number | null } };

export type StoriesFragmentFragment = { __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } };

export type CourseFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterCourseInput;
  sort?: InputMaybe<SortCourseInput>;
}>;


export type CourseFindManyQuery = { __typename?: 'Query', courseFindMany: { __typename?: 'ListCourseOutput', count: number, pages: number, items: Array<{ __typename?: 'CourseEntity', id: number, name: string, description: string, tags: Array<string>, type: CourseType, seoTags: Array<string>, alias?: string | null, subject: EducationSubject, progressType: CourseProgressType, promoVideo?: string | null, lessons: Array<{ __typename?: 'CourseLessonPreview', id: number, myProgressStatus?: CourseProgressLessonStatus | null, order: number, name: string, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, description: string, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null }>, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null, myProgress?: { __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, lesson: { __typename?: 'CourseLessonEntity', id: number } } | null } | null, image: { __typename?: 'CourseImage', main?: string | null }, contentCategory?: { __typename?: 'ContentCategoryEntity', id: number, name?: string | null, icon?: string | null } | null, categories: Array<{ __typename?: 'CourseCategoryEntity', id: number, subjectCategory: { __typename?: 'SubjectCategoryEntity', id: number, name: string } }>, product: { __typename?: 'ProductEntity', id: number, status: ProductStatus, isFree: boolean, archived: boolean, createdAt: any, publishedAt?: any | null, participantsCount: number, feedbackRating?: number | null, currency: ProductCurrency, isOnSale: boolean, currentSaleLaunch?: { __typename?: 'ProductLaunchEntity', id: number, name: string, deletedAt?: any | null, active: boolean, publishedAt?: any | null, saleStartAt?: any | null, saleFinishAt?: any | null, educationStartAt?: any | null, educationFinishAt?: any | null, status: ProductLaunchStatus, saleStatus: ProductLaunchByDateStatus, educationStatus: ProductLaunchByDateStatus, countAccesses: number, countPrices: number, infinityAccess: boolean, product: { __typename?: 'ProductEntity', id: number, course?: { __typename?: 'CourseEntity', id: number, name: string, image: { __typename?: 'CourseImage', main?: string | null } } | null } } | null, minimalPrice?: { __typename?: 'ProductPriceEntity', id: number, amount: number, amountExchangeRates?: { __typename?: 'ProductPriceExchangeRate', amount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null, previousAmount?: { __typename?: 'ExchangeRateOutput', Eur: number, Kzt: number, Rub: number, Usd: number, Uzs: number } | null } | null } | null }, authors: Array<{ __typename?: 'CourseAuthorEntity', id: number, user: { __typename?: 'UserEntity', id: number, lastOnlineAt: any, profile: { __typename?: 'ProfileEntity', id: number, firstName?: string | null, fullName: string, sex: UserSexType, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }>, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }> } };

export type StoriesFindManyQueryVariables = Exact<{
  list: ListInput;
  filter: FilterStoriesInput;
  sort?: InputMaybe<SortStoriesInput>;
}>;


export type StoriesFindManyQuery = { __typename?: 'Query', storiesFindMany: { __typename?: 'ListStoriesOutput', count: number, items: Array<{ __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } }> } };

export type CartFindOneQueryVariables = Exact<{ [key: string]: never; }>;


export type CartFindOneQuery = { __typename?: 'Query', cartFindOne?: { __typename?: 'CartEntity', id: number, promoCodes: Array<string>, products: Array<{ __typename?: 'CartProduct', productId: number, priceId: number, addedAt: any }> } | null };

export type CourseProgressFindManyCurrentQueryVariables = Exact<{
  list: ListInput;
  filter: FilterProgressCourseInput;
  sort?: InputMaybe<SortProgressCourseInput>;
}>;


export type CourseProgressFindManyCurrentQuery = { __typename?: 'Query', courseProgressFindManyCurrent: { __typename?: 'ListProgressCourseOutput', count: number, items: Array<{ __typename?: 'CourseProgressEntity', id: number, status: CourseProgressLessonStatus, practiceDeadlineAt?: any | null, course: { __typename?: 'CourseEntity', id: number, progressType: CourseProgressType, isParticipant?: boolean | null, currentLesson?: { __typename?: 'CourseLessonEntity', id: number, order: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, myProgressStatus?: CourseProgressLessonStatus | null } | null, preferenceSettings: { __typename?: 'CoursePreference', cardCustomLink?: string | null, cardColor?: { __typename?: 'AppSchemeData', BrightLight?: any | null, SpaceGray?: any | null } | null } }, lesson: { __typename?: 'CourseLessonEntity', id: number, name: string, order: number, isDemo: boolean, accessType: CourseLessonAccessType, myProgressStatus?: CourseProgressLessonStatus | null, description: string, previewImage?: string | null, withContent: boolean, withPractice: boolean, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, parent?: { __typename?: 'CourseLessonEntity', id: number, order: number, status: CourseLessonStatus, isDemo: boolean, accessType: CourseLessonAccessType, isPublished: boolean, isScheduled: boolean, scheduledPublishAt?: any | null } | null, publishedOrder?: { __typename?: 'CourseLessonOrder', order: number, parentOrder?: number | null } | null, next?: { __typename?: 'CourseLessonEntity', id: number, name: string, withContent: boolean, withPractice: boolean, description: string, previewImage?: string | null, isDemo: boolean, accessType: CourseLessonAccessType, publishedAt?: any | null, isPublished: boolean, isPublishedOrScheduled: boolean, scheduledPublishAt?: any | null, status: CourseLessonStatus, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, isEdited: boolean, order: number, blocksInfo: { __typename?: 'CourseLessonBlocksInfo', hasVideo: boolean, totalVideoDuration?: number | null }, course: { __typename?: 'CourseEntity', id: number }, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null } | null, wrapper?: { __typename?: 'StorageSizedImage', small?: string | null, maximum: string } | null, previous?: { __typename?: 'CourseLessonEntity', id: number, isDemo: boolean, accessType: CourseLessonAccessType, withContent: boolean, withPractice: boolean, canStartNextLesson: boolean } | null } }> } };

export type StoriesUpsertViewMutationVariables = Exact<{
  storiesId: Scalars['Int']['input'];
}>;


export type StoriesUpsertViewMutation = { __typename?: 'Mutation', storiesUpsertView: { __typename?: 'StoriesViewEntity', id: number, stories: { __typename?: 'StoriesEntity', id: number, title: string, duration: number, type: StoriesType, url: string, hasView: boolean, createdAt: any, previewImage?: string | null, wrapper?: string | null, status: StoriesStatus, seller?: { __typename?: 'SellerEntity', organization: { __typename?: 'SellerOrganizationEntity', logo?: string | null } } | null, user: { __typename?: 'UserEntity', id: number, profile: { __typename?: 'ProfileEntity', id: number, fullName: string, title?: string | null, emojiTitle?: string | null, avatar: { __typename?: 'ProfileAvatar', id: number, medium?: string | null }, titleState: { __typename?: 'ProfileTitleState', manualTitle?: string | null, manualEmojiTitle?: string | null, manualExpiredAt?: any | null, manualNextTitle?: string | null, manualNextEmojiTitle?: string | null } } } } } };

export const ProfileTitleFragmentFragmentDoc = gql`
    fragment ProfileTitleFragment on ProfileEntity {
  id
  title
  emojiTitle
  titleState {
    manualTitle
    manualEmojiTitle
    manualExpiredAt
    manualNextTitle
    manualNextEmojiTitle
  }
}
    `;
export const TournamentFindOneFragmentFragmentDoc = gql`
    fragment TournamentFindOneFragment on TournamentEntity {
  id
  uuid
  subject
  startAt
  bet
  type
  countMembers
  isMember
  state
  accessByInviteKey
  categories {
    subjectCategory {
      id
      name
    }
  }
  lastMembers {
    id
    profile {
      id
      firstName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const MessageWidgetFragmentFragmentDoc = gql`
    fragment MessageWidgetFragment on ChatMessageWidget {
  type
  data {
    contentElementUuid
    courseLessonPracticeAttemptUuid
  }
}
    `;
export const MessageFragmentFragmentDoc = gql`
    fragment MessageFragment on ChatMessageEntity {
  id
  createdAt
  updatedAt
  type
  text
  status
  editedAt
  isMine
  userTabUuid
  isRead
  isEditable
  replyMessage {
    id
    text
    createdAt
    editedAt
    user {
      id
      profile {
        id
        fullName
        ...ProfileTitleFragment
      }
    }
    medias {
      id
      storage {
        id
        location
        createdAt
        fileType
        imageSizes {
          small
          medium
          maximum
        }
        meta {
          size
          originalName
          duration
          mimeType
          dimensions {
            width
            height
          }
        }
      }
      widget {
        type
        ...MessageWidgetFragment
      }
    }
  }
  forwardUser {
    id
    profile {
      id
      fullName
      ...ProfileTitleFragment
    }
  }
  user {
    id
    profile {
      id
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
  medias {
    id
    storage {
      id
      location
      createdAt
      fileType
      imageSizes {
        small
        medium
        maximum
      }
      meta {
        size
        originalName
        duration
        mimeType
        dimensions {
          width
          height
        }
      }
    }
    widget {
      type
      ...MessageWidgetFragment
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}
${MessageWidgetFragmentFragmentDoc}`;
export const ChatMyMemberFragmentFragmentDoc = gql`
    fragment ChatMyMemberFragment on ChatMemberEntity {
  id
  muted
  blocked
  blockedUntil
  deletedAt
}
    `;
export const ChatPersonalCompanionMemberFragmentFragmentDoc = gql`
    fragment ChatPersonalCompanionMemberFragment on ChatMemberEntity {
  id
  muted
  blocked
  blockedUntil
  user {
    id
    lastOnlineAt
    profile {
      id
      sex
      fullName
      ...ProfileTitleFragment
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const ChatFragmentFragmentDoc = gql`
    fragment ChatFragment on ChatEntity {
  id
  updatedAt
  type
  name
  description
  icon
  isAdmin
  countUnread
  countMembers
  lastAction
  sendMessagePermission
  personalCompanionUserId
  lastMessage {
    ...MessageFragment
  }
  myMember {
    ...ChatMyMemberFragment
  }
  personalCompanionMember {
    ...ChatPersonalCompanionMemberFragment
  }
}
    ${MessageFragmentFragmentDoc}
${ChatMyMemberFragmentFragmentDoc}
${ChatPersonalCompanionMemberFragmentFragmentDoc}`;
export const SubjectFragmentFragmentDoc = gql`
    fragment SubjectFragment on SubjectEntity {
  id
  subject
  order
  name
  icon
  visible
  activeForTournament
  contentCategory {
    id
  }
}
    `;
export const ContentCategoryFragmentFragmentDoc = gql`
    fragment ContentCategoryFragment on ContentCategoryEntity {
  id
  space
  slug
  order
  name
  visible
  subjects {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;
export const FeedbackFragmentFragmentDoc = gql`
    fragment FeedbackFragment on ProductFeedbackEntity {
  id
  text
  rate
  status
  createdAt
  user {
    id
    profile {
      id
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const CourseLessonBlocksInfoFragmentFragmentDoc = gql`
    fragment CourseLessonBlocksInfoFragment on CourseLessonBlocksInfo {
  hasVideo
  totalVideoDuration
}
    `;
export const CourseLessonParentFragmentFragmentDoc = gql`
    fragment CourseLessonParentFragment on CourseLessonEntity {
  id
  order
  status
  isDemo
  accessType
  isPublished
  isScheduled
  scheduledPublishAt
}
    `;
export const ContentElementMyInteractionFragmentFragmentDoc = gql`
    fragment ContentElementMyInteractionFragment on ContentElementInteractionEntity {
  id
  data
}
    `;
export const ContentElementFragmentFragmentDoc = gql`
    fragment ContentElementFragment on ContentElementEntity {
  id
  type
  uuid
  title
  order
  content
  myInteraction {
    ...ContentElementMyInteractionFragment
  }
}
    ${ContentElementMyInteractionFragmentFragmentDoc}`;
export const LessonStudyFragmentFragmentDoc = gql`
    fragment LessonStudyFragment on CourseLessonEntity {
  id
  name
  description
  previewImage
  myProgressStatus
  publishedAt
  scheduledPublishAt
  isDemo
  accessType
  viewsCount
  isFinal
  order
  withContent
  withPractice
  canStartNextLesson
  updatedAt
  deletedAt
  blocksInfo {
    ...CourseLessonBlocksInfoFragment
  }
  wrapper {
    small
    maximum
  }
  next {
    id
    name
    order
    isDemo
    accessType
    withContent
    myProgressStatus
    parent {
      ...CourseLessonParentFragment
    }
    previous {
      id
      isDemo
      accessType
      withContent
      withPractice
      canStartNextLesson
    }
  }
  previous {
    id
    name
    isDemo
    accessType
    withContent
    withPractice
    canStartNextLesson
    parent {
      ...CourseLessonParentFragment
    }
    previous {
      id
      name
      isDemo
      accessType
      withContent
      withPractice
      canStartNextLesson
      parent {
        ...CourseLessonParentFragment
      }
    }
  }
  blocks {
    ...ContentElementFragment
  }
  medias {
    id
    createdAt
    storage {
      id
      createdAt
      location
      meta {
        size
        mimeType
        originalName
      }
    }
  }
}
    ${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}
${ContentElementFragmentFragmentDoc}`;
export const CourseLessonsFragmentFragmentDoc = gql`
    fragment CourseLessonsFragment on CourseEntity {
  lessons {
    id
    name
    order
    isDemo
    accessType
    myProgressStatus
    scheduledPublishAt
    description
    withContent
    withPractice
    blocksInfo {
      ...CourseLessonBlocksInfoFragment
    }
    wrapper {
      small
      maximum
    }
    parent {
      ...CourseLessonParentFragment
    }
    publishedOrder {
      order
      parentOrder
    }
    previous {
      id
      isDemo
      accessType
      withContent
      withPractice
      canStartNextLesson
    }
  }
}
    ${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export const CoursePreferenceSettingsFragmentFragmentDoc = gql`
    fragment CoursePreferenceSettingsFragment on CourseEntity {
  preferenceSettings {
    cardCustomLink
    cardColor {
      BrightLight
      SpaceGray
    }
  }
}
    `;
export const ProductParticipantFragmentFragmentDoc = gql`
    fragment ProductParticipantFragment on ProductParticipantEntity {
  id
  status
}
    `;
export const CourseAuthorsFragmentFragmentDoc = gql`
    fragment CourseAuthorsFragment on CourseAuthorEntity {
  id
  user {
    id
    lastOnlineAt
    profile {
      id
      firstName
      fullName
      sex
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const CourseInformationInLessonFragmentFragmentDoc = gql`
    fragment CourseInformationInLessonFragment on CourseEntity {
  id
  name
  type
  progressType
  isParticipant
  ...CoursePreferenceSettingsFragment
  product {
    id
    isFree
    seller {
      id
    }
    myAccess {
      id
      participant {
        ...ProductParticipantFragment
      }
    }
  }
  authors {
    ...CourseAuthorsFragment
  }
}
    ${CoursePreferenceSettingsFragmentFragmentDoc}
${ProductParticipantFragmentFragmentDoc}
${CourseAuthorsFragmentFragmentDoc}`;
export const EgeSubjectFragmentFragmentDoc = gql`
    fragment EgeSubjectFragment on SubjectEntity {
  id
  subject
  egeSubjectInfo {
    duration
    passingScore
    universityPassingScore
    dates {
      early
      main
      reserve
    }
  }
}
    `;
export const EgeTimeoutFragmentFragmentDoc = gql`
    fragment EgeTimeoutFragment on SubjectEntity {
  id
  subject
  egeSubjectInfo {
    dates {
      early
      main
      reserve
    }
  }
}
    `;
export const ArticleFragmentFragmentDoc = gql`
    fragment ArticleFragment on ArticleEntity {
  id
  slug
  title
  blocks {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export const LessonListItemFragmentFragmentDoc = gql`
    fragment LessonListItemFragment on CourseLessonEntity {
  id
  name
  withContent
  withPractice
  description
  previewImage
  isDemo
  accessType
  publishedAt
  isPublished
  isPublishedOrScheduled
  scheduledPublishAt
  status
  createdAt
  updatedAt
  deletedAt
  isEdited
  order
  blocksInfo {
    ...CourseLessonBlocksInfoFragment
  }
  course {
    id
  }
  wrapper {
    small
    maximum
  }
}
    ${CourseLessonBlocksInfoFragmentFragmentDoc}`;
export const ProductFaqFragmentFragmentDoc = gql`
    fragment ProductFaqFragment on ProductFaqEntity {
  id
  question
  answer
  active
  isOpenedInUi
}
    `;
export const LaunchFragmentFragmentDoc = gql`
    fragment LaunchFragment on ProductLaunchEntity {
  id
  name
  deletedAt
  active
  publishedAt
  saleStartAt
  saleFinishAt
  educationStartAt
  educationFinishAt
  status
  saleStatus
  educationStatus
  countAccesses
  countPrices
  infinityAccess
  product {
    id
    course {
      id
      name
      image {
        main
      }
    }
  }
}
    `;
export const ProductPriceExchangeFragmentFragmentDoc = gql`
    fragment ProductPriceExchangeFragment on ProductPriceEntity {
  id
  amount
  amountExchangeRates {
    amount {
      Eur
      Kzt
      Rub
      Usd
      Uzs
    }
    previousAmount {
      Eur
      Kzt
      Rub
      Usd
      Uzs
    }
  }
}
    `;
export const AbsoluteCourseFragmentFragmentDoc = gql`
    fragment AbsoluteCourseFragment on CourseEntity {
  id
  name
  description
  tags
  type
  seoTags
  alias
  subject
  progressType
  promoVideo
  image {
    main
  }
  contentCategory {
    id
    name
    icon
  }
  categories {
    id
    subjectCategory {
      id
      name
    }
  }
  lessons {
    id
    order
    name
    isDemo
    accessType
    withContent
    description
    wrapper {
      small
      maximum
    }
  }
  product {
    id
    status
    isFree
    archived
    createdAt
    publishedAt
    participantsCount
    feedbackRating
    currency
    isOnSale
    currentSaleLaunch {
      ...LaunchFragment
    }
    minimalPrice {
      id
      amount
      ...ProductPriceExchangeFragment
    }
  }
  authors {
    ...CourseAuthorsFragment
  }
}
    ${LaunchFragmentFragmentDoc}
${ProductPriceExchangeFragmentFragmentDoc}
${CourseAuthorsFragmentFragmentDoc}`;
export const CourseFragmentFragmentDoc = gql`
    fragment CourseFragment on CourseEntity {
  ...AbsoluteCourseFragment
  ...CoursePreferenceSettingsFragment
  lessons {
    id
    myProgressStatus
  }
  currentLesson {
    id
    name
    order
    isDemo
    accessType
    withContent
    withPractice
    myProgressStatus
    myProgress {
      id
      status
      lesson {
        id
      }
    }
  }
}
    ${AbsoluteCourseFragmentFragmentDoc}
${CoursePreferenceSettingsFragmentFragmentDoc}`;
export const CourseManageFragmentFragmentDoc = gql`
    fragment CourseManageFragment on CourseEntity {
  ...CourseFragment
  minDurationInDays
  product {
    groupsCount
    launches {
      ...LaunchFragment
    }
  }
  countModules {
    Published
    Draft
    ReadyToPublish
    totalCount
  }
  countLessons {
    Published
    Draft
    ReadyToPublish
    totalCount
  }
}
    ${CourseFragmentFragmentDoc}
${LaunchFragmentFragmentDoc}`;
export const ProductPriceFragmentFragmentDoc = gql`
    fragment ProductPriceFragment on ProductPriceEntity {
  id
  amount
  actualFrom
  actualTo
  activeFrom
  activeTo
  accessDays
  actualAccessDays
  previousAmount
  launchPeriodMode
  title
  description
  icon
  tags
  active
  isActive
  isActiveByDate
  infinityAccess
  launch {
    ...LaunchFragment
  }
  product {
    id
    currency
    isOnSale
  }
}
    ${LaunchFragmentFragmentDoc}`;
export const LessonManageFragmentFragmentDoc = gql`
    fragment LessonManageFragment on CourseLessonEntity {
  id
  name
  description
  withContent
  withPractice
  previewImage
  order
  isDemo
  accessType
  scheduledPublishAt
  publishedAt
  status
  isPublished
  isPublishedOrScheduled
  createdAt
  updatedAt
  deletedAt
  isEdited
  blocksInfo {
    ...CourseLessonBlocksInfoFragment
  }
  parent {
    ...CourseLessonParentFragment
  }
  wrapper {
    small
    maximum
  }
  medias {
    id
    createdAt
    deletedAt
    updatedAt
    storage {
      id
      createdAt
      updatedAt
      deletedAt
      uuid
      key
      location
      space
      bucketName
      bucketType
      fileType
      imageSizes {
        medium
      }
      meta {
        size
        originalName
        duration
        mimeType
        dimensions {
          width
          height
        }
      }
    }
  }
  blocks {
    ...ContentElementFragment
  }
  course {
    id
    subject
  }
}
    ${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}
${ContentElementFragmentFragmentDoc}`;
export const TaskCommonFragmentFragmentDoc = gql`
    fragment TaskCommonFragment on TaskEntity {
  id
  uuid
  title
  subject
  answerType
  contentTypes
  complexity
  archived
  maxPoint
  question
  blocks {
    ...ContentElementFragment
  }
  subjectCategory {
    id
    name
  }
  user {
    id
    domain
    lastOnlineAt
    profile {
      id
      firstName
      lastName
      country
      city
      role
      status
      fullName
      fullNameShort
      ...ProfileTitleFragment
      avatar {
        id
        medium
        maximum
      }
    }
  }
}
    ${ContentElementFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export const TaskResultFragmentFragmentDoc = gql`
    fragment TaskResultFragment on TaskAnswerEntity {
  id
  uuid
  point
  status
  maxPoint
  createdAt
  moduleName
  answer {
    quiz
    detailed {
      content
      attachments {
        type
        location
      }
    }
  }
  task {
    ...TaskCommonFragment
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export const LessonPracticeAttemptFragmentFragmentDoc = gql`
    fragment LessonPracticeAttemptFragment on CourseLessonPracticeAttemptEntity {
  id
  status
  sentToReviewAt
  attemptIndex
  finished
  solvedCount
  pointsAmount
  maxPointsAmount
  answers {
    ...TaskResultFragment
  }
  message {
    id
    chat {
      id
    }
  }
  practice {
    id
    lesson {
      id
      myProgressStatus
      canStartNextLesson
      course {
        id
        name
      }
      myProgress {
        id
        chat {
          id
        }
      }
      next {
        id
        myProgressStatus
        canStartNextLesson
        next {
          id
          myProgressStatus
          canStartNextLesson
        }
      }
    }
    tasks {
      id
      task {
        id
        uuid
        question
      }
    }
  }
}
    ${TaskResultFragmentFragmentDoc}`;
export const LessonPracticeFragmentFragmentDoc = gql`
    fragment LessonPracticeFragment on CourseLessonPracticeEntity {
  id
  description
  deadlineInDays
  lesson {
    id
    myProgress {
      id
      chat {
        id
      }
    }
  }
  attempts {
    ...LessonPracticeAttemptFragment
  }
  activeAttempt {
    ...LessonPracticeAttemptFragment
  }
  lastFinishedAttempt {
    ...LessonPracticeAttemptFragment
  }
  tasks {
    id
    order
    task {
      ...TaskCommonFragment
    }
  }
}
    ${LessonPracticeAttemptFragmentFragmentDoc}
${TaskCommonFragmentFragmentDoc}`;
export const CoursePublicationCheckItemFragmentFragmentDoc = gql`
    fragment CoursePublicationCheckItemFragment on CoursePublicationCheckItem {
  name
  valid
  description
  entityId
  entity
  errors
  icon
}
    `;
export const GroupFragmentFragmentDoc = gql`
    fragment GroupFragment on GroupEntity {
  id
  uuid
  space
  name
  maxMembers
  countMembers
  channel {
    id
  }
  groupChat {
    id
  }
  curator {
    id
    user {
      id
      lastOnlineAt
      profile {
        id
        firstName
        fullName
        fullNameShort
        avatar {
          id
          medium
        }
      }
    }
  }
  communication {
    channelIsActive
    groupChatIsActive
    dialogueWithEmployeesBlocked
  }
  accessLimitation {
    active
    startPointType
    durationInMinutes
    commonDateStartAt
  }
  scheduleLimitation {
    active
    type
    openUnit
    byWeekdays {
      selected
      startFrom
    }
    onceForInterval {
      durationInMinutes
      startFrom
    }
  }
  contentLimitation {
    disableSendHomework
    hideEarlyAccessLessons
    lessons
  }
}
    `;
export const GroupMemberFragmentFragmentDoc = gql`
    fragment GroupMemberFragment on GroupMemberEntity {
  id
  active
  blockedUntil
  user {
    id
    lastOnlineAt
    profile {
      id
      fullName
      firstName
      avatar {
        id
        medium
      }
    }
  }
  group {
    id
    launch {
      id
      product {
        id
        course {
          image {
            main
          }
        }
      }
    }
  }
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on InvoiceEntity {
  id
  uuid
  humanId
  currency
  createdAt
  discountAmount
  totalAmount
  expireAt
  user {
    id
    lastOnlineAt
    domain
    profile {
      id
      fullNameShort
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const PaymentFragmentFragmentDoc = gql`
    fragment PaymentFragment on PaymentEntity {
  id
  createdAt
  expireAt
  paidAt
  status
  isCompleted
  isCanceled
  isRecurrent
  checkoutPaymentId
  acquiring {
    provider {
      id
      type
      icon
    }
  }
  payerDetails {
    cardNumber
  }
  invoice {
    id
    uuid
    currency
    totalAmount
  }
}
    `;
export const PayoutRequisiteFragmentFragmentDoc = gql`
    fragment PayoutRequisiteFragment on PayoutRequisiteEntity {
  id
  bic
  bankName
  correspondentAccount
  bankAccountNumber
  updatedAt
  user {
    id
    profile {
      id
      fullName
    }
  }
}
    `;
export const DiscountFragmentFragmentDoc = gql`
    fragment DiscountFragment on DiscountEntity {
  id
  code
  type
  value
  active
  maxApplies
  isScheduled
  countApplies
  activeFrom
  activeTo
  note
  isActive
  isActiveByDate
  isActiveByCountApplies
}
    `;
export const PaymentProviderFragmentFragmentDoc = gql`
    fragment PaymentProviderFragment on PaymentProviderEntity {
  id
  name
  type
  icon
  active
  domains
  currencies
  ttlDuration
  dynamicForm
  preference {
    icon
    bgColor
    textColor
  }
}
    `;
export const SchoolAcquiringFragmentFragmentDoc = gql`
    fragment SchoolAcquiringFragment on AcquiringManage {
  id
  uuid
  active
  config
  name
  description
  note
  updatedAt
  provider {
    ...PaymentProviderFragment
  }
  user {
    id
    profile {
      id
      fullName
      avatar {
        id
        small
      }
    }
  }
}
    ${PaymentProviderFragmentFragmentDoc}`;
export const SellerOrganizationDocumentFragmentFragmentDoc = gql`
    fragment SellerOrganizationDocumentFragment on SellerOrganizationDocumentEntity {
  id
  type
  name
  location
  config {
    type
    uploadMode
    showInFooter
  }
  storage {
    id
    meta {
      size
      mimeType
      originalName
    }
  }
}
    `;
export const SchoolPriceFragmentFragmentDoc = gql`
    fragment SchoolPriceFragment on ProductPriceEntity {
  id
  type
  title
  amount
  active
  accessDays
  description
  previousAmount
  product {
    id
    currency
  }
  meta {
    override {
      slug
      tags
      title
      description
    }
  }
}
    `;
export const SchoolFragmentFragmentDoc = gql`
    fragment SchoolFragment on SchoolEntity {
  id
  name
  active
  domain
  iconUrl
  isPublic
  accessType
  domainType
  baseDomain
  description
  customDomain
  platformConfig
  access {
    id
    isActive
    expireAt
    createdAt
    price {
      ...SchoolPriceFragment
    }
  }
  config {
    forceRedirectToCustomDomain
  }
  addresses {
    name
    address
    locationLink
  }
  contacts {
    name
    phone
    email
    link
    role
  }
  blockSettings {
    logo {
      mode
      url
      text
    }
    meta {
      footerCaption
    }
    catalog {
      mode
      url
      color
      title
      subtitle
    }
    leftMenu {
      name
      icon
      link
    }
    footer {
      title
      items {
        text
        link
      }
    }
  }
  preferenceSettings {
    colorVariables {
      SpaceGray
      BrightLight
    }
  }
}
    ${SchoolPriceFragmentFragmentDoc}`;
export const SchoolManageFragmentFragmentDoc = gql`
    fragment SchoolManageFragment on SchoolEntity {
  ...SchoolFragment
  customCode {
    js
    css
  }
}
    ${SchoolFragmentFragmentDoc}`;
export const SchoolUserFindManyFragmentFragmentDoc = gql`
    fragment SchoolUserFindManyFragment on UserEntity {
  id
  phone
  email
  banned
  activated
  lastOnlineAt
  productAccessesCount
  profile {
    id
    sex
    firstName
    lastName
    fullName
    fullNameShort
    ...ProfileTitleFragment
    user {
      id
    }
    avatar {
      id
      small
      medium
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const WebhookEndpointFragmentFragmentDoc = gql`
    fragment WebhookEndpointFragment on WebhookEndpointEntity {
  id
  url
  note
  active
  events
}
    `;
export const PayoutOperationFragmentFragmentDoc = gql`
    fragment PayoutOperationFragment on PayoutOperationEntity {
  id
  status
  amount
  currency
  createdAt
  exception
  initiationType
  transferAmount
  transactionAmount
  user {
    id
    profile {
      id
      fullNameShort
      avatar {
        id
        medium
      }
    }
  }
}
    `;
export const SellerBalanceOperationFragmentFragmentDoc = gql`
    fragment SellerBalanceOperationFragment on SellerBalanceOperationEntity {
  id
  uuid
  type
  amount
  currency
  source
  createdAt
  payoutOperations {
    ...PayoutOperationFragment
  }
  invoiceProductPayouts {
    id
    status
    profitAmount
    commissionAmount
    transactionAmount
    payoutScheduledAt
    commission {
      id
      percent
      startAt
    }
    invoiceProduct {
      id
      invoice {
        id
        currency
      }
      product {
        id
        course {
          id
          name
          image {
            main
          }
        }
      }
    }
  }
}
    ${PayoutOperationFragmentFragmentDoc}`;
export const SellerBecomeRequestFragmentFragmentDoc = gql`
    fragment SellerBecomeRequestFragment on SellerBecomeRequestEntity {
  id
  status
  type
  inn
  bic
  ogrn
  name
  organizationName
  contactInfo
  declinedComment
  updatedAt
  address
  isOrganization
  bankName
  bankAccountNumber
  correspondentAccount
  organizationForm
  firstName
  lastName
  surname
  agreementDocs {
    toSign
    signed
  }
  user {
    id
    domain
    lastOnlineAt
    profile {
      id
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
  sellerOrganization {
    id
    logo
    name
    form
  }
  passport {
    series
    number
    issuedBy
    issuedByCode
    dateOfIssue
    registration
    pages {
      url
      page
      uploadedAt
    }
  }
  docs {
    url
    type
    uploadedAt
  }
  registerVerification {
    selfEmployed
    organization
    bank
  }
  icAdmin {
    id
    lastOnlineAt
    domain
    profile {
      id
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const SellerManagerFragmentFragmentDoc = gql`
    fragment SellerManagerFragment on SellerManagerEntity {
  id
  permissions
  active
  updatedAt
  isSellerOwner
  user {
    id
    lastOnlineAt
    profile {
      id
      fullName
      sex
      ...ProfileTitleFragment
      avatar {
        id
        small
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const SellerProductManagerFragmentFragmentDoc = gql`
    fragment SellerProductManagerFragment on SellerProductManagerEntity {
  id
  permissions
  active
  updatedAt
  product {
    id
    course {
      id
      name
      image {
        main
      }
    }
  }
  manager {
    id
    user {
      id
      lastOnlineAt
      profile {
        id
        fullName
        sex
        ...ProfileTitleFragment
        avatar {
          id
          small
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const SellerOrganizationFragmentFragmentDoc = gql`
    fragment SellerOrganizationFragment on SellerOrganizationEntity {
  id
  inn
  name
  logo
  form
  createdAt
  updatedAt
}
    `;
export const SellerCurrentBalanceFragmentFragmentDoc = gql`
    fragment SellerCurrentBalanceFragment on SellerCurrentBalanceOutput {
  balance
  payoutBalance
}
    `;
export const PayoutCommissionFragmentFragmentDoc = gql`
    fragment PayoutCommissionFragment on PayoutCommissionEntity {
  id
  percent
  startAt
  next {
    id
    percent
    startAt
  }
}
    `;
export const SellerFragmentFragmentDoc = gql`
    fragment SellerFragment on SellerEntity {
  id
  type
  baseCurrency
  currentManager {
    id
    permissions
    isSellerOwner
  }
  organization {
    id
    name
    form
    logo
  }
  tutor {
    id
    user {
      id
      profile {
        id
        fullNameShort
        ...ProfileTitleFragment
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const ProductAccessFragmentFragmentDoc = gql`
    fragment ProductAccessFragment on ProductAccessEntity {
  id
  active
  createdAt
  isActive
  expireAt
  launch {
    id
    name
    educationStartAt
    educationFinishAt
  }
  price {
    id
    title
  }
  product {
    id
    type
    course {
      id
      ...AbsoluteCourseFragment
      ...CoursePreferenceSettingsFragment
      lessons {
        id
        order
        isDemo
        accessType
        withContent
        withPractice
        previewImage
        blocksInfo {
          ...CourseLessonBlocksInfoFragment
        }
        parent {
          ...CourseLessonParentFragment
        }
      }
    }
  }
  participant {
    id
    courseProgresses {
      id
      status
      updatedAt
      lesson {
        id
        name
        description
        order
        isDemo
        accessType
        withContent
        withPractice
        wrapper {
          small
          maximum
        }
        parent {
          ...CourseLessonParentFragment
        }
      }
    }
  }
}
    ${AbsoluteCourseFragmentFragmentDoc}
${CoursePreferenceSettingsFragmentFragmentDoc}
${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export const InvoiceCreateByCartFragmentFragmentDoc = gql`
    fragment InvoiceCreateByCartFragment on InvoiceEntity {
  id
  uuid
  actualPayment {
    id
    status
    isCompleted
    checkoutUrl
  }
}
    `;
export const AcquiringFragmentFragmentDoc = gql`
    fragment AcquiringFragment on AcquiringEntity {
  id
  active
  name
  description
  provider {
    ...PaymentProviderFragment
  }
}
    ${PaymentProviderFragmentFragmentDoc}`;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on NotificationEntity {
  id
  type
  status
  title
  text
  isGhost
  icons {
    main {
      type
      url
    }
    extra {
      type
      url
    }
  }
  actor {
    type
    identifier
  }
  actions {
    title
    link {
      path
      params
    }
    method
    arguments
  }
}
    `;
export const ProfileFindOneFragmentFragmentDoc = gql`
    fragment ProfileFindOneFragment on ProfileEntity {
  id
  fullName
  country
  city
  official
  sex
  ...ProfileTitleFragment
  avatar {
    id
    maximum
  }
  user {
    id
    email
    verified
    lastOnlineAt
    domain
    tutor {
      id
      seller {
        id
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const AchievementFindManyFragmentFragmentDoc = gql`
    fragment AchievementFindManyFragment on ListAchievementOutput {
  items {
    id
    image
    name
    description
    levels
  }
}
    `;
export const EgeSubjectDetailsFragmentFragmentDoc = gql`
    fragment EgeSubjectDetailsFragment on SubjectEntity {
  ...SubjectFragment
  order
  egeSubjectInfo {
    passingScore
    universityPassingScore
    dates {
      early
      main
      reserve
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;
export const WalletOperationUserFragmentFragmentDoc = gql`
    fragment WalletOperationUserFragment on UserEntity {
  id
  profile {
    id
    fullName
    avatar {
      id
      medium
    }
  }
}
    `;
export const RivalEntityFragmentFragmentDoc = gql`
    fragment RivalEntityFragment on UserEntity {
  id
  profile {
    id
    fullNameShort
    ...ProfileTitleFragment
    avatar {
      id
      medium
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const TaskAnswersResultFragmentFragmentDoc = gql`
    fragment TaskAnswersResultFragment on TournamentResultEntity {
  id
  pointsAmount
  maxPointsAmount
  answers {
    ...TaskResultFragment
  }
  tournament {
    id
    uuid
    subject
    liveBroadcastUrl
    tasks {
      id
      task {
        id
        uuid
        question
      }
    }
  }
}
    ${TaskResultFragmentFragmentDoc}`;
export const TournamentResultParticipantsFragmentFragmentDoc = gql`
    fragment TournamentResultParticipantsFragment on TournamentResultEntity {
  id
  tournament {
    id
    uuid
  }
  user {
    id
    lastOnlineAt
    profile {
      id
      fullNameShort
      fullName
      firstName
      lastName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const ReadyAndUpcomingTournamentsFragmentFragmentDoc = gql`
    fragment ReadyAndUpcomingTournamentsFragment on TournamentEntity {
  id
  state
  type
  subject
  startAt
  isMember
}
    `;
export const ProfileUpdateFragmentFragmentDoc = gql`
    fragment ProfileUpdateFragment on ProfileEntity {
  id
  firstName
  lastName
  fullName
  fullNameShort
  sex
  bdate
  role
  user {
    domain
  }
  avatar {
    id
    medium
  }
  contact {
    phone
    email
    messengerUrl
  }
}
    `;
export const StoriesFragmentFragmentDoc = gql`
    fragment StoriesFragment on StoriesEntity {
  id
  title
  duration
  type
  url
  hasView
  createdAt
  previewImage
  wrapper
  status
  seller {
    organization {
      logo
    }
  }
  user {
    id
    profile {
      id
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export const TournamentFindOneDocument = gql`
    query TournamentFindOne($tournamentId: Int!) {
  tournamentFindOne(tournamentId: $tournamentId) {
    startMode
    ...TournamentFindOneFragment
  }
}
    ${TournamentFindOneFragmentFragmentDoc}`;
export type TournamentFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentFindOneQuery, TournamentFindOneQueryVariables>, 'query'> & ({ variables: TournamentFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentFindOneQuery = (props: TournamentFindOneQueryProps) => (
      <ApolloReactComponents.Query<TournamentFindOneQuery, TournamentFindOneQueryVariables> query={TournamentFindOneDocument} {...props} />
    );


/**
 * __useTournamentFindOneQuery__
 *
 * To run a query within a React component, call `useTournamentFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentFindOneQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentFindOneQuery(baseOptions: Apollo.QueryHookOptions<TournamentFindOneQuery, TournamentFindOneQueryVariables> & ({ variables: TournamentFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentFindOneQuery, TournamentFindOneQueryVariables>(TournamentFindOneDocument, options);
      }
export function useTournamentFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentFindOneQuery, TournamentFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentFindOneQuery, TournamentFindOneQueryVariables>(TournamentFindOneDocument, options);
        }
export function useTournamentFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentFindOneQuery, TournamentFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentFindOneQuery, TournamentFindOneQueryVariables>(TournamentFindOneDocument, options);
        }
export type TournamentFindOneQueryHookResult = ReturnType<typeof useTournamentFindOneQuery>;
export type TournamentFindOneLazyQueryHookResult = ReturnType<typeof useTournamentFindOneLazyQuery>;
export type TournamentFindOneSuspenseQueryHookResult = ReturnType<typeof useTournamentFindOneSuspenseQuery>;
export type TournamentFindOneQueryResult = Apollo.QueryResult<TournamentFindOneQuery, TournamentFindOneQueryVariables>;
export const TournamentLobbyAppointDocument = gql`
    mutation TournamentLobbyAppoint($tournamentId: Int!, $inviteKey: String!) {
  tournamentLobbyAppoint(tournamentId: $tournamentId, inviteKey: $inviteKey) {
    id
    uuid
    isMember
    countMembers
  }
}
    `;
export type TournamentLobbyAppointMutationFn = Apollo.MutationFunction<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables>;
export type TournamentLobbyAppointQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables>, 'mutation'>;

    export const TournamentLobbyAppointQuery = (props: TournamentLobbyAppointQueryProps) => (
      <ApolloReactComponents.Mutation<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables> mutation={TournamentLobbyAppointDocument} {...props} />
    );


/**
 * __useTournamentLobbyAppointMutation__
 *
 * To run a mutation, you first call `useTournamentLobbyAppointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTournamentLobbyAppointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tournamentLobbyAppointMutation, { data, loading, error }] = useTournamentLobbyAppointMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      inviteKey: // value for 'inviteKey'
 *   },
 * });
 */
export function useTournamentLobbyAppointMutation(baseOptions?: Apollo.MutationHookOptions<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables>(TournamentLobbyAppointDocument, options);
      }
export type TournamentLobbyAppointMutationHookResult = ReturnType<typeof useTournamentLobbyAppointMutation>;
export type TournamentLobbyAppointMutationResult = Apollo.MutationResult<TournamentLobbyAppointMutation>;
export type TournamentLobbyAppointMutationOptions = Apollo.BaseMutationOptions<TournamentLobbyAppointMutation, TournamentLobbyAppointMutationVariables>;
export const ChatFindOneTopBarDocument = gql`
    query ChatFindOneTopBar($chatId: Int!) {
  chatFindOne(chatId: $chatId) {
    id
    type
    name
    countUnread
    countMembers
    isAdmin
    sendMessagePermission
    personalCompanionMember {
      ...ChatPersonalCompanionMemberFragment
    }
    myMember {
      ...ChatMyMemberFragment
    }
  }
}
    ${ChatPersonalCompanionMemberFragmentFragmentDoc}
${ChatMyMemberFragmentFragmentDoc}`;
export type ChatFindOneTopBarQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>, 'query'> & ({ variables: ChatFindOneTopBarQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatFindOneTopBarQuery = (props: ChatFindOneTopBarQueryProps) => (
      <ApolloReactComponents.Query<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables> query={ChatFindOneTopBarDocument} {...props} />
    );


/**
 * __useChatFindOneTopBarQuery__
 *
 * To run a query within a React component, call `useChatFindOneTopBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatFindOneTopBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatFindOneTopBarQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatFindOneTopBarQuery(baseOptions: Apollo.QueryHookOptions<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables> & ({ variables: ChatFindOneTopBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>(ChatFindOneTopBarDocument, options);
      }
export function useChatFindOneTopBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>(ChatFindOneTopBarDocument, options);
        }
export function useChatFindOneTopBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>(ChatFindOneTopBarDocument, options);
        }
export type ChatFindOneTopBarQueryHookResult = ReturnType<typeof useChatFindOneTopBarQuery>;
export type ChatFindOneTopBarLazyQueryHookResult = ReturnType<typeof useChatFindOneTopBarLazyQuery>;
export type ChatFindOneTopBarSuspenseQueryHookResult = ReturnType<typeof useChatFindOneTopBarSuspenseQuery>;
export type ChatFindOneTopBarQueryResult = Apollo.QueryResult<ChatFindOneTopBarQuery, ChatFindOneTopBarQueryVariables>;
export const ChatMemberFindManyDocument = gql`
    query ChatMemberFindMany($chatId: Int!, $list: ListInput!, $filter: FilterMemberChatInput!, $sort: BaseSortInput) {
  chatMemberFindMany(chatId: $chatId, list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      user {
        id
        lastOnlineAt
        domain
        profile {
          id
          firstName
          lastName
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ChatMemberFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>, 'query'> & ({ variables: ChatMemberFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatMemberFindManyQuery = (props: ChatMemberFindManyQueryProps) => (
      <ApolloReactComponents.Query<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables> query={ChatMemberFindManyDocument} {...props} />
    );


/**
 * __useChatMemberFindManyQuery__
 *
 * To run a query within a React component, call `useChatMemberFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMemberFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMemberFindManyQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useChatMemberFindManyQuery(baseOptions: Apollo.QueryHookOptions<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables> & ({ variables: ChatMemberFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>(ChatMemberFindManyDocument, options);
      }
export function useChatMemberFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>(ChatMemberFindManyDocument, options);
        }
export function useChatMemberFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>(ChatMemberFindManyDocument, options);
        }
export type ChatMemberFindManyQueryHookResult = ReturnType<typeof useChatMemberFindManyQuery>;
export type ChatMemberFindManyLazyQueryHookResult = ReturnType<typeof useChatMemberFindManyLazyQuery>;
export type ChatMemberFindManySuspenseQueryHookResult = ReturnType<typeof useChatMemberFindManySuspenseQuery>;
export type ChatMemberFindManyQueryResult = Apollo.QueryResult<ChatMemberFindManyQuery, ChatMemberFindManyQueryVariables>;
export const ChatFindManyDocument = gql`
    query ChatFindMany($list: ListInput!, $filter: FilterChatInput!, $sort: SortChatInput, $cursor: CursorInput) {
  chatFindMany(list: $list, filter: $filter, sort: $sort, cursor: $cursor) {
    count
    cursor {
      after
      before
      hasNext
      hasPrev
    }
    items {
      ...ChatFragment
    }
  }
}
    ${ChatFragmentFragmentDoc}`;
export type ChatFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatFindManyQuery, ChatFindManyQueryVariables>, 'query'> & ({ variables: ChatFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatFindManyQuery = (props: ChatFindManyQueryProps) => (
      <ApolloReactComponents.Query<ChatFindManyQuery, ChatFindManyQueryVariables> query={ChatFindManyDocument} {...props} />
    );


/**
 * __useChatFindManyQuery__
 *
 * To run a query within a React component, call `useChatFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useChatFindManyQuery(baseOptions: Apollo.QueryHookOptions<ChatFindManyQuery, ChatFindManyQueryVariables> & ({ variables: ChatFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatFindManyQuery, ChatFindManyQueryVariables>(ChatFindManyDocument, options);
      }
export function useChatFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatFindManyQuery, ChatFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatFindManyQuery, ChatFindManyQueryVariables>(ChatFindManyDocument, options);
        }
export function useChatFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatFindManyQuery, ChatFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatFindManyQuery, ChatFindManyQueryVariables>(ChatFindManyDocument, options);
        }
export type ChatFindManyQueryHookResult = ReturnType<typeof useChatFindManyQuery>;
export type ChatFindManyLazyQueryHookResult = ReturnType<typeof useChatFindManyLazyQuery>;
export type ChatFindManySuspenseQueryHookResult = ReturnType<typeof useChatFindManySuspenseQuery>;
export type ChatFindManyQueryResult = Apollo.QueryResult<ChatFindManyQuery, ChatFindManyQueryVariables>;
export const ChatAndProfileSearchFindManyDocument = gql`
    query ChatAndProfileSearchFindMany($chatList: ListInput!, $chatFilter: FilterChatInput!, $chatSort: SortChatInput, $profileList: ListInput!, $profileFilter: FilterProfileInput!, $profileSort: BaseSortInput, $profileSkip: Boolean!) {
  chatFindMany(list: $chatList, filter: $chatFilter, sort: $chatSort) {
    count
    cursor {
      after
      before
      hasNext
      hasPrev
    }
    items {
      ...ChatFragment
    }
  }
  profileFindMany(list: $profileList, filter: $profileFilter, sort: $profileSort) @skip(if: $profileSkip) {
    items {
      id
      sex
      firstName
      lastName
      fullName
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
      user {
        id
        lastOnlineAt
        updatedAt
      }
    }
  }
}
    ${ChatFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type ChatAndProfileSearchFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>, 'query'> & ({ variables: ChatAndProfileSearchFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatAndProfileSearchFindManyQuery = (props: ChatAndProfileSearchFindManyQueryProps) => (
      <ApolloReactComponents.Query<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables> query={ChatAndProfileSearchFindManyDocument} {...props} />
    );


/**
 * __useChatAndProfileSearchFindManyQuery__
 *
 * To run a query within a React component, call `useChatAndProfileSearchFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAndProfileSearchFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAndProfileSearchFindManyQuery({
 *   variables: {
 *      chatList: // value for 'chatList'
 *      chatFilter: // value for 'chatFilter'
 *      chatSort: // value for 'chatSort'
 *      profileList: // value for 'profileList'
 *      profileFilter: // value for 'profileFilter'
 *      profileSort: // value for 'profileSort'
 *      profileSkip: // value for 'profileSkip'
 *   },
 * });
 */
export function useChatAndProfileSearchFindManyQuery(baseOptions: Apollo.QueryHookOptions<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables> & ({ variables: ChatAndProfileSearchFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>(ChatAndProfileSearchFindManyDocument, options);
      }
export function useChatAndProfileSearchFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>(ChatAndProfileSearchFindManyDocument, options);
        }
export function useChatAndProfileSearchFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>(ChatAndProfileSearchFindManyDocument, options);
        }
export type ChatAndProfileSearchFindManyQueryHookResult = ReturnType<typeof useChatAndProfileSearchFindManyQuery>;
export type ChatAndProfileSearchFindManyLazyQueryHookResult = ReturnType<typeof useChatAndProfileSearchFindManyLazyQuery>;
export type ChatAndProfileSearchFindManySuspenseQueryHookResult = ReturnType<typeof useChatAndProfileSearchFindManySuspenseQuery>;
export type ChatAndProfileSearchFindManyQueryResult = Apollo.QueryResult<ChatAndProfileSearchFindManyQuery, ChatAndProfileSearchFindManyQueryVariables>;
export const ChatMessageFindOneDocument = gql`
    query ChatMessageFindOne($chatId: Int!, $messageId: Int!) {
  chatMessageFindOne(chatId: $chatId, messageId: $messageId) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>, 'query'> & ({ variables: ChatMessageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatMessageFindOneQuery = (props: ChatMessageFindOneQueryProps) => (
      <ApolloReactComponents.Query<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables> query={ChatMessageFindOneDocument} {...props} />
    );


/**
 * __useChatMessageFindOneQuery__
 *
 * To run a query within a React component, call `useChatMessageFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageFindOneQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useChatMessageFindOneQuery(baseOptions: Apollo.QueryHookOptions<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables> & ({ variables: ChatMessageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>(ChatMessageFindOneDocument, options);
      }
export function useChatMessageFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>(ChatMessageFindOneDocument, options);
        }
export function useChatMessageFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>(ChatMessageFindOneDocument, options);
        }
export type ChatMessageFindOneQueryHookResult = ReturnType<typeof useChatMessageFindOneQuery>;
export type ChatMessageFindOneLazyQueryHookResult = ReturnType<typeof useChatMessageFindOneLazyQuery>;
export type ChatMessageFindOneSuspenseQueryHookResult = ReturnType<typeof useChatMessageFindOneSuspenseQuery>;
export type ChatMessageFindOneQueryResult = Apollo.QueryResult<ChatMessageFindOneQuery, ChatMessageFindOneQueryVariables>;
export const ChatMessageFindManyDocument = gql`
    query ChatMessageFindMany($chatId: Int!, $list: ListInput!, $filter: FilterMessageChatInput!, $sort: BaseSortInput, $cursor: CursorInput) {
  chatMessageFindMany(
    chatId: $chatId
    list: $list
    filter: $filter
    sort: $sort
    cursor: $cursor
  ) {
    items {
      ...MessageFragment
    }
    cursor {
      hasPrev
      hasNext
      before
      after
    }
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>, 'query'> & ({ variables: ChatMessageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatMessageFindManyQuery = (props: ChatMessageFindManyQueryProps) => (
      <ApolloReactComponents.Query<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables> query={ChatMessageFindManyDocument} {...props} />
    );


/**
 * __useChatMessageFindManyQuery__
 *
 * To run a query within a React component, call `useChatMessageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageFindManyQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useChatMessageFindManyQuery(baseOptions: Apollo.QueryHookOptions<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables> & ({ variables: ChatMessageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>(ChatMessageFindManyDocument, options);
      }
export function useChatMessageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>(ChatMessageFindManyDocument, options);
        }
export function useChatMessageFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>(ChatMessageFindManyDocument, options);
        }
export type ChatMessageFindManyQueryHookResult = ReturnType<typeof useChatMessageFindManyQuery>;
export type ChatMessageFindManyLazyQueryHookResult = ReturnType<typeof useChatMessageFindManyLazyQuery>;
export type ChatMessageFindManySuspenseQueryHookResult = ReturnType<typeof useChatMessageFindManySuspenseQuery>;
export type ChatMessageFindManyQueryResult = Apollo.QueryResult<ChatMessageFindManyQuery, ChatMessageFindManyQueryVariables>;
export const ChatAttachmentsFindManyDocument = gql`
    query ChatAttachmentsFindMany($chatId: Int!, $list: ListInput!, $filter: FilterMessageChatInput!, $sort: BaseSortInput, $cursor: CursorInput) {
  chatMessageFindMany(
    chatId: $chatId
    list: $list
    filter: $filter
    sort: $sort
    cursor: $cursor
  ) {
    items {
      id
      medias {
        id
        storage {
          id
          uuid
          key
          createdAt
          updatedAt
          location
          fileType
          imageSizes {
            small
            medium
            maximum
          }
          meta {
            size
            originalName
            duration
            mimeType
            dimensions {
              width
              height
            }
          }
        }
      }
    }
    cursor {
      hasPrev
      hasNext
      before
      after
    }
  }
}
    `;
export type ChatAttachmentsFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>, 'query'> & ({ variables: ChatAttachmentsFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatAttachmentsFindManyQuery = (props: ChatAttachmentsFindManyQueryProps) => (
      <ApolloReactComponents.Query<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables> query={ChatAttachmentsFindManyDocument} {...props} />
    );


/**
 * __useChatAttachmentsFindManyQuery__
 *
 * To run a query within a React component, call `useChatAttachmentsFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAttachmentsFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAttachmentsFindManyQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useChatAttachmentsFindManyQuery(baseOptions: Apollo.QueryHookOptions<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables> & ({ variables: ChatAttachmentsFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>(ChatAttachmentsFindManyDocument, options);
      }
export function useChatAttachmentsFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>(ChatAttachmentsFindManyDocument, options);
        }
export function useChatAttachmentsFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>(ChatAttachmentsFindManyDocument, options);
        }
export type ChatAttachmentsFindManyQueryHookResult = ReturnType<typeof useChatAttachmentsFindManyQuery>;
export type ChatAttachmentsFindManyLazyQueryHookResult = ReturnType<typeof useChatAttachmentsFindManyLazyQuery>;
export type ChatAttachmentsFindManySuspenseQueryHookResult = ReturnType<typeof useChatAttachmentsFindManySuspenseQuery>;
export type ChatAttachmentsFindManyQueryResult = Apollo.QueryResult<ChatAttachmentsFindManyQuery, ChatAttachmentsFindManyQueryVariables>;
export const FindManyFriendsHasNotPersonalChatDocument = gql`
    query FindManyFriendsHasNotPersonalChat($list: ListInput!, $filter: FilterFriendshipInput!, $sort: BaseSortInput, $relUserId: Int) {
  friendshipFindMany(
    list: $list
    filter: $filter
    sort: $sort
    relUserId: $relUserId
  ) {
    count
    items {
      id
      lastOnlineAt
      updatedAt
      profile {
        id
        sex
        firstName
        lastName
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type FindManyFriendsHasNotPersonalChatQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>, 'query'> & ({ variables: FindManyFriendsHasNotPersonalChatQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindManyFriendsHasNotPersonalChatQuery = (props: FindManyFriendsHasNotPersonalChatQueryProps) => (
      <ApolloReactComponents.Query<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables> query={FindManyFriendsHasNotPersonalChatDocument} {...props} />
    );


/**
 * __useFindManyFriendsHasNotPersonalChatQuery__
 *
 * To run a query within a React component, call `useFindManyFriendsHasNotPersonalChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFriendsHasNotPersonalChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFriendsHasNotPersonalChatQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      relUserId: // value for 'relUserId'
 *   },
 * });
 */
export function useFindManyFriendsHasNotPersonalChatQuery(baseOptions: Apollo.QueryHookOptions<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables> & ({ variables: FindManyFriendsHasNotPersonalChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>(FindManyFriendsHasNotPersonalChatDocument, options);
      }
export function useFindManyFriendsHasNotPersonalChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>(FindManyFriendsHasNotPersonalChatDocument, options);
        }
export function useFindManyFriendsHasNotPersonalChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>(FindManyFriendsHasNotPersonalChatDocument, options);
        }
export type FindManyFriendsHasNotPersonalChatQueryHookResult = ReturnType<typeof useFindManyFriendsHasNotPersonalChatQuery>;
export type FindManyFriendsHasNotPersonalChatLazyQueryHookResult = ReturnType<typeof useFindManyFriendsHasNotPersonalChatLazyQuery>;
export type FindManyFriendsHasNotPersonalChatSuspenseQueryHookResult = ReturnType<typeof useFindManyFriendsHasNotPersonalChatSuspenseQuery>;
export type FindManyFriendsHasNotPersonalChatQueryResult = Apollo.QueryResult<FindManyFriendsHasNotPersonalChatQuery, FindManyFriendsHasNotPersonalChatQueryVariables>;
export const ChatProfileFindOneDocument = gql`
    query ChatProfileFindOne($userId: Int!) {
  profileFindOne(userId: $userId) {
    ...ProfileFindOneFragment
  }
}
    ${ProfileFindOneFragmentFragmentDoc}`;
export type ChatProfileFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>, 'query'> & ({ variables: ChatProfileFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatProfileFindOneQuery = (props: ChatProfileFindOneQueryProps) => (
      <ApolloReactComponents.Query<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables> query={ChatProfileFindOneDocument} {...props} />
    );


/**
 * __useChatProfileFindOneQuery__
 *
 * To run a query within a React component, call `useChatProfileFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatProfileFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatProfileFindOneQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatProfileFindOneQuery(baseOptions: Apollo.QueryHookOptions<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables> & ({ variables: ChatProfileFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>(ChatProfileFindOneDocument, options);
      }
export function useChatProfileFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>(ChatProfileFindOneDocument, options);
        }
export function useChatProfileFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>(ChatProfileFindOneDocument, options);
        }
export type ChatProfileFindOneQueryHookResult = ReturnType<typeof useChatProfileFindOneQuery>;
export type ChatProfileFindOneLazyQueryHookResult = ReturnType<typeof useChatProfileFindOneLazyQuery>;
export type ChatProfileFindOneSuspenseQueryHookResult = ReturnType<typeof useChatProfileFindOneSuspenseQuery>;
export type ChatProfileFindOneQueryResult = Apollo.QueryResult<ChatProfileFindOneQuery, ChatProfileFindOneQueryVariables>;
export const ChatGetUnreadCountDocument = gql`
    query ChatGetUnreadCount($types: [ChatType!]) {
  chatGetUnreadCount(types: $types)
}
    `;
export type ChatGetUnreadCountQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>, 'query'>;

    export const ChatGetUnreadCountQuery = (props: ChatGetUnreadCountQueryProps) => (
      <ApolloReactComponents.Query<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables> query={ChatGetUnreadCountDocument} {...props} />
    );


/**
 * __useChatGetUnreadCountQuery__
 *
 * To run a query within a React component, call `useChatGetUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetUnreadCountQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useChatGetUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>(ChatGetUnreadCountDocument, options);
      }
export function useChatGetUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>(ChatGetUnreadCountDocument, options);
        }
export function useChatGetUnreadCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>(ChatGetUnreadCountDocument, options);
        }
export type ChatGetUnreadCountQueryHookResult = ReturnType<typeof useChatGetUnreadCountQuery>;
export type ChatGetUnreadCountLazyQueryHookResult = ReturnType<typeof useChatGetUnreadCountLazyQuery>;
export type ChatGetUnreadCountSuspenseQueryHookResult = ReturnType<typeof useChatGetUnreadCountSuspenseQuery>;
export type ChatGetUnreadCountQueryResult = Apollo.QueryResult<ChatGetUnreadCountQuery, ChatGetUnreadCountQueryVariables>;
export const ChatFindOnePersonalDocument = gql`
    query ChatFindOnePersonal($userId: Int!) {
  chatFindOnePersonal(userId: $userId) {
    ...ChatFragment
  }
}
    ${ChatFragmentFragmentDoc}`;
export type ChatFindOnePersonalQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>, 'query'> & ({ variables: ChatFindOnePersonalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChatFindOnePersonalQuery = (props: ChatFindOnePersonalQueryProps) => (
      <ApolloReactComponents.Query<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables> query={ChatFindOnePersonalDocument} {...props} />
    );


/**
 * __useChatFindOnePersonalQuery__
 *
 * To run a query within a React component, call `useChatFindOnePersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatFindOnePersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatFindOnePersonalQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatFindOnePersonalQuery(baseOptions: Apollo.QueryHookOptions<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables> & ({ variables: ChatFindOnePersonalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>(ChatFindOnePersonalDocument, options);
      }
export function useChatFindOnePersonalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>(ChatFindOnePersonalDocument, options);
        }
export function useChatFindOnePersonalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>(ChatFindOnePersonalDocument, options);
        }
export type ChatFindOnePersonalQueryHookResult = ReturnType<typeof useChatFindOnePersonalQuery>;
export type ChatFindOnePersonalLazyQueryHookResult = ReturnType<typeof useChatFindOnePersonalLazyQuery>;
export type ChatFindOnePersonalSuspenseQueryHookResult = ReturnType<typeof useChatFindOnePersonalSuspenseQuery>;
export type ChatFindOnePersonalQueryResult = Apollo.QueryResult<ChatFindOnePersonalQuery, ChatFindOnePersonalQueryVariables>;
export const ChatCreateDocument = gql`
    mutation ChatCreate($chat: CreateChatInput!) {
  chatCreate(chat: $chat) {
    ...ChatFragment
  }
}
    ${ChatFragmentFragmentDoc}`;
export type ChatCreateMutationFn = Apollo.MutationFunction<ChatCreateMutation, ChatCreateMutationVariables>;
export type ChatCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatCreateMutation, ChatCreateMutationVariables>, 'mutation'>;

    export const ChatCreateQuery = (props: ChatCreateQueryProps) => (
      <ApolloReactComponents.Mutation<ChatCreateMutation, ChatCreateMutationVariables> mutation={ChatCreateDocument} {...props} />
    );


/**
 * __useChatCreateMutation__
 *
 * To run a mutation, you first call `useChatCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatCreateMutation, { data, loading, error }] = useChatCreateMutation({
 *   variables: {
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useChatCreateMutation(baseOptions?: Apollo.MutationHookOptions<ChatCreateMutation, ChatCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatCreateMutation, ChatCreateMutationVariables>(ChatCreateDocument, options);
      }
export type ChatCreateMutationHookResult = ReturnType<typeof useChatCreateMutation>;
export type ChatCreateMutationResult = Apollo.MutationResult<ChatCreateMutation>;
export type ChatCreateMutationOptions = Apollo.BaseMutationOptions<ChatCreateMutation, ChatCreateMutationVariables>;
export const ChatMessageSendDocument = gql`
    mutation ChatMessageSend($chatId: Int!, $message: SendMessageChatInput!) {
  chatMessageSend(chatId: $chatId, message: $message) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageSendMutationFn = Apollo.MutationFunction<ChatMessageSendMutation, ChatMessageSendMutationVariables>;
export type ChatMessageSendQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMessageSendMutation, ChatMessageSendMutationVariables>, 'mutation'>;

    export const ChatMessageSendQuery = (props: ChatMessageSendQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMessageSendMutation, ChatMessageSendMutationVariables> mutation={ChatMessageSendDocument} {...props} />
    );


/**
 * __useChatMessageSendMutation__
 *
 * To run a mutation, you first call `useChatMessageSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageSendMutation, { data, loading, error }] = useChatMessageSendMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useChatMessageSendMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageSendMutation, ChatMessageSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageSendMutation, ChatMessageSendMutationVariables>(ChatMessageSendDocument, options);
      }
export type ChatMessageSendMutationHookResult = ReturnType<typeof useChatMessageSendMutation>;
export type ChatMessageSendMutationResult = Apollo.MutationResult<ChatMessageSendMutation>;
export type ChatMessageSendMutationOptions = Apollo.BaseMutationOptions<ChatMessageSendMutation, ChatMessageSendMutationVariables>;
export const ChatMessageEditDocument = gql`
    mutation ChatMessageEdit($chatId: Int!, $messageId: Int!, $message: EditMessageChatInput!) {
  chatMessageEdit(chatId: $chatId, messageId: $messageId, message: $message) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageEditMutationFn = Apollo.MutationFunction<ChatMessageEditMutation, ChatMessageEditMutationVariables>;
export type ChatMessageEditQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMessageEditMutation, ChatMessageEditMutationVariables>, 'mutation'>;

    export const ChatMessageEditQuery = (props: ChatMessageEditQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMessageEditMutation, ChatMessageEditMutationVariables> mutation={ChatMessageEditDocument} {...props} />
    );


/**
 * __useChatMessageEditMutation__
 *
 * To run a mutation, you first call `useChatMessageEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageEditMutation, { data, loading, error }] = useChatMessageEditMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useChatMessageEditMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageEditMutation, ChatMessageEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageEditMutation, ChatMessageEditMutationVariables>(ChatMessageEditDocument, options);
      }
export type ChatMessageEditMutationHookResult = ReturnType<typeof useChatMessageEditMutation>;
export type ChatMessageEditMutationResult = Apollo.MutationResult<ChatMessageEditMutation>;
export type ChatMessageEditMutationOptions = Apollo.BaseMutationOptions<ChatMessageEditMutation, ChatMessageEditMutationVariables>;
export const ChatMessageReadManyDocument = gql`
    mutation ChatMessageReadMany($chatId: Int!, $messageIds: [Int!]!) {
  chatMessageReadMany(chatId: $chatId, messageIds: $messageIds) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageReadManyMutationFn = Apollo.MutationFunction<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables>;
export type ChatMessageReadManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables>, 'mutation'>;

    export const ChatMessageReadManyQuery = (props: ChatMessageReadManyQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables> mutation={ChatMessageReadManyDocument} {...props} />
    );


/**
 * __useChatMessageReadManyMutation__
 *
 * To run a mutation, you first call `useChatMessageReadManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageReadManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageReadManyMutation, { data, loading, error }] = useChatMessageReadManyMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageIds: // value for 'messageIds'
 *   },
 * });
 */
export function useChatMessageReadManyMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables>(ChatMessageReadManyDocument, options);
      }
export type ChatMessageReadManyMutationHookResult = ReturnType<typeof useChatMessageReadManyMutation>;
export type ChatMessageReadManyMutationResult = Apollo.MutationResult<ChatMessageReadManyMutation>;
export type ChatMessageReadManyMutationOptions = Apollo.BaseMutationOptions<ChatMessageReadManyMutation, ChatMessageReadManyMutationVariables>;
export const ChatTypingSetStatusDocument = gql`
    mutation ChatTypingSetStatus($chatId: Int!, $isTyping: Boolean!) {
  chatTypingSetStatus(chatId: $chatId, isTyping: $isTyping) {
    profiles {
      id
      fullNameShort
    }
  }
}
    `;
export type ChatTypingSetStatusMutationFn = Apollo.MutationFunction<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables>;
export type ChatTypingSetStatusQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables>, 'mutation'>;

    export const ChatTypingSetStatusQuery = (props: ChatTypingSetStatusQueryProps) => (
      <ApolloReactComponents.Mutation<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables> mutation={ChatTypingSetStatusDocument} {...props} />
    );


/**
 * __useChatTypingSetStatusMutation__
 *
 * To run a mutation, you first call `useChatTypingSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatTypingSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatTypingSetStatusMutation, { data, loading, error }] = useChatTypingSetStatusMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      isTyping: // value for 'isTyping'
 *   },
 * });
 */
export function useChatTypingSetStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables>(ChatTypingSetStatusDocument, options);
      }
export type ChatTypingSetStatusMutationHookResult = ReturnType<typeof useChatTypingSetStatusMutation>;
export type ChatTypingSetStatusMutationResult = Apollo.MutationResult<ChatTypingSetStatusMutation>;
export type ChatTypingSetStatusMutationOptions = Apollo.BaseMutationOptions<ChatTypingSetStatusMutation, ChatTypingSetStatusMutationVariables>;
export const ChatMessageDeleteManyDocument = gql`
    mutation ChatMessageDeleteMany($chatId: Int!, $messageIds: [Int!]!) {
  chatMessageDeleteMany(chatId: $chatId, messageIds: $messageIds)
}
    `;
export type ChatMessageDeleteManyMutationFn = Apollo.MutationFunction<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables>;
export type ChatMessageDeleteManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables>, 'mutation'>;

    export const ChatMessageDeleteManyQuery = (props: ChatMessageDeleteManyQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables> mutation={ChatMessageDeleteManyDocument} {...props} />
    );


/**
 * __useChatMessageDeleteManyMutation__
 *
 * To run a mutation, you first call `useChatMessageDeleteManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageDeleteManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageDeleteManyMutation, { data, loading, error }] = useChatMessageDeleteManyMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageIds: // value for 'messageIds'
 *   },
 * });
 */
export function useChatMessageDeleteManyMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables>(ChatMessageDeleteManyDocument, options);
      }
export type ChatMessageDeleteManyMutationHookResult = ReturnType<typeof useChatMessageDeleteManyMutation>;
export type ChatMessageDeleteManyMutationResult = Apollo.MutationResult<ChatMessageDeleteManyMutation>;
export type ChatMessageDeleteManyMutationOptions = Apollo.BaseMutationOptions<ChatMessageDeleteManyMutation, ChatMessageDeleteManyMutationVariables>;
export const ChatMemberUpdateDocument = gql`
    mutation ChatMemberUpdate($chatId: Int!, $member: UpdateMemberChatInput!) {
  chatMemberUpdate(chatId: $chatId, member: $member) {
    id
    muted
    blocked
    deletedAt
    blockedUntil
    chat {
      id
      myMember {
        ...ChatMyMemberFragment
      }
    }
  }
}
    ${ChatMyMemberFragmentFragmentDoc}`;
export type ChatMemberUpdateMutationFn = Apollo.MutationFunction<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables>;
export type ChatMemberUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables>, 'mutation'>;

    export const ChatMemberUpdateQuery = (props: ChatMemberUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables> mutation={ChatMemberUpdateDocument} {...props} />
    );


/**
 * __useChatMemberUpdateMutation__
 *
 * To run a mutation, you first call `useChatMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMemberUpdateMutation, { data, loading, error }] = useChatMemberUpdateMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      member: // value for 'member'
 *   },
 * });
 */
export function useChatMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables>(ChatMemberUpdateDocument, options);
      }
export type ChatMemberUpdateMutationHookResult = ReturnType<typeof useChatMemberUpdateMutation>;
export type ChatMemberUpdateMutationResult = Apollo.MutationResult<ChatMemberUpdateMutation>;
export type ChatMemberUpdateMutationOptions = Apollo.BaseMutationOptions<ChatMemberUpdateMutation, ChatMemberUpdateMutationVariables>;
export const ChatMemberDeleteDocument = gql`
    mutation ChatMemberDelete($chatId: Int!) {
  chatMemberDelete(chatId: $chatId)
}
    `;
export type ChatMemberDeleteMutationFn = Apollo.MutationFunction<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables>;
export type ChatMemberDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables>, 'mutation'>;

    export const ChatMemberDeleteQuery = (props: ChatMemberDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables> mutation={ChatMemberDeleteDocument} {...props} />
    );


/**
 * __useChatMemberDeleteMutation__
 *
 * To run a mutation, you first call `useChatMemberDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMemberDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMemberDeleteMutation, { data, loading, error }] = useChatMemberDeleteMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatMemberDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables>(ChatMemberDeleteDocument, options);
      }
export type ChatMemberDeleteMutationHookResult = ReturnType<typeof useChatMemberDeleteMutation>;
export type ChatMemberDeleteMutationResult = Apollo.MutationResult<ChatMemberDeleteMutation>;
export type ChatMemberDeleteMutationOptions = Apollo.BaseMutationOptions<ChatMemberDeleteMutation, ChatMemberDeleteMutationVariables>;
export const ChatMemberToggleBlockPersonalDocument = gql`
    mutation ChatMemberToggleBlockPersonal($chatId: Int!, $companionUserId: Int!, $blocked: Boolean!) {
  chatMemberToggleBlockPersonal(
    chatId: $chatId
    companionUserId: $companionUserId
    blocked: $blocked
  ) {
    id
    muted
    blocked
    createdAt
    updatedAt
    deletedAt
    blockedUntil
    chat {
      id
      myMember {
        ...ChatMyMemberFragment
      }
    }
  }
}
    ${ChatMyMemberFragmentFragmentDoc}`;
export type ChatMemberToggleBlockPersonalMutationFn = Apollo.MutationFunction<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables>;
export type ChatMemberToggleBlockPersonalQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables>, 'mutation'>;

    export const ChatMemberToggleBlockPersonalQuery = (props: ChatMemberToggleBlockPersonalQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables> mutation={ChatMemberToggleBlockPersonalDocument} {...props} />
    );


/**
 * __useChatMemberToggleBlockPersonalMutation__
 *
 * To run a mutation, you first call `useChatMemberToggleBlockPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMemberToggleBlockPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMemberToggleBlockPersonalMutation, { data, loading, error }] = useChatMemberToggleBlockPersonalMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      companionUserId: // value for 'companionUserId'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useChatMemberToggleBlockPersonalMutation(baseOptions?: Apollo.MutationHookOptions<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables>(ChatMemberToggleBlockPersonalDocument, options);
      }
export type ChatMemberToggleBlockPersonalMutationHookResult = ReturnType<typeof useChatMemberToggleBlockPersonalMutation>;
export type ChatMemberToggleBlockPersonalMutationResult = Apollo.MutationResult<ChatMemberToggleBlockPersonalMutation>;
export type ChatMemberToggleBlockPersonalMutationOptions = Apollo.BaseMutationOptions<ChatMemberToggleBlockPersonalMutation, ChatMemberToggleBlockPersonalMutationVariables>;
export const ChatMessageForwardDocument = gql`
    mutation ChatMessageForward($chatId: Int!, $targetChatId: Int!, $message: ForwardMessageChatInput!) {
  chatMessageForward(
    chatId: $chatId
    message: $message
    targetChatId: $targetChatId
  ) {
    sent {
      ...MessageFragment
    }
    forwarded {
      ...MessageFragment
    }
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatMessageForwardMutationFn = Apollo.MutationFunction<ChatMessageForwardMutation, ChatMessageForwardMutationVariables>;
export type ChatMessageForwardQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ChatMessageForwardMutation, ChatMessageForwardMutationVariables>, 'mutation'>;

    export const ChatMessageForwardQuery = (props: ChatMessageForwardQueryProps) => (
      <ApolloReactComponents.Mutation<ChatMessageForwardMutation, ChatMessageForwardMutationVariables> mutation={ChatMessageForwardDocument} {...props} />
    );


/**
 * __useChatMessageForwardMutation__
 *
 * To run a mutation, you first call `useChatMessageForwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageForwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageForwardMutation, { data, loading, error }] = useChatMessageForwardMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      targetChatId: // value for 'targetChatId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useChatMessageForwardMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageForwardMutation, ChatMessageForwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageForwardMutation, ChatMessageForwardMutationVariables>(ChatMessageForwardDocument, options);
      }
export type ChatMessageForwardMutationHookResult = ReturnType<typeof useChatMessageForwardMutation>;
export type ChatMessageForwardMutationResult = Apollo.MutationResult<ChatMessageForwardMutation>;
export type ChatMessageForwardMutationOptions = Apollo.BaseMutationOptions<ChatMessageForwardMutation, ChatMessageForwardMutationVariables>;
export const ChatListenNewMessageDocument = gql`
    subscription ChatListenNewMessage($chatId: Int!) {
  chatListenNewMessage(chatId: $chatId) {
    action
    messages {
      ...MessageFragment
    }
  }
}
    ${MessageFragmentFragmentDoc}`;
export type ChatListenNewMessageQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ChatListenNewMessageSubscription, ChatListenNewMessageSubscriptionVariables>, 'subscription'>;

    export const ChatListenNewMessageQuery = (props: ChatListenNewMessageQueryProps) => (
      <ApolloReactComponents.Subscription<ChatListenNewMessageSubscription, ChatListenNewMessageSubscriptionVariables> subscription={ChatListenNewMessageDocument} {...props} />
    );


/**
 * __useChatListenNewMessageSubscription__
 *
 * To run a query within a React component, call `useChatListenNewMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatListenNewMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatListenNewMessageSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatListenNewMessageSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatListenNewMessageSubscription, ChatListenNewMessageSubscriptionVariables> & ({ variables: ChatListenNewMessageSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatListenNewMessageSubscription, ChatListenNewMessageSubscriptionVariables>(ChatListenNewMessageDocument, options);
      }
export type ChatListenNewMessageSubscriptionHookResult = ReturnType<typeof useChatListenNewMessageSubscription>;
export type ChatListenNewMessageSubscriptionResult = Apollo.SubscriptionResult<ChatListenNewMessageSubscription>;
export const ChatListenNewListEventDocument = gql`
    subscription ChatListenNewListEvent {
  chatListenNewListEvent {
    action
    chat {
      ...ChatFragment
    }
    myMember {
      ...ChatMyMemberFragment
    }
  }
}
    ${ChatFragmentFragmentDoc}
${ChatMyMemberFragmentFragmentDoc}`;
export type ChatListenNewListEventQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ChatListenNewListEventSubscription, ChatListenNewListEventSubscriptionVariables>, 'subscription'>;

    export const ChatListenNewListEventQuery = (props: ChatListenNewListEventQueryProps) => (
      <ApolloReactComponents.Subscription<ChatListenNewListEventSubscription, ChatListenNewListEventSubscriptionVariables> subscription={ChatListenNewListEventDocument} {...props} />
    );


/**
 * __useChatListenNewListEventSubscription__
 *
 * To run a query within a React component, call `useChatListenNewListEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatListenNewListEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatListenNewListEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatListenNewListEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatListenNewListEventSubscription, ChatListenNewListEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatListenNewListEventSubscription, ChatListenNewListEventSubscriptionVariables>(ChatListenNewListEventDocument, options);
      }
export type ChatListenNewListEventSubscriptionHookResult = ReturnType<typeof useChatListenNewListEventSubscription>;
export type ChatListenNewListEventSubscriptionResult = Apollo.SubscriptionResult<ChatListenNewListEventSubscription>;
export const ChatListenNewCountTotalUnreadDocument = gql`
    subscription ChatListenNewCountTotalUnread {
  chatListenNewTotalUnreadCount
}
    `;
export type ChatListenNewCountTotalUnreadQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ChatListenNewCountTotalUnreadSubscription, ChatListenNewCountTotalUnreadSubscriptionVariables>, 'subscription'>;

    export const ChatListenNewCountTotalUnreadQuery = (props: ChatListenNewCountTotalUnreadQueryProps) => (
      <ApolloReactComponents.Subscription<ChatListenNewCountTotalUnreadSubscription, ChatListenNewCountTotalUnreadSubscriptionVariables> subscription={ChatListenNewCountTotalUnreadDocument} {...props} />
    );


/**
 * __useChatListenNewCountTotalUnreadSubscription__
 *
 * To run a query within a React component, call `useChatListenNewCountTotalUnreadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatListenNewCountTotalUnreadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatListenNewCountTotalUnreadSubscription({
 *   variables: {
 *   },
 * });
 */
export function useChatListenNewCountTotalUnreadSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatListenNewCountTotalUnreadSubscription, ChatListenNewCountTotalUnreadSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatListenNewCountTotalUnreadSubscription, ChatListenNewCountTotalUnreadSubscriptionVariables>(ChatListenNewCountTotalUnreadDocument, options);
      }
export type ChatListenNewCountTotalUnreadSubscriptionHookResult = ReturnType<typeof useChatListenNewCountTotalUnreadSubscription>;
export type ChatListenNewCountTotalUnreadSubscriptionResult = Apollo.SubscriptionResult<ChatListenNewCountTotalUnreadSubscription>;
export const ChatListenNewTypingStateDocument = gql`
    subscription ChatListenNewTypingState($chatId: Int!) {
  chatListenNewTypingState(chatId: $chatId) {
    chatId
    anotherCount
    profiles {
      id
      firstName
    }
  }
}
    `;
export type ChatListenNewTypingStateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ChatListenNewTypingStateSubscription, ChatListenNewTypingStateSubscriptionVariables>, 'subscription'>;

    export const ChatListenNewTypingStateQuery = (props: ChatListenNewTypingStateQueryProps) => (
      <ApolloReactComponents.Subscription<ChatListenNewTypingStateSubscription, ChatListenNewTypingStateSubscriptionVariables> subscription={ChatListenNewTypingStateDocument} {...props} />
    );


/**
 * __useChatListenNewTypingStateSubscription__
 *
 * To run a query within a React component, call `useChatListenNewTypingStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatListenNewTypingStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatListenNewTypingStateSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatListenNewTypingStateSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatListenNewTypingStateSubscription, ChatListenNewTypingStateSubscriptionVariables> & ({ variables: ChatListenNewTypingStateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatListenNewTypingStateSubscription, ChatListenNewTypingStateSubscriptionVariables>(ChatListenNewTypingStateDocument, options);
      }
export type ChatListenNewTypingStateSubscriptionHookResult = ReturnType<typeof useChatListenNewTypingStateSubscription>;
export type ChatListenNewTypingStateSubscriptionResult = Apollo.SubscriptionResult<ChatListenNewTypingStateSubscription>;
export const ChatListenNewTotalUnreadCountDocument = gql`
    subscription ChatListenNewTotalUnreadCount($type: ChatType) {
  chatListenNewTotalUnreadCount(type: $type)
}
    `;
export type ChatListenNewTotalUnreadCountQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ChatListenNewTotalUnreadCountSubscription, ChatListenNewTotalUnreadCountSubscriptionVariables>, 'subscription'>;

    export const ChatListenNewTotalUnreadCountQuery = (props: ChatListenNewTotalUnreadCountQueryProps) => (
      <ApolloReactComponents.Subscription<ChatListenNewTotalUnreadCountSubscription, ChatListenNewTotalUnreadCountSubscriptionVariables> subscription={ChatListenNewTotalUnreadCountDocument} {...props} />
    );


/**
 * __useChatListenNewTotalUnreadCountSubscription__
 *
 * To run a query within a React component, call `useChatListenNewTotalUnreadCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatListenNewTotalUnreadCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatListenNewTotalUnreadCountSubscription({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useChatListenNewTotalUnreadCountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatListenNewTotalUnreadCountSubscription, ChatListenNewTotalUnreadCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatListenNewTotalUnreadCountSubscription, ChatListenNewTotalUnreadCountSubscriptionVariables>(ChatListenNewTotalUnreadCountDocument, options);
      }
export type ChatListenNewTotalUnreadCountSubscriptionHookResult = ReturnType<typeof useChatListenNewTotalUnreadCountSubscription>;
export type ChatListenNewTotalUnreadCountSubscriptionResult = Apollo.SubscriptionResult<ChatListenNewTotalUnreadCountSubscription>;
export const SupportTicketCreateByUserDocument = gql`
    mutation SupportTicketCreateByUser($ticket: CreateTicketSupportInput!) {
  supportTicketCreateByUser(ticket: $ticket) {
    chat {
      id
    }
  }
}
    `;
export type SupportTicketCreateByUserMutationFn = Apollo.MutationFunction<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables>;
export type SupportTicketCreateByUserQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables>, 'mutation'>;

    export const SupportTicketCreateByUserQuery = (props: SupportTicketCreateByUserQueryProps) => (
      <ApolloReactComponents.Mutation<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables> mutation={SupportTicketCreateByUserDocument} {...props} />
    );


/**
 * __useSupportTicketCreateByUserMutation__
 *
 * To run a mutation, you first call `useSupportTicketCreateByUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportTicketCreateByUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportTicketCreateByUserMutation, { data, loading, error }] = useSupportTicketCreateByUserMutation({
 *   variables: {
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useSupportTicketCreateByUserMutation(baseOptions?: Apollo.MutationHookOptions<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables>(SupportTicketCreateByUserDocument, options);
      }
export type SupportTicketCreateByUserMutationHookResult = ReturnType<typeof useSupportTicketCreateByUserMutation>;
export type SupportTicketCreateByUserMutationResult = Apollo.MutationResult<SupportTicketCreateByUserMutation>;
export type SupportTicketCreateByUserMutationOptions = Apollo.BaseMutationOptions<SupportTicketCreateByUserMutation, SupportTicketCreateByUserMutationVariables>;
export const CourseLessonPracticeAttemptWidgetDocument = gql`
    query CourseLessonPracticeAttemptWidget($attemptUuid: String!) {
  courseLessonPracticeAttemptFindOneByUuid(attemptUuid: $attemptUuid) {
    id
    uuid
    status
    finished
    solvedCount
    pointsAmount
    attemptIndex
    sentToReviewAt
    maxPointsAmount
    answers {
      ...TaskResultFragment
    }
    practice {
      id
      description
      lesson {
        id
        name
      }
    }
  }
}
    ${TaskResultFragmentFragmentDoc}`;
export type CourseLessonPracticeAttemptWidgetQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>, 'query'> & ({ variables: CourseLessonPracticeAttemptWidgetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonPracticeAttemptWidgetQuery = (props: CourseLessonPracticeAttemptWidgetQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables> query={CourseLessonPracticeAttemptWidgetDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeAttemptWidgetQuery__
 *
 * To run a query within a React component, call `useCourseLessonPracticeAttemptWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeAttemptWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonPracticeAttemptWidgetQuery({
 *   variables: {
 *      attemptUuid: // value for 'attemptUuid'
 *   },
 * });
 */
export function useCourseLessonPracticeAttemptWidgetQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables> & ({ variables: CourseLessonPracticeAttemptWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>(CourseLessonPracticeAttemptWidgetDocument, options);
      }
export function useCourseLessonPracticeAttemptWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>(CourseLessonPracticeAttemptWidgetDocument, options);
        }
export function useCourseLessonPracticeAttemptWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>(CourseLessonPracticeAttemptWidgetDocument, options);
        }
export type CourseLessonPracticeAttemptWidgetQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptWidgetQuery>;
export type CourseLessonPracticeAttemptWidgetLazyQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptWidgetLazyQuery>;
export type CourseLessonPracticeAttemptWidgetSuspenseQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptWidgetSuspenseQuery>;
export type CourseLessonPracticeAttemptWidgetQueryResult = Apollo.QueryResult<CourseLessonPracticeAttemptWidgetQuery, CourseLessonPracticeAttemptWidgetQueryVariables>;
export const GetDbConfigByKeyDocument = gql`
    query GetDbConfigByKey($key: DbConfigKey!, $version: String!) {
  configGetOneByKey(key: $key, version: $version)
}
    `;
export type GetDbConfigByKeyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>, 'query'> & ({ variables: GetDbConfigByKeyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDbConfigByKeyQuery = (props: GetDbConfigByKeyQueryProps) => (
      <ApolloReactComponents.Query<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables> query={GetDbConfigByKeyDocument} {...props} />
    );


/**
 * __useGetDbConfigByKeyQuery__
 *
 * To run a query within a React component, call `useGetDbConfigByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDbConfigByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDbConfigByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetDbConfigByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables> & ({ variables: GetDbConfigByKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>(GetDbConfigByKeyDocument, options);
      }
export function useGetDbConfigByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>(GetDbConfigByKeyDocument, options);
        }
export function useGetDbConfigByKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>(GetDbConfigByKeyDocument, options);
        }
export type GetDbConfigByKeyQueryHookResult = ReturnType<typeof useGetDbConfigByKeyQuery>;
export type GetDbConfigByKeyLazyQueryHookResult = ReturnType<typeof useGetDbConfigByKeyLazyQuery>;
export type GetDbConfigByKeySuspenseQueryHookResult = ReturnType<typeof useGetDbConfigByKeySuspenseQuery>;
export type GetDbConfigByKeyQueryResult = Apollo.QueryResult<GetDbConfigByKeyQuery, GetDbConfigByKeyQueryVariables>;
export const ConfigGetServerTimeDocument = gql`
    query ConfigGetServerTime {
  configGetServerTime
}
    `;
export type ConfigGetServerTimeQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>, 'query'>;

    export const ConfigGetServerTimeQuery = (props: ConfigGetServerTimeQueryProps) => (
      <ApolloReactComponents.Query<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables> query={ConfigGetServerTimeDocument} {...props} />
    );


/**
 * __useConfigGetServerTimeQuery__
 *
 * To run a query within a React component, call `useConfigGetServerTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigGetServerTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigGetServerTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigGetServerTimeQuery(baseOptions?: Apollo.QueryHookOptions<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>(ConfigGetServerTimeDocument, options);
      }
export function useConfigGetServerTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>(ConfigGetServerTimeDocument, options);
        }
export function useConfigGetServerTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>(ConfigGetServerTimeDocument, options);
        }
export type ConfigGetServerTimeQueryHookResult = ReturnType<typeof useConfigGetServerTimeQuery>;
export type ConfigGetServerTimeLazyQueryHookResult = ReturnType<typeof useConfigGetServerTimeLazyQuery>;
export type ConfigGetServerTimeSuspenseQueryHookResult = ReturnType<typeof useConfigGetServerTimeSuspenseQuery>;
export type ConfigGetServerTimeQueryResult = Apollo.QueryResult<ConfigGetServerTimeQuery, ConfigGetServerTimeQueryVariables>;
export const UpdateSessionMetaDocument = gql`
    mutation UpdateSessionMeta($sessionMeta: UpdateMetaSessionInput!) {
  sessionUpdateMeta(sessionMeta: $sessionMeta)
}
    `;
export type UpdateSessionMetaMutationFn = Apollo.MutationFunction<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables>;
export type UpdateSessionMetaQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables>, 'mutation'>;

    export const UpdateSessionMetaQuery = (props: UpdateSessionMetaQueryProps) => (
      <ApolloReactComponents.Mutation<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables> mutation={UpdateSessionMetaDocument} {...props} />
    );


/**
 * __useUpdateSessionMetaMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMetaMutation, { data, loading, error }] = useUpdateSessionMetaMutation({
 *   variables: {
 *      sessionMeta: // value for 'sessionMeta'
 *   },
 * });
 */
export function useUpdateSessionMetaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables>(UpdateSessionMetaDocument, options);
      }
export type UpdateSessionMetaMutationHookResult = ReturnType<typeof useUpdateSessionMetaMutation>;
export type UpdateSessionMetaMutationResult = Apollo.MutationResult<UpdateSessionMetaMutation>;
export type UpdateSessionMetaMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMetaMutation, UpdateSessionMetaMutationVariables>;
export const ContentElementInteractDocument = gql`
    mutation ContentElementInteract($contentElementUuid: String!, $interaction: UpsertInteractionElementContentInput!) {
  contentElementInteractionUpsert(
    contentElementUuid: $contentElementUuid
    interaction: $interaction
  ) {
    ...ContentElementMyInteractionFragment
    contentElement {
      id
    }
  }
}
    ${ContentElementMyInteractionFragmentFragmentDoc}`;
export type ContentElementInteractMutationFn = Apollo.MutationFunction<ContentElementInteractMutation, ContentElementInteractMutationVariables>;
export type ContentElementInteractQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ContentElementInteractMutation, ContentElementInteractMutationVariables>, 'mutation'>;

    export const ContentElementInteractQuery = (props: ContentElementInteractQueryProps) => (
      <ApolloReactComponents.Mutation<ContentElementInteractMutation, ContentElementInteractMutationVariables> mutation={ContentElementInteractDocument} {...props} />
    );


/**
 * __useContentElementInteractMutation__
 *
 * To run a mutation, you first call `useContentElementInteractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentElementInteractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentElementInteractMutation, { data, loading, error }] = useContentElementInteractMutation({
 *   variables: {
 *      contentElementUuid: // value for 'contentElementUuid'
 *      interaction: // value for 'interaction'
 *   },
 * });
 */
export function useContentElementInteractMutation(baseOptions?: Apollo.MutationHookOptions<ContentElementInteractMutation, ContentElementInteractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentElementInteractMutation, ContentElementInteractMutationVariables>(ContentElementInteractDocument, options);
      }
export type ContentElementInteractMutationHookResult = ReturnType<typeof useContentElementInteractMutation>;
export type ContentElementInteractMutationResult = Apollo.MutationResult<ContentElementInteractMutation>;
export type ContentElementInteractMutationOptions = Apollo.BaseMutationOptions<ContentElementInteractMutation, ContentElementInteractMutationVariables>;
export const GetAvailableCountryCodesDocument = gql`
    query GetAvailableCountryCodes {
  smsProviderGetAvailableCountryCodes
}
    `;
export type GetAvailableCountryCodesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>, 'query'>;

    export const GetAvailableCountryCodesQuery = (props: GetAvailableCountryCodesQueryProps) => (
      <ApolloReactComponents.Query<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables> query={GetAvailableCountryCodesDocument} {...props} />
    );


/**
 * __useGetAvailableCountryCodesQuery__
 *
 * To run a query within a React component, call `useGetAvailableCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCountryCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableCountryCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>(GetAvailableCountryCodesDocument, options);
      }
export function useGetAvailableCountryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>(GetAvailableCountryCodesDocument, options);
        }
export function useGetAvailableCountryCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>(GetAvailableCountryCodesDocument, options);
        }
export type GetAvailableCountryCodesQueryHookResult = ReturnType<typeof useGetAvailableCountryCodesQuery>;
export type GetAvailableCountryCodesLazyQueryHookResult = ReturnType<typeof useGetAvailableCountryCodesLazyQuery>;
export type GetAvailableCountryCodesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableCountryCodesSuspenseQuery>;
export type GetAvailableCountryCodesQueryResult = Apollo.QueryResult<GetAvailableCountryCodesQuery, GetAvailableCountryCodesQueryVariables>;
export const CompanyGetApiVersionDocument = gql`
    query CompanyGetApiVersion {
  companyGetApiVersion
}
    `;
export type CompanyGetApiVersionQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>, 'query'>;

    export const CompanyGetApiVersionQuery = (props: CompanyGetApiVersionQueryProps) => (
      <ApolloReactComponents.Query<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables> query={CompanyGetApiVersionDocument} {...props} />
    );


/**
 * __useCompanyGetApiVersionQuery__
 *
 * To run a query within a React component, call `useCompanyGetApiVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGetApiVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGetApiVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyGetApiVersionQuery(baseOptions?: Apollo.QueryHookOptions<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>(CompanyGetApiVersionDocument, options);
      }
export function useCompanyGetApiVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>(CompanyGetApiVersionDocument, options);
        }
export function useCompanyGetApiVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>(CompanyGetApiVersionDocument, options);
        }
export type CompanyGetApiVersionQueryHookResult = ReturnType<typeof useCompanyGetApiVersionQuery>;
export type CompanyGetApiVersionLazyQueryHookResult = ReturnType<typeof useCompanyGetApiVersionLazyQuery>;
export type CompanyGetApiVersionSuspenseQueryHookResult = ReturnType<typeof useCompanyGetApiVersionSuspenseQuery>;
export type CompanyGetApiVersionQueryResult = Apollo.QueryResult<CompanyGetApiVersionQuery, CompanyGetApiVersionQueryVariables>;
export const SupportFaqFindManyDocument = gql`
    query SupportFaqFindMany($list: ListInput!, $filter: FilterFaqSupportInput!, $sort: SortFaqSupportInput) {
  supportFaqFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      id
      article {
        id
        title
        blocks {
          ...ContentElementFragment
        }
      }
    }
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type SupportFaqFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>, 'query'> & ({ variables: SupportFaqFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SupportFaqFindManyQuery = (props: SupportFaqFindManyQueryProps) => (
      <ApolloReactComponents.Query<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables> query={SupportFaqFindManyDocument} {...props} />
    );


/**
 * __useSupportFaqFindManyQuery__
 *
 * To run a query within a React component, call `useSupportFaqFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportFaqFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportFaqFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSupportFaqFindManyQuery(baseOptions: Apollo.QueryHookOptions<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables> & ({ variables: SupportFaqFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>(SupportFaqFindManyDocument, options);
      }
export function useSupportFaqFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>(SupportFaqFindManyDocument, options);
        }
export function useSupportFaqFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>(SupportFaqFindManyDocument, options);
        }
export type SupportFaqFindManyQueryHookResult = ReturnType<typeof useSupportFaqFindManyQuery>;
export type SupportFaqFindManyLazyQueryHookResult = ReturnType<typeof useSupportFaqFindManyLazyQuery>;
export type SupportFaqFindManySuspenseQueryHookResult = ReturnType<typeof useSupportFaqFindManySuspenseQuery>;
export type SupportFaqFindManyQueryResult = Apollo.QueryResult<SupportFaqFindManyQuery, SupportFaqFindManyQueryVariables>;
export const SupportFaqFindManyDistinctByCategoryDocument = gql`
    query SupportFaqFindManyDistinctByCategory($filter: FilterFaqSupportInput!) {
  supportFaqFindManyDistinctByCategory(filter: $filter) {
    id
    vkIcon
    category
  }
}
    `;
export type SupportFaqFindManyDistinctByCategoryQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>, 'query'> & ({ variables: SupportFaqFindManyDistinctByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SupportFaqFindManyDistinctByCategoryQuery = (props: SupportFaqFindManyDistinctByCategoryQueryProps) => (
      <ApolloReactComponents.Query<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables> query={SupportFaqFindManyDistinctByCategoryDocument} {...props} />
    );


/**
 * __useSupportFaqFindManyDistinctByCategoryQuery__
 *
 * To run a query within a React component, call `useSupportFaqFindManyDistinctByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportFaqFindManyDistinctByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportFaqFindManyDistinctByCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSupportFaqFindManyDistinctByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables> & ({ variables: SupportFaqFindManyDistinctByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>(SupportFaqFindManyDistinctByCategoryDocument, options);
      }
export function useSupportFaqFindManyDistinctByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>(SupportFaqFindManyDistinctByCategoryDocument, options);
        }
export function useSupportFaqFindManyDistinctByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>(SupportFaqFindManyDistinctByCategoryDocument, options);
        }
export type SupportFaqFindManyDistinctByCategoryQueryHookResult = ReturnType<typeof useSupportFaqFindManyDistinctByCategoryQuery>;
export type SupportFaqFindManyDistinctByCategoryLazyQueryHookResult = ReturnType<typeof useSupportFaqFindManyDistinctByCategoryLazyQuery>;
export type SupportFaqFindManyDistinctByCategorySuspenseQueryHookResult = ReturnType<typeof useSupportFaqFindManyDistinctByCategorySuspenseQuery>;
export type SupportFaqFindManyDistinctByCategoryQueryResult = Apollo.QueryResult<SupportFaqFindManyDistinctByCategoryQuery, SupportFaqFindManyDistinctByCategoryQueryVariables>;
export const RequestDeletionDocument = gql`
    mutation RequestDeletion($form: RequestUserDeletionInput!) {
  userRequestDeletion(form: $form)
}
    `;
export type RequestDeletionMutationFn = Apollo.MutationFunction<RequestDeletionMutation, RequestDeletionMutationVariables>;
export type RequestDeletionQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestDeletionMutation, RequestDeletionMutationVariables>, 'mutation'>;

    export const RequestDeletionQuery = (props: RequestDeletionQueryProps) => (
      <ApolloReactComponents.Mutation<RequestDeletionMutation, RequestDeletionMutationVariables> mutation={RequestDeletionDocument} {...props} />
    );


/**
 * __useRequestDeletionMutation__
 *
 * To run a mutation, you first call `useRequestDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDeletionMutation, { data, loading, error }] = useRequestDeletionMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useRequestDeletionMutation(baseOptions?: Apollo.MutationHookOptions<RequestDeletionMutation, RequestDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDeletionMutation, RequestDeletionMutationVariables>(RequestDeletionDocument, options);
      }
export type RequestDeletionMutationHookResult = ReturnType<typeof useRequestDeletionMutation>;
export type RequestDeletionMutationResult = Apollo.MutationResult<RequestDeletionMutation>;
export type RequestDeletionMutationOptions = Apollo.BaseMutationOptions<RequestDeletionMutation, RequestDeletionMutationVariables>;
export const ContentCategoryFindManyDocument = gql`
    query ContentCategoryFindMany($list: ListInput!, $filter: FilterCategoryContentInput!, $sort: BaseSortInput) {
  contentCategoryFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    page
    pages
    items {
      ...ContentCategoryFragment
    }
  }
}
    ${ContentCategoryFragmentFragmentDoc}`;
export type ContentCategoryFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>, 'query'> & ({ variables: ContentCategoryFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ContentCategoryFindManyQuery = (props: ContentCategoryFindManyQueryProps) => (
      <ApolloReactComponents.Query<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables> query={ContentCategoryFindManyDocument} {...props} />
    );


/**
 * __useContentCategoryFindManyQuery__
 *
 * To run a query within a React component, call `useContentCategoryFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentCategoryFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentCategoryFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContentCategoryFindManyQuery(baseOptions: Apollo.QueryHookOptions<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables> & ({ variables: ContentCategoryFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>(ContentCategoryFindManyDocument, options);
      }
export function useContentCategoryFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>(ContentCategoryFindManyDocument, options);
        }
export function useContentCategoryFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>(ContentCategoryFindManyDocument, options);
        }
export type ContentCategoryFindManyQueryHookResult = ReturnType<typeof useContentCategoryFindManyQuery>;
export type ContentCategoryFindManyLazyQueryHookResult = ReturnType<typeof useContentCategoryFindManyLazyQuery>;
export type ContentCategoryFindManySuspenseQueryHookResult = ReturnType<typeof useContentCategoryFindManySuspenseQuery>;
export type ContentCategoryFindManyQueryResult = Apollo.QueryResult<ContentCategoryFindManyQuery, ContentCategoryFindManyQueryVariables>;
export const CourseFindOneDocument = gql`
    query CourseFindOne($courseId: Int, $alias: String) {
  courseFindOne(courseId: $courseId, alias: $alias) {
    isParticipant
    product {
      id
      isFree
      isOnSale
      currency
      feedbackRating
      approves
      currentSaleLaunch {
        ...LaunchFragment
      }
      seller {
        id
        verified
        organization {
          ...SellerOrganizationFragment
        }
      }
      participantsCount
      prices {
        id
        title
        description
        icon
        tags
        actualFrom
        actualTo
        previousAmount
        amount
        accessDays
        actualAccessDays
        launchPeriodMode
        ...ProductPriceExchangeFragment
      }
      myAccess {
        id
        isActive
        expireAt
      }
    }
    currentLesson {
      id
      isDemo
      accessType
      myProgressStatus
      practice {
        attempts {
          ...LessonPracticeAttemptFragment
        }
      }
      parent {
        ...CourseLessonParentFragment
      }
      publishedOrder {
        order
        parentOrder
      }
      next {
        ...LessonListItemFragment
      }
      previous {
        id
        isDemo
        accessType
        withContent
        withPractice
        canStartNextLesson
      }
      ...LessonListItemFragment
    }
    lessons {
      id
      name
      order
      isDemo
      accessType
      myProgressStatus
      description
      previewImage
      withContent
      withPractice
      blocksInfo {
        ...CourseLessonBlocksInfoFragment
      }
      parent {
        ...CourseLessonParentFragment
      }
      wrapper {
        small
        maximum
      }
      publishedOrder {
        order
        parentOrder
      }
      next {
        ...LessonListItemFragment
      }
      previous {
        id
        isDemo
        accessType
        withContent
        withPractice
        canStartNextLesson
      }
    }
    ...CourseFragment
  }
}
    ${LaunchFragmentFragmentDoc}
${SellerOrganizationFragmentFragmentDoc}
${ProductPriceExchangeFragmentFragmentDoc}
${LessonPracticeAttemptFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}
${LessonListItemFragmentFragmentDoc}
${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseFragmentFragmentDoc}`;
export type CourseFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindOneQuery, CourseFindOneQueryVariables>, 'query'>;

    export const CourseFindOneQuery = (props: CourseFindOneQueryProps) => (
      <ApolloReactComponents.Query<CourseFindOneQuery, CourseFindOneQueryVariables> query={CourseFindOneDocument} {...props} />
    );


/**
 * __useCourseFindOneQuery__
 *
 * To run a query within a React component, call `useCourseFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindOneQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useCourseFindOneQuery(baseOptions?: Apollo.QueryHookOptions<CourseFindOneQuery, CourseFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindOneQuery, CourseFindOneQueryVariables>(CourseFindOneDocument, options);
      }
export function useCourseFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindOneQuery, CourseFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindOneQuery, CourseFindOneQueryVariables>(CourseFindOneDocument, options);
        }
export function useCourseFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindOneQuery, CourseFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindOneQuery, CourseFindOneQueryVariables>(CourseFindOneDocument, options);
        }
export type CourseFindOneQueryHookResult = ReturnType<typeof useCourseFindOneQuery>;
export type CourseFindOneLazyQueryHookResult = ReturnType<typeof useCourseFindOneLazyQuery>;
export type CourseFindOneSuspenseQueryHookResult = ReturnType<typeof useCourseFindOneSuspenseQuery>;
export type CourseFindOneQueryResult = Apollo.QueryResult<CourseFindOneQuery, CourseFindOneQueryVariables>;
export const ProductFindManyFeedbacksDocument = gql`
    query ProductFindManyFeedbacks($list: ListInput!, $filter: FilterFeedbackProductInput!, $sort: BaseSortInput) {
  productFeedbackFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      ...FeedbackFragment
    }
  }
}
    ${FeedbackFragmentFragmentDoc}`;
export type ProductFindManyFeedbacksQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>, 'query'> & ({ variables: ProductFindManyFeedbacksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFindManyFeedbacksQuery = (props: ProductFindManyFeedbacksQueryProps) => (
      <ApolloReactComponents.Query<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables> query={ProductFindManyFeedbacksDocument} {...props} />
    );


/**
 * __useProductFindManyFeedbacksQuery__
 *
 * To run a query within a React component, call `useProductFindManyFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFindManyFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFindManyFeedbacksQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductFindManyFeedbacksQuery(baseOptions: Apollo.QueryHookOptions<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables> & ({ variables: ProductFindManyFeedbacksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>(ProductFindManyFeedbacksDocument, options);
      }
export function useProductFindManyFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>(ProductFindManyFeedbacksDocument, options);
        }
export function useProductFindManyFeedbacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>(ProductFindManyFeedbacksDocument, options);
        }
export type ProductFindManyFeedbacksQueryHookResult = ReturnType<typeof useProductFindManyFeedbacksQuery>;
export type ProductFindManyFeedbacksLazyQueryHookResult = ReturnType<typeof useProductFindManyFeedbacksLazyQuery>;
export type ProductFindManyFeedbacksSuspenseQueryHookResult = ReturnType<typeof useProductFindManyFeedbacksSuspenseQuery>;
export type ProductFindManyFeedbacksQueryResult = Apollo.QueryResult<ProductFindManyFeedbacksQuery, ProductFindManyFeedbacksQueryVariables>;
export const ProductFeedbackFindOneByUserAndProductDocument = gql`
    query ProductFeedbackFindOneByUserAndProduct($productId: Int!) {
  productFeedbackFindOneByUserAndProduct(productId: $productId) {
    ...FeedbackFragment
  }
  productFeedbackCanSend(productId: $productId)
}
    ${FeedbackFragmentFragmentDoc}`;
export type ProductFeedbackFindOneByUserAndProductQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>, 'query'> & ({ variables: ProductFeedbackFindOneByUserAndProductQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFeedbackFindOneByUserAndProductQuery = (props: ProductFeedbackFindOneByUserAndProductQueryProps) => (
      <ApolloReactComponents.Query<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables> query={ProductFeedbackFindOneByUserAndProductDocument} {...props} />
    );


/**
 * __useProductFeedbackFindOneByUserAndProductQuery__
 *
 * To run a query within a React component, call `useProductFeedbackFindOneByUserAndProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFeedbackFindOneByUserAndProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFeedbackFindOneByUserAndProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductFeedbackFindOneByUserAndProductQuery(baseOptions: Apollo.QueryHookOptions<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables> & ({ variables: ProductFeedbackFindOneByUserAndProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>(ProductFeedbackFindOneByUserAndProductDocument, options);
      }
export function useProductFeedbackFindOneByUserAndProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>(ProductFeedbackFindOneByUserAndProductDocument, options);
        }
export function useProductFeedbackFindOneByUserAndProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>(ProductFeedbackFindOneByUserAndProductDocument, options);
        }
export type ProductFeedbackFindOneByUserAndProductQueryHookResult = ReturnType<typeof useProductFeedbackFindOneByUserAndProductQuery>;
export type ProductFeedbackFindOneByUserAndProductLazyQueryHookResult = ReturnType<typeof useProductFeedbackFindOneByUserAndProductLazyQuery>;
export type ProductFeedbackFindOneByUserAndProductSuspenseQueryHookResult = ReturnType<typeof useProductFeedbackFindOneByUserAndProductSuspenseQuery>;
export type ProductFeedbackFindOneByUserAndProductQueryResult = Apollo.QueryResult<ProductFeedbackFindOneByUserAndProductQuery, ProductFeedbackFindOneByUserAndProductQueryVariables>;
export const ProductFeedbackUpsertDocument = gql`
    mutation ProductFeedbackUpsert($productId: Int!, $feedback: CreateFeedbackProductInput!) {
  productFeedbackUpsert(productId: $productId, feedback: $feedback) {
    ...FeedbackFragment
  }
}
    ${FeedbackFragmentFragmentDoc}`;
export type ProductFeedbackUpsertMutationFn = Apollo.MutationFunction<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables>;
export type ProductFeedbackUpsertQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables>, 'mutation'>;

    export const ProductFeedbackUpsertQuery = (props: ProductFeedbackUpsertQueryProps) => (
      <ApolloReactComponents.Mutation<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables> mutation={ProductFeedbackUpsertDocument} {...props} />
    );


/**
 * __useProductFeedbackUpsertMutation__
 *
 * To run a mutation, you first call `useProductFeedbackUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductFeedbackUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productFeedbackUpsertMutation, { data, loading, error }] = useProductFeedbackUpsertMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useProductFeedbackUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables>(ProductFeedbackUpsertDocument, options);
      }
export type ProductFeedbackUpsertMutationHookResult = ReturnType<typeof useProductFeedbackUpsertMutation>;
export type ProductFeedbackUpsertMutationResult = Apollo.MutationResult<ProductFeedbackUpsertMutation>;
export type ProductFeedbackUpsertMutationOptions = Apollo.BaseMutationOptions<ProductFeedbackUpsertMutation, ProductFeedbackUpsertMutationVariables>;
export const ProductAccessProlongAccessForFreeDocument = gql`
    mutation ProductAccessProlongAccessForFree($launchId: Int!) {
  productAccessProlongAccessForFree(launchId: $launchId) {
    id
    product {
      id
      course {
        id
        currentLesson {
          id
        }
      }
    }
  }
}
    `;
export type ProductAccessProlongAccessForFreeMutationFn = Apollo.MutationFunction<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables>;
export type ProductAccessProlongAccessForFreeQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables>, 'mutation'>;

    export const ProductAccessProlongAccessForFreeQuery = (props: ProductAccessProlongAccessForFreeQueryProps) => (
      <ApolloReactComponents.Mutation<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables> mutation={ProductAccessProlongAccessForFreeDocument} {...props} />
    );


/**
 * __useProductAccessProlongAccessForFreeMutation__
 *
 * To run a mutation, you first call `useProductAccessProlongAccessForFreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductAccessProlongAccessForFreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productAccessProlongAccessForFreeMutation, { data, loading, error }] = useProductAccessProlongAccessForFreeMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useProductAccessProlongAccessForFreeMutation(baseOptions?: Apollo.MutationHookOptions<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables>(ProductAccessProlongAccessForFreeDocument, options);
      }
export type ProductAccessProlongAccessForFreeMutationHookResult = ReturnType<typeof useProductAccessProlongAccessForFreeMutation>;
export type ProductAccessProlongAccessForFreeMutationResult = Apollo.MutationResult<ProductAccessProlongAccessForFreeMutation>;
export type ProductAccessProlongAccessForFreeMutationOptions = Apollo.BaseMutationOptions<ProductAccessProlongAccessForFreeMutation, ProductAccessProlongAccessForFreeMutationVariables>;
export const CourseLessonFindManyDocument = gql`
    query CourseLessonFindMany($courseId: Int!, $list: ListInput!, $filter: FilterLessonCourseInput!, $sort: BaseSortInput) {
  courseLessonFindMany(
    courseId: $courseId
    list: $list
    filter: $filter
    sort: $sort
  ) {
    count
    items {
      id
      name
      order
      isPublished
      isDemo
      accessType
      description
      myProgressStatus
      scheduledPublishAt
      previewImage
      withContent
      withPractice
      blocksInfo {
        ...CourseLessonBlocksInfoFragment
      }
      wrapper {
        small
        maximum
      }
      previous {
        id
        isDemo
        accessType
        withContent
        withPractice
        canStartNextLesson
      }
      next {
        id
      }
    }
  }
  courseFindOne(courseId: $courseId) {
    currentLesson {
      id
      order
    }
    lessons {
      id
      order
      blocksInfo {
        ...CourseLessonBlocksInfoFragment
      }
    }
  }
}
    ${CourseLessonBlocksInfoFragmentFragmentDoc}`;
export type CourseLessonFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>, 'query'> & ({ variables: CourseLessonFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonFindManyQuery = (props: CourseLessonFindManyQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables> query={CourseLessonFindManyDocument} {...props} />
    );


/**
 * __useCourseLessonFindManyQuery__
 *
 * To run a query within a React component, call `useCourseLessonFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonFindManyQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseLessonFindManyQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables> & ({ variables: CourseLessonFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>(CourseLessonFindManyDocument, options);
      }
export function useCourseLessonFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>(CourseLessonFindManyDocument, options);
        }
export function useCourseLessonFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>(CourseLessonFindManyDocument, options);
        }
export type CourseLessonFindManyQueryHookResult = ReturnType<typeof useCourseLessonFindManyQuery>;
export type CourseLessonFindManyLazyQueryHookResult = ReturnType<typeof useCourseLessonFindManyLazyQuery>;
export type CourseLessonFindManySuspenseQueryHookResult = ReturnType<typeof useCourseLessonFindManySuspenseQuery>;
export type CourseLessonFindManyQueryResult = Apollo.QueryResult<CourseLessonFindManyQuery, CourseLessonFindManyQueryVariables>;
export const CourseFindOneLessonsDocument = gql`
    query CourseFindOneLessons($courseId: Int!) {
  courseFindOne(courseId: $courseId) {
    id
    progressType
    isParticipant
    ...CoursePreferenceSettingsFragment
    product {
      id
      isFree
      myAccess {
        id
        isActive
        expireAt
        launch {
          id
          educationStartAt
          educationFinishAt
        }
      }
    }
    currentLesson {
      id
      order
      isDemo
      accessType
      withContent
      withPractice
      myProgressStatus
    }
    lessons {
      id
      name
      order
      isDemo
      accessType
      myProgressStatus
      scheduledPublishAt
      description
      withContent
      withPractice
      blocksInfo {
        ...CourseLessonBlocksInfoFragment
      }
      parent {
        ...CourseLessonParentFragment
      }
      wrapper {
        small
        maximum
      }
      myProgress {
        id
        status
      }
      previous {
        id
        name
        isDemo
        accessType
        withContent
        withPractice
        canStartNextLesson
      }
    }
  }
}
    ${CoursePreferenceSettingsFragmentFragmentDoc}
${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type CourseFindOneLessonsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>, 'query'> & ({ variables: CourseFindOneLessonsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseFindOneLessonsQuery = (props: CourseFindOneLessonsQueryProps) => (
      <ApolloReactComponents.Query<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables> query={CourseFindOneLessonsDocument} {...props} />
    );


/**
 * __useCourseFindOneLessonsQuery__
 *
 * To run a query within a React component, call `useCourseFindOneLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindOneLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindOneLessonsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseFindOneLessonsQuery(baseOptions: Apollo.QueryHookOptions<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables> & ({ variables: CourseFindOneLessonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>(CourseFindOneLessonsDocument, options);
      }
export function useCourseFindOneLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>(CourseFindOneLessonsDocument, options);
        }
export function useCourseFindOneLessonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>(CourseFindOneLessonsDocument, options);
        }
export type CourseFindOneLessonsQueryHookResult = ReturnType<typeof useCourseFindOneLessonsQuery>;
export type CourseFindOneLessonsLazyQueryHookResult = ReturnType<typeof useCourseFindOneLessonsLazyQuery>;
export type CourseFindOneLessonsSuspenseQueryHookResult = ReturnType<typeof useCourseFindOneLessonsSuspenseQuery>;
export type CourseFindOneLessonsQueryResult = Apollo.QueryResult<CourseFindOneLessonsQuery, CourseFindOneLessonsQueryVariables>;
export const CourseLessonFindOneDocument = gql`
    query CourseLessonFindOne($courseId: Int!, $lessonId: Int!) {
  courseFindOne(courseId: $courseId) {
    ...CourseInformationInLessonFragment
    currentLesson {
      id
      order
      isDemo
      accessType
      withContent
      withPractice
      myProgressStatus
      myProgress {
        id
        status
      }
      next {
        id
        name
        isDemo
        accessType
        withContent
        myProgressStatus
      }
      previous {
        id
        name
        isDemo
        accessType
        withContent
        withPractice
        myProgressStatus
        canStartNextLesson
      }
    }
    ...CourseLessonsFragment
  }
  courseLessonFindOne(courseId: $courseId, lessonId: $lessonId) {
    ...LessonStudyFragment
    parent {
      ...CourseLessonParentFragment
    }
  }
}
    ${CourseInformationInLessonFragmentFragmentDoc}
${CourseLessonsFragmentFragmentDoc}
${LessonStudyFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type CourseLessonFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>, 'query'> & ({ variables: CourseLessonFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonFindOneQuery = (props: CourseLessonFindOneQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables> query={CourseLessonFindOneDocument} {...props} />
    );


/**
 * __useCourseLessonFindOneQuery__
 *
 * To run a query within a React component, call `useCourseLessonFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonFindOneQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonFindOneQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables> & ({ variables: CourseLessonFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>(CourseLessonFindOneDocument, options);
      }
export function useCourseLessonFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>(CourseLessonFindOneDocument, options);
        }
export function useCourseLessonFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>(CourseLessonFindOneDocument, options);
        }
export type CourseLessonFindOneQueryHookResult = ReturnType<typeof useCourseLessonFindOneQuery>;
export type CourseLessonFindOneLazyQueryHookResult = ReturnType<typeof useCourseLessonFindOneLazyQuery>;
export type CourseLessonFindOneSuspenseQueryHookResult = ReturnType<typeof useCourseLessonFindOneSuspenseQuery>;
export type CourseLessonFindOneQueryResult = Apollo.QueryResult<CourseLessonFindOneQuery, CourseLessonFindOneQueryVariables>;
export const CourseLessonFindOneDemoDocument = gql`
    query CourseLessonFindOneDemo($courseId: Int!, $lessonId: Int!) {
  courseFindOne(courseId: $courseId) {
    ...CourseInformationInLessonFragment
    ...CourseLessonsFragment
  }
  courseLessonFindOneDemo(lessonId: $lessonId) {
    ...LessonStudyFragment
  }
}
    ${CourseInformationInLessonFragmentFragmentDoc}
${CourseLessonsFragmentFragmentDoc}
${LessonStudyFragmentFragmentDoc}`;
export type CourseLessonFindOneDemoQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>, 'query'> & ({ variables: CourseLessonFindOneDemoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonFindOneDemoQuery = (props: CourseLessonFindOneDemoQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables> query={CourseLessonFindOneDemoDocument} {...props} />
    );


/**
 * __useCourseLessonFindOneDemoQuery__
 *
 * To run a query within a React component, call `useCourseLessonFindOneDemoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonFindOneDemoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonFindOneDemoQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonFindOneDemoQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables> & ({ variables: CourseLessonFindOneDemoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>(CourseLessonFindOneDemoDocument, options);
      }
export function useCourseLessonFindOneDemoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>(CourseLessonFindOneDemoDocument, options);
        }
export function useCourseLessonFindOneDemoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>(CourseLessonFindOneDemoDocument, options);
        }
export type CourseLessonFindOneDemoQueryHookResult = ReturnType<typeof useCourseLessonFindOneDemoQuery>;
export type CourseLessonFindOneDemoLazyQueryHookResult = ReturnType<typeof useCourseLessonFindOneDemoLazyQuery>;
export type CourseLessonFindOneDemoSuspenseQueryHookResult = ReturnType<typeof useCourseLessonFindOneDemoSuspenseQuery>;
export type CourseLessonFindOneDemoQueryResult = Apollo.QueryResult<CourseLessonFindOneDemoQuery, CourseLessonFindOneDemoQueryVariables>;
export const CourseLessonGetProgressStatusDocument = gql`
    query CourseLessonGetProgressStatus($lessonId: Int!) {
  courseLessonGetProgressStatus(lessonId: $lessonId)
}
    `;
export type CourseLessonGetProgressStatusQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>, 'query'> & ({ variables: CourseLessonGetProgressStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonGetProgressStatusQuery = (props: CourseLessonGetProgressStatusQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables> query={CourseLessonGetProgressStatusDocument} {...props} />
    );


/**
 * __useCourseLessonGetProgressStatusQuery__
 *
 * To run a query within a React component, call `useCourseLessonGetProgressStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonGetProgressStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonGetProgressStatusQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonGetProgressStatusQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables> & ({ variables: CourseLessonGetProgressStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>(CourseLessonGetProgressStatusDocument, options);
      }
export function useCourseLessonGetProgressStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>(CourseLessonGetProgressStatusDocument, options);
        }
export function useCourseLessonGetProgressStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>(CourseLessonGetProgressStatusDocument, options);
        }
export type CourseLessonGetProgressStatusQueryHookResult = ReturnType<typeof useCourseLessonGetProgressStatusQuery>;
export type CourseLessonGetProgressStatusLazyQueryHookResult = ReturnType<typeof useCourseLessonGetProgressStatusLazyQuery>;
export type CourseLessonGetProgressStatusSuspenseQueryHookResult = ReturnType<typeof useCourseLessonGetProgressStatusSuspenseQuery>;
export type CourseLessonGetProgressStatusQueryResult = Apollo.QueryResult<CourseLessonGetProgressStatusQuery, CourseLessonGetProgressStatusQueryVariables>;
export const CourseLessonMetaUpsertDocument = gql`
    mutation CourseLessonMetaUpsert($lessonId: Int!, $meta: CreateLessonMetaCourseInput!) {
  courseLessonMetaUpsert(lessonId: $lessonId, meta: $meta) {
    id
    isLiked
    feedback {
      rate
      isSent
      comment
    }
  }
}
    `;
export type CourseLessonMetaUpsertMutationFn = Apollo.MutationFunction<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables>;
export type CourseLessonMetaUpsertQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables>, 'mutation'>;

    export const CourseLessonMetaUpsertQuery = (props: CourseLessonMetaUpsertQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables> mutation={CourseLessonMetaUpsertDocument} {...props} />
    );


/**
 * __useCourseLessonMetaUpsertMutation__
 *
 * To run a mutation, you first call `useCourseLessonMetaUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonMetaUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonMetaUpsertMutation, { data, loading, error }] = useCourseLessonMetaUpsertMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useCourseLessonMetaUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables>(CourseLessonMetaUpsertDocument, options);
      }
export type CourseLessonMetaUpsertMutationHookResult = ReturnType<typeof useCourseLessonMetaUpsertMutation>;
export type CourseLessonMetaUpsertMutationResult = Apollo.MutationResult<CourseLessonMetaUpsertMutation>;
export type CourseLessonMetaUpsertMutationOptions = Apollo.BaseMutationOptions<CourseLessonMetaUpsertMutation, CourseLessonMetaUpsertMutationVariables>;
export const CourseLessonMetaFindOneDocument = gql`
    query CourseLessonMetaFindOne($lessonId: Int!) {
  courseLessonMetaFindOne(lessonId: $lessonId) {
    id
    isLiked
    feedback {
      rate
      isSent
      comment
    }
  }
}
    `;
export type CourseLessonMetaFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>, 'query'> & ({ variables: CourseLessonMetaFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonMetaFindOneQuery = (props: CourseLessonMetaFindOneQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables> query={CourseLessonMetaFindOneDocument} {...props} />
    );


/**
 * __useCourseLessonMetaFindOneQuery__
 *
 * To run a query within a React component, call `useCourseLessonMetaFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonMetaFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonMetaFindOneQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonMetaFindOneQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables> & ({ variables: CourseLessonMetaFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>(CourseLessonMetaFindOneDocument, options);
      }
export function useCourseLessonMetaFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>(CourseLessonMetaFindOneDocument, options);
        }
export function useCourseLessonMetaFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>(CourseLessonMetaFindOneDocument, options);
        }
export type CourseLessonMetaFindOneQueryHookResult = ReturnType<typeof useCourseLessonMetaFindOneQuery>;
export type CourseLessonMetaFindOneLazyQueryHookResult = ReturnType<typeof useCourseLessonMetaFindOneLazyQuery>;
export type CourseLessonMetaFindOneSuspenseQueryHookResult = ReturnType<typeof useCourseLessonMetaFindOneSuspenseQuery>;
export type CourseLessonMetaFindOneQueryResult = Apollo.QueryResult<CourseLessonMetaFindOneQuery, CourseLessonMetaFindOneQueryVariables>;
export const CourseLessonUpsertChatDocument = gql`
    mutation CourseLessonUpsertChat($lessonId: Int!) {
  courseProgressUpsertChat(lessonId: $lessonId) {
    ...ChatFragment
  }
}
    ${ChatFragmentFragmentDoc}`;
export type CourseLessonUpsertChatMutationFn = Apollo.MutationFunction<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables>;
export type CourseLessonUpsertChatQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables>, 'mutation'>;

    export const CourseLessonUpsertChatQuery = (props: CourseLessonUpsertChatQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables> mutation={CourseLessonUpsertChatDocument} {...props} />
    );


/**
 * __useCourseLessonUpsertChatMutation__
 *
 * To run a mutation, you first call `useCourseLessonUpsertChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonUpsertChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonUpsertChatMutation, { data, loading, error }] = useCourseLessonUpsertChatMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonUpsertChatMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables>(CourseLessonUpsertChatDocument, options);
      }
export type CourseLessonUpsertChatMutationHookResult = ReturnType<typeof useCourseLessonUpsertChatMutation>;
export type CourseLessonUpsertChatMutationResult = Apollo.MutationResult<CourseLessonUpsertChatMutation>;
export type CourseLessonUpsertChatMutationOptions = Apollo.BaseMutationOptions<CourseLessonUpsertChatMutation, CourseLessonUpsertChatMutationVariables>;
export const CourseProgressStartNextManualDocument = gql`
    mutation CourseProgressStartNextManual($courseId: Int!, $currentLessonId: Int!) {
  courseProgressStartNextManual(
    courseId: $courseId
    currentLessonId: $currentLessonId
  ) {
    id
    lesson {
      id
      myProgressStatus
      next {
        id
      }
      previous {
        id
      }
    }
  }
}
    `;
export type CourseProgressStartNextManualMutationFn = Apollo.MutationFunction<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables>;
export type CourseProgressStartNextManualQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables>, 'mutation'>;

    export const CourseProgressStartNextManualQuery = (props: CourseProgressStartNextManualQueryProps) => (
      <ApolloReactComponents.Mutation<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables> mutation={CourseProgressStartNextManualDocument} {...props} />
    );


/**
 * __useCourseProgressStartNextManualMutation__
 *
 * To run a mutation, you first call `useCourseProgressStartNextManualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressStartNextManualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseProgressStartNextManualMutation, { data, loading, error }] = useCourseProgressStartNextManualMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      currentLessonId: // value for 'currentLessonId'
 *   },
 * });
 */
export function useCourseProgressStartNextManualMutation(baseOptions?: Apollo.MutationHookOptions<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables>(CourseProgressStartNextManualDocument, options);
      }
export type CourseProgressStartNextManualMutationHookResult = ReturnType<typeof useCourseProgressStartNextManualMutation>;
export type CourseProgressStartNextManualMutationResult = Apollo.MutationResult<CourseProgressStartNextManualMutation>;
export type CourseProgressStartNextManualMutationOptions = Apollo.BaseMutationOptions<CourseProgressStartNextManualMutation, CourseProgressStartNextManualMutationVariables>;
export const CourseProgressUpdateByParticipantDocument = gql`
    mutation CourseProgressUpdateByParticipant($lessonId: Int!, $progress: UpdateParticipantProgressCourseInput!) {
  courseProgressUpdateByParticipant(lessonId: $lessonId, progress: $progress) {
    id
    status
    lesson {
      id
    }
  }
}
    `;
export type CourseProgressUpdateByParticipantMutationFn = Apollo.MutationFunction<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables>;
export type CourseProgressUpdateByParticipantQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables>, 'mutation'>;

    export const CourseProgressUpdateByParticipantQuery = (props: CourseProgressUpdateByParticipantQueryProps) => (
      <ApolloReactComponents.Mutation<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables> mutation={CourseProgressUpdateByParticipantDocument} {...props} />
    );


/**
 * __useCourseProgressUpdateByParticipantMutation__
 *
 * To run a mutation, you first call `useCourseProgressUpdateByParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressUpdateByParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseProgressUpdateByParticipantMutation, { data, loading, error }] = useCourseProgressUpdateByParticipantMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      progress: // value for 'progress'
 *   },
 * });
 */
export function useCourseProgressUpdateByParticipantMutation(baseOptions?: Apollo.MutationHookOptions<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables>(CourseProgressUpdateByParticipantDocument, options);
      }
export type CourseProgressUpdateByParticipantMutationHookResult = ReturnType<typeof useCourseProgressUpdateByParticipantMutation>;
export type CourseProgressUpdateByParticipantMutationResult = Apollo.MutationResult<CourseProgressUpdateByParticipantMutation>;
export type CourseProgressUpdateByParticipantMutationOptions = Apollo.BaseMutationOptions<CourseProgressUpdateByParticipantMutation, CourseProgressUpdateByParticipantMutationVariables>;
export const ProductParticipantUpdateDocument = gql`
    mutation ProductParticipantUpdate($productId: Int!, $participant: UpdateParticipantProductInput!) {
  productParticipantUpdate(productId: $productId, participant: $participant) {
    ...ProductParticipantFragment
  }
}
    ${ProductParticipantFragmentFragmentDoc}`;
export type ProductParticipantUpdateMutationFn = Apollo.MutationFunction<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables>;
export type ProductParticipantUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables>, 'mutation'>;

    export const ProductParticipantUpdateQuery = (props: ProductParticipantUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables> mutation={ProductParticipantUpdateDocument} {...props} />
    );


/**
 * __useProductParticipantUpdateMutation__
 *
 * To run a mutation, you first call `useProductParticipantUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductParticipantUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productParticipantUpdateMutation, { data, loading, error }] = useProductParticipantUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      participant: // value for 'participant'
 *   },
 * });
 */
export function useProductParticipantUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables>(ProductParticipantUpdateDocument, options);
      }
export type ProductParticipantUpdateMutationHookResult = ReturnType<typeof useProductParticipantUpdateMutation>;
export type ProductParticipantUpdateMutationResult = Apollo.MutationResult<ProductParticipantUpdateMutation>;
export type ProductParticipantUpdateMutationOptions = Apollo.BaseMutationOptions<ProductParticipantUpdateMutation, ProductParticipantUpdateMutationVariables>;
export const CourseLessonPracticeAttemptSaveTaskAnswerDocument = gql`
    mutation CourseLessonPracticeAttemptSaveTaskAnswer($courseId: Int!, $practiceId: Int!, $answer: SaveAnswerTaskInput!) {
  courseLessonPracticeAttemptSaveTaskAnswer(
    courseId: $courseId
    practiceId: $practiceId
    answer: $answer
  ) {
    ...LessonPracticeAttemptFragment
  }
}
    ${LessonPracticeAttemptFragmentFragmentDoc}`;
export type CourseLessonPracticeAttemptSaveTaskAnswerMutationFn = Apollo.MutationFunction<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables>;
export type CourseLessonPracticeAttemptSaveTaskAnswerQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeAttemptSaveTaskAnswerQuery = (props: CourseLessonPracticeAttemptSaveTaskAnswerQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables> mutation={CourseLessonPracticeAttemptSaveTaskAnswerDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeAttemptSaveTaskAnswerMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeAttemptSaveTaskAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeAttemptSaveTaskAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeAttemptSaveTaskAnswerMutation, { data, loading, error }] = useCourseLessonPracticeAttemptSaveTaskAnswerMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      practiceId: // value for 'practiceId'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useCourseLessonPracticeAttemptSaveTaskAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables>(CourseLessonPracticeAttemptSaveTaskAnswerDocument, options);
      }
export type CourseLessonPracticeAttemptSaveTaskAnswerMutationHookResult = ReturnType<typeof useCourseLessonPracticeAttemptSaveTaskAnswerMutation>;
export type CourseLessonPracticeAttemptSaveTaskAnswerMutationResult = Apollo.MutationResult<CourseLessonPracticeAttemptSaveTaskAnswerMutation>;
export type CourseLessonPracticeAttemptSaveTaskAnswerMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeAttemptSaveTaskAnswerMutation, CourseLessonPracticeAttemptSaveTaskAnswerMutationVariables>;
export const CourseLessonPracticeAttemptFinishAttemptDocument = gql`
    mutation CourseLessonPracticeAttemptFinishAttempt($courseId: Int!, $practiceId: Int!) {
  courseLessonPracticeAttemptFinishAttempt(
    courseId: $courseId
    practiceId: $practiceId
  ) {
    ...LessonPracticeAttemptFragment
  }
}
    ${LessonPracticeAttemptFragmentFragmentDoc}`;
export type CourseLessonPracticeAttemptFinishAttemptMutationFn = Apollo.MutationFunction<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables>;
export type CourseLessonPracticeAttemptFinishAttemptQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeAttemptFinishAttemptQuery = (props: CourseLessonPracticeAttemptFinishAttemptQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables> mutation={CourseLessonPracticeAttemptFinishAttemptDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeAttemptFinishAttemptMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeAttemptFinishAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeAttemptFinishAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeAttemptFinishAttemptMutation, { data, loading, error }] = useCourseLessonPracticeAttemptFinishAttemptMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      practiceId: // value for 'practiceId'
 *   },
 * });
 */
export function useCourseLessonPracticeAttemptFinishAttemptMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables>(CourseLessonPracticeAttemptFinishAttemptDocument, options);
      }
export type CourseLessonPracticeAttemptFinishAttemptMutationHookResult = ReturnType<typeof useCourseLessonPracticeAttemptFinishAttemptMutation>;
export type CourseLessonPracticeAttemptFinishAttemptMutationResult = Apollo.MutationResult<CourseLessonPracticeAttemptFinishAttemptMutation>;
export type CourseLessonPracticeAttemptFinishAttemptMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeAttemptFinishAttemptMutation, CourseLessonPracticeAttemptFinishAttemptMutationVariables>;
export const CartUpsertDocument = gql`
    mutation CartUpsert($cart: CreateCartInput!, $merge: Boolean) {
  cartUpsert(cart: $cart, merge: $merge) {
    id
    uuid
    promoCodes
    products {
      priceId
      productId
    }
  }
}
    `;
export type CartUpsertMutationFn = Apollo.MutationFunction<CartUpsertMutation, CartUpsertMutationVariables>;
export type CartUpsertQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CartUpsertMutation, CartUpsertMutationVariables>, 'mutation'>;

    export const CartUpsertQuery = (props: CartUpsertQueryProps) => (
      <ApolloReactComponents.Mutation<CartUpsertMutation, CartUpsertMutationVariables> mutation={CartUpsertDocument} {...props} />
    );


/**
 * __useCartUpsertMutation__
 *
 * To run a mutation, you first call `useCartUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpsertMutation, { data, loading, error }] = useCartUpsertMutation({
 *   variables: {
 *      cart: // value for 'cart'
 *      merge: // value for 'merge'
 *   },
 * });
 */
export function useCartUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CartUpsertMutation, CartUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartUpsertMutation, CartUpsertMutationVariables>(CartUpsertDocument, options);
      }
export type CartUpsertMutationHookResult = ReturnType<typeof useCartUpsertMutation>;
export type CartUpsertMutationResult = Apollo.MutationResult<CartUpsertMutation>;
export type CartUpsertMutationOptions = Apollo.BaseMutationOptions<CartUpsertMutation, CartUpsertMutationVariables>;
export const CoursesFindManyDocument = gql`
    query CoursesFindMany($list: ListInput!, $filter: FilterCourseInput!, $sort: SortCourseInput) {
  courseFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...CourseFragment
    }
  }
}
    ${CourseFragmentFragmentDoc}`;
export type CoursesFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CoursesFindManyQuery, CoursesFindManyQueryVariables>, 'query'> & ({ variables: CoursesFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CoursesFindManyQuery = (props: CoursesFindManyQueryProps) => (
      <ApolloReactComponents.Query<CoursesFindManyQuery, CoursesFindManyQueryVariables> query={CoursesFindManyDocument} {...props} />
    );


/**
 * __useCoursesFindManyQuery__
 *
 * To run a query within a React component, call `useCoursesFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCoursesFindManyQuery(baseOptions: Apollo.QueryHookOptions<CoursesFindManyQuery, CoursesFindManyQueryVariables> & ({ variables: CoursesFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesFindManyQuery, CoursesFindManyQueryVariables>(CoursesFindManyDocument, options);
      }
export function useCoursesFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesFindManyQuery, CoursesFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesFindManyQuery, CoursesFindManyQueryVariables>(CoursesFindManyDocument, options);
        }
export function useCoursesFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CoursesFindManyQuery, CoursesFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesFindManyQuery, CoursesFindManyQueryVariables>(CoursesFindManyDocument, options);
        }
export type CoursesFindManyQueryHookResult = ReturnType<typeof useCoursesFindManyQuery>;
export type CoursesFindManyLazyQueryHookResult = ReturnType<typeof useCoursesFindManyLazyQuery>;
export type CoursesFindManySuspenseQueryHookResult = ReturnType<typeof useCoursesFindManySuspenseQuery>;
export type CoursesFindManyQueryResult = Apollo.QueryResult<CoursesFindManyQuery, CoursesFindManyQueryVariables>;
export const EgeSubjectAuthDocument = gql`
    query EgeSubjectAuth($subject: EducationSubject!) {
  subjectFindOne(subject: $subject) {
    ...EgeSubjectFragment
  }
  educationPreferenceGetExamsReminderState
  educationPreferenceGetUserSubjects {
    id
    subject
  }
  taskGetSubjectCategoryStatistic(subject: $subject) {
    subjectCategoryId
    subjectCategoryName
    totalSolvedCount
    correctSolvedCount
    totalTaskCount
  }
}
    ${EgeSubjectFragmentFragmentDoc}`;
export type EgeSubjectAuthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>, 'query'> & ({ variables: EgeSubjectAuthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeSubjectAuthQuery = (props: EgeSubjectAuthQueryProps) => (
      <ApolloReactComponents.Query<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables> query={EgeSubjectAuthDocument} {...props} />
    );


/**
 * __useEgeSubjectAuthQuery__
 *
 * To run a query within a React component, call `useEgeSubjectAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeSubjectAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeSubjectAuthQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEgeSubjectAuthQuery(baseOptions: Apollo.QueryHookOptions<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables> & ({ variables: EgeSubjectAuthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>(EgeSubjectAuthDocument, options);
      }
export function useEgeSubjectAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>(EgeSubjectAuthDocument, options);
        }
export function useEgeSubjectAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>(EgeSubjectAuthDocument, options);
        }
export type EgeSubjectAuthQueryHookResult = ReturnType<typeof useEgeSubjectAuthQuery>;
export type EgeSubjectAuthLazyQueryHookResult = ReturnType<typeof useEgeSubjectAuthLazyQuery>;
export type EgeSubjectAuthSuspenseQueryHookResult = ReturnType<typeof useEgeSubjectAuthSuspenseQuery>;
export type EgeSubjectAuthQueryResult = Apollo.QueryResult<EgeSubjectAuthQuery, EgeSubjectAuthQueryVariables>;
export const EgeSubjectUnauthDocument = gql`
    query EgeSubjectUnauth($subject: EducationSubject!) {
  subjectFindOne(subject: $subject) {
    ...EgeSubjectFragment
  }
}
    ${EgeSubjectFragmentFragmentDoc}`;
export type EgeSubjectUnauthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>, 'query'> & ({ variables: EgeSubjectUnauthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeSubjectUnauthQuery = (props: EgeSubjectUnauthQueryProps) => (
      <ApolloReactComponents.Query<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables> query={EgeSubjectUnauthDocument} {...props} />
    );


/**
 * __useEgeSubjectUnauthQuery__
 *
 * To run a query within a React component, call `useEgeSubjectUnauthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeSubjectUnauthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeSubjectUnauthQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEgeSubjectUnauthQuery(baseOptions: Apollo.QueryHookOptions<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables> & ({ variables: EgeSubjectUnauthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>(EgeSubjectUnauthDocument, options);
      }
export function useEgeSubjectUnauthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>(EgeSubjectUnauthDocument, options);
        }
export function useEgeSubjectUnauthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>(EgeSubjectUnauthDocument, options);
        }
export type EgeSubjectUnauthQueryHookResult = ReturnType<typeof useEgeSubjectUnauthQuery>;
export type EgeSubjectUnauthLazyQueryHookResult = ReturnType<typeof useEgeSubjectUnauthLazyQuery>;
export type EgeSubjectUnauthSuspenseQueryHookResult = ReturnType<typeof useEgeSubjectUnauthSuspenseQuery>;
export type EgeSubjectUnauthQueryResult = Apollo.QueryResult<EgeSubjectUnauthQuery, EgeSubjectUnauthQueryVariables>;
export const EgeSubjectDatesDocument = gql`
    query EgeSubjectDates($subject: EducationSubject!) {
  subjectFindOne(subject: $subject) {
    id
    activeForTournament
    subject
    egeSubjectInfo {
      dates {
        early
        main
        reserve
      }
    }
  }
}
    `;
export type EgeSubjectDatesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>, 'query'> & ({ variables: EgeSubjectDatesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeSubjectDatesQuery = (props: EgeSubjectDatesQueryProps) => (
      <ApolloReactComponents.Query<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables> query={EgeSubjectDatesDocument} {...props} />
    );


/**
 * __useEgeSubjectDatesQuery__
 *
 * To run a query within a React component, call `useEgeSubjectDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeSubjectDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeSubjectDatesQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEgeSubjectDatesQuery(baseOptions: Apollo.QueryHookOptions<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables> & ({ variables: EgeSubjectDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>(EgeSubjectDatesDocument, options);
      }
export function useEgeSubjectDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>(EgeSubjectDatesDocument, options);
        }
export function useEgeSubjectDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>(EgeSubjectDatesDocument, options);
        }
export type EgeSubjectDatesQueryHookResult = ReturnType<typeof useEgeSubjectDatesQuery>;
export type EgeSubjectDatesLazyQueryHookResult = ReturnType<typeof useEgeSubjectDatesLazyQuery>;
export type EgeSubjectDatesSuspenseQueryHookResult = ReturnType<typeof useEgeSubjectDatesSuspenseQuery>;
export type EgeSubjectDatesQueryResult = Apollo.QueryResult<EgeSubjectDatesQuery, EgeSubjectDatesQueryVariables>;
export const EgeSubjectExamineesDocument = gql`
    query EgeSubjectExaminees($subject: EducationSubject!) {
  subjectFindManyMembers(
    list: {take: 5}
    filter: {subjects: [$subject]}
    sort: {id: DESC}
  ) {
    count
    items {
      id
      profile {
        id
        fullName
        firstName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type EgeSubjectExamineesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>, 'query'> & ({ variables: EgeSubjectExamineesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeSubjectExamineesQuery = (props: EgeSubjectExamineesQueryProps) => (
      <ApolloReactComponents.Query<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables> query={EgeSubjectExamineesDocument} {...props} />
    );


/**
 * __useEgeSubjectExamineesQuery__
 *
 * To run a query within a React component, call `useEgeSubjectExamineesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeSubjectExamineesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeSubjectExamineesQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEgeSubjectExamineesQuery(baseOptions: Apollo.QueryHookOptions<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables> & ({ variables: EgeSubjectExamineesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>(EgeSubjectExamineesDocument, options);
      }
export function useEgeSubjectExamineesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>(EgeSubjectExamineesDocument, options);
        }
export function useEgeSubjectExamineesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>(EgeSubjectExamineesDocument, options);
        }
export type EgeSubjectExamineesQueryHookResult = ReturnType<typeof useEgeSubjectExamineesQuery>;
export type EgeSubjectExamineesLazyQueryHookResult = ReturnType<typeof useEgeSubjectExamineesLazyQuery>;
export type EgeSubjectExamineesSuspenseQueryHookResult = ReturnType<typeof useEgeSubjectExamineesSuspenseQuery>;
export type EgeSubjectExamineesQueryResult = Apollo.QueryResult<EgeSubjectExamineesQuery, EgeSubjectExamineesQueryVariables>;
export const EgeSetReminderStateDocument = gql`
    mutation EgeSetReminderState($subject: EducationSubject!) {
  educationPreferenceSetExamsReminderState(subject: $subject)
}
    `;
export type EgeSetReminderStateMutationFn = Apollo.MutationFunction<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables>;
export type EgeSetReminderStateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables>, 'mutation'>;

    export const EgeSetReminderStateQuery = (props: EgeSetReminderStateQueryProps) => (
      <ApolloReactComponents.Mutation<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables> mutation={EgeSetReminderStateDocument} {...props} />
    );


/**
 * __useEgeSetReminderStateMutation__
 *
 * To run a mutation, you first call `useEgeSetReminderStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEgeSetReminderStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [egeSetReminderStateMutation, { data, loading, error }] = useEgeSetReminderStateMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEgeSetReminderStateMutation(baseOptions?: Apollo.MutationHookOptions<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables>(EgeSetReminderStateDocument, options);
      }
export type EgeSetReminderStateMutationHookResult = ReturnType<typeof useEgeSetReminderStateMutation>;
export type EgeSetReminderStateMutationResult = Apollo.MutationResult<EgeSetReminderStateMutation>;
export type EgeSetReminderStateMutationOptions = Apollo.BaseMutationOptions<EgeSetReminderStateMutation, EgeSetReminderStateMutationVariables>;
export const EgeTimeoutAuthDocument = gql`
    query EgeTimeoutAuth($list: ListInput!, $filter: FilterSubjectInput!, $sort: BaseSortInput) {
  educationPreferenceGetExamsReminderState
  subjectFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      ...SubjectFragment
      ...EgeTimeoutFragment
    }
  }
}
    ${SubjectFragmentFragmentDoc}
${EgeTimeoutFragmentFragmentDoc}`;
export type EgeTimeoutAuthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>, 'query'> & ({ variables: EgeTimeoutAuthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeTimeoutAuthQuery = (props: EgeTimeoutAuthQueryProps) => (
      <ApolloReactComponents.Query<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables> query={EgeTimeoutAuthDocument} {...props} />
    );


/**
 * __useEgeTimeoutAuthQuery__
 *
 * To run a query within a React component, call `useEgeTimeoutAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeTimeoutAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeTimeoutAuthQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEgeTimeoutAuthQuery(baseOptions: Apollo.QueryHookOptions<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables> & ({ variables: EgeTimeoutAuthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>(EgeTimeoutAuthDocument, options);
      }
export function useEgeTimeoutAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>(EgeTimeoutAuthDocument, options);
        }
export function useEgeTimeoutAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>(EgeTimeoutAuthDocument, options);
        }
export type EgeTimeoutAuthQueryHookResult = ReturnType<typeof useEgeTimeoutAuthQuery>;
export type EgeTimeoutAuthLazyQueryHookResult = ReturnType<typeof useEgeTimeoutAuthLazyQuery>;
export type EgeTimeoutAuthSuspenseQueryHookResult = ReturnType<typeof useEgeTimeoutAuthSuspenseQuery>;
export type EgeTimeoutAuthQueryResult = Apollo.QueryResult<EgeTimeoutAuthQuery, EgeTimeoutAuthQueryVariables>;
export const EgeTimeoutUnauthDocument = gql`
    query EgeTimeoutUnauth($list: ListInput!, $filter: FilterSubjectInput!, $sort: BaseSortInput) {
  subjectFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      ...SubjectFragment
      ...EgeTimeoutFragment
    }
  }
}
    ${SubjectFragmentFragmentDoc}
${EgeTimeoutFragmentFragmentDoc}`;
export type EgeTimeoutUnauthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>, 'query'> & ({ variables: EgeTimeoutUnauthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EgeTimeoutUnauthQuery = (props: EgeTimeoutUnauthQueryProps) => (
      <ApolloReactComponents.Query<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables> query={EgeTimeoutUnauthDocument} {...props} />
    );


/**
 * __useEgeTimeoutUnauthQuery__
 *
 * To run a query within a React component, call `useEgeTimeoutUnauthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEgeTimeoutUnauthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEgeTimeoutUnauthQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEgeTimeoutUnauthQuery(baseOptions: Apollo.QueryHookOptions<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables> & ({ variables: EgeTimeoutUnauthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>(EgeTimeoutUnauthDocument, options);
      }
export function useEgeTimeoutUnauthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>(EgeTimeoutUnauthDocument, options);
        }
export function useEgeTimeoutUnauthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>(EgeTimeoutUnauthDocument, options);
        }
export type EgeTimeoutUnauthQueryHookResult = ReturnType<typeof useEgeTimeoutUnauthQuery>;
export type EgeTimeoutUnauthLazyQueryHookResult = ReturnType<typeof useEgeTimeoutUnauthLazyQuery>;
export type EgeTimeoutUnauthSuspenseQueryHookResult = ReturnType<typeof useEgeTimeoutUnauthSuspenseQuery>;
export type EgeTimeoutUnauthQueryResult = Apollo.QueryResult<EgeTimeoutUnauthQuery, EgeTimeoutUnauthQueryVariables>;
export const ArticleFindManyDocument = gql`
    query ArticleFindMany($list: ListInput!, $filter: FilterArticleInput!, $sort: BaseSortInput!) {
  articleFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...ArticleFragment
    }
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleFindManyQuery, ArticleFindManyQueryVariables>, 'query'> & ({ variables: ArticleFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleFindManyQuery = (props: ArticleFindManyQueryProps) => (
      <ApolloReactComponents.Query<ArticleFindManyQuery, ArticleFindManyQueryVariables> query={ArticleFindManyDocument} {...props} />
    );


/**
 * __useArticleFindManyQuery__
 *
 * To run a query within a React component, call `useArticleFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useArticleFindManyQuery(baseOptions: Apollo.QueryHookOptions<ArticleFindManyQuery, ArticleFindManyQueryVariables> & ({ variables: ArticleFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleFindManyQuery, ArticleFindManyQueryVariables>(ArticleFindManyDocument, options);
      }
export function useArticleFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleFindManyQuery, ArticleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleFindManyQuery, ArticleFindManyQueryVariables>(ArticleFindManyDocument, options);
        }
export function useArticleFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArticleFindManyQuery, ArticleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleFindManyQuery, ArticleFindManyQueryVariables>(ArticleFindManyDocument, options);
        }
export type ArticleFindManyQueryHookResult = ReturnType<typeof useArticleFindManyQuery>;
export type ArticleFindManyLazyQueryHookResult = ReturnType<typeof useArticleFindManyLazyQuery>;
export type ArticleFindManySuspenseQueryHookResult = ReturnType<typeof useArticleFindManySuspenseQuery>;
export type ArticleFindManyQueryResult = Apollo.QueryResult<ArticleFindManyQuery, ArticleFindManyQueryVariables>;
export const ArticleFindOneDocument = gql`
    query ArticleFindOne($articleId: Int!) {
  articleFindOne(articleId: $articleId) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleFindOneQuery, ArticleFindOneQueryVariables>, 'query'> & ({ variables: ArticleFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleFindOneQuery = (props: ArticleFindOneQueryProps) => (
      <ApolloReactComponents.Query<ArticleFindOneQuery, ArticleFindOneQueryVariables> query={ArticleFindOneDocument} {...props} />
    );


/**
 * __useArticleFindOneQuery__
 *
 * To run a query within a React component, call `useArticleFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleFindOneQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleFindOneQuery(baseOptions: Apollo.QueryHookOptions<ArticleFindOneQuery, ArticleFindOneQueryVariables> & ({ variables: ArticleFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleFindOneQuery, ArticleFindOneQueryVariables>(ArticleFindOneDocument, options);
      }
export function useArticleFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleFindOneQuery, ArticleFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleFindOneQuery, ArticleFindOneQueryVariables>(ArticleFindOneDocument, options);
        }
export function useArticleFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArticleFindOneQuery, ArticleFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleFindOneQuery, ArticleFindOneQueryVariables>(ArticleFindOneDocument, options);
        }
export type ArticleFindOneQueryHookResult = ReturnType<typeof useArticleFindOneQuery>;
export type ArticleFindOneLazyQueryHookResult = ReturnType<typeof useArticleFindOneLazyQuery>;
export type ArticleFindOneSuspenseQueryHookResult = ReturnType<typeof useArticleFindOneSuspenseQuery>;
export type ArticleFindOneQueryResult = Apollo.QueryResult<ArticleFindOneQuery, ArticleFindOneQueryVariables>;
export const ArticleCreateDocument = gql`
    mutation ArticleCreate($article: CreateArticleInput!) {
  articleCreate(article: $article) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleCreateMutationFn = Apollo.MutationFunction<ArticleCreateMutation, ArticleCreateMutationVariables>;
export type ArticleCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleCreateMutation, ArticleCreateMutationVariables>, 'mutation'>;

    export const ArticleCreateQuery = (props: ArticleCreateQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleCreateMutation, ArticleCreateMutationVariables> mutation={ArticleCreateDocument} {...props} />
    );


/**
 * __useArticleCreateMutation__
 *
 * To run a mutation, you first call `useArticleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleCreateMutation, { data, loading, error }] = useArticleCreateMutation({
 *   variables: {
 *      article: // value for 'article'
 *   },
 * });
 */
export function useArticleCreateMutation(baseOptions?: Apollo.MutationHookOptions<ArticleCreateMutation, ArticleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleCreateMutation, ArticleCreateMutationVariables>(ArticleCreateDocument, options);
      }
export type ArticleCreateMutationHookResult = ReturnType<typeof useArticleCreateMutation>;
export type ArticleCreateMutationResult = Apollo.MutationResult<ArticleCreateMutation>;
export type ArticleCreateMutationOptions = Apollo.BaseMutationOptions<ArticleCreateMutation, ArticleCreateMutationVariables>;
export const ArticleUpdateDocument = gql`
    mutation ArticleUpdate($articleId: Int!, $article: UpdateArticleInput!) {
  articleUpdate(articleId: $articleId, article: $article) {
    ...ArticleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleUpdateMutationFn = Apollo.MutationFunction<ArticleUpdateMutation, ArticleUpdateMutationVariables>;
export type ArticleUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleUpdateMutation, ArticleUpdateMutationVariables>, 'mutation'>;

    export const ArticleUpdateQuery = (props: ArticleUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleUpdateMutation, ArticleUpdateMutationVariables> mutation={ArticleUpdateDocument} {...props} />
    );


/**
 * __useArticleUpdateMutation__
 *
 * To run a mutation, you first call `useArticleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleUpdateMutation, { data, loading, error }] = useArticleUpdateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      article: // value for 'article'
 *   },
 * });
 */
export function useArticleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ArticleUpdateMutation, ArticleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleUpdateMutation, ArticleUpdateMutationVariables>(ArticleUpdateDocument, options);
      }
export type ArticleUpdateMutationHookResult = ReturnType<typeof useArticleUpdateMutation>;
export type ArticleUpdateMutationResult = Apollo.MutationResult<ArticleUpdateMutation>;
export type ArticleUpdateMutationOptions = Apollo.BaseMutationOptions<ArticleUpdateMutation, ArticleUpdateMutationVariables>;
export const ArticleBlockManageCreateDocument = gql`
    mutation ArticleBlockManageCreate($articleId: Int!, $contentElement: CreateElementContentInput!) {
  articleBlockManageCreate(articleId: $articleId, contentElement: $contentElement) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type ArticleBlockManageCreateMutationFn = Apollo.MutationFunction<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables>;
export type ArticleBlockManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables>, 'mutation'>;

    export const ArticleBlockManageCreateQuery = (props: ArticleBlockManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables> mutation={ArticleBlockManageCreateDocument} {...props} />
    );


/**
 * __useArticleBlockManageCreateMutation__
 *
 * To run a mutation, you first call `useArticleBlockManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleBlockManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleBlockManageCreateMutation, { data, loading, error }] = useArticleBlockManageCreateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useArticleBlockManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables>(ArticleBlockManageCreateDocument, options);
      }
export type ArticleBlockManageCreateMutationHookResult = ReturnType<typeof useArticleBlockManageCreateMutation>;
export type ArticleBlockManageCreateMutationResult = Apollo.MutationResult<ArticleBlockManageCreateMutation>;
export type ArticleBlockManageCreateMutationOptions = Apollo.BaseMutationOptions<ArticleBlockManageCreateMutation, ArticleBlockManageCreateMutationVariables>;
export const ArticleBlockManageUpdateDocument = gql`
    mutation ArticleBlockManageUpdate($articleId: Int!, $contentElementId: Int!, $contentElement: UpdateElementContentInput!) {
  articleBlockManageUpdate(
    articleId: $articleId
    contentElementId: $contentElementId
    contentElement: $contentElement
  ) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type ArticleBlockManageUpdateMutationFn = Apollo.MutationFunction<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables>;
export type ArticleBlockManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables>, 'mutation'>;

    export const ArticleBlockManageUpdateQuery = (props: ArticleBlockManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables> mutation={ArticleBlockManageUpdateDocument} {...props} />
    );


/**
 * __useArticleBlockManageUpdateMutation__
 *
 * To run a mutation, you first call `useArticleBlockManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleBlockManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleBlockManageUpdateMutation, { data, loading, error }] = useArticleBlockManageUpdateMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      contentElementId: // value for 'contentElementId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useArticleBlockManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables>(ArticleBlockManageUpdateDocument, options);
      }
export type ArticleBlockManageUpdateMutationHookResult = ReturnType<typeof useArticleBlockManageUpdateMutation>;
export type ArticleBlockManageUpdateMutationResult = Apollo.MutationResult<ArticleBlockManageUpdateMutation>;
export type ArticleBlockManageUpdateMutationOptions = Apollo.BaseMutationOptions<ArticleBlockManageUpdateMutation, ArticleBlockManageUpdateMutationVariables>;
export const ArticleBlockManageDeleteDocument = gql`
    mutation ArticleBlockManageDelete($articleId: Int!, $contentElementId: Int!) {
  articleBlockManageDelete(
    articleId: $articleId
    contentElementId: $contentElementId
  )
}
    `;
export type ArticleBlockManageDeleteMutationFn = Apollo.MutationFunction<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables>;
export type ArticleBlockManageDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables>, 'mutation'>;

    export const ArticleBlockManageDeleteQuery = (props: ArticleBlockManageDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables> mutation={ArticleBlockManageDeleteDocument} {...props} />
    );


/**
 * __useArticleBlockManageDeleteMutation__
 *
 * To run a mutation, you first call `useArticleBlockManageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleBlockManageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleBlockManageDeleteMutation, { data, loading, error }] = useArticleBlockManageDeleteMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useArticleBlockManageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables>(ArticleBlockManageDeleteDocument, options);
      }
export type ArticleBlockManageDeleteMutationHookResult = ReturnType<typeof useArticleBlockManageDeleteMutation>;
export type ArticleBlockManageDeleteMutationResult = Apollo.MutationResult<ArticleBlockManageDeleteMutation>;
export type ArticleBlockManageDeleteMutationOptions = Apollo.BaseMutationOptions<ArticleBlockManageDeleteMutation, ArticleBlockManageDeleteMutationVariables>;
export const ArticleBlockManageRecoverDocument = gql`
    mutation ArticleBlockManageRecover($articleId: Int!, $contentElementId: Int!) {
  articleBlockManageRecover(
    articleId: $articleId
    contentElementId: $contentElementId
  ) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type ArticleBlockManageRecoverMutationFn = Apollo.MutationFunction<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables>;
export type ArticleBlockManageRecoverQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables>, 'mutation'>;

    export const ArticleBlockManageRecoverQuery = (props: ArticleBlockManageRecoverQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables> mutation={ArticleBlockManageRecoverDocument} {...props} />
    );


/**
 * __useArticleBlockManageRecoverMutation__
 *
 * To run a mutation, you first call `useArticleBlockManageRecoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleBlockManageRecoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleBlockManageRecoverMutation, { data, loading, error }] = useArticleBlockManageRecoverMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useArticleBlockManageRecoverMutation(baseOptions?: Apollo.MutationHookOptions<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables>(ArticleBlockManageRecoverDocument, options);
      }
export type ArticleBlockManageRecoverMutationHookResult = ReturnType<typeof useArticleBlockManageRecoverMutation>;
export type ArticleBlockManageRecoverMutationResult = Apollo.MutationResult<ArticleBlockManageRecoverMutation>;
export type ArticleBlockManageRecoverMutationOptions = Apollo.BaseMutationOptions<ArticleBlockManageRecoverMutation, ArticleBlockManageRecoverMutationVariables>;
export const ArticleBlockManageUpdateOrderDocument = gql`
    mutation ArticleBlockManageUpdateOrder($articleId: Int!, $blockOrder: UpdateBlockOrderArticleInput!) {
  articleBlockManageUpdateOrder(articleId: $articleId, blockOrder: $blockOrder) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type ArticleBlockManageUpdateOrderMutationFn = Apollo.MutationFunction<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables>;
export type ArticleBlockManageUpdateOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables>, 'mutation'>;

    export const ArticleBlockManageUpdateOrderQuery = (props: ArticleBlockManageUpdateOrderQueryProps) => (
      <ApolloReactComponents.Mutation<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables> mutation={ArticleBlockManageUpdateOrderDocument} {...props} />
    );


/**
 * __useArticleBlockManageUpdateOrderMutation__
 *
 * To run a mutation, you first call `useArticleBlockManageUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArticleBlockManageUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [articleBlockManageUpdateOrderMutation, { data, loading, error }] = useArticleBlockManageUpdateOrderMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      blockOrder: // value for 'blockOrder'
 *   },
 * });
 */
export function useArticleBlockManageUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables>(ArticleBlockManageUpdateOrderDocument, options);
      }
export type ArticleBlockManageUpdateOrderMutationHookResult = ReturnType<typeof useArticleBlockManageUpdateOrderMutation>;
export type ArticleBlockManageUpdateOrderMutationResult = Apollo.MutationResult<ArticleBlockManageUpdateOrderMutation>;
export type ArticleBlockManageUpdateOrderMutationOptions = Apollo.BaseMutationOptions<ArticleBlockManageUpdateOrderMutation, ArticleBlockManageUpdateOrderMutationVariables>;
export const GetPartnerRequestsDocument = gql`
    query GetPartnerRequests($list: ListInput!, $filter: FilterRequestSellerInput!, $sort: BaseSortInput) {
  sellerBecomeRequestFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      id
      type
      status
      organizationName
      organizationForm
      sellerOrganization {
        id
        logo
        name
        form
      }
      user {
        id
        profile {
          id
          fullNameShort
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type GetPartnerRequestsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>, 'query'> & ({ variables: GetPartnerRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPartnerRequestsQuery = (props: GetPartnerRequestsQueryProps) => (
      <ApolloReactComponents.Query<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables> query={GetPartnerRequestsDocument} {...props} />
    );


/**
 * __useGetPartnerRequestsQuery__
 *
 * To run a query within a React component, call `useGetPartnerRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerRequestsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPartnerRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables> & ({ variables: GetPartnerRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>(GetPartnerRequestsDocument, options);
      }
export function useGetPartnerRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>(GetPartnerRequestsDocument, options);
        }
export function useGetPartnerRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>(GetPartnerRequestsDocument, options);
        }
export type GetPartnerRequestsQueryHookResult = ReturnType<typeof useGetPartnerRequestsQuery>;
export type GetPartnerRequestsLazyQueryHookResult = ReturnType<typeof useGetPartnerRequestsLazyQuery>;
export type GetPartnerRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPartnerRequestsSuspenseQuery>;
export type GetPartnerRequestsQueryResult = Apollo.QueryResult<GetPartnerRequestsQuery, GetPartnerRequestsQueryVariables>;
export const SellerReviewBecomeRequestDocument = gql`
    mutation SellerReviewBecomeRequest($requestId: Int!, $status: SellerBecomeRequestStatus!, $comment: String) {
  sellerBecomeRequestReview(
    requestId: $requestId
    status: $status
    comment: $comment
  ) {
    id
    status
  }
}
    `;
export type SellerReviewBecomeRequestMutationFn = Apollo.MutationFunction<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables>;
export type SellerReviewBecomeRequestQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables>, 'mutation'>;

    export const SellerReviewBecomeRequestQuery = (props: SellerReviewBecomeRequestQueryProps) => (
      <ApolloReactComponents.Mutation<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables> mutation={SellerReviewBecomeRequestDocument} {...props} />
    );


/**
 * __useSellerReviewBecomeRequestMutation__
 *
 * To run a mutation, you first call `useSellerReviewBecomeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerReviewBecomeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerReviewBecomeRequestMutation, { data, loading, error }] = useSellerReviewBecomeRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSellerReviewBecomeRequestMutation(baseOptions?: Apollo.MutationHookOptions<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables>(SellerReviewBecomeRequestDocument, options);
      }
export type SellerReviewBecomeRequestMutationHookResult = ReturnType<typeof useSellerReviewBecomeRequestMutation>;
export type SellerReviewBecomeRequestMutationResult = Apollo.MutationResult<SellerReviewBecomeRequestMutation>;
export type SellerReviewBecomeRequestMutationOptions = Apollo.BaseMutationOptions<SellerReviewBecomeRequestMutation, SellerReviewBecomeRequestMutationVariables>;
export const GetUserDataDocument = gql`
    query GetUserData($userId: Int!) {
  profileFindOne(userId: $userId) {
    id
    user {
      id
      lastOnlineAt
      verified
      banned
      permissions
      vkId
      active
      email
    }
  }
}
    `;
export type GetUserDataQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserDataQuery, GetUserDataQueryVariables>, 'query'> & ({ variables: GetUserDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserDataQuery = (props: GetUserDataQueryProps) => (
      <ApolloReactComponents.Query<GetUserDataQuery, GetUserDataQueryVariables> query={GetUserDataDocument} {...props} />
    );


/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables> & ({ variables: GetUserDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export function useGetUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataSuspenseQueryHookResult = ReturnType<typeof useGetUserDataSuspenseQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<GetUserDataQuery, GetUserDataQueryVariables>;
export const GetUserProfileDocument = gql`
    query GetUserProfile($userId: Int!) {
  profileFindOne(userId: $userId) {
    id
    fullName
    ...ProfileTitleFragment
    avatar {
      id
      medium
    }
    user {
      id
      lastOnlineAt
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type GetUserProfileQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserProfileQuery, GetUserProfileQueryVariables>, 'query'> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserProfileQuery = (props: GetUserProfileQueryProps) => (
      <ApolloReactComponents.Query<GetUserProfileQuery, GetUserProfileQueryVariables> query={GetUserProfileDocument} {...props} />
    );


/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const UserManageUpdateDocument = gql`
    mutation UserManageUpdate($userId: Int!, $userPartial: UpdateUserInput!) {
  userManageUpdate(userId: $userId, userPartial: $userPartial) {
    id
    banned
    permissions
    verified
  }
}
    `;
export type UserManageUpdateMutationFn = Apollo.MutationFunction<UserManageUpdateMutation, UserManageUpdateMutationVariables>;
export type UserManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<UserManageUpdateMutation, UserManageUpdateMutationVariables>, 'mutation'>;

    export const UserManageUpdateQuery = (props: UserManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<UserManageUpdateMutation, UserManageUpdateMutationVariables> mutation={UserManageUpdateDocument} {...props} />
    );


/**
 * __useUserManageUpdateMutation__
 *
 * To run a mutation, you first call `useUserManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userManageUpdateMutation, { data, loading, error }] = useUserManageUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userPartial: // value for 'userPartial'
 *   },
 * });
 */
export function useUserManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserManageUpdateMutation, UserManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserManageUpdateMutation, UserManageUpdateMutationVariables>(UserManageUpdateDocument, options);
      }
export type UserManageUpdateMutationHookResult = ReturnType<typeof useUserManageUpdateMutation>;
export type UserManageUpdateMutationResult = Apollo.MutationResult<UserManageUpdateMutation>;
export type UserManageUpdateMutationOptions = Apollo.BaseMutationOptions<UserManageUpdateMutation, UserManageUpdateMutationVariables>;
export const UserFindManyDocument = gql`
    query UserFindMany($list: ListInput!, $filter: FilterUserInput!, $sort: BaseSortInput) {
  userFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      id
      verified
      banned
      active
      vkId
      email
      permissions
      lastOnlineAt
      profile {
        sex
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          small
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type UserFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<UserFindManyQuery, UserFindManyQueryVariables>, 'query'> & ({ variables: UserFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserFindManyQuery = (props: UserFindManyQueryProps) => (
      <ApolloReactComponents.Query<UserFindManyQuery, UserFindManyQueryVariables> query={UserFindManyDocument} {...props} />
    );


/**
 * __useUserFindManyQuery__
 *
 * To run a query within a React component, call `useUserFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUserFindManyQuery(baseOptions: Apollo.QueryHookOptions<UserFindManyQuery, UserFindManyQueryVariables> & ({ variables: UserFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindManyQuery, UserFindManyQueryVariables>(UserFindManyDocument, options);
      }
export function useUserFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindManyQuery, UserFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindManyQuery, UserFindManyQueryVariables>(UserFindManyDocument, options);
        }
export function useUserFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFindManyQuery, UserFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindManyQuery, UserFindManyQueryVariables>(UserFindManyDocument, options);
        }
export type UserFindManyQueryHookResult = ReturnType<typeof useUserFindManyQuery>;
export type UserFindManyLazyQueryHookResult = ReturnType<typeof useUserFindManyLazyQuery>;
export type UserFindManySuspenseQueryHookResult = ReturnType<typeof useUserFindManySuspenseQuery>;
export type UserFindManyQueryResult = Apollo.QueryResult<UserFindManyQuery, UserFindManyQueryVariables>;
export const CourseFindManyLessonsDocument = gql`
    query CourseFindManyLessons($courseId: Int!, $list: ListInput!, $filter: FilterLessonCourseInput!, $sort: BaseSortInput) {
  courseLessonFindMany(
    courseId: $courseId
    list: $list
    filter: $filter
    sort: $sort
  ) {
    pages
    items {
      ...LessonListItemFragment
      parent {
        ...CourseLessonParentFragment
      }
    }
  }
}
    ${LessonListItemFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type CourseFindManyLessonsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>, 'query'> & ({ variables: CourseFindManyLessonsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseFindManyLessonsQuery = (props: CourseFindManyLessonsQueryProps) => (
      <ApolloReactComponents.Query<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables> query={CourseFindManyLessonsDocument} {...props} />
    );


/**
 * __useCourseFindManyLessonsQuery__
 *
 * To run a query within a React component, call `useCourseFindManyLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindManyLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindManyLessonsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseFindManyLessonsQuery(baseOptions: Apollo.QueryHookOptions<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables> & ({ variables: CourseFindManyLessonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>(CourseFindManyLessonsDocument, options);
      }
export function useCourseFindManyLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>(CourseFindManyLessonsDocument, options);
        }
export function useCourseFindManyLessonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>(CourseFindManyLessonsDocument, options);
        }
export type CourseFindManyLessonsQueryHookResult = ReturnType<typeof useCourseFindManyLessonsQuery>;
export type CourseFindManyLessonsLazyQueryHookResult = ReturnType<typeof useCourseFindManyLessonsLazyQuery>;
export type CourseFindManyLessonsSuspenseQueryHookResult = ReturnType<typeof useCourseFindManyLessonsSuspenseQuery>;
export type CourseFindManyLessonsQueryResult = Apollo.QueryResult<CourseFindManyLessonsQuery, CourseFindManyLessonsQueryVariables>;
export const CourseUpdateLessonOrderDocument = gql`
    mutation CourseUpdateLessonOrder($courseId: Int!, $lessonIds: [Int!]!) {
  courseLessonManageUpdateOrder(courseId: $courseId, lessonIds: $lessonIds) {
    ...LessonListItemFragment
  }
}
    ${LessonListItemFragmentFragmentDoc}`;
export type CourseUpdateLessonOrderMutationFn = Apollo.MutationFunction<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables>;
export type CourseUpdateLessonOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables>, 'mutation'>;

    export const CourseUpdateLessonOrderQuery = (props: CourseUpdateLessonOrderQueryProps) => (
      <ApolloReactComponents.Mutation<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables> mutation={CourseUpdateLessonOrderDocument} {...props} />
    );


/**
 * __useCourseUpdateLessonOrderMutation__
 *
 * To run a mutation, you first call `useCourseUpdateLessonOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseUpdateLessonOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseUpdateLessonOrderMutation, { data, loading, error }] = useCourseUpdateLessonOrderMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonIds: // value for 'lessonIds'
 *   },
 * });
 */
export function useCourseUpdateLessonOrderMutation(baseOptions?: Apollo.MutationHookOptions<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables>(CourseUpdateLessonOrderDocument, options);
      }
export type CourseUpdateLessonOrderMutationHookResult = ReturnType<typeof useCourseUpdateLessonOrderMutation>;
export type CourseUpdateLessonOrderMutationResult = Apollo.MutationResult<CourseUpdateLessonOrderMutation>;
export type CourseUpdateLessonOrderMutationOptions = Apollo.BaseMutationOptions<CourseUpdateLessonOrderMutation, CourseUpdateLessonOrderMutationVariables>;
export const ProductFaqFindManyDocument = gql`
    query ProductFaqFindMany($list: ListInput!, $filter: FilterFaqProductInput!, $sort: SortFaqProductInput) {
  productFaqFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      ...ProductFaqFragment
    }
  }
}
    ${ProductFaqFragmentFragmentDoc}`;
export type ProductFaqFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>, 'query'> & ({ variables: ProductFaqFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFaqFindManyQuery = (props: ProductFaqFindManyQueryProps) => (
      <ApolloReactComponents.Query<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables> query={ProductFaqFindManyDocument} {...props} />
    );


/**
 * __useProductFaqFindManyQuery__
 *
 * To run a query within a React component, call `useProductFaqFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFaqFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFaqFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductFaqFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables> & ({ variables: ProductFaqFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>(ProductFaqFindManyDocument, options);
      }
export function useProductFaqFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>(ProductFaqFindManyDocument, options);
        }
export function useProductFaqFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>(ProductFaqFindManyDocument, options);
        }
export type ProductFaqFindManyQueryHookResult = ReturnType<typeof useProductFaqFindManyQuery>;
export type ProductFaqFindManyLazyQueryHookResult = ReturnType<typeof useProductFaqFindManyLazyQuery>;
export type ProductFaqFindManySuspenseQueryHookResult = ReturnType<typeof useProductFaqFindManySuspenseQuery>;
export type ProductFaqFindManyQueryResult = Apollo.QueryResult<ProductFaqFindManyQuery, ProductFaqFindManyQueryVariables>;
export const ProductFaqFindOneDocument = gql`
    query ProductFaqFindOne($faqId: Int!) {
  productFaqFindOne(faqId: $faqId) {
    ...ProductFaqFragment
  }
}
    ${ProductFaqFragmentFragmentDoc}`;
export type ProductFaqFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>, 'query'> & ({ variables: ProductFaqFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFaqFindOneQuery = (props: ProductFaqFindOneQueryProps) => (
      <ApolloReactComponents.Query<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables> query={ProductFaqFindOneDocument} {...props} />
    );


/**
 * __useProductFaqFindOneQuery__
 *
 * To run a query within a React component, call `useProductFaqFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFaqFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFaqFindOneQuery({
 *   variables: {
 *      faqId: // value for 'faqId'
 *   },
 * });
 */
export function useProductFaqFindOneQuery(baseOptions: Apollo.QueryHookOptions<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables> & ({ variables: ProductFaqFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>(ProductFaqFindOneDocument, options);
      }
export function useProductFaqFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>(ProductFaqFindOneDocument, options);
        }
export function useProductFaqFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>(ProductFaqFindOneDocument, options);
        }
export type ProductFaqFindOneQueryHookResult = ReturnType<typeof useProductFaqFindOneQuery>;
export type ProductFaqFindOneLazyQueryHookResult = ReturnType<typeof useProductFaqFindOneLazyQuery>;
export type ProductFaqFindOneSuspenseQueryHookResult = ReturnType<typeof useProductFaqFindOneSuspenseQuery>;
export type ProductFaqFindOneQueryResult = Apollo.QueryResult<ProductFaqFindOneQuery, ProductFaqFindOneQueryVariables>;
export const ProductFaqCreateDocument = gql`
    mutation ProductFaqCreate($productId: Int!, $faq: CreateFaqProductInput!) {
  productFaqCreate(productId: $productId, faq: $faq) {
    ...ProductFaqFragment
  }
}
    ${ProductFaqFragmentFragmentDoc}`;
export type ProductFaqCreateMutationFn = Apollo.MutationFunction<ProductFaqCreateMutation, ProductFaqCreateMutationVariables>;
export type ProductFaqCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductFaqCreateMutation, ProductFaqCreateMutationVariables>, 'mutation'>;

    export const ProductFaqCreateQuery = (props: ProductFaqCreateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductFaqCreateMutation, ProductFaqCreateMutationVariables> mutation={ProductFaqCreateDocument} {...props} />
    );


/**
 * __useProductFaqCreateMutation__
 *
 * To run a mutation, you first call `useProductFaqCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductFaqCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productFaqCreateMutation, { data, loading, error }] = useProductFaqCreateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      faq: // value for 'faq'
 *   },
 * });
 */
export function useProductFaqCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductFaqCreateMutation, ProductFaqCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductFaqCreateMutation, ProductFaqCreateMutationVariables>(ProductFaqCreateDocument, options);
      }
export type ProductFaqCreateMutationHookResult = ReturnType<typeof useProductFaqCreateMutation>;
export type ProductFaqCreateMutationResult = Apollo.MutationResult<ProductFaqCreateMutation>;
export type ProductFaqCreateMutationOptions = Apollo.BaseMutationOptions<ProductFaqCreateMutation, ProductFaqCreateMutationVariables>;
export const ProductFaqUpdateDocument = gql`
    mutation ProductFaqUpdate($faqId: Int!, $faq: UpdateFaqProductInput!) {
  productFaqUpdate(faqId: $faqId, faq: $faq) {
    ...ProductFaqFragment
  }
}
    ${ProductFaqFragmentFragmentDoc}`;
export type ProductFaqUpdateMutationFn = Apollo.MutationFunction<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables>;
export type ProductFaqUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables>, 'mutation'>;

    export const ProductFaqUpdateQuery = (props: ProductFaqUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables> mutation={ProductFaqUpdateDocument} {...props} />
    );


/**
 * __useProductFaqUpdateMutation__
 *
 * To run a mutation, you first call `useProductFaqUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductFaqUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productFaqUpdateMutation, { data, loading, error }] = useProductFaqUpdateMutation({
 *   variables: {
 *      faqId: // value for 'faqId'
 *      faq: // value for 'faq'
 *   },
 * });
 */
export function useProductFaqUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables>(ProductFaqUpdateDocument, options);
      }
export type ProductFaqUpdateMutationHookResult = ReturnType<typeof useProductFaqUpdateMutation>;
export type ProductFaqUpdateMutationResult = Apollo.MutationResult<ProductFaqUpdateMutation>;
export type ProductFaqUpdateMutationOptions = Apollo.BaseMutationOptions<ProductFaqUpdateMutation, ProductFaqUpdateMutationVariables>;
export const ProductFaqUpdateOrderDocument = gql`
    mutation ProductFaqUpdateOrder($productId: Int!, $faqIds: [Int!]!) {
  productFaqUpdateOrder(productId: $productId, faqIds: $faqIds) {
    id
  }
}
    `;
export type ProductFaqUpdateOrderMutationFn = Apollo.MutationFunction<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables>;
export type ProductFaqUpdateOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables>, 'mutation'>;

    export const ProductFaqUpdateOrderQuery = (props: ProductFaqUpdateOrderQueryProps) => (
      <ApolloReactComponents.Mutation<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables> mutation={ProductFaqUpdateOrderDocument} {...props} />
    );


/**
 * __useProductFaqUpdateOrderMutation__
 *
 * To run a mutation, you first call `useProductFaqUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductFaqUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productFaqUpdateOrderMutation, { data, loading, error }] = useProductFaqUpdateOrderMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      faqIds: // value for 'faqIds'
 *   },
 * });
 */
export function useProductFaqUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables>(ProductFaqUpdateOrderDocument, options);
      }
export type ProductFaqUpdateOrderMutationHookResult = ReturnType<typeof useProductFaqUpdateOrderMutation>;
export type ProductFaqUpdateOrderMutationResult = Apollo.MutationResult<ProductFaqUpdateOrderMutation>;
export type ProductFaqUpdateOrderMutationOptions = Apollo.BaseMutationOptions<ProductFaqUpdateOrderMutation, ProductFaqUpdateOrderMutationVariables>;
export const CourseFindOneManageDocument = gql`
    query CourseFindOneManage($courseId: Int!) {
  courseFindOne(courseId: $courseId) {
    ...CourseManageFragment
  }
}
    ${CourseManageFragmentFragmentDoc}`;
export type CourseFindOneManageQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>, 'query'> & ({ variables: CourseFindOneManageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseFindOneManageQuery = (props: CourseFindOneManageQueryProps) => (
      <ApolloReactComponents.Query<CourseFindOneManageQuery, CourseFindOneManageQueryVariables> query={CourseFindOneManageDocument} {...props} />
    );


/**
 * __useCourseFindOneManageQuery__
 *
 * To run a query within a React component, call `useCourseFindOneManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindOneManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindOneManageQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseFindOneManageQuery(baseOptions: Apollo.QueryHookOptions<CourseFindOneManageQuery, CourseFindOneManageQueryVariables> & ({ variables: CourseFindOneManageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>(CourseFindOneManageDocument, options);
      }
export function useCourseFindOneManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>(CourseFindOneManageDocument, options);
        }
export function useCourseFindOneManageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>(CourseFindOneManageDocument, options);
        }
export type CourseFindOneManageQueryHookResult = ReturnType<typeof useCourseFindOneManageQuery>;
export type CourseFindOneManageLazyQueryHookResult = ReturnType<typeof useCourseFindOneManageLazyQuery>;
export type CourseFindOneManageSuspenseQueryHookResult = ReturnType<typeof useCourseFindOneManageSuspenseQuery>;
export type CourseFindOneManageQueryResult = Apollo.QueryResult<CourseFindOneManageQuery, CourseFindOneManageQueryVariables>;
export const CourseManageCheckCourseAliasDocument = gql`
    query CourseManageCheckCourseAlias($alias: String!, $courseId: Int!) {
  courseManageCheckCourseAlias(alias: $alias, courseId: $courseId) {
    success
    cause
    message
  }
}
    `;
export type CourseManageCheckCourseAliasQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>, 'query'> & ({ variables: CourseManageCheckCourseAliasQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseManageCheckCourseAliasQuery = (props: CourseManageCheckCourseAliasQueryProps) => (
      <ApolloReactComponents.Query<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables> query={CourseManageCheckCourseAliasDocument} {...props} />
    );


/**
 * __useCourseManageCheckCourseAliasQuery__
 *
 * To run a query within a React component, call `useCourseManageCheckCourseAliasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseManageCheckCourseAliasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseManageCheckCourseAliasQuery({
 *   variables: {
 *      alias: // value for 'alias'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseManageCheckCourseAliasQuery(baseOptions: Apollo.QueryHookOptions<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables> & ({ variables: CourseManageCheckCourseAliasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>(CourseManageCheckCourseAliasDocument, options);
      }
export function useCourseManageCheckCourseAliasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>(CourseManageCheckCourseAliasDocument, options);
        }
export function useCourseManageCheckCourseAliasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>(CourseManageCheckCourseAliasDocument, options);
        }
export type CourseManageCheckCourseAliasQueryHookResult = ReturnType<typeof useCourseManageCheckCourseAliasQuery>;
export type CourseManageCheckCourseAliasLazyQueryHookResult = ReturnType<typeof useCourseManageCheckCourseAliasLazyQuery>;
export type CourseManageCheckCourseAliasSuspenseQueryHookResult = ReturnType<typeof useCourseManageCheckCourseAliasSuspenseQuery>;
export type CourseManageCheckCourseAliasQueryResult = Apollo.QueryResult<CourseManageCheckCourseAliasQuery, CourseManageCheckCourseAliasQueryVariables>;
export const CourseManageCreateDocument = gql`
    mutation CourseManageCreate($course: CreateCourseInput!) {
  courseManageCreate(course: $course) {
    ...CourseManageFragment
  }
}
    ${CourseManageFragmentFragmentDoc}`;
export type CourseManageCreateMutationFn = Apollo.MutationFunction<CourseManageCreateMutation, CourseManageCreateMutationVariables>;
export type CourseManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseManageCreateMutation, CourseManageCreateMutationVariables>, 'mutation'>;

    export const CourseManageCreateQuery = (props: CourseManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseManageCreateMutation, CourseManageCreateMutationVariables> mutation={CourseManageCreateDocument} {...props} />
    );


/**
 * __useCourseManageCreateMutation__
 *
 * To run a mutation, you first call `useCourseManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseManageCreateMutation, { data, loading, error }] = useCourseManageCreateMutation({
 *   variables: {
 *      course: // value for 'course'
 *   },
 * });
 */
export function useCourseManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseManageCreateMutation, CourseManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseManageCreateMutation, CourseManageCreateMutationVariables>(CourseManageCreateDocument, options);
      }
export type CourseManageCreateMutationHookResult = ReturnType<typeof useCourseManageCreateMutation>;
export type CourseManageCreateMutationResult = Apollo.MutationResult<CourseManageCreateMutation>;
export type CourseManageCreateMutationOptions = Apollo.BaseMutationOptions<CourseManageCreateMutation, CourseManageCreateMutationVariables>;
export const CourseManageUpdateDocument = gql`
    mutation CourseManageUpdate($courseId: Int!, $course: UpdateCourseInput!) {
  courseManageUpdate(courseId: $courseId, course: $course) {
    ...CourseManageFragment
  }
}
    ${CourseManageFragmentFragmentDoc}`;
export type CourseManageUpdateMutationFn = Apollo.MutationFunction<CourseManageUpdateMutation, CourseManageUpdateMutationVariables>;
export type CourseManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseManageUpdateMutation, CourseManageUpdateMutationVariables>, 'mutation'>;

    export const CourseManageUpdateQuery = (props: CourseManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseManageUpdateMutation, CourseManageUpdateMutationVariables> mutation={CourseManageUpdateDocument} {...props} />
    );


/**
 * __useCourseManageUpdateMutation__
 *
 * To run a mutation, you first call `useCourseManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseManageUpdateMutation, { data, loading, error }] = useCourseManageUpdateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      course: // value for 'course'
 *   },
 * });
 */
export function useCourseManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseManageUpdateMutation, CourseManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseManageUpdateMutation, CourseManageUpdateMutationVariables>(CourseManageUpdateDocument, options);
      }
export type CourseManageUpdateMutationHookResult = ReturnType<typeof useCourseManageUpdateMutation>;
export type CourseManageUpdateMutationResult = Apollo.MutationResult<CourseManageUpdateMutation>;
export type CourseManageUpdateMutationOptions = Apollo.BaseMutationOptions<CourseManageUpdateMutation, CourseManageUpdateMutationVariables>;
export const CourseManageCloneDocument = gql`
    mutation CourseManageClone($courseId: Int!) {
  courseManageClone(courseId: $courseId) {
    ...CourseManageFragment
  }
}
    ${CourseManageFragmentFragmentDoc}`;
export type CourseManageCloneMutationFn = Apollo.MutationFunction<CourseManageCloneMutation, CourseManageCloneMutationVariables>;
export type CourseManageCloneQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseManageCloneMutation, CourseManageCloneMutationVariables>, 'mutation'>;

    export const CourseManageCloneQuery = (props: CourseManageCloneQueryProps) => (
      <ApolloReactComponents.Mutation<CourseManageCloneMutation, CourseManageCloneMutationVariables> mutation={CourseManageCloneDocument} {...props} />
    );


/**
 * __useCourseManageCloneMutation__
 *
 * To run a mutation, you first call `useCourseManageCloneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseManageCloneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseManageCloneMutation, { data, loading, error }] = useCourseManageCloneMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseManageCloneMutation(baseOptions?: Apollo.MutationHookOptions<CourseManageCloneMutation, CourseManageCloneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseManageCloneMutation, CourseManageCloneMutationVariables>(CourseManageCloneDocument, options);
      }
export type CourseManageCloneMutationHookResult = ReturnType<typeof useCourseManageCloneMutation>;
export type CourseManageCloneMutationResult = Apollo.MutationResult<CourseManageCloneMutation>;
export type CourseManageCloneMutationOptions = Apollo.BaseMutationOptions<CourseManageCloneMutation, CourseManageCloneMutationVariables>;
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($productId: Int!, $product: UpdateProductInput!) {
  productManageUpdate(productId: $productId, product: $product) {
    id
    archived
    createdAt
    publishedAt
    participantsCount
    saleStartAt
    saleFinishAt
    feedbackRating
    currency
    isOnSale
    minimalPrice {
      id
      amount
    }
    prices {
      id
      amount
      previousAmount
    }
  }
}
    `;
export type ProductUpdateMutationFn = Apollo.MutationFunction<ProductUpdateMutation, ProductUpdateMutationVariables>;
export type ProductUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductUpdateMutation, ProductUpdateMutationVariables>, 'mutation'>;

    export const ProductUpdateQuery = (props: ProductUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductUpdateMutation, ProductUpdateMutationVariables> mutation={ProductUpdateDocument} {...props} />
    );


/**
 * __useProductUpdateMutation__
 *
 * To run a mutation, you first call `useProductUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdateMutation, { data, loading, error }] = useProductUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useProductUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdateMutation, ProductUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument, options);
      }
export type ProductUpdateMutationHookResult = ReturnType<typeof useProductUpdateMutation>;
export type ProductUpdateMutationResult = Apollo.MutationResult<ProductUpdateMutation>;
export type ProductUpdateMutationOptions = Apollo.BaseMutationOptions<ProductUpdateMutation, ProductUpdateMutationVariables>;
export const CourseDatesUpdateDocument = gql`
    mutation CourseDatesUpdate($courseId: Int!, $course: UpdateCourseInput!, $productId: Int!, $product: UpdateProductInput!) {
  courseManageUpdate(courseId: $courseId, course: $course) {
    id
  }
  productManageUpdate(productId: $productId, product: $product) {
    id
    saleStartAt
    saleFinishAt
  }
}
    `;
export type CourseDatesUpdateMutationFn = Apollo.MutationFunction<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables>;
export type CourseDatesUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables>, 'mutation'>;

    export const CourseDatesUpdateQuery = (props: CourseDatesUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables> mutation={CourseDatesUpdateDocument} {...props} />
    );


/**
 * __useCourseDatesUpdateMutation__
 *
 * To run a mutation, you first call `useCourseDatesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseDatesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseDatesUpdateMutation, { data, loading, error }] = useCourseDatesUpdateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      course: // value for 'course'
 *      productId: // value for 'productId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useCourseDatesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables>(CourseDatesUpdateDocument, options);
      }
export type CourseDatesUpdateMutationHookResult = ReturnType<typeof useCourseDatesUpdateMutation>;
export type CourseDatesUpdateMutationResult = Apollo.MutationResult<CourseDatesUpdateMutation>;
export type CourseDatesUpdateMutationOptions = Apollo.BaseMutationOptions<CourseDatesUpdateMutation, CourseDatesUpdateMutationVariables>;
export const ProductPriceFindOneDocument = gql`
    query ProductPriceFindOne($priceId: Int!) {
  productPriceFindOne(priceId: $priceId) {
    ...ProductPriceFragment
  }
}
    ${ProductPriceFragmentFragmentDoc}`;
export type ProductPriceFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>, 'query'> & ({ variables: ProductPriceFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductPriceFindOneQuery = (props: ProductPriceFindOneQueryProps) => (
      <ApolloReactComponents.Query<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables> query={ProductPriceFindOneDocument} {...props} />
    );


/**
 * __useProductPriceFindOneQuery__
 *
 * To run a query within a React component, call `useProductPriceFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceFindOneQuery({
 *   variables: {
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useProductPriceFindOneQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables> & ({ variables: ProductPriceFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>(ProductPriceFindOneDocument, options);
      }
export function useProductPriceFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>(ProductPriceFindOneDocument, options);
        }
export function useProductPriceFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>(ProductPriceFindOneDocument, options);
        }
export type ProductPriceFindOneQueryHookResult = ReturnType<typeof useProductPriceFindOneQuery>;
export type ProductPriceFindOneLazyQueryHookResult = ReturnType<typeof useProductPriceFindOneLazyQuery>;
export type ProductPriceFindOneSuspenseQueryHookResult = ReturnType<typeof useProductPriceFindOneSuspenseQuery>;
export type ProductPriceFindOneQueryResult = Apollo.QueryResult<ProductPriceFindOneQuery, ProductPriceFindOneQueryVariables>;
export const ProductFindManyPricesDocument = gql`
    query ProductFindManyPrices($list: ListInput!, $filter: FilterPriceProductInput!, $sort: BaseSortInput) {
  productPriceFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      ...ProductPriceFragment
    }
  }
}
    ${ProductPriceFragmentFragmentDoc}`;
export type ProductFindManyPricesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>, 'query'> & ({ variables: ProductFindManyPricesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFindManyPricesQuery = (props: ProductFindManyPricesQueryProps) => (
      <ApolloReactComponents.Query<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables> query={ProductFindManyPricesDocument} {...props} />
    );


/**
 * __useProductFindManyPricesQuery__
 *
 * To run a query within a React component, call `useProductFindManyPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFindManyPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFindManyPricesQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductFindManyPricesQuery(baseOptions: Apollo.QueryHookOptions<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables> & ({ variables: ProductFindManyPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>(ProductFindManyPricesDocument, options);
      }
export function useProductFindManyPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>(ProductFindManyPricesDocument, options);
        }
export function useProductFindManyPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>(ProductFindManyPricesDocument, options);
        }
export type ProductFindManyPricesQueryHookResult = ReturnType<typeof useProductFindManyPricesQuery>;
export type ProductFindManyPricesLazyQueryHookResult = ReturnType<typeof useProductFindManyPricesLazyQuery>;
export type ProductFindManyPricesSuspenseQueryHookResult = ReturnType<typeof useProductFindManyPricesSuspenseQuery>;
export type ProductFindManyPricesQueryResult = Apollo.QueryResult<ProductFindManyPricesQuery, ProductFindManyPricesQueryVariables>;
export const ProductCreatePriceDocument = gql`
    mutation ProductCreatePrice($productId: Int!, $price: CreatePriceProductInput!, $launchId: Int) {
  productPriceCreate(productId: $productId, price: $price, launchId: $launchId) {
    ...ProductPriceFragment
  }
}
    ${ProductPriceFragmentFragmentDoc}`;
export type ProductCreatePriceMutationFn = Apollo.MutationFunction<ProductCreatePriceMutation, ProductCreatePriceMutationVariables>;
export type ProductCreatePriceQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductCreatePriceMutation, ProductCreatePriceMutationVariables>, 'mutation'>;

    export const ProductCreatePriceQuery = (props: ProductCreatePriceQueryProps) => (
      <ApolloReactComponents.Mutation<ProductCreatePriceMutation, ProductCreatePriceMutationVariables> mutation={ProductCreatePriceDocument} {...props} />
    );


/**
 * __useProductCreatePriceMutation__
 *
 * To run a mutation, you first call `useProductCreatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCreatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCreatePriceMutation, { data, loading, error }] = useProductCreatePriceMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      price: // value for 'price'
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useProductCreatePriceMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreatePriceMutation, ProductCreatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreatePriceMutation, ProductCreatePriceMutationVariables>(ProductCreatePriceDocument, options);
      }
export type ProductCreatePriceMutationHookResult = ReturnType<typeof useProductCreatePriceMutation>;
export type ProductCreatePriceMutationResult = Apollo.MutationResult<ProductCreatePriceMutation>;
export type ProductCreatePriceMutationOptions = Apollo.BaseMutationOptions<ProductCreatePriceMutation, ProductCreatePriceMutationVariables>;
export const ProductUpdatePriceDocument = gql`
    mutation ProductUpdatePrice($priceId: Int!, $price: UpdatePriceProductInput!) {
  productPriceUpdate(price: $price, priceId: $priceId) {
    ...ProductPriceFragment
  }
}
    ${ProductPriceFragmentFragmentDoc}`;
export type ProductUpdatePriceMutationFn = Apollo.MutationFunction<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables>;
export type ProductUpdatePriceQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables>, 'mutation'>;

    export const ProductUpdatePriceQuery = (props: ProductUpdatePriceQueryProps) => (
      <ApolloReactComponents.Mutation<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables> mutation={ProductUpdatePriceDocument} {...props} />
    );


/**
 * __useProductUpdatePriceMutation__
 *
 * To run a mutation, you first call `useProductUpdatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdatePriceMutation, { data, loading, error }] = useProductUpdatePriceMutation({
 *   variables: {
 *      priceId: // value for 'priceId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useProductUpdatePriceMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables>(ProductUpdatePriceDocument, options);
      }
export type ProductUpdatePriceMutationHookResult = ReturnType<typeof useProductUpdatePriceMutation>;
export type ProductUpdatePriceMutationResult = Apollo.MutationResult<ProductUpdatePriceMutation>;
export type ProductUpdatePriceMutationOptions = Apollo.BaseMutationOptions<ProductUpdatePriceMutation, ProductUpdatePriceMutationVariables>;
export const ProductLaunchFindManyDocument = gql`
    query ProductLaunchFindMany($list: ListInput!, $filter: FilterLaunchProductInput!, $sort: SortLaunchProductInput) {
  productLaunchFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    page
    pages
    items {
      ...LaunchFragment
    }
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductLaunchFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>, 'query'> & ({ variables: ProductLaunchFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductLaunchFindManyQuery = (props: ProductLaunchFindManyQueryProps) => (
      <ApolloReactComponents.Query<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables> query={ProductLaunchFindManyDocument} {...props} />
    );


/**
 * __useProductLaunchFindManyQuery__
 *
 * To run a query within a React component, call `useProductLaunchFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLaunchFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLaunchFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductLaunchFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables> & ({ variables: ProductLaunchFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>(ProductLaunchFindManyDocument, options);
      }
export function useProductLaunchFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>(ProductLaunchFindManyDocument, options);
        }
export function useProductLaunchFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>(ProductLaunchFindManyDocument, options);
        }
export type ProductLaunchFindManyQueryHookResult = ReturnType<typeof useProductLaunchFindManyQuery>;
export type ProductLaunchFindManyLazyQueryHookResult = ReturnType<typeof useProductLaunchFindManyLazyQuery>;
export type ProductLaunchFindManySuspenseQueryHookResult = ReturnType<typeof useProductLaunchFindManySuspenseQuery>;
export type ProductLaunchFindManyQueryResult = Apollo.QueryResult<ProductLaunchFindManyQuery, ProductLaunchFindManyQueryVariables>;
export const ProductLaunchFindOneDocument = gql`
    query ProductLaunchFindOne($launchId: Int!) {
  productLaunchFindOne(launchId: $launchId) {
    ...LaunchFragment
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductLaunchFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>, 'query'> & ({ variables: ProductLaunchFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductLaunchFindOneQuery = (props: ProductLaunchFindOneQueryProps) => (
      <ApolloReactComponents.Query<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables> query={ProductLaunchFindOneDocument} {...props} />
    );


/**
 * __useProductLaunchFindOneQuery__
 *
 * To run a query within a React component, call `useProductLaunchFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLaunchFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLaunchFindOneQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useProductLaunchFindOneQuery(baseOptions: Apollo.QueryHookOptions<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables> & ({ variables: ProductLaunchFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>(ProductLaunchFindOneDocument, options);
      }
export function useProductLaunchFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>(ProductLaunchFindOneDocument, options);
        }
export function useProductLaunchFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>(ProductLaunchFindOneDocument, options);
        }
export type ProductLaunchFindOneQueryHookResult = ReturnType<typeof useProductLaunchFindOneQuery>;
export type ProductLaunchFindOneLazyQueryHookResult = ReturnType<typeof useProductLaunchFindOneLazyQuery>;
export type ProductLaunchFindOneSuspenseQueryHookResult = ReturnType<typeof useProductLaunchFindOneSuspenseQuery>;
export type ProductLaunchFindOneQueryResult = Apollo.QueryResult<ProductLaunchFindOneQuery, ProductLaunchFindOneQueryVariables>;
export const ProductLaunchFindOneCrossedDocument = gql`
    query ProductLaunchFindOneCrossed($launchId: Int!, $launch: CheckLaunchProductInput!) {
  productLaunchFindOneCrossed(launchId: $launchId, launch: $launch) {
    ...LaunchFragment
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductLaunchFindOneCrossedQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>, 'query'> & ({ variables: ProductLaunchFindOneCrossedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductLaunchFindOneCrossedQuery = (props: ProductLaunchFindOneCrossedQueryProps) => (
      <ApolloReactComponents.Query<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables> query={ProductLaunchFindOneCrossedDocument} {...props} />
    );


/**
 * __useProductLaunchFindOneCrossedQuery__
 *
 * To run a query within a React component, call `useProductLaunchFindOneCrossedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLaunchFindOneCrossedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLaunchFindOneCrossedQuery({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      launch: // value for 'launch'
 *   },
 * });
 */
export function useProductLaunchFindOneCrossedQuery(baseOptions: Apollo.QueryHookOptions<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables> & ({ variables: ProductLaunchFindOneCrossedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>(ProductLaunchFindOneCrossedDocument, options);
      }
export function useProductLaunchFindOneCrossedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>(ProductLaunchFindOneCrossedDocument, options);
        }
export function useProductLaunchFindOneCrossedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>(ProductLaunchFindOneCrossedDocument, options);
        }
export type ProductLaunchFindOneCrossedQueryHookResult = ReturnType<typeof useProductLaunchFindOneCrossedQuery>;
export type ProductLaunchFindOneCrossedLazyQueryHookResult = ReturnType<typeof useProductLaunchFindOneCrossedLazyQuery>;
export type ProductLaunchFindOneCrossedSuspenseQueryHookResult = ReturnType<typeof useProductLaunchFindOneCrossedSuspenseQuery>;
export type ProductLaunchFindOneCrossedQueryResult = Apollo.QueryResult<ProductLaunchFindOneCrossedQuery, ProductLaunchFindOneCrossedQueryVariables>;
export const ProductLaunchCreateDocument = gql`
    mutation ProductLaunchCreate($productId: Int!, $launch: CreateLaunchProductInput!) {
  productLaunchCreate(productId: $productId, launch: $launch) {
    ...LaunchFragment
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductLaunchCreateMutationFn = Apollo.MutationFunction<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables>;
export type ProductLaunchCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables>, 'mutation'>;

    export const ProductLaunchCreateQuery = (props: ProductLaunchCreateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables> mutation={ProductLaunchCreateDocument} {...props} />
    );


/**
 * __useProductLaunchCreateMutation__
 *
 * To run a mutation, you first call `useProductLaunchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductLaunchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productLaunchCreateMutation, { data, loading, error }] = useProductLaunchCreateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      launch: // value for 'launch'
 *   },
 * });
 */
export function useProductLaunchCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables>(ProductLaunchCreateDocument, options);
      }
export type ProductLaunchCreateMutationHookResult = ReturnType<typeof useProductLaunchCreateMutation>;
export type ProductLaunchCreateMutationResult = Apollo.MutationResult<ProductLaunchCreateMutation>;
export type ProductLaunchCreateMutationOptions = Apollo.BaseMutationOptions<ProductLaunchCreateMutation, ProductLaunchCreateMutationVariables>;
export const ProductLaunchUpdateDocument = gql`
    mutation ProductLaunchUpdate($launchId: Int!, $launch: UpdateLaunchProductInput!) {
  productLaunchUpdate(launchId: $launchId, launch: $launch) {
    ...LaunchFragment
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductLaunchUpdateMutationFn = Apollo.MutationFunction<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables>;
export type ProductLaunchUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables>, 'mutation'>;

    export const ProductLaunchUpdateQuery = (props: ProductLaunchUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables> mutation={ProductLaunchUpdateDocument} {...props} />
    );


/**
 * __useProductLaunchUpdateMutation__
 *
 * To run a mutation, you first call `useProductLaunchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductLaunchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productLaunchUpdateMutation, { data, loading, error }] = useProductLaunchUpdateMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      launch: // value for 'launch'
 *   },
 * });
 */
export function useProductLaunchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables>(ProductLaunchUpdateDocument, options);
      }
export type ProductLaunchUpdateMutationHookResult = ReturnType<typeof useProductLaunchUpdateMutation>;
export type ProductLaunchUpdateMutationResult = Apollo.MutationResult<ProductLaunchUpdateMutation>;
export type ProductLaunchUpdateMutationOptions = Apollo.BaseMutationOptions<ProductLaunchUpdateMutation, ProductLaunchUpdateMutationVariables>;
export const ProductPublicationManualPublishLaunchDocument = gql`
    mutation ProductPublicationManualPublishLaunch($launchId: Int!, $publication: PublishLaunchProductInput!) {
  productPublicationManualPublishLaunch(
    launchId: $launchId
    publication: $publication
  ) {
    ...LaunchFragment
  }
}
    ${LaunchFragmentFragmentDoc}`;
export type ProductPublicationManualPublishLaunchMutationFn = Apollo.MutationFunction<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables>;
export type ProductPublicationManualPublishLaunchQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables>, 'mutation'>;

    export const ProductPublicationManualPublishLaunchQuery = (props: ProductPublicationManualPublishLaunchQueryProps) => (
      <ApolloReactComponents.Mutation<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables> mutation={ProductPublicationManualPublishLaunchDocument} {...props} />
    );


/**
 * __useProductPublicationManualPublishLaunchMutation__
 *
 * To run a mutation, you first call `useProductPublicationManualPublishLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductPublicationManualPublishLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productPublicationManualPublishLaunchMutation, { data, loading, error }] = useProductPublicationManualPublishLaunchMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      publication: // value for 'publication'
 *   },
 * });
 */
export function useProductPublicationManualPublishLaunchMutation(baseOptions?: Apollo.MutationHookOptions<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables>(ProductPublicationManualPublishLaunchDocument, options);
      }
export type ProductPublicationManualPublishLaunchMutationHookResult = ReturnType<typeof useProductPublicationManualPublishLaunchMutation>;
export type ProductPublicationManualPublishLaunchMutationResult = Apollo.MutationResult<ProductPublicationManualPublishLaunchMutation>;
export type ProductPublicationManualPublishLaunchMutationOptions = Apollo.BaseMutationOptions<ProductPublicationManualPublishLaunchMutation, ProductPublicationManualPublishLaunchMutationVariables>;
export const GetLessonDocument = gql`
    query GetLesson($courseId: Int!, $lessonId: Int!) {
  courseLessonFindOne(courseId: $courseId, lessonId: $lessonId) {
    ...LessonManageFragment
  }
}
    ${LessonManageFragmentFragmentDoc}`;
export type GetLessonQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLessonQuery, GetLessonQueryVariables>, 'query'> & ({ variables: GetLessonQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetLessonQuery = (props: GetLessonQueryProps) => (
      <ApolloReactComponents.Query<GetLessonQuery, GetLessonQueryVariables> query={GetLessonDocument} {...props} />
    );


/**
 * __useGetLessonQuery__
 *
 * To run a query within a React component, call `useGetLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonQuery(baseOptions: Apollo.QueryHookOptions<GetLessonQuery, GetLessonQueryVariables> & ({ variables: GetLessonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonQuery, GetLessonQueryVariables>(GetLessonDocument, options);
      }
export function useGetLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonQuery, GetLessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonQuery, GetLessonQueryVariables>(GetLessonDocument, options);
        }
export function useGetLessonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLessonQuery, GetLessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonQuery, GetLessonQueryVariables>(GetLessonDocument, options);
        }
export type GetLessonQueryHookResult = ReturnType<typeof useGetLessonQuery>;
export type GetLessonLazyQueryHookResult = ReturnType<typeof useGetLessonLazyQuery>;
export type GetLessonSuspenseQueryHookResult = ReturnType<typeof useGetLessonSuspenseQuery>;
export type GetLessonQueryResult = Apollo.QueryResult<GetLessonQuery, GetLessonQueryVariables>;
export const CourseLessonPracticeFindOneDocument = gql`
    query CourseLessonPracticeFindOne($courseId: Int!, $lessonId: Int!) {
  courseLessonPracticeFindOne(courseId: $courseId, lessonId: $lessonId) {
    id
    ...LessonPracticeFragment
  }
}
    ${LessonPracticeFragmentFragmentDoc}`;
export type CourseLessonPracticeFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>, 'query'> & ({ variables: CourseLessonPracticeFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonPracticeFindOneQuery = (props: CourseLessonPracticeFindOneQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables> query={CourseLessonPracticeFindOneDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeFindOneQuery__
 *
 * To run a query within a React component, call `useCourseLessonPracticeFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonPracticeFindOneQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonPracticeFindOneQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables> & ({ variables: CourseLessonPracticeFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>(CourseLessonPracticeFindOneDocument, options);
      }
export function useCourseLessonPracticeFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>(CourseLessonPracticeFindOneDocument, options);
        }
export function useCourseLessonPracticeFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>(CourseLessonPracticeFindOneDocument, options);
        }
export type CourseLessonPracticeFindOneQueryHookResult = ReturnType<typeof useCourseLessonPracticeFindOneQuery>;
export type CourseLessonPracticeFindOneLazyQueryHookResult = ReturnType<typeof useCourseLessonPracticeFindOneLazyQuery>;
export type CourseLessonPracticeFindOneSuspenseQueryHookResult = ReturnType<typeof useCourseLessonPracticeFindOneSuspenseQuery>;
export type CourseLessonPracticeFindOneQueryResult = Apollo.QueryResult<CourseLessonPracticeFindOneQuery, CourseLessonPracticeFindOneQueryVariables>;
export const CourseLessonPracticeManageFindOneDocument = gql`
    query CourseLessonPracticeManageFindOne($courseId: Int!, $lessonId: Int!) {
  courseLessonPracticeFindOne(courseId: $courseId, lessonId: $lessonId) {
    ...LessonPracticeFragment
  }
}
    ${LessonPracticeFragmentFragmentDoc}`;
export type CourseLessonPracticeManageFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>, 'query'> & ({ variables: CourseLessonPracticeManageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonPracticeManageFindOneQuery = (props: CourseLessonPracticeManageFindOneQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables> query={CourseLessonPracticeManageFindOneDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeManageFindOneQuery__
 *
 * To run a query within a React component, call `useCourseLessonPracticeManageFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeManageFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonPracticeManageFindOneQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonPracticeManageFindOneQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables> & ({ variables: CourseLessonPracticeManageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>(CourseLessonPracticeManageFindOneDocument, options);
      }
export function useCourseLessonPracticeManageFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>(CourseLessonPracticeManageFindOneDocument, options);
        }
export function useCourseLessonPracticeManageFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>(CourseLessonPracticeManageFindOneDocument, options);
        }
export type CourseLessonPracticeManageFindOneQueryHookResult = ReturnType<typeof useCourseLessonPracticeManageFindOneQuery>;
export type CourseLessonPracticeManageFindOneLazyQueryHookResult = ReturnType<typeof useCourseLessonPracticeManageFindOneLazyQuery>;
export type CourseLessonPracticeManageFindOneSuspenseQueryHookResult = ReturnType<typeof useCourseLessonPracticeManageFindOneSuspenseQuery>;
export type CourseLessonPracticeManageFindOneQueryResult = Apollo.QueryResult<CourseLessonPracticeManageFindOneQuery, CourseLessonPracticeManageFindOneQueryVariables>;
export const CourseLessonManageCreateDocument = gql`
    mutation CourseLessonManageCreate($courseId: Int!, $lesson: CreateLessonCourseInput!) {
  courseLessonManageCreate(courseId: $courseId, lesson: $lesson) {
    ...LessonManageFragment
    ...LessonListItemFragment
  }
}
    ${LessonManageFragmentFragmentDoc}
${LessonListItemFragmentFragmentDoc}`;
export type CourseLessonManageCreateMutationFn = Apollo.MutationFunction<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables>;
export type CourseLessonManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables>, 'mutation'>;

    export const CourseLessonManageCreateQuery = (props: CourseLessonManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables> mutation={CourseLessonManageCreateDocument} {...props} />
    );


/**
 * __useCourseLessonManageCreateMutation__
 *
 * To run a mutation, you first call `useCourseLessonManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonManageCreateMutation, { data, loading, error }] = useCourseLessonManageCreateMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      lesson: // value for 'lesson'
 *   },
 * });
 */
export function useCourseLessonManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables>(CourseLessonManageCreateDocument, options);
      }
export type CourseLessonManageCreateMutationHookResult = ReturnType<typeof useCourseLessonManageCreateMutation>;
export type CourseLessonManageCreateMutationResult = Apollo.MutationResult<CourseLessonManageCreateMutation>;
export type CourseLessonManageCreateMutationOptions = Apollo.BaseMutationOptions<CourseLessonManageCreateMutation, CourseLessonManageCreateMutationVariables>;
export const CourseLessonManageCloneDocument = gql`
    mutation CourseLessonManageClone($lessonId: Int!, $sourceCourseId: Int!, $targetCourseId: Int) {
  courseLessonManageClone(
    lessonId: $lessonId
    sourceCourseId: $sourceCourseId
    targetCourseId: $targetCourseId
  ) {
    ...LessonManageFragment
    ...LessonListItemFragment
  }
}
    ${LessonManageFragmentFragmentDoc}
${LessonListItemFragmentFragmentDoc}`;
export type CourseLessonManageCloneMutationFn = Apollo.MutationFunction<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables>;
export type CourseLessonManageCloneQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables>, 'mutation'>;

    export const CourseLessonManageCloneQuery = (props: CourseLessonManageCloneQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables> mutation={CourseLessonManageCloneDocument} {...props} />
    );


/**
 * __useCourseLessonManageCloneMutation__
 *
 * To run a mutation, you first call `useCourseLessonManageCloneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonManageCloneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonManageCloneMutation, { data, loading, error }] = useCourseLessonManageCloneMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      sourceCourseId: // value for 'sourceCourseId'
 *      targetCourseId: // value for 'targetCourseId'
 *   },
 * });
 */
export function useCourseLessonManageCloneMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables>(CourseLessonManageCloneDocument, options);
      }
export type CourseLessonManageCloneMutationHookResult = ReturnType<typeof useCourseLessonManageCloneMutation>;
export type CourseLessonManageCloneMutationResult = Apollo.MutationResult<CourseLessonManageCloneMutation>;
export type CourseLessonManageCloneMutationOptions = Apollo.BaseMutationOptions<CourseLessonManageCloneMutation, CourseLessonManageCloneMutationVariables>;
export const CourseLessonManageUpdateDocument = gql`
    mutation CourseLessonManageUpdate($lessonId: Int!, $lesson: UpdateLessonCourseInput!) {
  courseLessonManageUpdate(lessonId: $lessonId, lesson: $lesson) {
    ...LessonManageFragment
  }
}
    ${LessonManageFragmentFragmentDoc}`;
export type CourseLessonManageUpdateMutationFn = Apollo.MutationFunction<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables>;
export type CourseLessonManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables>, 'mutation'>;

    export const CourseLessonManageUpdateQuery = (props: CourseLessonManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables> mutation={CourseLessonManageUpdateDocument} {...props} />
    );


/**
 * __useCourseLessonManageUpdateMutation__
 *
 * To run a mutation, you first call `useCourseLessonManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonManageUpdateMutation, { data, loading, error }] = useCourseLessonManageUpdateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      lesson: // value for 'lesson'
 *   },
 * });
 */
export function useCourseLessonManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables>(CourseLessonManageUpdateDocument, options);
      }
export type CourseLessonManageUpdateMutationHookResult = ReturnType<typeof useCourseLessonManageUpdateMutation>;
export type CourseLessonManageUpdateMutationResult = Apollo.MutationResult<CourseLessonManageUpdateMutation>;
export type CourseLessonManageUpdateMutationOptions = Apollo.BaseMutationOptions<CourseLessonManageUpdateMutation, CourseLessonManageUpdateMutationVariables>;
export const CourseLessonManageDeleteDocument = gql`
    mutation CourseLessonManageDelete($lessonId: Int!) {
  courseLessonManageDelete(lessonId: $lessonId)
}
    `;
export type CourseLessonManageDeleteMutationFn = Apollo.MutationFunction<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables>;
export type CourseLessonManageDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables>, 'mutation'>;

    export const CourseLessonManageDeleteQuery = (props: CourseLessonManageDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables> mutation={CourseLessonManageDeleteDocument} {...props} />
    );


/**
 * __useCourseLessonManageDeleteMutation__
 *
 * To run a mutation, you first call `useCourseLessonManageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonManageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonManageDeleteMutation, { data, loading, error }] = useCourseLessonManageDeleteMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCourseLessonManageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables>(CourseLessonManageDeleteDocument, options);
      }
export type CourseLessonManageDeleteMutationHookResult = ReturnType<typeof useCourseLessonManageDeleteMutation>;
export type CourseLessonManageDeleteMutationResult = Apollo.MutationResult<CourseLessonManageDeleteMutation>;
export type CourseLessonManageDeleteMutationOptions = Apollo.BaseMutationOptions<CourseLessonManageDeleteMutation, CourseLessonManageDeleteMutationVariables>;
export const CourseLessonPracticeManageCreateDocument = gql`
    mutation CourseLessonPracticeManageCreate($lessonId: Int!, $practice: CreateLessonPracticeCourseInput!) {
  courseLessonPracticeManageCreate(lessonId: $lessonId, practice: $practice) {
    ...LessonPracticeFragment
  }
}
    ${LessonPracticeFragmentFragmentDoc}`;
export type CourseLessonPracticeManageCreateMutationFn = Apollo.MutationFunction<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables>;
export type CourseLessonPracticeManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeManageCreateQuery = (props: CourseLessonPracticeManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables> mutation={CourseLessonPracticeManageCreateDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeManageCreateMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeManageCreateMutation, { data, loading, error }] = useCourseLessonPracticeManageCreateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      practice: // value for 'practice'
 *   },
 * });
 */
export function useCourseLessonPracticeManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables>(CourseLessonPracticeManageCreateDocument, options);
      }
export type CourseLessonPracticeManageCreateMutationHookResult = ReturnType<typeof useCourseLessonPracticeManageCreateMutation>;
export type CourseLessonPracticeManageCreateMutationResult = Apollo.MutationResult<CourseLessonPracticeManageCreateMutation>;
export type CourseLessonPracticeManageCreateMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeManageCreateMutation, CourseLessonPracticeManageCreateMutationVariables>;
export const CourseLessonPracticeManageUpdateDocument = gql`
    mutation CourseLessonPracticeManageUpdate($lessonPracticeId: Int!, $practice: UpdateLessonPracticeCourseInput!) {
  courseLessonPracticeManageUpdate(
    lessonPracticeId: $lessonPracticeId
    practice: $practice
  ) {
    ...LessonPracticeFragment
  }
}
    ${LessonPracticeFragmentFragmentDoc}`;
export type CourseLessonPracticeManageUpdateMutationFn = Apollo.MutationFunction<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables>;
export type CourseLessonPracticeManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeManageUpdateQuery = (props: CourseLessonPracticeManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables> mutation={CourseLessonPracticeManageUpdateDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeManageUpdateMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeManageUpdateMutation, { data, loading, error }] = useCourseLessonPracticeManageUpdateMutation({
 *   variables: {
 *      lessonPracticeId: // value for 'lessonPracticeId'
 *      practice: // value for 'practice'
 *   },
 * });
 */
export function useCourseLessonPracticeManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables>(CourseLessonPracticeManageUpdateDocument, options);
      }
export type CourseLessonPracticeManageUpdateMutationHookResult = ReturnType<typeof useCourseLessonPracticeManageUpdateMutation>;
export type CourseLessonPracticeManageUpdateMutationResult = Apollo.MutationResult<CourseLessonPracticeManageUpdateMutation>;
export type CourseLessonPracticeManageUpdateMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeManageUpdateMutation, CourseLessonPracticeManageUpdateMutationVariables>;
export const CourseLessonPracticeManageUpdateTaskOrderDocument = gql`
    mutation CourseLessonPracticeManageUpdateTaskOrder($lessonId: Int!, $lessonPracticeId: Int!, $taskOrder: UpdateLessonPracticeTaskOrderCourseInput!) {
  courseLessonPracticeTaskManageUpdateOrder(
    lessonId: $lessonId
    lessonPracticeId: $lessonPracticeId
    taskOrder: $taskOrder
  ) {
    id
    order
  }
}
    `;
export type CourseLessonPracticeManageUpdateTaskOrderMutationFn = Apollo.MutationFunction<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables>;
export type CourseLessonPracticeManageUpdateTaskOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeManageUpdateTaskOrderQuery = (props: CourseLessonPracticeManageUpdateTaskOrderQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables> mutation={CourseLessonPracticeManageUpdateTaskOrderDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeManageUpdateTaskOrderMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeManageUpdateTaskOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeManageUpdateTaskOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeManageUpdateTaskOrderMutation, { data, loading, error }] = useCourseLessonPracticeManageUpdateTaskOrderMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      lessonPracticeId: // value for 'lessonPracticeId'
 *      taskOrder: // value for 'taskOrder'
 *   },
 * });
 */
export function useCourseLessonPracticeManageUpdateTaskOrderMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables>(CourseLessonPracticeManageUpdateTaskOrderDocument, options);
      }
export type CourseLessonPracticeManageUpdateTaskOrderMutationHookResult = ReturnType<typeof useCourseLessonPracticeManageUpdateTaskOrderMutation>;
export type CourseLessonPracticeManageUpdateTaskOrderMutationResult = Apollo.MutationResult<CourseLessonPracticeManageUpdateTaskOrderMutation>;
export type CourseLessonPracticeManageUpdateTaskOrderMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeManageUpdateTaskOrderMutation, CourseLessonPracticeManageUpdateTaskOrderMutationVariables>;
export const CourseLessonBlockManageCreateDocument = gql`
    mutation CourseLessonBlockManageCreate($lessonId: Int!, $contentElement: CreateElementContentInput!) {
  courseLessonBlockManageCreate(
    lessonId: $lessonId
    contentElement: $contentElement
  ) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type CourseLessonBlockManageCreateMutationFn = Apollo.MutationFunction<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables>;
export type CourseLessonBlockManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables>, 'mutation'>;

    export const CourseLessonBlockManageCreateQuery = (props: CourseLessonBlockManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables> mutation={CourseLessonBlockManageCreateDocument} {...props} />
    );


/**
 * __useCourseLessonBlockManageCreateMutation__
 *
 * To run a mutation, you first call `useCourseLessonBlockManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBlockManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonBlockManageCreateMutation, { data, loading, error }] = useCourseLessonBlockManageCreateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useCourseLessonBlockManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables>(CourseLessonBlockManageCreateDocument, options);
      }
export type CourseLessonBlockManageCreateMutationHookResult = ReturnType<typeof useCourseLessonBlockManageCreateMutation>;
export type CourseLessonBlockManageCreateMutationResult = Apollo.MutationResult<CourseLessonBlockManageCreateMutation>;
export type CourseLessonBlockManageCreateMutationOptions = Apollo.BaseMutationOptions<CourseLessonBlockManageCreateMutation, CourseLessonBlockManageCreateMutationVariables>;
export const CourseLessonBlockManageUpdateDocument = gql`
    mutation CourseLessonBlockManageUpdate($lessonId: Int!, $contentElementId: Int!, $contentElement: UpdateElementContentInput!) {
  courseLessonBlockManageUpdate(
    lessonId: $lessonId
    contentElementId: $contentElementId
    contentElement: $contentElement
  ) {
    ...ContentElementFragment
    lesson {
      id
      blocksInfo {
        ...CourseLessonBlocksInfoFragment
      }
    }
  }
}
    ${ContentElementFragmentFragmentDoc}
${CourseLessonBlocksInfoFragmentFragmentDoc}`;
export type CourseLessonBlockManageUpdateMutationFn = Apollo.MutationFunction<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables>;
export type CourseLessonBlockManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables>, 'mutation'>;

    export const CourseLessonBlockManageUpdateQuery = (props: CourseLessonBlockManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables> mutation={CourseLessonBlockManageUpdateDocument} {...props} />
    );


/**
 * __useCourseLessonBlockManageUpdateMutation__
 *
 * To run a mutation, you first call `useCourseLessonBlockManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBlockManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonBlockManageUpdateMutation, { data, loading, error }] = useCourseLessonBlockManageUpdateMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      contentElementId: // value for 'contentElementId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useCourseLessonBlockManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables>(CourseLessonBlockManageUpdateDocument, options);
      }
export type CourseLessonBlockManageUpdateMutationHookResult = ReturnType<typeof useCourseLessonBlockManageUpdateMutation>;
export type CourseLessonBlockManageUpdateMutationResult = Apollo.MutationResult<CourseLessonBlockManageUpdateMutation>;
export type CourseLessonBlockManageUpdateMutationOptions = Apollo.BaseMutationOptions<CourseLessonBlockManageUpdateMutation, CourseLessonBlockManageUpdateMutationVariables>;
export const CourseLessonBlockManageDeleteDocument = gql`
    mutation CourseLessonBlockManageDelete($lessonId: Int!, $contentElementId: Int!) {
  courseLessonBlockManageDelete(
    lessonId: $lessonId
    contentElementId: $contentElementId
  )
}
    `;
export type CourseLessonBlockManageDeleteMutationFn = Apollo.MutationFunction<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables>;
export type CourseLessonBlockManageDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables>, 'mutation'>;

    export const CourseLessonBlockManageDeleteQuery = (props: CourseLessonBlockManageDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables> mutation={CourseLessonBlockManageDeleteDocument} {...props} />
    );


/**
 * __useCourseLessonBlockManageDeleteMutation__
 *
 * To run a mutation, you first call `useCourseLessonBlockManageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBlockManageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonBlockManageDeleteMutation, { data, loading, error }] = useCourseLessonBlockManageDeleteMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useCourseLessonBlockManageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables>(CourseLessonBlockManageDeleteDocument, options);
      }
export type CourseLessonBlockManageDeleteMutationHookResult = ReturnType<typeof useCourseLessonBlockManageDeleteMutation>;
export type CourseLessonBlockManageDeleteMutationResult = Apollo.MutationResult<CourseLessonBlockManageDeleteMutation>;
export type CourseLessonBlockManageDeleteMutationOptions = Apollo.BaseMutationOptions<CourseLessonBlockManageDeleteMutation, CourseLessonBlockManageDeleteMutationVariables>;
export const CourseLessonBlockManageRecoverDocument = gql`
    mutation CourseLessonBlockManageRecover($lessonId: Int!, $contentElementId: Int!) {
  courseLessonBlockManageRecover(
    lessonId: $lessonId
    contentElementId: $contentElementId
  ) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type CourseLessonBlockManageRecoverMutationFn = Apollo.MutationFunction<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables>;
export type CourseLessonBlockManageRecoverQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables>, 'mutation'>;

    export const CourseLessonBlockManageRecoverQuery = (props: CourseLessonBlockManageRecoverQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables> mutation={CourseLessonBlockManageRecoverDocument} {...props} />
    );


/**
 * __useCourseLessonBlockManageRecoverMutation__
 *
 * To run a mutation, you first call `useCourseLessonBlockManageRecoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBlockManageRecoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonBlockManageRecoverMutation, { data, loading, error }] = useCourseLessonBlockManageRecoverMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useCourseLessonBlockManageRecoverMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables>(CourseLessonBlockManageRecoverDocument, options);
      }
export type CourseLessonBlockManageRecoverMutationHookResult = ReturnType<typeof useCourseLessonBlockManageRecoverMutation>;
export type CourseLessonBlockManageRecoverMutationResult = Apollo.MutationResult<CourseLessonBlockManageRecoverMutation>;
export type CourseLessonBlockManageRecoverMutationOptions = Apollo.BaseMutationOptions<CourseLessonBlockManageRecoverMutation, CourseLessonBlockManageRecoverMutationVariables>;
export const CourseLessonBlockManageUpdateOrderDocument = gql`
    mutation CourseLessonBlockManageUpdateOrder($lessonId: Int!, $blockOrder: UpdateLessonBlockOrderCourseInput!) {
  courseLessonBlockManageUpdateOrder(lessonId: $lessonId, blockOrder: $blockOrder) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type CourseLessonBlockManageUpdateOrderMutationFn = Apollo.MutationFunction<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables>;
export type CourseLessonBlockManageUpdateOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables>, 'mutation'>;

    export const CourseLessonBlockManageUpdateOrderQuery = (props: CourseLessonBlockManageUpdateOrderQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables> mutation={CourseLessonBlockManageUpdateOrderDocument} {...props} />
    );


/**
 * __useCourseLessonBlockManageUpdateOrderMutation__
 *
 * To run a mutation, you first call `useCourseLessonBlockManageUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonBlockManageUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonBlockManageUpdateOrderMutation, { data, loading, error }] = useCourseLessonBlockManageUpdateOrderMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      blockOrder: // value for 'blockOrder'
 *   },
 * });
 */
export function useCourseLessonBlockManageUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables>(CourseLessonBlockManageUpdateOrderDocument, options);
      }
export type CourseLessonBlockManageUpdateOrderMutationHookResult = ReturnType<typeof useCourseLessonBlockManageUpdateOrderMutation>;
export type CourseLessonBlockManageUpdateOrderMutationResult = Apollo.MutationResult<CourseLessonBlockManageUpdateOrderMutation>;
export type CourseLessonBlockManageUpdateOrderMutationOptions = Apollo.BaseMutationOptions<CourseLessonBlockManageUpdateOrderMutation, CourseLessonBlockManageUpdateOrderMutationVariables>;
export const ContentElementListenUpdateDocument = gql`
    subscription ContentElementListenUpdate($contentElementUuid: String!) {
  contentElementListenUpdate(contentElementUuid: $contentElementUuid) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type ContentElementListenUpdateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ContentElementListenUpdateSubscription, ContentElementListenUpdateSubscriptionVariables>, 'subscription'>;

    export const ContentElementListenUpdateQuery = (props: ContentElementListenUpdateQueryProps) => (
      <ApolloReactComponents.Subscription<ContentElementListenUpdateSubscription, ContentElementListenUpdateSubscriptionVariables> subscription={ContentElementListenUpdateDocument} {...props} />
    );


/**
 * __useContentElementListenUpdateSubscription__
 *
 * To run a query within a React component, call `useContentElementListenUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContentElementListenUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentElementListenUpdateSubscription({
 *   variables: {
 *      contentElementUuid: // value for 'contentElementUuid'
 *   },
 * });
 */
export function useContentElementListenUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<ContentElementListenUpdateSubscription, ContentElementListenUpdateSubscriptionVariables> & ({ variables: ContentElementListenUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ContentElementListenUpdateSubscription, ContentElementListenUpdateSubscriptionVariables>(ContentElementListenUpdateDocument, options);
      }
export type ContentElementListenUpdateSubscriptionHookResult = ReturnType<typeof useContentElementListenUpdateSubscription>;
export type ContentElementListenUpdateSubscriptionResult = Apollo.SubscriptionResult<ContentElementListenUpdateSubscription>;
export const CourseLessonPracticeTaskManageCreateDocument = gql`
    mutation CourseLessonPracticeTaskManageCreate($lessonPracticeId: Int!, $task: CreateTaskInput!) {
  courseLessonPracticeTaskManageCreate(
    lessonPracticeId: $lessonPracticeId
    task: $task
  ) {
    id
    order
    task {
      ...TaskCommonFragment
    }
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export type CourseLessonPracticeTaskManageCreateMutationFn = Apollo.MutationFunction<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables>;
export type CourseLessonPracticeTaskManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeTaskManageCreateQuery = (props: CourseLessonPracticeTaskManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables> mutation={CourseLessonPracticeTaskManageCreateDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeTaskManageCreateMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeTaskManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeTaskManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeTaskManageCreateMutation, { data, loading, error }] = useCourseLessonPracticeTaskManageCreateMutation({
 *   variables: {
 *      lessonPracticeId: // value for 'lessonPracticeId'
 *      task: // value for 'task'
 *   },
 * });
 */
export function useCourseLessonPracticeTaskManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables>(CourseLessonPracticeTaskManageCreateDocument, options);
      }
export type CourseLessonPracticeTaskManageCreateMutationHookResult = ReturnType<typeof useCourseLessonPracticeTaskManageCreateMutation>;
export type CourseLessonPracticeTaskManageCreateMutationResult = Apollo.MutationResult<CourseLessonPracticeTaskManageCreateMutation>;
export type CourseLessonPracticeTaskManageCreateMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeTaskManageCreateMutation, CourseLessonPracticeTaskManageCreateMutationVariables>;
export const CourseLessonPracticeTaskManageDeleteDocument = gql`
    mutation CourseLessonPracticeTaskManageDelete($practiceTaskId: Int!) {
  courseLessonPracticeTaskManageDelete(practiceTaskId: $practiceTaskId)
}
    `;
export type CourseLessonPracticeTaskManageDeleteMutationFn = Apollo.MutationFunction<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables>;
export type CourseLessonPracticeTaskManageDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables>, 'mutation'>;

    export const CourseLessonPracticeTaskManageDeleteQuery = (props: CourseLessonPracticeTaskManageDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables> mutation={CourseLessonPracticeTaskManageDeleteDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeTaskManageDeleteMutation__
 *
 * To run a mutation, you first call `useCourseLessonPracticeTaskManageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeTaskManageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseLessonPracticeTaskManageDeleteMutation, { data, loading, error }] = useCourseLessonPracticeTaskManageDeleteMutation({
 *   variables: {
 *      practiceTaskId: // value for 'practiceTaskId'
 *   },
 * });
 */
export function useCourseLessonPracticeTaskManageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables>(CourseLessonPracticeTaskManageDeleteDocument, options);
      }
export type CourseLessonPracticeTaskManageDeleteMutationHookResult = ReturnType<typeof useCourseLessonPracticeTaskManageDeleteMutation>;
export type CourseLessonPracticeTaskManageDeleteMutationResult = Apollo.MutationResult<CourseLessonPracticeTaskManageDeleteMutation>;
export type CourseLessonPracticeTaskManageDeleteMutationOptions = Apollo.BaseMutationOptions<CourseLessonPracticeTaskManageDeleteMutation, CourseLessonPracticeTaskManageDeleteMutationVariables>;
export const CourseFindManyManageDocument = gql`
    query CourseFindManyManage($list: ListInput!, $filter: FilterCourseInput!, $sort: SortCourseInput) {
  courseFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...CourseManageFragment
    }
  }
}
    ${CourseManageFragmentFragmentDoc}`;
export type CourseFindManyManageQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>, 'query'> & ({ variables: CourseFindManyManageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseFindManyManageQuery = (props: CourseFindManyManageQueryProps) => (
      <ApolloReactComponents.Query<CourseFindManyManageQuery, CourseFindManyManageQueryVariables> query={CourseFindManyManageDocument} {...props} />
    );


/**
 * __useCourseFindManyManageQuery__
 *
 * To run a query within a React component, call `useCourseFindManyManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindManyManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindManyManageQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseFindManyManageQuery(baseOptions: Apollo.QueryHookOptions<CourseFindManyManageQuery, CourseFindManyManageQueryVariables> & ({ variables: CourseFindManyManageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>(CourseFindManyManageDocument, options);
      }
export function useCourseFindManyManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>(CourseFindManyManageDocument, options);
        }
export function useCourseFindManyManageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>(CourseFindManyManageDocument, options);
        }
export type CourseFindManyManageQueryHookResult = ReturnType<typeof useCourseFindManyManageQuery>;
export type CourseFindManyManageLazyQueryHookResult = ReturnType<typeof useCourseFindManyManageLazyQuery>;
export type CourseFindManyManageSuspenseQueryHookResult = ReturnType<typeof useCourseFindManyManageSuspenseQuery>;
export type CourseFindManyManageQueryResult = Apollo.QueryResult<CourseFindManyManageQuery, CourseFindManyManageQueryVariables>;
export const GetCoursesManageDocument = gql`
    query GetCoursesManage($list: ListInput!, $filter: FilterCourseInput!, $sort: SortCourseInput) {
  courseFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    items {
      ...CourseFragment
    }
  }
}
    ${CourseFragmentFragmentDoc}`;
export type GetCoursesManageQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCoursesManageQuery, GetCoursesManageQueryVariables>, 'query'> & ({ variables: GetCoursesManageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCoursesManageQuery = (props: GetCoursesManageQueryProps) => (
      <ApolloReactComponents.Query<GetCoursesManageQuery, GetCoursesManageQueryVariables> query={GetCoursesManageDocument} {...props} />
    );


/**
 * __useGetCoursesManageQuery__
 *
 * To run a query within a React component, call `useGetCoursesManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesManageQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCoursesManageQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesManageQuery, GetCoursesManageQueryVariables> & ({ variables: GetCoursesManageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesManageQuery, GetCoursesManageQueryVariables>(GetCoursesManageDocument, options);
      }
export function useGetCoursesManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesManageQuery, GetCoursesManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesManageQuery, GetCoursesManageQueryVariables>(GetCoursesManageDocument, options);
        }
export function useGetCoursesManageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesManageQuery, GetCoursesManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesManageQuery, GetCoursesManageQueryVariables>(GetCoursesManageDocument, options);
        }
export type GetCoursesManageQueryHookResult = ReturnType<typeof useGetCoursesManageQuery>;
export type GetCoursesManageLazyQueryHookResult = ReturnType<typeof useGetCoursesManageLazyQuery>;
export type GetCoursesManageSuspenseQueryHookResult = ReturnType<typeof useGetCoursesManageSuspenseQuery>;
export type GetCoursesManageQueryResult = Apollo.QueryResult<GetCoursesManageQuery, GetCoursesManageQueryVariables>;
export const CourseCountByTypeDocument = gql`
    query CourseCountByType($mode: CountByTypeMode!, $filter: FilterCourseInput!) {
  courseCountByType(mode: $mode, filter: $filter) {
    totalCount
    VideoCourse
    TextCourse
    MasterClass
    Webinar
    PersonalLesson
  }
}
    `;
export type CourseCountByTypeQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>, 'query'> & ({ variables: CourseCountByTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseCountByTypeQuery = (props: CourseCountByTypeQueryProps) => (
      <ApolloReactComponents.Query<CourseCountByTypeQuery, CourseCountByTypeQueryVariables> query={CourseCountByTypeDocument} {...props} />
    );


/**
 * __useCourseCountByTypeQuery__
 *
 * To run a query within a React component, call `useCourseCountByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCountByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCountByTypeQuery({
 *   variables: {
 *      mode: // value for 'mode'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCourseCountByTypeQuery(baseOptions: Apollo.QueryHookOptions<CourseCountByTypeQuery, CourseCountByTypeQueryVariables> & ({ variables: CourseCountByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>(CourseCountByTypeDocument, options);
      }
export function useCourseCountByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>(CourseCountByTypeDocument, options);
        }
export function useCourseCountByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>(CourseCountByTypeDocument, options);
        }
export type CourseCountByTypeQueryHookResult = ReturnType<typeof useCourseCountByTypeQuery>;
export type CourseCountByTypeLazyQueryHookResult = ReturnType<typeof useCourseCountByTypeLazyQuery>;
export type CourseCountByTypeSuspenseQueryHookResult = ReturnType<typeof useCourseCountByTypeSuspenseQuery>;
export type CourseCountByTypeQueryResult = Apollo.QueryResult<CourseCountByTypeQuery, CourseCountByTypeQueryVariables>;
export const CourseCheckLaunchPublicationDocument = gql`
    query CourseCheckLaunchPublication($courseId: Int!, $launchId: Int!) {
  courseCheckLaunchPublication(courseId: $courseId, launchId: $launchId) {
    available
    details {
      valid
      name {
        ...CoursePublicationCheckItemFragment
      }
      description {
        ...CoursePublicationCheckItemFragment
      }
      tags {
        ...CoursePublicationCheckItemFragment
      }
      categories {
        ...CoursePublicationCheckItemFragment
      }
    }
    branding {
      valid
      image {
        ...CoursePublicationCheckItemFragment
      }
    }
    authors {
      valid {
        ...CoursePublicationCheckItemFragment
      }
      authors {
        ...CoursePublicationCheckItemFragment
      }
    }
    content {
      valid {
        ...CoursePublicationCheckItemFragment
      }
      lessons {
        ...CoursePublicationCheckItemFragment
      }
    }
    pricing {
      valid {
        ...CoursePublicationCheckItemFragment
      }
      prices {
        ...CoursePublicationCheckItemFragment
      }
    }
    date {
      valid
      saleDates {
        ...CoursePublicationCheckItemFragment
      }
      educationDates {
        ...CoursePublicationCheckItemFragment
      }
    }
  }
  courseFindOne(courseId: $courseId) {
    ...CourseFragment
  }
  productLaunchFindOne(launchId: $launchId) {
    ...LaunchFragment
  }
}
    ${CoursePublicationCheckItemFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${LaunchFragmentFragmentDoc}`;
export type CourseCheckLaunchPublicationQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>, 'query'> & ({ variables: CourseCheckLaunchPublicationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseCheckLaunchPublicationQuery = (props: CourseCheckLaunchPublicationQueryProps) => (
      <ApolloReactComponents.Query<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables> query={CourseCheckLaunchPublicationDocument} {...props} />
    );


/**
 * __useCourseCheckLaunchPublicationQuery__
 *
 * To run a query within a React component, call `useCourseCheckLaunchPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCheckLaunchPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCheckLaunchPublicationQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      launchId: // value for 'launchId'
 *   },
 * });
 */
export function useCourseCheckLaunchPublicationQuery(baseOptions: Apollo.QueryHookOptions<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables> & ({ variables: CourseCheckLaunchPublicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>(CourseCheckLaunchPublicationDocument, options);
      }
export function useCourseCheckLaunchPublicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>(CourseCheckLaunchPublicationDocument, options);
        }
export function useCourseCheckLaunchPublicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>(CourseCheckLaunchPublicationDocument, options);
        }
export type CourseCheckLaunchPublicationQueryHookResult = ReturnType<typeof useCourseCheckLaunchPublicationQuery>;
export type CourseCheckLaunchPublicationLazyQueryHookResult = ReturnType<typeof useCourseCheckLaunchPublicationLazyQuery>;
export type CourseCheckLaunchPublicationSuspenseQueryHookResult = ReturnType<typeof useCourseCheckLaunchPublicationSuspenseQuery>;
export type CourseCheckLaunchPublicationQueryResult = Apollo.QueryResult<CourseCheckLaunchPublicationQuery, CourseCheckLaunchPublicationQueryVariables>;
export const ProductManageUpsertReviewTicketDocument = gql`
    mutation ProductManageUpsertReviewTicket($productId: Int!) {
  productManageUpsertReviewTicket(productId: $productId) {
    id
    chat {
      id
    }
  }
}
    `;
export type ProductManageUpsertReviewTicketMutationFn = Apollo.MutationFunction<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables>;
export type ProductManageUpsertReviewTicketQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables>, 'mutation'>;

    export const ProductManageUpsertReviewTicketQuery = (props: ProductManageUpsertReviewTicketQueryProps) => (
      <ApolloReactComponents.Mutation<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables> mutation={ProductManageUpsertReviewTicketDocument} {...props} />
    );


/**
 * __useProductManageUpsertReviewTicketMutation__
 *
 * To run a mutation, you first call `useProductManageUpsertReviewTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductManageUpsertReviewTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productManageUpsertReviewTicketMutation, { data, loading, error }] = useProductManageUpsertReviewTicketMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductManageUpsertReviewTicketMutation(baseOptions?: Apollo.MutationHookOptions<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables>(ProductManageUpsertReviewTicketDocument, options);
      }
export type ProductManageUpsertReviewTicketMutationHookResult = ReturnType<typeof useProductManageUpsertReviewTicketMutation>;
export type ProductManageUpsertReviewTicketMutationResult = Apollo.MutationResult<ProductManageUpsertReviewTicketMutation>;
export type ProductManageUpsertReviewTicketMutationOptions = Apollo.BaseMutationOptions<ProductManageUpsertReviewTicketMutation, ProductManageUpsertReviewTicketMutationVariables>;
export const ProductPublicationReviewLaunchDocument = gql`
    mutation ProductPublicationReviewLaunch($launchId: Int!, $review: ReviewLaunchProductInput!) {
  productPublicationReviewLaunch(launchId: $launchId, review: $review) {
    id
    status
  }
}
    `;
export type ProductPublicationReviewLaunchMutationFn = Apollo.MutationFunction<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables>;
export type ProductPublicationReviewLaunchQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables>, 'mutation'>;

    export const ProductPublicationReviewLaunchQuery = (props: ProductPublicationReviewLaunchQueryProps) => (
      <ApolloReactComponents.Mutation<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables> mutation={ProductPublicationReviewLaunchDocument} {...props} />
    );


/**
 * __useProductPublicationReviewLaunchMutation__
 *
 * To run a mutation, you first call `useProductPublicationReviewLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductPublicationReviewLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productPublicationReviewLaunchMutation, { data, loading, error }] = useProductPublicationReviewLaunchMutation({
 *   variables: {
 *      launchId: // value for 'launchId'
 *      review: // value for 'review'
 *   },
 * });
 */
export function useProductPublicationReviewLaunchMutation(baseOptions?: Apollo.MutationHookOptions<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables>(ProductPublicationReviewLaunchDocument, options);
      }
export type ProductPublicationReviewLaunchMutationHookResult = ReturnType<typeof useProductPublicationReviewLaunchMutation>;
export type ProductPublicationReviewLaunchMutationResult = Apollo.MutationResult<ProductPublicationReviewLaunchMutation>;
export type ProductPublicationReviewLaunchMutationOptions = Apollo.BaseMutationOptions<ProductPublicationReviewLaunchMutation, ProductPublicationReviewLaunchMutationVariables>;
export const GroupFindOneDocument = gql`
    query GroupFindOne($groupId: Int!) {
  groupFindOne(groupId: $groupId) {
    ...GroupFragment
    product {
      id
      course {
        id
        name
        type
        image {
          main
        }
      }
    }
  }
}
    ${GroupFragmentFragmentDoc}`;
export type GroupFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupFindOneQuery, GroupFindOneQueryVariables>, 'query'> & ({ variables: GroupFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupFindOneQuery = (props: GroupFindOneQueryProps) => (
      <ApolloReactComponents.Query<GroupFindOneQuery, GroupFindOneQueryVariables> query={GroupFindOneDocument} {...props} />
    );


/**
 * __useGroupFindOneQuery__
 *
 * To run a query within a React component, call `useGroupFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFindOneQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupFindOneQuery(baseOptions: Apollo.QueryHookOptions<GroupFindOneQuery, GroupFindOneQueryVariables> & ({ variables: GroupFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFindOneQuery, GroupFindOneQueryVariables>(GroupFindOneDocument, options);
      }
export function useGroupFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFindOneQuery, GroupFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFindOneQuery, GroupFindOneQueryVariables>(GroupFindOneDocument, options);
        }
export function useGroupFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupFindOneQuery, GroupFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFindOneQuery, GroupFindOneQueryVariables>(GroupFindOneDocument, options);
        }
export type GroupFindOneQueryHookResult = ReturnType<typeof useGroupFindOneQuery>;
export type GroupFindOneLazyQueryHookResult = ReturnType<typeof useGroupFindOneLazyQuery>;
export type GroupFindOneSuspenseQueryHookResult = ReturnType<typeof useGroupFindOneSuspenseQuery>;
export type GroupFindOneQueryResult = Apollo.QueryResult<GroupFindOneQuery, GroupFindOneQueryVariables>;
export const GroupFindManyDocument = gql`
    query GroupFindMany($list: ListInput!, $filter: FilterGroupInput!, $sort: BaseSortInput) {
  groupFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    count
    pages
    items {
      ...GroupFragment
    }
  }
}
    ${GroupFragmentFragmentDoc}`;
export type GroupFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupFindManyQuery, GroupFindManyQueryVariables>, 'query'> & ({ variables: GroupFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupFindManyQuery = (props: GroupFindManyQueryProps) => (
      <ApolloReactComponents.Query<GroupFindManyQuery, GroupFindManyQueryVariables> query={GroupFindManyDocument} {...props} />
    );


/**
 * __useGroupFindManyQuery__
 *
 * To run a query within a React component, call `useGroupFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGroupFindManyQuery(baseOptions: Apollo.QueryHookOptions<GroupFindManyQuery, GroupFindManyQueryVariables> & ({ variables: GroupFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFindManyQuery, GroupFindManyQueryVariables>(GroupFindManyDocument, options);
      }
export function useGroupFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFindManyQuery, GroupFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFindManyQuery, GroupFindManyQueryVariables>(GroupFindManyDocument, options);
        }
export function useGroupFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupFindManyQuery, GroupFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFindManyQuery, GroupFindManyQueryVariables>(GroupFindManyDocument, options);
        }
export type GroupFindManyQueryHookResult = ReturnType<typeof useGroupFindManyQuery>;
export type GroupFindManyLazyQueryHookResult = ReturnType<typeof useGroupFindManyLazyQuery>;
export type GroupFindManySuspenseQueryHookResult = ReturnType<typeof useGroupFindManySuspenseQuery>;
export type GroupFindManyQueryResult = Apollo.QueryResult<GroupFindManyQuery, GroupFindManyQueryVariables>;
export const GroupManageCreateDocument = gql`
    mutation GroupManageCreate($group: CreateGroupInput!) {
  groupManageCreate(group: $group) {
    ...GroupFragment
  }
}
    ${GroupFragmentFragmentDoc}`;
export type GroupManageCreateMutationFn = Apollo.MutationFunction<GroupManageCreateMutation, GroupManageCreateMutationVariables>;
export type GroupManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<GroupManageCreateMutation, GroupManageCreateMutationVariables>, 'mutation'>;

    export const GroupManageCreateQuery = (props: GroupManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<GroupManageCreateMutation, GroupManageCreateMutationVariables> mutation={GroupManageCreateDocument} {...props} />
    );


/**
 * __useGroupManageCreateMutation__
 *
 * To run a mutation, you first call `useGroupManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupManageCreateMutation, { data, loading, error }] = useGroupManageCreateMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGroupManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<GroupManageCreateMutation, GroupManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupManageCreateMutation, GroupManageCreateMutationVariables>(GroupManageCreateDocument, options);
      }
export type GroupManageCreateMutationHookResult = ReturnType<typeof useGroupManageCreateMutation>;
export type GroupManageCreateMutationResult = Apollo.MutationResult<GroupManageCreateMutation>;
export type GroupManageCreateMutationOptions = Apollo.BaseMutationOptions<GroupManageCreateMutation, GroupManageCreateMutationVariables>;
export const GroupManageUpdateDocument = gql`
    mutation GroupManageUpdate($groupId: Int!, $group: UpdateGroupInput!) {
  groupManageUpdate(groupId: $groupId, group: $group) {
    ...GroupFragment
  }
}
    ${GroupFragmentFragmentDoc}`;
export type GroupManageUpdateMutationFn = Apollo.MutationFunction<GroupManageUpdateMutation, GroupManageUpdateMutationVariables>;
export type GroupManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<GroupManageUpdateMutation, GroupManageUpdateMutationVariables>, 'mutation'>;

    export const GroupManageUpdateQuery = (props: GroupManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<GroupManageUpdateMutation, GroupManageUpdateMutationVariables> mutation={GroupManageUpdateDocument} {...props} />
    );


/**
 * __useGroupManageUpdateMutation__
 *
 * To run a mutation, you first call `useGroupManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupManageUpdateMutation, { data, loading, error }] = useGroupManageUpdateMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGroupManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GroupManageUpdateMutation, GroupManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupManageUpdateMutation, GroupManageUpdateMutationVariables>(GroupManageUpdateDocument, options);
      }
export type GroupManageUpdateMutationHookResult = ReturnType<typeof useGroupManageUpdateMutation>;
export type GroupManageUpdateMutationResult = Apollo.MutationResult<GroupManageUpdateMutation>;
export type GroupManageUpdateMutationOptions = Apollo.BaseMutationOptions<GroupManageUpdateMutation, GroupManageUpdateMutationVariables>;
export const GroupMemberFindManyDocument = gql`
    query GroupMemberFindMany($list: ListInput!, $filter: FilterMemberGroupInput!, $sort: BaseSortInput) {
  groupMemberFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...GroupMemberFragment
    }
  }
}
    ${GroupMemberFragmentFragmentDoc}`;
export type GroupMemberFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>, 'query'> & ({ variables: GroupMemberFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupMemberFindManyQuery = (props: GroupMemberFindManyQueryProps) => (
      <ApolloReactComponents.Query<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables> query={GroupMemberFindManyDocument} {...props} />
    );


/**
 * __useGroupMemberFindManyQuery__
 *
 * To run a query within a React component, call `useGroupMemberFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMemberFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMemberFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGroupMemberFindManyQuery(baseOptions: Apollo.QueryHookOptions<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables> & ({ variables: GroupMemberFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>(GroupMemberFindManyDocument, options);
      }
export function useGroupMemberFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>(GroupMemberFindManyDocument, options);
        }
export function useGroupMemberFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>(GroupMemberFindManyDocument, options);
        }
export type GroupMemberFindManyQueryHookResult = ReturnType<typeof useGroupMemberFindManyQuery>;
export type GroupMemberFindManyLazyQueryHookResult = ReturnType<typeof useGroupMemberFindManyLazyQuery>;
export type GroupMemberFindManySuspenseQueryHookResult = ReturnType<typeof useGroupMemberFindManySuspenseQuery>;
export type GroupMemberFindManyQueryResult = Apollo.QueryResult<GroupMemberFindManyQuery, GroupMemberFindManyQueryVariables>;
export const GroupMemberCreateManyDocument = gql`
    mutation GroupMemberCreateMany($groupId: Int!, $userIds: [Int!]!) {
  groupMemberCreateMany(groupId: $groupId, userIds: $userIds) {
    ...GroupMemberFragment
  }
}
    ${GroupMemberFragmentFragmentDoc}`;
export type GroupMemberCreateManyMutationFn = Apollo.MutationFunction<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables>;
export type GroupMemberCreateManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables>, 'mutation'>;

    export const GroupMemberCreateManyQuery = (props: GroupMemberCreateManyQueryProps) => (
      <ApolloReactComponents.Mutation<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables> mutation={GroupMemberCreateManyDocument} {...props} />
    );


/**
 * __useGroupMemberCreateManyMutation__
 *
 * To run a mutation, you first call `useGroupMemberCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupMemberCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupMemberCreateManyMutation, { data, loading, error }] = useGroupMemberCreateManyMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGroupMemberCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables>(GroupMemberCreateManyDocument, options);
      }
export type GroupMemberCreateManyMutationHookResult = ReturnType<typeof useGroupMemberCreateManyMutation>;
export type GroupMemberCreateManyMutationResult = Apollo.MutationResult<GroupMemberCreateManyMutation>;
export type GroupMemberCreateManyMutationOptions = Apollo.BaseMutationOptions<GroupMemberCreateManyMutation, GroupMemberCreateManyMutationVariables>;
export const GroupMemberDeleteManyDocument = gql`
    mutation GroupMemberDeleteMany($groupId: Int!, $userIds: [Int!]!) {
  groupMemberDeleteMany(groupId: $groupId, userIds: $userIds)
}
    `;
export type GroupMemberDeleteManyMutationFn = Apollo.MutationFunction<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables>;
export type GroupMemberDeleteManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables>, 'mutation'>;

    export const GroupMemberDeleteManyQuery = (props: GroupMemberDeleteManyQueryProps) => (
      <ApolloReactComponents.Mutation<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables> mutation={GroupMemberDeleteManyDocument} {...props} />
    );


/**
 * __useGroupMemberDeleteManyMutation__
 *
 * To run a mutation, you first call `useGroupMemberDeleteManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupMemberDeleteManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupMemberDeleteManyMutation, { data, loading, error }] = useGroupMemberDeleteManyMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGroupMemberDeleteManyMutation(baseOptions?: Apollo.MutationHookOptions<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables>(GroupMemberDeleteManyDocument, options);
      }
export type GroupMemberDeleteManyMutationHookResult = ReturnType<typeof useGroupMemberDeleteManyMutation>;
export type GroupMemberDeleteManyMutationResult = Apollo.MutationResult<GroupMemberDeleteManyMutation>;
export type GroupMemberDeleteManyMutationOptions = Apollo.BaseMutationOptions<GroupMemberDeleteManyMutation, GroupMemberDeleteManyMutationVariables>;
export const InvoiceManageFindManyDocument = gql`
    query InvoiceManageFindMany($list: ListInput!, $filter: FilterInvoiceInput!, $sort: BaseSortInput) {
  invoiceManageFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...InvoiceFragment
      actualPayment {
        id
        status
        isCompleted
        isCanceled
        paidAt
      }
      products {
        id
        product {
          id
          course {
            id
            name
            image {
              main
            }
          }
        }
      }
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceManageFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>, 'query'> & ({ variables: InvoiceManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvoiceManageFindManyQuery = (props: InvoiceManageFindManyQueryProps) => (
      <ApolloReactComponents.Query<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables> query={InvoiceManageFindManyDocument} {...props} />
    );


/**
 * __useInvoiceManageFindManyQuery__
 *
 * To run a query within a React component, call `useInvoiceManageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceManageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceManageFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInvoiceManageFindManyQuery(baseOptions: Apollo.QueryHookOptions<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables> & ({ variables: InvoiceManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>(InvoiceManageFindManyDocument, options);
      }
export function useInvoiceManageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>(InvoiceManageFindManyDocument, options);
        }
export function useInvoiceManageFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>(InvoiceManageFindManyDocument, options);
        }
export type InvoiceManageFindManyQueryHookResult = ReturnType<typeof useInvoiceManageFindManyQuery>;
export type InvoiceManageFindManyLazyQueryHookResult = ReturnType<typeof useInvoiceManageFindManyLazyQuery>;
export type InvoiceManageFindManySuspenseQueryHookResult = ReturnType<typeof useInvoiceManageFindManySuspenseQuery>;
export type InvoiceManageFindManyQueryResult = Apollo.QueryResult<InvoiceManageFindManyQuery, InvoiceManageFindManyQueryVariables>;
export const InvoiceManageFindOneByUuidDocument = gql`
    query InvoiceManageFindOneByUuid($uuid: String!) {
  invoiceManageFindOne(uuid: $uuid) {
    ...InvoiceFragment
    actualPayment {
      id
      status
      isCompleted
      isCanceled
      paidAt
      checkoutUrl
    }
    products {
      id
      totalPrice
      discountAmount
      price {
        id
        title
      }
      product {
        id
        type
        currency
        course {
          ...CourseManageFragment
          lessons {
            id
            parent {
              ...CourseLessonParentFragment
            }
          }
        }
      }
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${CourseManageFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type InvoiceManageFindOneByUuidQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>, 'query'> & ({ variables: InvoiceManageFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvoiceManageFindOneByUuidQuery = (props: InvoiceManageFindOneByUuidQueryProps) => (
      <ApolloReactComponents.Query<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables> query={InvoiceManageFindOneByUuidDocument} {...props} />
    );


/**
 * __useInvoiceManageFindOneByUuidQuery__
 *
 * To run a query within a React component, call `useInvoiceManageFindOneByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceManageFindOneByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceManageFindOneByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useInvoiceManageFindOneByUuidQuery(baseOptions: Apollo.QueryHookOptions<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables> & ({ variables: InvoiceManageFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>(InvoiceManageFindOneByUuidDocument, options);
      }
export function useInvoiceManageFindOneByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>(InvoiceManageFindOneByUuidDocument, options);
        }
export function useInvoiceManageFindOneByUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>(InvoiceManageFindOneByUuidDocument, options);
        }
export type InvoiceManageFindOneByUuidQueryHookResult = ReturnType<typeof useInvoiceManageFindOneByUuidQuery>;
export type InvoiceManageFindOneByUuidLazyQueryHookResult = ReturnType<typeof useInvoiceManageFindOneByUuidLazyQuery>;
export type InvoiceManageFindOneByUuidSuspenseQueryHookResult = ReturnType<typeof useInvoiceManageFindOneByUuidSuspenseQuery>;
export type InvoiceManageFindOneByUuidQueryResult = Apollo.QueryResult<InvoiceManageFindOneByUuidQuery, InvoiceManageFindOneByUuidQueryVariables>;
export const PaymentManageFindManyDocument = gql`
    query PaymentManageFindMany($list: ListInput!, $filter: FilterPaymentInput!, $sort: BaseSortInput) {
  paymentManageFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...PaymentFragment
    }
  }
}
    ${PaymentFragmentFragmentDoc}`;
export type PaymentManageFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>, 'query'> & ({ variables: PaymentManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentManageFindManyQuery = (props: PaymentManageFindManyQueryProps) => (
      <ApolloReactComponents.Query<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables> query={PaymentManageFindManyDocument} {...props} />
    );


/**
 * __usePaymentManageFindManyQuery__
 *
 * To run a query within a React component, call `usePaymentManageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentManageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentManageFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaymentManageFindManyQuery(baseOptions: Apollo.QueryHookOptions<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables> & ({ variables: PaymentManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>(PaymentManageFindManyDocument, options);
      }
export function usePaymentManageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>(PaymentManageFindManyDocument, options);
        }
export function usePaymentManageFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>(PaymentManageFindManyDocument, options);
        }
export type PaymentManageFindManyQueryHookResult = ReturnType<typeof usePaymentManageFindManyQuery>;
export type PaymentManageFindManyLazyQueryHookResult = ReturnType<typeof usePaymentManageFindManyLazyQuery>;
export type PaymentManageFindManySuspenseQueryHookResult = ReturnType<typeof usePaymentManageFindManySuspenseQuery>;
export type PaymentManageFindManyQueryResult = Apollo.QueryResult<PaymentManageFindManyQuery, PaymentManageFindManyQueryVariables>;
export const PayoutFindOneDetailDocument = gql`
    query PayoutFindOneDetail {
  payoutRequisiteFindOneActive {
    ...PayoutRequisiteFragment
  }
  sellerCurrentUserSeller {
    id
    verified
  }
}
    ${PayoutRequisiteFragmentFragmentDoc}`;
export type PayoutFindOneDetailQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>, 'query'>;

    export const PayoutFindOneDetailQuery = (props: PayoutFindOneDetailQueryProps) => (
      <ApolloReactComponents.Query<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables> query={PayoutFindOneDetailDocument} {...props} />
    );


/**
 * __usePayoutFindOneDetailQuery__
 *
 * To run a query within a React component, call `usePayoutFindOneDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutFindOneDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutFindOneDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoutFindOneDetailQuery(baseOptions?: Apollo.QueryHookOptions<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>(PayoutFindOneDetailDocument, options);
      }
export function usePayoutFindOneDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>(PayoutFindOneDetailDocument, options);
        }
export function usePayoutFindOneDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>(PayoutFindOneDetailDocument, options);
        }
export type PayoutFindOneDetailQueryHookResult = ReturnType<typeof usePayoutFindOneDetailQuery>;
export type PayoutFindOneDetailLazyQueryHookResult = ReturnType<typeof usePayoutFindOneDetailLazyQuery>;
export type PayoutFindOneDetailSuspenseQueryHookResult = ReturnType<typeof usePayoutFindOneDetailSuspenseQuery>;
export type PayoutFindOneDetailQueryResult = Apollo.QueryResult<PayoutFindOneDetailQuery, PayoutFindOneDetailQueryVariables>;
export const PayoutRequisiteFindOneActiveDocument = gql`
    query PayoutRequisiteFindOneActive {
  payoutRequisiteFindOneActive {
    ...PayoutRequisiteFragment
  }
  sellerBalanceCurrent {
    ...SellerCurrentBalanceFragment
  }
}
    ${PayoutRequisiteFragmentFragmentDoc}
${SellerCurrentBalanceFragmentFragmentDoc}`;
export type PayoutRequisiteFindOneActiveQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>, 'query'>;

    export const PayoutRequisiteFindOneActiveQuery = (props: PayoutRequisiteFindOneActiveQueryProps) => (
      <ApolloReactComponents.Query<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables> query={PayoutRequisiteFindOneActiveDocument} {...props} />
    );


/**
 * __usePayoutRequisiteFindOneActiveQuery__
 *
 * To run a query within a React component, call `usePayoutRequisiteFindOneActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutRequisiteFindOneActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutRequisiteFindOneActiveQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoutRequisiteFindOneActiveQuery(baseOptions?: Apollo.QueryHookOptions<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>(PayoutRequisiteFindOneActiveDocument, options);
      }
export function usePayoutRequisiteFindOneActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>(PayoutRequisiteFindOneActiveDocument, options);
        }
export function usePayoutRequisiteFindOneActiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>(PayoutRequisiteFindOneActiveDocument, options);
        }
export type PayoutRequisiteFindOneActiveQueryHookResult = ReturnType<typeof usePayoutRequisiteFindOneActiveQuery>;
export type PayoutRequisiteFindOneActiveLazyQueryHookResult = ReturnType<typeof usePayoutRequisiteFindOneActiveLazyQuery>;
export type PayoutRequisiteFindOneActiveSuspenseQueryHookResult = ReturnType<typeof usePayoutRequisiteFindOneActiveSuspenseQuery>;
export type PayoutRequisiteFindOneActiveQueryResult = Apollo.QueryResult<PayoutRequisiteFindOneActiveQuery, PayoutRequisiteFindOneActiveQueryVariables>;
export const PayoutRequisiteCreateDocument = gql`
    mutation PayoutRequisiteCreate($requisite: CreateRequisitePayoutInput!) {
  payoutRequisiteCreate(requisite: $requisite) {
    ...PayoutRequisiteFragment
  }
}
    ${PayoutRequisiteFragmentFragmentDoc}`;
export type PayoutRequisiteCreateMutationFn = Apollo.MutationFunction<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables>;
export type PayoutRequisiteCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables>, 'mutation'>;

    export const PayoutRequisiteCreateQuery = (props: PayoutRequisiteCreateQueryProps) => (
      <ApolloReactComponents.Mutation<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables> mutation={PayoutRequisiteCreateDocument} {...props} />
    );


/**
 * __usePayoutRequisiteCreateMutation__
 *
 * To run a mutation, you first call `usePayoutRequisiteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoutRequisiteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoutRequisiteCreateMutation, { data, loading, error }] = usePayoutRequisiteCreateMutation({
 *   variables: {
 *      requisite: // value for 'requisite'
 *   },
 * });
 */
export function usePayoutRequisiteCreateMutation(baseOptions?: Apollo.MutationHookOptions<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables>(PayoutRequisiteCreateDocument, options);
      }
export type PayoutRequisiteCreateMutationHookResult = ReturnType<typeof usePayoutRequisiteCreateMutation>;
export type PayoutRequisiteCreateMutationResult = Apollo.MutationResult<PayoutRequisiteCreateMutation>;
export type PayoutRequisiteCreateMutationOptions = Apollo.BaseMutationOptions<PayoutRequisiteCreateMutation, PayoutRequisiteCreateMutationVariables>;
export const PayoutOperationFindManyDocument = gql`
    query PayoutOperationFindMany($list: ListInput!, $filter: FilterOperationPayoutInput!, $sort: BaseSortInput) {
  payoutOperationFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...PayoutOperationFragment
      operations {
        id
      }
    }
  }
}
    ${PayoutOperationFragmentFragmentDoc}`;
export type PayoutOperationFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>, 'query'> & ({ variables: PayoutOperationFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PayoutOperationFindManyQuery = (props: PayoutOperationFindManyQueryProps) => (
      <ApolloReactComponents.Query<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables> query={PayoutOperationFindManyDocument} {...props} />
    );


/**
 * __usePayoutOperationFindManyQuery__
 *
 * To run a query within a React component, call `usePayoutOperationFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutOperationFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutOperationFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePayoutOperationFindManyQuery(baseOptions: Apollo.QueryHookOptions<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables> & ({ variables: PayoutOperationFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>(PayoutOperationFindManyDocument, options);
      }
export function usePayoutOperationFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>(PayoutOperationFindManyDocument, options);
        }
export function usePayoutOperationFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>(PayoutOperationFindManyDocument, options);
        }
export type PayoutOperationFindManyQueryHookResult = ReturnType<typeof usePayoutOperationFindManyQuery>;
export type PayoutOperationFindManyLazyQueryHookResult = ReturnType<typeof usePayoutOperationFindManyLazyQuery>;
export type PayoutOperationFindManySuspenseQueryHookResult = ReturnType<typeof usePayoutOperationFindManySuspenseQuery>;
export type PayoutOperationFindManyQueryResult = Apollo.QueryResult<PayoutOperationFindManyQuery, PayoutOperationFindManyQueryVariables>;
export const PayoutOperationSumAmountByFilterDocument = gql`
    query PayoutOperationSumAmountByFilter($countFilter: FilterOperationPayoutInput!, $sumFilter: FilterOperationPayoutInput!) {
  payoutOperationCountByFilter(filter: $countFilter)
  payoutOperationSumAmountByFilter(filter: $sumFilter)
  sellerBalanceCurrent {
    ...SellerCurrentBalanceFragment
  }
}
    ${SellerCurrentBalanceFragmentFragmentDoc}`;
export type PayoutOperationSumAmountByFilterQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>, 'query'> & ({ variables: PayoutOperationSumAmountByFilterQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PayoutOperationSumAmountByFilterQuery = (props: PayoutOperationSumAmountByFilterQueryProps) => (
      <ApolloReactComponents.Query<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables> query={PayoutOperationSumAmountByFilterDocument} {...props} />
    );


/**
 * __usePayoutOperationSumAmountByFilterQuery__
 *
 * To run a query within a React component, call `usePayoutOperationSumAmountByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutOperationSumAmountByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutOperationSumAmountByFilterQuery({
 *   variables: {
 *      countFilter: // value for 'countFilter'
 *      sumFilter: // value for 'sumFilter'
 *   },
 * });
 */
export function usePayoutOperationSumAmountByFilterQuery(baseOptions: Apollo.QueryHookOptions<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables> & ({ variables: PayoutOperationSumAmountByFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>(PayoutOperationSumAmountByFilterDocument, options);
      }
export function usePayoutOperationSumAmountByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>(PayoutOperationSumAmountByFilterDocument, options);
        }
export function usePayoutOperationSumAmountByFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>(PayoutOperationSumAmountByFilterDocument, options);
        }
export type PayoutOperationSumAmountByFilterQueryHookResult = ReturnType<typeof usePayoutOperationSumAmountByFilterQuery>;
export type PayoutOperationSumAmountByFilterLazyQueryHookResult = ReturnType<typeof usePayoutOperationSumAmountByFilterLazyQuery>;
export type PayoutOperationSumAmountByFilterSuspenseQueryHookResult = ReturnType<typeof usePayoutOperationSumAmountByFilterSuspenseQuery>;
export type PayoutOperationSumAmountByFilterQueryResult = Apollo.QueryResult<PayoutOperationSumAmountByFilterQuery, PayoutOperationSumAmountByFilterQueryVariables>;
export const PayoutOperationCalculateBeforePayoutDocument = gql`
    query PayoutOperationCalculateBeforePayout($operation: CreateOperationPayoutInput!) {
  payoutOperationCalculateBeforePayout(operation: $operation) {
    minAmount
    isInternal
    transferAmount
    transactionAmount
  }
}
    `;
export type PayoutOperationCalculateBeforePayoutQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>, 'query'> & ({ variables: PayoutOperationCalculateBeforePayoutQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PayoutOperationCalculateBeforePayoutQuery = (props: PayoutOperationCalculateBeforePayoutQueryProps) => (
      <ApolloReactComponents.Query<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables> query={PayoutOperationCalculateBeforePayoutDocument} {...props} />
    );


/**
 * __usePayoutOperationCalculateBeforePayoutQuery__
 *
 * To run a query within a React component, call `usePayoutOperationCalculateBeforePayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutOperationCalculateBeforePayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutOperationCalculateBeforePayoutQuery({
 *   variables: {
 *      operation: // value for 'operation'
 *   },
 * });
 */
export function usePayoutOperationCalculateBeforePayoutQuery(baseOptions: Apollo.QueryHookOptions<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables> & ({ variables: PayoutOperationCalculateBeforePayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>(PayoutOperationCalculateBeforePayoutDocument, options);
      }
export function usePayoutOperationCalculateBeforePayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>(PayoutOperationCalculateBeforePayoutDocument, options);
        }
export function usePayoutOperationCalculateBeforePayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>(PayoutOperationCalculateBeforePayoutDocument, options);
        }
export type PayoutOperationCalculateBeforePayoutQueryHookResult = ReturnType<typeof usePayoutOperationCalculateBeforePayoutQuery>;
export type PayoutOperationCalculateBeforePayoutLazyQueryHookResult = ReturnType<typeof usePayoutOperationCalculateBeforePayoutLazyQuery>;
export type PayoutOperationCalculateBeforePayoutSuspenseQueryHookResult = ReturnType<typeof usePayoutOperationCalculateBeforePayoutSuspenseQuery>;
export type PayoutOperationCalculateBeforePayoutQueryResult = Apollo.QueryResult<PayoutOperationCalculateBeforePayoutQuery, PayoutOperationCalculateBeforePayoutQueryVariables>;
export const PayoutOperationCreateDocument = gql`
    mutation PayoutOperationCreate($operation: CreateOperationPayoutInput!) {
  payoutOperationCreate(operation: $operation) {
    ...PayoutOperationFragment
  }
}
    ${PayoutOperationFragmentFragmentDoc}`;
export type PayoutOperationCreateMutationFn = Apollo.MutationFunction<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables>;
export type PayoutOperationCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables>, 'mutation'>;

    export const PayoutOperationCreateQuery = (props: PayoutOperationCreateQueryProps) => (
      <ApolloReactComponents.Mutation<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables> mutation={PayoutOperationCreateDocument} {...props} />
    );


/**
 * __usePayoutOperationCreateMutation__
 *
 * To run a mutation, you first call `usePayoutOperationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoutOperationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoutOperationCreateMutation, { data, loading, error }] = usePayoutOperationCreateMutation({
 *   variables: {
 *      operation: // value for 'operation'
 *   },
 * });
 */
export function usePayoutOperationCreateMutation(baseOptions?: Apollo.MutationHookOptions<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables>(PayoutOperationCreateDocument, options);
      }
export type PayoutOperationCreateMutationHookResult = ReturnType<typeof usePayoutOperationCreateMutation>;
export type PayoutOperationCreateMutationResult = Apollo.MutationResult<PayoutOperationCreateMutation>;
export type PayoutOperationCreateMutationOptions = Apollo.BaseMutationOptions<PayoutOperationCreateMutation, PayoutOperationCreateMutationVariables>;
export const DiscountManageFindOneDocument = gql`
    query DiscountManageFindOne($discountId: Int!) {
  discountManageFindOne(discountId: $discountId) {
    ...DiscountFragment
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountManageFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>, 'query'> & ({ variables: DiscountManageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DiscountManageFindOneQuery = (props: DiscountManageFindOneQueryProps) => (
      <ApolloReactComponents.Query<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables> query={DiscountManageFindOneDocument} {...props} />
    );


/**
 * __useDiscountManageFindOneQuery__
 *
 * To run a query within a React component, call `useDiscountManageFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountManageFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountManageFindOneQuery({
 *   variables: {
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useDiscountManageFindOneQuery(baseOptions: Apollo.QueryHookOptions<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables> & ({ variables: DiscountManageFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>(DiscountManageFindOneDocument, options);
      }
export function useDiscountManageFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>(DiscountManageFindOneDocument, options);
        }
export function useDiscountManageFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>(DiscountManageFindOneDocument, options);
        }
export type DiscountManageFindOneQueryHookResult = ReturnType<typeof useDiscountManageFindOneQuery>;
export type DiscountManageFindOneLazyQueryHookResult = ReturnType<typeof useDiscountManageFindOneLazyQuery>;
export type DiscountManageFindOneSuspenseQueryHookResult = ReturnType<typeof useDiscountManageFindOneSuspenseQuery>;
export type DiscountManageFindOneQueryResult = Apollo.QueryResult<DiscountManageFindOneQuery, DiscountManageFindOneQueryVariables>;
export const DiscountManageFindManyDocument = gql`
    query DiscountManageFindMany($list: ListInput!, $filter: FilterDiscountInput!, $sort: BaseSortInput) {
  discountManageFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...DiscountFragment
    }
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountManageFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>, 'query'> & ({ variables: DiscountManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DiscountManageFindManyQuery = (props: DiscountManageFindManyQueryProps) => (
      <ApolloReactComponents.Query<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables> query={DiscountManageFindManyDocument} {...props} />
    );


/**
 * __useDiscountManageFindManyQuery__
 *
 * To run a query within a React component, call `useDiscountManageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountManageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountManageFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDiscountManageFindManyQuery(baseOptions: Apollo.QueryHookOptions<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables> & ({ variables: DiscountManageFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>(DiscountManageFindManyDocument, options);
      }
export function useDiscountManageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>(DiscountManageFindManyDocument, options);
        }
export function useDiscountManageFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>(DiscountManageFindManyDocument, options);
        }
export type DiscountManageFindManyQueryHookResult = ReturnType<typeof useDiscountManageFindManyQuery>;
export type DiscountManageFindManyLazyQueryHookResult = ReturnType<typeof useDiscountManageFindManyLazyQuery>;
export type DiscountManageFindManySuspenseQueryHookResult = ReturnType<typeof useDiscountManageFindManySuspenseQuery>;
export type DiscountManageFindManyQueryResult = Apollo.QueryResult<DiscountManageFindManyQuery, DiscountManageFindManyQueryVariables>;
export const DiscountManageCreateDocument = gql`
    mutation DiscountManageCreate($discount: CreateDiscountInput!) {
  discountManageCreate(discount: $discount) {
    ...DiscountFragment
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountManageCreateMutationFn = Apollo.MutationFunction<DiscountManageCreateMutation, DiscountManageCreateMutationVariables>;
export type DiscountManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<DiscountManageCreateMutation, DiscountManageCreateMutationVariables>, 'mutation'>;

    export const DiscountManageCreateQuery = (props: DiscountManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<DiscountManageCreateMutation, DiscountManageCreateMutationVariables> mutation={DiscountManageCreateDocument} {...props} />
    );


/**
 * __useDiscountManageCreateMutation__
 *
 * To run a mutation, you first call `useDiscountManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountManageCreateMutation, { data, loading, error }] = useDiscountManageCreateMutation({
 *   variables: {
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useDiscountManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountManageCreateMutation, DiscountManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountManageCreateMutation, DiscountManageCreateMutationVariables>(DiscountManageCreateDocument, options);
      }
export type DiscountManageCreateMutationHookResult = ReturnType<typeof useDiscountManageCreateMutation>;
export type DiscountManageCreateMutationResult = Apollo.MutationResult<DiscountManageCreateMutation>;
export type DiscountManageCreateMutationOptions = Apollo.BaseMutationOptions<DiscountManageCreateMutation, DiscountManageCreateMutationVariables>;
export const DiscountManageUpdateDocument = gql`
    mutation DiscountManageUpdate($discountId: Int!, $discount: UpdateDiscountInput!) {
  discountManageUpdate(discountId: $discountId, discount: $discount) {
    ...DiscountFragment
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountManageUpdateMutationFn = Apollo.MutationFunction<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables>;
export type DiscountManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables>, 'mutation'>;

    export const DiscountManageUpdateQuery = (props: DiscountManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables> mutation={DiscountManageUpdateDocument} {...props} />
    );


/**
 * __useDiscountManageUpdateMutation__
 *
 * To run a mutation, you first call `useDiscountManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountManageUpdateMutation, { data, loading, error }] = useDiscountManageUpdateMutation({
 *   variables: {
 *      discountId: // value for 'discountId'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useDiscountManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables>(DiscountManageUpdateDocument, options);
      }
export type DiscountManageUpdateMutationHookResult = ReturnType<typeof useDiscountManageUpdateMutation>;
export type DiscountManageUpdateMutationResult = Apollo.MutationResult<DiscountManageUpdateMutation>;
export type DiscountManageUpdateMutationOptions = Apollo.BaseMutationOptions<DiscountManageUpdateMutation, DiscountManageUpdateMutationVariables>;
export const PaymentProviderFindOneActiveByTypeDocument = gql`
    query PaymentProviderFindOneActiveByType($paymentProviderType: PaymentProviderType!) {
  paymentProviderFindOneActiveByType(paymentProviderType: $paymentProviderType) {
    ...PaymentProviderFragment
  }
}
    ${PaymentProviderFragmentFragmentDoc}`;
export type PaymentProviderFindOneActiveByTypeQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>, 'query'> & ({ variables: PaymentProviderFindOneActiveByTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentProviderFindOneActiveByTypeQuery = (props: PaymentProviderFindOneActiveByTypeQueryProps) => (
      <ApolloReactComponents.Query<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables> query={PaymentProviderFindOneActiveByTypeDocument} {...props} />
    );


/**
 * __usePaymentProviderFindOneActiveByTypeQuery__
 *
 * To run a query within a React component, call `usePaymentProviderFindOneActiveByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProviderFindOneActiveByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentProviderFindOneActiveByTypeQuery({
 *   variables: {
 *      paymentProviderType: // value for 'paymentProviderType'
 *   },
 * });
 */
export function usePaymentProviderFindOneActiveByTypeQuery(baseOptions: Apollo.QueryHookOptions<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables> & ({ variables: PaymentProviderFindOneActiveByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>(PaymentProviderFindOneActiveByTypeDocument, options);
      }
export function usePaymentProviderFindOneActiveByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>(PaymentProviderFindOneActiveByTypeDocument, options);
        }
export function usePaymentProviderFindOneActiveByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>(PaymentProviderFindOneActiveByTypeDocument, options);
        }
export type PaymentProviderFindOneActiveByTypeQueryHookResult = ReturnType<typeof usePaymentProviderFindOneActiveByTypeQuery>;
export type PaymentProviderFindOneActiveByTypeLazyQueryHookResult = ReturnType<typeof usePaymentProviderFindOneActiveByTypeLazyQuery>;
export type PaymentProviderFindOneActiveByTypeSuspenseQueryHookResult = ReturnType<typeof usePaymentProviderFindOneActiveByTypeSuspenseQuery>;
export type PaymentProviderFindOneActiveByTypeQueryResult = Apollo.QueryResult<PaymentProviderFindOneActiveByTypeQuery, PaymentProviderFindOneActiveByTypeQueryVariables>;
export const PaymentProviderFindManyDocument = gql`
    query PaymentProviderFindMany($list: ListInput!, $filter: FilterProviderPaymentInput!, $sort: BaseSortInput) {
  paymentProviderFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...PaymentProviderFragment
    }
  }
}
    ${PaymentProviderFragmentFragmentDoc}`;
export type PaymentProviderFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>, 'query'> & ({ variables: PaymentProviderFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentProviderFindManyQuery = (props: PaymentProviderFindManyQueryProps) => (
      <ApolloReactComponents.Query<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables> query={PaymentProviderFindManyDocument} {...props} />
    );


/**
 * __usePaymentProviderFindManyQuery__
 *
 * To run a query within a React component, call `usePaymentProviderFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProviderFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentProviderFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePaymentProviderFindManyQuery(baseOptions: Apollo.QueryHookOptions<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables> & ({ variables: PaymentProviderFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>(PaymentProviderFindManyDocument, options);
      }
export function usePaymentProviderFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>(PaymentProviderFindManyDocument, options);
        }
export function usePaymentProviderFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>(PaymentProviderFindManyDocument, options);
        }
export type PaymentProviderFindManyQueryHookResult = ReturnType<typeof usePaymentProviderFindManyQuery>;
export type PaymentProviderFindManyLazyQueryHookResult = ReturnType<typeof usePaymentProviderFindManyLazyQuery>;
export type PaymentProviderFindManySuspenseQueryHookResult = ReturnType<typeof usePaymentProviderFindManySuspenseQuery>;
export type PaymentProviderFindManyQueryResult = Apollo.QueryResult<PaymentProviderFindManyQuery, PaymentProviderFindManyQueryVariables>;
export const SchoolAcquiringCreateDocument = gql`
    mutation SchoolAcquiringCreate($acquiring: CreateAcquiringInput!) {
  schoolAcquiringCreate(acquiring: $acquiring) {
    ...SchoolAcquiringFragment
  }
}
    ${SchoolAcquiringFragmentFragmentDoc}`;
export type SchoolAcquiringCreateMutationFn = Apollo.MutationFunction<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables>;
export type SchoolAcquiringCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables>, 'mutation'>;

    export const SchoolAcquiringCreateQuery = (props: SchoolAcquiringCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables> mutation={SchoolAcquiringCreateDocument} {...props} />
    );


/**
 * __useSchoolAcquiringCreateMutation__
 *
 * To run a mutation, you first call `useSchoolAcquiringCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAcquiringCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAcquiringCreateMutation, { data, loading, error }] = useSchoolAcquiringCreateMutation({
 *   variables: {
 *      acquiring: // value for 'acquiring'
 *   },
 * });
 */
export function useSchoolAcquiringCreateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables>(SchoolAcquiringCreateDocument, options);
      }
export type SchoolAcquiringCreateMutationHookResult = ReturnType<typeof useSchoolAcquiringCreateMutation>;
export type SchoolAcquiringCreateMutationResult = Apollo.MutationResult<SchoolAcquiringCreateMutation>;
export type SchoolAcquiringCreateMutationOptions = Apollo.BaseMutationOptions<SchoolAcquiringCreateMutation, SchoolAcquiringCreateMutationVariables>;
export const SchoolAcquiringUpdateDocument = gql`
    mutation SchoolAcquiringUpdate($acquiringId: Int!, $acquiring: UpdateAcquiringInput!) {
  schoolAcquiringUpdate(acquiringId: $acquiringId, acquiring: $acquiring) {
    ...SchoolAcquiringFragment
  }
}
    ${SchoolAcquiringFragmentFragmentDoc}`;
export type SchoolAcquiringUpdateMutationFn = Apollo.MutationFunction<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables>;
export type SchoolAcquiringUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables>, 'mutation'>;

    export const SchoolAcquiringUpdateQuery = (props: SchoolAcquiringUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables> mutation={SchoolAcquiringUpdateDocument} {...props} />
    );


/**
 * __useSchoolAcquiringUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolAcquiringUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAcquiringUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAcquiringUpdateMutation, { data, loading, error }] = useSchoolAcquiringUpdateMutation({
 *   variables: {
 *      acquiringId: // value for 'acquiringId'
 *      acquiring: // value for 'acquiring'
 *   },
 * });
 */
export function useSchoolAcquiringUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables>(SchoolAcquiringUpdateDocument, options);
      }
export type SchoolAcquiringUpdateMutationHookResult = ReturnType<typeof useSchoolAcquiringUpdateMutation>;
export type SchoolAcquiringUpdateMutationResult = Apollo.MutationResult<SchoolAcquiringUpdateMutation>;
export type SchoolAcquiringUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolAcquiringUpdateMutation, SchoolAcquiringUpdateMutationVariables>;
export const SchoolAcquiringFindOneDocument = gql`
    query SchoolAcquiringFindOne($acquiringId: Int!) {
  schoolAcquiringFindOne(acquiringId: $acquiringId) {
    ...SchoolAcquiringFragment
  }
}
    ${SchoolAcquiringFragmentFragmentDoc}`;
export type SchoolAcquiringFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>, 'query'> & ({ variables: SchoolAcquiringFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolAcquiringFindOneQuery = (props: SchoolAcquiringFindOneQueryProps) => (
      <ApolloReactComponents.Query<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables> query={SchoolAcquiringFindOneDocument} {...props} />
    );


/**
 * __useSchoolAcquiringFindOneQuery__
 *
 * To run a query within a React component, call `useSchoolAcquiringFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAcquiringFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAcquiringFindOneQuery({
 *   variables: {
 *      acquiringId: // value for 'acquiringId'
 *   },
 * });
 */
export function useSchoolAcquiringFindOneQuery(baseOptions: Apollo.QueryHookOptions<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables> & ({ variables: SchoolAcquiringFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>(SchoolAcquiringFindOneDocument, options);
      }
export function useSchoolAcquiringFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>(SchoolAcquiringFindOneDocument, options);
        }
export function useSchoolAcquiringFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>(SchoolAcquiringFindOneDocument, options);
        }
export type SchoolAcquiringFindOneQueryHookResult = ReturnType<typeof useSchoolAcquiringFindOneQuery>;
export type SchoolAcquiringFindOneLazyQueryHookResult = ReturnType<typeof useSchoolAcquiringFindOneLazyQuery>;
export type SchoolAcquiringFindOneSuspenseQueryHookResult = ReturnType<typeof useSchoolAcquiringFindOneSuspenseQuery>;
export type SchoolAcquiringFindOneQueryResult = Apollo.QueryResult<SchoolAcquiringFindOneQuery, SchoolAcquiringFindOneQueryVariables>;
export const SchoolAcquiringFindManyDocument = gql`
    query SchoolAcquiringFindMany($list: ListInput!, $filter: FilterAcquiringInput!, $sort: BaseSortInput) {
  schoolAcquiringFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...SchoolAcquiringFragment
    }
  }
}
    ${SchoolAcquiringFragmentFragmentDoc}`;
export type SchoolAcquiringFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>, 'query'> & ({ variables: SchoolAcquiringFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolAcquiringFindManyQuery = (props: SchoolAcquiringFindManyQueryProps) => (
      <ApolloReactComponents.Query<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables> query={SchoolAcquiringFindManyDocument} {...props} />
    );


/**
 * __useSchoolAcquiringFindManyQuery__
 *
 * To run a query within a React component, call `useSchoolAcquiringFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAcquiringFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAcquiringFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSchoolAcquiringFindManyQuery(baseOptions: Apollo.QueryHookOptions<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables> & ({ variables: SchoolAcquiringFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>(SchoolAcquiringFindManyDocument, options);
      }
export function useSchoolAcquiringFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>(SchoolAcquiringFindManyDocument, options);
        }
export function useSchoolAcquiringFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>(SchoolAcquiringFindManyDocument, options);
        }
export type SchoolAcquiringFindManyQueryHookResult = ReturnType<typeof useSchoolAcquiringFindManyQuery>;
export type SchoolAcquiringFindManyLazyQueryHookResult = ReturnType<typeof useSchoolAcquiringFindManyLazyQuery>;
export type SchoolAcquiringFindManySuspenseQueryHookResult = ReturnType<typeof useSchoolAcquiringFindManySuspenseQuery>;
export type SchoolAcquiringFindManyQueryResult = Apollo.QueryResult<SchoolAcquiringFindManyQuery, SchoolAcquiringFindManyQueryVariables>;
export const SchoolAcquiringUpdateOrderDocument = gql`
    mutation SchoolAcquiringUpdateOrder($acquiringIds: [Int!]!) {
  schoolAcquiringUpdateOrder(acquiringIds: $acquiringIds) {
    ...SchoolAcquiringFragment
  }
}
    ${SchoolAcquiringFragmentFragmentDoc}`;
export type SchoolAcquiringUpdateOrderMutationFn = Apollo.MutationFunction<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables>;
export type SchoolAcquiringUpdateOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables>, 'mutation'>;

    export const SchoolAcquiringUpdateOrderQuery = (props: SchoolAcquiringUpdateOrderQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables> mutation={SchoolAcquiringUpdateOrderDocument} {...props} />
    );


/**
 * __useSchoolAcquiringUpdateOrderMutation__
 *
 * To run a mutation, you first call `useSchoolAcquiringUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAcquiringUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAcquiringUpdateOrderMutation, { data, loading, error }] = useSchoolAcquiringUpdateOrderMutation({
 *   variables: {
 *      acquiringIds: // value for 'acquiringIds'
 *   },
 * });
 */
export function useSchoolAcquiringUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables>(SchoolAcquiringUpdateOrderDocument, options);
      }
export type SchoolAcquiringUpdateOrderMutationHookResult = ReturnType<typeof useSchoolAcquiringUpdateOrderMutation>;
export type SchoolAcquiringUpdateOrderMutationResult = Apollo.MutationResult<SchoolAcquiringUpdateOrderMutation>;
export type SchoolAcquiringUpdateOrderMutationOptions = Apollo.BaseMutationOptions<SchoolAcquiringUpdateOrderMutation, SchoolAcquiringUpdateOrderMutationVariables>;
export const SchoolContentCategoryCreateDocument = gql`
    mutation SchoolContentCategoryCreate($category: CreateCategoryContentInput!) {
  schoolContentCategoryCreate(category: $category) {
    ...ContentCategoryFragment
  }
}
    ${ContentCategoryFragmentFragmentDoc}`;
export type SchoolContentCategoryCreateMutationFn = Apollo.MutationFunction<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables>;
export type SchoolContentCategoryCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables>, 'mutation'>;

    export const SchoolContentCategoryCreateQuery = (props: SchoolContentCategoryCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables> mutation={SchoolContentCategoryCreateDocument} {...props} />
    );


/**
 * __useSchoolContentCategoryCreateMutation__
 *
 * To run a mutation, you first call `useSchoolContentCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolContentCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolContentCategoryCreateMutation, { data, loading, error }] = useSchoolContentCategoryCreateMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useSchoolContentCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables>(SchoolContentCategoryCreateDocument, options);
      }
export type SchoolContentCategoryCreateMutationHookResult = ReturnType<typeof useSchoolContentCategoryCreateMutation>;
export type SchoolContentCategoryCreateMutationResult = Apollo.MutationResult<SchoolContentCategoryCreateMutation>;
export type SchoolContentCategoryCreateMutationOptions = Apollo.BaseMutationOptions<SchoolContentCategoryCreateMutation, SchoolContentCategoryCreateMutationVariables>;
export const SchoolContentCategoryUpdateDocument = gql`
    mutation SchoolContentCategoryUpdate($categoryId: Int!, $category: UpdateCategoryContentInput!) {
  schoolContentCategoryUpdate(categoryId: $categoryId, category: $category) {
    ...ContentCategoryFragment
  }
}
    ${ContentCategoryFragmentFragmentDoc}`;
export type SchoolContentCategoryUpdateMutationFn = Apollo.MutationFunction<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables>;
export type SchoolContentCategoryUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables>, 'mutation'>;

    export const SchoolContentCategoryUpdateQuery = (props: SchoolContentCategoryUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables> mutation={SchoolContentCategoryUpdateDocument} {...props} />
    );


/**
 * __useSchoolContentCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolContentCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolContentCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolContentCategoryUpdateMutation, { data, loading, error }] = useSchoolContentCategoryUpdateMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useSchoolContentCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables>(SchoolContentCategoryUpdateDocument, options);
      }
export type SchoolContentCategoryUpdateMutationHookResult = ReturnType<typeof useSchoolContentCategoryUpdateMutation>;
export type SchoolContentCategoryUpdateMutationResult = Apollo.MutationResult<SchoolContentCategoryUpdateMutation>;
export type SchoolContentCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolContentCategoryUpdateMutation, SchoolContentCategoryUpdateMutationVariables>;
export const SchoolSubjectCreateDocument = gql`
    mutation SchoolSubjectCreate($subject: CreateSubjectInput!) {
  schoolSubjectCreate(subject: $subject) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;
export type SchoolSubjectCreateMutationFn = Apollo.MutationFunction<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables>;
export type SchoolSubjectCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables>, 'mutation'>;

    export const SchoolSubjectCreateQuery = (props: SchoolSubjectCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables> mutation={SchoolSubjectCreateDocument} {...props} />
    );


/**
 * __useSchoolSubjectCreateMutation__
 *
 * To run a mutation, you first call `useSchoolSubjectCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubjectCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubjectCreateMutation, { data, loading, error }] = useSchoolSubjectCreateMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSchoolSubjectCreateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables>(SchoolSubjectCreateDocument, options);
      }
export type SchoolSubjectCreateMutationHookResult = ReturnType<typeof useSchoolSubjectCreateMutation>;
export type SchoolSubjectCreateMutationResult = Apollo.MutationResult<SchoolSubjectCreateMutation>;
export type SchoolSubjectCreateMutationOptions = Apollo.BaseMutationOptions<SchoolSubjectCreateMutation, SchoolSubjectCreateMutationVariables>;
export const SchoolSubjectUpdateDocument = gql`
    mutation SchoolSubjectUpdate($subjectId: Int!, $subject: UpdateSubjectInput!) {
  schoolSubjectUpdate(subjectId: $subjectId, subject: $subject) {
    ...SubjectFragment
  }
}
    ${SubjectFragmentFragmentDoc}`;
export type SchoolSubjectUpdateMutationFn = Apollo.MutationFunction<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables>;
export type SchoolSubjectUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables>, 'mutation'>;

    export const SchoolSubjectUpdateQuery = (props: SchoolSubjectUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables> mutation={SchoolSubjectUpdateDocument} {...props} />
    );


/**
 * __useSchoolSubjectUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolSubjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubjectUpdateMutation, { data, loading, error }] = useSchoolSubjectUpdateMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSchoolSubjectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables>(SchoolSubjectUpdateDocument, options);
      }
export type SchoolSubjectUpdateMutationHookResult = ReturnType<typeof useSchoolSubjectUpdateMutation>;
export type SchoolSubjectUpdateMutationResult = Apollo.MutationResult<SchoolSubjectUpdateMutation>;
export type SchoolSubjectUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolSubjectUpdateMutation, SchoolSubjectUpdateMutationVariables>;
export const SellerOrganizationDocumentFindOneDocument = gql`
    query SellerOrganizationDocumentFindOne($documentId: Int!) {
  sellerOrganizationDocumentFindOne(documentId: $documentId) {
    ...SellerOrganizationDocumentFragment
  }
}
    ${SellerOrganizationDocumentFragmentFragmentDoc}`;
export type SellerOrganizationDocumentFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>, 'query'> & ({ variables: SellerOrganizationDocumentFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerOrganizationDocumentFindOneQuery = (props: SellerOrganizationDocumentFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables> query={SellerOrganizationDocumentFindOneDocument} {...props} />
    );


/**
 * __useSellerOrganizationDocumentFindOneQuery__
 *
 * To run a query within a React component, call `useSellerOrganizationDocumentFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationDocumentFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerOrganizationDocumentFindOneQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useSellerOrganizationDocumentFindOneQuery(baseOptions: Apollo.QueryHookOptions<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables> & ({ variables: SellerOrganizationDocumentFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>(SellerOrganizationDocumentFindOneDocument, options);
      }
export function useSellerOrganizationDocumentFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>(SellerOrganizationDocumentFindOneDocument, options);
        }
export function useSellerOrganizationDocumentFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>(SellerOrganizationDocumentFindOneDocument, options);
        }
export type SellerOrganizationDocumentFindOneQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindOneQuery>;
export type SellerOrganizationDocumentFindOneLazyQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindOneLazyQuery>;
export type SellerOrganizationDocumentFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindOneSuspenseQuery>;
export type SellerOrganizationDocumentFindOneQueryResult = Apollo.QueryResult<SellerOrganizationDocumentFindOneQuery, SellerOrganizationDocumentFindOneQueryVariables>;
export const SellerOrganizationDocumentFindManyDocument = gql`
    query SellerOrganizationDocumentFindMany($list: ListInput!, $filter: FilterOrganizationDocumentSellerInput!, $sort: BaseSortInput) {
  sellerOrganizationDocumentFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...SellerOrganizationDocumentFragment
    }
  }
}
    ${SellerOrganizationDocumentFragmentFragmentDoc}`;
export type SellerOrganizationDocumentFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>, 'query'> & ({ variables: SellerOrganizationDocumentFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerOrganizationDocumentFindManyQuery = (props: SellerOrganizationDocumentFindManyQueryProps) => (
      <ApolloReactComponents.Query<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables> query={SellerOrganizationDocumentFindManyDocument} {...props} />
    );


/**
 * __useSellerOrganizationDocumentFindManyQuery__
 *
 * To run a query within a React component, call `useSellerOrganizationDocumentFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationDocumentFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerOrganizationDocumentFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSellerOrganizationDocumentFindManyQuery(baseOptions: Apollo.QueryHookOptions<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables> & ({ variables: SellerOrganizationDocumentFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>(SellerOrganizationDocumentFindManyDocument, options);
      }
export function useSellerOrganizationDocumentFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>(SellerOrganizationDocumentFindManyDocument, options);
        }
export function useSellerOrganizationDocumentFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>(SellerOrganizationDocumentFindManyDocument, options);
        }
export type SellerOrganizationDocumentFindManyQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindManyQuery>;
export type SellerOrganizationDocumentFindManyLazyQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindManyLazyQuery>;
export type SellerOrganizationDocumentFindManySuspenseQueryHookResult = ReturnType<typeof useSellerOrganizationDocumentFindManySuspenseQuery>;
export type SellerOrganizationDocumentFindManyQueryResult = Apollo.QueryResult<SellerOrganizationDocumentFindManyQuery, SellerOrganizationDocumentFindManyQueryVariables>;
export const SellerOrganizationDocumentCreateDocument = gql`
    mutation SellerOrganizationDocumentCreate($document: CreateOrganizationDocumentSellerInput!) {
  sellerOrganizationDocumentCreate(document: $document) {
    ...SellerOrganizationDocumentFragment
  }
}
    ${SellerOrganizationDocumentFragmentFragmentDoc}`;
export type SellerOrganizationDocumentCreateMutationFn = Apollo.MutationFunction<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables>;
export type SellerOrganizationDocumentCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables>, 'mutation'>;

    export const SellerOrganizationDocumentCreateQuery = (props: SellerOrganizationDocumentCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables> mutation={SellerOrganizationDocumentCreateDocument} {...props} />
    );


/**
 * __useSellerOrganizationDocumentCreateMutation__
 *
 * To run a mutation, you first call `useSellerOrganizationDocumentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationDocumentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerOrganizationDocumentCreateMutation, { data, loading, error }] = useSellerOrganizationDocumentCreateMutation({
 *   variables: {
 *      document: // value for 'document'
 *   },
 * });
 */
export function useSellerOrganizationDocumentCreateMutation(baseOptions?: Apollo.MutationHookOptions<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables>(SellerOrganizationDocumentCreateDocument, options);
      }
export type SellerOrganizationDocumentCreateMutationHookResult = ReturnType<typeof useSellerOrganizationDocumentCreateMutation>;
export type SellerOrganizationDocumentCreateMutationResult = Apollo.MutationResult<SellerOrganizationDocumentCreateMutation>;
export type SellerOrganizationDocumentCreateMutationOptions = Apollo.BaseMutationOptions<SellerOrganizationDocumentCreateMutation, SellerOrganizationDocumentCreateMutationVariables>;
export const SellerOrganizationDocumentUpdateDocument = gql`
    mutation SellerOrganizationDocumentUpdate($documentId: Int!, $document: UpdateOrganizationDocumentSellerInput!) {
  sellerOrganizationDocumentUpdate(documentId: $documentId, document: $document) {
    ...SellerOrganizationDocumentFragment
  }
}
    ${SellerOrganizationDocumentFragmentFragmentDoc}`;
export type SellerOrganizationDocumentUpdateMutationFn = Apollo.MutationFunction<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables>;
export type SellerOrganizationDocumentUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables>, 'mutation'>;

    export const SellerOrganizationDocumentUpdateQuery = (props: SellerOrganizationDocumentUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables> mutation={SellerOrganizationDocumentUpdateDocument} {...props} />
    );


/**
 * __useSellerOrganizationDocumentUpdateMutation__
 *
 * To run a mutation, you first call `useSellerOrganizationDocumentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationDocumentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerOrganizationDocumentUpdateMutation, { data, loading, error }] = useSellerOrganizationDocumentUpdateMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useSellerOrganizationDocumentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables>(SellerOrganizationDocumentUpdateDocument, options);
      }
export type SellerOrganizationDocumentUpdateMutationHookResult = ReturnType<typeof useSellerOrganizationDocumentUpdateMutation>;
export type SellerOrganizationDocumentUpdateMutationResult = Apollo.MutationResult<SellerOrganizationDocumentUpdateMutation>;
export type SellerOrganizationDocumentUpdateMutationOptions = Apollo.BaseMutationOptions<SellerOrganizationDocumentUpdateMutation, SellerOrganizationDocumentUpdateMutationVariables>;
export const SchoolOrganizationUpdateDocument = gql`
    mutation SchoolOrganizationUpdate($sellerOrganizationId: Int!, $organization: UpdateOrganizationSchoolInput!) {
  schoolOrganizationUpdate(
    sellerOrganizationId: $sellerOrganizationId
    organization: $organization
  ) {
    ...SellerOrganizationFragment
  }
}
    ${SellerOrganizationFragmentFragmentDoc}`;
export type SchoolOrganizationUpdateMutationFn = Apollo.MutationFunction<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables>;
export type SchoolOrganizationUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables>, 'mutation'>;

    export const SchoolOrganizationUpdateQuery = (props: SchoolOrganizationUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables> mutation={SchoolOrganizationUpdateDocument} {...props} />
    );


/**
 * __useSchoolOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolOrganizationUpdateMutation, { data, loading, error }] = useSchoolOrganizationUpdateMutation({
 *   variables: {
 *      sellerOrganizationId: // value for 'sellerOrganizationId'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSchoolOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables>(SchoolOrganizationUpdateDocument, options);
      }
export type SchoolOrganizationUpdateMutationHookResult = ReturnType<typeof useSchoolOrganizationUpdateMutation>;
export type SchoolOrganizationUpdateMutationResult = Apollo.MutationResult<SchoolOrganizationUpdateMutation>;
export type SchoolOrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolOrganizationUpdateMutation, SchoolOrganizationUpdateMutationVariables>;
export const SchoolManageFindManyMineDocument = gql`
    query SchoolManageFindManyMine {
  schoolManageFindManyMine {
    id
    name
    description
    iconUrl
    domainType
    customDomain
    baseDomain
    access {
      id
      expireAt
      isActive
    }
  }
}
    `;
export type SchoolManageFindManyMineQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>, 'query'>;

    export const SchoolManageFindManyMineQuery = (props: SchoolManageFindManyMineQueryProps) => (
      <ApolloReactComponents.Query<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables> query={SchoolManageFindManyMineDocument} {...props} />
    );


/**
 * __useSchoolManageFindManyMineQuery__
 *
 * To run a query within a React component, call `useSchoolManageFindManyMineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageFindManyMineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolManageFindManyMineQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolManageFindManyMineQuery(baseOptions?: Apollo.QueryHookOptions<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>(SchoolManageFindManyMineDocument, options);
      }
export function useSchoolManageFindManyMineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>(SchoolManageFindManyMineDocument, options);
        }
export function useSchoolManageFindManyMineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>(SchoolManageFindManyMineDocument, options);
        }
export type SchoolManageFindManyMineQueryHookResult = ReturnType<typeof useSchoolManageFindManyMineQuery>;
export type SchoolManageFindManyMineLazyQueryHookResult = ReturnType<typeof useSchoolManageFindManyMineLazyQuery>;
export type SchoolManageFindManyMineSuspenseQueryHookResult = ReturnType<typeof useSchoolManageFindManyMineSuspenseQuery>;
export type SchoolManageFindManyMineQueryResult = Apollo.QueryResult<SchoolManageFindManyMineQuery, SchoolManageFindManyMineQueryVariables>;
export const SchoolManageCheckDomainDocument = gql`
    query SchoolManageCheckDomain($schoolId: Int, $domain: String!, $domainType: SchoolDomainType!) {
  schoolManageCheckDomain(
    schoolId: $schoolId
    domain: $domain
    domainType: $domainType
  ) {
    success
    cause
    message
  }
}
    `;
export type SchoolManageCheckDomainQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>, 'query'> & ({ variables: SchoolManageCheckDomainQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolManageCheckDomainQuery = (props: SchoolManageCheckDomainQueryProps) => (
      <ApolloReactComponents.Query<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables> query={SchoolManageCheckDomainDocument} {...props} />
    );


/**
 * __useSchoolManageCheckDomainQuery__
 *
 * To run a query within a React component, call `useSchoolManageCheckDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageCheckDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolManageCheckDomainQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      domain: // value for 'domain'
 *      domainType: // value for 'domainType'
 *   },
 * });
 */
export function useSchoolManageCheckDomainQuery(baseOptions: Apollo.QueryHookOptions<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables> & ({ variables: SchoolManageCheckDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>(SchoolManageCheckDomainDocument, options);
      }
export function useSchoolManageCheckDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>(SchoolManageCheckDomainDocument, options);
        }
export function useSchoolManageCheckDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>(SchoolManageCheckDomainDocument, options);
        }
export type SchoolManageCheckDomainQueryHookResult = ReturnType<typeof useSchoolManageCheckDomainQuery>;
export type SchoolManageCheckDomainLazyQueryHookResult = ReturnType<typeof useSchoolManageCheckDomainLazyQuery>;
export type SchoolManageCheckDomainSuspenseQueryHookResult = ReturnType<typeof useSchoolManageCheckDomainSuspenseQuery>;
export type SchoolManageCheckDomainQueryResult = Apollo.QueryResult<SchoolManageCheckDomainQuery, SchoolManageCheckDomainQueryVariables>;
export const SchoolManageUpdateDocument = gql`
    mutation SchoolManageUpdate($schoolId: Int!, $school: UpdateSchoolInput!) {
  schoolManageUpdate(schoolId: $schoolId, school: $school) {
    ...SchoolManageFragment
  }
}
    ${SchoolManageFragmentFragmentDoc}`;
export type SchoolManageUpdateMutationFn = Apollo.MutationFunction<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables>;
export type SchoolManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables>, 'mutation'>;

    export const SchoolManageUpdateQuery = (props: SchoolManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables> mutation={SchoolManageUpdateDocument} {...props} />
    );


/**
 * __useSchoolManageUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolManageUpdateMutation, { data, loading, error }] = useSchoolManageUpdateMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      school: // value for 'school'
 *   },
 * });
 */
export function useSchoolManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables>(SchoolManageUpdateDocument, options);
      }
export type SchoolManageUpdateMutationHookResult = ReturnType<typeof useSchoolManageUpdateMutation>;
export type SchoolManageUpdateMutationResult = Apollo.MutationResult<SchoolManageUpdateMutation>;
export type SchoolManageUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolManageUpdateMutation, SchoolManageUpdateMutationVariables>;
export const SchoolPriceFindManyActiveDocument = gql`
    query SchoolPriceFindManyActive($currency: ProductCurrency!) {
  schoolPriceFindManyActive(currency: $currency) {
    ...SchoolPriceFragment
  }
}
    ${SchoolPriceFragmentFragmentDoc}`;
export type SchoolPriceFindManyActiveQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>, 'query'> & ({ variables: SchoolPriceFindManyActiveQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolPriceFindManyActiveQuery = (props: SchoolPriceFindManyActiveQueryProps) => (
      <ApolloReactComponents.Query<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables> query={SchoolPriceFindManyActiveDocument} {...props} />
    );


/**
 * __useSchoolPriceFindManyActiveQuery__
 *
 * To run a query within a React component, call `useSchoolPriceFindManyActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolPriceFindManyActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolPriceFindManyActiveQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSchoolPriceFindManyActiveQuery(baseOptions: Apollo.QueryHookOptions<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables> & ({ variables: SchoolPriceFindManyActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>(SchoolPriceFindManyActiveDocument, options);
      }
export function useSchoolPriceFindManyActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>(SchoolPriceFindManyActiveDocument, options);
        }
export function useSchoolPriceFindManyActiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>(SchoolPriceFindManyActiveDocument, options);
        }
export type SchoolPriceFindManyActiveQueryHookResult = ReturnType<typeof useSchoolPriceFindManyActiveQuery>;
export type SchoolPriceFindManyActiveLazyQueryHookResult = ReturnType<typeof useSchoolPriceFindManyActiveLazyQuery>;
export type SchoolPriceFindManyActiveSuspenseQueryHookResult = ReturnType<typeof useSchoolPriceFindManyActiveSuspenseQuery>;
export type SchoolPriceFindManyActiveQueryResult = Apollo.QueryResult<SchoolPriceFindManyActiveQuery, SchoolPriceFindManyActiveQueryVariables>;
export const SchoolUserFindManyDocument = gql`
    query SchoolUserFindMany($list: ListInput!, $filter: FilterUserInput!, $sort: BaseSortInput) {
  schoolUserFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...SchoolUserFindManyFragment
    }
  }
}
    ${SchoolUserFindManyFragmentFragmentDoc}`;
export type SchoolUserFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>, 'query'> & ({ variables: SchoolUserFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolUserFindManyQuery = (props: SchoolUserFindManyQueryProps) => (
      <ApolloReactComponents.Query<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables> query={SchoolUserFindManyDocument} {...props} />
    );


/**
 * __useSchoolUserFindManyQuery__
 *
 * To run a query within a React component, call `useSchoolUserFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolUserFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSchoolUserFindManyQuery(baseOptions: Apollo.QueryHookOptions<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables> & ({ variables: SchoolUserFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>(SchoolUserFindManyDocument, options);
      }
export function useSchoolUserFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>(SchoolUserFindManyDocument, options);
        }
export function useSchoolUserFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>(SchoolUserFindManyDocument, options);
        }
export type SchoolUserFindManyQueryHookResult = ReturnType<typeof useSchoolUserFindManyQuery>;
export type SchoolUserFindManyLazyQueryHookResult = ReturnType<typeof useSchoolUserFindManyLazyQuery>;
export type SchoolUserFindManySuspenseQueryHookResult = ReturnType<typeof useSchoolUserFindManySuspenseQuery>;
export type SchoolUserFindManyQueryResult = Apollo.QueryResult<SchoolUserFindManyQuery, SchoolUserFindManyQueryVariables>;
export const SchoolUserManageCreateManyDocument = gql`
    mutation SchoolUserManageCreateMany($users: CreateManyUserInput!, $enrollments: CreateAccessManyProductInput) {
  schoolUserManageCreateMany(users: $users, enrollments: $enrollments) {
    created {
      ...SchoolUserFindManyFragment
    }
    exist {
      ...SchoolUserFindManyFragment
    }
  }
}
    ${SchoolUserFindManyFragmentFragmentDoc}`;
export type SchoolUserManageCreateManyMutationFn = Apollo.MutationFunction<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables>;
export type SchoolUserManageCreateManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables>, 'mutation'>;

    export const SchoolUserManageCreateManyQuery = (props: SchoolUserManageCreateManyQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables> mutation={SchoolUserManageCreateManyDocument} {...props} />
    );


/**
 * __useSchoolUserManageCreateManyMutation__
 *
 * To run a mutation, you first call `useSchoolUserManageCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserManageCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUserManageCreateManyMutation, { data, loading, error }] = useSchoolUserManageCreateManyMutation({
 *   variables: {
 *      users: // value for 'users'
 *      enrollments: // value for 'enrollments'
 *   },
 * });
 */
export function useSchoolUserManageCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables>(SchoolUserManageCreateManyDocument, options);
      }
export type SchoolUserManageCreateManyMutationHookResult = ReturnType<typeof useSchoolUserManageCreateManyMutation>;
export type SchoolUserManageCreateManyMutationResult = Apollo.MutationResult<SchoolUserManageCreateManyMutation>;
export type SchoolUserManageCreateManyMutationOptions = Apollo.BaseMutationOptions<SchoolUserManageCreateManyMutation, SchoolUserManageCreateManyMutationVariables>;
export const SchoolUserFindOneDocument = gql`
    query SchoolUserFindOne($userId: Int!) {
  schoolUserFindOne(userId: $userId) {
    id
    tgId
    email
    phone
    domain
    banned
    language
    timezone
    createdAt
    lastOnlineAt
    createdBy {
      id
      profile {
        id
        fullName
      }
    }
    profile {
      id
      sex
      bdate
      firstName
      lastName
      fullName
      avatar {
        id
        medium
      }
      ...ProfileTitleFragment
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type SchoolUserFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>, 'query'> & ({ variables: SchoolUserFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolUserFindOneQuery = (props: SchoolUserFindOneQueryProps) => (
      <ApolloReactComponents.Query<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables> query={SchoolUserFindOneDocument} {...props} />
    );


/**
 * __useSchoolUserFindOneQuery__
 *
 * To run a query within a React component, call `useSchoolUserFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolUserFindOneQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSchoolUserFindOneQuery(baseOptions: Apollo.QueryHookOptions<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables> & ({ variables: SchoolUserFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>(SchoolUserFindOneDocument, options);
      }
export function useSchoolUserFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>(SchoolUserFindOneDocument, options);
        }
export function useSchoolUserFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>(SchoolUserFindOneDocument, options);
        }
export type SchoolUserFindOneQueryHookResult = ReturnType<typeof useSchoolUserFindOneQuery>;
export type SchoolUserFindOneLazyQueryHookResult = ReturnType<typeof useSchoolUserFindOneLazyQuery>;
export type SchoolUserFindOneSuspenseQueryHookResult = ReturnType<typeof useSchoolUserFindOneSuspenseQuery>;
export type SchoolUserFindOneQueryResult = Apollo.QueryResult<SchoolUserFindOneQuery, SchoolUserFindOneQueryVariables>;
export const SchoolUserSessionFindManyDocument = gql`
    query SchoolUserSessionFindMany($list: ListInput!, $filter: FilterSessionInput!, $sort: BaseSortInput) {
  schoolUserSessionFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      id
      ip
      alive
      createdAt
      isOnline
      launcher
      lastActivityAt
      location {
        city
        country
        countryCode
      }
    }
  }
}
    `;
export type SchoolUserSessionFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>, 'query'> & ({ variables: SchoolUserSessionFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolUserSessionFindManyQuery = (props: SchoolUserSessionFindManyQueryProps) => (
      <ApolloReactComponents.Query<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables> query={SchoolUserSessionFindManyDocument} {...props} />
    );


/**
 * __useSchoolUserSessionFindManyQuery__
 *
 * To run a query within a React component, call `useSchoolUserSessionFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserSessionFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolUserSessionFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSchoolUserSessionFindManyQuery(baseOptions: Apollo.QueryHookOptions<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables> & ({ variables: SchoolUserSessionFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>(SchoolUserSessionFindManyDocument, options);
      }
export function useSchoolUserSessionFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>(SchoolUserSessionFindManyDocument, options);
        }
export function useSchoolUserSessionFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>(SchoolUserSessionFindManyDocument, options);
        }
export type SchoolUserSessionFindManyQueryHookResult = ReturnType<typeof useSchoolUserSessionFindManyQuery>;
export type SchoolUserSessionFindManyLazyQueryHookResult = ReturnType<typeof useSchoolUserSessionFindManyLazyQuery>;
export type SchoolUserSessionFindManySuspenseQueryHookResult = ReturnType<typeof useSchoolUserSessionFindManySuspenseQuery>;
export type SchoolUserSessionFindManyQueryResult = Apollo.QueryResult<SchoolUserSessionFindManyQuery, SchoolUserSessionFindManyQueryVariables>;
export const SchoolUserPasswordFindOneLastPlainDocument = gql`
    query SchoolUserPasswordFindOneLastPlain($userId: Int!) {
  schoolUserPasswordFindOneLastPlain(userId: $userId)
}
    `;
export type SchoolUserPasswordFindOneLastPlainQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>, 'query'> & ({ variables: SchoolUserPasswordFindOneLastPlainQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolUserPasswordFindOneLastPlainQuery = (props: SchoolUserPasswordFindOneLastPlainQueryProps) => (
      <ApolloReactComponents.Query<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables> query={SchoolUserPasswordFindOneLastPlainDocument} {...props} />
    );


/**
 * __useSchoolUserPasswordFindOneLastPlainQuery__
 *
 * To run a query within a React component, call `useSchoolUserPasswordFindOneLastPlainQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserPasswordFindOneLastPlainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolUserPasswordFindOneLastPlainQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSchoolUserPasswordFindOneLastPlainQuery(baseOptions: Apollo.QueryHookOptions<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables> & ({ variables: SchoolUserPasswordFindOneLastPlainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>(SchoolUserPasswordFindOneLastPlainDocument, options);
      }
export function useSchoolUserPasswordFindOneLastPlainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>(SchoolUserPasswordFindOneLastPlainDocument, options);
        }
export function useSchoolUserPasswordFindOneLastPlainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>(SchoolUserPasswordFindOneLastPlainDocument, options);
        }
export type SchoolUserPasswordFindOneLastPlainQueryHookResult = ReturnType<typeof useSchoolUserPasswordFindOneLastPlainQuery>;
export type SchoolUserPasswordFindOneLastPlainLazyQueryHookResult = ReturnType<typeof useSchoolUserPasswordFindOneLastPlainLazyQuery>;
export type SchoolUserPasswordFindOneLastPlainSuspenseQueryHookResult = ReturnType<typeof useSchoolUserPasswordFindOneLastPlainSuspenseQuery>;
export type SchoolUserPasswordFindOneLastPlainQueryResult = Apollo.QueryResult<SchoolUserPasswordFindOneLastPlainQuery, SchoolUserPasswordFindOneLastPlainQueryVariables>;
export const SchoolUserManageSessionKillAllDocument = gql`
    mutation SchoolUserManageSessionKillAll($userId: Int!) {
  schoolUserManageSessionKillAll(userId: $userId) {
    id
    alive
    isOnline
  }
}
    `;
export type SchoolUserManageSessionKillAllMutationFn = Apollo.MutationFunction<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables>;
export type SchoolUserManageSessionKillAllQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables>, 'mutation'>;

    export const SchoolUserManageSessionKillAllQuery = (props: SchoolUserManageSessionKillAllQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables> mutation={SchoolUserManageSessionKillAllDocument} {...props} />
    );


/**
 * __useSchoolUserManageSessionKillAllMutation__
 *
 * To run a mutation, you first call `useSchoolUserManageSessionKillAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserManageSessionKillAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUserManageSessionKillAllMutation, { data, loading, error }] = useSchoolUserManageSessionKillAllMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSchoolUserManageSessionKillAllMutation(baseOptions?: Apollo.MutationHookOptions<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables>(SchoolUserManageSessionKillAllDocument, options);
      }
export type SchoolUserManageSessionKillAllMutationHookResult = ReturnType<typeof useSchoolUserManageSessionKillAllMutation>;
export type SchoolUserManageSessionKillAllMutationResult = Apollo.MutationResult<SchoolUserManageSessionKillAllMutation>;
export type SchoolUserManageSessionKillAllMutationOptions = Apollo.BaseMutationOptions<SchoolUserManageSessionKillAllMutation, SchoolUserManageSessionKillAllMutationVariables>;
export const SchoolUserManageSessionKillByIdDocument = gql`
    mutation SchoolUserManageSessionKillById($sessionId: Int!) {
  schoolUserManageSessionKillById(sessionId: $sessionId) {
    id
    alive
    isOnline
  }
}
    `;
export type SchoolUserManageSessionKillByIdMutationFn = Apollo.MutationFunction<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables>;
export type SchoolUserManageSessionKillByIdQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables>, 'mutation'>;

    export const SchoolUserManageSessionKillByIdQuery = (props: SchoolUserManageSessionKillByIdQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables> mutation={SchoolUserManageSessionKillByIdDocument} {...props} />
    );


/**
 * __useSchoolUserManageSessionKillByIdMutation__
 *
 * To run a mutation, you first call `useSchoolUserManageSessionKillByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserManageSessionKillByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUserManageSessionKillByIdMutation, { data, loading, error }] = useSchoolUserManageSessionKillByIdMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSchoolUserManageSessionKillByIdMutation(baseOptions?: Apollo.MutationHookOptions<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables>(SchoolUserManageSessionKillByIdDocument, options);
      }
export type SchoolUserManageSessionKillByIdMutationHookResult = ReturnType<typeof useSchoolUserManageSessionKillByIdMutation>;
export type SchoolUserManageSessionKillByIdMutationResult = Apollo.MutationResult<SchoolUserManageSessionKillByIdMutation>;
export type SchoolUserManageSessionKillByIdMutationOptions = Apollo.BaseMutationOptions<SchoolUserManageSessionKillByIdMutation, SchoolUserManageSessionKillByIdMutationVariables>;
export const SchoolUserManageUpdateDocument = gql`
    mutation SchoolUserManageUpdate($userId: Int!, $userPartial: UpdateUserInput!) {
  schoolUserManageUpdate(userId: $userId, userPartial: $userPartial) {
    id
    banned
    lastOnlineAt
  }
}
    `;
export type SchoolUserManageUpdateMutationFn = Apollo.MutationFunction<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables>;
export type SchoolUserManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables>, 'mutation'>;

    export const SchoolUserManageUpdateQuery = (props: SchoolUserManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables> mutation={SchoolUserManageUpdateDocument} {...props} />
    );


/**
 * __useSchoolUserManageUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolUserManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUserManageUpdateMutation, { data, loading, error }] = useSchoolUserManageUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userPartial: // value for 'userPartial'
 *   },
 * });
 */
export function useSchoolUserManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables>(SchoolUserManageUpdateDocument, options);
      }
export type SchoolUserManageUpdateMutationHookResult = ReturnType<typeof useSchoolUserManageUpdateMutation>;
export type SchoolUserManageUpdateMutationResult = Apollo.MutationResult<SchoolUserManageUpdateMutation>;
export type SchoolUserManageUpdateMutationOptions = Apollo.BaseMutationOptions<SchoolUserManageUpdateMutation, SchoolUserManageUpdateMutationVariables>;
export const SchoolUserAccessCreateManyDocument = gql`
    mutation SchoolUserAccessCreateMany($userId: Int!, $enrollments: CreateAccessManyProductInput!) {
  schoolUserManageProductAccessesCreateMany(
    userId: $userId
    enrollments: $enrollments
  ) {
    id
    ...ProductAccessFragment
    user {
      id
      domain
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProductAccessFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type SchoolUserAccessCreateManyMutationFn = Apollo.MutationFunction<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables>;
export type SchoolUserAccessCreateManyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables>, 'mutation'>;

    export const SchoolUserAccessCreateManyQuery = (props: SchoolUserAccessCreateManyQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables> mutation={SchoolUserAccessCreateManyDocument} {...props} />
    );


/**
 * __useSchoolUserAccessCreateManyMutation__
 *
 * To run a mutation, you first call `useSchoolUserAccessCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUserAccessCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUserAccessCreateManyMutation, { data, loading, error }] = useSchoolUserAccessCreateManyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      enrollments: // value for 'enrollments'
 *   },
 * });
 */
export function useSchoolUserAccessCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables>(SchoolUserAccessCreateManyDocument, options);
      }
export type SchoolUserAccessCreateManyMutationHookResult = ReturnType<typeof useSchoolUserAccessCreateManyMutation>;
export type SchoolUserAccessCreateManyMutationResult = Apollo.MutationResult<SchoolUserAccessCreateManyMutation>;
export type SchoolUserAccessCreateManyMutationOptions = Apollo.BaseMutationOptions<SchoolUserAccessCreateManyMutation, SchoolUserAccessCreateManyMutationVariables>;
export const WebhookEndpointFindOneDocument = gql`
    query WebhookEndpointFindOne($endpointId: Int!) {
  webhookEndpointFindOne(endpointId: $endpointId) {
    ...WebhookEndpointFragment
  }
}
    ${WebhookEndpointFragmentFragmentDoc}`;
export type WebhookEndpointFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>, 'query'> & ({ variables: WebhookEndpointFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WebhookEndpointFindOneQuery = (props: WebhookEndpointFindOneQueryProps) => (
      <ApolloReactComponents.Query<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables> query={WebhookEndpointFindOneDocument} {...props} />
    );


/**
 * __useWebhookEndpointFindOneQuery__
 *
 * To run a query within a React component, call `useWebhookEndpointFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookEndpointFindOneQuery({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *   },
 * });
 */
export function useWebhookEndpointFindOneQuery(baseOptions: Apollo.QueryHookOptions<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables> & ({ variables: WebhookEndpointFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>(WebhookEndpointFindOneDocument, options);
      }
export function useWebhookEndpointFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>(WebhookEndpointFindOneDocument, options);
        }
export function useWebhookEndpointFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>(WebhookEndpointFindOneDocument, options);
        }
export type WebhookEndpointFindOneQueryHookResult = ReturnType<typeof useWebhookEndpointFindOneQuery>;
export type WebhookEndpointFindOneLazyQueryHookResult = ReturnType<typeof useWebhookEndpointFindOneLazyQuery>;
export type WebhookEndpointFindOneSuspenseQueryHookResult = ReturnType<typeof useWebhookEndpointFindOneSuspenseQuery>;
export type WebhookEndpointFindOneQueryResult = Apollo.QueryResult<WebhookEndpointFindOneQuery, WebhookEndpointFindOneQueryVariables>;
export const WebhookEndpointFindManyDocument = gql`
    query WebhookEndpointFindMany($list: ListInput!, $filter: FilterEndpointWebhookInput!, $sort: BaseSortInput) {
  webhookEndpointFindMany(list: $list, filter: $filter, sort: $sort) {
    page
    pages
    count
    items {
      ...WebhookEndpointFragment
    }
  }
}
    ${WebhookEndpointFragmentFragmentDoc}`;
export type WebhookEndpointFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>, 'query'> & ({ variables: WebhookEndpointFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WebhookEndpointFindManyQuery = (props: WebhookEndpointFindManyQueryProps) => (
      <ApolloReactComponents.Query<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables> query={WebhookEndpointFindManyDocument} {...props} />
    );


/**
 * __useWebhookEndpointFindManyQuery__
 *
 * To run a query within a React component, call `useWebhookEndpointFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookEndpointFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWebhookEndpointFindManyQuery(baseOptions: Apollo.QueryHookOptions<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables> & ({ variables: WebhookEndpointFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>(WebhookEndpointFindManyDocument, options);
      }
export function useWebhookEndpointFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>(WebhookEndpointFindManyDocument, options);
        }
export function useWebhookEndpointFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>(WebhookEndpointFindManyDocument, options);
        }
export type WebhookEndpointFindManyQueryHookResult = ReturnType<typeof useWebhookEndpointFindManyQuery>;
export type WebhookEndpointFindManyLazyQueryHookResult = ReturnType<typeof useWebhookEndpointFindManyLazyQuery>;
export type WebhookEndpointFindManySuspenseQueryHookResult = ReturnType<typeof useWebhookEndpointFindManySuspenseQuery>;
export type WebhookEndpointFindManyQueryResult = Apollo.QueryResult<WebhookEndpointFindManyQuery, WebhookEndpointFindManyQueryVariables>;
export const WebhookEndpointCreateDocument = gql`
    mutation WebhookEndpointCreate($endpoint: CreateEndpointWebhookInput!) {
  webhookEndpointCreate(endpoint: $endpoint) {
    ...WebhookEndpointFragment
  }
}
    ${WebhookEndpointFragmentFragmentDoc}`;
export type WebhookEndpointCreateMutationFn = Apollo.MutationFunction<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables>;
export type WebhookEndpointCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables>, 'mutation'>;

    export const WebhookEndpointCreateQuery = (props: WebhookEndpointCreateQueryProps) => (
      <ApolloReactComponents.Mutation<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables> mutation={WebhookEndpointCreateDocument} {...props} />
    );


/**
 * __useWebhookEndpointCreateMutation__
 *
 * To run a mutation, you first call `useWebhookEndpointCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookEndpointCreateMutation, { data, loading, error }] = useWebhookEndpointCreateMutation({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useWebhookEndpointCreateMutation(baseOptions?: Apollo.MutationHookOptions<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables>(WebhookEndpointCreateDocument, options);
      }
export type WebhookEndpointCreateMutationHookResult = ReturnType<typeof useWebhookEndpointCreateMutation>;
export type WebhookEndpointCreateMutationResult = Apollo.MutationResult<WebhookEndpointCreateMutation>;
export type WebhookEndpointCreateMutationOptions = Apollo.BaseMutationOptions<WebhookEndpointCreateMutation, WebhookEndpointCreateMutationVariables>;
export const WebhookEndpointUpdateDocument = gql`
    mutation WebhookEndpointUpdate($endpointId: Int!, $endpoint: UpdateEndpointWebhookInput!) {
  webhookEndpointUpdate(endpointId: $endpointId, endpoint: $endpoint) {
    ...WebhookEndpointFragment
  }
}
    ${WebhookEndpointFragmentFragmentDoc}`;
export type WebhookEndpointUpdateMutationFn = Apollo.MutationFunction<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables>;
export type WebhookEndpointUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables>, 'mutation'>;

    export const WebhookEndpointUpdateQuery = (props: WebhookEndpointUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables> mutation={WebhookEndpointUpdateDocument} {...props} />
    );


/**
 * __useWebhookEndpointUpdateMutation__
 *
 * To run a mutation, you first call `useWebhookEndpointUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookEndpointUpdateMutation, { data, loading, error }] = useWebhookEndpointUpdateMutation({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useWebhookEndpointUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables>(WebhookEndpointUpdateDocument, options);
      }
export type WebhookEndpointUpdateMutationHookResult = ReturnType<typeof useWebhookEndpointUpdateMutation>;
export type WebhookEndpointUpdateMutationResult = Apollo.MutationResult<WebhookEndpointUpdateMutation>;
export type WebhookEndpointUpdateMutationOptions = Apollo.BaseMutationOptions<WebhookEndpointUpdateMutation, WebhookEndpointUpdateMutationVariables>;
export const WebhookEndpointDeleteDocument = gql`
    mutation WebhookEndpointDelete($endpointId: Int!) {
  webhookEndpointDelete(endpointId: $endpointId)
}
    `;
export type WebhookEndpointDeleteMutationFn = Apollo.MutationFunction<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables>;
export type WebhookEndpointDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables>, 'mutation'>;

    export const WebhookEndpointDeleteQuery = (props: WebhookEndpointDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables> mutation={WebhookEndpointDeleteDocument} {...props} />
    );


/**
 * __useWebhookEndpointDeleteMutation__
 *
 * To run a mutation, you first call `useWebhookEndpointDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookEndpointDeleteMutation, { data, loading, error }] = useWebhookEndpointDeleteMutation({
 *   variables: {
 *      endpointId: // value for 'endpointId'
 *   },
 * });
 */
export function useWebhookEndpointDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables>(WebhookEndpointDeleteDocument, options);
      }
export type WebhookEndpointDeleteMutationHookResult = ReturnType<typeof useWebhookEndpointDeleteMutation>;
export type WebhookEndpointDeleteMutationResult = Apollo.MutationResult<WebhookEndpointDeleteMutation>;
export type WebhookEndpointDeleteMutationOptions = Apollo.BaseMutationOptions<WebhookEndpointDeleteMutation, WebhookEndpointDeleteMutationVariables>;
export const SchoolManageGetStateByKeyDocument = gql`
    query SchoolManageGetStateByKey($schoolId: Int!, $key: SchoolStateKey!) {
  schoolManageGetStateByKey(schoolId: $schoolId, key: $key)
}
    `;
export type SchoolManageGetStateByKeyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>, 'query'> & ({ variables: SchoolManageGetStateByKeyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolManageGetStateByKeyQuery = (props: SchoolManageGetStateByKeyQueryProps) => (
      <ApolloReactComponents.Query<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables> query={SchoolManageGetStateByKeyDocument} {...props} />
    );


/**
 * __useSchoolManageGetStateByKeyQuery__
 *
 * To run a query within a React component, call `useSchoolManageGetStateByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageGetStateByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolManageGetStateByKeyQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSchoolManageGetStateByKeyQuery(baseOptions: Apollo.QueryHookOptions<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables> & ({ variables: SchoolManageGetStateByKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>(SchoolManageGetStateByKeyDocument, options);
      }
export function useSchoolManageGetStateByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>(SchoolManageGetStateByKeyDocument, options);
        }
export function useSchoolManageGetStateByKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>(SchoolManageGetStateByKeyDocument, options);
        }
export type SchoolManageGetStateByKeyQueryHookResult = ReturnType<typeof useSchoolManageGetStateByKeyQuery>;
export type SchoolManageGetStateByKeyLazyQueryHookResult = ReturnType<typeof useSchoolManageGetStateByKeyLazyQuery>;
export type SchoolManageGetStateByKeySuspenseQueryHookResult = ReturnType<typeof useSchoolManageGetStateByKeySuspenseQuery>;
export type SchoolManageGetStateByKeyQueryResult = Apollo.QueryResult<SchoolManageGetStateByKeyQuery, SchoolManageGetStateByKeyQueryVariables>;
export const SchoolManageSetStateByKeyDocument = gql`
    mutation SchoolManageSetStateByKey($schoolId: Int!, $key: SchoolStateKey!, $input: JsonObjectInput!) {
  schoolManageSetStateByKey(schoolId: $schoolId, key: $key, input: $input)
}
    `;
export type SchoolManageSetStateByKeyMutationFn = Apollo.MutationFunction<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables>;
export type SchoolManageSetStateByKeyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables>, 'mutation'>;

    export const SchoolManageSetStateByKeyQuery = (props: SchoolManageSetStateByKeyQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables> mutation={SchoolManageSetStateByKeyDocument} {...props} />
    );


/**
 * __useSchoolManageSetStateByKeyMutation__
 *
 * To run a mutation, you first call `useSchoolManageSetStateByKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageSetStateByKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolManageSetStateByKeyMutation, { data, loading, error }] = useSchoolManageSetStateByKeyMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolManageSetStateByKeyMutation(baseOptions?: Apollo.MutationHookOptions<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables>(SchoolManageSetStateByKeyDocument, options);
      }
export type SchoolManageSetStateByKeyMutationHookResult = ReturnType<typeof useSchoolManageSetStateByKeyMutation>;
export type SchoolManageSetStateByKeyMutationResult = Apollo.MutationResult<SchoolManageSetStateByKeyMutation>;
export type SchoolManageSetStateByKeyMutationOptions = Apollo.BaseMutationOptions<SchoolManageSetStateByKeyMutation, SchoolManageSetStateByKeyMutationVariables>;
export const SchoolManageListenUpdateDocument = gql`
    subscription SchoolManageListenUpdate($schoolId: Int!) {
  schoolListenUpdate(schoolId: $schoolId) {
    ...SchoolManageFragment
  }
}
    ${SchoolManageFragmentFragmentDoc}`;
export type SchoolManageListenUpdateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<SchoolManageListenUpdateSubscription, SchoolManageListenUpdateSubscriptionVariables>, 'subscription'>;

    export const SchoolManageListenUpdateQuery = (props: SchoolManageListenUpdateQueryProps) => (
      <ApolloReactComponents.Subscription<SchoolManageListenUpdateSubscription, SchoolManageListenUpdateSubscriptionVariables> subscription={SchoolManageListenUpdateDocument} {...props} />
    );


/**
 * __useSchoolManageListenUpdateSubscription__
 *
 * To run a query within a React component, call `useSchoolManageListenUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageListenUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolManageListenUpdateSubscription({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSchoolManageListenUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchoolManageListenUpdateSubscription, SchoolManageListenUpdateSubscriptionVariables> & ({ variables: SchoolManageListenUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchoolManageListenUpdateSubscription, SchoolManageListenUpdateSubscriptionVariables>(SchoolManageListenUpdateDocument, options);
      }
export type SchoolManageListenUpdateSubscriptionHookResult = ReturnType<typeof useSchoolManageListenUpdateSubscription>;
export type SchoolManageListenUpdateSubscriptionResult = Apollo.SubscriptionResult<SchoolManageListenUpdateSubscription>;
export const SellerBalanceOperationFindOneDocument = gql`
    query SellerBalanceOperationFindOne($operationId: Int!) {
  sellerBalanceOperationFindOne(operationId: $operationId) {
    ...SellerBalanceOperationFragment
  }
}
    ${SellerBalanceOperationFragmentFragmentDoc}`;
export type SellerBalanceOperationFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>, 'query'> & ({ variables: SellerBalanceOperationFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerBalanceOperationFindOneQuery = (props: SellerBalanceOperationFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables> query={SellerBalanceOperationFindOneDocument} {...props} />
    );


/**
 * __useSellerBalanceOperationFindOneQuery__
 *
 * To run a query within a React component, call `useSellerBalanceOperationFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerBalanceOperationFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerBalanceOperationFindOneQuery({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useSellerBalanceOperationFindOneQuery(baseOptions: Apollo.QueryHookOptions<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables> & ({ variables: SellerBalanceOperationFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>(SellerBalanceOperationFindOneDocument, options);
      }
export function useSellerBalanceOperationFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>(SellerBalanceOperationFindOneDocument, options);
        }
export function useSellerBalanceOperationFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>(SellerBalanceOperationFindOneDocument, options);
        }
export type SellerBalanceOperationFindOneQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindOneQuery>;
export type SellerBalanceOperationFindOneLazyQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindOneLazyQuery>;
export type SellerBalanceOperationFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindOneSuspenseQuery>;
export type SellerBalanceOperationFindOneQueryResult = Apollo.QueryResult<SellerBalanceOperationFindOneQuery, SellerBalanceOperationFindOneQueryVariables>;
export const SellerBalanceOperationFindManyDocument = gql`
    query SellerBalanceOperationFindMany($list: ListInput!, $filter: FilterBalanceOperationSellerInput!, $sort: BaseSortInput!) {
  sellerBalanceOperationFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      ...SellerBalanceOperationFragment
    }
  }
}
    ${SellerBalanceOperationFragmentFragmentDoc}`;
export type SellerBalanceOperationFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>, 'query'> & ({ variables: SellerBalanceOperationFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerBalanceOperationFindManyQuery = (props: SellerBalanceOperationFindManyQueryProps) => (
      <ApolloReactComponents.Query<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables> query={SellerBalanceOperationFindManyDocument} {...props} />
    );


/**
 * __useSellerBalanceOperationFindManyQuery__
 *
 * To run a query within a React component, call `useSellerBalanceOperationFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerBalanceOperationFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerBalanceOperationFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSellerBalanceOperationFindManyQuery(baseOptions: Apollo.QueryHookOptions<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables> & ({ variables: SellerBalanceOperationFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>(SellerBalanceOperationFindManyDocument, options);
      }
export function useSellerBalanceOperationFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>(SellerBalanceOperationFindManyDocument, options);
        }
export function useSellerBalanceOperationFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>(SellerBalanceOperationFindManyDocument, options);
        }
export type SellerBalanceOperationFindManyQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindManyQuery>;
export type SellerBalanceOperationFindManyLazyQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindManyLazyQuery>;
export type SellerBalanceOperationFindManySuspenseQueryHookResult = ReturnType<typeof useSellerBalanceOperationFindManySuspenseQuery>;
export type SellerBalanceOperationFindManyQueryResult = Apollo.QueryResult<SellerBalanceOperationFindManyQuery, SellerBalanceOperationFindManyQueryVariables>;
export const SellerBecomeRequestFindOneDocument = gql`
    query SellerBecomeRequestFindOne($requestId: Int!) {
  sellerBecomeRequestFindOne(requestId: $requestId) {
    ...SellerBecomeRequestFragment
  }
}
    ${SellerBecomeRequestFragmentFragmentDoc}`;
export type SellerBecomeRequestFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>, 'query'> & ({ variables: SellerBecomeRequestFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerBecomeRequestFindOneQuery = (props: SellerBecomeRequestFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables> query={SellerBecomeRequestFindOneDocument} {...props} />
    );


/**
 * __useSellerBecomeRequestFindOneQuery__
 *
 * To run a query within a React component, call `useSellerBecomeRequestFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerBecomeRequestFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerBecomeRequestFindOneQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useSellerBecomeRequestFindOneQuery(baseOptions: Apollo.QueryHookOptions<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables> & ({ variables: SellerBecomeRequestFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>(SellerBecomeRequestFindOneDocument, options);
      }
export function useSellerBecomeRequestFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>(SellerBecomeRequestFindOneDocument, options);
        }
export function useSellerBecomeRequestFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>(SellerBecomeRequestFindOneDocument, options);
        }
export type SellerBecomeRequestFindOneQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneQuery>;
export type SellerBecomeRequestFindOneLazyQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneLazyQuery>;
export type SellerBecomeRequestFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneSuspenseQuery>;
export type SellerBecomeRequestFindOneQueryResult = Apollo.QueryResult<SellerBecomeRequestFindOneQuery, SellerBecomeRequestFindOneQueryVariables>;
export const SellerBecomeRequestFindOneByCurrentUserDocument = gql`
    query SellerBecomeRequestFindOneByCurrentUser {
  sellerBecomeRequestFindOneByCurrentUser {
    id
    status
  }
}
    `;
export type SellerBecomeRequestFindOneByCurrentUserQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>, 'query'>;

    export const SellerBecomeRequestFindOneByCurrentUserQuery = (props: SellerBecomeRequestFindOneByCurrentUserQueryProps) => (
      <ApolloReactComponents.Query<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables> query={SellerBecomeRequestFindOneByCurrentUserDocument} {...props} />
    );


/**
 * __useSellerBecomeRequestFindOneByCurrentUserQuery__
 *
 * To run a query within a React component, call `useSellerBecomeRequestFindOneByCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerBecomeRequestFindOneByCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerBecomeRequestFindOneByCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSellerBecomeRequestFindOneByCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>(SellerBecomeRequestFindOneByCurrentUserDocument, options);
      }
export function useSellerBecomeRequestFindOneByCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>(SellerBecomeRequestFindOneByCurrentUserDocument, options);
        }
export function useSellerBecomeRequestFindOneByCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>(SellerBecomeRequestFindOneByCurrentUserDocument, options);
        }
export type SellerBecomeRequestFindOneByCurrentUserQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneByCurrentUserQuery>;
export type SellerBecomeRequestFindOneByCurrentUserLazyQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneByCurrentUserLazyQuery>;
export type SellerBecomeRequestFindOneByCurrentUserSuspenseQueryHookResult = ReturnType<typeof useSellerBecomeRequestFindOneByCurrentUserSuspenseQuery>;
export type SellerBecomeRequestFindOneByCurrentUserQueryResult = Apollo.QueryResult<SellerBecomeRequestFindOneByCurrentUserQuery, SellerBecomeRequestFindOneByCurrentUserQueryVariables>;
export const RequestBecomeSellerDocument = gql`
    mutation RequestBecomeSeller($request: SellerBecomeRequestInput!, $requestId: Int) {
  sellerBecomeRequestUpsert(request: $request, requestId: $requestId) {
    ...SellerBecomeRequestFragment
  }
}
    ${SellerBecomeRequestFragmentFragmentDoc}`;
export type RequestBecomeSellerMutationFn = Apollo.MutationFunction<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables>;
export type RequestBecomeSellerQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables>, 'mutation'>;

    export const RequestBecomeSellerQuery = (props: RequestBecomeSellerQueryProps) => (
      <ApolloReactComponents.Mutation<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables> mutation={RequestBecomeSellerDocument} {...props} />
    );


/**
 * __useRequestBecomeSellerMutation__
 *
 * To run a mutation, you first call `useRequestBecomeSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBecomeSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBecomeSellerMutation, { data, loading, error }] = useRequestBecomeSellerMutation({
 *   variables: {
 *      request: // value for 'request'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRequestBecomeSellerMutation(baseOptions?: Apollo.MutationHookOptions<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables>(RequestBecomeSellerDocument, options);
      }
export type RequestBecomeSellerMutationHookResult = ReturnType<typeof useRequestBecomeSellerMutation>;
export type RequestBecomeSellerMutationResult = Apollo.MutationResult<RequestBecomeSellerMutation>;
export type RequestBecomeSellerMutationOptions = Apollo.BaseMutationOptions<RequestBecomeSellerMutation, RequestBecomeSellerMutationVariables>;
export const SellerBecomeRequestUpsertShortFormDocument = gql`
    mutation SellerBecomeRequestUpsertShortForm($request: ShortFormSellerBecomeRequestInput!) {
  sellerBecomeRequestUpsertShortForm(request: $request) {
    id
    status
    sellerOrganization {
      id
      seller {
        ...SellerFragment
      }
    }
  }
}
    ${SellerFragmentFragmentDoc}`;
export type SellerBecomeRequestUpsertShortFormMutationFn = Apollo.MutationFunction<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables>;
export type SellerBecomeRequestUpsertShortFormQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables>, 'mutation'>;

    export const SellerBecomeRequestUpsertShortFormQuery = (props: SellerBecomeRequestUpsertShortFormQueryProps) => (
      <ApolloReactComponents.Mutation<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables> mutation={SellerBecomeRequestUpsertShortFormDocument} {...props} />
    );


/**
 * __useSellerBecomeRequestUpsertShortFormMutation__
 *
 * To run a mutation, you first call `useSellerBecomeRequestUpsertShortFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerBecomeRequestUpsertShortFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerBecomeRequestUpsertShortFormMutation, { data, loading, error }] = useSellerBecomeRequestUpsertShortFormMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSellerBecomeRequestUpsertShortFormMutation(baseOptions?: Apollo.MutationHookOptions<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables>(SellerBecomeRequestUpsertShortFormDocument, options);
      }
export type SellerBecomeRequestUpsertShortFormMutationHookResult = ReturnType<typeof useSellerBecomeRequestUpsertShortFormMutation>;
export type SellerBecomeRequestUpsertShortFormMutationResult = Apollo.MutationResult<SellerBecomeRequestUpsertShortFormMutation>;
export type SellerBecomeRequestUpsertShortFormMutationOptions = Apollo.BaseMutationOptions<SellerBecomeRequestUpsertShortFormMutation, SellerBecomeRequestUpsertShortFormMutationVariables>;
export const SellerManagerFindOneDocument = gql`
    query SellerManagerFindOne($managerId: Int!) {
  sellerManagerFindOne(managerId: $managerId) {
    ...SellerManagerFragment
  }
}
    ${SellerManagerFragmentFragmentDoc}`;
export type SellerManagerFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>, 'query'> & ({ variables: SellerManagerFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerManagerFindOneQuery = (props: SellerManagerFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables> query={SellerManagerFindOneDocument} {...props} />
    );


/**
 * __useSellerManagerFindOneQuery__
 *
 * To run a query within a React component, call `useSellerManagerFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerManagerFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerManagerFindOneQuery({
 *   variables: {
 *      managerId: // value for 'managerId'
 *   },
 * });
 */
export function useSellerManagerFindOneQuery(baseOptions: Apollo.QueryHookOptions<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables> & ({ variables: SellerManagerFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>(SellerManagerFindOneDocument, options);
      }
export function useSellerManagerFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>(SellerManagerFindOneDocument, options);
        }
export function useSellerManagerFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>(SellerManagerFindOneDocument, options);
        }
export type SellerManagerFindOneQueryHookResult = ReturnType<typeof useSellerManagerFindOneQuery>;
export type SellerManagerFindOneLazyQueryHookResult = ReturnType<typeof useSellerManagerFindOneLazyQuery>;
export type SellerManagerFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerManagerFindOneSuspenseQuery>;
export type SellerManagerFindOneQueryResult = Apollo.QueryResult<SellerManagerFindOneQuery, SellerManagerFindOneQueryVariables>;
export const SellerProductManagerFindOneDocument = gql`
    query SellerProductManagerFindOne($productManagerId: Int!) {
  sellerProductManagerFindOne(productManagerId: $productManagerId) {
    ...SellerProductManagerFragment
  }
}
    ${SellerProductManagerFragmentFragmentDoc}`;
export type SellerProductManagerFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>, 'query'> & ({ variables: SellerProductManagerFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerProductManagerFindOneQuery = (props: SellerProductManagerFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables> query={SellerProductManagerFindOneDocument} {...props} />
    );


/**
 * __useSellerProductManagerFindOneQuery__
 *
 * To run a query within a React component, call `useSellerProductManagerFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerProductManagerFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerProductManagerFindOneQuery({
 *   variables: {
 *      productManagerId: // value for 'productManagerId'
 *   },
 * });
 */
export function useSellerProductManagerFindOneQuery(baseOptions: Apollo.QueryHookOptions<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables> & ({ variables: SellerProductManagerFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>(SellerProductManagerFindOneDocument, options);
      }
export function useSellerProductManagerFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>(SellerProductManagerFindOneDocument, options);
        }
export function useSellerProductManagerFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>(SellerProductManagerFindOneDocument, options);
        }
export type SellerProductManagerFindOneQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneQuery>;
export type SellerProductManagerFindOneLazyQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneLazyQuery>;
export type SellerProductManagerFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneSuspenseQuery>;
export type SellerProductManagerFindOneQueryResult = Apollo.QueryResult<SellerProductManagerFindOneQuery, SellerProductManagerFindOneQueryVariables>;
export const SellerManagerUpdateDocument = gql`
    mutation SellerManagerUpdate($managerId: Int!, $manager: UpdateManagerSellerInput!) {
  sellerManagerUpdate(managerId: $managerId, manager: $manager) {
    ...SellerManagerFragment
  }
}
    ${SellerManagerFragmentFragmentDoc}`;
export type SellerManagerUpdateMutationFn = Apollo.MutationFunction<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables>;
export type SellerManagerUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables>, 'mutation'>;

    export const SellerManagerUpdateQuery = (props: SellerManagerUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables> mutation={SellerManagerUpdateDocument} {...props} />
    );


/**
 * __useSellerManagerUpdateMutation__
 *
 * To run a mutation, you first call `useSellerManagerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerManagerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerManagerUpdateMutation, { data, loading, error }] = useSellerManagerUpdateMutation({
 *   variables: {
 *      managerId: // value for 'managerId'
 *      manager: // value for 'manager'
 *   },
 * });
 */
export function useSellerManagerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables>(SellerManagerUpdateDocument, options);
      }
export type SellerManagerUpdateMutationHookResult = ReturnType<typeof useSellerManagerUpdateMutation>;
export type SellerManagerUpdateMutationResult = Apollo.MutationResult<SellerManagerUpdateMutation>;
export type SellerManagerUpdateMutationOptions = Apollo.BaseMutationOptions<SellerManagerUpdateMutation, SellerManagerUpdateMutationVariables>;
export const SellerManagerDeleteDocument = gql`
    mutation SellerManagerDelete($managerId: Int!) {
  sellerManagerDelete(managerId: $managerId)
}
    `;
export type SellerManagerDeleteMutationFn = Apollo.MutationFunction<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables>;
export type SellerManagerDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables>, 'mutation'>;

    export const SellerManagerDeleteQuery = (props: SellerManagerDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables> mutation={SellerManagerDeleteDocument} {...props} />
    );


/**
 * __useSellerManagerDeleteMutation__
 *
 * To run a mutation, you first call `useSellerManagerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerManagerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerManagerDeleteMutation, { data, loading, error }] = useSellerManagerDeleteMutation({
 *   variables: {
 *      managerId: // value for 'managerId'
 *   },
 * });
 */
export function useSellerManagerDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables>(SellerManagerDeleteDocument, options);
      }
export type SellerManagerDeleteMutationHookResult = ReturnType<typeof useSellerManagerDeleteMutation>;
export type SellerManagerDeleteMutationResult = Apollo.MutationResult<SellerManagerDeleteMutation>;
export type SellerManagerDeleteMutationOptions = Apollo.BaseMutationOptions<SellerManagerDeleteMutation, SellerManagerDeleteMutationVariables>;
export const SellerFindManyManagersDocument = gql`
    query SellerFindManyManagers($list: ListInput!, $filter: FilterManagerSellerInput!, $sort: SortManagerSellerInput) {
  sellerManagerFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      ...SellerManagerFragment
    }
  }
}
    ${SellerManagerFragmentFragmentDoc}`;
export type SellerFindManyManagersQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>, 'query'> & ({ variables: SellerFindManyManagersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerFindManyManagersQuery = (props: SellerFindManyManagersQueryProps) => (
      <ApolloReactComponents.Query<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables> query={SellerFindManyManagersDocument} {...props} />
    );


/**
 * __useSellerFindManyManagersQuery__
 *
 * To run a query within a React component, call `useSellerFindManyManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerFindManyManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerFindManyManagersQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSellerFindManyManagersQuery(baseOptions: Apollo.QueryHookOptions<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables> & ({ variables: SellerFindManyManagersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>(SellerFindManyManagersDocument, options);
      }
export function useSellerFindManyManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>(SellerFindManyManagersDocument, options);
        }
export function useSellerFindManyManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>(SellerFindManyManagersDocument, options);
        }
export type SellerFindManyManagersQueryHookResult = ReturnType<typeof useSellerFindManyManagersQuery>;
export type SellerFindManyManagersLazyQueryHookResult = ReturnType<typeof useSellerFindManyManagersLazyQuery>;
export type SellerFindManyManagersSuspenseQueryHookResult = ReturnType<typeof useSellerFindManyManagersSuspenseQuery>;
export type SellerFindManyManagersQueryResult = Apollo.QueryResult<SellerFindManyManagersQuery, SellerFindManyManagersQueryVariables>;
export const SellerProductManagerFindManyDocument = gql`
    query SellerProductManagerFindMany($list: ListInput!, $filter: FilterProductManagerSellerInput!, $sort: BaseSortInput) {
  sellerProductManagerFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      ...SellerProductManagerFragment
    }
  }
}
    ${SellerProductManagerFragmentFragmentDoc}`;
export type SellerProductManagerFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>, 'query'> & ({ variables: SellerProductManagerFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerProductManagerFindManyQuery = (props: SellerProductManagerFindManyQueryProps) => (
      <ApolloReactComponents.Query<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables> query={SellerProductManagerFindManyDocument} {...props} />
    );


/**
 * __useSellerProductManagerFindManyQuery__
 *
 * To run a query within a React component, call `useSellerProductManagerFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerProductManagerFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerProductManagerFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSellerProductManagerFindManyQuery(baseOptions: Apollo.QueryHookOptions<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables> & ({ variables: SellerProductManagerFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>(SellerProductManagerFindManyDocument, options);
      }
export function useSellerProductManagerFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>(SellerProductManagerFindManyDocument, options);
        }
export function useSellerProductManagerFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>(SellerProductManagerFindManyDocument, options);
        }
export type SellerProductManagerFindManyQueryHookResult = ReturnType<typeof useSellerProductManagerFindManyQuery>;
export type SellerProductManagerFindManyLazyQueryHookResult = ReturnType<typeof useSellerProductManagerFindManyLazyQuery>;
export type SellerProductManagerFindManySuspenseQueryHookResult = ReturnType<typeof useSellerProductManagerFindManySuspenseQuery>;
export type SellerProductManagerFindManyQueryResult = Apollo.QueryResult<SellerProductManagerFindManyQuery, SellerProductManagerFindManyQueryVariables>;
export const SellerProductManagerFindOneByUserAndProductDocument = gql`
    query SellerProductManagerFindOneByUserAndProduct($userId: Int!, $productId: Int!) {
  sellerProductManagerFindOneByUserAndProduct(
    userId: $userId
    productId: $productId
  ) {
    ...SellerProductManagerFragment
  }
}
    ${SellerProductManagerFragmentFragmentDoc}`;
export type SellerProductManagerFindOneByUserAndProductQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>, 'query'> & ({ variables: SellerProductManagerFindOneByUserAndProductQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerProductManagerFindOneByUserAndProductQuery = (props: SellerProductManagerFindOneByUserAndProductQueryProps) => (
      <ApolloReactComponents.Query<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables> query={SellerProductManagerFindOneByUserAndProductDocument} {...props} />
    );


/**
 * __useSellerProductManagerFindOneByUserAndProductQuery__
 *
 * To run a query within a React component, call `useSellerProductManagerFindOneByUserAndProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerProductManagerFindOneByUserAndProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerProductManagerFindOneByUserAndProductQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useSellerProductManagerFindOneByUserAndProductQuery(baseOptions: Apollo.QueryHookOptions<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables> & ({ variables: SellerProductManagerFindOneByUserAndProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>(SellerProductManagerFindOneByUserAndProductDocument, options);
      }
export function useSellerProductManagerFindOneByUserAndProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>(SellerProductManagerFindOneByUserAndProductDocument, options);
        }
export function useSellerProductManagerFindOneByUserAndProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>(SellerProductManagerFindOneByUserAndProductDocument, options);
        }
export type SellerProductManagerFindOneByUserAndProductQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneByUserAndProductQuery>;
export type SellerProductManagerFindOneByUserAndProductLazyQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneByUserAndProductLazyQuery>;
export type SellerProductManagerFindOneByUserAndProductSuspenseQueryHookResult = ReturnType<typeof useSellerProductManagerFindOneByUserAndProductSuspenseQuery>;
export type SellerProductManagerFindOneByUserAndProductQueryResult = Apollo.QueryResult<SellerProductManagerFindOneByUserAndProductQuery, SellerProductManagerFindOneByUserAndProductQueryVariables>;
export const SellerManagerFindOneByUserDocument = gql`
    query SellerManagerFindOneByUser($userId: Int!) {
  sellerManagerFindOneByUser(userId: $userId) {
    ...SellerManagerFragment
  }
}
    ${SellerManagerFragmentFragmentDoc}`;
export type SellerManagerFindOneByUserQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>, 'query'> & ({ variables: SellerManagerFindOneByUserQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerManagerFindOneByUserQuery = (props: SellerManagerFindOneByUserQueryProps) => (
      <ApolloReactComponents.Query<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables> query={SellerManagerFindOneByUserDocument} {...props} />
    );


/**
 * __useSellerManagerFindOneByUserQuery__
 *
 * To run a query within a React component, call `useSellerManagerFindOneByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerManagerFindOneByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerManagerFindOneByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSellerManagerFindOneByUserQuery(baseOptions: Apollo.QueryHookOptions<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables> & ({ variables: SellerManagerFindOneByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>(SellerManagerFindOneByUserDocument, options);
      }
export function useSellerManagerFindOneByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>(SellerManagerFindOneByUserDocument, options);
        }
export function useSellerManagerFindOneByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>(SellerManagerFindOneByUserDocument, options);
        }
export type SellerManagerFindOneByUserQueryHookResult = ReturnType<typeof useSellerManagerFindOneByUserQuery>;
export type SellerManagerFindOneByUserLazyQueryHookResult = ReturnType<typeof useSellerManagerFindOneByUserLazyQuery>;
export type SellerManagerFindOneByUserSuspenseQueryHookResult = ReturnType<typeof useSellerManagerFindOneByUserSuspenseQuery>;
export type SellerManagerFindOneByUserQueryResult = Apollo.QueryResult<SellerManagerFindOneByUserQuery, SellerManagerFindOneByUserQueryVariables>;
export const SellerManagerCreateDocument = gql`
    mutation SellerManagerCreate($manager: CreateManagerSellerInput!) {
  sellerManagerCreate(manager: $manager) {
    ...SellerManagerFragment
  }
}
    ${SellerManagerFragmentFragmentDoc}`;
export type SellerManagerCreateMutationFn = Apollo.MutationFunction<SellerManagerCreateMutation, SellerManagerCreateMutationVariables>;
export type SellerManagerCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerManagerCreateMutation, SellerManagerCreateMutationVariables>, 'mutation'>;

    export const SellerManagerCreateQuery = (props: SellerManagerCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerManagerCreateMutation, SellerManagerCreateMutationVariables> mutation={SellerManagerCreateDocument} {...props} />
    );


/**
 * __useSellerManagerCreateMutation__
 *
 * To run a mutation, you first call `useSellerManagerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerManagerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerManagerCreateMutation, { data, loading, error }] = useSellerManagerCreateMutation({
 *   variables: {
 *      manager: // value for 'manager'
 *   },
 * });
 */
export function useSellerManagerCreateMutation(baseOptions?: Apollo.MutationHookOptions<SellerManagerCreateMutation, SellerManagerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerManagerCreateMutation, SellerManagerCreateMutationVariables>(SellerManagerCreateDocument, options);
      }
export type SellerManagerCreateMutationHookResult = ReturnType<typeof useSellerManagerCreateMutation>;
export type SellerManagerCreateMutationResult = Apollo.MutationResult<SellerManagerCreateMutation>;
export type SellerManagerCreateMutationOptions = Apollo.BaseMutationOptions<SellerManagerCreateMutation, SellerManagerCreateMutationVariables>;
export const SellerProductManagerCreateDocument = gql`
    mutation SellerProductManagerCreate($productManager: CreateProductManagerSellerInput!) {
  sellerProductManagerCreate(productManager: $productManager) {
    ...SellerProductManagerFragment
  }
}
    ${SellerProductManagerFragmentFragmentDoc}`;
export type SellerProductManagerCreateMutationFn = Apollo.MutationFunction<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables>;
export type SellerProductManagerCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables>, 'mutation'>;

    export const SellerProductManagerCreateQuery = (props: SellerProductManagerCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables> mutation={SellerProductManagerCreateDocument} {...props} />
    );


/**
 * __useSellerProductManagerCreateMutation__
 *
 * To run a mutation, you first call `useSellerProductManagerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerProductManagerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerProductManagerCreateMutation, { data, loading, error }] = useSellerProductManagerCreateMutation({
 *   variables: {
 *      productManager: // value for 'productManager'
 *   },
 * });
 */
export function useSellerProductManagerCreateMutation(baseOptions?: Apollo.MutationHookOptions<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables>(SellerProductManagerCreateDocument, options);
      }
export type SellerProductManagerCreateMutationHookResult = ReturnType<typeof useSellerProductManagerCreateMutation>;
export type SellerProductManagerCreateMutationResult = Apollo.MutationResult<SellerProductManagerCreateMutation>;
export type SellerProductManagerCreateMutationOptions = Apollo.BaseMutationOptions<SellerProductManagerCreateMutation, SellerProductManagerCreateMutationVariables>;
export const SellerProductManagerUpdateDocument = gql`
    mutation SellerProductManagerUpdate($productManagerId: Int!, $productManager: UpdateProductManagerSellerInput!) {
  sellerProductManagerUpdate(
    productManager: $productManager
    productManagerId: $productManagerId
  ) {
    ...SellerProductManagerFragment
  }
}
    ${SellerProductManagerFragmentFragmentDoc}`;
export type SellerProductManagerUpdateMutationFn = Apollo.MutationFunction<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables>;
export type SellerProductManagerUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables>, 'mutation'>;

    export const SellerProductManagerUpdateQuery = (props: SellerProductManagerUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables> mutation={SellerProductManagerUpdateDocument} {...props} />
    );


/**
 * __useSellerProductManagerUpdateMutation__
 *
 * To run a mutation, you first call `useSellerProductManagerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerProductManagerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerProductManagerUpdateMutation, { data, loading, error }] = useSellerProductManagerUpdateMutation({
 *   variables: {
 *      productManagerId: // value for 'productManagerId'
 *      productManager: // value for 'productManager'
 *   },
 * });
 */
export function useSellerProductManagerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables>(SellerProductManagerUpdateDocument, options);
      }
export type SellerProductManagerUpdateMutationHookResult = ReturnType<typeof useSellerProductManagerUpdateMutation>;
export type SellerProductManagerUpdateMutationResult = Apollo.MutationResult<SellerProductManagerUpdateMutation>;
export type SellerProductManagerUpdateMutationOptions = Apollo.BaseMutationOptions<SellerProductManagerUpdateMutation, SellerProductManagerUpdateMutationVariables>;
export const SellerInfoFindOneDocument = gql`
    query SellerInfoFindOne {
  sellerCurrentUserSeller {
    id
    verified
    organization {
      ...SellerOrganizationFragment
      request {
        id
        status
      }
    }
  }
  payoutCommissionFindOneCurrent {
    ...PayoutCommissionFragment
  }
}
    ${SellerOrganizationFragmentFragmentDoc}
${PayoutCommissionFragmentFragmentDoc}`;
export type SellerInfoFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>, 'query'>;

    export const SellerInfoFindOneQuery = (props: SellerInfoFindOneQueryProps) => (
      <ApolloReactComponents.Query<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables> query={SellerInfoFindOneDocument} {...props} />
    );


/**
 * __useSellerInfoFindOneQuery__
 *
 * To run a query within a React component, call `useSellerInfoFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerInfoFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerInfoFindOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useSellerInfoFindOneQuery(baseOptions?: Apollo.QueryHookOptions<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>(SellerInfoFindOneDocument, options);
      }
export function useSellerInfoFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>(SellerInfoFindOneDocument, options);
        }
export function useSellerInfoFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>(SellerInfoFindOneDocument, options);
        }
export type SellerInfoFindOneQueryHookResult = ReturnType<typeof useSellerInfoFindOneQuery>;
export type SellerInfoFindOneLazyQueryHookResult = ReturnType<typeof useSellerInfoFindOneLazyQuery>;
export type SellerInfoFindOneSuspenseQueryHookResult = ReturnType<typeof useSellerInfoFindOneSuspenseQuery>;
export type SellerInfoFindOneQueryResult = Apollo.QueryResult<SellerInfoFindOneQuery, SellerInfoFindOneQueryVariables>;
export const SellerCurrentBalanceDocument = gql`
    query SellerCurrentBalance {
  sellerBalanceCurrent {
    ...SellerCurrentBalanceFragment
  }
}
    ${SellerCurrentBalanceFragmentFragmentDoc}`;
export type SellerCurrentBalanceQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>, 'query'>;

    export const SellerCurrentBalanceQuery = (props: SellerCurrentBalanceQueryProps) => (
      <ApolloReactComponents.Query<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables> query={SellerCurrentBalanceDocument} {...props} />
    );


/**
 * __useSellerCurrentBalanceQuery__
 *
 * To run a query within a React component, call `useSellerCurrentBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerCurrentBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerCurrentBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useSellerCurrentBalanceQuery(baseOptions?: Apollo.QueryHookOptions<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>(SellerCurrentBalanceDocument, options);
      }
export function useSellerCurrentBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>(SellerCurrentBalanceDocument, options);
        }
export function useSellerCurrentBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>(SellerCurrentBalanceDocument, options);
        }
export type SellerCurrentBalanceQueryHookResult = ReturnType<typeof useSellerCurrentBalanceQuery>;
export type SellerCurrentBalanceLazyQueryHookResult = ReturnType<typeof useSellerCurrentBalanceLazyQuery>;
export type SellerCurrentBalanceSuspenseQueryHookResult = ReturnType<typeof useSellerCurrentBalanceSuspenseQuery>;
export type SellerCurrentBalanceQueryResult = Apollo.QueryResult<SellerCurrentBalanceQuery, SellerCurrentBalanceQueryVariables>;
export const SellerOrganizationUpdateDocument = gql`
    mutation SellerOrganizationUpdate($sellerOrganizationId: Int!, $organization: UpdateOrganizationSellerInput!) {
  sellerOrganizationUpdate(
    sellerOrganizationId: $sellerOrganizationId
    organization: $organization
  ) {
    ...SellerOrganizationFragment
    request {
      id
      status
    }
  }
}
    ${SellerOrganizationFragmentFragmentDoc}`;
export type SellerOrganizationUpdateMutationFn = Apollo.MutationFunction<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables>;
export type SellerOrganizationUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables>, 'mutation'>;

    export const SellerOrganizationUpdateQuery = (props: SellerOrganizationUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables> mutation={SellerOrganizationUpdateDocument} {...props} />
    );


/**
 * __useSellerOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useSellerOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerOrganizationUpdateMutation, { data, loading, error }] = useSellerOrganizationUpdateMutation({
 *   variables: {
 *      sellerOrganizationId: // value for 'sellerOrganizationId'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSellerOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables>(SellerOrganizationUpdateDocument, options);
      }
export type SellerOrganizationUpdateMutationHookResult = ReturnType<typeof useSellerOrganizationUpdateMutation>;
export type SellerOrganizationUpdateMutationResult = Apollo.MutationResult<SellerOrganizationUpdateMutation>;
export type SellerOrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<SellerOrganizationUpdateMutation, SellerOrganizationUpdateMutationVariables>;
export const SellerOrganizationFindManyDocumentsDocument = gql`
    query SellerOrganizationFindManyDocuments($list: ListInput!, $filter: FilterOrganizationDocumentSellerInput!, $sort: BaseSortInput) {
  sellerOrganizationDocumentFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      id
      location
      updatedAt
      type
    }
  }
}
    `;
export type SellerOrganizationFindManyDocumentsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>, 'query'> & ({ variables: SellerOrganizationFindManyDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SellerOrganizationFindManyDocumentsQuery = (props: SellerOrganizationFindManyDocumentsQueryProps) => (
      <ApolloReactComponents.Query<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables> query={SellerOrganizationFindManyDocumentsDocument} {...props} />
    );


/**
 * __useSellerOrganizationFindManyDocumentsQuery__
 *
 * To run a query within a React component, call `useSellerOrganizationFindManyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerOrganizationFindManyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerOrganizationFindManyDocumentsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSellerOrganizationFindManyDocumentsQuery(baseOptions: Apollo.QueryHookOptions<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables> & ({ variables: SellerOrganizationFindManyDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>(SellerOrganizationFindManyDocumentsDocument, options);
      }
export function useSellerOrganizationFindManyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>(SellerOrganizationFindManyDocumentsDocument, options);
        }
export function useSellerOrganizationFindManyDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>(SellerOrganizationFindManyDocumentsDocument, options);
        }
export type SellerOrganizationFindManyDocumentsQueryHookResult = ReturnType<typeof useSellerOrganizationFindManyDocumentsQuery>;
export type SellerOrganizationFindManyDocumentsLazyQueryHookResult = ReturnType<typeof useSellerOrganizationFindManyDocumentsLazyQuery>;
export type SellerOrganizationFindManyDocumentsSuspenseQueryHookResult = ReturnType<typeof useSellerOrganizationFindManyDocumentsSuspenseQuery>;
export type SellerOrganizationFindManyDocumentsQueryResult = Apollo.QueryResult<SellerOrganizationFindManyDocumentsQuery, SellerOrganizationFindManyDocumentsQueryVariables>;
export const CompanyGetOrganizationInfoByInnDocument = gql`
    query CompanyGetOrganizationInfoByInn($inn: String!) {
  companyGetOrganizationInfoByInn(inn: $inn) {
    inn
    name
    isActive
  }
}
    `;
export type CompanyGetOrganizationInfoByInnQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>, 'query'> & ({ variables: CompanyGetOrganizationInfoByInnQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CompanyGetOrganizationInfoByInnQuery = (props: CompanyGetOrganizationInfoByInnQueryProps) => (
      <ApolloReactComponents.Query<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables> query={CompanyGetOrganizationInfoByInnDocument} {...props} />
    );


/**
 * __useCompanyGetOrganizationInfoByInnQuery__
 *
 * To run a query within a React component, call `useCompanyGetOrganizationInfoByInnQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGetOrganizationInfoByInnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGetOrganizationInfoByInnQuery({
 *   variables: {
 *      inn: // value for 'inn'
 *   },
 * });
 */
export function useCompanyGetOrganizationInfoByInnQuery(baseOptions: Apollo.QueryHookOptions<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables> & ({ variables: CompanyGetOrganizationInfoByInnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>(CompanyGetOrganizationInfoByInnDocument, options);
      }
export function useCompanyGetOrganizationInfoByInnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>(CompanyGetOrganizationInfoByInnDocument, options);
        }
export function useCompanyGetOrganizationInfoByInnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>(CompanyGetOrganizationInfoByInnDocument, options);
        }
export type CompanyGetOrganizationInfoByInnQueryHookResult = ReturnType<typeof useCompanyGetOrganizationInfoByInnQuery>;
export type CompanyGetOrganizationInfoByInnLazyQueryHookResult = ReturnType<typeof useCompanyGetOrganizationInfoByInnLazyQuery>;
export type CompanyGetOrganizationInfoByInnSuspenseQueryHookResult = ReturnType<typeof useCompanyGetOrganizationInfoByInnSuspenseQuery>;
export type CompanyGetOrganizationInfoByInnQueryResult = Apollo.QueryResult<CompanyGetOrganizationInfoByInnQuery, CompanyGetOrganizationInfoByInnQueryVariables>;
export const CompanyGetBankInfoByBicDocument = gql`
    query CompanyGetBankInfoByBic($bic: String!) {
  companyGetBankInfoByBic(bic: $bic) {
    bic
    name
    isActive
  }
}
    `;
export type CompanyGetBankInfoByBicQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>, 'query'> & ({ variables: CompanyGetBankInfoByBicQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CompanyGetBankInfoByBicQuery = (props: CompanyGetBankInfoByBicQueryProps) => (
      <ApolloReactComponents.Query<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables> query={CompanyGetBankInfoByBicDocument} {...props} />
    );


/**
 * __useCompanyGetBankInfoByBicQuery__
 *
 * To run a query within a React component, call `useCompanyGetBankInfoByBicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGetBankInfoByBicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGetBankInfoByBicQuery({
 *   variables: {
 *      bic: // value for 'bic'
 *   },
 * });
 */
export function useCompanyGetBankInfoByBicQuery(baseOptions: Apollo.QueryHookOptions<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables> & ({ variables: CompanyGetBankInfoByBicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>(CompanyGetBankInfoByBicDocument, options);
      }
export function useCompanyGetBankInfoByBicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>(CompanyGetBankInfoByBicDocument, options);
        }
export function useCompanyGetBankInfoByBicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>(CompanyGetBankInfoByBicDocument, options);
        }
export type CompanyGetBankInfoByBicQueryHookResult = ReturnType<typeof useCompanyGetBankInfoByBicQuery>;
export type CompanyGetBankInfoByBicLazyQueryHookResult = ReturnType<typeof useCompanyGetBankInfoByBicLazyQuery>;
export type CompanyGetBankInfoByBicSuspenseQueryHookResult = ReturnType<typeof useCompanyGetBankInfoByBicSuspenseQuery>;
export type CompanyGetBankInfoByBicQueryResult = Apollo.QueryResult<CompanyGetBankInfoByBicQuery, CompanyGetBankInfoByBicQueryVariables>;
export const GetUserSellersDocument = gql`
    query GetUserSellers {
  sellerFindManyByUser(list: {skip: 0}) {
    items {
      ...SellerFragment
    }
  }
}
    ${SellerFragmentFragmentDoc}`;
export type GetUserSellersQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserSellersQuery, GetUserSellersQueryVariables>, 'query'>;

    export const GetUserSellersQuery = (props: GetUserSellersQueryProps) => (
      <ApolloReactComponents.Query<GetUserSellersQuery, GetUserSellersQueryVariables> query={GetUserSellersDocument} {...props} />
    );


/**
 * __useGetUserSellersQuery__
 *
 * To run a query within a React component, call `useGetUserSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSellersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSellersQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSellersQuery, GetUserSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSellersQuery, GetUserSellersQueryVariables>(GetUserSellersDocument, options);
      }
export function useGetUserSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSellersQuery, GetUserSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSellersQuery, GetUserSellersQueryVariables>(GetUserSellersDocument, options);
        }
export function useGetUserSellersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSellersQuery, GetUserSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSellersQuery, GetUserSellersQueryVariables>(GetUserSellersDocument, options);
        }
export type GetUserSellersQueryHookResult = ReturnType<typeof useGetUserSellersQuery>;
export type GetUserSellersLazyQueryHookResult = ReturnType<typeof useGetUserSellersLazyQuery>;
export type GetUserSellersSuspenseQueryHookResult = ReturnType<typeof useGetUserSellersSuspenseQuery>;
export type GetUserSellersQueryResult = Apollo.QueryResult<GetUserSellersQuery, GetUserSellersQueryVariables>;
export const SellerCurrentUserSellerDocument = gql`
    query SellerCurrentUserSeller {
  sellerCurrentUserSeller {
    verified
    organization {
      ...SellerOrganizationFragment
      request {
        id
        status
      }
    }
    ...SellerFragment
  }
}
    ${SellerOrganizationFragmentFragmentDoc}
${SellerFragmentFragmentDoc}`;
export type SellerCurrentUserSellerQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>, 'query'>;

    export const SellerCurrentUserSellerQuery = (props: SellerCurrentUserSellerQueryProps) => (
      <ApolloReactComponents.Query<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables> query={SellerCurrentUserSellerDocument} {...props} />
    );


/**
 * __useSellerCurrentUserSellerQuery__
 *
 * To run a query within a React component, call `useSellerCurrentUserSellerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerCurrentUserSellerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerCurrentUserSellerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSellerCurrentUserSellerQuery(baseOptions?: Apollo.QueryHookOptions<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>(SellerCurrentUserSellerDocument, options);
      }
export function useSellerCurrentUserSellerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>(SellerCurrentUserSellerDocument, options);
        }
export function useSellerCurrentUserSellerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>(SellerCurrentUserSellerDocument, options);
        }
export type SellerCurrentUserSellerQueryHookResult = ReturnType<typeof useSellerCurrentUserSellerQuery>;
export type SellerCurrentUserSellerLazyQueryHookResult = ReturnType<typeof useSellerCurrentUserSellerLazyQuery>;
export type SellerCurrentUserSellerSuspenseQueryHookResult = ReturnType<typeof useSellerCurrentUserSellerSuspenseQuery>;
export type SellerCurrentUserSellerQueryResult = Apollo.QueryResult<SellerCurrentUserSellerQuery, SellerCurrentUserSellerQueryVariables>;
export const StoriesFindOneDocument = gql`
    query StoriesFindOne($storiesId: Int!) {
  storiesFindOne(storiesId: $storiesId) {
    ...StoriesFragment
  }
}
    ${StoriesFragmentFragmentDoc}`;
export type StoriesFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<StoriesFindOneQuery, StoriesFindOneQueryVariables>, 'query'> & ({ variables: StoriesFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StoriesFindOneQuery = (props: StoriesFindOneQueryProps) => (
      <ApolloReactComponents.Query<StoriesFindOneQuery, StoriesFindOneQueryVariables> query={StoriesFindOneDocument} {...props} />
    );


/**
 * __useStoriesFindOneQuery__
 *
 * To run a query within a React component, call `useStoriesFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesFindOneQuery({
 *   variables: {
 *      storiesId: // value for 'storiesId'
 *   },
 * });
 */
export function useStoriesFindOneQuery(baseOptions: Apollo.QueryHookOptions<StoriesFindOneQuery, StoriesFindOneQueryVariables> & ({ variables: StoriesFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesFindOneQuery, StoriesFindOneQueryVariables>(StoriesFindOneDocument, options);
      }
export function useStoriesFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesFindOneQuery, StoriesFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesFindOneQuery, StoriesFindOneQueryVariables>(StoriesFindOneDocument, options);
        }
export function useStoriesFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoriesFindOneQuery, StoriesFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoriesFindOneQuery, StoriesFindOneQueryVariables>(StoriesFindOneDocument, options);
        }
export type StoriesFindOneQueryHookResult = ReturnType<typeof useStoriesFindOneQuery>;
export type StoriesFindOneLazyQueryHookResult = ReturnType<typeof useStoriesFindOneLazyQuery>;
export type StoriesFindOneSuspenseQueryHookResult = ReturnType<typeof useStoriesFindOneSuspenseQuery>;
export type StoriesFindOneQueryResult = Apollo.QueryResult<StoriesFindOneQuery, StoriesFindOneQueryVariables>;
export const StoriesCreateDocument = gql`
    mutation StoriesCreate($stories: CreateStoriesInput!) {
  storiesManageCreate(stories: $stories) {
    ...StoriesFragment
  }
}
    ${StoriesFragmentFragmentDoc}`;
export type StoriesCreateMutationFn = Apollo.MutationFunction<StoriesCreateMutation, StoriesCreateMutationVariables>;
export type StoriesCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<StoriesCreateMutation, StoriesCreateMutationVariables>, 'mutation'>;

    export const StoriesCreateQuery = (props: StoriesCreateQueryProps) => (
      <ApolloReactComponents.Mutation<StoriesCreateMutation, StoriesCreateMutationVariables> mutation={StoriesCreateDocument} {...props} />
    );


/**
 * __useStoriesCreateMutation__
 *
 * To run a mutation, you first call `useStoriesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoriesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storiesCreateMutation, { data, loading, error }] = useStoriesCreateMutation({
 *   variables: {
 *      stories: // value for 'stories'
 *   },
 * });
 */
export function useStoriesCreateMutation(baseOptions?: Apollo.MutationHookOptions<StoriesCreateMutation, StoriesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoriesCreateMutation, StoriesCreateMutationVariables>(StoriesCreateDocument, options);
      }
export type StoriesCreateMutationHookResult = ReturnType<typeof useStoriesCreateMutation>;
export type StoriesCreateMutationResult = Apollo.MutationResult<StoriesCreateMutation>;
export type StoriesCreateMutationOptions = Apollo.BaseMutationOptions<StoriesCreateMutation, StoriesCreateMutationVariables>;
export const StoriesUpdateOneDocument = gql`
    mutation StoriesUpdateOne($storiesId: Int!, $stories: UpdateStoriesInput!) {
  storiesManageUpdate(storiesId: $storiesId, stories: $stories) {
    ...StoriesFragment
  }
}
    ${StoriesFragmentFragmentDoc}`;
export type StoriesUpdateOneMutationFn = Apollo.MutationFunction<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables>;
export type StoriesUpdateOneQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables>, 'mutation'>;

    export const StoriesUpdateOneQuery = (props: StoriesUpdateOneQueryProps) => (
      <ApolloReactComponents.Mutation<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables> mutation={StoriesUpdateOneDocument} {...props} />
    );


/**
 * __useStoriesUpdateOneMutation__
 *
 * To run a mutation, you first call `useStoriesUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoriesUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storiesUpdateOneMutation, { data, loading, error }] = useStoriesUpdateOneMutation({
 *   variables: {
 *      storiesId: // value for 'storiesId'
 *      stories: // value for 'stories'
 *   },
 * });
 */
export function useStoriesUpdateOneMutation(baseOptions?: Apollo.MutationHookOptions<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables>(StoriesUpdateOneDocument, options);
      }
export type StoriesUpdateOneMutationHookResult = ReturnType<typeof useStoriesUpdateOneMutation>;
export type StoriesUpdateOneMutationResult = Apollo.MutationResult<StoriesUpdateOneMutation>;
export type StoriesUpdateOneMutationOptions = Apollo.BaseMutationOptions<StoriesUpdateOneMutation, StoriesUpdateOneMutationVariables>;
export const ProductAccessFindOneDocument = gql`
    query ProductAccessFindOne($accessId: Int!) {
  productAccessFindOne(accessId: $accessId) {
    ...ProductAccessFragment
  }
}
    ${ProductAccessFragmentFragmentDoc}`;
export type ProductAccessFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>, 'query'> & ({ variables: ProductAccessFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductAccessFindOneQuery = (props: ProductAccessFindOneQueryProps) => (
      <ApolloReactComponents.Query<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables> query={ProductAccessFindOneDocument} {...props} />
    );


/**
 * __useProductAccessFindOneQuery__
 *
 * To run a query within a React component, call `useProductAccessFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAccessFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAccessFindOneQuery({
 *   variables: {
 *      accessId: // value for 'accessId'
 *   },
 * });
 */
export function useProductAccessFindOneQuery(baseOptions: Apollo.QueryHookOptions<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables> & ({ variables: ProductAccessFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>(ProductAccessFindOneDocument, options);
      }
export function useProductAccessFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>(ProductAccessFindOneDocument, options);
        }
export function useProductAccessFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>(ProductAccessFindOneDocument, options);
        }
export type ProductAccessFindOneQueryHookResult = ReturnType<typeof useProductAccessFindOneQuery>;
export type ProductAccessFindOneLazyQueryHookResult = ReturnType<typeof useProductAccessFindOneLazyQuery>;
export type ProductAccessFindOneSuspenseQueryHookResult = ReturnType<typeof useProductAccessFindOneSuspenseQuery>;
export type ProductAccessFindOneQueryResult = Apollo.QueryResult<ProductAccessFindOneQuery, ProductAccessFindOneQueryVariables>;
export const ProductAccessFindManyDocument = gql`
    query ProductAccessFindMany($list: ListInput!, $filter: FilterAccessProductInput!, $sort: SortAccessProductInput) {
  productAccessFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      ...ProductAccessFragment
      user {
        id
        domain
        lastOnlineAt
        profile {
          id
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProductAccessFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type ProductAccessFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>, 'query'> & ({ variables: ProductAccessFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductAccessFindManyQuery = (props: ProductAccessFindManyQueryProps) => (
      <ApolloReactComponents.Query<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables> query={ProductAccessFindManyDocument} {...props} />
    );


/**
 * __useProductAccessFindManyQuery__
 *
 * To run a query within a React component, call `useProductAccessFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAccessFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAccessFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductAccessFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables> & ({ variables: ProductAccessFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>(ProductAccessFindManyDocument, options);
      }
export function useProductAccessFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>(ProductAccessFindManyDocument, options);
        }
export function useProductAccessFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>(ProductAccessFindManyDocument, options);
        }
export type ProductAccessFindManyQueryHookResult = ReturnType<typeof useProductAccessFindManyQuery>;
export type ProductAccessFindManyLazyQueryHookResult = ReturnType<typeof useProductAccessFindManyLazyQuery>;
export type ProductAccessFindManySuspenseQueryHookResult = ReturnType<typeof useProductAccessFindManySuspenseQuery>;
export type ProductAccessFindManyQueryResult = Apollo.QueryResult<ProductAccessFindManyQuery, ProductAccessFindManyQueryVariables>;
export const FindOneProductIdByCourseDocument = gql`
    query FindOneProductIdByCourse($courseId: Int!) {
  courseFindOne(courseId: $courseId) {
    id
    type
    name
    product {
      id
    }
  }
}
    `;
export type FindOneProductIdByCourseQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>, 'query'> & ({ variables: FindOneProductIdByCourseQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindOneProductIdByCourseQuery = (props: FindOneProductIdByCourseQueryProps) => (
      <ApolloReactComponents.Query<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables> query={FindOneProductIdByCourseDocument} {...props} />
    );


/**
 * __useFindOneProductIdByCourseQuery__
 *
 * To run a query within a React component, call `useFindOneProductIdByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneProductIdByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneProductIdByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useFindOneProductIdByCourseQuery(baseOptions: Apollo.QueryHookOptions<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables> & ({ variables: FindOneProductIdByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>(FindOneProductIdByCourseDocument, options);
      }
export function useFindOneProductIdByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>(FindOneProductIdByCourseDocument, options);
        }
export function useFindOneProductIdByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>(FindOneProductIdByCourseDocument, options);
        }
export type FindOneProductIdByCourseQueryHookResult = ReturnType<typeof useFindOneProductIdByCourseQuery>;
export type FindOneProductIdByCourseLazyQueryHookResult = ReturnType<typeof useFindOneProductIdByCourseLazyQuery>;
export type FindOneProductIdByCourseSuspenseQueryHookResult = ReturnType<typeof useFindOneProductIdByCourseSuspenseQuery>;
export type FindOneProductIdByCourseQueryResult = Apollo.QueryResult<FindOneProductIdByCourseQuery, FindOneProductIdByCourseQueryVariables>;
export const CourseLessonPracticeAttemptFindManyDocument = gql`
    query CourseLessonPracticeAttemptFindMany($list: ListInput!, $filter: FilterLessonPracticeAttemptCourseInput!, $sort: SortLessonPracticeAttemptCourseInput) {
  courseLessonPracticeAttemptFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    page
    pages
    isFirst
    isLast
    items {
      id
      status
      attemptIndex
      finished
      solvedCount
      pointsAmount
      sentToReviewAt
      maxPointsAmount
      user {
        id
        lastOnlineAt
        profile {
          id
          fullName
          firstName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
      practice {
        id
        lesson {
          id
          name
          course {
            id
            name
          }
        }
      }
      curator {
        id
        user {
          id
          profile {
            id
            firstName
            fullNameShort
            avatar {
              id
              medium
            }
          }
        }
      }
      message {
        id
        chat {
          id
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type CourseLessonPracticeAttemptFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>, 'query'> & ({ variables: CourseLessonPracticeAttemptFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseLessonPracticeAttemptFindManyQuery = (props: CourseLessonPracticeAttemptFindManyQueryProps) => (
      <ApolloReactComponents.Query<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables> query={CourseLessonPracticeAttemptFindManyDocument} {...props} />
    );


/**
 * __useCourseLessonPracticeAttemptFindManyQuery__
 *
 * To run a query within a React component, call `useCourseLessonPracticeAttemptFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseLessonPracticeAttemptFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseLessonPracticeAttemptFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseLessonPracticeAttemptFindManyQuery(baseOptions: Apollo.QueryHookOptions<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables> & ({ variables: CourseLessonPracticeAttemptFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>(CourseLessonPracticeAttemptFindManyDocument, options);
      }
export function useCourseLessonPracticeAttemptFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>(CourseLessonPracticeAttemptFindManyDocument, options);
        }
export function useCourseLessonPracticeAttemptFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>(CourseLessonPracticeAttemptFindManyDocument, options);
        }
export type CourseLessonPracticeAttemptFindManyQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptFindManyQuery>;
export type CourseLessonPracticeAttemptFindManyLazyQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptFindManyLazyQuery>;
export type CourseLessonPracticeAttemptFindManySuspenseQueryHookResult = ReturnType<typeof useCourseLessonPracticeAttemptFindManySuspenseQuery>;
export type CourseLessonPracticeAttemptFindManyQueryResult = Apollo.QueryResult<CourseLessonPracticeAttemptFindManyQuery, CourseLessonPracticeAttemptFindManyQueryVariables>;
export const TaskFindOneDocument = gql`
    query TaskFindOne($taskUuid: String!, $list: ListInput!, $filter: FilterTaskInput!, $sort: BaseSortInput) {
  taskFindOne(taskUuid: $taskUuid) {
    ...TaskCommonFragment
  }
  taskFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      uuid
    }
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export type TaskFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TaskFindOneQuery, TaskFindOneQueryVariables>, 'query'> & ({ variables: TaskFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TaskFindOneQuery = (props: TaskFindOneQueryProps) => (
      <ApolloReactComponents.Query<TaskFindOneQuery, TaskFindOneQueryVariables> query={TaskFindOneDocument} {...props} />
    );


/**
 * __useTaskFindOneQuery__
 *
 * To run a query within a React component, call `useTaskFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFindOneQuery({
 *   variables: {
 *      taskUuid: // value for 'taskUuid'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskFindOneQuery(baseOptions: Apollo.QueryHookOptions<TaskFindOneQuery, TaskFindOneQueryVariables> & ({ variables: TaskFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFindOneQuery, TaskFindOneQueryVariables>(TaskFindOneDocument, options);
      }
export function useTaskFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFindOneQuery, TaskFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFindOneQuery, TaskFindOneQueryVariables>(TaskFindOneDocument, options);
        }
export function useTaskFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskFindOneQuery, TaskFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskFindOneQuery, TaskFindOneQueryVariables>(TaskFindOneDocument, options);
        }
export type TaskFindOneQueryHookResult = ReturnType<typeof useTaskFindOneQuery>;
export type TaskFindOneLazyQueryHookResult = ReturnType<typeof useTaskFindOneLazyQuery>;
export type TaskFindOneSuspenseQueryHookResult = ReturnType<typeof useTaskFindOneSuspenseQuery>;
export type TaskFindOneQueryResult = Apollo.QueryResult<TaskFindOneQuery, TaskFindOneQueryVariables>;
export const TaskManageUpdateDocument = gql`
    mutation TaskManageUpdate($taskId: Int!, $task: UpdateTaskInput!) {
  taskManageUpdate(taskId: $taskId, task: $task) {
    ...TaskCommonFragment
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export type TaskManageUpdateMutationFn = Apollo.MutationFunction<TaskManageUpdateMutation, TaskManageUpdateMutationVariables>;
export type TaskManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskManageUpdateMutation, TaskManageUpdateMutationVariables>, 'mutation'>;

    export const TaskManageUpdateQuery = (props: TaskManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<TaskManageUpdateMutation, TaskManageUpdateMutationVariables> mutation={TaskManageUpdateDocument} {...props} />
    );


/**
 * __useTaskManageUpdateMutation__
 *
 * To run a mutation, you first call `useTaskManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskManageUpdateMutation, { data, loading, error }] = useTaskManageUpdateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      task: // value for 'task'
 *   },
 * });
 */
export function useTaskManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskManageUpdateMutation, TaskManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskManageUpdateMutation, TaskManageUpdateMutationVariables>(TaskManageUpdateDocument, options);
      }
export type TaskManageUpdateMutationHookResult = ReturnType<typeof useTaskManageUpdateMutation>;
export type TaskManageUpdateMutationResult = Apollo.MutationResult<TaskManageUpdateMutation>;
export type TaskManageUpdateMutationOptions = Apollo.BaseMutationOptions<TaskManageUpdateMutation, TaskManageUpdateMutationVariables>;
export const TaskManageCreateDocument = gql`
    mutation TaskManageCreate($task: CreateTaskInput!) {
  taskManageCreate(task: $task) {
    ...TaskCommonFragment
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export type TaskManageCreateMutationFn = Apollo.MutationFunction<TaskManageCreateMutation, TaskManageCreateMutationVariables>;
export type TaskManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskManageCreateMutation, TaskManageCreateMutationVariables>, 'mutation'>;

    export const TaskManageCreateQuery = (props: TaskManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<TaskManageCreateMutation, TaskManageCreateMutationVariables> mutation={TaskManageCreateDocument} {...props} />
    );


/**
 * __useTaskManageCreateMutation__
 *
 * To run a mutation, you first call `useTaskManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskManageCreateMutation, { data, loading, error }] = useTaskManageCreateMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useTaskManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskManageCreateMutation, TaskManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskManageCreateMutation, TaskManageCreateMutationVariables>(TaskManageCreateDocument, options);
      }
export type TaskManageCreateMutationHookResult = ReturnType<typeof useTaskManageCreateMutation>;
export type TaskManageCreateMutationResult = Apollo.MutationResult<TaskManageCreateMutation>;
export type TaskManageCreateMutationOptions = Apollo.BaseMutationOptions<TaskManageCreateMutation, TaskManageCreateMutationVariables>;
export const SubjectCategoryManageCreateDocument = gql`
    mutation SubjectCategoryManageCreate($category: CreateCategorySubjectInput!) {
  subjectCategoryManageCreate(category: $category) {
    id
    name
  }
}
    `;
export type SubjectCategoryManageCreateMutationFn = Apollo.MutationFunction<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables>;
export type SubjectCategoryManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables>, 'mutation'>;

    export const SubjectCategoryManageCreateQuery = (props: SubjectCategoryManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables> mutation={SubjectCategoryManageCreateDocument} {...props} />
    );


/**
 * __useSubjectCategoryManageCreateMutation__
 *
 * To run a mutation, you first call `useSubjectCategoryManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubjectCategoryManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subjectCategoryManageCreateMutation, { data, loading, error }] = useSubjectCategoryManageCreateMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useSubjectCategoryManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables>(SubjectCategoryManageCreateDocument, options);
      }
export type SubjectCategoryManageCreateMutationHookResult = ReturnType<typeof useSubjectCategoryManageCreateMutation>;
export type SubjectCategoryManageCreateMutationResult = Apollo.MutationResult<SubjectCategoryManageCreateMutation>;
export type SubjectCategoryManageCreateMutationOptions = Apollo.BaseMutationOptions<SubjectCategoryManageCreateMutation, SubjectCategoryManageCreateMutationVariables>;
export const SubjectCategoryFindManyDocument = gql`
    query SubjectCategoryFindMany($list: ListInput!, $filter: FilterCategorySubjectInput!, $sort: BaseSortInput) {
  subjectCategoryFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      id
      name
      visibility
    }
  }
}
    `;
export type SubjectCategoryFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>, 'query'> & ({ variables: SubjectCategoryFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubjectCategoryFindManyQuery = (props: SubjectCategoryFindManyQueryProps) => (
      <ApolloReactComponents.Query<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables> query={SubjectCategoryFindManyDocument} {...props} />
    );


/**
 * __useSubjectCategoryFindManyQuery__
 *
 * To run a query within a React component, call `useSubjectCategoryFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectCategoryFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectCategoryFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSubjectCategoryFindManyQuery(baseOptions: Apollo.QueryHookOptions<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables> & ({ variables: SubjectCategoryFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>(SubjectCategoryFindManyDocument, options);
      }
export function useSubjectCategoryFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>(SubjectCategoryFindManyDocument, options);
        }
export function useSubjectCategoryFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>(SubjectCategoryFindManyDocument, options);
        }
export type SubjectCategoryFindManyQueryHookResult = ReturnType<typeof useSubjectCategoryFindManyQuery>;
export type SubjectCategoryFindManyLazyQueryHookResult = ReturnType<typeof useSubjectCategoryFindManyLazyQuery>;
export type SubjectCategoryFindManySuspenseQueryHookResult = ReturnType<typeof useSubjectCategoryFindManySuspenseQuery>;
export type SubjectCategoryFindManyQueryResult = Apollo.QueryResult<SubjectCategoryFindManyQuery, SubjectCategoryFindManyQueryVariables>;
export const TaskBlockManageCreateDocument = gql`
    mutation TaskBlockManageCreate($taskId: Int!, $contentElement: CreateElementContentInput!) {
  taskBlockManageCreate(taskId: $taskId, contentElement: $contentElement) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type TaskBlockManageCreateMutationFn = Apollo.MutationFunction<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables>;
export type TaskBlockManageCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables>, 'mutation'>;

    export const TaskBlockManageCreateQuery = (props: TaskBlockManageCreateQueryProps) => (
      <ApolloReactComponents.Mutation<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables> mutation={TaskBlockManageCreateDocument} {...props} />
    );


/**
 * __useTaskBlockManageCreateMutation__
 *
 * To run a mutation, you first call `useTaskBlockManageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockManageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBlockManageCreateMutation, { data, loading, error }] = useTaskBlockManageCreateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useTaskBlockManageCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables>(TaskBlockManageCreateDocument, options);
      }
export type TaskBlockManageCreateMutationHookResult = ReturnType<typeof useTaskBlockManageCreateMutation>;
export type TaskBlockManageCreateMutationResult = Apollo.MutationResult<TaskBlockManageCreateMutation>;
export type TaskBlockManageCreateMutationOptions = Apollo.BaseMutationOptions<TaskBlockManageCreateMutation, TaskBlockManageCreateMutationVariables>;
export const TaskBlockManageUpdateDocument = gql`
    mutation TaskBlockManageUpdate($taskId: Int!, $contentElementId: Int!, $contentElement: UpdateElementContentInput!) {
  taskBlockManageUpdate(
    taskId: $taskId
    contentElement: $contentElement
    contentElementId: $contentElementId
  ) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type TaskBlockManageUpdateMutationFn = Apollo.MutationFunction<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables>;
export type TaskBlockManageUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables>, 'mutation'>;

    export const TaskBlockManageUpdateQuery = (props: TaskBlockManageUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables> mutation={TaskBlockManageUpdateDocument} {...props} />
    );


/**
 * __useTaskBlockManageUpdateMutation__
 *
 * To run a mutation, you first call `useTaskBlockManageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockManageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBlockManageUpdateMutation, { data, loading, error }] = useTaskBlockManageUpdateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      contentElementId: // value for 'contentElementId'
 *      contentElement: // value for 'contentElement'
 *   },
 * });
 */
export function useTaskBlockManageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables>(TaskBlockManageUpdateDocument, options);
      }
export type TaskBlockManageUpdateMutationHookResult = ReturnType<typeof useTaskBlockManageUpdateMutation>;
export type TaskBlockManageUpdateMutationResult = Apollo.MutationResult<TaskBlockManageUpdateMutation>;
export type TaskBlockManageUpdateMutationOptions = Apollo.BaseMutationOptions<TaskBlockManageUpdateMutation, TaskBlockManageUpdateMutationVariables>;
export const TaskBlockManageDeleteDocument = gql`
    mutation TaskBlockManageDelete($taskId: Int!, $contentElementId: Int!) {
  taskBlockManageDelete(taskId: $taskId, contentElementId: $contentElementId)
}
    `;
export type TaskBlockManageDeleteMutationFn = Apollo.MutationFunction<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables>;
export type TaskBlockManageDeleteQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables>, 'mutation'>;

    export const TaskBlockManageDeleteQuery = (props: TaskBlockManageDeleteQueryProps) => (
      <ApolloReactComponents.Mutation<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables> mutation={TaskBlockManageDeleteDocument} {...props} />
    );


/**
 * __useTaskBlockManageDeleteMutation__
 *
 * To run a mutation, you first call `useTaskBlockManageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockManageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBlockManageDeleteMutation, { data, loading, error }] = useTaskBlockManageDeleteMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useTaskBlockManageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables>(TaskBlockManageDeleteDocument, options);
      }
export type TaskBlockManageDeleteMutationHookResult = ReturnType<typeof useTaskBlockManageDeleteMutation>;
export type TaskBlockManageDeleteMutationResult = Apollo.MutationResult<TaskBlockManageDeleteMutation>;
export type TaskBlockManageDeleteMutationOptions = Apollo.BaseMutationOptions<TaskBlockManageDeleteMutation, TaskBlockManageDeleteMutationVariables>;
export const TaskBlockManageRecoverDocument = gql`
    mutation TaskBlockManageRecover($taskId: Int!, $contentElementId: Int!) {
  taskBlockManageRecover(taskId: $taskId, contentElementId: $contentElementId) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type TaskBlockManageRecoverMutationFn = Apollo.MutationFunction<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables>;
export type TaskBlockManageRecoverQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables>, 'mutation'>;

    export const TaskBlockManageRecoverQuery = (props: TaskBlockManageRecoverQueryProps) => (
      <ApolloReactComponents.Mutation<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables> mutation={TaskBlockManageRecoverDocument} {...props} />
    );


/**
 * __useTaskBlockManageRecoverMutation__
 *
 * To run a mutation, you first call `useTaskBlockManageRecoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockManageRecoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBlockManageRecoverMutation, { data, loading, error }] = useTaskBlockManageRecoverMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      contentElementId: // value for 'contentElementId'
 *   },
 * });
 */
export function useTaskBlockManageRecoverMutation(baseOptions?: Apollo.MutationHookOptions<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables>(TaskBlockManageRecoverDocument, options);
      }
export type TaskBlockManageRecoverMutationHookResult = ReturnType<typeof useTaskBlockManageRecoverMutation>;
export type TaskBlockManageRecoverMutationResult = Apollo.MutationResult<TaskBlockManageRecoverMutation>;
export type TaskBlockManageRecoverMutationOptions = Apollo.BaseMutationOptions<TaskBlockManageRecoverMutation, TaskBlockManageRecoverMutationVariables>;
export const TaskBlockManageUpdateOrderDocument = gql`
    mutation TaskBlockManageUpdateOrder($taskId: Int!, $blockOrder: UpdateBlockOrderTaskInput!) {
  taskBlockManageUpdateOrder(taskId: $taskId, blockOrder: $blockOrder) {
    ...ContentElementFragment
  }
}
    ${ContentElementFragmentFragmentDoc}`;
export type TaskBlockManageUpdateOrderMutationFn = Apollo.MutationFunction<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables>;
export type TaskBlockManageUpdateOrderQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables>, 'mutation'>;

    export const TaskBlockManageUpdateOrderQuery = (props: TaskBlockManageUpdateOrderQueryProps) => (
      <ApolloReactComponents.Mutation<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables> mutation={TaskBlockManageUpdateOrderDocument} {...props} />
    );


/**
 * __useTaskBlockManageUpdateOrderMutation__
 *
 * To run a mutation, you first call `useTaskBlockManageUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBlockManageUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBlockManageUpdateOrderMutation, { data, loading, error }] = useTaskBlockManageUpdateOrderMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      blockOrder: // value for 'blockOrder'
 *   },
 * });
 */
export function useTaskBlockManageUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables>(TaskBlockManageUpdateOrderDocument, options);
      }
export type TaskBlockManageUpdateOrderMutationHookResult = ReturnType<typeof useTaskBlockManageUpdateOrderMutation>;
export type TaskBlockManageUpdateOrderMutationResult = Apollo.MutationResult<TaskBlockManageUpdateOrderMutation>;
export type TaskBlockManageUpdateOrderMutationOptions = Apollo.BaseMutationOptions<TaskBlockManageUpdateOrderMutation, TaskBlockManageUpdateOrderMutationVariables>;
export const TaskFindManyDocument = gql`
    query TaskFindMany($list: ListInput!, $filter: FilterTaskInput!, $sort: BaseSortInput) {
  taskFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    items {
      id
      uuid
      title
      answerType
      contentTypes
      subject
      question
      complexity
      user {
        id
        lastOnlineAt
        profile {
          id
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
      subjectCategory {
        id
        name
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TaskFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TaskFindManyQuery, TaskFindManyQueryVariables>, 'query'> & ({ variables: TaskFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TaskFindManyQuery = (props: TaskFindManyQueryProps) => (
      <ApolloReactComponents.Query<TaskFindManyQuery, TaskFindManyQueryVariables> query={TaskFindManyDocument} {...props} />
    );


/**
 * __useTaskFindManyQuery__
 *
 * To run a query within a React component, call `useTaskFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTaskFindManyQuery(baseOptions: Apollo.QueryHookOptions<TaskFindManyQuery, TaskFindManyQueryVariables> & ({ variables: TaskFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFindManyQuery, TaskFindManyQueryVariables>(TaskFindManyDocument, options);
      }
export function useTaskFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFindManyQuery, TaskFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFindManyQuery, TaskFindManyQueryVariables>(TaskFindManyDocument, options);
        }
export function useTaskFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskFindManyQuery, TaskFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskFindManyQuery, TaskFindManyQueryVariables>(TaskFindManyDocument, options);
        }
export type TaskFindManyQueryHookResult = ReturnType<typeof useTaskFindManyQuery>;
export type TaskFindManyLazyQueryHookResult = ReturnType<typeof useTaskFindManyLazyQuery>;
export type TaskFindManySuspenseQueryHookResult = ReturnType<typeof useTaskFindManySuspenseQuery>;
export type TaskFindManyQueryResult = Apollo.QueryResult<TaskFindManyQuery, TaskFindManyQueryVariables>;
export const InvoiceFindOneByUuidDocument = gql`
    query InvoiceFindOneByUuid($uuid: String!) {
  invoiceFindOneByUuid(uuid: $uuid) {
    id
    uuid
    createdAt
    humanId
    currency
    totalAmount
    discountAmount
    actualPayment {
      id
      status
      paidAt
      isCompleted
    }
    user {
      id
      login
    }
    products {
      id
      price {
        id
      }
      product {
        id
        type
        currency
        prices {
          id
          accessDays
          previousAmount
          ...ProductPriceExchangeFragment
        }
        course {
          ...CourseFragment
          lessons {
            parent {
              ...CourseLessonParentFragment
            }
          }
        }
      }
    }
  }
}
    ${ProductPriceExchangeFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type InvoiceFindOneByUuidQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>, 'query'> & ({ variables: InvoiceFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvoiceFindOneByUuidQuery = (props: InvoiceFindOneByUuidQueryProps) => (
      <ApolloReactComponents.Query<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables> query={InvoiceFindOneByUuidDocument} {...props} />
    );


/**
 * __useInvoiceFindOneByUuidQuery__
 *
 * To run a query within a React component, call `useInvoiceFindOneByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFindOneByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceFindOneByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useInvoiceFindOneByUuidQuery(baseOptions: Apollo.QueryHookOptions<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables> & ({ variables: InvoiceFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>(InvoiceFindOneByUuidDocument, options);
      }
export function useInvoiceFindOneByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>(InvoiceFindOneByUuidDocument, options);
        }
export function useInvoiceFindOneByUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>(InvoiceFindOneByUuidDocument, options);
        }
export type InvoiceFindOneByUuidQueryHookResult = ReturnType<typeof useInvoiceFindOneByUuidQuery>;
export type InvoiceFindOneByUuidLazyQueryHookResult = ReturnType<typeof useInvoiceFindOneByUuidLazyQuery>;
export type InvoiceFindOneByUuidSuspenseQueryHookResult = ReturnType<typeof useInvoiceFindOneByUuidSuspenseQuery>;
export type InvoiceFindOneByUuidQueryResult = Apollo.QueryResult<InvoiceFindOneByUuidQuery, InvoiceFindOneByUuidQueryVariables>;
export const InvoiceRecreatePaymentDocument = gql`
    mutation InvoiceRecreatePayment($uuid: String!, $acquiringId: Int!) {
  invoiceRecreatePayment(uuid: $uuid, acquiringId: $acquiringId) {
    id
    uuid
    actualPayment {
      id
      status
      isCompleted
      checkoutUrl
    }
  }
}
    `;
export type InvoiceRecreatePaymentMutationFn = Apollo.MutationFunction<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables>;
export type InvoiceRecreatePaymentQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables>, 'mutation'>;

    export const InvoiceRecreatePaymentQuery = (props: InvoiceRecreatePaymentQueryProps) => (
      <ApolloReactComponents.Mutation<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables> mutation={InvoiceRecreatePaymentDocument} {...props} />
    );


/**
 * __useInvoiceRecreatePaymentMutation__
 *
 * To run a mutation, you first call `useInvoiceRecreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRecreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRecreatePaymentMutation, { data, loading, error }] = useInvoiceRecreatePaymentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      acquiringId: // value for 'acquiringId'
 *   },
 * });
 */
export function useInvoiceRecreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables>(InvoiceRecreatePaymentDocument, options);
      }
export type InvoiceRecreatePaymentMutationHookResult = ReturnType<typeof useInvoiceRecreatePaymentMutation>;
export type InvoiceRecreatePaymentMutationResult = Apollo.MutationResult<InvoiceRecreatePaymentMutation>;
export type InvoiceRecreatePaymentMutationOptions = Apollo.BaseMutationOptions<InvoiceRecreatePaymentMutation, InvoiceRecreatePaymentMutationVariables>;
export const AcquiringFindManyActiveDocument = gql`
    query AcquiringFindManyActive($filter: FilterAcquiringInput!) {
  acquiringFindManyActive(list: {}, sort: {}, filter: $filter) {
    items {
      ...AcquiringFragment
    }
  }
}
    ${AcquiringFragmentFragmentDoc}`;
export type AcquiringFindManyActiveQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>, 'query'> & ({ variables: AcquiringFindManyActiveQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AcquiringFindManyActiveQuery = (props: AcquiringFindManyActiveQueryProps) => (
      <ApolloReactComponents.Query<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables> query={AcquiringFindManyActiveDocument} {...props} />
    );


/**
 * __useAcquiringFindManyActiveQuery__
 *
 * To run a query within a React component, call `useAcquiringFindManyActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcquiringFindManyActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcquiringFindManyActiveQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAcquiringFindManyActiveQuery(baseOptions: Apollo.QueryHookOptions<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables> & ({ variables: AcquiringFindManyActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>(AcquiringFindManyActiveDocument, options);
      }
export function useAcquiringFindManyActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>(AcquiringFindManyActiveDocument, options);
        }
export function useAcquiringFindManyActiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>(AcquiringFindManyActiveDocument, options);
        }
export type AcquiringFindManyActiveQueryHookResult = ReturnType<typeof useAcquiringFindManyActiveQuery>;
export type AcquiringFindManyActiveLazyQueryHookResult = ReturnType<typeof useAcquiringFindManyActiveLazyQuery>;
export type AcquiringFindManyActiveSuspenseQueryHookResult = ReturnType<typeof useAcquiringFindManyActiveSuspenseQuery>;
export type AcquiringFindManyActiveQueryResult = Apollo.QueryResult<AcquiringFindManyActiveQuery, AcquiringFindManyActiveQueryVariables>;
export const ProductFindManyDocument = gql`
    query ProductFindMany($list: ListInput!, $filter: FilterProductInput!, $sort: BaseSortInput) {
  productFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      id
      currency
      prices {
        id
        accessDays
        previousAmount
        ...ProductPriceExchangeFragment
      }
      course {
        ...CourseFragment
      }
    }
  }
}
    ${ProductPriceExchangeFragmentFragmentDoc}
${CourseFragmentFragmentDoc}`;
export type ProductFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFindManyQuery, ProductFindManyQueryVariables>, 'query'> & ({ variables: ProductFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductFindManyQuery = (props: ProductFindManyQueryProps) => (
      <ApolloReactComponents.Query<ProductFindManyQuery, ProductFindManyQueryVariables> query={ProductFindManyDocument} {...props} />
    );


/**
 * __useProductFindManyQuery__
 *
 * To run a query within a React component, call `useProductFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProductFindManyQuery, ProductFindManyQueryVariables> & ({ variables: ProductFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFindManyQuery, ProductFindManyQueryVariables>(ProductFindManyDocument, options);
      }
export function useProductFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFindManyQuery, ProductFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFindManyQuery, ProductFindManyQueryVariables>(ProductFindManyDocument, options);
        }
export function useProductFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductFindManyQuery, ProductFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFindManyQuery, ProductFindManyQueryVariables>(ProductFindManyDocument, options);
        }
export type ProductFindManyQueryHookResult = ReturnType<typeof useProductFindManyQuery>;
export type ProductFindManyLazyQueryHookResult = ReturnType<typeof useProductFindManyLazyQuery>;
export type ProductFindManySuspenseQueryHookResult = ReturnType<typeof useProductFindManySuspenseQuery>;
export type ProductFindManyQueryResult = Apollo.QueryResult<ProductFindManyQuery, ProductFindManyQueryVariables>;
export const InvoiceCalculateCartTotalDocument = gql`
    query InvoiceCalculateCartTotal($cart: CalculateCartTotalInvoiceInput!, $acquiringFilter: FilterAcquiringInput!) {
  acquiringFindManyActive(list: {}, sort: {}, filter: $acquiringFilter) {
    items {
      ...AcquiringFragment
    }
  }
  invoiceCalculateCartTotal(cart: $cart) {
    totalAmount
    discountAmount
    unAppliedDiscounts {
      reason
      discount {
        id
        code
      }
    }
    items {
      totalPrice
      discountAmount
      originalPrice
      product {
        id
        type
        currency
        course {
          id
          name
          subject
          image {
            main
          }
        }
      }
      price {
        id
        title
        amount
        accessDays
        previousAmount
        actualAccessDays
        subscriptionPeriod
        ...SchoolPriceFragment
      }
    }
  }
}
    ${AcquiringFragmentFragmentDoc}
${SchoolPriceFragmentFragmentDoc}`;
export type InvoiceCalculateCartTotalQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>, 'query'> & ({ variables: InvoiceCalculateCartTotalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvoiceCalculateCartTotalQuery = (props: InvoiceCalculateCartTotalQueryProps) => (
      <ApolloReactComponents.Query<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables> query={InvoiceCalculateCartTotalDocument} {...props} />
    );


/**
 * __useInvoiceCalculateCartTotalQuery__
 *
 * To run a query within a React component, call `useInvoiceCalculateCartTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCalculateCartTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceCalculateCartTotalQuery({
 *   variables: {
 *      cart: // value for 'cart'
 *      acquiringFilter: // value for 'acquiringFilter'
 *   },
 * });
 */
export function useInvoiceCalculateCartTotalQuery(baseOptions: Apollo.QueryHookOptions<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables> & ({ variables: InvoiceCalculateCartTotalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>(InvoiceCalculateCartTotalDocument, options);
      }
export function useInvoiceCalculateCartTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>(InvoiceCalculateCartTotalDocument, options);
        }
export function useInvoiceCalculateCartTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>(InvoiceCalculateCartTotalDocument, options);
        }
export type InvoiceCalculateCartTotalQueryHookResult = ReturnType<typeof useInvoiceCalculateCartTotalQuery>;
export type InvoiceCalculateCartTotalLazyQueryHookResult = ReturnType<typeof useInvoiceCalculateCartTotalLazyQuery>;
export type InvoiceCalculateCartTotalSuspenseQueryHookResult = ReturnType<typeof useInvoiceCalculateCartTotalSuspenseQuery>;
export type InvoiceCalculateCartTotalQueryResult = Apollo.QueryResult<InvoiceCalculateCartTotalQuery, InvoiceCalculateCartTotalQueryVariables>;
export const CartFindOneSharedByUuidDocument = gql`
    query CartFindOneSharedByUuid($uuid: String!) {
  cartFindOneSharedByUuid(uuid: $uuid) {
    id
    uuid
    promoCodes
    user {
      id
      domain
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
    products {
      productId
      priceId
      addedAt
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type CartFindOneSharedByUuidQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>, 'query'> & ({ variables: CartFindOneSharedByUuidQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CartFindOneSharedByUuidQuery = (props: CartFindOneSharedByUuidQueryProps) => (
      <ApolloReactComponents.Query<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables> query={CartFindOneSharedByUuidDocument} {...props} />
    );


/**
 * __useCartFindOneSharedByUuidQuery__
 *
 * To run a query within a React component, call `useCartFindOneSharedByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartFindOneSharedByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartFindOneSharedByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCartFindOneSharedByUuidQuery(baseOptions: Apollo.QueryHookOptions<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables> & ({ variables: CartFindOneSharedByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>(CartFindOneSharedByUuidDocument, options);
      }
export function useCartFindOneSharedByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>(CartFindOneSharedByUuidDocument, options);
        }
export function useCartFindOneSharedByUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>(CartFindOneSharedByUuidDocument, options);
        }
export type CartFindOneSharedByUuidQueryHookResult = ReturnType<typeof useCartFindOneSharedByUuidQuery>;
export type CartFindOneSharedByUuidLazyQueryHookResult = ReturnType<typeof useCartFindOneSharedByUuidLazyQuery>;
export type CartFindOneSharedByUuidSuspenseQueryHookResult = ReturnType<typeof useCartFindOneSharedByUuidSuspenseQuery>;
export type CartFindOneSharedByUuidQueryResult = Apollo.QueryResult<CartFindOneSharedByUuidQuery, CartFindOneSharedByUuidQueryVariables>;
export const DiscountCheckCodeDocument = gql`
    query DiscountCheckCode($code: String!) {
  discountCheckCode(code: $code) {
    id
    value
    type
    code
  }
}
    `;
export type DiscountCheckCodeQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>, 'query'> & ({ variables: DiscountCheckCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DiscountCheckCodeQuery = (props: DiscountCheckCodeQueryProps) => (
      <ApolloReactComponents.Query<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables> query={DiscountCheckCodeDocument} {...props} />
    );


/**
 * __useDiscountCheckCodeQuery__
 *
 * To run a query within a React component, call `useDiscountCheckCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCheckCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCheckCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useDiscountCheckCodeQuery(baseOptions: Apollo.QueryHookOptions<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables> & ({ variables: DiscountCheckCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>(DiscountCheckCodeDocument, options);
      }
export function useDiscountCheckCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>(DiscountCheckCodeDocument, options);
        }
export function useDiscountCheckCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>(DiscountCheckCodeDocument, options);
        }
export type DiscountCheckCodeQueryHookResult = ReturnType<typeof useDiscountCheckCodeQuery>;
export type DiscountCheckCodeLazyQueryHookResult = ReturnType<typeof useDiscountCheckCodeLazyQuery>;
export type DiscountCheckCodeSuspenseQueryHookResult = ReturnType<typeof useDiscountCheckCodeSuspenseQuery>;
export type DiscountCheckCodeQueryResult = Apollo.QueryResult<DiscountCheckCodeQuery, DiscountCheckCodeQueryVariables>;
export const InvoiceCreateByCartDocument = gql`
    mutation InvoiceCreateByCart($cart: CreateInvoiceInput!) {
  invoiceCreateByCart(cart: $cart) {
    ...InvoiceCreateByCartFragment
  }
}
    ${InvoiceCreateByCartFragmentFragmentDoc}`;
export type InvoiceCreateByCartMutationFn = Apollo.MutationFunction<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables>;
export type InvoiceCreateByCartQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables>, 'mutation'>;

    export const InvoiceCreateByCartQuery = (props: InvoiceCreateByCartQueryProps) => (
      <ApolloReactComponents.Mutation<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables> mutation={InvoiceCreateByCartDocument} {...props} />
    );


/**
 * __useInvoiceCreateByCartMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateByCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateByCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateByCartMutation, { data, loading, error }] = useInvoiceCreateByCartMutation({
 *   variables: {
 *      cart: // value for 'cart'
 *   },
 * });
 */
export function useInvoiceCreateByCartMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables>(InvoiceCreateByCartDocument, options);
      }
export type InvoiceCreateByCartMutationHookResult = ReturnType<typeof useInvoiceCreateByCartMutation>;
export type InvoiceCreateByCartMutationResult = Apollo.MutationResult<InvoiceCreateByCartMutation>;
export type InvoiceCreateByCartMutationOptions = Apollo.BaseMutationOptions<InvoiceCreateByCartMutation, InvoiceCreateByCartMutationVariables>;
export const InvoiceCreateByCartUnauthDocument = gql`
    mutation InvoiceCreateByCartUnauth($cart: CreateInvoiceInput!, $payer: PayerCreateInvoiceInput!) {
  invoiceCreateByCartUnauth(cart: $cart, payer: $payer) {
    ...InvoiceCreateByCartFragment
  }
}
    ${InvoiceCreateByCartFragmentFragmentDoc}`;
export type InvoiceCreateByCartUnauthMutationFn = Apollo.MutationFunction<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables>;
export type InvoiceCreateByCartUnauthQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables>, 'mutation'>;

    export const InvoiceCreateByCartUnauthQuery = (props: InvoiceCreateByCartUnauthQueryProps) => (
      <ApolloReactComponents.Mutation<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables> mutation={InvoiceCreateByCartUnauthDocument} {...props} />
    );


/**
 * __useInvoiceCreateByCartUnauthMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateByCartUnauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateByCartUnauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateByCartUnauthMutation, { data, loading, error }] = useInvoiceCreateByCartUnauthMutation({
 *   variables: {
 *      cart: // value for 'cart'
 *      payer: // value for 'payer'
 *   },
 * });
 */
export function useInvoiceCreateByCartUnauthMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables>(InvoiceCreateByCartUnauthDocument, options);
      }
export type InvoiceCreateByCartUnauthMutationHookResult = ReturnType<typeof useInvoiceCreateByCartUnauthMutation>;
export type InvoiceCreateByCartUnauthMutationResult = Apollo.MutationResult<InvoiceCreateByCartUnauthMutation>;
export type InvoiceCreateByCartUnauthMutationOptions = Apollo.BaseMutationOptions<InvoiceCreateByCartUnauthMutation, InvoiceCreateByCartUnauthMutationVariables>;
export const InvoiceCreateBySharedCartDocument = gql`
    mutation InvoiceCreateBySharedCart($sharedCart: CreateBySharedCartInvoiceInput!) {
  invoiceCreateBySharedCart(sharedCart: $sharedCart) {
    ...InvoiceCreateByCartFragment
  }
}
    ${InvoiceCreateByCartFragmentFragmentDoc}`;
export type InvoiceCreateBySharedCartMutationFn = Apollo.MutationFunction<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables>;
export type InvoiceCreateBySharedCartQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables>, 'mutation'>;

    export const InvoiceCreateBySharedCartQuery = (props: InvoiceCreateBySharedCartQueryProps) => (
      <ApolloReactComponents.Mutation<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables> mutation={InvoiceCreateBySharedCartDocument} {...props} />
    );


/**
 * __useInvoiceCreateBySharedCartMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateBySharedCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateBySharedCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateBySharedCartMutation, { data, loading, error }] = useInvoiceCreateBySharedCartMutation({
 *   variables: {
 *      sharedCart: // value for 'sharedCart'
 *   },
 * });
 */
export function useInvoiceCreateBySharedCartMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables>(InvoiceCreateBySharedCartDocument, options);
      }
export type InvoiceCreateBySharedCartMutationHookResult = ReturnType<typeof useInvoiceCreateBySharedCartMutation>;
export type InvoiceCreateBySharedCartMutationResult = Apollo.MutationResult<InvoiceCreateBySharedCartMutation>;
export type InvoiceCreateBySharedCartMutationOptions = Apollo.BaseMutationOptions<InvoiceCreateBySharedCartMutation, InvoiceCreateBySharedCartMutationVariables>;
export const ListFriendsByStatusDocument = gql`
    query ListFriendsByStatus($list: ListInput!, $filter: FilterFriendshipInput!, $sort: BaseSortInput, $relUserId: Int) {
  friendshipFindMany(
    list: $list
    filter: $filter
    sort: $sort
    relUserId: $relUserId
  ) {
    count
    items {
      id
      lastOnlineAt
      profile {
        id
        sex
        firstName
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ListFriendsByStatusQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>, 'query'> & ({ variables: ListFriendsByStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ListFriendsByStatusQuery = (props: ListFriendsByStatusQueryProps) => (
      <ApolloReactComponents.Query<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables> query={ListFriendsByStatusDocument} {...props} />
    );


/**
 * __useListFriendsByStatusQuery__
 *
 * To run a query within a React component, call `useListFriendsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFriendsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFriendsByStatusQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      relUserId: // value for 'relUserId'
 *   },
 * });
 */
export function useListFriendsByStatusQuery(baseOptions: Apollo.QueryHookOptions<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables> & ({ variables: ListFriendsByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>(ListFriendsByStatusDocument, options);
      }
export function useListFriendsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>(ListFriendsByStatusDocument, options);
        }
export function useListFriendsByStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>(ListFriendsByStatusDocument, options);
        }
export type ListFriendsByStatusQueryHookResult = ReturnType<typeof useListFriendsByStatusQuery>;
export type ListFriendsByStatusLazyQueryHookResult = ReturnType<typeof useListFriendsByStatusLazyQuery>;
export type ListFriendsByStatusSuspenseQueryHookResult = ReturnType<typeof useListFriendsByStatusSuspenseQuery>;
export type ListFriendsByStatusQueryResult = Apollo.QueryResult<ListFriendsByStatusQuery, ListFriendsByStatusQueryVariables>;
export const PossibleFriendsListDocument = gql`
    query PossibleFriendsList($list: ListInput!) {
  friendshipFindManyPossible(list: $list) {
    count
    items {
      id
      lastOnlineAt
      friendshipStatus
      profile {
        id
        fullName
        ...ProfileTitleFragment
        user {
          id
          lastOnlineAt
        }
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type PossibleFriendsListQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>, 'query'> & ({ variables: PossibleFriendsListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PossibleFriendsListQuery = (props: PossibleFriendsListQueryProps) => (
      <ApolloReactComponents.Query<PossibleFriendsListQuery, PossibleFriendsListQueryVariables> query={PossibleFriendsListDocument} {...props} />
    );


/**
 * __usePossibleFriendsListQuery__
 *
 * To run a query within a React component, call `usePossibleFriendsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossibleFriendsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossibleFriendsListQuery({
 *   variables: {
 *      list: // value for 'list'
 *   },
 * });
 */
export function usePossibleFriendsListQuery(baseOptions: Apollo.QueryHookOptions<PossibleFriendsListQuery, PossibleFriendsListQueryVariables> & ({ variables: PossibleFriendsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>(PossibleFriendsListDocument, options);
      }
export function usePossibleFriendsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>(PossibleFriendsListDocument, options);
        }
export function usePossibleFriendsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>(PossibleFriendsListDocument, options);
        }
export type PossibleFriendsListQueryHookResult = ReturnType<typeof usePossibleFriendsListQuery>;
export type PossibleFriendsListLazyQueryHookResult = ReturnType<typeof usePossibleFriendsListLazyQuery>;
export type PossibleFriendsListSuspenseQueryHookResult = ReturnType<typeof usePossibleFriendsListSuspenseQuery>;
export type PossibleFriendsListQueryResult = Apollo.QueryResult<PossibleFriendsListQuery, PossibleFriendsListQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($list: ListInput!, $filter: FilterNotificationInput!, $sort: BaseSortInput) {
  notificationFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      createdAt
      ...NotificationFragment
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;
export type NotificationsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<NotificationsQuery, NotificationsQueryVariables>, 'query'> & ({ variables: NotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NotificationsQuery = (props: NotificationsQueryProps) => (
      <ApolloReactComponents.Query<NotificationsQuery, NotificationsQueryVariables> query={NotificationsDocument} {...props} />
    );


/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables> & ({ variables: NotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationCountByStatusDocument = gql`
    query NotificationCountByStatus($notificationStatus: NotificationStatus!) {
  notificationCountByStatus(notificationStatus: $notificationStatus)
}
    `;
export type NotificationCountByStatusQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>, 'query'> & ({ variables: NotificationCountByStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NotificationCountByStatusQuery = (props: NotificationCountByStatusQueryProps) => (
      <ApolloReactComponents.Query<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables> query={NotificationCountByStatusDocument} {...props} />
    );


/**
 * __useNotificationCountByStatusQuery__
 *
 * To run a query within a React component, call `useNotificationCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCountByStatusQuery({
 *   variables: {
 *      notificationStatus: // value for 'notificationStatus'
 *   },
 * });
 */
export function useNotificationCountByStatusQuery(baseOptions: Apollo.QueryHookOptions<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables> & ({ variables: NotificationCountByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>(NotificationCountByStatusDocument, options);
      }
export function useNotificationCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>(NotificationCountByStatusDocument, options);
        }
export function useNotificationCountByStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>(NotificationCountByStatusDocument, options);
        }
export type NotificationCountByStatusQueryHookResult = ReturnType<typeof useNotificationCountByStatusQuery>;
export type NotificationCountByStatusLazyQueryHookResult = ReturnType<typeof useNotificationCountByStatusLazyQuery>;
export type NotificationCountByStatusSuspenseQueryHookResult = ReturnType<typeof useNotificationCountByStatusSuspenseQuery>;
export type NotificationCountByStatusQueryResult = Apollo.QueryResult<NotificationCountByStatusQuery, NotificationCountByStatusQueryVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($notificationId: Int!) {
  notificationReadNotification(notificationId: $notificationId) {
    id
    status
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;
export type ReadNotificationQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ReadNotificationMutation, ReadNotificationMutationVariables>, 'mutation'>;

    export const ReadNotificationQuery = (props: ReadNotificationQueryProps) => (
      <ApolloReactComponents.Mutation<ReadNotificationMutation, ReadNotificationMutationVariables> mutation={ReadNotificationDocument} {...props} />
    );


/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation ReadAllNotifications {
  notificationReadAllNotifications
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export type ReadAllNotificationsQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>, 'mutation'>;

    export const ReadAllNotificationsQuery = (props: ReadAllNotificationsQueryProps) => (
      <ApolloReactComponents.Mutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables> mutation={ReadAllNotificationsDocument} {...props} />
    );


/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const NotificationListenNewUnreadCountDocument = gql`
    subscription NotificationListenNewUnreadCount {
  notificationListenNewUnreadNotificationCount
}
    `;
export type NotificationListenNewUnreadCountQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<NotificationListenNewUnreadCountSubscription, NotificationListenNewUnreadCountSubscriptionVariables>, 'subscription'>;

    export const NotificationListenNewUnreadCountQuery = (props: NotificationListenNewUnreadCountQueryProps) => (
      <ApolloReactComponents.Subscription<NotificationListenNewUnreadCountSubscription, NotificationListenNewUnreadCountSubscriptionVariables> subscription={NotificationListenNewUnreadCountDocument} {...props} />
    );


/**
 * __useNotificationListenNewUnreadCountSubscription__
 *
 * To run a query within a React component, call `useNotificationListenNewUnreadCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationListenNewUnreadCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationListenNewUnreadCountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationListenNewUnreadCountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationListenNewUnreadCountSubscription, NotificationListenNewUnreadCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationListenNewUnreadCountSubscription, NotificationListenNewUnreadCountSubscriptionVariables>(NotificationListenNewUnreadCountDocument, options);
      }
export type NotificationListenNewUnreadCountSubscriptionHookResult = ReturnType<typeof useNotificationListenNewUnreadCountSubscription>;
export type NotificationListenNewUnreadCountSubscriptionResult = Apollo.SubscriptionResult<NotificationListenNewUnreadCountSubscription>;
export const NotificationListenNewUnreadDocument = gql`
    subscription NotificationListenNewUnread {
  notificationListenNewNotificationItemOrUpdate {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;
export type NotificationListenNewUnreadQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<NotificationListenNewUnreadSubscription, NotificationListenNewUnreadSubscriptionVariables>, 'subscription'>;

    export const NotificationListenNewUnreadQuery = (props: NotificationListenNewUnreadQueryProps) => (
      <ApolloReactComponents.Subscription<NotificationListenNewUnreadSubscription, NotificationListenNewUnreadSubscriptionVariables> subscription={NotificationListenNewUnreadDocument} {...props} />
    );


/**
 * __useNotificationListenNewUnreadSubscription__
 *
 * To run a query within a React component, call `useNotificationListenNewUnreadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationListenNewUnreadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationListenNewUnreadSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationListenNewUnreadSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationListenNewUnreadSubscription, NotificationListenNewUnreadSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationListenNewUnreadSubscription, NotificationListenNewUnreadSubscriptionVariables>(NotificationListenNewUnreadDocument, options);
      }
export type NotificationListenNewUnreadSubscriptionHookResult = ReturnType<typeof useNotificationListenNewUnreadSubscription>;
export type NotificationListenNewUnreadSubscriptionResult = Apollo.SubscriptionResult<NotificationListenNewUnreadSubscription>;
export const ProfileFindOneDocument = gql`
    query ProfileFindOne($userId: Int!) {
  profileFindOne(userId: $userId) {
    ...ProfileFindOneFragment
  }
}
    ${ProfileFindOneFragmentFragmentDoc}`;
export type ProfileFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileFindOneQuery, ProfileFindOneQueryVariables>, 'query'> & ({ variables: ProfileFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfileFindOneQuery = (props: ProfileFindOneQueryProps) => (
      <ApolloReactComponents.Query<ProfileFindOneQuery, ProfileFindOneQueryVariables> query={ProfileFindOneDocument} {...props} />
    );


/**
 * __useProfileFindOneQuery__
 *
 * To run a query within a React component, call `useProfileFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileFindOneQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileFindOneQuery(baseOptions: Apollo.QueryHookOptions<ProfileFindOneQuery, ProfileFindOneQueryVariables> & ({ variables: ProfileFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileFindOneQuery, ProfileFindOneQueryVariables>(ProfileFindOneDocument, options);
      }
export function useProfileFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileFindOneQuery, ProfileFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileFindOneQuery, ProfileFindOneQueryVariables>(ProfileFindOneDocument, options);
        }
export function useProfileFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileFindOneQuery, ProfileFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileFindOneQuery, ProfileFindOneQueryVariables>(ProfileFindOneDocument, options);
        }
export type ProfileFindOneQueryHookResult = ReturnType<typeof useProfileFindOneQuery>;
export type ProfileFindOneLazyQueryHookResult = ReturnType<typeof useProfileFindOneLazyQuery>;
export type ProfileFindOneSuspenseQueryHookResult = ReturnType<typeof useProfileFindOneSuspenseQuery>;
export type ProfileFindOneQueryResult = Apollo.QueryResult<ProfileFindOneQuery, ProfileFindOneQueryVariables>;
export const ProfileInfoAuthDocument = gql`
    query ProfileInfoAuth($userId: Int!) {
  profileFindOne(userId: $userId) {
    ...ProfileFindOneFragment
  }
  friendshipGetFriendshipStatus(relUserId: $userId) {
    id
    status
    from {
      id
    }
    to {
      id
    }
  }
  educationPreferenceGetUserSubjects(relUserId: $userId) {
    ...SubjectFragment
  }
  friendshipFindMany(
    list: {skip: 0}
    filter: {status: Confirmed}
    sort: {}
    relUserId: $userId
  ) {
    count
  }
  friendshipFindManyCommon(list: {skip: 0, take: 3}, relUserId: $userId) {
    count
    items {
      id
      profile {
        id
        firstName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
  promotionCountInvited(relUserId: $userId)
  walletGetBalance(relUserId: $userId)
}
    ${ProfileFindOneFragmentFragmentDoc}
${SubjectFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type ProfileInfoAuthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>, 'query'> & ({ variables: ProfileInfoAuthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfileInfoAuthQuery = (props: ProfileInfoAuthQueryProps) => (
      <ApolloReactComponents.Query<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables> query={ProfileInfoAuthDocument} {...props} />
    );


/**
 * __useProfileInfoAuthQuery__
 *
 * To run a query within a React component, call `useProfileInfoAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInfoAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInfoAuthQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileInfoAuthQuery(baseOptions: Apollo.QueryHookOptions<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables> & ({ variables: ProfileInfoAuthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>(ProfileInfoAuthDocument, options);
      }
export function useProfileInfoAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>(ProfileInfoAuthDocument, options);
        }
export function useProfileInfoAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>(ProfileInfoAuthDocument, options);
        }
export type ProfileInfoAuthQueryHookResult = ReturnType<typeof useProfileInfoAuthQuery>;
export type ProfileInfoAuthLazyQueryHookResult = ReturnType<typeof useProfileInfoAuthLazyQuery>;
export type ProfileInfoAuthSuspenseQueryHookResult = ReturnType<typeof useProfileInfoAuthSuspenseQuery>;
export type ProfileInfoAuthQueryResult = Apollo.QueryResult<ProfileInfoAuthQuery, ProfileInfoAuthQueryVariables>;
export const ProfileInfoUnauthDocument = gql`
    query ProfileInfoUnauth($userId: Int!) {
  profileFindOne(userId: $userId) {
    ...ProfileFindOneFragment
    sex
  }
  educationPreferenceGetUserSubjects(relUserId: $userId) {
    ...SubjectFragment
  }
}
    ${ProfileFindOneFragmentFragmentDoc}
${SubjectFragmentFragmentDoc}`;
export type ProfileInfoUnauthQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>, 'query'> & ({ variables: ProfileInfoUnauthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfileInfoUnauthQuery = (props: ProfileInfoUnauthQueryProps) => (
      <ApolloReactComponents.Query<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables> query={ProfileInfoUnauthDocument} {...props} />
    );


/**
 * __useProfileInfoUnauthQuery__
 *
 * To run a query within a React component, call `useProfileInfoUnauthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInfoUnauthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInfoUnauthQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileInfoUnauthQuery(baseOptions: Apollo.QueryHookOptions<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables> & ({ variables: ProfileInfoUnauthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>(ProfileInfoUnauthDocument, options);
      }
export function useProfileInfoUnauthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>(ProfileInfoUnauthDocument, options);
        }
export function useProfileInfoUnauthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>(ProfileInfoUnauthDocument, options);
        }
export type ProfileInfoUnauthQueryHookResult = ReturnType<typeof useProfileInfoUnauthQuery>;
export type ProfileInfoUnauthLazyQueryHookResult = ReturnType<typeof useProfileInfoUnauthLazyQuery>;
export type ProfileInfoUnauthSuspenseQueryHookResult = ReturnType<typeof useProfileInfoUnauthSuspenseQuery>;
export type ProfileInfoUnauthQueryResult = Apollo.QueryResult<ProfileInfoUnauthQuery, ProfileInfoUnauthQueryVariables>;
export const SetFriendshipStatusDocument = gql`
    mutation setFriendshipStatus($relUserId: Int!, $status: FriendshipStatus!) {
  friendshipSetFriendshipStatus(relUserId: $relUserId, status: $status) {
    id
    status
    from {
      id
    }
    to {
      id
    }
  }
}
    `;
export type SetFriendshipStatusMutationFn = Apollo.MutationFunction<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables>;
export type SetFriendshipStatusQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables>, 'mutation'>;

    export const SetFriendshipStatusQuery = (props: SetFriendshipStatusQueryProps) => (
      <ApolloReactComponents.Mutation<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables> mutation={SetFriendshipStatusDocument} {...props} />
    );


/**
 * __useSetFriendshipStatusMutation__
 *
 * To run a mutation, you first call `useSetFriendshipStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFriendshipStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFriendshipStatusMutation, { data, loading, error }] = useSetFriendshipStatusMutation({
 *   variables: {
 *      relUserId: // value for 'relUserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetFriendshipStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables>(SetFriendshipStatusDocument, options);
      }
export type SetFriendshipStatusMutationHookResult = ReturnType<typeof useSetFriendshipStatusMutation>;
export type SetFriendshipStatusMutationResult = Apollo.MutationResult<SetFriendshipStatusMutation>;
export type SetFriendshipStatusMutationOptions = Apollo.BaseMutationOptions<SetFriendshipStatusMutation, SetFriendshipStatusMutationVariables>;
export const ProfileListenTitleDocument = gql`
    subscription ProfileListenTitle($profileId: Int!) {
  profileListenNewState(profileId: $profileId) {
    id
    ...ProfileTitleFragment
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ProfileListenTitleQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<ProfileListenTitleSubscription, ProfileListenTitleSubscriptionVariables>, 'subscription'>;

    export const ProfileListenTitleQuery = (props: ProfileListenTitleQueryProps) => (
      <ApolloReactComponents.Subscription<ProfileListenTitleSubscription, ProfileListenTitleSubscriptionVariables> subscription={ProfileListenTitleDocument} {...props} />
    );


/**
 * __useProfileListenTitleSubscription__
 *
 * To run a query within a React component, call `useProfileListenTitleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProfileListenTitleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileListenTitleSubscription({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useProfileListenTitleSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProfileListenTitleSubscription, ProfileListenTitleSubscriptionVariables> & ({ variables: ProfileListenTitleSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProfileListenTitleSubscription, ProfileListenTitleSubscriptionVariables>(ProfileListenTitleDocument, options);
      }
export type ProfileListenTitleSubscriptionHookResult = ReturnType<typeof useProfileListenTitleSubscription>;
export type ProfileListenTitleSubscriptionResult = Apollo.SubscriptionResult<ProfileListenTitleSubscription>;
export const GetUserIdByAliasDocument = gql`
    query GetUserIdByAlias($userId: Int, $domain: String) {
  profileFindOne(userId: $userId, domain: $domain) {
    id
    user {
      id
    }
  }
}
    `;
export type GetUserIdByAliasQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>, 'query'>;

    export const GetUserIdByAliasQuery = (props: GetUserIdByAliasQueryProps) => (
      <ApolloReactComponents.Query<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables> query={GetUserIdByAliasDocument} {...props} />
    );


/**
 * __useGetUserIdByAliasQuery__
 *
 * To run a query within a React component, call `useGetUserIdByAliasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdByAliasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdByAliasQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetUserIdByAliasQuery(baseOptions?: Apollo.QueryHookOptions<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>(GetUserIdByAliasDocument, options);
      }
export function useGetUserIdByAliasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>(GetUserIdByAliasDocument, options);
        }
export function useGetUserIdByAliasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>(GetUserIdByAliasDocument, options);
        }
export type GetUserIdByAliasQueryHookResult = ReturnType<typeof useGetUserIdByAliasQuery>;
export type GetUserIdByAliasLazyQueryHookResult = ReturnType<typeof useGetUserIdByAliasLazyQuery>;
export type GetUserIdByAliasSuspenseQueryHookResult = ReturnType<typeof useGetUserIdByAliasSuspenseQuery>;
export type GetUserIdByAliasQueryResult = Apollo.QueryResult<GetUserIdByAliasQuery, GetUserIdByAliasQueryVariables>;
export const ProfileGetTitleDocument = gql`
    query ProfileGetTitle($userId: Int) {
  profileFindOne(userId: $userId) {
    id
    ...ProfileTitleFragment
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ProfileGetTitleQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>, 'query'>;

    export const ProfileGetTitleQuery = (props: ProfileGetTitleQueryProps) => (
      <ApolloReactComponents.Query<ProfileGetTitleQuery, ProfileGetTitleQueryVariables> query={ProfileGetTitleDocument} {...props} />
    );


/**
 * __useProfileGetTitleQuery__
 *
 * To run a query within a React component, call `useProfileGetTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGetTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGetTitleQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileGetTitleQuery(baseOptions?: Apollo.QueryHookOptions<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>(ProfileGetTitleDocument, options);
      }
export function useProfileGetTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>(ProfileGetTitleDocument, options);
        }
export function useProfileGetTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>(ProfileGetTitleDocument, options);
        }
export type ProfileGetTitleQueryHookResult = ReturnType<typeof useProfileGetTitleQuery>;
export type ProfileGetTitleLazyQueryHookResult = ReturnType<typeof useProfileGetTitleLazyQuery>;
export type ProfileGetTitleSuspenseQueryHookResult = ReturnType<typeof useProfileGetTitleSuspenseQuery>;
export type ProfileGetTitleQueryResult = Apollo.QueryResult<ProfileGetTitleQuery, ProfileGetTitleQueryVariables>;
export const ProfileUpdateTitleManuallyDocument = gql`
    mutation ProfileUpdateTitleManually($title: UpdateTitleProfileInput!) {
  profileUpdateTitleManually(title: $title) {
    ...ProfileTitleFragment
    id
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ProfileUpdateTitleManuallyMutationFn = Apollo.MutationFunction<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables>;
export type ProfileUpdateTitleManuallyQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables>, 'mutation'>;

    export const ProfileUpdateTitleManuallyQuery = (props: ProfileUpdateTitleManuallyQueryProps) => (
      <ApolloReactComponents.Mutation<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables> mutation={ProfileUpdateTitleManuallyDocument} {...props} />
    );


/**
 * __useProfileUpdateTitleManuallyMutation__
 *
 * To run a mutation, you first call `useProfileUpdateTitleManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateTitleManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateTitleManuallyMutation, { data, loading, error }] = useProfileUpdateTitleManuallyMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useProfileUpdateTitleManuallyMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables>(ProfileUpdateTitleManuallyDocument, options);
      }
export type ProfileUpdateTitleManuallyMutationHookResult = ReturnType<typeof useProfileUpdateTitleManuallyMutation>;
export type ProfileUpdateTitleManuallyMutationResult = Apollo.MutationResult<ProfileUpdateTitleManuallyMutation>;
export type ProfileUpdateTitleManuallyMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateTitleManuallyMutation, ProfileUpdateTitleManuallyMutationVariables>;
export const ListProfileSubjectsDocument = gql`
    query ListProfileSubjects($list: ListInput!, $filter: FilterSubjectInput!, $sort: BaseSortInput) {
  subjectFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      ...SubjectFragment
      ...EgeSubjectDetailsFragment
      egeSubjectInfo {
        dates {
          early
          main
          reserve
        }
      }
    }
  }
  educationPreferenceGetUserSubjects {
    ...EgeSubjectDetailsFragment
  }
}
    ${SubjectFragmentFragmentDoc}
${EgeSubjectDetailsFragmentFragmentDoc}`;
export type ListProfileSubjectsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>, 'query'> & ({ variables: ListProfileSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ListProfileSubjectsQuery = (props: ListProfileSubjectsQueryProps) => (
      <ApolloReactComponents.Query<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables> query={ListProfileSubjectsDocument} {...props} />
    );


/**
 * __useListProfileSubjectsQuery__
 *
 * To run a query within a React component, call `useListProfileSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProfileSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProfileSubjectsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListProfileSubjectsQuery(baseOptions: Apollo.QueryHookOptions<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables> & ({ variables: ListProfileSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>(ListProfileSubjectsDocument, options);
      }
export function useListProfileSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>(ListProfileSubjectsDocument, options);
        }
export function useListProfileSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>(ListProfileSubjectsDocument, options);
        }
export type ListProfileSubjectsQueryHookResult = ReturnType<typeof useListProfileSubjectsQuery>;
export type ListProfileSubjectsLazyQueryHookResult = ReturnType<typeof useListProfileSubjectsLazyQuery>;
export type ListProfileSubjectsSuspenseQueryHookResult = ReturnType<typeof useListProfileSubjectsSuspenseQuery>;
export type ListProfileSubjectsQueryResult = Apollo.QueryResult<ListProfileSubjectsQuery, ListProfileSubjectsQueryVariables>;
export const EgeUpdateUserSubjectsDocument = gql`
    mutation EgeUpdateUserSubjects($subjects: [EducationSubject!]!) {
  educationPreferenceSetUserSubjects(subjects: $subjects) {
    ...EgeSubjectDetailsFragment
  }
}
    ${EgeSubjectDetailsFragmentFragmentDoc}`;
export type EgeUpdateUserSubjectsMutationFn = Apollo.MutationFunction<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables>;
export type EgeUpdateUserSubjectsQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables>, 'mutation'>;

    export const EgeUpdateUserSubjectsQuery = (props: EgeUpdateUserSubjectsQueryProps) => (
      <ApolloReactComponents.Mutation<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables> mutation={EgeUpdateUserSubjectsDocument} {...props} />
    );


/**
 * __useEgeUpdateUserSubjectsMutation__
 *
 * To run a mutation, you first call `useEgeUpdateUserSubjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEgeUpdateUserSubjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [egeUpdateUserSubjectsMutation, { data, loading, error }] = useEgeUpdateUserSubjectsMutation({
 *   variables: {
 *      subjects: // value for 'subjects'
 *   },
 * });
 */
export function useEgeUpdateUserSubjectsMutation(baseOptions?: Apollo.MutationHookOptions<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables>(EgeUpdateUserSubjectsDocument, options);
      }
export type EgeUpdateUserSubjectsMutationHookResult = ReturnType<typeof useEgeUpdateUserSubjectsMutation>;
export type EgeUpdateUserSubjectsMutationResult = Apollo.MutationResult<EgeUpdateUserSubjectsMutation>;
export type EgeUpdateUserSubjectsMutationOptions = Apollo.BaseMutationOptions<EgeUpdateUserSubjectsMutation, EgeUpdateUserSubjectsMutationVariables>;
export const SubjectFindManyDocument = gql`
    query SubjectFindMany($list: ListInput!, $filter: FilterSubjectInput!, $sort: BaseSortInput) {
  subjectFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    page
    pages
    items {
      ...SubjectFragment
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;
export type SubjectFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SubjectFindManyQuery, SubjectFindManyQueryVariables>, 'query'> & ({ variables: SubjectFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubjectFindManyQuery = (props: SubjectFindManyQueryProps) => (
      <ApolloReactComponents.Query<SubjectFindManyQuery, SubjectFindManyQueryVariables> query={SubjectFindManyDocument} {...props} />
    );


/**
 * __useSubjectFindManyQuery__
 *
 * To run a query within a React component, call `useSubjectFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSubjectFindManyQuery(baseOptions: Apollo.QueryHookOptions<SubjectFindManyQuery, SubjectFindManyQueryVariables> & ({ variables: SubjectFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectFindManyQuery, SubjectFindManyQueryVariables>(SubjectFindManyDocument, options);
      }
export function useSubjectFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectFindManyQuery, SubjectFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectFindManyQuery, SubjectFindManyQueryVariables>(SubjectFindManyDocument, options);
        }
export function useSubjectFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectFindManyQuery, SubjectFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectFindManyQuery, SubjectFindManyQueryVariables>(SubjectFindManyDocument, options);
        }
export type SubjectFindManyQueryHookResult = ReturnType<typeof useSubjectFindManyQuery>;
export type SubjectFindManyLazyQueryHookResult = ReturnType<typeof useSubjectFindManyLazyQuery>;
export type SubjectFindManySuspenseQueryHookResult = ReturnType<typeof useSubjectFindManySuspenseQuery>;
export type SubjectFindManyQueryResult = Apollo.QueryResult<SubjectFindManyQuery, SubjectFindManyQueryVariables>;
export const WalletOperationsDocument = gql`
    query WalletOperations($list: ListInput!, $filter: FilterWalletInput!, $sort: BaseSortInput) {
  walletOperationFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      isRefund
      id
      createdAt
      identifier
      type
      amount
      name
      comment
      tournament {
        id
        type
        state
        subject
        bet
        finishAt
      }
      toUser {
        ...WalletOperationUserFragment
      }
      fromUser {
        ...WalletOperationUserFragment
      }
    }
    pages
  }
}
    ${WalletOperationUserFragmentFragmentDoc}`;
export type WalletOperationsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WalletOperationsQuery, WalletOperationsQueryVariables>, 'query'> & ({ variables: WalletOperationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WalletOperationsQuery = (props: WalletOperationsQueryProps) => (
      <ApolloReactComponents.Query<WalletOperationsQuery, WalletOperationsQueryVariables> query={WalletOperationsDocument} {...props} />
    );


/**
 * __useWalletOperationsQuery__
 *
 * To run a query within a React component, call `useWalletOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletOperationsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWalletOperationsQuery(baseOptions: Apollo.QueryHookOptions<WalletOperationsQuery, WalletOperationsQueryVariables> & ({ variables: WalletOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletOperationsQuery, WalletOperationsQueryVariables>(WalletOperationsDocument, options);
      }
export function useWalletOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletOperationsQuery, WalletOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletOperationsQuery, WalletOperationsQueryVariables>(WalletOperationsDocument, options);
        }
export function useWalletOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletOperationsQuery, WalletOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletOperationsQuery, WalletOperationsQueryVariables>(WalletOperationsDocument, options);
        }
export type WalletOperationsQueryHookResult = ReturnType<typeof useWalletOperationsQuery>;
export type WalletOperationsLazyQueryHookResult = ReturnType<typeof useWalletOperationsLazyQuery>;
export type WalletOperationsSuspenseQueryHookResult = ReturnType<typeof useWalletOperationsSuspenseQuery>;
export type WalletOperationsQueryResult = Apollo.QueryResult<WalletOperationsQuery, WalletOperationsQueryVariables>;
export const WalletCardDocument = gql`
    query WalletCard {
  walletGetBalance
  walletGetMonthlyIncome
  walletGetMonthlyExpense
}
    `;
export type WalletCardQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WalletCardQuery, WalletCardQueryVariables>, 'query'>;

    export const WalletCardQuery = (props: WalletCardQueryProps) => (
      <ApolloReactComponents.Query<WalletCardQuery, WalletCardQueryVariables> query={WalletCardDocument} {...props} />
    );


/**
 * __useWalletCardQuery__
 *
 * To run a query within a React component, call `useWalletCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletCardQuery(baseOptions?: Apollo.QueryHookOptions<WalletCardQuery, WalletCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletCardQuery, WalletCardQueryVariables>(WalletCardDocument, options);
      }
export function useWalletCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletCardQuery, WalletCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletCardQuery, WalletCardQueryVariables>(WalletCardDocument, options);
        }
export function useWalletCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletCardQuery, WalletCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletCardQuery, WalletCardQueryVariables>(WalletCardDocument, options);
        }
export type WalletCardQueryHookResult = ReturnType<typeof useWalletCardQuery>;
export type WalletCardLazyQueryHookResult = ReturnType<typeof useWalletCardLazyQuery>;
export type WalletCardSuspenseQueryHookResult = ReturnType<typeof useWalletCardSuspenseQuery>;
export type WalletCardQueryResult = Apollo.QueryResult<WalletCardQuery, WalletCardQueryVariables>;
export const WalletGetBalanceDocument = gql`
    query WalletGetBalance {
  walletGetBalance
}
    `;
export type WalletGetBalanceQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>, 'query'>;

    export const WalletGetBalanceQuery = (props: WalletGetBalanceQueryProps) => (
      <ApolloReactComponents.Query<WalletGetBalanceQuery, WalletGetBalanceQueryVariables> query={WalletGetBalanceDocument} {...props} />
    );


/**
 * __useWalletGetBalanceQuery__
 *
 * To run a query within a React component, call `useWalletGetBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletGetBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletGetBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletGetBalanceQuery(baseOptions?: Apollo.QueryHookOptions<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>(WalletGetBalanceDocument, options);
      }
export function useWalletGetBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>(WalletGetBalanceDocument, options);
        }
export function useWalletGetBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>(WalletGetBalanceDocument, options);
        }
export type WalletGetBalanceQueryHookResult = ReturnType<typeof useWalletGetBalanceQuery>;
export type WalletGetBalanceLazyQueryHookResult = ReturnType<typeof useWalletGetBalanceLazyQuery>;
export type WalletGetBalanceSuspenseQueryHookResult = ReturnType<typeof useWalletGetBalanceSuspenseQuery>;
export type WalletGetBalanceQueryResult = Apollo.QueryResult<WalletGetBalanceQuery, WalletGetBalanceQueryVariables>;
export const UserBalanceListenUpdateDocument = gql`
    subscription UserBalanceListenUpdate {
  walletListenNewUserBalance
}
    `;
export type UserBalanceListenUpdateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<UserBalanceListenUpdateSubscription, UserBalanceListenUpdateSubscriptionVariables>, 'subscription'>;

    export const UserBalanceListenUpdateQuery = (props: UserBalanceListenUpdateQueryProps) => (
      <ApolloReactComponents.Subscription<UserBalanceListenUpdateSubscription, UserBalanceListenUpdateSubscriptionVariables> subscription={UserBalanceListenUpdateDocument} {...props} />
    );


/**
 * __useUserBalanceListenUpdateSubscription__
 *
 * To run a query within a React component, call `useUserBalanceListenUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserBalanceListenUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBalanceListenUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserBalanceListenUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserBalanceListenUpdateSubscription, UserBalanceListenUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserBalanceListenUpdateSubscription, UserBalanceListenUpdateSubscriptionVariables>(UserBalanceListenUpdateDocument, options);
      }
export type UserBalanceListenUpdateSubscriptionHookResult = ReturnType<typeof useUserBalanceListenUpdateSubscription>;
export type UserBalanceListenUpdateSubscriptionResult = Apollo.SubscriptionResult<UserBalanceListenUpdateSubscription>;
export const WalletMakeTransferDocument = gql`
    mutation WalletMakeTransfer($transfer: MakeTransferWalletInput!) {
  walletOperationMakeTransfer(transfer: $transfer) {
    id
    createdAt
    type
    amount
    identifier
  }
}
    `;
export type WalletMakeTransferMutationFn = Apollo.MutationFunction<WalletMakeTransferMutation, WalletMakeTransferMutationVariables>;
export type WalletMakeTransferQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<WalletMakeTransferMutation, WalletMakeTransferMutationVariables>, 'mutation'>;

    export const WalletMakeTransferQuery = (props: WalletMakeTransferQueryProps) => (
      <ApolloReactComponents.Mutation<WalletMakeTransferMutation, WalletMakeTransferMutationVariables> mutation={WalletMakeTransferDocument} {...props} />
    );


/**
 * __useWalletMakeTransferMutation__
 *
 * To run a mutation, you first call `useWalletMakeTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletMakeTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletMakeTransferMutation, { data, loading, error }] = useWalletMakeTransferMutation({
 *   variables: {
 *      transfer: // value for 'transfer'
 *   },
 * });
 */
export function useWalletMakeTransferMutation(baseOptions?: Apollo.MutationHookOptions<WalletMakeTransferMutation, WalletMakeTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletMakeTransferMutation, WalletMakeTransferMutationVariables>(WalletMakeTransferDocument, options);
      }
export type WalletMakeTransferMutationHookResult = ReturnType<typeof useWalletMakeTransferMutation>;
export type WalletMakeTransferMutationResult = Apollo.MutationResult<WalletMakeTransferMutation>;
export type WalletMakeTransferMutationOptions = Apollo.BaseMutationOptions<WalletMakeTransferMutation, WalletMakeTransferMutationVariables>;
export const FriendsReceiverListDocument = gql`
    query FriendsReceiverList($list: ListInput!, $filter: FilterFriendshipInput!, $sort: BaseSortInput, $relUserId: Int) {
  friendshipFindMany(
    list: $list
    filter: $filter
    sort: $sort
    relUserId: $relUserId
  ) {
    count
    items {
      id
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type FriendsReceiverListQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>, 'query'> & ({ variables: FriendsReceiverListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FriendsReceiverListQuery = (props: FriendsReceiverListQueryProps) => (
      <ApolloReactComponents.Query<FriendsReceiverListQuery, FriendsReceiverListQueryVariables> query={FriendsReceiverListDocument} {...props} />
    );


/**
 * __useFriendsReceiverListQuery__
 *
 * To run a query within a React component, call `useFriendsReceiverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsReceiverListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsReceiverListQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      relUserId: // value for 'relUserId'
 *   },
 * });
 */
export function useFriendsReceiverListQuery(baseOptions: Apollo.QueryHookOptions<FriendsReceiverListQuery, FriendsReceiverListQueryVariables> & ({ variables: FriendsReceiverListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>(FriendsReceiverListDocument, options);
      }
export function useFriendsReceiverListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>(FriendsReceiverListDocument, options);
        }
export function useFriendsReceiverListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>(FriendsReceiverListDocument, options);
        }
export type FriendsReceiverListQueryHookResult = ReturnType<typeof useFriendsReceiverListQuery>;
export type FriendsReceiverListLazyQueryHookResult = ReturnType<typeof useFriendsReceiverListLazyQuery>;
export type FriendsReceiverListSuspenseQueryHookResult = ReturnType<typeof useFriendsReceiverListSuspenseQuery>;
export type FriendsReceiverListQueryResult = Apollo.QueryResult<FriendsReceiverListQuery, FriendsReceiverListQueryVariables>;
export const SendConfirmationDocument = gql`
    query SendConfirmation($userId: Int!) {
  profileFindOne(userId: $userId) {
    id
    fullName
    ...ProfileTitleFragment
    avatar {
      id
      medium
    }
    user {
      id
      lastOnlineAt
    }
  }
  walletGetBalance
  walletGetMonthlyIncome
  walletGetMonthlyExpense
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type SendConfirmationQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SendConfirmationQuery, SendConfirmationQueryVariables>, 'query'> & ({ variables: SendConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SendConfirmationQuery = (props: SendConfirmationQueryProps) => (
      <ApolloReactComponents.Query<SendConfirmationQuery, SendConfirmationQueryVariables> query={SendConfirmationDocument} {...props} />
    );


/**
 * __useSendConfirmationQuery__
 *
 * To run a query within a React component, call `useSendConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendConfirmationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendConfirmationQuery(baseOptions: Apollo.QueryHookOptions<SendConfirmationQuery, SendConfirmationQueryVariables> & ({ variables: SendConfirmationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendConfirmationQuery, SendConfirmationQueryVariables>(SendConfirmationDocument, options);
      }
export function useSendConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendConfirmationQuery, SendConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendConfirmationQuery, SendConfirmationQueryVariables>(SendConfirmationDocument, options);
        }
export function useSendConfirmationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SendConfirmationQuery, SendConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SendConfirmationQuery, SendConfirmationQueryVariables>(SendConfirmationDocument, options);
        }
export type SendConfirmationQueryHookResult = ReturnType<typeof useSendConfirmationQuery>;
export type SendConfirmationLazyQueryHookResult = ReturnType<typeof useSendConfirmationLazyQuery>;
export type SendConfirmationSuspenseQueryHookResult = ReturnType<typeof useSendConfirmationSuspenseQuery>;
export type SendConfirmationQueryResult = Apollo.QueryResult<SendConfirmationQuery, SendConfirmationQueryVariables>;
export const WalletFindOneOperationDocument = gql`
    query WalletFindOneOperation($operationId: Int!) {
  walletOperationFindOne(operationId: $operationId) {
    id
    amount
    comment
    createdAt
    toUser {
      id
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type WalletFindOneOperationQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>, 'query'> & ({ variables: WalletFindOneOperationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WalletFindOneOperationQuery = (props: WalletFindOneOperationQueryProps) => (
      <ApolloReactComponents.Query<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables> query={WalletFindOneOperationDocument} {...props} />
    );


/**
 * __useWalletFindOneOperationQuery__
 *
 * To run a query within a React component, call `useWalletFindOneOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletFindOneOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletFindOneOperationQuery({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useWalletFindOneOperationQuery(baseOptions: Apollo.QueryHookOptions<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables> & ({ variables: WalletFindOneOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>(WalletFindOneOperationDocument, options);
      }
export function useWalletFindOneOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>(WalletFindOneOperationDocument, options);
        }
export function useWalletFindOneOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>(WalletFindOneOperationDocument, options);
        }
export type WalletFindOneOperationQueryHookResult = ReturnType<typeof useWalletFindOneOperationQuery>;
export type WalletFindOneOperationLazyQueryHookResult = ReturnType<typeof useWalletFindOneOperationLazyQuery>;
export type WalletFindOneOperationSuspenseQueryHookResult = ReturnType<typeof useWalletFindOneOperationSuspenseQuery>;
export type WalletFindOneOperationQueryResult = Apollo.QueryResult<WalletFindOneOperationQuery, WalletFindOneOperationQueryVariables>;
export const SearchProfileDocument = gql`
    query SearchProfile($list: ListInput!, $filter: FilterProfileInput!, $sort: BaseSortInput) {
  profileFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      id
      sex
      fullName
      fullNameShort
      ...ProfileTitleFragment
      avatar {
        id
        medium
      }
      user {
        id
        lastOnlineAt
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type SearchProfileQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchProfileQuery, SearchProfileQueryVariables>, 'query'> & ({ variables: SearchProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchProfileQuery = (props: SearchProfileQueryProps) => (
      <ApolloReactComponents.Query<SearchProfileQuery, SearchProfileQueryVariables> query={SearchProfileDocument} {...props} />
    );


/**
 * __useSearchProfileQuery__
 *
 * To run a query within a React component, call `useSearchProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfileQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchProfileQuery(baseOptions: Apollo.QueryHookOptions<SearchProfileQuery, SearchProfileQueryVariables> & ({ variables: SearchProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProfileQuery, SearchProfileQueryVariables>(SearchProfileDocument, options);
      }
export function useSearchProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProfileQuery, SearchProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProfileQuery, SearchProfileQueryVariables>(SearchProfileDocument, options);
        }
export function useSearchProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchProfileQuery, SearchProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProfileQuery, SearchProfileQueryVariables>(SearchProfileDocument, options);
        }
export type SearchProfileQueryHookResult = ReturnType<typeof useSearchProfileQuery>;
export type SearchProfileLazyQueryHookResult = ReturnType<typeof useSearchProfileLazyQuery>;
export type SearchProfileSuspenseQueryHookResult = ReturnType<typeof useSearchProfileSuspenseQuery>;
export type SearchProfileQueryResult = Apollo.QueryResult<SearchProfileQuery, SearchProfileQueryVariables>;
export const ApplyInvitationBonusDocument = gql`
    mutation ApplyInvitationBonus($uuid: String!) {
  promotionApplyInvitationBonus(uuid: $uuid) {
    id
    createdAt
    inviter {
      id
      profile {
        id
        fullName
        ...ProfileTitleFragment
        user {
          id
          lastOnlineAt
        }
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ApplyInvitationBonusMutationFn = Apollo.MutationFunction<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables>;
export type ApplyInvitationBonusQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables>, 'mutation'>;

    export const ApplyInvitationBonusQuery = (props: ApplyInvitationBonusQueryProps) => (
      <ApolloReactComponents.Mutation<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables> mutation={ApplyInvitationBonusDocument} {...props} />
    );


/**
 * __useApplyInvitationBonusMutation__
 *
 * To run a mutation, you first call `useApplyInvitationBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyInvitationBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyInvitationBonusMutation, { data, loading, error }] = useApplyInvitationBonusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useApplyInvitationBonusMutation(baseOptions?: Apollo.MutationHookOptions<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables>(ApplyInvitationBonusDocument, options);
      }
export type ApplyInvitationBonusMutationHookResult = ReturnType<typeof useApplyInvitationBonusMutation>;
export type ApplyInvitationBonusMutationResult = Apollo.MutationResult<ApplyInvitationBonusMutation>;
export type ApplyInvitationBonusMutationOptions = Apollo.BaseMutationOptions<ApplyInvitationBonusMutation, ApplyInvitationBonusMutationVariables>;
export const SchoolManageCreateWithSellerDocument = gql`
    mutation SchoolManageCreateWithSeller($school: CreateSchoolInput!) {
  schoolManageCreateWithSeller(school: $school) {
    ...SchoolManageFragment
    seller {
      ...SellerFragment
    }
  }
}
    ${SchoolManageFragmentFragmentDoc}
${SellerFragmentFragmentDoc}`;
export type SchoolManageCreateWithSellerMutationFn = Apollo.MutationFunction<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables>;
export type SchoolManageCreateWithSellerQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables>, 'mutation'>;

    export const SchoolManageCreateWithSellerQuery = (props: SchoolManageCreateWithSellerQueryProps) => (
      <ApolloReactComponents.Mutation<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables> mutation={SchoolManageCreateWithSellerDocument} {...props} />
    );


/**
 * __useSchoolManageCreateWithSellerMutation__
 *
 * To run a mutation, you first call `useSchoolManageCreateWithSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolManageCreateWithSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolManageCreateWithSellerMutation, { data, loading, error }] = useSchoolManageCreateWithSellerMutation({
 *   variables: {
 *      school: // value for 'school'
 *   },
 * });
 */
export function useSchoolManageCreateWithSellerMutation(baseOptions?: Apollo.MutationHookOptions<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables>(SchoolManageCreateWithSellerDocument, options);
      }
export type SchoolManageCreateWithSellerMutationHookResult = ReturnType<typeof useSchoolManageCreateWithSellerMutation>;
export type SchoolManageCreateWithSellerMutationResult = Apollo.MutationResult<SchoolManageCreateWithSellerMutation>;
export type SchoolManageCreateWithSellerMutationOptions = Apollo.BaseMutationOptions<SchoolManageCreateWithSellerMutation, SchoolManageCreateWithSellerMutationVariables>;
export const SchoolFindOneDocument = gql`
    query SchoolFindOne($schoolId: Int!) {
  schoolFindOne(schoolId: $schoolId) {
    ...SchoolFragment
  }
}
    ${SchoolFragmentFragmentDoc}`;
export type SchoolFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolFindOneQuery, SchoolFindOneQueryVariables>, 'query'> & ({ variables: SchoolFindOneQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolFindOneQuery = (props: SchoolFindOneQueryProps) => (
      <ApolloReactComponents.Query<SchoolFindOneQuery, SchoolFindOneQueryVariables> query={SchoolFindOneDocument} {...props} />
    );


/**
 * __useSchoolFindOneQuery__
 *
 * To run a query within a React component, call `useSchoolFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolFindOneQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSchoolFindOneQuery(baseOptions: Apollo.QueryHookOptions<SchoolFindOneQuery, SchoolFindOneQueryVariables> & ({ variables: SchoolFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolFindOneQuery, SchoolFindOneQueryVariables>(SchoolFindOneDocument, options);
      }
export function useSchoolFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolFindOneQuery, SchoolFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolFindOneQuery, SchoolFindOneQueryVariables>(SchoolFindOneDocument, options);
        }
export function useSchoolFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolFindOneQuery, SchoolFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolFindOneQuery, SchoolFindOneQueryVariables>(SchoolFindOneDocument, options);
        }
export type SchoolFindOneQueryHookResult = ReturnType<typeof useSchoolFindOneQuery>;
export type SchoolFindOneLazyQueryHookResult = ReturnType<typeof useSchoolFindOneLazyQuery>;
export type SchoolFindOneSuspenseQueryHookResult = ReturnType<typeof useSchoolFindOneSuspenseQuery>;
export type SchoolFindOneQueryResult = Apollo.QueryResult<SchoolFindOneQuery, SchoolFindOneQueryVariables>;
export const SchoolFindOneManageDocument = gql`
    query SchoolFindOneManage($schoolId: Int!) {
  schoolFindOne(schoolId: $schoolId) {
    ...SchoolManageFragment
  }
}
    ${SchoolManageFragmentFragmentDoc}`;
export type SchoolFindOneManageQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>, 'query'> & ({ variables: SchoolFindOneManageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SchoolFindOneManageQuery = (props: SchoolFindOneManageQueryProps) => (
      <ApolloReactComponents.Query<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables> query={SchoolFindOneManageDocument} {...props} />
    );


/**
 * __useSchoolFindOneManageQuery__
 *
 * To run a query within a React component, call `useSchoolFindOneManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolFindOneManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolFindOneManageQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSchoolFindOneManageQuery(baseOptions: Apollo.QueryHookOptions<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables> & ({ variables: SchoolFindOneManageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>(SchoolFindOneManageDocument, options);
      }
export function useSchoolFindOneManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>(SchoolFindOneManageDocument, options);
        }
export function useSchoolFindOneManageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>(SchoolFindOneManageDocument, options);
        }
export type SchoolFindOneManageQueryHookResult = ReturnType<typeof useSchoolFindOneManageQuery>;
export type SchoolFindOneManageLazyQueryHookResult = ReturnType<typeof useSchoolFindOneManageLazyQuery>;
export type SchoolFindOneManageSuspenseQueryHookResult = ReturnType<typeof useSchoolFindOneManageSuspenseQuery>;
export type SchoolFindOneManageQueryResult = Apollo.QueryResult<SchoolFindOneManageQuery, SchoolFindOneManageQueryVariables>;
export const SchoolListenUpdateDocument = gql`
    subscription SchoolListenUpdate($schoolId: Int!) {
  schoolListenUpdate(schoolId: $schoolId) {
    ...SchoolFragment
  }
}
    ${SchoolFragmentFragmentDoc}`;
export type SchoolListenUpdateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<SchoolListenUpdateSubscription, SchoolListenUpdateSubscriptionVariables>, 'subscription'>;

    export const SchoolListenUpdateQuery = (props: SchoolListenUpdateQueryProps) => (
      <ApolloReactComponents.Subscription<SchoolListenUpdateSubscription, SchoolListenUpdateSubscriptionVariables> subscription={SchoolListenUpdateDocument} {...props} />
    );


/**
 * __useSchoolListenUpdateSubscription__
 *
 * To run a query within a React component, call `useSchoolListenUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchoolListenUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolListenUpdateSubscription({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSchoolListenUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SchoolListenUpdateSubscription, SchoolListenUpdateSubscriptionVariables> & ({ variables: SchoolListenUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SchoolListenUpdateSubscription, SchoolListenUpdateSubscriptionVariables>(SchoolListenUpdateDocument, options);
      }
export type SchoolListenUpdateSubscriptionHookResult = ReturnType<typeof useSchoolListenUpdateSubscription>;
export type SchoolListenUpdateSubscriptionResult = Apollo.SubscriptionResult<SchoolListenUpdateSubscription>;
export const TaskAnswerFindOneByUuidDocument = gql`
    query TaskAnswerFindOneByUuid($taskAnswerUuid: String!) {
  taskAnswerFindOneByUuid(taskAnswerUuid: $taskAnswerUuid) {
    id
    point
    maxPoint
    answer {
      quiz
    }
    task {
      id
      uuid
      maxPoint
    }
  }
}
    `;
export type TaskAnswerFindOneByUuidQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>, 'query'> & ({ variables: TaskAnswerFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TaskAnswerFindOneByUuidQuery = (props: TaskAnswerFindOneByUuidQueryProps) => (
      <ApolloReactComponents.Query<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables> query={TaskAnswerFindOneByUuidDocument} {...props} />
    );


/**
 * __useTaskAnswerFindOneByUuidQuery__
 *
 * To run a query within a React component, call `useTaskAnswerFindOneByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskAnswerFindOneByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskAnswerFindOneByUuidQuery({
 *   variables: {
 *      taskAnswerUuid: // value for 'taskAnswerUuid'
 *   },
 * });
 */
export function useTaskAnswerFindOneByUuidQuery(baseOptions: Apollo.QueryHookOptions<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables> & ({ variables: TaskAnswerFindOneByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>(TaskAnswerFindOneByUuidDocument, options);
      }
export function useTaskAnswerFindOneByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>(TaskAnswerFindOneByUuidDocument, options);
        }
export function useTaskAnswerFindOneByUuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>(TaskAnswerFindOneByUuidDocument, options);
        }
export type TaskAnswerFindOneByUuidQueryHookResult = ReturnType<typeof useTaskAnswerFindOneByUuidQuery>;
export type TaskAnswerFindOneByUuidLazyQueryHookResult = ReturnType<typeof useTaskAnswerFindOneByUuidLazyQuery>;
export type TaskAnswerFindOneByUuidSuspenseQueryHookResult = ReturnType<typeof useTaskAnswerFindOneByUuidSuspenseQuery>;
export type TaskAnswerFindOneByUuidQueryResult = Apollo.QueryResult<TaskAnswerFindOneByUuidQuery, TaskAnswerFindOneByUuidQueryVariables>;
export const StartLookingForBlitzRivalDocument = gql`
    mutation StartLookingForBlitzRival($subject: EducationSubject!) {
  tournamentBlitzFindRival(subject: $subject) {
    id
    status
    subject
    tournament {
      id
    }
    user {
      ...RivalEntityFragment
    }
  }
}
    ${RivalEntityFragmentFragmentDoc}`;
export type StartLookingForBlitzRivalMutationFn = Apollo.MutationFunction<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables>;
export type StartLookingForBlitzRivalQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables>, 'mutation'>;

    export const StartLookingForBlitzRivalQuery = (props: StartLookingForBlitzRivalQueryProps) => (
      <ApolloReactComponents.Mutation<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables> mutation={StartLookingForBlitzRivalDocument} {...props} />
    );


/**
 * __useStartLookingForBlitzRivalMutation__
 *
 * To run a mutation, you first call `useStartLookingForBlitzRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLookingForBlitzRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLookingForBlitzRivalMutation, { data, loading, error }] = useStartLookingForBlitzRivalMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useStartLookingForBlitzRivalMutation(baseOptions?: Apollo.MutationHookOptions<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables>(StartLookingForBlitzRivalDocument, options);
      }
export type StartLookingForBlitzRivalMutationHookResult = ReturnType<typeof useStartLookingForBlitzRivalMutation>;
export type StartLookingForBlitzRivalMutationResult = Apollo.MutationResult<StartLookingForBlitzRivalMutation>;
export type StartLookingForBlitzRivalMutationOptions = Apollo.BaseMutationOptions<StartLookingForBlitzRivalMutation, StartLookingForBlitzRivalMutationVariables>;
export const TournamentSetStatusUserBlitzQueueDocument = gql`
    mutation TournamentSetStatusUserBlitzQueue($status: TournamentBlitzLobbyStatus!, $blitzLobbyId: Int) {
  tournamentBlitzSetStatusUserQueue(status: $status, blitzLobbyId: $blitzLobbyId)
}
    `;
export type TournamentSetStatusUserBlitzQueueMutationFn = Apollo.MutationFunction<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables>;
export type TournamentSetStatusUserBlitzQueueQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables>, 'mutation'>;

    export const TournamentSetStatusUserBlitzQueueQuery = (props: TournamentSetStatusUserBlitzQueueQueryProps) => (
      <ApolloReactComponents.Mutation<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables> mutation={TournamentSetStatusUserBlitzQueueDocument} {...props} />
    );


/**
 * __useTournamentSetStatusUserBlitzQueueMutation__
 *
 * To run a mutation, you first call `useTournamentSetStatusUserBlitzQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTournamentSetStatusUserBlitzQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tournamentSetStatusUserBlitzQueueMutation, { data, loading, error }] = useTournamentSetStatusUserBlitzQueueMutation({
 *   variables: {
 *      status: // value for 'status'
 *      blitzLobbyId: // value for 'blitzLobbyId'
 *   },
 * });
 */
export function useTournamentSetStatusUserBlitzQueueMutation(baseOptions?: Apollo.MutationHookOptions<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables>(TournamentSetStatusUserBlitzQueueDocument, options);
      }
export type TournamentSetStatusUserBlitzQueueMutationHookResult = ReturnType<typeof useTournamentSetStatusUserBlitzQueueMutation>;
export type TournamentSetStatusUserBlitzQueueMutationResult = Apollo.MutationResult<TournamentSetStatusUserBlitzQueueMutation>;
export type TournamentSetStatusUserBlitzQueueMutationOptions = Apollo.BaseMutationOptions<TournamentSetStatusUserBlitzQueueMutation, TournamentSetStatusUserBlitzQueueMutationVariables>;
export const TournamentListenBlitzRivalDocument = gql`
    subscription TournamentListenBlitzRival($blitzLobbyId: Int!) {
  tournamentListenTournamentBlitzLobbyState(blitzLobbyId: $blitzLobbyId) {
    id
    status
    tournament {
      id
      lastMembers {
        ...RivalEntityFragment
      }
    }
  }
}
    ${RivalEntityFragmentFragmentDoc}`;
export type TournamentListenBlitzRivalQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenBlitzRivalSubscription, TournamentListenBlitzRivalSubscriptionVariables>, 'subscription'>;

    export const TournamentListenBlitzRivalQuery = (props: TournamentListenBlitzRivalQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenBlitzRivalSubscription, TournamentListenBlitzRivalSubscriptionVariables> subscription={TournamentListenBlitzRivalDocument} {...props} />
    );


/**
 * __useTournamentListenBlitzRivalSubscription__
 *
 * To run a query within a React component, call `useTournamentListenBlitzRivalSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenBlitzRivalSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenBlitzRivalSubscription({
 *   variables: {
 *      blitzLobbyId: // value for 'blitzLobbyId'
 *   },
 * });
 */
export function useTournamentListenBlitzRivalSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenBlitzRivalSubscription, TournamentListenBlitzRivalSubscriptionVariables> & ({ variables: TournamentListenBlitzRivalSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenBlitzRivalSubscription, TournamentListenBlitzRivalSubscriptionVariables>(TournamentListenBlitzRivalDocument, options);
      }
export type TournamentListenBlitzRivalSubscriptionHookResult = ReturnType<typeof useTournamentListenBlitzRivalSubscription>;
export type TournamentListenBlitzRivalSubscriptionResult = Apollo.SubscriptionResult<TournamentListenBlitzRivalSubscription>;
export const TournamentCreateDocument = gql`
    mutation TournamentCreate($tournament: CreateTournamentInput!) {
  tournamentCreate(tournament: $tournament) {
    id
    createdAt
    updatedAt
    type
    subject
    state
    bet
    startMode
    startAt
  }
}
    `;
export type TournamentCreateMutationFn = Apollo.MutationFunction<TournamentCreateMutation, TournamentCreateMutationVariables>;
export type TournamentCreateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<TournamentCreateMutation, TournamentCreateMutationVariables>, 'mutation'>;

    export const TournamentCreateQuery = (props: TournamentCreateQueryProps) => (
      <ApolloReactComponents.Mutation<TournamentCreateMutation, TournamentCreateMutationVariables> mutation={TournamentCreateDocument} {...props} />
    );


/**
 * __useTournamentCreateMutation__
 *
 * To run a mutation, you first call `useTournamentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTournamentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tournamentCreateMutation, { data, loading, error }] = useTournamentCreateMutation({
 *   variables: {
 *      tournament: // value for 'tournament'
 *   },
 * });
 */
export function useTournamentCreateMutation(baseOptions?: Apollo.MutationHookOptions<TournamentCreateMutation, TournamentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TournamentCreateMutation, TournamentCreateMutationVariables>(TournamentCreateDocument, options);
      }
export type TournamentCreateMutationHookResult = ReturnType<typeof useTournamentCreateMutation>;
export type TournamentCreateMutationResult = Apollo.MutationResult<TournamentCreateMutation>;
export type TournamentCreateMutationOptions = Apollo.BaseMutationOptions<TournamentCreateMutation, TournamentCreateMutationVariables>;
export const GetSubjectTaskAmountDocument = gql`
    query GetSubjectTaskAmount($subject: EducationSubject!) {
  subjectFindOne(subject: $subject) {
    id
    egeSubjectInfo {
      egeFirstPartTaskCount
    }
  }
}
    `;
export type GetSubjectTaskAmountQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>, 'query'> & ({ variables: GetSubjectTaskAmountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubjectTaskAmountQuery = (props: GetSubjectTaskAmountQueryProps) => (
      <ApolloReactComponents.Query<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables> query={GetSubjectTaskAmountDocument} {...props} />
    );


/**
 * __useGetSubjectTaskAmountQuery__
 *
 * To run a query within a React component, call `useGetSubjectTaskAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectTaskAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectTaskAmountQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useGetSubjectTaskAmountQuery(baseOptions: Apollo.QueryHookOptions<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables> & ({ variables: GetSubjectTaskAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>(GetSubjectTaskAmountDocument, options);
      }
export function useGetSubjectTaskAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>(GetSubjectTaskAmountDocument, options);
        }
export function useGetSubjectTaskAmountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>(GetSubjectTaskAmountDocument, options);
        }
export type GetSubjectTaskAmountQueryHookResult = ReturnType<typeof useGetSubjectTaskAmountQuery>;
export type GetSubjectTaskAmountLazyQueryHookResult = ReturnType<typeof useGetSubjectTaskAmountLazyQuery>;
export type GetSubjectTaskAmountSuspenseQueryHookResult = ReturnType<typeof useGetSubjectTaskAmountSuspenseQuery>;
export type GetSubjectTaskAmountQueryResult = Apollo.QueryResult<GetSubjectTaskAmountQuery, GetSubjectTaskAmountQueryVariables>;
export const GetTaskAmountDocument = gql`
    query GetTaskAmount($list: ListInput!, $filter: FilterSubjectInput!, $sort: BaseSortInput) {
  subjectFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      id
      egeSubjectInfo {
        egeFirstPartTaskCount
      }
    }
  }
}
    `;
export type GetTaskAmountQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTaskAmountQuery, GetTaskAmountQueryVariables>, 'query'> & ({ variables: GetTaskAmountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTaskAmountQuery = (props: GetTaskAmountQueryProps) => (
      <ApolloReactComponents.Query<GetTaskAmountQuery, GetTaskAmountQueryVariables> query={GetTaskAmountDocument} {...props} />
    );


/**
 * __useGetTaskAmountQuery__
 *
 * To run a query within a React component, call `useGetTaskAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskAmountQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTaskAmountQuery(baseOptions: Apollo.QueryHookOptions<GetTaskAmountQuery, GetTaskAmountQueryVariables> & ({ variables: GetTaskAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskAmountQuery, GetTaskAmountQueryVariables>(GetTaskAmountDocument, options);
      }
export function useGetTaskAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskAmountQuery, GetTaskAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskAmountQuery, GetTaskAmountQueryVariables>(GetTaskAmountDocument, options);
        }
export function useGetTaskAmountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskAmountQuery, GetTaskAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskAmountQuery, GetTaskAmountQueryVariables>(GetTaskAmountDocument, options);
        }
export type GetTaskAmountQueryHookResult = ReturnType<typeof useGetTaskAmountQuery>;
export type GetTaskAmountLazyQueryHookResult = ReturnType<typeof useGetTaskAmountLazyQuery>;
export type GetTaskAmountSuspenseQueryHookResult = ReturnType<typeof useGetTaskAmountSuspenseQuery>;
export type GetTaskAmountQueryResult = Apollo.QueryResult<GetTaskAmountQuery, GetTaskAmountQueryVariables>;
export const SubjectCategorySelectionFindManyDocument = gql`
    query SubjectCategorySelectionFindMany($list: ListInput!, $filter: FilterCategorySelectionSubjectInput!, $sort: BaseSortInput) {
  subjectCategorySelectionFindMany(list: $list, filter: $filter, sort: $sort) {
    items {
      id
      name
      categories {
        id
      }
    }
  }
}
    `;
export type SubjectCategorySelectionFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>, 'query'> & ({ variables: SubjectCategorySelectionFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubjectCategorySelectionFindManyQuery = (props: SubjectCategorySelectionFindManyQueryProps) => (
      <ApolloReactComponents.Query<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables> query={SubjectCategorySelectionFindManyDocument} {...props} />
    );


/**
 * __useSubjectCategorySelectionFindManyQuery__
 *
 * To run a query within a React component, call `useSubjectCategorySelectionFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectCategorySelectionFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectCategorySelectionFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSubjectCategorySelectionFindManyQuery(baseOptions: Apollo.QueryHookOptions<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables> & ({ variables: SubjectCategorySelectionFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>(SubjectCategorySelectionFindManyDocument, options);
      }
export function useSubjectCategorySelectionFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>(SubjectCategorySelectionFindManyDocument, options);
        }
export function useSubjectCategorySelectionFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>(SubjectCategorySelectionFindManyDocument, options);
        }
export type SubjectCategorySelectionFindManyQueryHookResult = ReturnType<typeof useSubjectCategorySelectionFindManyQuery>;
export type SubjectCategorySelectionFindManyLazyQueryHookResult = ReturnType<typeof useSubjectCategorySelectionFindManyLazyQuery>;
export type SubjectCategorySelectionFindManySuspenseQueryHookResult = ReturnType<typeof useSubjectCategorySelectionFindManySuspenseQuery>;
export type SubjectCategorySelectionFindManyQueryResult = Apollo.QueryResult<SubjectCategorySelectionFindManyQuery, SubjectCategorySelectionFindManyQueryVariables>;
export const UserTournamentsCountDocument = gql`
    query UserTournamentsCount($filter: FilterTournamentInput!) {
  tournamentCountByFilter(filter: $filter)
}
    `;
export type UserTournamentsCountQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>, 'query'> & ({ variables: UserTournamentsCountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserTournamentsCountQuery = (props: UserTournamentsCountQueryProps) => (
      <ApolloReactComponents.Query<UserTournamentsCountQuery, UserTournamentsCountQueryVariables> query={UserTournamentsCountDocument} {...props} />
    );


/**
 * __useUserTournamentsCountQuery__
 *
 * To run a query within a React component, call `useUserTournamentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTournamentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTournamentsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserTournamentsCountQuery(baseOptions: Apollo.QueryHookOptions<UserTournamentsCountQuery, UserTournamentsCountQueryVariables> & ({ variables: UserTournamentsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>(UserTournamentsCountDocument, options);
      }
export function useUserTournamentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>(UserTournamentsCountDocument, options);
        }
export function useUserTournamentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>(UserTournamentsCountDocument, options);
        }
export type UserTournamentsCountQueryHookResult = ReturnType<typeof useUserTournamentsCountQuery>;
export type UserTournamentsCountLazyQueryHookResult = ReturnType<typeof useUserTournamentsCountLazyQuery>;
export type UserTournamentsCountSuspenseQueryHookResult = ReturnType<typeof useUserTournamentsCountSuspenseQuery>;
export type UserTournamentsCountQueryResult = Apollo.QueryResult<UserTournamentsCountQuery, UserTournamentsCountQueryVariables>;
export const TournamentGetStatusDocument = gql`
    query TournamentGetStatus($tournamentId: Int!) {
  tournamentFindOne(tournamentId: $tournamentId) {
    id
    state
    type
    isMember
  }
}
    `;
export type TournamentGetStatusQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>, 'query'> & ({ variables: TournamentGetStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentGetStatusQuery = (props: TournamentGetStatusQueryProps) => (
      <ApolloReactComponents.Query<TournamentGetStatusQuery, TournamentGetStatusQueryVariables> query={TournamentGetStatusDocument} {...props} />
    );


/**
 * __useTournamentGetStatusQuery__
 *
 * To run a query within a React component, call `useTournamentGetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentGetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentGetStatusQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentGetStatusQuery(baseOptions: Apollo.QueryHookOptions<TournamentGetStatusQuery, TournamentGetStatusQueryVariables> & ({ variables: TournamentGetStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>(TournamentGetStatusDocument, options);
      }
export function useTournamentGetStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>(TournamentGetStatusDocument, options);
        }
export function useTournamentGetStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>(TournamentGetStatusDocument, options);
        }
export type TournamentGetStatusQueryHookResult = ReturnType<typeof useTournamentGetStatusQuery>;
export type TournamentGetStatusLazyQueryHookResult = ReturnType<typeof useTournamentGetStatusLazyQuery>;
export type TournamentGetStatusSuspenseQueryHookResult = ReturnType<typeof useTournamentGetStatusSuspenseQuery>;
export type TournamentGetStatusQueryResult = Apollo.QueryResult<TournamentGetStatusQuery, TournamentGetStatusQueryVariables>;
export const TournamentFindOneLobbyDocument = gql`
    query TournamentFindOneLobby($tournamentId: Int!) {
  tournamentFindOne(tournamentId: $tournamentId) {
    ...TournamentFindOneFragment
    startMode
    type
    finishAt
    autoCancelAt
    liveBroadcastUrl
    user {
      id
      lastOnlineAt
      profile {
        id
        firstName
        lastName
        fullNameShort
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${TournamentFindOneFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type TournamentFindOneLobbyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>, 'query'> & ({ variables: TournamentFindOneLobbyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentFindOneLobbyQuery = (props: TournamentFindOneLobbyQueryProps) => (
      <ApolloReactComponents.Query<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables> query={TournamentFindOneLobbyDocument} {...props} />
    );


/**
 * __useTournamentFindOneLobbyQuery__
 *
 * To run a query within a React component, call `useTournamentFindOneLobbyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentFindOneLobbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentFindOneLobbyQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentFindOneLobbyQuery(baseOptions: Apollo.QueryHookOptions<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables> & ({ variables: TournamentFindOneLobbyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>(TournamentFindOneLobbyDocument, options);
      }
export function useTournamentFindOneLobbyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>(TournamentFindOneLobbyDocument, options);
        }
export function useTournamentFindOneLobbySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>(TournamentFindOneLobbyDocument, options);
        }
export type TournamentFindOneLobbyQueryHookResult = ReturnType<typeof useTournamentFindOneLobbyQuery>;
export type TournamentFindOneLobbyLazyQueryHookResult = ReturnType<typeof useTournamentFindOneLobbyLazyQuery>;
export type TournamentFindOneLobbySuspenseQueryHookResult = ReturnType<typeof useTournamentFindOneLobbySuspenseQuery>;
export type TournamentFindOneLobbyQueryResult = Apollo.QueryResult<TournamentFindOneLobbyQuery, TournamentFindOneLobbyQueryVariables>;
export const TournamentMembersDocument = gql`
    query TournamentMembers($tournamentId: Int!, $list: ListInput!, $filter: FilterMemberTournamentInput!, $sort: SortMemberTournamentInput) {
  tournamentLobbyFindManyMembers(
    tournamentId: $tournamentId
    list: $list
    filter: $filter
    sort: $sort
  ) {
    count
    items {
      id
      isPlayer
      user {
        id
        lastOnlineAt
        profile {
          id
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentMembersQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentMembersQuery, TournamentMembersQueryVariables>, 'query'> & ({ variables: TournamentMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentMembersQuery = (props: TournamentMembersQueryProps) => (
      <ApolloReactComponents.Query<TournamentMembersQuery, TournamentMembersQueryVariables> query={TournamentMembersDocument} {...props} />
    );


/**
 * __useTournamentMembersQuery__
 *
 * To run a query within a React component, call `useTournamentMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentMembersQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTournamentMembersQuery(baseOptions: Apollo.QueryHookOptions<TournamentMembersQuery, TournamentMembersQueryVariables> & ({ variables: TournamentMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentMembersQuery, TournamentMembersQueryVariables>(TournamentMembersDocument, options);
      }
export function useTournamentMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentMembersQuery, TournamentMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentMembersQuery, TournamentMembersQueryVariables>(TournamentMembersDocument, options);
        }
export function useTournamentMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentMembersQuery, TournamentMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentMembersQuery, TournamentMembersQueryVariables>(TournamentMembersDocument, options);
        }
export type TournamentMembersQueryHookResult = ReturnType<typeof useTournamentMembersQuery>;
export type TournamentMembersLazyQueryHookResult = ReturnType<typeof useTournamentMembersLazyQuery>;
export type TournamentMembersSuspenseQueryHookResult = ReturnType<typeof useTournamentMembersSuspenseQuery>;
export type TournamentMembersQueryResult = Apollo.QueryResult<TournamentMembersQuery, TournamentMembersQueryVariables>;
export const TournamentMessagesDocument = gql`
    query TournamentMessages($tournamentId: Int!, $list: ListInput!) {
  tournamentLobbyFindManyMessages(tournamentId: $tournamentId, list: $list) {
    count
    items {
      id
      message {
        uuid
        text
      }
      user {
        id
        lastOnlineAt
        profile {
          id
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentMessagesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentMessagesQuery, TournamentMessagesQueryVariables>, 'query'> & ({ variables: TournamentMessagesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentMessagesQuery = (props: TournamentMessagesQueryProps) => (
      <ApolloReactComponents.Query<TournamentMessagesQuery, TournamentMessagesQueryVariables> query={TournamentMessagesDocument} {...props} />
    );


/**
 * __useTournamentMessagesQuery__
 *
 * To run a query within a React component, call `useTournamentMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentMessagesQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useTournamentMessagesQuery(baseOptions: Apollo.QueryHookOptions<TournamentMessagesQuery, TournamentMessagesQueryVariables> & ({ variables: TournamentMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentMessagesQuery, TournamentMessagesQueryVariables>(TournamentMessagesDocument, options);
      }
export function useTournamentMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentMessagesQuery, TournamentMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentMessagesQuery, TournamentMessagesQueryVariables>(TournamentMessagesDocument, options);
        }
export function useTournamentMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentMessagesQuery, TournamentMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentMessagesQuery, TournamentMessagesQueryVariables>(TournamentMessagesDocument, options);
        }
export type TournamentMessagesQueryHookResult = ReturnType<typeof useTournamentMessagesQuery>;
export type TournamentMessagesLazyQueryHookResult = ReturnType<typeof useTournamentMessagesLazyQuery>;
export type TournamentMessagesSuspenseQueryHookResult = ReturnType<typeof useTournamentMessagesSuspenseQuery>;
export type TournamentMessagesQueryResult = Apollo.QueryResult<TournamentMessagesQuery, TournamentMessagesQueryVariables>;
export const TournamentInvitationsDocument = gql`
    query TournamentInvitations($tournamentId: Int!, $list: ListInput!) {
  tournamentLobbyFindManyInvitations(tournamentId: $tournamentId, list: $list) {
    items {
      to {
        id
      }
    }
  }
}
    `;
export type TournamentInvitationsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>, 'query'> & ({ variables: TournamentInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentInvitationsQuery = (props: TournamentInvitationsQueryProps) => (
      <ApolloReactComponents.Query<TournamentInvitationsQuery, TournamentInvitationsQueryVariables> query={TournamentInvitationsDocument} {...props} />
    );


/**
 * __useTournamentInvitationsQuery__
 *
 * To run a query within a React component, call `useTournamentInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentInvitationsQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useTournamentInvitationsQuery(baseOptions: Apollo.QueryHookOptions<TournamentInvitationsQuery, TournamentInvitationsQueryVariables> & ({ variables: TournamentInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>(TournamentInvitationsDocument, options);
      }
export function useTournamentInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>(TournamentInvitationsDocument, options);
        }
export function useTournamentInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>(TournamentInvitationsDocument, options);
        }
export type TournamentInvitationsQueryHookResult = ReturnType<typeof useTournamentInvitationsQuery>;
export type TournamentInvitationsLazyQueryHookResult = ReturnType<typeof useTournamentInvitationsLazyQuery>;
export type TournamentInvitationsSuspenseQueryHookResult = ReturnType<typeof useTournamentInvitationsSuspenseQuery>;
export type TournamentInvitationsQueryResult = Apollo.QueryResult<TournamentInvitationsQuery, TournamentInvitationsQueryVariables>;
export const UserFinishedTournamentDocument = gql`
    query UserFinishedTournament($tournamentId: Int!) {
  tournamentResultFindOne(tournamentId: $tournamentId) {
    id
    tournament {
      id
      uuid
      accessByInviteKey
    }
    finished
  }
}
    `;
export type UserFinishedTournamentQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>, 'query'> & ({ variables: UserFinishedTournamentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserFinishedTournamentQuery = (props: UserFinishedTournamentQueryProps) => (
      <ApolloReactComponents.Query<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables> query={UserFinishedTournamentDocument} {...props} />
    );


/**
 * __useUserFinishedTournamentQuery__
 *
 * To run a query within a React component, call `useUserFinishedTournamentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFinishedTournamentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFinishedTournamentQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useUserFinishedTournamentQuery(baseOptions: Apollo.QueryHookOptions<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables> & ({ variables: UserFinishedTournamentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>(UserFinishedTournamentDocument, options);
      }
export function useUserFinishedTournamentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>(UserFinishedTournamentDocument, options);
        }
export function useUserFinishedTournamentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>(UserFinishedTournamentDocument, options);
        }
export type UserFinishedTournamentQueryHookResult = ReturnType<typeof useUserFinishedTournamentQuery>;
export type UserFinishedTournamentLazyQueryHookResult = ReturnType<typeof useUserFinishedTournamentLazyQuery>;
export type UserFinishedTournamentSuspenseQueryHookResult = ReturnType<typeof useUserFinishedTournamentSuspenseQuery>;
export type UserFinishedTournamentQueryResult = Apollo.QueryResult<UserFinishedTournamentQuery, UserFinishedTournamentQueryVariables>;
export const SetIsPlayerDocument = gql`
    mutation SetIsPlayer($tournamentId: Int!) {
  tournamentLobbyMakeMemberPlayer(tournamentId: $tournamentId) {
    id
    isPlayer
    user {
      id
    }
  }
}
    `;
export type SetIsPlayerMutationFn = Apollo.MutationFunction<SetIsPlayerMutation, SetIsPlayerMutationVariables>;
export type SetIsPlayerQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SetIsPlayerMutation, SetIsPlayerMutationVariables>, 'mutation'>;

    export const SetIsPlayerQuery = (props: SetIsPlayerQueryProps) => (
      <ApolloReactComponents.Mutation<SetIsPlayerMutation, SetIsPlayerMutationVariables> mutation={SetIsPlayerDocument} {...props} />
    );


/**
 * __useSetIsPlayerMutation__
 *
 * To run a mutation, you first call `useSetIsPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIsPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIsPlayerMutation, { data, loading, error }] = useSetIsPlayerMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useSetIsPlayerMutation(baseOptions?: Apollo.MutationHookOptions<SetIsPlayerMutation, SetIsPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIsPlayerMutation, SetIsPlayerMutationVariables>(SetIsPlayerDocument, options);
      }
export type SetIsPlayerMutationHookResult = ReturnType<typeof useSetIsPlayerMutation>;
export type SetIsPlayerMutationResult = Apollo.MutationResult<SetIsPlayerMutation>;
export type SetIsPlayerMutationOptions = Apollo.BaseMutationOptions<SetIsPlayerMutation, SetIsPlayerMutationVariables>;
export const StartTournamentDocument = gql`
    mutation StartTournament($tournamentId: Int!) {
  tournamentLobbyManuallyStartTournament(tournamentId: $tournamentId)
}
    `;
export type StartTournamentMutationFn = Apollo.MutationFunction<StartTournamentMutation, StartTournamentMutationVariables>;
export type StartTournamentQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<StartTournamentMutation, StartTournamentMutationVariables>, 'mutation'>;

    export const StartTournamentQuery = (props: StartTournamentQueryProps) => (
      <ApolloReactComponents.Mutation<StartTournamentMutation, StartTournamentMutationVariables> mutation={StartTournamentDocument} {...props} />
    );


/**
 * __useStartTournamentMutation__
 *
 * To run a mutation, you first call `useStartTournamentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTournamentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTournamentMutation, { data, loading, error }] = useStartTournamentMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useStartTournamentMutation(baseOptions?: Apollo.MutationHookOptions<StartTournamentMutation, StartTournamentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTournamentMutation, StartTournamentMutationVariables>(StartTournamentDocument, options);
      }
export type StartTournamentMutationHookResult = ReturnType<typeof useStartTournamentMutation>;
export type StartTournamentMutationResult = Apollo.MutationResult<StartTournamentMutation>;
export type StartTournamentMutationOptions = Apollo.BaseMutationOptions<StartTournamentMutation, StartTournamentMutationVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($invitation: SendInvitationTournamentInput!) {
  tournamentLobbySendInvitation(invitation: $invitation) {
    to {
      id
    }
  }
}
    `;
export type SendInvitationMutationFn = Apollo.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;
export type SendInvitationQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SendInvitationMutation, SendInvitationMutationVariables>, 'mutation'>;

    export const SendInvitationQuery = (props: SendInvitationQueryProps) => (
      <ApolloReactComponents.Mutation<SendInvitationMutation, SendInvitationMutationVariables> mutation={SendInvitationDocument} {...props} />
    );


/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      invitation: // value for 'invitation'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = Apollo.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = Apollo.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const SendTournamentMessageDocument = gql`
    mutation SendTournamentMessage($messagePayload: SendMessageTournamentInput!) {
  tournamentLobbySendMessage(messagePayload: $messagePayload) {
    id
    createdAt
    message {
      uuid
      text
    }
    user {
      id
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type SendTournamentMessageMutationFn = Apollo.MutationFunction<SendTournamentMessageMutation, SendTournamentMessageMutationVariables>;
export type SendTournamentMessageQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SendTournamentMessageMutation, SendTournamentMessageMutationVariables>, 'mutation'>;

    export const SendTournamentMessageQuery = (props: SendTournamentMessageQueryProps) => (
      <ApolloReactComponents.Mutation<SendTournamentMessageMutation, SendTournamentMessageMutationVariables> mutation={SendTournamentMessageDocument} {...props} />
    );


/**
 * __useSendTournamentMessageMutation__
 *
 * To run a mutation, you first call `useSendTournamentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTournamentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTournamentMessageMutation, { data, loading, error }] = useSendTournamentMessageMutation({
 *   variables: {
 *      messagePayload: // value for 'messagePayload'
 *   },
 * });
 */
export function useSendTournamentMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTournamentMessageMutation, SendTournamentMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTournamentMessageMutation, SendTournamentMessageMutationVariables>(SendTournamentMessageDocument, options);
      }
export type SendTournamentMessageMutationHookResult = ReturnType<typeof useSendTournamentMessageMutation>;
export type SendTournamentMessageMutationResult = Apollo.MutationResult<SendTournamentMessageMutation>;
export type SendTournamentMessageMutationOptions = Apollo.BaseMutationOptions<SendTournamentMessageMutation, SendTournamentMessageMutationVariables>;
export const TournamentListenMessagesDocument = gql`
    subscription TournamentListenMessages($tournamentId: Int!) {
  tournamentListenNewLobbyMessage(tournamentId: $tournamentId) {
    id
    message {
      uuid
      text
    }
    user {
      id
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentListenMessagesQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenMessagesSubscription, TournamentListenMessagesSubscriptionVariables>, 'subscription'>;

    export const TournamentListenMessagesQuery = (props: TournamentListenMessagesQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenMessagesSubscription, TournamentListenMessagesSubscriptionVariables> subscription={TournamentListenMessagesDocument} {...props} />
    );


/**
 * __useTournamentListenMessagesSubscription__
 *
 * To run a query within a React component, call `useTournamentListenMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenMessagesSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentListenMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenMessagesSubscription, TournamentListenMessagesSubscriptionVariables> & ({ variables: TournamentListenMessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenMessagesSubscription, TournamentListenMessagesSubscriptionVariables>(TournamentListenMessagesDocument, options);
      }
export type TournamentListenMessagesSubscriptionHookResult = ReturnType<typeof useTournamentListenMessagesSubscription>;
export type TournamentListenMessagesSubscriptionResult = Apollo.SubscriptionResult<TournamentListenMessagesSubscription>;
export const TournamentListenStateDocument = gql`
    subscription TournamentListenState($tournamentId: Int!) {
  tournamentListenTournamentState(tournamentId: $tournamentId) {
    id
    state
    countMembers
  }
}
    `;
export type TournamentListenStateQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenStateSubscription, TournamentListenStateSubscriptionVariables>, 'subscription'>;

    export const TournamentListenStateQuery = (props: TournamentListenStateQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenStateSubscription, TournamentListenStateSubscriptionVariables> subscription={TournamentListenStateDocument} {...props} />
    );


/**
 * __useTournamentListenStateSubscription__
 *
 * To run a query within a React component, call `useTournamentListenStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenStateSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentListenStateSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenStateSubscription, TournamentListenStateSubscriptionVariables> & ({ variables: TournamentListenStateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenStateSubscription, TournamentListenStateSubscriptionVariables>(TournamentListenStateDocument, options);
      }
export type TournamentListenStateSubscriptionHookResult = ReturnType<typeof useTournamentListenStateSubscription>;
export type TournamentListenStateSubscriptionResult = Apollo.SubscriptionResult<TournamentListenStateSubscription>;
export const TournamentListenNewMembersDocument = gql`
    subscription TournamentListenNewMembers($tournamentId: Int!) {
  tournamentListenNewMember(tournamentId: $tournamentId) {
    tournament {
      countMembers
    }
    id
    isPlayer
    user {
      id
      lastOnlineAt
      profile {
        id
        fullName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentListenNewMembersQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenNewMembersSubscription, TournamentListenNewMembersSubscriptionVariables>, 'subscription'>;

    export const TournamentListenNewMembersQuery = (props: TournamentListenNewMembersQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenNewMembersSubscription, TournamentListenNewMembersSubscriptionVariables> subscription={TournamentListenNewMembersDocument} {...props} />
    );


/**
 * __useTournamentListenNewMembersSubscription__
 *
 * To run a query within a React component, call `useTournamentListenNewMembersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenNewMembersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenNewMembersSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentListenNewMembersSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenNewMembersSubscription, TournamentListenNewMembersSubscriptionVariables> & ({ variables: TournamentListenNewMembersSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenNewMembersSubscription, TournamentListenNewMembersSubscriptionVariables>(TournamentListenNewMembersDocument, options);
      }
export type TournamentListenNewMembersSubscriptionHookResult = ReturnType<typeof useTournamentListenNewMembersSubscription>;
export type TournamentListenNewMembersSubscriptionResult = Apollo.SubscriptionResult<TournamentListenNewMembersSubscription>;
export const TournamentTasksDocument = gql`
    query TournamentTasks($tournamentId: Int!) {
  tournamentFindOne(tournamentId: $tournamentId) {
    id
    type
    state
    isMember
    subject
    countMembers
    liveBroadcastUrl
    finishAt
    tasks {
      id
      task {
        ...TaskCommonFragment
      }
    }
  }
  tournamentResultFindOne(tournamentId: $tournamentId) {
    id
    finished
    currentTaskIndex
    answers {
      id
      answer {
        quiz
      }
      task {
        id
        uuid
      }
    }
  }
}
    ${TaskCommonFragmentFragmentDoc}`;
export type TournamentTasksQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentTasksQuery, TournamentTasksQueryVariables>, 'query'> & ({ variables: TournamentTasksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentTasksQuery = (props: TournamentTasksQueryProps) => (
      <ApolloReactComponents.Query<TournamentTasksQuery, TournamentTasksQueryVariables> query={TournamentTasksDocument} {...props} />
    );


/**
 * __useTournamentTasksQuery__
 *
 * To run a query within a React component, call `useTournamentTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentTasksQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentTasksQuery(baseOptions: Apollo.QueryHookOptions<TournamentTasksQuery, TournamentTasksQueryVariables> & ({ variables: TournamentTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentTasksQuery, TournamentTasksQueryVariables>(TournamentTasksDocument, options);
      }
export function useTournamentTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentTasksQuery, TournamentTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentTasksQuery, TournamentTasksQueryVariables>(TournamentTasksDocument, options);
        }
export function useTournamentTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentTasksQuery, TournamentTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentTasksQuery, TournamentTasksQueryVariables>(TournamentTasksDocument, options);
        }
export type TournamentTasksQueryHookResult = ReturnType<typeof useTournamentTasksQuery>;
export type TournamentTasksLazyQueryHookResult = ReturnType<typeof useTournamentTasksLazyQuery>;
export type TournamentTasksSuspenseQueryHookResult = ReturnType<typeof useTournamentTasksSuspenseQuery>;
export type TournamentTasksQueryResult = Apollo.QueryResult<TournamentTasksQuery, TournamentTasksQueryVariables>;
export const GetTournamentStateDocument = gql`
    query GetTournamentState($tournamentId: Int!) {
  tournamentFindOne(tournamentId: $tournamentId) {
    id
    uuid
    type
    state
    isMember
  }
}
    `;
export type GetTournamentStateQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTournamentStateQuery, GetTournamentStateQueryVariables>, 'query'> & ({ variables: GetTournamentStateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTournamentStateQuery = (props: GetTournamentStateQueryProps) => (
      <ApolloReactComponents.Query<GetTournamentStateQuery, GetTournamentStateQueryVariables> query={GetTournamentStateDocument} {...props} />
    );


/**
 * __useGetTournamentStateQuery__
 *
 * To run a query within a React component, call `useGetTournamentStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentStateQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useGetTournamentStateQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentStateQuery, GetTournamentStateQueryVariables> & ({ variables: GetTournamentStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentStateQuery, GetTournamentStateQueryVariables>(GetTournamentStateDocument, options);
      }
export function useGetTournamentStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentStateQuery, GetTournamentStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentStateQuery, GetTournamentStateQueryVariables>(GetTournamentStateDocument, options);
        }
export function useGetTournamentStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTournamentStateQuery, GetTournamentStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTournamentStateQuery, GetTournamentStateQueryVariables>(GetTournamentStateDocument, options);
        }
export type GetTournamentStateQueryHookResult = ReturnType<typeof useGetTournamentStateQuery>;
export type GetTournamentStateLazyQueryHookResult = ReturnType<typeof useGetTournamentStateLazyQuery>;
export type GetTournamentStateSuspenseQueryHookResult = ReturnType<typeof useGetTournamentStateSuspenseQuery>;
export type GetTournamentStateQueryResult = Apollo.QueryResult<GetTournamentStateQuery, GetTournamentStateQueryVariables>;
export const TournamentMembersProgressDocument = gql`
    query TournamentMembersProgress($tournamentId: Int!, $list: ListInput!) {
  tournamentResultFindMany(tournamentId: $tournamentId, list: $list) {
    count
    items {
      id
      user {
        id
        profile {
          id
          fullName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
      solvedCount
      finished
      tournament {
        id
        tasks {
          id
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentMembersProgressQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>, 'query'> & ({ variables: TournamentMembersProgressQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentMembersProgressQuery = (props: TournamentMembersProgressQueryProps) => (
      <ApolloReactComponents.Query<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables> query={TournamentMembersProgressDocument} {...props} />
    );


/**
 * __useTournamentMembersProgressQuery__
 *
 * To run a query within a React component, call `useTournamentMembersProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentMembersProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentMembersProgressQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useTournamentMembersProgressQuery(baseOptions: Apollo.QueryHookOptions<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables> & ({ variables: TournamentMembersProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>(TournamentMembersProgressDocument, options);
      }
export function useTournamentMembersProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>(TournamentMembersProgressDocument, options);
        }
export function useTournamentMembersProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>(TournamentMembersProgressDocument, options);
        }
export type TournamentMembersProgressQueryHookResult = ReturnType<typeof useTournamentMembersProgressQuery>;
export type TournamentMembersProgressLazyQueryHookResult = ReturnType<typeof useTournamentMembersProgressLazyQuery>;
export type TournamentMembersProgressSuspenseQueryHookResult = ReturnType<typeof useTournamentMembersProgressSuspenseQuery>;
export type TournamentMembersProgressQueryResult = Apollo.QueryResult<TournamentMembersProgressQuery, TournamentMembersProgressQueryVariables>;
export const SendTaskAnswerDocument = gql`
    mutation SendTaskAnswer($tournamentId: Int!, $answer: SaveAnswerTaskInput!, $currentTaskIndex: Int) {
  tournamentProcessSaveTaskAnswer(
    tournamentId: $tournamentId
    answer: $answer
    currentTaskIndex: $currentTaskIndex
  ) {
    id
    finished
    currentTaskIndex
    answers {
      id
      answer {
        quiz
      }
      task {
        id
        uuid
      }
    }
  }
}
    `;
export type SendTaskAnswerMutationFn = Apollo.MutationFunction<SendTaskAnswerMutation, SendTaskAnswerMutationVariables>;
export type SendTaskAnswerQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SendTaskAnswerMutation, SendTaskAnswerMutationVariables>, 'mutation'>;

    export const SendTaskAnswerQuery = (props: SendTaskAnswerQueryProps) => (
      <ApolloReactComponents.Mutation<SendTaskAnswerMutation, SendTaskAnswerMutationVariables> mutation={SendTaskAnswerDocument} {...props} />
    );


/**
 * __useSendTaskAnswerMutation__
 *
 * To run a mutation, you first call `useSendTaskAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTaskAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTaskAnswerMutation, { data, loading, error }] = useSendTaskAnswerMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      answer: // value for 'answer'
 *      currentTaskIndex: // value for 'currentTaskIndex'
 *   },
 * });
 */
export function useSendTaskAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SendTaskAnswerMutation, SendTaskAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTaskAnswerMutation, SendTaskAnswerMutationVariables>(SendTaskAnswerDocument, options);
      }
export type SendTaskAnswerMutationHookResult = ReturnType<typeof useSendTaskAnswerMutation>;
export type SendTaskAnswerMutationResult = Apollo.MutationResult<SendTaskAnswerMutation>;
export type SendTaskAnswerMutationOptions = Apollo.BaseMutationOptions<SendTaskAnswerMutation, SendTaskAnswerMutationVariables>;
export const FinishTournamentDocument = gql`
    mutation FinishTournament($tournamentId: Int!) {
  tournamentResultFinishMyTournament(tournamentId: $tournamentId) {
    id
    finished
    currentTaskIndex
  }
}
    `;
export type FinishTournamentMutationFn = Apollo.MutationFunction<FinishTournamentMutation, FinishTournamentMutationVariables>;
export type FinishTournamentQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<FinishTournamentMutation, FinishTournamentMutationVariables>, 'mutation'>;

    export const FinishTournamentQuery = (props: FinishTournamentQueryProps) => (
      <ApolloReactComponents.Mutation<FinishTournamentMutation, FinishTournamentMutationVariables> mutation={FinishTournamentDocument} {...props} />
    );


/**
 * __useFinishTournamentMutation__
 *
 * To run a mutation, you first call `useFinishTournamentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishTournamentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishTournamentMutation, { data, loading, error }] = useFinishTournamentMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useFinishTournamentMutation(baseOptions?: Apollo.MutationHookOptions<FinishTournamentMutation, FinishTournamentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishTournamentMutation, FinishTournamentMutationVariables>(FinishTournamentDocument, options);
      }
export type FinishTournamentMutationHookResult = ReturnType<typeof useFinishTournamentMutation>;
export type FinishTournamentMutationResult = Apollo.MutationResult<FinishTournamentMutation>;
export type FinishTournamentMutationOptions = Apollo.BaseMutationOptions<FinishTournamentMutation, FinishTournamentMutationVariables>;
export const TournamentListenMembersProgressDocument = gql`
    subscription TournamentListenMembersProgress($tournamentId: Int!) {
  tournamentListenNewMemberProgress(tournamentId: $tournamentId) {
    id
    solvedCount
    user {
      lastOnlineAt
    }
  }
}
    `;
export type TournamentListenMembersProgressQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenMembersProgressSubscription, TournamentListenMembersProgressSubscriptionVariables>, 'subscription'>;

    export const TournamentListenMembersProgressQuery = (props: TournamentListenMembersProgressQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenMembersProgressSubscription, TournamentListenMembersProgressSubscriptionVariables> subscription={TournamentListenMembersProgressDocument} {...props} />
    );


/**
 * __useTournamentListenMembersProgressSubscription__
 *
 * To run a query within a React component, call `useTournamentListenMembersProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenMembersProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenMembersProgressSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentListenMembersProgressSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenMembersProgressSubscription, TournamentListenMembersProgressSubscriptionVariables> & ({ variables: TournamentListenMembersProgressSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenMembersProgressSubscription, TournamentListenMembersProgressSubscriptionVariables>(TournamentListenMembersProgressDocument, options);
      }
export type TournamentListenMembersProgressSubscriptionHookResult = ReturnType<typeof useTournamentListenMembersProgressSubscription>;
export type TournamentListenMembersProgressSubscriptionResult = Apollo.SubscriptionResult<TournamentListenMembersProgressSubscription>;
export const TournamentResultDocument = gql`
    query TournamentResult($tournamentId: Int!, $list: ListInput!) {
  tournamentResultFindMany(tournamentId: $tournamentId, list: $list) {
    pages
    items {
      id
      prize
      ...TournamentResultParticipantsFragment
    }
  }
  tournamentFindOne(tournamentId: $tournamentId) {
    id
    countMembers
    countWinners
    fund
    bet
  }
}
    ${TournamentResultParticipantsFragmentFragmentDoc}`;
export type TournamentResultQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentResultQuery, TournamentResultQueryVariables>, 'query'> & ({ variables: TournamentResultQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentResultQuery = (props: TournamentResultQueryProps) => (
      <ApolloReactComponents.Query<TournamentResultQuery, TournamentResultQueryVariables> query={TournamentResultDocument} {...props} />
    );


/**
 * __useTournamentResultQuery__
 *
 * To run a query within a React component, call `useTournamentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentResultQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useTournamentResultQuery(baseOptions: Apollo.QueryHookOptions<TournamentResultQuery, TournamentResultQueryVariables> & ({ variables: TournamentResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentResultQuery, TournamentResultQueryVariables>(TournamentResultDocument, options);
      }
export function useTournamentResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentResultQuery, TournamentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentResultQuery, TournamentResultQueryVariables>(TournamentResultDocument, options);
        }
export function useTournamentResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentResultQuery, TournamentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentResultQuery, TournamentResultQueryVariables>(TournamentResultDocument, options);
        }
export type TournamentResultQueryHookResult = ReturnType<typeof useTournamentResultQuery>;
export type TournamentResultLazyQueryHookResult = ReturnType<typeof useTournamentResultLazyQuery>;
export type TournamentResultSuspenseQueryHookResult = ReturnType<typeof useTournamentResultSuspenseQuery>;
export type TournamentResultQueryResult = Apollo.QueryResult<TournamentResultQuery, TournamentResultQueryVariables>;
export const TournamentParticipantsDocument = gql`
    query TournamentParticipants($tournamentId: Int!, $list: ListInput!) {
  tournamentResultFindMany(tournamentId: $tournamentId, list: $list) {
    pages
    items {
      id
      place
      pointsAmount
      solvedCount
      prize
      ...TournamentResultParticipantsFragment
    }
  }
}
    ${TournamentResultParticipantsFragmentFragmentDoc}`;
export type TournamentParticipantsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>, 'query'> & ({ variables: TournamentParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TournamentParticipantsQuery = (props: TournamentParticipantsQueryProps) => (
      <ApolloReactComponents.Query<TournamentParticipantsQuery, TournamentParticipantsQueryVariables> query={TournamentParticipantsDocument} {...props} />
    );


/**
 * __useTournamentParticipantsQuery__
 *
 * To run a query within a React component, call `useTournamentParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentParticipantsQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useTournamentParticipantsQuery(baseOptions: Apollo.QueryHookOptions<TournamentParticipantsQuery, TournamentParticipantsQueryVariables> & ({ variables: TournamentParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>(TournamentParticipantsDocument, options);
      }
export function useTournamentParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>(TournamentParticipantsDocument, options);
        }
export function useTournamentParticipantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>(TournamentParticipantsDocument, options);
        }
export type TournamentParticipantsQueryHookResult = ReturnType<typeof useTournamentParticipantsQuery>;
export type TournamentParticipantsLazyQueryHookResult = ReturnType<typeof useTournamentParticipantsLazyQuery>;
export type TournamentParticipantsSuspenseQueryHookResult = ReturnType<typeof useTournamentParticipantsSuspenseQuery>;
export type TournamentParticipantsQueryResult = Apollo.QueryResult<TournamentParticipantsQuery, TournamentParticipantsQueryVariables>;
export const MyTournamentResultDocument = gql`
    query MyTournamentResult($tournamentId: Int!) {
  tournamentResultFindOne(tournamentId: $tournamentId) {
    ...TaskAnswersResultFragment
  }
}
    ${TaskAnswersResultFragmentFragmentDoc}`;
export type MyTournamentResultQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<MyTournamentResultQuery, MyTournamentResultQueryVariables>, 'query'> & ({ variables: MyTournamentResultQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MyTournamentResultQuery = (props: MyTournamentResultQueryProps) => (
      <ApolloReactComponents.Query<MyTournamentResultQuery, MyTournamentResultQueryVariables> query={MyTournamentResultDocument} {...props} />
    );


/**
 * __useMyTournamentResultQuery__
 *
 * To run a query within a React component, call `useMyTournamentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTournamentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTournamentResultQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useMyTournamentResultQuery(baseOptions: Apollo.QueryHookOptions<MyTournamentResultQuery, MyTournamentResultQueryVariables> & ({ variables: MyTournamentResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTournamentResultQuery, MyTournamentResultQueryVariables>(MyTournamentResultDocument, options);
      }
export function useMyTournamentResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTournamentResultQuery, MyTournamentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTournamentResultQuery, MyTournamentResultQueryVariables>(MyTournamentResultDocument, options);
        }
export function useMyTournamentResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTournamentResultQuery, MyTournamentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTournamentResultQuery, MyTournamentResultQueryVariables>(MyTournamentResultDocument, options);
        }
export type MyTournamentResultQueryHookResult = ReturnType<typeof useMyTournamentResultQuery>;
export type MyTournamentResultLazyQueryHookResult = ReturnType<typeof useMyTournamentResultLazyQuery>;
export type MyTournamentResultSuspenseQueryHookResult = ReturnType<typeof useMyTournamentResultSuspenseQuery>;
export type MyTournamentResultQueryResult = Apollo.QueryResult<MyTournamentResultQuery, MyTournamentResultQueryVariables>;
export const GetPlacesDocument = gql`
    query GetPlaces($tournamentId: Int!, $list: ListInput!) {
  tournamentResultFindMany(tournamentId: $tournamentId, list: $list) {
    items {
      id
      tournament {
        id
        uuid
      }
      user {
        id
      }
    }
  }
}
    `;
export type GetPlacesQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPlacesQuery, GetPlacesQueryVariables>, 'query'> & ({ variables: GetPlacesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPlacesQuery = (props: GetPlacesQueryProps) => (
      <ApolloReactComponents.Query<GetPlacesQuery, GetPlacesQueryVariables> query={GetPlacesDocument} {...props} />
    );


/**
 * __useGetPlacesQuery__
 *
 * To run a query within a React component, call `useGetPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useGetPlacesQuery(baseOptions: Apollo.QueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables> & ({ variables: GetPlacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
      }
export function useGetPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export function useGetPlacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export type GetPlacesQueryHookResult = ReturnType<typeof useGetPlacesQuery>;
export type GetPlacesLazyQueryHookResult = ReturnType<typeof useGetPlacesLazyQuery>;
export type GetPlacesSuspenseQueryHookResult = ReturnType<typeof useGetPlacesSuspenseQuery>;
export type GetPlacesQueryResult = Apollo.QueryResult<GetPlacesQuery, GetPlacesQueryVariables>;
export const VkPublishTournamentResultDocument = gql`
    mutation VkPublishTournamentResult($tournamentId: Int!, $promotionType: PromotionPublicationType!, $contentType: TournamentPromotionContentType!) {
  tournamentPromotionPublish(
    tournamentId: $tournamentId
    promotionType: $promotionType
    contentType: $contentType
  )
}
    `;
export type VkPublishTournamentResultMutationFn = Apollo.MutationFunction<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables>;
export type VkPublishTournamentResultQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables>, 'mutation'>;

    export const VkPublishTournamentResultQuery = (props: VkPublishTournamentResultQueryProps) => (
      <ApolloReactComponents.Mutation<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables> mutation={VkPublishTournamentResultDocument} {...props} />
    );


/**
 * __useVkPublishTournamentResultMutation__
 *
 * To run a mutation, you first call `useVkPublishTournamentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVkPublishTournamentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vkPublishTournamentResultMutation, { data, loading, error }] = useVkPublishTournamentResultMutation({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *      promotionType: // value for 'promotionType'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useVkPublishTournamentResultMutation(baseOptions?: Apollo.MutationHookOptions<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables>(VkPublishTournamentResultDocument, options);
      }
export type VkPublishTournamentResultMutationHookResult = ReturnType<typeof useVkPublishTournamentResultMutation>;
export type VkPublishTournamentResultMutationResult = Apollo.MutationResult<VkPublishTournamentResultMutation>;
export type VkPublishTournamentResultMutationOptions = Apollo.BaseMutationOptions<VkPublishTournamentResultMutation, VkPublishTournamentResultMutationVariables>;
export const ReadyAndUpcomingTournamentsDocument = gql`
    query ReadyAndUpcomingTournaments($listReady: ListInput!, $filterReady: FilterTournamentInput!, $sortReady: SortTournamentInput, $listUpcoming: ListInput!, $filterUpcoming: FilterTournamentInput!, $sortUpcoming: SortTournamentInput) {
  tournamentFindManyReady: tournamentFindMany(
    list: $listReady
    filter: $filterReady
    sort: $sortReady
  ) {
    items {
      ...ReadyAndUpcomingTournamentsFragment
    }
  }
  tournamentFindManyUpcoming: tournamentFindMany(
    list: $listUpcoming
    filter: $filterUpcoming
    sort: $sortUpcoming
  ) {
    items {
      ...ReadyAndUpcomingTournamentsFragment
    }
  }
}
    ${ReadyAndUpcomingTournamentsFragmentFragmentDoc}`;
export type ReadyAndUpcomingTournamentsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>, 'query'> & ({ variables: ReadyAndUpcomingTournamentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReadyAndUpcomingTournamentsQuery = (props: ReadyAndUpcomingTournamentsQueryProps) => (
      <ApolloReactComponents.Query<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables> query={ReadyAndUpcomingTournamentsDocument} {...props} />
    );


/**
 * __useReadyAndUpcomingTournamentsQuery__
 *
 * To run a query within a React component, call `useReadyAndUpcomingTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyAndUpcomingTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadyAndUpcomingTournamentsQuery({
 *   variables: {
 *      listReady: // value for 'listReady'
 *      filterReady: // value for 'filterReady'
 *      sortReady: // value for 'sortReady'
 *      listUpcoming: // value for 'listUpcoming'
 *      filterUpcoming: // value for 'filterUpcoming'
 *      sortUpcoming: // value for 'sortUpcoming'
 *   },
 * });
 */
export function useReadyAndUpcomingTournamentsQuery(baseOptions: Apollo.QueryHookOptions<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables> & ({ variables: ReadyAndUpcomingTournamentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>(ReadyAndUpcomingTournamentsDocument, options);
      }
export function useReadyAndUpcomingTournamentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>(ReadyAndUpcomingTournamentsDocument, options);
        }
export function useReadyAndUpcomingTournamentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>(ReadyAndUpcomingTournamentsDocument, options);
        }
export type ReadyAndUpcomingTournamentsQueryHookResult = ReturnType<typeof useReadyAndUpcomingTournamentsQuery>;
export type ReadyAndUpcomingTournamentsLazyQueryHookResult = ReturnType<typeof useReadyAndUpcomingTournamentsLazyQuery>;
export type ReadyAndUpcomingTournamentsSuspenseQueryHookResult = ReturnType<typeof useReadyAndUpcomingTournamentsSuspenseQuery>;
export type ReadyAndUpcomingTournamentsQueryResult = Apollo.QueryResult<ReadyAndUpcomingTournamentsQuery, ReadyAndUpcomingTournamentsQueryVariables>;
export const ScheduledTournamentsDocument = gql`
    query ScheduledTournaments($list: ListInput!, $filter: FilterTournamentInput!, $sort: SortTournamentInput) {
  tournamentFindMany(list: $list, filter: $filter, sort: $sort) {
    pages
    count
    items {
      id
      subject
      type
      bet
      isMember
      state
      categories {
        subjectCategory {
          id
          name
        }
      }
      countMembers
      startAt
      startMode
      lastMembers {
        id
        profile {
          id
          firstName
          ...ProfileTitleFragment
          avatar {
            id
            medium
          }
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type ScheduledTournamentsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>, 'query'> & ({ variables: ScheduledTournamentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ScheduledTournamentsQuery = (props: ScheduledTournamentsQueryProps) => (
      <ApolloReactComponents.Query<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables> query={ScheduledTournamentsDocument} {...props} />
    );


/**
 * __useScheduledTournamentsQuery__
 *
 * To run a query within a React component, call `useScheduledTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledTournamentsQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useScheduledTournamentsQuery(baseOptions: Apollo.QueryHookOptions<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables> & ({ variables: ScheduledTournamentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>(ScheduledTournamentsDocument, options);
      }
export function useScheduledTournamentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>(ScheduledTournamentsDocument, options);
        }
export function useScheduledTournamentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>(ScheduledTournamentsDocument, options);
        }
export type ScheduledTournamentsQueryHookResult = ReturnType<typeof useScheduledTournamentsQuery>;
export type ScheduledTournamentsLazyQueryHookResult = ReturnType<typeof useScheduledTournamentsLazyQuery>;
export type ScheduledTournamentsSuspenseQueryHookResult = ReturnType<typeof useScheduledTournamentsSuspenseQuery>;
export type ScheduledTournamentsQueryResult = Apollo.QueryResult<ScheduledTournamentsQuery, ScheduledTournamentsQueryVariables>;
export const UsersOnlineDocument = gql`
    query UsersOnline {
  userCountUsersOnline
}
    `;
export type UsersOnlineQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<UsersOnlineQuery, UsersOnlineQueryVariables>, 'query'>;

    export const UsersOnlineQuery = (props: UsersOnlineQueryProps) => (
      <ApolloReactComponents.Query<UsersOnlineQuery, UsersOnlineQueryVariables> query={UsersOnlineDocument} {...props} />
    );


/**
 * __useUsersOnlineQuery__
 *
 * To run a query within a React component, call `useUsersOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersOnlineQuery(baseOptions?: Apollo.QueryHookOptions<UsersOnlineQuery, UsersOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersOnlineQuery, UsersOnlineQueryVariables>(UsersOnlineDocument, options);
      }
export function useUsersOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersOnlineQuery, UsersOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersOnlineQuery, UsersOnlineQueryVariables>(UsersOnlineDocument, options);
        }
export function useUsersOnlineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersOnlineQuery, UsersOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersOnlineQuery, UsersOnlineQueryVariables>(UsersOnlineDocument, options);
        }
export type UsersOnlineQueryHookResult = ReturnType<typeof useUsersOnlineQuery>;
export type UsersOnlineLazyQueryHookResult = ReturnType<typeof useUsersOnlineLazyQuery>;
export type UsersOnlineSuspenseQueryHookResult = ReturnType<typeof useUsersOnlineSuspenseQuery>;
export type UsersOnlineQueryResult = Apollo.QueryResult<UsersOnlineQuery, UsersOnlineQueryVariables>;
export const UserOnlineCountDocument = gql`
    subscription UserOnlineCount {
  userListenCountUserOnline
}
    `;
export type UserOnlineCountQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<UserOnlineCountSubscription, UserOnlineCountSubscriptionVariables>, 'subscription'>;

    export const UserOnlineCountQuery = (props: UserOnlineCountQueryProps) => (
      <ApolloReactComponents.Subscription<UserOnlineCountSubscription, UserOnlineCountSubscriptionVariables> subscription={UserOnlineCountDocument} {...props} />
    );


/**
 * __useUserOnlineCountSubscription__
 *
 * To run a query within a React component, call `useUserOnlineCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserOnlineCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOnlineCountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserOnlineCountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserOnlineCountSubscription, UserOnlineCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserOnlineCountSubscription, UserOnlineCountSubscriptionVariables>(UserOnlineCountDocument, options);
      }
export type UserOnlineCountSubscriptionHookResult = ReturnType<typeof useUserOnlineCountSubscription>;
export type UserOnlineCountSubscriptionResult = Apollo.SubscriptionResult<UserOnlineCountSubscription>;
export const TournamentListenNewMemberDocument = gql`
    subscription TournamentListenNewMember($tournamentId: Int!) {
  tournamentListenNewMember(tournamentId: $tournamentId) {
    tournament {
      countMembers
    }
    user {
      id
      lastOnlineAt
      profile {
        id
        firstName
        ...ProfileTitleFragment
        avatar {
          id
          medium
        }
      }
    }
  }
}
    ${ProfileTitleFragmentFragmentDoc}`;
export type TournamentListenNewMemberQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<TournamentListenNewMemberSubscription, TournamentListenNewMemberSubscriptionVariables>, 'subscription'>;

    export const TournamentListenNewMemberQuery = (props: TournamentListenNewMemberQueryProps) => (
      <ApolloReactComponents.Subscription<TournamentListenNewMemberSubscription, TournamentListenNewMemberSubscriptionVariables> subscription={TournamentListenNewMemberDocument} {...props} />
    );


/**
 * __useTournamentListenNewMemberSubscription__
 *
 * To run a query within a React component, call `useTournamentListenNewMemberSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentListenNewMemberSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTournamentListenNewMemberSubscription({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useTournamentListenNewMemberSubscription(baseOptions: Apollo.SubscriptionHookOptions<TournamentListenNewMemberSubscription, TournamentListenNewMemberSubscriptionVariables> & ({ variables: TournamentListenNewMemberSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TournamentListenNewMemberSubscription, TournamentListenNewMemberSubscriptionVariables>(TournamentListenNewMemberDocument, options);
      }
export type TournamentListenNewMemberSubscriptionHookResult = ReturnType<typeof useTournamentListenNewMemberSubscription>;
export type TournamentListenNewMemberSubscriptionResult = Apollo.SubscriptionResult<TournamentListenNewMemberSubscription>;
export const MyUserSettingsDocument = gql`
    query MyUserSettings {
  userGetMyInfo {
    id
    tgId
    email
    phone
    domain
    createdOnDomain
    profile {
      id
      ...ProfileUpdateFragment
      ...ProfileTitleFragment
      originalNames {
        firstName
        lastName
      }
    }
    meta {
      hasOtp
    }
  }
  sessionGetActiveSessions {
    id
    ip
    alive
    isCurrent
    launcher
    createdAt
    lastActivityAt
    location {
      city
      country
      countryCode
    }
  }
  passwordFindOneLast {
    id
    updatedAt
  }
}
    ${ProfileUpdateFragmentFragmentDoc}
${ProfileTitleFragmentFragmentDoc}`;
export type MyUserSettingsQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<MyUserSettingsQuery, MyUserSettingsQueryVariables>, 'query'>;

    export const MyUserSettingsQuery = (props: MyUserSettingsQueryProps) => (
      <ApolloReactComponents.Query<MyUserSettingsQuery, MyUserSettingsQueryVariables> query={MyUserSettingsDocument} {...props} />
    );


/**
 * __useMyUserSettingsQuery__
 *
 * To run a query within a React component, call `useMyUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MyUserSettingsQuery, MyUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyUserSettingsQuery, MyUserSettingsQueryVariables>(MyUserSettingsDocument, options);
      }
export function useMyUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyUserSettingsQuery, MyUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyUserSettingsQuery, MyUserSettingsQueryVariables>(MyUserSettingsDocument, options);
        }
export function useMyUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyUserSettingsQuery, MyUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyUserSettingsQuery, MyUserSettingsQueryVariables>(MyUserSettingsDocument, options);
        }
export type MyUserSettingsQueryHookResult = ReturnType<typeof useMyUserSettingsQuery>;
export type MyUserSettingsLazyQueryHookResult = ReturnType<typeof useMyUserSettingsLazyQuery>;
export type MyUserSettingsSuspenseQueryHookResult = ReturnType<typeof useMyUserSettingsSuspenseQuery>;
export type MyUserSettingsQueryResult = Apollo.QueryResult<MyUserSettingsQuery, MyUserSettingsQueryVariables>;
export const CheckUserDomainDocument = gql`
    query CheckUserDomain($domain: String!) {
  userSettingsCheckDomain(domain: $domain) {
    success
    cause
    message
  }
}
    `;
export type CheckUserDomainQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckUserDomainQuery, CheckUserDomainQueryVariables>, 'query'> & ({ variables: CheckUserDomainQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CheckUserDomainQuery = (props: CheckUserDomainQueryProps) => (
      <ApolloReactComponents.Query<CheckUserDomainQuery, CheckUserDomainQueryVariables> query={CheckUserDomainDocument} {...props} />
    );


/**
 * __useCheckUserDomainQuery__
 *
 * To run a query within a React component, call `useCheckUserDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCheckUserDomainQuery(baseOptions: Apollo.QueryHookOptions<CheckUserDomainQuery, CheckUserDomainQueryVariables> & ({ variables: CheckUserDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserDomainQuery, CheckUserDomainQueryVariables>(CheckUserDomainDocument, options);
      }
export function useCheckUserDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserDomainQuery, CheckUserDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserDomainQuery, CheckUserDomainQueryVariables>(CheckUserDomainDocument, options);
        }
export function useCheckUserDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUserDomainQuery, CheckUserDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserDomainQuery, CheckUserDomainQueryVariables>(CheckUserDomainDocument, options);
        }
export type CheckUserDomainQueryHookResult = ReturnType<typeof useCheckUserDomainQuery>;
export type CheckUserDomainLazyQueryHookResult = ReturnType<typeof useCheckUserDomainLazyQuery>;
export type CheckUserDomainSuspenseQueryHookResult = ReturnType<typeof useCheckUserDomainSuspenseQuery>;
export type CheckUserDomainQueryResult = Apollo.QueryResult<CheckUserDomainQuery, CheckUserDomainQueryVariables>;
export const ProfileUpdateDocument = gql`
    mutation ProfileUpdate($profile: UpdateProfileInput!) {
  profileUpdate(profile: $profile) {
    ...ProfileUpdateFragment
  }
}
    ${ProfileUpdateFragmentFragmentDoc}`;
export type ProfileUpdateMutationFn = Apollo.MutationFunction<ProfileUpdateMutation, ProfileUpdateMutationVariables>;
export type ProfileUpdateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>, 'mutation'>;

    export const ProfileUpdateQuery = (props: ProfileUpdateQueryProps) => (
      <ApolloReactComponents.Mutation<ProfileUpdateMutation, ProfileUpdateMutationVariables> mutation={ProfileUpdateDocument} {...props} />
    );


/**
 * __useProfileUpdateMutation__
 *
 * To run a mutation, you first call `useProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateMutation, { data, loading, error }] = useProfileUpdateMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateMutation, ProfileUpdateMutationVariables>(ProfileUpdateDocument, options);
      }
export type ProfileUpdateMutationHookResult = ReturnType<typeof useProfileUpdateMutation>;
export type ProfileUpdateMutationResult = Apollo.MutationResult<ProfileUpdateMutation>;
export type ProfileUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>;
export const ProfileUpdatePhotoDocument = gql`
    mutation ProfileUpdatePhoto($photo: UpdateAvatarProfileInput!) {
  profileUpdatePhoto(photo: $photo) {
    ...ProfileUpdateFragment
  }
}
    ${ProfileUpdateFragmentFragmentDoc}`;
export type ProfileUpdatePhotoMutationFn = Apollo.MutationFunction<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables>;
export type ProfileUpdatePhotoQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables>, 'mutation'>;

    export const ProfileUpdatePhotoQuery = (props: ProfileUpdatePhotoQueryProps) => (
      <ApolloReactComponents.Mutation<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables> mutation={ProfileUpdatePhotoDocument} {...props} />
    );


/**
 * __useProfileUpdatePhotoMutation__
 *
 * To run a mutation, you first call `useProfileUpdatePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdatePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdatePhotoMutation, { data, loading, error }] = useProfileUpdatePhotoMutation({
 *   variables: {
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useProfileUpdatePhotoMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables>(ProfileUpdatePhotoDocument, options);
      }
export type ProfileUpdatePhotoMutationHookResult = ReturnType<typeof useProfileUpdatePhotoMutation>;
export type ProfileUpdatePhotoMutationResult = Apollo.MutationResult<ProfileUpdatePhotoMutation>;
export type ProfileUpdatePhotoMutationOptions = Apollo.BaseMutationOptions<ProfileUpdatePhotoMutation, ProfileUpdatePhotoMutationVariables>;
export const SetUserDomainDocument = gql`
    mutation SetUserDomain($domain: String!) {
  userSettingsSetDomain(domain: $domain) {
    domain
  }
}
    `;
export type SetUserDomainMutationFn = Apollo.MutationFunction<SetUserDomainMutation, SetUserDomainMutationVariables>;
export type SetUserDomainQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<SetUserDomainMutation, SetUserDomainMutationVariables>, 'mutation'>;

    export const SetUserDomainQuery = (props: SetUserDomainQueryProps) => (
      <ApolloReactComponents.Mutation<SetUserDomainMutation, SetUserDomainMutationVariables> mutation={SetUserDomainDocument} {...props} />
    );


/**
 * __useSetUserDomainMutation__
 *
 * To run a mutation, you first call `useSetUserDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDomainMutation, { data, loading, error }] = useSetUserDomainMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useSetUserDomainMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDomainMutation, SetUserDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserDomainMutation, SetUserDomainMutationVariables>(SetUserDomainDocument, options);
      }
export type SetUserDomainMutationHookResult = ReturnType<typeof useSetUserDomainMutation>;
export type SetUserDomainMutationResult = Apollo.MutationResult<SetUserDomainMutation>;
export type SetUserDomainMutationOptions = Apollo.BaseMutationOptions<SetUserDomainMutation, SetUserDomainMutationVariables>;
export const KillSessionsDocument = gql`
    mutation KillSessions {
  sessionKillAnotherSessions
}
    `;
export type KillSessionsMutationFn = Apollo.MutationFunction<KillSessionsMutation, KillSessionsMutationVariables>;
export type KillSessionsQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<KillSessionsMutation, KillSessionsMutationVariables>, 'mutation'>;

    export const KillSessionsQuery = (props: KillSessionsQueryProps) => (
      <ApolloReactComponents.Mutation<KillSessionsMutation, KillSessionsMutationVariables> mutation={KillSessionsDocument} {...props} />
    );


/**
 * __useKillSessionsMutation__
 *
 * To run a mutation, you first call `useKillSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKillSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [killSessionsMutation, { data, loading, error }] = useKillSessionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useKillSessionsMutation(baseOptions?: Apollo.MutationHookOptions<KillSessionsMutation, KillSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KillSessionsMutation, KillSessionsMutationVariables>(KillSessionsDocument, options);
      }
export type KillSessionsMutationHookResult = ReturnType<typeof useKillSessionsMutation>;
export type KillSessionsMutationResult = Apollo.MutationResult<KillSessionsMutation>;
export type KillSessionsMutationOptions = Apollo.BaseMutationOptions<KillSessionsMutation, KillSessionsMutationVariables>;
export const KillSessionByIdDocument = gql`
    mutation KillSessionById($sessionId: Int!) {
  sessionKillSessionById(sessionId: $sessionId) {
    id
    alive
  }
}
    `;
export type KillSessionByIdMutationFn = Apollo.MutationFunction<KillSessionByIdMutation, KillSessionByIdMutationVariables>;
export type KillSessionByIdQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<KillSessionByIdMutation, KillSessionByIdMutationVariables>, 'mutation'>;

    export const KillSessionByIdQuery = (props: KillSessionByIdQueryProps) => (
      <ApolloReactComponents.Mutation<KillSessionByIdMutation, KillSessionByIdMutationVariables> mutation={KillSessionByIdDocument} {...props} />
    );


/**
 * __useKillSessionByIdMutation__
 *
 * To run a mutation, you first call `useKillSessionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKillSessionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [killSessionByIdMutation, { data, loading, error }] = useKillSessionByIdMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useKillSessionByIdMutation(baseOptions?: Apollo.MutationHookOptions<KillSessionByIdMutation, KillSessionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KillSessionByIdMutation, KillSessionByIdMutationVariables>(KillSessionByIdDocument, options);
      }
export type KillSessionByIdMutationHookResult = ReturnType<typeof useKillSessionByIdMutation>;
export type KillSessionByIdMutationResult = Apollo.MutationResult<KillSessionByIdMutation>;
export type KillSessionByIdMutationOptions = Apollo.BaseMutationOptions<KillSessionByIdMutation, KillSessionByIdMutationVariables>;
export const SessionListenKillDocument = gql`
    subscription SessionListenKill {
  sessionListenExit
}
    `;
export type SessionListenKillQueryProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<SessionListenKillSubscription, SessionListenKillSubscriptionVariables>, 'subscription'>;

    export const SessionListenKillQuery = (props: SessionListenKillQueryProps) => (
      <ApolloReactComponents.Subscription<SessionListenKillSubscription, SessionListenKillSubscriptionVariables> subscription={SessionListenKillDocument} {...props} />
    );


/**
 * __useSessionListenKillSubscription__
 *
 * To run a query within a React component, call `useSessionListenKillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSessionListenKillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionListenKillSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSessionListenKillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SessionListenKillSubscription, SessionListenKillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SessionListenKillSubscription, SessionListenKillSubscriptionVariables>(SessionListenKillDocument, options);
      }
export type SessionListenKillSubscriptionHookResult = ReturnType<typeof useSessionListenKillSubscription>;
export type SessionListenKillSubscriptionResult = Apollo.SubscriptionResult<SessionListenKillSubscription>;
export const GetUserStateDocument = gql`
    query GetUserState($key: UserStateKey!) {
  userStateGetByKey(key: $key)
}
    `;
export type GetUserStateQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserStateQuery, GetUserStateQueryVariables>, 'query'> & ({ variables: GetUserStateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserStateQuery = (props: GetUserStateQueryProps) => (
      <ApolloReactComponents.Query<GetUserStateQuery, GetUserStateQueryVariables> query={GetUserStateDocument} {...props} />
    );


/**
 * __useGetUserStateQuery__
 *
 * To run a query within a React component, call `useGetUserStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStateQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetUserStateQuery(baseOptions: Apollo.QueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables> & ({ variables: GetUserStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, options);
      }
export function useGetUserStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, options);
        }
export function useGetUserStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, options);
        }
export type GetUserStateQueryHookResult = ReturnType<typeof useGetUserStateQuery>;
export type GetUserStateLazyQueryHookResult = ReturnType<typeof useGetUserStateLazyQuery>;
export type GetUserStateSuspenseQueryHookResult = ReturnType<typeof useGetUserStateSuspenseQuery>;
export type GetUserStateQueryResult = Apollo.QueryResult<GetUserStateQuery, GetUserStateQueryVariables>;
export const UpdateUserStateDocument = gql`
    mutation UpdateUserState($key: UserStateKey!, $input: JsonObjectInput!) {
  userStateSetByKey(key: $key, input: $input)
}
    `;
export type UpdateUserStateMutationFn = Apollo.MutationFunction<UpdateUserStateMutation, UpdateUserStateMutationVariables>;
export type UpdateUserStateQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserStateMutation, UpdateUserStateMutationVariables>, 'mutation'>;

    export const UpdateUserStateQuery = (props: UpdateUserStateQueryProps) => (
      <ApolloReactComponents.Mutation<UpdateUserStateMutation, UpdateUserStateMutationVariables> mutation={UpdateUserStateDocument} {...props} />
    );


/**
 * __useUpdateUserStateMutation__
 *
 * To run a mutation, you first call `useUpdateUserStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStateMutation, { data, loading, error }] = useUpdateUserStateMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStateMutation, UpdateUserStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStateMutation, UpdateUserStateMutationVariables>(UpdateUserStateDocument, options);
      }
export type UpdateUserStateMutationHookResult = ReturnType<typeof useUpdateUserStateMutation>;
export type UpdateUserStateMutationResult = Apollo.MutationResult<UpdateUserStateMutation>;
export type UpdateUserStateMutationOptions = Apollo.BaseMutationOptions<UpdateUserStateMutation, UpdateUserStateMutationVariables>;
export const UserConnectTelegramDocument = gql`
    mutation UserConnectTelegram($callbackConnectInput: ConnectCallbackTelegramInput!) {
  userConnectTelegram(callbackConnectInput: $callbackConnectInput) {
    id
    tgId
  }
}
    `;
export type UserConnectTelegramMutationFn = Apollo.MutationFunction<UserConnectTelegramMutation, UserConnectTelegramMutationVariables>;
export type UserConnectTelegramQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<UserConnectTelegramMutation, UserConnectTelegramMutationVariables>, 'mutation'>;

    export const UserConnectTelegramQuery = (props: UserConnectTelegramQueryProps) => (
      <ApolloReactComponents.Mutation<UserConnectTelegramMutation, UserConnectTelegramMutationVariables> mutation={UserConnectTelegramDocument} {...props} />
    );


/**
 * __useUserConnectTelegramMutation__
 *
 * To run a mutation, you first call `useUserConnectTelegramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectTelegramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectTelegramMutation, { data, loading, error }] = useUserConnectTelegramMutation({
 *   variables: {
 *      callbackConnectInput: // value for 'callbackConnectInput'
 *   },
 * });
 */
export function useUserConnectTelegramMutation(baseOptions?: Apollo.MutationHookOptions<UserConnectTelegramMutation, UserConnectTelegramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserConnectTelegramMutation, UserConnectTelegramMutationVariables>(UserConnectTelegramDocument, options);
      }
export type UserConnectTelegramMutationHookResult = ReturnType<typeof useUserConnectTelegramMutation>;
export type UserConnectTelegramMutationResult = Apollo.MutationResult<UserConnectTelegramMutation>;
export type UserConnectTelegramMutationOptions = Apollo.BaseMutationOptions<UserConnectTelegramMutation, UserConnectTelegramMutationVariables>;
export const CourseFindManyDocument = gql`
    query CourseFindMany($list: ListInput!, $filter: FilterCourseInput!, $sort: SortCourseInput) {
  courseFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    pages
    items {
      ...CourseFragment
      lessons {
        id
        parent {
          ...CourseLessonParentFragment
        }
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}`;
export type CourseFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseFindManyQuery, CourseFindManyQueryVariables>, 'query'> & ({ variables: CourseFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseFindManyQuery = (props: CourseFindManyQueryProps) => (
      <ApolloReactComponents.Query<CourseFindManyQuery, CourseFindManyQueryVariables> query={CourseFindManyDocument} {...props} />
    );


/**
 * __useCourseFindManyQuery__
 *
 * To run a query within a React component, call `useCourseFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseFindManyQuery(baseOptions: Apollo.QueryHookOptions<CourseFindManyQuery, CourseFindManyQueryVariables> & ({ variables: CourseFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseFindManyQuery, CourseFindManyQueryVariables>(CourseFindManyDocument, options);
      }
export function useCourseFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseFindManyQuery, CourseFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseFindManyQuery, CourseFindManyQueryVariables>(CourseFindManyDocument, options);
        }
export function useCourseFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseFindManyQuery, CourseFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseFindManyQuery, CourseFindManyQueryVariables>(CourseFindManyDocument, options);
        }
export type CourseFindManyQueryHookResult = ReturnType<typeof useCourseFindManyQuery>;
export type CourseFindManyLazyQueryHookResult = ReturnType<typeof useCourseFindManyLazyQuery>;
export type CourseFindManySuspenseQueryHookResult = ReturnType<typeof useCourseFindManySuspenseQuery>;
export type CourseFindManyQueryResult = Apollo.QueryResult<CourseFindManyQuery, CourseFindManyQueryVariables>;
export const StoriesFindManyDocument = gql`
    query StoriesFindMany($list: ListInput!, $filter: FilterStoriesInput!, $sort: SortStoriesInput) {
  storiesFindMany(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      ...StoriesFragment
    }
  }
}
    ${StoriesFragmentFragmentDoc}`;
export type StoriesFindManyQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<StoriesFindManyQuery, StoriesFindManyQueryVariables>, 'query'> & ({ variables: StoriesFindManyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StoriesFindManyQuery = (props: StoriesFindManyQueryProps) => (
      <ApolloReactComponents.Query<StoriesFindManyQuery, StoriesFindManyQueryVariables> query={StoriesFindManyDocument} {...props} />
    );


/**
 * __useStoriesFindManyQuery__
 *
 * To run a query within a React component, call `useStoriesFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesFindManyQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useStoriesFindManyQuery(baseOptions: Apollo.QueryHookOptions<StoriesFindManyQuery, StoriesFindManyQueryVariables> & ({ variables: StoriesFindManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesFindManyQuery, StoriesFindManyQueryVariables>(StoriesFindManyDocument, options);
      }
export function useStoriesFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesFindManyQuery, StoriesFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesFindManyQuery, StoriesFindManyQueryVariables>(StoriesFindManyDocument, options);
        }
export function useStoriesFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StoriesFindManyQuery, StoriesFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoriesFindManyQuery, StoriesFindManyQueryVariables>(StoriesFindManyDocument, options);
        }
export type StoriesFindManyQueryHookResult = ReturnType<typeof useStoriesFindManyQuery>;
export type StoriesFindManyLazyQueryHookResult = ReturnType<typeof useStoriesFindManyLazyQuery>;
export type StoriesFindManySuspenseQueryHookResult = ReturnType<typeof useStoriesFindManySuspenseQuery>;
export type StoriesFindManyQueryResult = Apollo.QueryResult<StoriesFindManyQuery, StoriesFindManyQueryVariables>;
export const CartFindOneDocument = gql`
    query CartFindOne {
  cartFindOne {
    id
    promoCodes
    products {
      productId
      priceId
      addedAt
    }
  }
}
    `;
export type CartFindOneQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CartFindOneQuery, CartFindOneQueryVariables>, 'query'>;

    export const CartFindOneQuery = (props: CartFindOneQueryProps) => (
      <ApolloReactComponents.Query<CartFindOneQuery, CartFindOneQueryVariables> query={CartFindOneDocument} {...props} />
    );


/**
 * __useCartFindOneQuery__
 *
 * To run a query within a React component, call `useCartFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartFindOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartFindOneQuery(baseOptions?: Apollo.QueryHookOptions<CartFindOneQuery, CartFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartFindOneQuery, CartFindOneQueryVariables>(CartFindOneDocument, options);
      }
export function useCartFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartFindOneQuery, CartFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartFindOneQuery, CartFindOneQueryVariables>(CartFindOneDocument, options);
        }
export function useCartFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CartFindOneQuery, CartFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartFindOneQuery, CartFindOneQueryVariables>(CartFindOneDocument, options);
        }
export type CartFindOneQueryHookResult = ReturnType<typeof useCartFindOneQuery>;
export type CartFindOneLazyQueryHookResult = ReturnType<typeof useCartFindOneLazyQuery>;
export type CartFindOneSuspenseQueryHookResult = ReturnType<typeof useCartFindOneSuspenseQuery>;
export type CartFindOneQueryResult = Apollo.QueryResult<CartFindOneQuery, CartFindOneQueryVariables>;
export const CourseProgressFindManyCurrentDocument = gql`
    query CourseProgressFindManyCurrent($list: ListInput!, $filter: FilterProgressCourseInput!, $sort: SortProgressCourseInput) {
  courseProgressFindManyCurrent(list: $list, filter: $filter, sort: $sort) {
    count
    items {
      id
      status
      practiceDeadlineAt
      course {
        id
        progressType
        isParticipant
        ...CoursePreferenceSettingsFragment
        currentLesson {
          id
          order
          isDemo
          accessType
          withContent
          withPractice
          myProgressStatus
        }
      }
      lesson {
        id
        name
        order
        isDemo
        accessType
        myProgressStatus
        description
        previewImage
        withContent
        withPractice
        blocksInfo {
          ...CourseLessonBlocksInfoFragment
        }
        parent {
          ...CourseLessonParentFragment
        }
        publishedOrder {
          order
          parentOrder
        }
        next {
          ...LessonListItemFragment
        }
        wrapper {
          small
          maximum
        }
        previous {
          id
          isDemo
          accessType
          withContent
          withPractice
          canStartNextLesson
        }
      }
    }
  }
}
    ${CoursePreferenceSettingsFragmentFragmentDoc}
${CourseLessonBlocksInfoFragmentFragmentDoc}
${CourseLessonParentFragmentFragmentDoc}
${LessonListItemFragmentFragmentDoc}`;
export type CourseProgressFindManyCurrentQueryProps = Omit<ApolloReactComponents.QueryComponentOptions<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>, 'query'> & ({ variables: CourseProgressFindManyCurrentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CourseProgressFindManyCurrentQuery = (props: CourseProgressFindManyCurrentQueryProps) => (
      <ApolloReactComponents.Query<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables> query={CourseProgressFindManyCurrentDocument} {...props} />
    );


/**
 * __useCourseProgressFindManyCurrentQuery__
 *
 * To run a query within a React component, call `useCourseProgressFindManyCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressFindManyCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseProgressFindManyCurrentQuery({
 *   variables: {
 *      list: // value for 'list'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCourseProgressFindManyCurrentQuery(baseOptions: Apollo.QueryHookOptions<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables> & ({ variables: CourseProgressFindManyCurrentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>(CourseProgressFindManyCurrentDocument, options);
      }
export function useCourseProgressFindManyCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>(CourseProgressFindManyCurrentDocument, options);
        }
export function useCourseProgressFindManyCurrentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>(CourseProgressFindManyCurrentDocument, options);
        }
export type CourseProgressFindManyCurrentQueryHookResult = ReturnType<typeof useCourseProgressFindManyCurrentQuery>;
export type CourseProgressFindManyCurrentLazyQueryHookResult = ReturnType<typeof useCourseProgressFindManyCurrentLazyQuery>;
export type CourseProgressFindManyCurrentSuspenseQueryHookResult = ReturnType<typeof useCourseProgressFindManyCurrentSuspenseQuery>;
export type CourseProgressFindManyCurrentQueryResult = Apollo.QueryResult<CourseProgressFindManyCurrentQuery, CourseProgressFindManyCurrentQueryVariables>;
export const StoriesUpsertViewDocument = gql`
    mutation StoriesUpsertView($storiesId: Int!) {
  storiesUpsertView(storiesId: $storiesId) {
    id
    stories {
      ...StoriesFragment
    }
  }
}
    ${StoriesFragmentFragmentDoc}`;
export type StoriesUpsertViewMutationFn = Apollo.MutationFunction<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables>;
export type StoriesUpsertViewQueryProps = Omit<ApolloReactComponents.MutationComponentOptions<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables>, 'mutation'>;

    export const StoriesUpsertViewQuery = (props: StoriesUpsertViewQueryProps) => (
      <ApolloReactComponents.Mutation<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables> mutation={StoriesUpsertViewDocument} {...props} />
    );


/**
 * __useStoriesUpsertViewMutation__
 *
 * To run a mutation, you first call `useStoriesUpsertViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoriesUpsertViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storiesUpsertViewMutation, { data, loading, error }] = useStoriesUpsertViewMutation({
 *   variables: {
 *      storiesId: // value for 'storiesId'
 *   },
 * });
 */
export function useStoriesUpsertViewMutation(baseOptions?: Apollo.MutationHookOptions<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables>(StoriesUpsertViewDocument, options);
      }
export type StoriesUpsertViewMutationHookResult = ReturnType<typeof useStoriesUpsertViewMutation>;
export type StoriesUpsertViewMutationResult = Apollo.MutationResult<StoriesUpsertViewMutation>;
export type StoriesUpsertViewMutationOptions = Apollo.BaseMutationOptions<StoriesUpsertViewMutation, StoriesUpsertViewMutationVariables>;
